(function () {
  'use strict';

  angular.module('app.services', []);

})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('purchaseOrderCompositeService', purchaseOrderCompositeService);

  purchaseOrderCompositeService.$inject = ['purchaseOrderCompositeBackendService', 'authorizationService', 'SETTINGS'];

  function purchaseOrderCompositeService(purchaseOrderCompositeBackendService, authorizationService, SETTINGS) {
    var service = {
      getPurchaseOrderLines: getPurchaseOrderLines,
      updateDualUse: updateDualUse
    };

    return service;

    //////////////////

    function getPurchaseOrderLines(id) {
      return purchaseOrderCompositeBackendService.getPurchaseOrderLines({code: SETTINGS.projectCode, id: id}).$promise.then(function (response) {
        return response;
      });
    }

    function updateDualUse(linetoUpdate) {
      return (linetoUpdate.isDualUse ? purchaseOrderCompositeBackendService.setDualUse : purchaseOrderCompositeBackendService.setIsNotDualUse)
      ({
        code: SETTINGS.projectCode,
        id: linetoUpdate.id
      }, linetoUpdate).$promise.then(function(response) {
        if(response.statusCode == '403'){
          authorizationService.forbidden(response, 'Cannot update dual use.');
        }
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update dual use.');
        return error;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('purchaseOrderCompositeBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_COMPOSITE_GATEWAY + ':code/purchase-orders/:id', {code: '@code', id: '@id'}, {

        getPurchaseOrderLines: {
          url: API.BASE_URI_COMPOSITE_GATEWAY + ':code/purchase-orders/:id/lines', method: 'GET', params: {code: '@code', id: '@id'}
        },
        setDualUse: {
          url: API.BASE_URI_COMPOSITE_GATEWAY + ':code/purchase-order-lines/:id/is-dual-use', method: 'PUT', params: {code: '@code', id: '@id'}
        },
        setIsNotDualUse: {
          url: API.BASE_URI_COMPOSITE_GATEWAY + ':code/purchase-order-lines/:id/is-dual-use', method: 'DELETE', params: {code: '@code', id: '@id'}
        }
      });
    });
})();

(function () {
  'use strict';

  angular.module('app.deliveries', []);

})();

(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgRegisterShort', wgRegisterShort);

  wgRegisterShort.$inject = ['$uibModal', '$exceptionHandler'];

  /* @ngInject */
  function wgRegisterShort($uibModal, $exceptionHandler) {
    var directive = {
      bindToController: true,
      controller: RegisterShortCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        checkLineId: '@',
        barcode: '@',
        description: '@',
        getShorts: '&'
      },
      templateUrl: 'app/deliveries/osd/registerShort.html'
    };
    return directive;

    function link(scope, element, attrs) {
      try {
        if (!attrs.barcode) {
          throw( new Error( "\"barcode\" must be included attribute."))
        }

        if (!attrs.checkLineId) {
          throw( new Error( "\"check-line-id\" must be included attribute."))
        }
      }
      catch (error) {
        $exceptionHandler(error);
      }
    }
  }

  RegisterShortCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function RegisterShortCtrl($uibModal) {
    var vm = this;

    vm.barcode = this.barcode;
    vm.description = this.description;
    vm.checkLineId = this.checkLineId;
    vm.getShorts = this.getShorts;

    vm.openRegisterShort = openRegisterShort;

    function openRegisterShort() {
      $uibModal.open({
        templateUrl: 'app/deliveries/osd/registerShortModal.html',
        controller: 'RegisterShortModalCtrl',
        controllerAs: 'vm',
        resolve: {
          barcode: function () {
            return vm.barcode;
          },
          description: function () {
            return vm.description;
          },
          checkLineId: function () {
            return vm.checkLineId;
          },
          getShorts: function () {
            return vm.getShorts;
          }
        }
      });
    }
  }

  angular
    .module('app.deliveries')
    .controller('RegisterShortModalCtrl', RegisterShortModalCtrl);

  RegisterShortModalCtrl.$inject = ['$rootScope', '$uibModalInstance', 'deliveryService', 'barcode', 'description', 'checkLineId', 'getShorts'];

  function RegisterShortModalCtrl($rootScope, $uibModalInstance, deliveryService, barcode, description, checkLineId, getShorts) {
    var vm = this;

    vm.barcode = barcode;
    vm.description = description;
    vm.checkLineId = checkLineId;
    vm.getShorts = getShorts;

    vm.comments = '';

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    activate();

    ///////////////

    function activate() {
    }

    vm.ok = function () {
      vm.saving = true;
      vm.saved = false;

      var short = {
        checkLineId: vm.checkLineId,
        comments: vm.comments
      };

        deliveryService.registerShort(short)
          .then(function(response) {
            vm.getShorts();
            $rootScope.$broadcast('osd-registered');
            $rootScope.$broadcast('short-registered');

            vm.error = false;
            vm.saved = true;
            vm.saving = false;

          }, function() {

            vm.saved = false;
            vm.error = true;
            vm.saving = false;
          });
      };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgRegisterOverage', wgRegisterOverage);

  wgRegisterOverage.$inject = ['$uibModal', '$exceptionHandler'];

  /* @ngInject */
  function wgRegisterOverage($uibModal, $exceptionHandler) {
    var directive = {
      bindToController: true,
      controller: RegisterOverageCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        checkLineId: '@',
        deliveryId: '@',
        warehouseId: '@',
        purchaseOrderLineId: '@',
        barcode: '@',
        description: '@',
        quantityOutstanding: '@',
        requiredOverage: '@',
        potentialOverages: '=',
        displayOverages: '&'
      },
      templateUrl: 'app/deliveries/osd/registerOverage.html'
    };
    return directive;

    function link(scope, element, attrs) {
      try {
        if (!attrs.barcode) {
          throw( new Error( "\"barcode\" must be included attribute."))
        }

        if (!attrs.checkLineId) {
          throw( new Error( "\"check-line-id\" must be included attribute."))
        }
      }
      catch (error) {
        $exceptionHandler(error);
      }
    }
  }

  RegisterOverageCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function RegisterOverageCtrl($uibModal) {
    var vm = this;

    vm.barcode = this.barcode;
    vm.description = this.description;
    vm.purchaseOrderLineId = this.purchaseOrderLineId;
    vm.deliveryId = this.deliveryId;
    vm.warehouseId = this.warehouseId;
    vm.checkLineId = this.checkLineId;
    vm.quantityOutstanding = this.quantityOutstanding;
    vm.requiredOverage = this.requiredOverage;
    vm.potentialOverages = this.potentialOverages;
    vm.displayOverages = this.displayOverages;

    vm.openRegisterOverage = openRegisterOverage;

    function openRegisterOverage() {
      $uibModal.open({
        templateUrl: 'app/deliveries/osd/registerOverageModal.html',
        controller: 'RegisterOverageModalCtrl',
        controllerAs: 'vm',
        resolve: {
          barcode: function () {
            return vm.barcode;
          },
          description: function () {
            return vm.description;
          },
          purchaseOrderLineId: function () {
            return vm.purchaseOrderLineId;
          },
          checkLineId: function () {
            return vm.checkLineId;
          },
          deliveryId: function () {
            return vm.deliveryId;
          },
          warehouseId: function () {
            return vm.warehouseId;
          },
          potentialOverages: function () {
            return vm.potentialOverages;
          },
          quantityOutstanding: function () {
            return vm.quantityOutstanding;
          },
          requiredOverage: function () {
            return vm.requiredOverage;
          },
          displayOverages: function () {
            return vm.displayOverages;
          }
        }
      });
    }
  }

  angular
    .module('app.deliveries')
    .controller('RegisterOverageModalCtrl', RegisterOverageModalCtrl);

  RegisterOverageModalCtrl.$inject = ['$rootScope', '$uibModalInstance', 'deliveryService', 'barcode', 'description', 'purchaseOrderLineId', 'checkLineId', 'deliveryId', 'warehouseId', 'quantityOutstanding', 'requiredOverage', 'potentialOverages', 'displayOverages', 'API', 'SETTINGS', 'OidcManager'];

  function RegisterOverageModalCtrl($rootScope, $uibModalInstance, deliveryService, barcode, description, purchaseOrderLineId, checkLineId, deliveryId, warehouseId, quantityOutstanding, requiredOverage, potentialOverages, displayOverages, API, SETTINGS, OidcManager) {
    var vm = this;

    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.barcode = barcode;
    vm.description = description;
    vm.purchaseOrderLineId = purchaseOrderLineId;
    vm.checkLineId = checkLineId;
    vm.deliveryId = deliveryId;
    vm.warehouseId = warehouseId;
    vm.quantityOutstanding = quantityOutstanding;
    vm.requiredOverage = requiredOverage;
    vm.potentialOverages = potentialOverages;
    vm.displayOverages = displayOverages;

    /** Quarantine locations */
    vm.quarantineLocations = [];
    vm.quarantineLocationsOptions = [];
    vm.selectedQuarantineLocationId = '';

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.receivedItemOverages = [];

    vm.discrepancyDescription = '';

    activate();

    ///////////////

    function activate() {

    }


    vm.ok = function () {
      vm.saving = true;
      vm.saved = false;

      vm.receivedItemOverages = [];
      angular.forEach(vm.potentialOverages, function(value, key) {
        vm.receivedItemOverages.push( {barcode: value.barcode, overageQuantity: parseFloat(value.overageQuantity) } );
      });

      var overage = {
        purchaseOrderLineId: vm.purchaseOrderLineId,
        deliveryId: vm.deliveryId,
        checkLineId: vm.checkLineId,
        discrepancyDescription: vm.discrepancyDescription,
        receivedItemOverages: vm.receivedItemOverages,
        quarantineLocationId: vm.selectedQuarantineLocationId
      };

        deliveryService.registerOverage(overage)
          .then(function(response) {
            vm.displayOverages();
            $rootScope.$broadcast('osd-registered');

            vm.error = false;
            vm.saved = true;
            vm.saving = false;

          }, function() {

            vm.saved = false;
            vm.error = true;
            vm.saving = false;
          });
      };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    /** Quarantine Locations */

    vm.quarantineLocations = new kendo.data.DataSource({
      transport: {
        read: {
          url: function(options) {
            return API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations/' + vm.warehouseId + '/quarantine'},
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      },
      group: { field: "warehouseName" }
    });

    vm.quarantineLocationsOptions = {
      placeholder: "Select location",
      dataSource: vm.quarantineLocations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgRegisterIntervention', wgRegisterIntervention);

  wgRegisterIntervention.$inject = ['$uibModal', '$exceptionHandler'];

  /* @ngInject */
  function wgRegisterIntervention($uibModal, $exceptionHandler) {
    var directive = {
      bindToController: true,
      controller: RegisterInterventionCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        checkLineId: '@',
        deliveryId: '@',
        warehouseId: '@',
        purchaseOrderLineId: '@',
        barcode: '@',
        description: '@',
        checkedQuantity: '@',
        displayOverages: '&'
      },
      templateUrl: 'app/deliveries/osd/registerIntervention.html'
    };
    return directive;

    function link(scope, element, attrs) {
      try {
        if (!attrs.barcode) {
          throw( new Error( "\"barcode\" must be included attribute."))
        }

        if (!attrs.checkLineId) {
          throw( new Error( "\"check-line-id\" must be included attribute."))
        }
      }
      catch (error) {
        $exceptionHandler(error);
      }
    }
  }

  RegisterInterventionCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function RegisterInterventionCtrl($uibModal) {
    var vm = this;

    vm.barcode = this.barcode;
    vm.description = this.description;
    vm.purchaseOrderLineId = this.purchaseOrderLineId;
    vm.deliveryId = this.deliveryId;
    vm.checkLineId = this.checkLineId;
    vm.warehouseId = this.warehouseId;
    vm.checkedQuantity = this.checkedQuantity;
    vm.displayOverages = this.displayOverages;

    vm.openRegisterIntervention = openRegisterIntervention;

    function openRegisterIntervention() {
      $uibModal.open({
        templateUrl: 'app/deliveries/osd/registerInterventionModal.html',
        controller: 'RegisterInterventionModalCtrl',
        controllerAs: 'vm',
        resolve: {
          barcode: function () {
            return vm.barcode;
          },
          description: function () {
            return vm.description;
          },
          purchaseOrderLineId: function () {
            return vm.purchaseOrderLineId;
          },
          checkLineId: function () {
            return vm.checkLineId;
          },
          deliveryId: function () {
            return vm.deliveryId;
          },
          warehouseId: function () {
            return vm.warehouseId;
          },
          checkedQuantity: function () {
            return vm.checkedQuantity;
          },
          displayOverages: function () {
            return vm.displayOverages;
          }
        }
      });
    }
  }

  angular
    .module('app.deliveries')
    .controller('RegisterInterventionModalCtrl', RegisterInterventionModalCtrl);

  RegisterInterventionModalCtrl.$inject = ['$rootScope', '$uibModalInstance', 'deliveryService', 'barcode', 'description', 'purchaseOrderLineId', 'checkLineId', 'deliveryId', 'warehouseId', 'checkedQuantity', 'displayOverages', 'OidcManager', 'API', 'SETTINGS'];

  function RegisterInterventionModalCtrl($rootScope, $uibModalInstance, deliveryService, barcode, description, purchaseOrderLineId, checkLineId, deliveryId, warehouseId, checkedQuantity, displayOverages, OidcManager, API, SETTINGS) {
    var vm = this;

    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.barcode = barcode;
    vm.description = description;
    vm.purchaseOrderLineId = purchaseOrderLineId;
    vm.checkLineId = checkLineId;
    vm.deliveryId = deliveryId;
    vm.warehouseId = warehouseId;
    vm.checkedQuantity = checkedQuantity;
    vm.displayOverages = displayOverages;

    /** Quarantine locations */
    vm.quarantineLocations = [];
    vm.quarantineLocationsOptions = [];
    vm.selectedQuarantineLocationId = '';

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.damagedInterventionQuantity = '';
    vm.otherInterventionQuantity = '';
    vm.discrepancyDescription = '';

    activate();

    ///////////////

    function activate() {

    }

    vm.ok = function () {
      vm.saving = true;
      vm.saved = false;

      var intervention = {
        purchaseOrderLineId: vm.purchaseOrderLineId,
        deliveryId: vm.deliveryId,
        barcode: barcode,
        damagedInterventionQuantity: vm.damagedInterventionQuantity,
        otherInterventionQuantity: vm.otherInterventionQuantity,
        discrepancyDescription: vm.discrepancyDescription,
        quarantineLocationId: vm.selectedQuarantineLocationId
      };

        deliveryService.registerIntervention(intervention)
          .then(function(response) {
            vm.displayOverages();
            $rootScope.$broadcast('osd-registered');

            vm.error = false;
            vm.saved = true;
            vm.saving = false;

          }, function() {

            vm.saved = false;
            vm.error = true;
            vm.saving = false;
          });
      };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    /** Quarantine Locations */

    vm.quarantineLocations = new kendo.data.DataSource({
      transport: {
        read: {
          url: function(options) {
            return API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations/' + vm.warehouseId + '/quarantine'},
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      },
      group: { field: "warehouseName" }
    });

    vm.quarantineLocationsOptions = {
      placeholder: "Select location",
      dataSource: vm.quarantineLocations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };

  }

})();


(function() {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgAddInspections', wgAddInspections);

  wgAddInspections.$inject = [];

  /* @ngInject */
  function wgAddInspections(){
    var directive = {
      bindToController: true,
      controller: AddInspectionsCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: 'app/deliveries/inspection/addInspections.html',
      scope: {
        items: '=',
        warehouseId: '@',
        postUpdateDelegate: '&'
      }
    };

    return directive;

    function link(scope, element, attrs){

    }
  }

  AddInspectionsCtrl.$inject = ['$uibModal', '$filter'];

  /* @ngInject */
  function AddInspectionsCtrl($uibModal, $filter) {
    var vm = this;
    vm.items = this.items;
    vm.warehouseId = this.warehouseId;
    vm.postUpdateDelegate = this.postUpdateDelegate;

    vm.inspectItems = inspectItems;

    function inspectItems(items) {
      $uibModal.open({
        templateUrl: 'app/deliveries/inspection/addInspectionsModal.html',
        controller: 'AddInspectionsModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          items: function () {
            return $filter('filter')(items, 
              function(item){ return item.isIncluded === true && (item.checkLine.requiresInspection === true || item.hasInspections === true) });
          },
          warehouseId: function () {
            return vm.warehouseId;
          },
          postUpdateDelegate: function () {
            return vm.postUpdateDelegate;
          }
        }
      });
    }
  }

  angular
    .module('app.deliveries')
    .controller('AddInspectionsModalCtrl', AddInspectionsModalCtrl);

  AddInspectionsModalCtrl.$inject = ['$rootScope', '$stateParams', '$uibModalInstance', 'deliveryService', 'items', 'warehouseId', 'postUpdateDelegate'];

  function AddInspectionsModalCtrl($rootScope, $stateParams, $uibModalInstance, deliveryService, items, warehouseId, postUpdateDelegate) {
    var vm = this;

    vm.deliveryId = $stateParams.id
    vm.items = items;
    vm.warehouseId = warehouseId;
    vm.postUpdateDelegate = postUpdateDelegate;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    activate();

    //////////////////////////

    function activate() {

    }

    vm.ok = function(){
      vm.saving = true;

      var inspectedItems = [];

      angular.forEach(vm.items, function (item) {
        if(item.isIncluded) {
          if(item.inspections.length > 1) {
            angular.forEach(item.inspections, function (inspection) {
              var inspectedItem = {
                purchaseOrderLineId: item.checkLine.purchaseOrderLineId,
                barcode: inspection.barcode,
                failedInspectionQuantity: inspection.failedInspectionQuantity,
                comments: inspection.comments,
                isVendorInspection: item.checkLine.inspectionType === 'V',
                quarantineLocationId: inspection.selectedQuarantineLocationId
              };
              inspectedItems.push(inspectedItem);
            });
          } else
          {
            var inspectedItem = {
            purchaseOrderLineId: item.checkLine.purchaseOrderLineId,
            barcode: item.checkLine.barcode,
            failedInspectionQuantity: item.failedQuantity,
            comments: item.comments,
            isVendorInspection: item.checkLine.inspectionType === 'V',
            quarantineLocationId: item.selectedQuarantineLocationId
          };
          inspectedItems.push(inspectedItem);
        }
        }
      });

      var inspections = {
        ircNumber: vm.ircNumber,
        inspectedItems: inspectedItems
      };

      return deliveryService.registerInspections(vm.deliveryId, inspections)
        .then(function (response) {
          vm.saved = true;
          vm.error = false;
          vm.saving = false;
          $rootScope.$broadcast('osd-registered');
          vm.postUpdateDelegate();
        }, function () {
          vm.saved = false;
          vm.error = true;
          vm.saving = false;
        });
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
      resetModal();
      vm.postUpdateDelegate();
    };

    function resetModal() {

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgAddInspection', wgAddInspection);

  wgAddInspection.$inject = [];

  /* @ngInject */
  function wgAddInspection() {
    var directive = {
      bindToController: true,
      controller: AddInspectionCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/deliveries/inspection/addInspection.html',
      scope: {
        item: '=',
        isVendorInspection: '=',
        maxInspectionQuantity: '=',
        warehouseId: '@',
        postUpdateDelegate: '&'
      }
    };

    return directive;

    function link(scope, element, attrs) {

    }
  }

  AddInspectionCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function AddInspectionCtrl($uibModal) {
    var vm = this;

    vm.item = this.item;
    vm.warehouseId = this.warehouseId;
    vm.postUpdateDelegate = this.postUpdateDelegate;

    vm.openInspection = openInspection;

    function openInspection() {

      $uibModal.open({
        templateUrl: 'app/deliveries/inspection/addInspectionModal.html',
        controller: 'AddInspectionModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          item: function () {
            return vm.item;
          },
          isVendorInspection: function () {
            return vm.isVendorInspection;
          },
          maxInspectionQuantity: function () {
            return vm.maxInspectionQuantity;
          },
          warehouseId: function () {
            return vm.warehouseId;
          },
          postUpdateDelegate: function () {
            return vm.postUpdateDelegate;
          }
        }
      });
    }
  }

  angular
    .module('app.deliveries')
    .controller('AddInspectionModalCtrl', AddInspectionModalCtrl);

  AddInspectionModalCtrl.$inject = ['$rootScope', '$uibModalInstance', 'deliveryService', 'item', 'isVendorInspection', 'maxInspectionQuantity', 'postUpdateDelegate', 'warehouseId', 'OidcManager', 'API', 'SETTINGS'];

  function AddInspectionModalCtrl($rootScope, $uibModalInstance, deliveryService, item, isVendorInspection, maxInspectionQuantity, postUpdateDelegate, warehouseId, OidcManager, API, SETTINGS) {
    var vm = this;

    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.warehouseId = warehouseId;

    vm.item = item;
    vm.isVendorInspection = isVendorInspection;
    vm.postUpdateDelegate = postUpdateDelegate;
    vm.maxInspectionQuantity = maxInspectionQuantity;

    /** Quarantine locations */
    vm.quarantineLocations = [];
    vm.quarantineLocationsOptions = [];
    vm.selectedQuarantineLocationId = '';

    vm.passedQuantity = passedQuantity;

    activate();

    ////////////////////

    function activate() {

    }

    function passedQuantity() {
      var total = parseFloat(vm.item.checkedQuantity || 0) - parseFloat(vm.item.failedQuantity || 0);
      return total || 0;
    }

    vm.ok = function () {
      if (vm.isVendorInspection) {
        registerVendorInspection();
      } else {
        registerDeliveryInspection();
      }
    };

    function registerVendorInspection() {
      var itemToUpdate = {
        inspectedQuantity: vm.item.checkedQuantity,
        passedQuantity: passedQuantity(),
        failedQuantity: vm.item.failedQuantity,
        comments: vm.item.comments,
        ircNumber: vm.item.ircNumber,
        isVendorInspection: true
      };

      return deliveryService.registerVendorInspection(vm.item.id, itemToUpdate)
        .then(function (response) {
          vm.saved = true;
          vm.postUpdateDelegate({id: vm.item.id, passedQuantity: itemToUpdate.passedQuantity});
        }, function () {
          vm.saved = false;
          vm.error = true;
          vm.saving = false;
        });
    }

    function registerDeliveryInspection() {
      var itemToUpdate = {
        barcode: vm.item.barcode,
        comments: vm.item.comments,
        failedInspectionQuantity: vm.item.failedQuantity,
        deliveryId: vm.item.deliveryId,
        ircNumber: vm.item.ircNumber,
        isVendorInspection: vm.item.inspectionType === 'V',
        quarantineLocationId: vm.selectedQuarantineLocationId
      };

      return deliveryService.registerInspection(vm.item.purchaseOrderLineId, itemToUpdate)
        .then(function (response) {
          vm.saved = true;
          $rootScope.$broadcast('osd-registered');
          vm.postUpdateDelegate();
        }, function () {
          vm.saved = false;
          vm.error = true;
          vm.saving = false;
        });
    }

    function resetModal() {
      vm.item.checkedQuantity = "";
      passedQuantity();
      vm.item.failedQuantity = "";
      vm.item.comments = "";
      vm.item.ircNumber = "";
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
      resetModal();
      vm.postUpdateDelegate();
    };

    /** Quarantine Locations */

    vm.quarantineLocations = new kendo.data.DataSource({
      transport: {
        read: {
          url: function(options) {
            return API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations/' + vm.warehouseId + '/quarantine'},
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      },
      group: { field: "warehouseName" }
    });

    vm.quarantineLocationsOptions = {
      placeholder: "Select location",
      dataSource: vm.quarantineLocations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };
  }

})();

(function () {
  'use strict';

  angular.module('app.common', []);

})();

(function() {
  'use strict';

  //Directive used to set metisMenu
  angular.module('app.common')
    .directive('sideNavigation', function ($timeout) {
      return {
        restrict: 'A',
        link: function (scope, element) {
          // Call metsi to build when user signup
          scope.$watch('authentication.user', function() {
            $timeout(function() {
              element.metisMenu();
            });
          });

        }
      };
    })
})();


(function () {

angular
  .module('app.common')
  .directive("requireValidOption", function() {
  return {
    require: "ngModel",
    restrict: "A",
    scope: {
      model: '=requireValidOption'
    },
    link: function(scope, element, attrs, ctrl) {
      var validator = getValidator(ctrl, element);

      // Register validator for UI changes.
      ctrl.$parsers.unshift(validator);

      // Register validator for model changes.
      ctrl.$formatters.unshift(validator);
    }
  };
});


  function getValidator(controller, element)
  {
    var _controller = controller;
    var _element = element;
    var _text = null;
    var _value = null;

    // Parameter "value" is not used.
    function validate(value)
    {
      var combobox = _element.data("kendoComboBox");
      _text = combobox ? combobox.text() : null;
      _value = combobox ? combobox.select() !== -1 : null;

      var valid = _text && _value;

      _controller.$setValidity('invalidOption', valid);

      return valid ? value : undefined;
    }

    return validate;
  }
})();

(function() {
  'use strict';

  angular.module('app.common')
    .directive('replace', function() {
      return {
        require: 'ngModel',
        scope: {
          regex: '@replace',
          with: '@with'
        },
        link: function(scope, element, attrs, model) {
          model.$parsers.push(function(val) {
            if (!val) { return; }
            var regex = new RegExp(scope.regex);
            var replaced = val.replace(regex, scope.with);
            if (replaced !== val) {
              model.$setViewValue(replaced);
              model.$render();
            }
            return replaced;
          });
        }
      };
    });


})();

(function () {

angular
  .module('app.common')
  .directive("passwordVerify", function() {
  return {
    require: "ngModel",
    scope: {
      passwordVerify: '='
    },
    link: function(scope, element, attrs, ctrl) {
      scope.$watch(function() {
        var combined;

        if (scope.passwordVerify || ctrl.$viewValue) {
          combined = scope.passwordVerify + '_' + ctrl.$viewValue;
        }
        return combined;
      }, function(value) {
        if (value) {
          ctrl.$parsers.unshift(function(viewValue) {
            var origin = scope.passwordVerify;
            if (origin !== viewValue) {
              ctrl.$setValidity("passwordVerify", false);
              return undefined;
            } else {
              ctrl.$setValidity("passwordVerify", true);
              return viewValue;
            }
          });
        }
      });
    }
  };
});
})();

(function() {
  'use strict';

  angular.module('app.common')
    .directive('numericOnly', function(){
      return {
        require: 'ngModel',
        link: function(scope, element, attrs, modelCtrl) {

          modelCtrl.$parsers.push(function (inputValue) {

            var transformedInput = inputValue ? inputValue.replace(/[^\d+.]/g,'') : null;

            if (transformedInput!=inputValue) {
              modelCtrl.$setViewValue(transformedInput);
              modelCtrl.$render();
            }

            return transformedInput;
          });
        }
      };
    });


})();

(function() {
  'use strict';

  function isEmpty(value) {
    return angular.isUndefined(value) || value === '' || value === null || value !== value;
  }

  angular.module('app.common')
    .directive('ngMin', function () {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {
          scope.$watch(attr.ngMin, function () {
            ctrl.$setViewValue(ctrl.$viewValue);
          });
          var minValidator = function (value) {
            var min = attr.ngMin || 0;
            elem.attr('min', min);
            if (!isEmpty(value) && +value < +min) {
              ctrl.$setValidity('ngMin', false);
              return undefined;
            } else {
              ctrl.$setValidity('ngMin', true);
              return value;
            }
          };

          ctrl.$parsers.push(minValidator);
          ctrl.$formatters.push(minValidator);
        }
      };
    })
    .directive('ngMax', function () {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {
          scope.$watch(attr.ngMax, function () {
            ctrl.$setViewValue(ctrl.$viewValue);
          });
          var maxValidator = function (value) {
            var max = attr.ngMax || Infinity;
            elem.attr('max', max);
            if (!isEmpty(value) && +value > +max) {
              ctrl.$setValidity('ngMax', false);
              return undefined;
            } else {
              ctrl.$setValidity('ngMax', true);
              return value;
            }
          };

          ctrl.$parsers.push(maxValidator);
          ctrl.$formatters.push(maxValidator);
        }
      };
    });


})();

(function() {
  'use strict';

  //Directive used to set minimalize button
  angular.module('app.common')
    .directive('minimalizaSidebar', function ($timeout) {
      return {
        restrict: 'A',
        template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
        controller: function ($scope) {
          $scope.minimalize = function () {
            angular.element('body').toggleClass('mini-navbar');
            if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
              // Hide menu in order to smoothly turn on when maximize menu
              angular.element('#side-menu').hide();
              // For smoothly turn on menu
              $timeout(function () {
                angular.element('#side-menu').fadeIn(400);
                angular.element('#expand-sidebar-full').fadeIn(400);
                angular.element('#expand-sidebar').removeClass('fa-angle-double-right');
                angular.element('#expand-sidebar').addClass('fa-angle-double-left');
                angular.element('#expand-sidebar').attr('title','Collapse sidebar');
              }, 200);
            } else {
              // Remove all inline style from jquery fadeIn function to reset menu state
              angular.element('#side-menu').removeAttr('style');
              angular.element('#expand-sidebar').removeClass('fa-angle-double-left');
              angular.element('#expand-sidebar').addClass('fa-angle-double-right');
              angular.element('#expand-sidebar').attr('title','Expand sidebar');
            }
          };
        }
      };
    });

})();


(function() {
  'use strict';

  angular.module('app.common')
    .directive('lettersOnly', function() {
      return {
        replace: true,
        template: '<input replace="[^a-zA-Z]" with="">'
      };
    });

})();

(function() {
  'use strict';

  angular.module('app.common')
    .directive('icheck', function($timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function($scope, element, $attrs, ngModel) {
      return $timeout(function() {
        var value;
        value = $attrs['value'];

        $scope.$watch($attrs['ngModel'], function(newValue){
          $(element).iCheck('update');
        });

        return $(element).iCheck({
          checkboxClass: 'icheckbox_square-green',
          radioClass: 'iradio_square-green'

        }).on('ifChanged', function(event) {
          if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
            $scope.$apply(function() {
              return ngModel.$setViewValue(event.target.checked);
            });
          }
          if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
            return $scope.$apply(function() {
              return ngModel.$setViewValue(value);
            });
          }
        });
      });
    }
  };
});
})();

/*
Add the icheck-ignore attribute to set a child property to be ignored if its set to true
eg : icheck-ignore='isDisabled', if the isDisabled property is set to true, it will not be checked / unchecked
 */
(function() {
  'use strict';

  angular.module('app.common')
    .directive('icheckAllNested', function($timeout, $filter) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function($scope, element, $attrs, ngModel) {
      return $timeout(function() {
        var value;
        value = $attrs['value'];

        var parentAndChildProperty = $attrs.icheckAllNested;
        var ignoreProperty = $attrs.icheckIgnore;

        var objProperties = parentAndChildProperty.split(".");

        var parentProperty = objProperties[0].concat("." + objProperties[1]);
        var nestedProperty = objProperties[2];
        var childProperty = objProperties[objProperties.length - 1];

        $scope.$watch(parentProperty, function (newVal) {
          var hasTrue, hasFalse;
          angular.forEach(newVal, function (v) {
            if(!v[ignoreProperty]) {
              if (v[childProperty]) {
                hasTrue = true;
              } else {
                hasFalse = true;
              }
            }
          });
          if (hasTrue && hasFalse) {
              $(element).prop('checked', false);
              ngModel.$setViewValue(false);
          } else {
              $(element).prop('checked', hasTrue);
              ngModel.$setViewValue(hasTrue);
          }
        }, true);


        $scope.$watch($attrs['ngModel'], function(newValue){
          $(element).iCheck('update');
        });

        return $(element).iCheck({
          checkboxClass: 'icheckbox_square-green',
          radioClass: 'iradio_square-green'

        }).on('ifChanged', function(event) {
          if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
            $scope.$apply(function() {

              var setValue = element.prop('checked');
              angular.forEach($scope.$eval(parentProperty), function (i) {
                angular.forEach(i[nestedProperty], function(v){
                  if (!v[ignoreProperty])
                  v[childProperty] = setValue;
                });
              });

              if ($scope.vm.updateSelected !== undefined) {
                $scope.vm.updateSelected(); }

              return ngModel.$setViewValue(event.target.checked);
            });
          }
          if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
            return $scope.$apply(function() {
              return ngModel.$setViewValue(value);
            });
          }
        });
      });
    }
  };
});
})();

/*
 Add the icheck-ignore attribute to set a child property to be ignored if its set to true
 eg : icheck-ignore='isDisabled', if the isDisabled property is set to true, it will not be checked / unchecked
 */
(function () {
  'use strict';

  angular.module('app.common')
    .directive('icheckAllFour', function ($timeout) {
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, element, $attrs, ngModel) {
          return $timeout(function () {
            var value;
            value = $attrs['value'];

            var parentAndChildProperty = $attrs.icheckAllFour;
            var splits = parentAndChildProperty.split('.', 4);

            var parentProperty = splits[0] + '.' + splits[1];
            var middleProperty = splits[2];
            var childProperty = splits[3];

            $scope.$watch(parentProperty, function (newVal) {
              var hasTrue, hasFalse;
              angular.forEach(newVal, function (item) {
                if (item[middleProperty]) {
                  angular.forEach(item[middleProperty], function (v) {
                    if (v[childProperty]) {
                      hasTrue = true;
                    } else {
                      hasFalse = true;
                    }
                  });
                  if (hasTrue && hasFalse) {
                    $(element).prop('checked', false);
                    ngModel.$setViewValue(false);
                  } else {
                    $(element).prop('checked', hasTrue);
                    ngModel.$setViewValue(hasTrue);
                  }
                }
              }, true);
            }, true);


            $scope.$watch($attrs['ngModel'], function (newValue) {
              $(element).iCheck('update');
            });

            return $(element).iCheck({
              checkboxClass: 'icheckbox_square-green',
              radioClass: 'iradio_square-green'

            }).on('ifChanged', function (event) {
              if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                $scope.$apply(function () {

                  var setValue = element.prop('checked');
                  angular.forEach($scope.$eval(parentProperty), function (v) {
                    angular.forEach(v[middleProperty], function (y) {
                      y[childProperty] = setValue;
                    });
                  });

                  if ($scope.vm.updateSelected !== undefined) {
                    $scope.vm.updateSelected();
                  }

                  return ngModel.$setViewValue(event.target.checked);
                });
              }
              if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                return $scope.$apply(function () {
                  return ngModel.$setViewValue(value);
                });
              }
            });
          });
        }
      };
    });
})();

/*
Add the icheck-ignore attribute to set a child property to be ignored if its set to true
eg : icheck-ignore='isDisabled', if the isDisabled property is set to true, it will not be checked / unchecked
 */
(function() {
  'use strict';

  angular.module('app.common')
    .directive('icheckAll', function($timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function($scope, element, $attrs, ngModel) {
      return $timeout(function() {
        var value;
        value = $attrs['value'];

        var parentAndChildProperty = $attrs.icheckAll;
        var ignoreProperty = $attrs.icheckIgnore;
        var parentProperty = parentAndChildProperty.substring(0, parentAndChildProperty.lastIndexOf("."));
        var childProperty = parentAndChildProperty.substring(parentAndChildProperty.lastIndexOf(".") + 1, parentAndChildProperty.length);

        $scope.$watch(parentProperty, function (newVal) {
          var hasTrue, hasFalse;
          angular.forEach(newVal, function (v) {
            if(!v[ignoreProperty]) {
              if (v[childProperty]) {
                hasTrue = true;
              } else {
                hasFalse = true;
              }
            }
          });
          if (hasTrue && hasFalse) {
              $(element).prop('checked', false);
              ngModel.$setViewValue(false);
          } else {
              $(element).prop('checked', hasTrue);
              ngModel.$setViewValue(hasTrue);
          }
        }, true);


        $scope.$watch($attrs['ngModel'], function(newValue){
          $(element).iCheck('update');
        });

        return $(element).iCheck({
          checkboxClass: 'icheckbox_square-green',
          radioClass: 'iradio_square-green'

        }).on('ifChanged', function(event) {
          if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
            $scope.$apply(function() {

              var setValue = element.prop('checked');
              angular.forEach($scope.$eval(parentProperty), function (v) {
                if (!v[ignoreProperty])
                v[childProperty] = setValue;
              });

              if ($scope.vm.updateSelected !== undefined) {
                $scope.vm.updateSelected(); }

              return ngModel.$setViewValue(event.target.checked);
            });
          }
          if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
            return $scope.$apply(function() {
              return ngModel.$setViewValue(value);
            });
          }
        });
      });
    }
  };
});
})();

(function() {
  'use strict';

  //Directive used to set minimalize button
  angular.module('app.common')
    .directive('expandSidebar', function ($timeout) {
      return {
        restrict: 'A',
        template: '<ul class="nav metismenu" ><li><a class="navbar-minimalize" href="" ng-click="minimalize()">' +
        '<i ng-class="{ \'fa fa-angle-double-left fa-lg\': isSmall, \'fa fa-angle-double-right fa-lg\': !isSmall}" id="expand-sidebar" title="{{isSmall ? \'Collapse sidebar\' : \'Expand sidebar\'}}"></i></a></li></ul>',
        link: function(scope, element, attrs, ctrl) {
          scope.isSmall = !angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small');
        },
        controller: function ($scope) {
          $scope.minimalize = function () {
            angular.element('body').toggleClass('mini-navbar');
            if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
              // Hide menu in order to smoothly turn on when maximize menu
              angular.element('#side-menu').hide();
              angular.element('#expand-sidebar-full').hide();
              // For smoothly turn on menu
              $timeout(function () {
                angular.element('#side-menu').fadeIn(400);
                angular.element('#expand-sidebar-full').fadeIn(400);
                angular.element('#expand-sidebar').removeClass('fa-angle-double-right');
                angular.element('#expand-sidebar').addClass('fa-angle-double-left');
                angular.element('#expand-sidebar').attr('title','Collapse sidebar');
              }, 200);
            } else {
              // Remove all inline style from jquery fadeIn function to reset menu state
              angular.element('#side-menu').removeAttr('style');
              angular.element('#expand-sidebar').removeClass('fa-angle-double-left');
              angular.element('#expand-sidebar').addClass('fa-angle-double-right');
              angular.element('#expand-sidebar').attr('title','Expand sidebar');
            }
          };
        }
      };
    });

})();


(function() {
  'use strict';

  angular.module('app.common')
    .directive("dropzone", ['OidcManager', '$timeout', function(OidcManager, $timeout) {
        return {
          restrict: "A",
          controllerAs: 'vm',
          scope: {
            parentId: '=',
            importEndpoint: '=',
            getImportErrors: '&'
          },
          link: function(scope, element, attrs, controller) {
            var previewNode = angular.element(document.querySelector("#template"));
            previewNode[0].id = "";
            var previewTemplate = previewNode[0].parentNode.innerHTML;
            previewNode[0].parentNode.removeChild(previewNode[0]);

            var fileNo = 0;
            element.dropzone({
              url:"/api/1/FileTransfer",
              paramName: "uploadfile",
              maxThumbnailFilesize: 5,
              maxFilesize: 5,
              addRemoveLinks : false,
              acceptedFiles : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
              previewTemplate: previewTemplate,
              init: function() {
                var myDropzone = this;
                myDropzone.on("processing", function(file) {
                  // var xhr = new XMLHttpRequest();
                });
                myDropzone.on("complete", function (file) {
                  //DoSomething();
                });
                myDropzone.on("success", function(file, data) {
                  if (!data.IsSuccess) {
                    fileNo++;
                    var btnName = "btnDownload" + fileNo.toString();

                    var errorMessage = "<div><span class='dz-error'><i class='fa fa-times-circle-o' style='font-size: 28px; vertical-align: middle'></i><strong> Unsuccessful: " + data.Message + "</strong></span>";
                    if (data.DocumentKey !== null){
                      errorMessage += "<button class='btn btn-warning pull-right' style='cursor: hand;' id='" + btnName + "'>Click to view errors</button>";
                    }
                    errorMessage += "</div>";

                    var rowError = Dropzone.createElement(errorMessage);

                    file.previewTemplate.childNodes[1].appendChild(rowError);
                    if (data.DocumentKey !== null) {
                      file.previewElement.querySelector("#" + btnName).onclick = function () {
                        scope.getImportErrors({parentId: scope.parentId, documentKey: data.DocumentKey});
                      };
                    }
                  } else {
                    var rowOk = Dropzone.createElement(
                    "<div><span class='dz-success-message'><i class='fa fa-check-circle-o' style='font-size: 28px; vertical-align: middle'></i><strong> Finished: " +
                    data.SuccessCount + " row(s) successfully imported.</strong></span></div>"
                    );
                    file.previewTemplate.childNodes[1].appendChild(rowOk);
                    scope.$emit('upload-complete');
                  }
                  $timeout(function () {
                    file.previewTemplate.querySelector("#progressBar").hidden = true;
                  }, 2000);
                });
                myDropzone.on("sending", function(file, xhr, formData){
                  xhr.open('POST', scope.importEndpoint, true);
                  xhr.setRequestHeader('Authorization', 'Bearer ' + OidcManager.OidcTokenManager().access_token);
                });
                myDropzone.on("error", function(file, data){
                  file.previewElement.classList.add("dz-error");
                  file.previewElement.querySelector("[data-dz-errormessage]").textContent = data.Message;
                });
                myDropzone.on('addedfile', function(file) {
                  var ext = file.name.split('.').pop();

                  if (ext.indexOf("xlsx") !== -1) {

                    $(file.previewElement).find(".dz-image img").attr("src", "/assets/images/excel-sm.png");
                  } else {
                    file.previewElement.classList.add("dz-file-preview-error-top");
                    $(file.previewElement).find(".dz-image img").attr("src", "/assets/images/reject-file.png");
                    file.previewTemplate.querySelector("#progressBar").hidden = true;
                    var rowError = Dropzone.createElement(
                      "<div><span class='dz-error'><i class='fa fa-times-circle-o' style='font-size: 28px; vertical-align: middle'></i><strong> " +
                      " This file type is not supported - *.xlsx only.</strong></span></div>"
                    );
                    file.previewTemplate.childNodes[1].appendChild(rowError);
                  }
                });
              }
            });
          }
        };
      }
    ]);

})();

(function() {
  'use strict';

  angular.module('app.common')
    .directive('dateToIso', function (){
      return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attr, controller) {
          controller.$formatters.push(function(value){
            if (value) controller.$setViewValue(value);
            return value;
          });

          //format the date to remove the timezone
          controller.$parsers.push(function (datepickerValue) {
            return moment(datepickerValue).format("YYYY-MM-DD");
          });
        }
      }
    })
})();

(function() {
  'use strict';

  angular.module('app.common')
  .directive('datepickerPopup', function (){
    return {
      restrict: 'EAC',
      require: 'ngModel',
      link: function(scope, element, attr, controller) {
        //remove the default formatter from the input directive to prevent conflict
        controller.$formatters.shift();
      }
    }
  })
})();

(function() {
  'use strict';

  angular.module('app.common')
  .directive('capitalize', function() {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, modelCtrl) {
        var capitalize = function(inputValue) {
          if(inputValue == undefined) inputValue = '';
          var capitalized = inputValue.toUpperCase();
          if(capitalized !== inputValue) {
            modelCtrl.$setViewValue(capitalized);
            modelCtrl.$render();
          }
          return capitalized;
        };
        modelCtrl.$parsers.push(capitalize);
        capitalize(scope[attrs.ngModel]);  // capitalize initial value
      }
    };
  });


})();

(function() {
  'use strict';

  angular.module('app.common')
    .filter('yesNo', function() {
      return function(input) {
        return input ? 'Yes' : 'No';
      }
    });
})();


(function() {
  'use strict';

  angular.module('app.common')
    .filter('truncateNumber', function () {
    return function (value, maxValue, truncateChar) {
      if (isNaN(maxValue))
        maxValue = 99;

      if (truncateChar === undefined)
        truncateChar = "+";

      if (parseInt(value) < maxValue)
        return String(value);
      else {
        return String(maxValue) + truncateChar;
      }
    };
  });
})();

(function() {
  'use strict';

  angular.module('app.common')
    .filter('truncate', function () {
    return function (text, length, end) {
      if (isNaN(length))
        length = 10;

      if (end === undefined)
        end = "...";

      if (text.length <= length || text.length - end.length <= length) {
        return text;
      }
      else {
        return String(text).substring(0, length - end.length) + end;
      }
    };
  });
})();

(function() {
  'use strict';

  angular.module('app.common')
    .filter('sumOfValue', function () {
      return function (data, key) {
        if (angular.isUndefined(data) && angular.isUndefined(key))
          return 0;
        var sum = 0;
        var anyNaN = false;

        angular.forEach(data,function(v,k){
          if(!isNaN(parseFloat(v[key]))){
            sum = sum + parseFloat(v[key]);
          }
          else{
            anyNaN = true;
          }
        });
        if(anyNaN) return "";
        return sum;
      };
    });
})();

(function() {
  'use strict';

  angular.module('app.common')
    .filter('percentage', ['$filter', function ($filter) {
      return function (input, decimals) {
        return $filter('number')(input * 100, decimals) + '%';
      };
    }]);
})();


(function() {
  'use strict';

  angular.module('app.common')
    .filter('natural', ['naturalService', function(naturalService) {
      return function(input) {
        return naturalService.naturalValue(input);
      }
    }]);
})();

(function() {
  'use strict';

  angular.module('app.common')
    .filter('movementInvalidQuantity', function () {
      return function(items, greaterThan) {

        var out = [];

        angular.forEach(items, function(item) {

          if(item.storedItems != undefined) { // Transfers
            angular.forEach(item.storedItems, function (storedItem) {
              if ((parseFloat(storedItem.requestedQuantity) < greaterThan || parseFloat(storedItem.requestedQuantity) > parseFloat(storedItem.selectedQuantity)) && storedItem.isIncluded) {
                out.push(storedItem);
              }
            });
          }
          else { // Returns
            if ((parseFloat(item.requestedQuantity) < greaterThan || parseFloat(item.requestedQuantity) > parseFloat(item.selectedQuantity)) && item.isIncluded) {
              out.push(item);
            }
          }
        });

        return out;
      };
    });
})();

(function() {
  'use strict';

  angular.module('app.common')
    .filter('movementGreaterThanZero', function () {
      return function(items, greaterThan) {

        var out = [];

        angular.forEach(items, function(item) {
          if(item.storedItems != undefined) { // Transfers
            angular.forEach(item.storedItems, function(storedItem) {
              if (parseFloat(storedItem.requestedQuantity) > greaterThan && parseFloat(storedItem.requestedQuantity) <= parseFloat(storedItem.selectedQuantity) && storedItem.isIncluded) {
                out.push(storedItem);
              }
            });
          }
          else { // Returns
            if (parseFloat(item.requestedQuantity) > greaterThan && parseFloat(item.requestedQuantity) <= parseFloat(item.selectedQuantity) && item.isIncluded) {
              out.push(item);
            }
          }
        });

        return out;
      };
    });
})();

(function() {
  'use strict';

  angular.module('app.common')
    .filter('isIncluded', function(){
      return function(items) {

        var out = [];

        angular.forEach(items, function(item) {
          if (item != undefined){
            if (item.isIncluded) {
              out.push(item);
            };
          }
        });

        return out;
      };
    });
})();

(function() {
  'use strict';

  angular.module('app.common')
    .filter('invalidQuantity', function () {
      return function(items, greaterThan) {

        var out = [];

        angular.forEach(items, function(item) {

          if(item.storedItems != undefined) { // Transfers
            angular.forEach(item.storedItems, function (storedItem) {
              if ((parseFloat(storedItem.selectedQuantity) < greaterThan || parseFloat(storedItem.selectedQuantity) > parseFloat(storedItem.quantity)) && storedItem.isIncluded) {
                out.push(storedItem);
              }
            });
          }
          else { // Returns
            if ((parseFloat(item.selectedQuantity) < greaterThan || parseFloat(item.selectedQuantity) > parseFloat(item.quantity)) && item.isIncluded) {
              out.push(item);
            }
          }
        });

        return out;
      };
    });
})();

(function() {
  'use strict';

  angular.module('app.common')
    .filter('highlight', function () {
      return function (text, search, caseSensitive) {
      if (text && (search || angular.isNumber(search))) {
        text = text.toString();
        search = search.toString();

        var searchTerms = search.split(' ');
        searchTerms.forEach(function (item) {
          if (caseSensitive) {
            text = text.split(item).join('<span class="ui-match">' + item + '</span>');
          } else {
            text = text.replace(new RegExp(item, 'gi'), '<span class="ui-match">$&</span>');
          }
        });

        return text;

      } else {
        return text;
      }
    };
  });
})();


(function() {
  'use strict';

  angular.module('app.common')
    .filter('greaterThanZero', function () {
      return function(items, greaterThan) {

        var out = [];

        angular.forEach(items, function(item) {
          if(item.storedItems != undefined) { // Transfers
            angular.forEach(item.storedItems, function(storedItem) {
              if (parseFloat(storedItem.selectedQuantity) > greaterThan && parseFloat(storedItem.selectedQuantity) <= parseFloat(storedItem.quantity) && storedItem.isIncluded) {
                out.push(storedItem);
              }
            });
          }
          else { // Returns
            if (parseFloat(item.selectedQuantity) > greaterThan && parseFloat(item.selectedQuantity) <= parseFloat(item.quantity) && item.isIncluded) {
              out.push(item);
            }
          }
        });

        return out;
      };
    });
})();

(function() {
  'use strict';

  angular.module('blocks.logger', []);
})();

(function() {
  'use strict';

  angular
    .module('blocks.logger')
    .factory('logger', logger);

  logger.$inject = ['$log', 'toastr'];

  function logger($log, toastr) {
    var service = {
      showToasts: true,

      logError   : logError,
      logInfo    : logInfo,
      logSuccess : logSuccess,
      logWarning : logWarning,

      // straight to console; bypass toastr
      log     : $log.log
    };

    return service;
    /////////////////////

    function logError(message, data, title) {
      toastr.error(message, title);
      $log.error('Error: ' + message, data);
    }

    function logInfo(message, data, title) {
      toastr.info(message, title);
      $log.info('Info: ' + message, data);
    }

    function logSuccess(message, data, title) {
      toastr.success(message, title);
      $log.info('Success: ' + message, data);
    }

    function logWarning(message, data, title) {
      toastr.warning(message, title);
      $log.warn('Warning: ' + message, data);
    }
  }
}());

(function() {
  'use strict';

  angular.module('blocks.exception', ['blocks.logger']);
})();

(function() {
  'use strict';

  angular
    .module('blocks.exception')
    .factory('exception', exception);

  /* @ngInject */
  function exception(logger) {
    var service = {
      catcher: catcher
    };
    return service;

    function catcher(message) {
      return function(reason) {
        logger.logError(message, reason);
      };
    }
  }
})();

// Include in index.html so that app level exceptions are handled.
// Exclude from testRunner.html which should run exactly what it wants to run
(function() {
  'use strict';

  angular
    .module('blocks.exception')
    .provider('exceptionHandler', exceptionHandlerProvider)
    .config(config);

  /**
   * Must configure the exception handling
   * @return {[type]}
   */
  function exceptionHandlerProvider() {
    /* jshint validthis:true */
    this.config = {
      appErrorPrefix: undefined
    };

    this.configure = function (appErrorPrefix) {
      this.config.appErrorPrefix = appErrorPrefix;
    };

    this.$get = function() {
      return {config: this.config};
    };
  }

  /**
   * Configure by setting an optional string value for appErrorPrefix.
   * Accessible via config.appErrorPrefix (via config value).
   * @param  {[type]} $provide
   * @return {[type]}
   * @ngInject
   */
  function config($provide) {
    $provide.decorator('$exceptionHandler', extendExceptionHandler);
  }

  /**
   * Extend the $exceptionHandler service to also display a toast.
   * @param  {Object} $delegate
   * @param  {Object} exceptionHandler
   * @param  {Object} logger
   * @return {Function} the decorated $exceptionHandler service
   */
  function extendExceptionHandler($delegate, exceptionHandler, logger) {
    return function(exception, cause) {
      var appErrorPrefix = exceptionHandler.config.appErrorPrefix || '';
      var errorData = {exception: exception, cause: cause};
      exception.message = appErrorPrefix + exception.message;
      $delegate(exception, cause);
      /**
       * Could add the error to a service's collection,
       * add errors to $rootScope, log errors to remote web server,
       * or log locally. Or throw hard. It is entirely up to you.
       * throw exception;
       *
       * @example
       *     throw { message: 'error message we added' };
       */
      logger.logError(exception.message, errorData);
    };
  }
})();

(function() {
  'use strict';

  angular.module('blocks.router', [
    'ui.router',
    'blocks.logger'
  ]);
})();

(function() {
  'use strict';

  angular
    .module('blocks.router')
    .provider('routehelperConfig', routehelperConfig)
    .factory('routehelper', routehelper);

  routehelper.$inject = ['$location', '$rootScope', '$route', 'logger', 'routehelperConfig'];

  // Must configure via the routehelperConfigProvider
  function routehelperConfig() {
    /* jshint validthis:true */
    this.config = {
      // These are the properties we need to set
      // $routeProvider: undefined
      // docTitle: ''
      // resolveAlways: {ready: function(){ } }
    };

    this.$get = function() {
      return {
        config: this.config
      };
    };
  }

  function routehelper($location, $rootScope, $route, logger, routehelperConfig) {
    var handlingRouteChangeError = false;
    var routeCounts = {
      errors: 0,
      changes: 0
    };
    var routes = [];
    var $routeProvider = routehelperConfig.config.$routeProvider;

    var service = {
      configureRoutes: configureRoutes,
      getRoutes: getRoutes,
      routeCounts: routeCounts
    };

    init();

    return service;
    ///////////////

    function configureRoutes(routes) {
      routes.forEach(function(route) {
        route.config.resolve =
          angular.extend(route.config.resolve || {}, routehelperConfig.config.resolveAlways);
        $routeProvider.when(route.url, route.config);
      });
      $routeProvider.otherwise({redirectTo: '/'});
    }

    function handleRoutingErrors() {
      // Route cancellation:
      // On routing error, go to the dashboard.
      // Provide an exit clause if it tries to do it twice.
      $rootScope.$on('$routeChangeError',
        function(event, current, previous, rejection) {
          if (handlingRouteChangeError) {
            return;
          }
          routeCounts.errors++;
          handlingRouteChangeError = true;
          var destination = (current && (current.title || current.name || current.loadedTemplateUrl)) ||
            'unknown target';
          var msg = 'Error routing to ' + destination + '. ' + (rejection.msg || '');
          logger.logWarning(msg, [current]);
          $location.path('/');
        }
      );
    }

    function init() {
      handleRoutingErrors();
      updateDocTitle();
    }

    function getRoutes() {
      for (var prop in $route.routes) {
        if ($route.routes.hasOwnProperty(prop)) {
          var route = $route.routes[prop];
          var isRoute = !!route.title;
          if (isRoute) {
            routes.push(route);
          }
        }
      }
      return routes;
    }

    function updateDocTitle() {
      $rootScope.$on('$routeChangeSuccess',
        function(event, current, previous) {
          routeCounts.changes++;
          handlingRouteChangeError = false;
          var title = routehelperConfig.config.docTitle + ' ' + (current.title || '');
          $rootScope.title = title; // data bind to <title>
        }
      );
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.search', []);

})();

(function () {
  'use strict';

  angular
    .module('app.search')
    .controller('TransferSearchCtrl', TransferSearchCtrl);

  TransferSearchCtrl.$inject = ['$state', '$stateParams', 'searchService'];

  /* @ngInject */
  function TransferSearchCtrl($state, $stateParams, searchService) {
    if ($state.transition) return;

    var vm = this;
    vm.searchTerm = $stateParams.term || '';
    vm.lastSearchTerm = '';
    vm.results = undefined;
    vm.resultsBagAndTag = undefined;
    vm.totalItems = 0;
    vm.itemsPerPage = 10;
    vm.currentPage = $stateParams.page || 1;
    vm.doSearch = doSearch;
    vm.resetCurrentPage = resetCurrentPage;
    vm.pageChange = pageChange;
    vm.setActiveTab = setActiveTab;
    vm.searchTransfers = searchTransfers;
    vm.searchTransferBagAndTags = searchTransferBagAndTags;
    vm.searching = false;

    activate();

    ////////////////

    function activate() {

      if (vm.searchTerm !== '') {
        return doSearch().then(function(){
        });
      }
    }

    function doSearch() {
      vm.searching = true;

      var data = {
        searchTerm: vm.searchTerm
      };

      vm.lastSearchTerm = angular.copy(vm.searchTerm);

      return searchTransfers(data).then(function () {
        return searchTransferBagAndTags(data).then(function () {
          vm.searching = false;
          vm.totalItems = vm.results.length + vm.resultsBagAndTag.length;

          pageChange(vm.currentPage);
          setActiveTab();
        });
      });
    }

    function searchTransfers(data) {
      return searchService.searchTransfers(data).then(function(data) {
        vm.results = data;
      });
    }

    function searchTransferBagAndTags(data) {
      return searchService.searchTransferBagAndTags(data).then(function(data) {
        vm.resultsBagAndTag = data;
      });
    }

    function setActiveTab(){

      vm.tabs.storedItemsResultsActive = false;
      vm.tabs.bagAndTagResultsActive = false;

      if(vm.results !== undefined && vm.results !== null && vm.results.length) {
        vm.tabs.storedItemsResultsActive = true;
      }
      else if(vm.resultsBagAndTag !== undefined && vm.resultsBagAndTag !== null && vm.resultsBagAndTag.length) {
        vm.tabs.bagAndTagResultsActive = true;
      }
    }

    function pageChange(newPageNumber) {
      $state.transitionTo('search.transfer', {term: vm.searchTerm, page: newPageNumber}, {notify: false } );
    }

    function resetCurrentPage() {
      vm.currentPage = 1;
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.search')
    .controller('ReturnSearchCtrl', ReturnSearchCtrl);

  ReturnSearchCtrl.$inject = ['$state', '$stateParams', 'searchService'];

  /* @ngInject */
  function ReturnSearchCtrl($state, $stateParams, searchService) {
    if ($state.transition) return;

    var vm = this;
    vm.searchTerm = $stateParams.term || '';
    vm.lastSearchTerm = '';
    vm.results = undefined;
    vm.resultsBagAndTag = undefined;
    vm.totalItems = 0;
    vm.itemsPerPage = 10;
    vm.currentPage = $stateParams.page || 1;
    vm.doSearch = doSearch;
    vm.resetCurrentPage = resetCurrentPage;
    vm.pageChange = pageChange;
    vm.setActiveTab = setActiveTab;
    vm.searchReturns = searchReturns;
    vm.searchReturnBagAndTags = searchReturnBagAndTags;
    vm.searching = false;

    activate();

    ////////////////

    function activate() {

      if (vm.searchTerm !== '') {
        return doSearch().then(function(){
        });
      }
    }

    function doSearch() {
      vm.searching = true;

      var data = {
        searchTerm: vm.searchTerm
      };

      vm.lastSearchTerm = angular.copy(vm.searchTerm);

      return searchReturns(data).then(function () {
        return searchReturnBagAndTags(data).then(function () {
          vm.searching = false;
          vm.totalItems = vm.results.length + vm.resultsBagAndTag.length;

          pageChange(vm.currentPage);
          setActiveTab();
        });
      });
    }

    function searchReturns(data) {
      return searchService.searchReturns(data).then(function(data) {
        vm.results = data;
      });
    }

    function searchReturnBagAndTags(data) {
      return searchService.searchReturnBagAndTags(data).then(function(data) {
        vm.resultsBagAndTag = data;
      });
    }

    function setActiveTab(){

      vm.tabs.storedItemsResultsActive = false;
      vm.tabs.bagAndTagResultsActive = false;

      if(vm.results !== undefined && vm.results !== null && vm.results.length) {
        vm.tabs.storedItemsResultsActive = true;
      }
      else if(vm.resultsBagAndTag !== undefined && vm.resultsBagAndTag !== null && vm.resultsBagAndTag.length) {
        vm.tabs.bagAndTagResultsActive = true;
      }
    }

    function pageChange(newPageNumber) {
      $state.transitionTo('search.returns', {term: vm.searchTerm, page: newPageNumber}, {notify: false } );
    }

    function resetCurrentPage() {
      vm.currentPage = 1;
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.search')
    .controller('ManifestSearchCtrl', ManifestSearchCtrl);

  ManifestSearchCtrl.$inject = ['$state', '$stateParams', 'searchService'];

  /* @ngInject */
  function ManifestSearchCtrl($state, $stateParams, searchService) {
    if ($state.transition) return;

    var vm = this;
    vm.searchTerm = $stateParams.term || '';
    vm.lastSearchTerm = '';
    vm.results = undefined;
    vm.resultsBagAndTag = undefined;
    vm.totalItems = 0;
    vm.itemsPerPage = 10;
    vm.currentPage = $stateParams.page || 1;
    vm.doSearch = doSearch;
    vm.resetCurrentPage = resetCurrentPage;
    vm.pageChange = pageChange;
    vm.setActiveTab = setActiveTab;
    vm.searchManifest = searchManifest;
    vm.searchManifestBagAndTags = searchManifestBagAndTags;
    vm.searching = false;

    activate();

    ////////////////

    function activate() {

      if (vm.searchTerm !== '') {
        return doSearch().then(function(){
        });
      }
    }

    function doSearch() {
      vm.searching = true;

      var data = {
        searchTerm: vm.searchTerm
      };

      vm.lastSearchTerm = angular.copy(vm.searchTerm);

      return searchManifest(data).then(function () {
        return searchManifestBagAndTags(data).then(function () {
          vm.searching = false;
          vm.totalItems = vm.results.length + vm.resultsBagAndTag.length;

          pageChange(vm.currentPage);
          setActiveTab();
        });
      });
    }

    function searchManifest(data) {
      return searchService.searchManifest(data).then(function(data) {
        vm.results = data;
      });
    }

    function searchManifestBagAndTags(data) {
      return searchService.searchManifestBagAndTags(data).then(function(data) {
        vm.resultsBagAndTag = data;
      });
    }

    function setActiveTab(){

      vm.tabs.storedItemsResultsActive = false;
      vm.tabs.bagAndTagResultsActive = false;

      if(vm.results !== undefined && vm.results !== null && vm.results.length) {
        vm.tabs.storedItemsResultsActive = true;
      }
      else if(vm.resultsBagAndTag !== undefined && vm.resultsBagAndTag !== null && vm.resultsBagAndTag.length) {
        vm.tabs.bagAndTagResultsActive = true;
      }
    }

    function pageChange(newPageNumber) {
      $state.transitionTo('search.manifests', {term: vm.searchTerm, page: newPageNumber}, {notify: false } );
    }

    function resetCurrentPage() {
      vm.currentPage = 1;
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.search')
    .controller('IssueSearchCtrl', IssueSearchCtrl);

  IssueSearchCtrl.$inject = ['$state', '$stateParams', 'searchService'];

  /* @ngInject */
  function IssueSearchCtrl($state, $stateParams, searchService) {
    if ($state.transition) return;

    var vm = this;
    vm.searchTerm = $stateParams.term || '';
    vm.lastSearchTerm = '';
    vm.results = undefined;
    vm.resultsBagAndTag = undefined;
    vm.totalItems = 0;
    vm.itemsPerPage = 10;
    vm.currentPage = $stateParams.page || 1;
    vm.doSearch = doSearch;
    vm.resetCurrentPage = resetCurrentPage;
    vm.pageChange = pageChange;
    vm.setActiveTab = setActiveTab;
    vm.searchIssues = searchIssues;
    vm.searchIssueBagAndTags = searchIssueBagAndTags;
    vm.searching = false;

    vm.tabs = {
      storedItemsActive: true,
      bagAngTagsActive: false
    };

    activate();

    ////////////////

    function activate() {

      if (vm.searchTerm !== '') {
        return doSearch().then(function(){
        });
      }
    }

    function doSearch() {
      vm.searching = true;

      var data = {
        searchTerm: vm.searchTerm
      };
      vm.lastSearchTerm = angular.copy(vm.searchTerm);

      return searchIssues(data).then(function () {
        return searchIssueBagAndTags(data).then(function () {
          vm.searching = false;
          vm.totalItems = vm.results.length + vm.resultsBagAndTag.length;

          pageChange(vm.currentPage);
          setActiveTab();
        });
      });


    }

    function searchIssues(data) {
      return searchService.searchIssues(data).then(function(data) {
        vm.results = data;
      });
    }

    function searchIssueBagAndTags(data) {
      return searchService.searchIssueBagAndTags(data).then(function(data) {
        vm.resultsBagAndTag = data;
      });
    }

    function pageChange(newPageNumber) {
      $state.transitionTo('search.issues', {term: vm.searchTerm, page: newPageNumber}, {notify: false } );
    }

    function setActiveTab(){

      vm.tabs.storedItemsResultsActive = false;
      vm.tabs.bagAndTagResultsActive = false;

      if(vm.results !== undefined && vm.results !== null && vm.results.length) {
        vm.tabs.storedItemsResultsActive = true;
      }
      else if(vm.resultsBagAndTag !== undefined && vm.resultsBagAndTag !== null && vm.resultsBagAndTag.length) {
        vm.tabs.bagAndTagResultsActive = true;
      }
    }

    function resetCurrentPage() {
      vm.currentPage = 1;
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.search')
    .controller('DeliverySearchCtrl', DeliverySearchCtrl);

  DeliverySearchCtrl.$inject = ['$state', '$stateParams', 'searchService'];

  /* @ngInject */
  function DeliverySearchCtrl($state, $stateParams, searchService) {
    if ($state.transition) return;

    var vm = this;
    vm.searchTerm = $stateParams.term || '';
    vm.lastSearchTerm = '';
    vm.results = undefined;
    vm.totalItems = 0;
    vm.itemsPerPage = 10;
    vm.currentPage = $stateParams.page || 1;
    vm.doSearch = doSearch;
    vm.resetCurrentPage = resetCurrentPage;
    vm.pageChange = pageChange;
    vm.searching = false;

    activate();

    ////////////////

    function activate() {

      if (vm.searchTerm !== '') {
        return doSearch().then(function(){
        });
      }
    }

    function doSearch() {
      vm.searching = true;

      var data = {
        searchTerm: vm.searchTerm
      };


      return searchService.searchDeliveries(data).then(function(data) {
        vm.results = data;
        vm.totalItems = vm.results.length;
        vm.lastSearchTerm = angular.copy(vm.searchTerm);
        pageChange(vm.currentPage);
        vm.searching = false;
      });
    }

    function pageChange(newPageNumber) {
      $state.transitionTo('search.deliveries', {term: vm.searchTerm, page: newPageNumber}, {notify: false } );
    }

    function resetCurrentPage() {
      vm.currentPage = 1;
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.search')
    .controller('SearchCtrl', SearchCtrl);

  SearchCtrl.$inject = ['$state', '$stateParams', 'dataservice'];

  /* @ngInject */
  function SearchCtrl($state, $stateParams, dataservice) {
    if ($state.transition) return;

    var vm = this;

    var dateFormat = 'DD-MM-YYYY';
    var calendarDateFormat = 'dd-MMM-yyyy';

    vm.searchParams = {
      searchTerm : $stateParams.term || '',
      searchFromDate : $stateParams.fromDate ? moment($stateParams.fromDate, dateFormat).toDate() : '',
      searchToDate : $stateParams.toDate ? moment($stateParams.toDate, dateFormat).toDate() : ''
    };

    vm.searchResultString = '';
    vm.results = undefined;
    vm.totalItems = 0;
    vm.itemsPerPage = 10;
    vm.currentPage = $stateParams.page || 1;
    vm.doSearch = doSearch;
    vm.resetCurrentPage = resetCurrentPage;
    vm.pageChange = pageChange;
    vm.searching = false;
    vm.calendar = {
      opened: {},
      dateFormat: calendarDateFormat,
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ////////////////

    function activate() {

      if (vm.searchParams.searchTerm !== '' || vm.searchParams.searchFromDate !== '' || vm.searchParams.searchToDate !== '') {
        return doSearch().then(function(){
        });
      }
    }

    function doSearch() {
      vm.searching = true;

      return dataservice.searchPurchaseOrders(vm.searchParams).then(function(data) {
        vm.results = data;
        vm.totalItems = vm.results.length;
        vm.lastSearchParams = angular.copy(vm.searchParams);
        pageChange(vm.currentPage);
        generateSearchResultString();
        vm.searching = false;
      });
    }

    function pageChange(newPageNumber) {
      $state.transitionTo('search.purchase-orders',
        {
          term: vm.searchParams.searchTerm,
          fromDate : vm.searchParams.searchFromDate ? moment(vm.searchParams.searchFromDate).format(dateFormat) : null,
          toDate : vm.searchParams.searchToDate ? moment(vm.searchParams.searchToDate).format(dateFormat) : null,
          page: newPageNumber
        },
        {
          notify: false
        });
    }

    function resetCurrentPage() {
      vm.currentPage = 1;
    }

    function generateSearchResultString(){
      if (vm.lastSearchParams) {
        var fromDateFormatted = vm.lastSearchParams.searchFromDate ? moment(vm.lastSearchParams.searchFromDate).format("DD MMM YYYY") : null;
        var toDateFormatted = vm.lastSearchParams.searchToDate ? moment(vm.lastSearchParams.searchToDate).format("DD MMM YYYY") : null;

        vm.searchResultString = vm.lastSearchParams.searchTerm ? 'for "' + vm.lastSearchParams.searchTerm + '" ' : '';
        vm.searchResultString += fromDateFormatted ? 'created after ' + fromDateFormatted + ' ' : '';
        vm.searchResultString += toDateFormatted ?
          (fromDateFormatted ? 'and before ' + toDateFormatted : 'created before ' + toDateFormatted)
          : '';
      }
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('transferService', transferService);

  transferService.$inject = ['$q','transferBackendService', 'authorizationService', 'SETTINGS'];

  function transferService($q, transferBackendService, authorizationService, SETTINGS) {

    var service = {
      getTransfer: getTransfer,
      getTransferItems: getTransferItems,
      getTransferCostCodeItems: getTransferCostCodeItems,
      getTransferBagAndTagItems: getTransferBagAndTagItems,
      getTransfers: getTransfers,
      getTransfersCount: getTransfersCount,
      getTransfersCompleted: getTransfersCompleted,
      createTransfer: createTransfer,
      transferItems: transferItems,
      transferCostCodeItems: transferCostCodeItems,
      completeTransfer: completeTransfer,
      removeItemFromTransfer: removeItemFromTransfer,
      removeCostCodeItemFromTransfer: removeCostCodeItemFromTransfer,
      removeBagAndTagItemFromTransfer: removeBagAndTagItemFromTransfer,
      cancelTransfer: cancelTransfer,
      searchTransfers: searchTransfers,
      searchTransferBagAndTags: searchTransferBagAndTags
    };

    return service;

    //////////////

    function getTransfer(id) {
      return transferBackendService.getTransfer({code:SETTINGS.projectCode, id: id}).$promise.then(function(response) {
        return response;
      });
    }

    function getTransferItems(id) {
      return transferBackendService.getTransferItems({code:SETTINGS.projectCode, id: id}).$promise.then(function(response) {
        return response;
      });
    }

    function getTransferCostCodeItems(id) {
      return transferBackendService.getTransferCostCodeItems({code:SETTINGS.projectCode, id: id}).$promise.then(function(response) {
        return response;
      });
    }

    function getTransferBagAndTagItems(id) {
      return transferBackendService.getTransferBagAndTagItems({code:SETTINGS.projectCode, id: id}).$promise.then(function(response) {
        return response;
      });
    }

    function getTransfers() {
      return transferBackendService.getTransfers({code:SETTINGS.projectCode}).$promise.then(function(response) {
        return response;
      });
    }

    function getTransfersCount() {
      return transferBackendService.getTransfersCount({code:SETTINGS.projectCode}).$promise;
    }

    function getTransfersCompleted() {
      return transferBackendService.getTransfersCompleted({code:SETTINGS.projectCode}).$promise.then(function(response) {
        return response;
      });
    }

    function createTransfer(transfer) {
      return transferBackendService.createTransfer({code:SETTINGS.projectCode}, transfer).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot create transfer.');
        return error;
      });
    }

    function transferItems(transferItems) {
      return transferBackendService.transferItems({code:SETTINGS.projectCode, id: transferItems.transferId}, transferItems).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update transfer.');
        return error;
      });
    }

    function transferCostCodeItems(transferItems) {
      return transferBackendService.transferCostCodeItems({code:SETTINGS.projectCode, id: transferItems.transferId}, transferItems).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update transfer.');
        return error;
      });
    }

    function removeItemFromTransfer(transferId, storedItemLocationId, locationId) {
      return transferBackendService.removeItemFromTransfer({code:SETTINGS.projectCode, id:transferId, storedItemLocationId:storedItemLocationId, locationId:locationId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update transfer.');
        return error;
      });
    }

    function removeCostCodeItemFromTransfer(transferId, storedItemLocationId, costCode) {
      return transferBackendService.removeCostCodeItemFromTransfer({code:SETTINGS.projectCode, id:transferId, storedItemLocationId:storedItemLocationId, costCode:costCode}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update transfer.');
        return error;
      });
    }

    function removeBagAndTagItemFromTransfer(transferId, storedItemLocationId, locationId, bagAndTagId) {
      return transferBackendService.removeBagAndTagItemFromTransfer({code:SETTINGS.projectCode, id:transferId, storedItemLocationId:storedItemLocationId, locationId:locationId, bagAndTagId:bagAndTagId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update transfer.');
        return error;
      });
    }

    function completeTransfer(id) {
      return transferBackendService.completeTransfer({code:SETTINGS.projectCode, id:id}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot complete transfer.');
        return error;
      });
    }

    function cancelTransfer(id) {
      return transferBackendService.cancelTransfer({code:SETTINGS.projectCode, id:id}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot cancel transfer.');
        return error;
      });
    }

    function searchTransfers(data) {
      var deferred = $q.defer();

      transferBackendService.searchTransfers({
        code: SETTINGS.projectCode
      }, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot search transfers.');
      });

      return deferred.promise;
    }

    function searchTransferBagAndTags(data) {
      var deferred = $q.defer();

      transferBackendService.searchTransferBagAndTags({
        code: SETTINGS.projectCode
      }, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot search transfers.');
      });

      return deferred.promise;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('transferBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_WAREHOUSE + 'transfers/:id', {id: '@id'}, {

        getTransfer: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/:id', method:'GET', params:{code:'@code', id:'@id'}},
        getTransferItems: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/:id/transfer-items', method:'GET', params:{code:'@code', id:'@id'}, isArray: true},
        getTransferCostCodeItems: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/:id/transfer-cost-code-items', method:'GET', params:{code:'@code', id:'@id'}, isArray: true},
        getTransferBagAndTagItems: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/:id/transfer-bag-and-tag-items', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},
        getTransfers: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/', method:'GET', params:{code:'@code', id:'@id'}, isArray: true},
        getTransfersCount: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/count', method:'GET', params:{code:'@code', id:'@id'}},
        getTransfersCompleted: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/complete', method:'GET', params:{code:'@code'}, isArray: true},
        createTransfer: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/', method:'POST', params:{code:'@code'}},
        transferItems: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/:id/transfer-items', method:'PUT', params:{code:'@code', id:'@id'}},
        transferCostCodeItems: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/:id/transfer-cost-code-items', method:'PUT', params:{code:'@code', id:'@id'}},
        completeTransfer: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/:id/complete-transfer', method:'PUT', params:{code:'@code', id:'@id'}},
        cancelTransfer: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/:id/cancel-transfer', method:'PUT', params:{code:'@code', id:'@id'}},
        removeItemFromTransfer: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/:id/transfer-items/:storedItemLocationId/:locationId', method:'DELETE', params:{code:'@code', id:'@id', storedItemLocationId:'@storedItemLocationId', locationId:'@locationId'}},
        removeCostCodeItemFromTransfer: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/:id/transfer-items/:storedItemLocationId/:costCode', method:'DELETE', params:{code:'@code', id:'@id', storedItemLocationId:'@storedItemLocationId', costCode:'@costCode'}},
        removeBagAndTagItemFromTransfer: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/:id/transfer-items/:storedItemLocationId/:locationId/:bagAndTagId', method:'DELETE', params:{code:'@code', id:'@id', storedItemLocationId:'@storedItemLocationId', locationId:'@locationId', bagAndTagId:'@bagAndTagId'}},
        searchTransfers: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/search', method:'POST', params: {code:'@code'}, isArray: true},
        searchTransferBagAndTags: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/search-bag-and-tags', method:'POST', params: {code:'@code'}, isArray: true}

      });
    });
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('stockService', stockService);

  stockService.$inject = ['$q', 'SETTINGS', 'stockBackendService', 'urlHelperService'];

  function stockService($q, SETTINGS, stockBackendService, urlHelperService) {
    var service = {
      searchStockItems: searchStockItems,
      searchForPicklist: searchForPicklist,
      searchStockItemsManifest: searchStockItemsManifest,
      getStoredItemByMaterialCode: getStoredItemByMaterialCode,
      getMaterialDetailsByStoredItemId: getMaterialDetailsByStoredItemId,
      getStoredItemByBarcode: getStoredItemByBarcode,
      getStoredItemByStoredItemLocation: getStoredItemByStoredItemLocation,
      getCostCodes: getCostCodes,
      getIrcNumbers: getIrcNumbers,
      getPicklistItemsForIssue: getPicklistItemsForIssue,
      getPicklistBagAndTagItemsForIssue: getPicklistBagAndTagItemsForIssue,
      getRefNumbers: getRefNumbers,
      createOverShortDamaged: createOverShortDamaged,
      getImportTemplate: getImportTemplate,
      getImportErrors: getImportErrors
    };

    return service;

    ///////////////

    function searchStockItems(poNumbersSelected, materialCodesSelected, costCodesSelected, barcodesSelected, locationsSelected, issuesSelected, workpackNumbersSelected, filter, returnsOnly, warehouse) {
      var deferred = $q.defer();

      if (poNumbersSelected.length > 0 || materialCodesSelected.length > 0 || costCodesSelected.length > 0 || barcodesSelected.length > 0 || locationsSelected.length > 0 || issuesSelected.length > 0 || workpackNumbersSelected.length > 0 || filter.length > 0) {

        var poNumbers = urlHelperService.getSelectedValues(poNumbersSelected, 'number');
        var materialCodes = urlHelperService.getSelectedValues(materialCodesSelected, 'materialCode');
        var costCodes = urlHelperService.getSelectedValues(costCodesSelected, 'costCode');
        var barcodes = urlHelperService.getSelectedValues(barcodesSelected, 'barcode');
        var locations = urlHelperService.getSelectedValues(locationsSelected, 'id');
        var issues = urlHelperService.getSelectedValues(issuesSelected, 'id');
        var workpackNumbers = urlHelperService.getSelectedValues(workpackNumbersSelected, 'workpackNumber')

        var storedItemsSearchQuery = {
          poNumber: poNumbers,
          materialCode: materialCodes,
          costCode: costCodes,
          barcode: barcodes,
          location: locations,
          issue: issues,
          workpackNumber: workpackNumbers,
          filter: filter,
          warehouse: warehouse
        };

        (returnsOnly ? stockBackendService.searchForReturn : stockBackendService.search)
        ({code: SETTINGS.projectCode}, storedItemsSearchQuery, function (response) {
          deferred.resolve(response);
        }, function (error) {
          deferred.reject(error);
        });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }


    function searchForPicklist(poNumbersSelected, materialCodesSelected, costCodesSelected, barcodesSelected, filter) {
      var deferred = $q.defer();

      if (poNumbersSelected.length > 0 || materialCodesSelected.length > 0 || costCodesSelected.length > 0 || barcodesSelected.length > 0 || filter.length > 0) {

        var poNumbers = urlHelperService.getSelectedValues(poNumbersSelected, 'number');
        var materialCodes = urlHelperService.getSelectedValues(materialCodesSelected, 'materialCode');
        var costCodes = urlHelperService.getSelectedValues(costCodesSelected, 'costCode');
        var barcodes = urlHelperService.getSelectedValues(barcodesSelected, 'barcode');

        var storedItemsSearchQuery = {
          poNumber: poNumbers,
          materialCode: materialCodes,
          costCode: costCodes,
          barcode: barcodes,
          filter: filter
        };

        stockBackendService.searchForPicklist
        ({code: SETTINGS.projectCode}, storedItemsSearchQuery, function (response) {
          deferred.resolve(response);
        }, function (error) {
          deferred.reject(error);
        });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }


    function searchStockItemsManifest(poNumbersSelected, materialCodesSelected, costCodesSelected, barcodesSelected, issuesSelected,
                                      transfersSelected, deliveriesSelected, returnsSelected, filter) {
      var deferred = $q.defer();

      if (poNumbersSelected.length > 0 || materialCodesSelected.length > 0 || costCodesSelected.length > 0 || barcodesSelected.length > 0 ||
          issuesSelected.length > 0 || transfersSelected.length > 0 || deliveriesSelected.length > 0 ||
          returnsSelected.length > 0 ||filter.length > 0) {

        var poNumbers = urlHelperService.getSelectedValues(poNumbersSelected, 'number');
        var materialCodes = urlHelperService.getSelectedValues(materialCodesSelected, 'materialCode');
        var costCodes = urlHelperService.getSelectedValues(costCodesSelected, 'costCode');
        var barcodes = urlHelperService.getSelectedValues(barcodesSelected, 'barcode');
        var issues = urlHelperService.getSelectedValues(issuesSelected, 'id');
        var returns = urlHelperService.getSelectedValues(returnsSelected, 'id');
        var transfers = urlHelperService.getSelectedValues(transfersSelected, 'id');
        var deliveries = urlHelperService.getSelectedValues(deliveriesSelected, 'id');

        var storedItemsSearchQuery = {
          poNumber: poNumbers,
          materialCode: materialCodes,
          costCode: costCodes,
          barcode: barcodes,
          issue: issues,
          transfer: transfers,
          delivery: deliveries,
          return: returns,
          filter: filter
        };

        stockBackendService.searchManifest({code: SETTINGS.projectCode}, storedItemsSearchQuery, function (response) {
          deferred.resolve(response);
        }, function (error) {
          deferred.reject(error);
        });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    function getStoredItemByMaterialCode(materialCode){
      return stockBackendService.getStoredItemByMaterialCode({code:SETTINGS.projectCode, materialCode:materialCode}).$promise.then(function (response) {
        return response;
      });
    }

    function getMaterialDetailsByStoredItemId(storedItemId){
      return stockBackendService.getMaterialDetailsByStoredItemId({code:SETTINGS.projectCode, id:storedItemId}).$promise.then(function (response) {
        return response;
      });
    }

    function getStoredItemByBarcode(barcode){
      return stockBackendService.getStoredItemByBarcode({code:SETTINGS.projectCode, barcode:barcode}).$promise.then(function (response) {
        return response;
      })
    }

    function getStoredItemByStoredItemLocation(storedItemLocationId){
      return stockBackendService.getStoredItemByStoredItemLocation({code:SETTINGS.projectCode, storedItemLocationId:storedItemLocationId}).$promise.then(function (response) {
        return response;
      })
    }

    function getPicklistItemsForIssue(picklistId){
      return stockBackendService.getPicklistItemsForIssue({code:SETTINGS.projectCode, picklistId:picklistId}).$promise.then(function (response) {
        return response;
      });
    }

    function getPicklistBagAndTagItemsForIssue(picklistId){
      return stockBackendService.getPicklistBagAndTagItemsForIssue({code:SETTINGS.projectCode, picklistId:picklistId}).$promise.then(function (response) {
        return response;
      });
    }

    function getCostCodes(){
      return stockBackendService.getCostCodes({code:SETTINGS.projectCode}).$promise.then(function (response) {
        return response;
      });
    }

    function getIrcNumbers(){
      return stockBackendService.getIrcNumbers({code:SETTINGS.projectCode}).$promise.then(function (response) {
        return response;
      });
    }

    function getRefNumbers(hideIssue){
      var searchObject = {
        hideIssue: hideIssue
      };

      return stockBackendService.getRefNumbers({code:SETTINGS.projectCode}, searchObject).$promise.then(function (response) {
        return response;
      })
    }

    function createOverShortDamaged(id, itemToAdd){
      return stockBackendService.createOverShortDamaged({code:SETTINGS.projectCode, id:id}, itemToAdd).$promise.then(function (response) {
        return response;
      })
    }

    function getImportTemplate() {
      return stockBackendService.getImportTemplate({code: SETTINGS.projectCode}).$promise.then(function (response){
        return response;
      });
    }

    function getImportErrors(documentKey) {
      return stockBackendService.getImportErrors({code: SETTINGS.projectCode, key: documentKey}).$promise.then(function(response) {
        return response;
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('stockBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_WAREHOUSE + ':code/stored-items/:id', {code:'@code', id:'@id'}, {

        search: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/search', method:'POST', params:{code:'@code'}, isArray:true},
        searchForReturn: {url:API.BASE_URI_WAREHOUSE + ':code/returns/searchForReturn', method:'POST', params:{code:'@code'}, isArray:true},
        searchForPicklist: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/search-picklist', method:'POST', params:{code:'@code'}, isArray:true},
        searchManifest: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/search-manifest', method:'POST', params:{code:'@code'}},
        getStoredItemByMaterialCode: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/material-code/:materialCode', method: 'GET', params:{code:'@code', materialCode:'@materialCode'}},
        getMaterialDetailsByStoredItemId: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/details/:id', method: 'GET', params:{code:'@code', id:'@storedItemId'}},
        getStoredItemByBarcode: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/barcode/:barcode', method:'GET', params:{code:'@code', barcode:'@barcode'}},
        getStoredItemByStoredItemLocation: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/stored-item-location/:storedItemLocationId', method: 'GET', params:{code:'@code', storedItemLocationId:'@storedItemLocationId'}},
        getPicklistItemsForIssue: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/search-for-picklist/:picklistId', method: 'GET', params:{code:'@code', picklistId:'@picklistId'}, isArray:true},
        getPicklistBagAndTagItemsForIssue: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/search-for-picklist-bag-and-tag/:picklistId', method: 'GET', params:{code:'@code', picklistId:'@picklistId'}, isArray:true},
        getCostCodes: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/cost-codes', method: 'GET', params:{code:'@code'}, isArray:true},
        getIrcNumbers: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/irc-numbers', method: 'GET', params:{code:'@code'}, isArray:true},
        getRefNumbers: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/ref-numbers', method: 'POST', params:{code:'@code'}, isArray:true},
        createOverShortDamaged: {url:API.BASE_URI_WAREHOUSE + ':code/stored-items/:id/osd', method: 'POST', params:{code:'@code', id:'@id'}},

        getImportTemplate: {url: API.BASE_URI_WAREHOUSE + ':code/import-export/stock-balance-import-template', method:'GET', params:{code:'@code'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers){
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        },

        getImportErrors: {url: API.BASE_URI_WAREHOUSE + ':code/import-export/stock-balance-upload-errors/:key', method: 'GET', params: {code:'@code', key:'@key'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers){
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        }

      });

      function parseHeaderFilename(headers){
        var header = headers('Content-Disposition');
        var result = header.split(';')[1].trim().split('=')[1];
        return result.replace(/"/g, '');
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('searchService', searchService);

  searchService.$inject = ['$q','searchBackendService', 'authorizationService', 'SETTINGS'];

  function searchService($q, searchBackendService, authorizationService, SETTINGS) {

    var service = {
      searchDeliveries: searchDeliveries,
      searchIssues: searchIssues,
      searchIssueBagAndTags: searchIssueBagAndTags,
      searchReturns: searchReturns,
      searchReturnBagAndTags: searchReturnBagAndTags,
      searchManifest: searchManifest,
      searchManifestBagAndTags: searchManifestBagAndTags,
      searchTransfers: searchTransfers,
      searchTransferBagAndTags: searchTransferBagAndTags
    };

    return service;

    //////////////

    function searchDeliveries(data) {
      var deferred = $q.defer();

      searchBackendService.searchDeliveries({
        code: SETTINGS.projectCode
      }, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function searchTransfers(data) {
      var deferred = $q.defer();

      searchBackendService.searchTransfers({
        code: SETTINGS.projectCode
      }, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot search transfers.');
      });

      return deferred.promise;
    }

    function searchTransferBagAndTags(data) {
      var deferred = $q.defer();

      searchBackendService.searchTransferBagAndTags({
        code: SETTINGS.projectCode
      }, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot search transfers.');
      });

      return deferred.promise;
    }

    function searchIssues(data) {
      var deferred = $q.defer();

      searchBackendService.searchIssues({
        code: SETTINGS.projectCode
      }, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot search issues.');
      });

      return deferred.promise;
    }

    function searchIssueBagAndTags(data) {
      var deferred = $q.defer();

      searchBackendService.searchIssueBagAndTags({
        code: SETTINGS.projectCode
      }, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot search issues.');
      });

      return deferred.promise;
    }

    function searchReturns(data) {
      var deferred = $q.defer();

      searchBackendService.searchReturns({
        code: SETTINGS.projectCode
      }, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot search returns.');
      });

      return deferred.promise;
    }

    function searchReturnBagAndTags(data) {
      var deferred = $q.defer();

      searchBackendService.searchReturnBagAndTags({
        code: SETTINGS.projectCode
      }, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot search returns.');
      });

      return deferred.promise;
    }

    function searchManifest(data) {
      var deferred = $q.defer();

      searchBackendService.searchManifest({
        code: SETTINGS.projectCode
      }, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot search manifest.');
      });

      return deferred.promise;
    }

    function searchManifestBagAndTags(data) {
      var deferred = $q.defer();

      searchBackendService.searchManifestBagAndTags({
        code: SETTINGS.projectCode
      }, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot search manifest.');
      });

      return deferred.promise;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('searchBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_WAREHOUSE + 'transfers/:id', {id: '@id'}, {

        searchDeliveries: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/search', method:'POST', params: {code:'@code'}, isArray: true},
        searchTransfers: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/search', method:'POST', params: {code:'@code'}, isArray: true},
        searchTransferBagAndTags: {url:API.BASE_URI_WAREHOUSE + ':code/transfers/search-bag-and-tags', method:'POST', params: {code:'@code'}, isArray: true},
        searchIssues: {url:API.BASE_URI_WAREHOUSE + ':code/issues/search', method:'POST', params: {code:'@code'}, isArray: true},
        searchIssueBagAndTags: {url:API.BASE_URI_WAREHOUSE + ':code/issues/search-bag-and-tags', method:'POST', params: {code:'@code'}, isArray: true},
        searchReturns: {url:API.BASE_URI_WAREHOUSE + ':code/returns/search', method:'POST', params: {code:'@code'}, isArray: true},
        searchReturnBagAndTags: {url:API.BASE_URI_WAREHOUSE + ':code/returns/search-bag-and-tags', method:'POST', params: {code:'@code'}, isArray: true},
        searchManifest: {url:API.BASE_URI_SHIPPING + ':code/manifests/search', method:'POST', params:{code:'@code'}, isArray:true},
        searchManifestBagAndTags: {url:API.BASE_URI_SHIPPING + ':code/manifests/search-bag-and-tags', method:'POST', params:{code:'@code'}, isArray:true}
      });
    });
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('returnService', returnService);

  returnService.$inject = ['$q', 'returnBackendService', 'authorizationService', 'SETTINGS'];

  function returnService($q, returnBackendService, authorizationService, SETTINGS) {

    var service = {
      getReturn: getReturn,
      getReturnsCompleted: getReturnsCompleted,
      getReturnsIncomplete: getReturnsIncomplete,
      getReturnsIncompleteCount: getReturnsIncompleteCount,
      createReturn: createReturn,
      addItemToReturn: addItemToReturn,
      returnItems: returnItems,
      returnBagAndTagItems: returnBagAndTagItems,
      completeReturn: completeReturn,
      cancelReturn: cancelReturn,
      getReturnItems: getReturnItems,
      getReturnBagAndTagItems: getReturnBagAndTagItems,
      removeItemFromReturn: removeItemFromReturn,
      removeBagAndTagItemFromReturn: removeBagAndTagItemFromReturn,
    };

    return service;

    //////////////

    function getReturn(returnId) {
      var deferred = $q.defer();

      returnBackendService.getReturn({code: SETTINGS.projectCode, id: returnId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getReturnItems(returnId) {
      var deferred = $q.defer();

      returnBackendService.getReturnItems({code: SETTINGS.projectCode, id:returnId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getReturnBagAndTagItems(returnId) {
      var deferred = $q.defer();

      returnBackendService.getReturnBagAndTagItems({code: SETTINGS.projectCode, id:returnId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getReturnsCompleted() {
      var deferred = $q.defer();

      returnBackendService.getReturnsCompleted({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getReturnsIncomplete() {
      var deferred = $q.defer();

      returnBackendService.getReturnsIncomplete({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getReturnsIncompleteCount() {
      return returnBackendService.getReturnsIncompleteCount({code: SETTINGS.projectCode}).$promise;
    }

    function createReturn(theReturn) {
      var deferred = $q.defer();

      var newReturn = {
        id: '',
        description: theReturn.description
      };

      returnBackendService.createReturn({code:SETTINGS.projectCode}, newReturn, function(response){
        newReturn.id = response.returnId;
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot create return.');
      });

      return deferred.promise;
    }

    function addItemToReturn(returnId, storedItemLocationId, returnQuantity) {
      var deferred = $q.defer();

      var returnItem = {
        id: '',
        returnId: returnId,
        storedItemLocationId: storedItemLocationId,
        quantity: returnQuantity
      };

      returnBackendService.addItemToReturn({code:SETTINGS.projectCode, id:returnId}, returnItem, function(response) {
        returnItem.id = response.id;
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update return.');
      });

      return deferred.promise;
    }

    function returnItems(returnItems) {
      return returnBackendService.returnItems({code:SETTINGS.projectCode, id: returnItems.returnId}, returnItems).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update return.');
        return error;
      });
    }

    function returnBagAndTagItems(returnItems) {
      return returnBackendService.returnBagAndTagItems({code:SETTINGS.projectCode, id:returnItems.returnId}, returnItems).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update return.');
        return error;
      });
    }

    function completeReturn(returnId) {
      return returnBackendService.completeReturn({code:SETTINGS.projectCode, id:returnId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot complete return.');
        return error;
      });
    }

    function cancelReturn(returnId){
      return returnBackendService.cancelReturn({code:SETTINGS.projectCode, id:returnId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot cancel return.');
        return error;
      });
    }

    function removeItemFromReturn(returnId, storedItemLocationId, locationId, issueItemId) {
      return returnBackendService.removeItemFromReturn({code:SETTINGS.projectCode, id:returnId, storedItemLocationId:storedItemLocationId, locationId:locationId, issueItemId:issueItemId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update return.');
        return error;
      });
    }

    function removeBagAndTagItemFromReturn(returnId, bagAndTagReturnId) {
      return returnBackendService.removeBagAndTagItemFromReturn({code:SETTINGS.projectCode, id:returnId, bagAndTagReturnId:bagAndTagReturnId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update return.');
        return error;
      });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('returnBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_WAREHOUSE + 'returns/:id', {id: '@id'}, {

        getReturn: {url:API.BASE_URI_WAREHOUSE + ':code/returns/:id', method:'GET', params:{code:'@code', id:'@id'}},
        getReturnsCompleted: {url:API.BASE_URI_WAREHOUSE + ':code/returns/complete', method:'GET', params:{code:'@code'}, isArray:true},
        getReturnsIncomplete: {url:API.BASE_URI_WAREHOUSE + ':code/returns/incomplete', method:'GET', params:{code:'@code'}, isArray:true},
        getReturnsIncompleteCount: {url:API.BASE_URI_WAREHOUSE + ':code/returns/incomplete/count', method:'GET', params:{code:'@code'}},
        createReturn: {url:API.BASE_URI_WAREHOUSE + ':code/returns/', method:'POST', params:{code:'@code'}},
        completeReturn: {url:API.BASE_URI_WAREHOUSE + ':code/returns/:id/complete-return', method:'PUT', params:{code:'@code', id:'@id'}},
        cancelReturn: {url:API.BASE_URI_WAREHOUSE + ':code/returns/:id/cancel-return', method:'PUT', params:{code:'@code', id:'@id'}},
        returnItems: {url:API.BASE_URI_WAREHOUSE + ':code/returns/:id/return-items', method:'PUT', params:{code:'@code', id:'@id'}},
        getReturnItems: {url:API.BASE_URI_WAREHOUSE + ':code/returns/:id/return-items', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},
        getReturnBagAndTagItems: {url:API.BASE_URI_WAREHOUSE + ':code/returns/:id/return-bag-and-tag-items', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},
        addItemToReturn: {url:API.BASE_URI_WAREHOUSE + ':code/returns/:id/add-item', method:'PUT', params:{code:'@code', id:'@id'}},
        returnBagAndTagItems: {url:API.BASE_URI_WAREHOUSE + ':code/returns/:id/return-bag-and-tag-items', method:'PUT', params:{code:'@code', id:'@id'}},
        removeItemFromReturn: {url:API.BASE_URI_WAREHOUSE + ':code/returns/:id/return-items/:storedItemLocationId/:locationId/:issueItemId', method:'DELETE', params:{code:'@code', id:'@id', storedItemLocationId:'@storedItemLocationId', locationId:'@locationId', issueItemId:'@issueItemId'}},
        removeBagAndTagItemFromReturn: {url:API.BASE_URI_WAREHOUSE + ':code/returns/:id/bag-and-tags/:bagAndTagReturnId', method:'DELETE', params:{code:'@code', id:'@id', bagAndTagReturnId:'@bagAndTagReturnId'}}

      });
    });
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('reportingService', reportingService);

  reportingService.$inject = ['$q', 'reportingBackendService', 'SETTINGS', 'FileSaver', 'Blob'];

  function reportingService($q, reportingBackendService, SETTINGS, FileSaver, Blob) {

    var service = {
      prepAndRunReport: prepAndRunReport,
      runReport: runReport
    };

    return service;

    //////////////

    function prepAndRunReport(data) {
      return runReport(data)
        .then(function (response) {
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        }, function (error) {

        }
      );
    }

    function runReport(data) {
      var deferred = $q.defer();

      reportingBackendService.runReport({code: SETTINGS.projectCode}, data,
        function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('reportingBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_REPORTING + ':code/reporting/:id', {code:'@code', id:'@id'}, {

        runReport: {
          url: API.BASE_URI_REPORTING + ':code/reporting/run',
          method: 'POST',
          params: {code: '@code'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers) {
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        }
      });


      function parseHeaderFilename(headers){
        var header = headers('Content-Disposition');
        var result = header.split(';')[1].trim().split('=')[1];
        return result.replace(/"/g, '');
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('purchaseOrderService', purchaseOrderService);

  purchaseOrderService.$inject = ['$q','purchaseOrderBackendService', 'authorizationService', 'SETTINGS'];

  function purchaseOrderService($q, purchaseOrderBackendService, authorizationService, SETTINGS) {

    var service = {
      createPurchaseOrder: createPurchaseOrder,
      getSuppliers: getSuppliers,
      getMaterials: getMaterials,
      getCostCodes: getCostCodes,
      getIncompletePurchaseOrders: getIncompletePurchaseOrders,
      getCompletePurchaseOrders: getCompletePurchaseOrders,
      getPurchaseOrder: getPurchaseOrder,
      getPurchaseOrderComments: getPurchaseOrderComments,
      addPurchaseOrderComment: addPurchaseOrderComment,
      getPurchaseOrderLineComments: getPurchaseOrderLineComments,
      addPurchaseOrderLineComment: addPurchaseOrderLineComment,
      getUnitsOfMeasure: getUnitsOfMeasure,
      getCurrencyCodes: getCurrencyCodes,
      createPurchaseOrderLine: createPurchaseOrderLine,
      deletePurchaseOrderLine: deletePurchaseOrderLine,
      cancelPurchaseOrder: cancelPurchaseOrder,
      completePurchaseOrder: completePurchaseOrder,
      getPurchaseOrderLine: getPurchaseOrderLine,
      getImportTemplate: getImportTemplate,
      getImportErrors: getImportErrors,
      getPurchaseOrderLines: getPurchaseOrderLines,
      getPurchaseOrderFromOracle: getPurchaseOrderFromOracle,
      getPurchaseOrderQueryStatus: getPurchaseOrderQueryStatus,
      getPurchaseOrderLineHistory: getPurchaseOrderLineHistory,
      updatePOLineReceivability : updatePOLineReceivability,
      getReceiptsIncompleteCount: getReceiptsIncompleteCount,
      getReceiptsIncomplete: getReceiptsIncomplete,
      getReceiptedPurchaseOrderLines: getReceiptedPurchaseOrderLines
    };

    return service;

    //////////////////

    function createPurchaseOrder(purchaseOrder) {
      var deferred = $q.defer();
      purchaseOrderBackendService.createPurchaseOrder({code: SETTINGS.projectCode}, purchaseOrder, function (response) {
        deferred.resolve(response);
      }, function(error){
        deferred.reject(error);
        authorizationService.error(error, 'Cannot create non-PO receipt.');
      });
      return deferred.promise;
    }

    function getSuppliers(){
      return purchaseOrderBackendService.getSuppliers({code: SETTINGS.projectCode}).$promise.then(function (response){
        return response;
      });
    }

    function getMaterials(){
      return purchaseOrderBackendService.getMaterials({code: SETTINGS.projectCode}).$promise.then(function (response){
        return response;
      });
    }

    function getCostCodes(){
      return purchaseOrderBackendService.getCostCodes({code: SETTINGS.projectCode}).$promise.then(function (response){
        return response;
      });
    }

    function getIncompletePurchaseOrders(){
      return purchaseOrderBackendService.getIncompletePurchaseOrders({code: SETTINGS.projectCode}).$promise.then(function (response) {
        return response;
      });
    }

    function getCompletePurchaseOrders(){
      return purchaseOrderBackendService.getCompletePurchaseOrders({code: SETTINGS.projectCode}).$promise.then(function (response) {
        return response;
      });
    }

    function getPurchaseOrder(id) {
      return purchaseOrderBackendService.getPurchaseOrder({code: SETTINGS.projectCode, id: id}).$promise.then(function (response) {
        return response;
      });
    }

    function getPurchaseOrderComments(id) {
      return purchaseOrderBackendService.getPurchaseOrderComments({code: SETTINGS.projectCode, id: id}).$promise.then(function (response) {
        return response;
      });
    }

    function addPurchaseOrderComment(id, item) {
      return purchaseOrderBackendService.addPurchaseOrderComment({code: SETTINGS.projectCode, id: id}, item).$promise.then(function (response) {
        return response;
      });
    }

    function getPurchaseOrderLineComments(id) {
      return purchaseOrderBackendService.getPurchaseOrderLineComments({code: SETTINGS.projectCode, id: id}).$promise.then(function (response) {
        return response;
      });
    }

    function addPurchaseOrderLineComment(id, item) {
      return purchaseOrderBackendService.addPurchaseOrderLineComment({code: SETTINGS.projectCode, id: id}, item).$promise.then(function (response) {
        return response;
      });
    }

    function getUnitsOfMeasure() {
      return purchaseOrderBackendService.getUnitsOfMeasure({code: SETTINGS.projectCode}).$promise.then(function (response) {
        return response;
      });
    }

    function getCurrencyCodes() {
      return purchaseOrderBackendService.getCurrencyCodes({code: SETTINGS.projectCode}).$promise.then(function (response) {
        return response;
      });
    }

    function createPurchaseOrderLine(purchaseOrderId, lineItem) {
      var data = {
        materialCode: lineItem.materialCode,
        costCode: lineItem.costCode,
        description: lineItem.description,
        quantity: lineItem.quantity,
        unitOfMeasureCode: lineItem.unitOfMeasureCode,
        receivingTolerance: lineItem.receivingTolerance,
        unitPrice: lineItem.price,
        currencyCode: lineItem.currencyCode
      };
      var deferred = $q.defer();
      purchaseOrderBackendService.createPurchaseOrderLine({code: SETTINGS.projectCode, id: purchaseOrderId}, data, function (response) {
        deferred.resolve(response);
      }, function(error){
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update non-PO receipt.');
      });
      return deferred.promise;      
    }

    function deletePurchaseOrderLine(purchaseOrderId, lineItemId) {
      var deferred = $q.defer();
      purchaseOrderBackendService.deletePurchaseOrderLine({code: SETTINGS.projectCode, id: purchaseOrderId, itemId: lineItemId}, function (response) {
        deferred.resolve(response);
      }, function(error){
        deferred.reject(error);
        authorizationService.error(error, 'Cannot delete non-PO receipt.');
      });
      return deferred.promise;
    }

    function cancelPurchaseOrder(purchaseOrderId) {
      var deferred = $q.defer();
      purchaseOrderBackendService.cancelPurchaseOrder({code: SETTINGS.projectCode, id: purchaseOrderId}, function (response) {
        deferred.resolve(response);
      }, function(error){
        deferred.reject(error);
        authorizationService.error(error, 'Cannot cancel non-PO receipt.');
      });
      return deferred.promise;
    }

    function completePurchaseOrder(purchaseOrderId) {
      var deferred = $q.defer();
      purchaseOrderBackendService.completePurchaseOrder({code: SETTINGS.projectCode, id: purchaseOrderId}, function (response) {
        deferred.resolve(response);
      }, function(error){
        deferred.reject(error);
        authorizationService.error(error, 'Cannot complete non-PO receipt.');
      });
      return deferred.promise;
    }

    function getPurchaseOrderLine(purchaseOrderId, lineItemId) {
      return purchaseOrderBackendService.getPurchaseOrderLine({code: SETTINGS.projectCode, id: purchaseOrderId, itemId: lineItemId}).$promise.then(function (response) {
        return response;
      });
    }

    function getImportTemplate() {
      return purchaseOrderBackendService.getImportTemplate({code: SETTINGS.projectCode}).$promise.then(function (response){
        return response;
      });
    }

    function getImportErrors(parentId, documentKey) {
      return purchaseOrderBackendService.getImportErrors({code: SETTINGS.projectCode, key: documentKey}).$promise.then(function(response) {
        return response;
      });
    }

    function getPurchaseOrderLines(id, includeQuantities) {
      return purchaseOrderBackendService.getPurchaseOrderLines({code: SETTINGS.projectCode, id: id, includeQuantities:includeQuantities}).$promise.then(function(response) {
        return response;
      });
    }

    function getPurchaseOrderFromOracle(purchaseOrderNumber) {
      var data = {
        purchaseOrderNumber: purchaseOrderNumber
      };
      return purchaseOrderBackendService.getPurchaseOrderFromOracle({code: SETTINGS.projectCode}, data).$promise.then(function(response) {
        return response;
      });
    }

    function getPurchaseOrderQueryStatus(id, purchaseOrderNumber) {
      var data = {
        id: id,
        purchaseOrderNumber: purchaseOrderNumber
      };
      return purchaseOrderBackendService.getPurchaseOrderQueryStatus({code: SETTINGS.projectCode}, data).$promise.then(function(response) {
        return response;
      });
    }

    function getPurchaseOrderLineHistory(id, itemId) {
      return purchaseOrderBackendService.getPurchaseOrderLineHistory({code: SETTINGS.projectCode, id: id, itemId: itemId}).$promise.then(function(response) {
        return response;
      })
    }

    function updatePOLineReceivability(purchaseOrderLine) {
      return (purchaseOrderLine.isNonReceivable ? purchaseOrderBackendService.setPurchaseOrderLineNonReceivable : purchaseOrderBackendService.setPurchaseOrderLineReceivable )
      ({
        code: SETTINGS.projectCode,
        id: purchaseOrderLine.purchaseOrderLineId
      }, purchaseOrderLine).$promise.then(function (response) {
        return response;
      }, function(error) {
        authorizationService.error(error, 'Cannot change receivability of PO line.');
        return error;
      });
    }

    function getReceiptsIncompleteCount(){
      return purchaseOrderBackendService.getReceiptsIncompleteCount({code: SETTINGS.projectCode}).$promise.then(function(response) {
        return response;
      });
    }

    function getReceiptsIncomplete(filter){
      var data = {
        filter: filter
      };
      return purchaseOrderBackendService.getReceiptsIncomplete({code: SETTINGS.projectCode}, data).$promise.then(function(response) {
        return response;
      });
    }

    function getReceiptedPurchaseOrderLines(purchaseOrderId){
      return purchaseOrderBackendService.getReceiptedPurchaseOrderLines({code: SETTINGS.projectCode, id: purchaseOrderId}).$promise.then(function(response){
        return response;
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('purchaseOrderBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_PURCHASING + ':code/purchase-orders/:id', {code:'@code', id:'@id'}, {

        createPurchaseOrder: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/create/', method: 'POST', params:{code: '@code'}},
        getSuppliers: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/suppliers', method: 'GET', params:{code: '@code'}, isArray: true},
        getMaterials: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/materials', method: 'GET', params:{code: '@code'}, isArray: true},
        getCostCodes: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/costCodes', method: 'GET', params:{code: '@code'}, isArray: true},
        getIncompletePurchaseOrders: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/incomplete', method: 'GET', params:{code: '@code'}, isArray: true},
        getCompletePurchaseOrders: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/complete', method: 'GET', params:{code: '@code'}, isArray: true},
        getPurchaseOrder: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/:id', method: 'GET', params:{code: '@code', id: '@id'}},
        getPurchaseOrderComments: {url: API.BASE_URI_WAREHOUSE + ':code/purchase-orders/:id/comments', method: 'GET', params:{code: '@code', id: '@id'}, isArray: true},
        addPurchaseOrderComment: {url: API.BASE_URI_WAREHOUSE + ':code/purchase-orders/:id/add-comment', method: 'PUT', params:{code: '@code', id: '@id'}},
        getPurchaseOrderLineComments: {url: API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/:id/comments', method: 'GET', params:{code: '@code', id: '@id'}, isArray: true},
        addPurchaseOrderLineComment: {url: API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/:id/add-comment', method: 'PUT', params:{code: '@code', id: '@id'}},
        getUnitsOfMeasure: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/uom', method: 'GET', params:{code: '@code'}, isArray: true},
        getCurrencyCodes: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/currency', method: 'GET', params:{code: '@code'}, isArray: true},
        createPurchaseOrderLine: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/:id/create-line', method: 'POST', params:{code: '@code', id: '@id'}},
        deletePurchaseOrderLine: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/:id/delete/:itemId', method: 'DELETE', params:{code: '@code', id: '@id', itemId: '@itemId'}},
        cancelPurchaseOrder: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/:id/cancel', method: 'PUT', params:{code: '@code', id: '@id'}},
        completePurchaseOrder: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/:id/complete', method: 'PUT', params:{code: '@code', id: '@id'}},
        getPurchaseOrderLine: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/:id/line-item/:itemId', method: 'GET', params:{code: '@code', id: '@id', itemId: '@itemId'}},
        getPurchaseOrderLines: {url: API.BASE_URI_WAREHOUSE + ':code/purchase-orders/:id/lines/:includeQuantities', method: 'GET', params:{code:'@code', id:'@id', includeQuantities:'@includeQuantities'}, isArray: true},
        getPurchaseOrderLineHistory: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/:id/line-item/:itemId/history', method: 'GET', params:{code: '@code', id: '@id', itemId: '@itemId'}, isArray: true},

        setPurchaseOrderLineNonReceivable: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/:id/non-receivable', method:'PUT', params: {code:'@code', id: '@id'}},
        setPurchaseOrderLineReceivable: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/:id/non-receivable', method:'DELETE', params: {code:'@code', id: '@id'}},
        getReceiptsIncompleteCount: {url:API.BASE_URI_PURCHASING + ':code/purchase-orders/receipts-incomplete/count', method:'GET', params: {code:'@code'}},
        getReceiptsIncomplete: {url:API.BASE_URI_PURCHASING + ':code/purchase-orders/receipts-incomplete', method:'POST', params: {code:'@code'}, isArray: true},
        getReceiptedPurchaseOrderLines: {url:API.BASE_URI_PURCHASING + ':code/purchase-orders/receipts-incomplete/:id/line-items', method:'GET', params: {code:'@code', id:'@id'}, isArray: true},

        getImportTemplate: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/import-template', method:'GET', params:{code:'@code'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers){
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        },

        getImportErrors: {url: API.BASE_URI_PURCHASING + ':code/purchase-orders/upload-errors/:key', method: 'GET', params: {code:'@code', key:'@key'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers){
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        },

        getPurchaseOrderFromOracle: {url: API.BASE_URI_WAREHOUSE + ':code/purchase-orders', method:'POST', params:{code:'@code'}},
        getPurchaseOrderQueryStatus: {url: API.BASE_URI_WAREHOUSE + ':code/purchase-orders/query-status', method:'POST', params:{code:'@code'}}

      });

      function parseHeaderFilename(headers){
        var header = headers('Content-Disposition');
        var result = header.split(';')[1].trim().split('=')[1];
        return result.replace(/"/g, '');
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('projectService', projectService);

  projectService.$inject = ['$q', '$filter', '$localStorage', 'projectBackendService', 'authorizationService', 'SETTINGS'];

  function projectService($q, $filter, $localStorage, projectBackendService, authorizationService, SETTINGS) {

    var service = {
      getProject: getProject,
      getProjectStock: getProjectStock,
      createProject: createProject,
      getProjects: getProjects,
      getProjectsExcludeCurrent: getProjectsExcludeCurrent,
      getProjectsStock: getProjectsStock,
      getProjectByCode: getProjectByCode,
      updateProject: updateProject
    };

    return service;

    ////////////

    function getProject(projectId) {

      var deferred = $q.defer();

      projectBackendService.getProject({id: projectId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getProjectStock(projectId, projectCode) {

      var deferred = $q.defer();

      projectBackendService.getProjectStock({code: projectCode, id: projectId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function createProject(project) {

      var deferred = $q.defer();

      var newProject = {
        id: '',
        name: project.name,
        code: project.code,        
        client: project.client,
        currencyCode: project.currencyCode,
        startDate: project.startDate,
        endDate: project.endDate,
        subProject: project.subProject,
        allowLabelPrinting: project.allowLabelPrinting,
        expenditureOrgCode: project.expenditureOrgCode,
        operatingUnitCode: project.operatingUnitCode,        
        enableSync: project.enableSync
      };

      projectBackendService.createProject({}, newProject, function (response) {
        deferred.resolve(response);        
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function updateProject(project) {
      var deferred = $q.defer();

      projectBackendService.updateProject({id: project.id}, project, function(response){      
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });
      
      return deferred.promise;
    }

    function getProjects(filterByUser) {
      var projects = [];

      return projectBackendService.getProjects().$promise.then(function (response) {
        projects = response;        

        if (filterByUser) {
          var result = [];
          if ($localStorage.permissions !== undefined) {
            var userProjects = $filter('filter')($localStorage.permissions.project);
            if (isArray(userProjects)) {
              angular.forEach(userProjects, function (code) {
                var project = $filter('filter')(projects, {code: code});
                if (project.length > 0)
                  result.push(project[0]);
              });
            } else {
              var project = $filter('filter')(projects, {code: userProjects});
              result.push(project[0]);
            }
            return result;
          }
        }
        return projects;
      });
    }

    function getProjectsExcludeCurrent() {
      var projects = [];

      return projectBackendService.getProjects().$promise.then(function (response) {
        projects = response;

        for (var i = projects.length - 1; i >= 0; i--) {
          if (projects[i].code == SETTINGS.projectCode) {
            projects.splice(i, 1);
          }
        }

        return projects;
      });
    }

    function getProjectsStock() {
      var deferred = $q.defer();

      projectBackendService.getProjectsStock({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getProjectByCode() {
      return projectBackendService.getProjectByCode({code: SETTINGS.projectCode}).$promise.then(function (response) {
        return response;
      });
    }

    function isArray(obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('projectBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_PROJECT + 'projects/:id', {id:'@id'}, {

        getProject: {url:API.BASE_URI_PROJECT + 'projects/:id', method:'GET', params: {id: '@id'}},
        getProjectStock: {url:API.BASE_URI_WAREHOUSE + ':code/projects/:id', method:'GET', params: {code:'@code', id: '@id'}},
        createProject: {url:API.BASE_URI_PROJECT + 'projects', method:'POST'},
        updateProject: {url:API.BASE_URI_PROJECT + 'projects/:id', method:'POST', params: {id: '@id'}},
        getProjects: {url:API.BASE_URI_PROJECT + 'projects', method:'GET', isArray: true},
        getProjectsStock: {url:API.BASE_URI_WAREHOUSE + ':code/projects', method:'GET', params: {code:'@code'}, isArray: true},
        getProjectByCode: {url:API.BASE_URI_WAREHOUSE + ':code/projects/code', method:'GET', params: {code:'@code'}}

      });
  });


})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('picklistService', picklistService);

  picklistService.$inject = ['$q', 'picklistBackendService', 'authorizationService', 'SETTINGS'];

  function picklistService($q, picklistBackendService, authorizationService, SETTINGS) {

    var service = {
      getPicklist: getPicklist,
      getPicklistsCompleted: getPicklistsCompleted,
      getPicklistsPicking: getPicklistsPicking,
      getPicklistsPickingCount: getPicklistsPickingCount,
      getPicklistsIncomplete: getPicklistsIncomplete,
      getPicklistsIncompleteCount: getPicklistsIncompleteCount,
      createPicklist: createPicklist,
      reopenPicklist: reopenPicklist,
      addItemToPicklist: addItemToPicklist,
      addBagAndTagToPicklist: addBagAndTagToPicklist,
      picklistItems: picklistItems,
      returnBagAndTagItems: returnBagAndTagItems,
      completePicklist: completePicklist,
      cancelPicklist: cancelPicklist,
      getPicklistItems: getPicklistItems,
      getPicklistBagAndTagItems: getPicklistBagAndTagItems,
      removeItemFromPicklist: removeItemFromPicklist,
      removeBagAndTagFromPicklist: removeBagAndTagFromPicklist
    };

    return service;

    //////////////

    function getPicklist(picklistId) {
      var deferred = $q.defer();

      picklistBackendService.getPicklist({code: SETTINGS.projectCode, id: picklistId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getPicklistItems(picklistId) {
      var deferred = $q.defer();

      picklistBackendService.getPicklistItems({code: SETTINGS.projectCode, id:picklistId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function reopenPicklist(picklistId) {
 var deferred = $q.defer();
 picklistBackendService.reopenPicklist(
   { code: SETTINGS.projectCode, id: picklistId },
   function (response) {
     deferred.resolve(response);
   },
   function (error) {
     deferred.reject(error);
     authorizationService.error(error, 'Cannot reopen picklist.');
   }
 );
 return deferred.promise;
}

    function getPicklistBagAndTagItems(picklistId) {
      var deferred = $q.defer();

      picklistBackendService.getPicklistBagAndTagItems({code: SETTINGS.projectCode, id:picklistId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getPicklistsCompleted() {
      var deferred = $q.defer();

      picklistBackendService.getPicklistsCompleted({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getPicklistsPicking() {
      var deferred = $q.defer();

      picklistBackendService.getPicklistsPicking({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getPicklistsPickingCount(){
      return picklistBackendService.getPicklistsPickingCount({code: SETTINGS.projectCode}).$promise;
    }

    function getPicklistsIncomplete() {
      var deferred = $q.defer();

      picklistBackendService.getPicklistsIncomplete({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getPicklistsIncompleteCount() {
      return picklistBackendService.getPicklistsIncompleteCount({code: SETTINGS.projectCode}).$promise;
    }

    function createPicklist(thePicklist) {
      var deferred = $q.defer();

      var newPicklist = {
        id: '',
        description: thePicklist.description
      };

      picklistBackendService.createPicklist({code:SETTINGS.projectCode}, newPicklist, function(response){
        newPicklist.id = response.picklistId;
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot create picklist.');
      });

      return deferred.promise;
    }

    function addItemToPicklist(picklistId, storedItemId, quantity) {
      var deferred = $q.defer();

      var picklistItem = {
        id: '',
        picklistId: picklistId,
        storedItemId: storedItemId,
        quantity: quantity
      };

      picklistBackendService.addItemToPicklist({code:SETTINGS.projectCode, id:picklistId}, picklistItem, function(response) {
        picklistItem.id = response.id;
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update picklist.');
      });

      return deferred.promise;
    }

    function addBagAndTagToPicklist(picklistId, bagAndTagId) {
      var deferred = $q.defer();

      var data = {
        id: '',
        bagAndTagId: bagAndTagId
      };

      picklistBackendService.addBagAndTagToPicklist({code:SETTINGS.projectCode, id:picklistId}, data, function(response) {
        data.id = response.id;
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update picklist.');
      });

      return deferred.promise;
    }

    function picklistItems(picklistItems) {
      return picklistBackendService.picklistItems({code:SETTINGS.projectCode, id: picklistItems.picklistId}, picklistItems).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update picklist.');
        return error;
      });
    }

    function returnBagAndTagItems(picklistItems) {
      return picklistBackendService.returnBagAndTagItems({code:SETTINGS.projectCode, id:picklistItems.picklistId}, picklistItems).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update picklist.');
        return error;
      });
    }

    function completePicklist(picklistId) {
      return picklistBackendService.completePicklist({code:SETTINGS.projectCode, id:picklistId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot complete picklist.');
        return error;
      });
    }

    function cancelPicklist(picklistId){
      return picklistBackendService.cancelPicklist({code:SETTINGS.projectCode, id:picklistId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot cancel picklist.');
        return error;
      });
    }

    function removeItemFromPicklist(picklistId, storedItemId) {
      return picklistBackendService.removeItemFromPicklist({code:SETTINGS.projectCode, id:picklistId, storedItemId:storedItemId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update picklist.');
        return error;
      });
    }

    function removeBagAndTagFromPicklist(picklistId, bagAndTagId) {
      return picklistBackendService.removeBagAndTagFromPicklist({code:SETTINGS.projectCode, id:picklistId, bagAndTagId:bagAndTagId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update picklist.');
        return error;
      });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('picklistBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_WAREHOUSE + 'picklists/:id', {id: '@id'}, {

        getPicklist: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/:id', method:'GET', params:{code:'@code', id:'@id'}},
        getPicklistsCompleted: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/complete', method:'GET', params:{code:'@code'}, isArray:true},
        getPicklistsPicking: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/picking', method:'GET', params:{code:'@code'}, isArray:true},
        getPicklistsPickingCount: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/picking/count', method:'GET', params:{code:'@code'}},
        getPicklistsIncomplete: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/incomplete', method:'GET', params:{code:'@code'}, isArray:true},
        getPicklistsIncompleteCount: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/incomplete/count', method:'GET', params:{code:'@code'}},
        createPicklist: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/', method:'POST', params:{code:'@code'}},
        completePicklist: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/:id/complete-picklist', method:'PUT', params:{code:'@code', id:'@id'}},
        cancelPicklist: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/:id/cancel-picklist', method:'PUT', params:{code:'@code', id:'@id'}},
        picklistItems: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/:id/picklist-items', method:'PUT', params:{code:'@code', id:'@id'}},
        getPicklistItems: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/:id/picklist-items', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},
        getPicklistBagAndTagItems: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/:id/bag-and-tags', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},
        addItemToPicklist: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/:id/add-item', method:'PUT', params:{code:'@code', id:'@id'}},
        addBagAndTagToPicklist: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/:id/add-bag-and-tag', method:'PUT', params:{code:'@code', id:'@id'}},
        reopenPicklist: {url: API.BASE_URI_WAREHOUSE + ':code/picklists/:id/reopen-picklist', method: 'PUT', params: {code:'@code',id:'@id'}},
        returnBagAndTagItems: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/:id/picklist-bag-and-tag-items', method:'PUT', params:{code:'@code', id:'@id'}},
        removeItemFromPicklist: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/:id/picklist-items/:storedItemId', method:'DELETE', params:{code:'@code', id:'@id', storedItemId:'@storedItemId'}},
        removeBagAndTagFromPicklist: {url:API.BASE_URI_WAREHOUSE + ':code/picklists/:id/bag-and-tags/:bagAndTagId', method:'DELETE', params:{code:'@code', id:'@id', bagAndTagId:'@bagAndTagId'}}

      });
    });
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('movementService', movementService);

  movementService.$inject = ['$q', 'movementBackendService', 'authorizationService', 'urlHelperService', 'SETTINGS'];

  function movementService($q, movementBackendService, authorizationService, urlHelperService, SETTINGS) {

    var service = {
      getMovement: getMovement,
      getMovementsCompleted: getMovementsCompleted,
      getMovementsIncomplete: getMovementsIncomplete,
      getMovementsIncompleteCount: getMovementsIncompleteCount,
      getMovementsDelivery: getMovementsDelivery,
      createMovement: createMovement,
      addItemToMovement: addItemToMovement,
      movementItems: movementItems,
      completeMovement: completeMovement,
      cancelMovement: cancelMovement,
      getMovementItems: getMovementItems,
      removeItemFromMovement: removeItemFromMovement,
      searchMovementItems : searchMovementItems
    };

    return service;

    //////////////

    function getMovement(movementId) {
      var deferred = $q.defer();

      movementBackendService.getMovement({code: SETTINGS.projectCode, id: movementId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getMovementItems(movementId) {
      var deferred = $q.defer();

      movementBackendService.getMovementItems({code: SETTINGS.projectCode, id:movementId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }


    function getMovementsCompleted() {
      var deferred = $q.defer();

      movementBackendService.getMovementsCompleted({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getMovementsIncomplete() {
      var deferred = $q.defer();

      movementBackendService.getMovementsIncomplete({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getMovementsIncompleteCount() {
      return movementBackendService.getMovementsIncompleteCount({code: SETTINGS.projectCode}).$promise;
    }

    function getMovementsDelivery() {
      var deferred = $q.defer();

      movementBackendService.getMovementsDelivery({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function createMovement(theMovement) {
      var deferred = $q.defer();

      var newMovement = {
        id: '',
        description: theMovement.description,
        warehouseId: theMovement.warehouseId,
        newProjectId: theMovement.newProjectId
      };

      movementBackendService.createMovement({code:SETTINGS.projectCode}, newMovement, function(response){
        newMovement.id = response.movementId;
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot create movement.');
      });

      return deferred.promise;
    }

    function addItemToMovement(movementId, storedItemLocationId, quantity) {
      var deferred = $q.defer();

      var movementItem = {
        id: '',
        movementId: movementId,
        storedItemLocationId: storedItemLocationId,
        quantity: quantity
      };

      movementBackendService.addItemToMovement({code:SETTINGS.projectCode, id:movementId}, movementItem, function(response) {
        movementItem.id = response.id;
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update movement.');
      });

      return deferred.promise;
    }


    function movementItems(movementItems) {
      return movementBackendService.movementItems({code:SETTINGS.projectCode, id: movementItems.movementId}, movementItems).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update movement.');
        return error;
      });
    }

    function returnBagAndTagItems(movementItems) {
      return movementBackendService.returnBagAndTagItems({code:SETTINGS.projectCode, id:movementItems.movementId}, movementItems).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update movement.');
        return error;
      });
    }

    function completeMovement(movementId) {
      return movementBackendService.completeMovement({code:SETTINGS.projectCode, id:movementId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot complete movement.');
        return error;
      });
    }

    function cancelMovement(movementId){
      return movementBackendService.cancelMovement({code:SETTINGS.projectCode, id:movementId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot cancel movement.');
        return error;
      });
    }

    function removeItemFromMovement(movementId, storedItemLocationId) {
      return movementBackendService.removeItemFromMovement({code:SETTINGS.projectCode, id:movementId, storedItemLocationId:storedItemLocationId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update movement.');
        return error;
      });
    }

    function searchMovementItems(movementsSelected, filter) {
      var deferred = $q.defer();

      if (movementsSelected.length > 0 || filter.length > 0) {

        var movements = urlHelperService.getSelectedValues(movementsSelected, 'number');

        var searchQuery = {
          movement: movements,
          filter: filter
        };

        movementBackendService.searchMovementItems({
          code: SETTINGS.projectCode
        }, searchQuery, function (response) {
          deferred.resolve(response);
        }, function (error) {
          deferred.reject(error);
        });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('movementBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_WAREHOUSE + 'movements/:id', {id: '@id'}, {

        getMovement: {url:API.BASE_URI_WAREHOUSE + ':code/movements/:id', method:'GET', params:{code:'@code', id:'@id'}},
        getMovementsCompleted: {url:API.BASE_URI_WAREHOUSE + ':code/movements/complete', method:'GET', params:{code:'@code'}, isArray:true},
        getMovementsIncomplete: {url:API.BASE_URI_WAREHOUSE + ':code/movements/incomplete', method:'GET', params:{code:'@code'}, isArray:true},
        getMovementsIncompleteCount: {url:API.BASE_URI_WAREHOUSE + ':code/movements/incomplete/count', method:'GET', params:{code:'@code'}},
        getMovementsDelivery: {url:API.BASE_URI_WAREHOUSE + ':code/movements/delivery', method:'GET', params:{code:'@code'}, isArray:true},
        createMovement: {url:API.BASE_URI_WAREHOUSE + ':code/movements/', method:'POST', params:{code:'@code'}},
        completeMovement: {url:API.BASE_URI_WAREHOUSE + ':code/movements/:id/complete-movement', method:'PUT', params:{code:'@code', id:'@id'}},
        cancelMovement: {url:API.BASE_URI_WAREHOUSE + ':code/movements/:id/cancel-movement', method:'PUT', params:{code:'@code', id:'@id'}},
        movementItems: {url:API.BASE_URI_WAREHOUSE + ':code/movements/:id/movement-items', method:'PUT', params:{code:'@code', id:'@id'}},
        getMovementItems: {url:API.BASE_URI_WAREHOUSE + ':code/movements/:id/movement-items', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},
        addItemToMovement: {url:API.BASE_URI_WAREHOUSE + ':code/movements/:id/add-item', method:'PUT', params:{code:'@code', id:'@id'}},
        removeItemFromMovement: {url:API.BASE_URI_WAREHOUSE + ':code/movements/:id/movement-items/:storedItemLocationId', method:'DELETE', params:{code:'@code', id:'@id', storedItemLocationId:'@storedItemLocationId'}},
        searchMovementItems: {url:API.BASE_URI_WAREHOUSE + ':code/movements/movement-items/search', method:'POST', params:{code:'@code'}, isArray:true},
      });
    });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('minMaxService', minMaxService);

  minMaxService.$inject = ['$q', 'minMaxBackendService', 'authorizationService', 'SETTINGS'];

  function minMaxService($q, minMaxBackendService, authorizationService, SETTINGS) {

    var service = {
      addMinMaxMaterialCode: addMinMaxMaterialCode,
      getMinMaxItems: getMinMaxItems,
      updateMinMaxMaterialCode: updateMinMaxMaterialCode,
      deleteMinMaxMaterialCode: deleteMinMaxMaterialCode,
      getImportTemplate: getImportTemplate,
      getImportErrors: getImportErrors,
      getMinMaxExport: getMinMaxExport,
      setActive: setActive,
      getReorderedMinMaxItems: getReorderedMinMaxItems,
      getNotOrderedMinMaxItems: getNotOrderedMinMaxItems,
      getIncompleteMinMaxItems: getIncompleteMinMaxItems,
      getIncompleteMinMaxItemsCount: getIncompleteMinMaxItemsCount,
      reorder: reorder,
      dismiss: dismiss
    };

    return service;

    ///////////////////////

    function addMinMaxMaterialCode(item) {
      var deferred = $q.defer();

      minMaxBackendService.addMinMaxMaterialCode({code:SETTINGS.projectCode}, item, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot add min/mix material code.');
      });

      return deferred.promise;
    }

    function getMinMaxItems() {
      return minMaxBackendService.getMinMaxItems({code:SETTINGS.projectCode}).$promise.then(function(response) {
        return response;
      });
    }

    function updateMinMaxMaterialCode(item) {
      var data = {
        minQuantity: item.minQuantity,
        maxQuantity: item.maxQuantity,
        reorderQuantity: item.reorderQuantity,
        isActive: item.isActive
      };

      return minMaxBackendService.updateMinMaxMaterialCode({code:SETTINGS.projectCode, id: item.id}, data).$promise.then(function(response) {
        return response;
      });
    }

    function setActive(item) {
      var data = {
        isActive: item.isActive
      };

      return minMaxBackendService.updateMinMaxMaterialCode({code:SETTINGS.projectCode, id: item.id}, data).$promise.then(function(response) {
        return response;
      });
    }

    function deleteMinMaxMaterialCode(id) {
      return minMaxBackendService.deleteMinMaxMaterialCode({code:SETTINGS.projectCode, id: id}).$promise.then(function(response) {
        return response;
      });
    }

    function getReorderedMinMaxItems() {
      return minMaxBackendService.getReorderedMinMaxItems({code: SETTINGS.projectCode}).$promise.then(function(response) {
        return response;
      });
    }

    function getNotOrderedMinMaxItems() {
      return minMaxBackendService.getNotOrderedMinMaxItems({code: SETTINGS.projectCode}).$promise.then(function(response) {
        return response;
      });
    }

    function getIncompleteMinMaxItems() {
      return minMaxBackendService.getIncompleteMinMaxItems({code: SETTINGS.projectCode}).$promise.then(function(response) {
        return response;
      });
    }

    function getIncompleteMinMaxItemsCount() {
      return minMaxBackendService.getIncompleteMinMaxItemsCount({code: SETTINGS.projectCode}).$promise;
    }

    function getImportTemplate() {
      return minMaxBackendService.getImportTemplate({code: SETTINGS.projectCode}).$promise.then(function (response){
        return response;
      });
    }

    function getImportErrors(documentKey) {
      return minMaxBackendService.getImportErrors({code: SETTINGS.projectCode, key: documentKey}).$promise.then(function(response) {
        return response;
      });
    }

    function getMinMaxExport() {
      return minMaxBackendService.getMinMaxExport({code: SETTINGS.projectCode}).$promise.then(function(response) {
        return response;
      });
    }

    function reorder(item) {
      var data = {
        buyerEmployeeId: item.buyerEmployeeId,
        materialMinMaxItems: item.actionItems,
        comments: item.comments
      };

      return minMaxBackendService.reorder({code:SETTINGS.projectCode}, data).$promise.then(function(response) {
        return response;
      });
    }

    function dismiss(item) {
      var data = {
        materialMinMaxItems: item.actionItems,
        comments: item.comments
      };

      return minMaxBackendService.dismiss({code:SETTINGS.projectCode}, data).$promise.then(function(response) {
        return response;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('minMaxBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_WAREHOUSE + 'min-max/:id', {id: '@id'}, {

        getMinMax: { url: API.BASE_URI_WAREHOUSE + ':code/material-min-max/:id', method: 'GET', params: {code: '@code', id: '@id'}},
        getMinMaxItems: { url: API.BASE_URI_WAREHOUSE + ':code/material-min-max/', method: 'GET', params: {code: '@code'}, isArray: true},
        addMinMaxMaterialCode: { url: API.BASE_URI_WAREHOUSE + ':code/material-min-max/', method: 'POST', params: {code: '@code'}},
        updateMinMaxMaterialCode: { url: API.BASE_URI_WAREHOUSE + ':code/material-min-max/:id', method: 'PUT', params: {code: '@code', id: '@id'}},
        deleteMinMaxMaterialCode: { url: API.BASE_URI_WAREHOUSE + ':code/material-min-max/:id', method: 'DELETE', params: {code: '@code', id: '@id'}},
        getReorderedMinMaxItems: {url:API.BASE_URI_WAREHOUSE + ':code/material-min-max/reordered', method:'GET', params: {code:'@code'}, isArray: true},
        getNotOrderedMinMaxItems: {url:API.BASE_URI_WAREHOUSE + ':code/material-min-max/not-ordered', method:'GET', params: {code:'@code'}, isArray: true},
        getIncompleteMinMaxItems: {url:API.BASE_URI_WAREHOUSE + ':code/material-min-max/incomplete', method:'GET', params: {code:'@code'}, isArray: true},
        getIncompleteMinMaxItemsCount: {url:API.BASE_URI_WAREHOUSE + ':code/material-min-max/incomplete/count', method:'GET', params: {code:'@code'}},
        reorder: {url:API.BASE_URI_WAREHOUSE + ':code/material-min-max/reorder', method:'PUT', params: {code:'@code'}},
        dismiss: {url:API.BASE_URI_WAREHOUSE + ':code/material-min-max/dismiss', method:'PUT', params: {code:'@code'}},

        getImportTemplate: {url: API.BASE_URI_WAREHOUSE + ':code/import-export/min-max-import-template', method:'GET', params:{code:'@code'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers){
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        },

        getImportErrors: {url: API.BASE_URI_WAREHOUSE + ':code/import-export/min-max-upload-errors/:key', method: 'GET', params: {code:'@code', key:'@key'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers){
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        },

        getMinMaxExport: {url: API.BASE_URI_WAREHOUSE + ':code/import-export/export-min-max', method:'GET', params:{code:'@code'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers){
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        }

      });

      function parseHeaderFilename(headers){
        var header = headers('Content-Disposition');
        var result = header.split(';')[1].trim().split('=')[1];
        return result.replace(/"/g, '');
      }
    });
})();

(function(){
  'use strict';

  angular
    .module('app.services')
    .factory('materialAllocationService', materialAllocationService);

  materialAllocationService.$inject = ['$q', 'materialAllocationBackendService', 'authorizationService', 'urlHelperService', 'SETTINGS', 'API'];

  function materialAllocationService($q, materialAllocationBackendService, authorizationService, urlHelperService, SETTINGS, API) {

    var service = {
      getDemand: getDemand,
      getConstructionWorkpacks: getConstructionWorkpacks,
      getConstructionWorkpack: getConstructionWorkpack,
      getConstructionWorkpackDemandTotals: getConstructionWorkpackDemandTotals,
      createConstructionWorkpack: createConstructionWorkpack,
      updateConstructionWorkpack: updateConstructionWorkpack,
      deleteConstructionWorkpack: deleteConstructionWorkpack,
      getAllocationActivity: getAllocationActivity,
      priorityChanged: priorityChanged,
      getImportTemplate: getImportTemplate,
      getImportErrors: getImportErrors
    };

    return service;

    ////////////////////////

    function getDemand(demandId) {
      var deferred = $q.defer();

      materialAllocationBackendService.getDemand({projectId: SETTINGS.projectId, id: demandId}, function(response){
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getConstructionWorkpacks(){
      var deferred = $q.defer();

      materialAllocationBackendService.getConstructionWorkpacks({projectId: SETTINGS.projectId}, function(response){
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getConstructionWorkpack(id){
      var deferred = $q.defer();

      materialAllocationBackendService.getConstructionWorkpack({projectId: SETTINGS.projectId, id: id}, function(response){
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getConstructionWorkpackDemandTotals(id, jobNumber){
      var deferred = $q.defer();

      materialAllocationBackendService.getConstructionWorkpackDemandTotals({projectId: SETTINGS.projectId, id:id, jobNumber: jobNumber}, function(response){
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function createConstructionWorkpack(demand) {
      var deferred = $q.defer();

      var newDemand = {
        id: '',
        number: demand.number,
        description: demand.description,
        jobNumber: demand.jobNumber
      };

      materialAllocationBackendService.createConstructionWorkpack({projectId: SETTINGS.projectId}, newDemand, function(response){
        newDemand.id = response.demandId;
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot create material allocation');
      });

      return deferred.promise;
    }

    function updateConstructionWorkpack(demand) {
      var deferred = $q.defer();

      materialAllocationBackendService.updateConstructionWorkpack({projectId: SETTINGS.projectId}, demand, function(response){
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update material allocation');
      });

      return deferred.promise;
    }

    function deleteConstructionWorkpack(id) {
      var deferred = $q.defer();

      materialAllocationBackendService.deleteConstructionWorkpack({projectId: SETTINGS.projectId, id: id}, function(response){
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot delete material allocation');
      });

      return deferred.promise;
    }

    function getAllocationActivity() {
      var deferred = $q.defer();

      materialAllocationBackendService.getAllocationActivity({projectId: SETTINGS.projectId}, function(response){
        deferred.resolve(response);
      }, function(error){
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function priorityChanged(model) {
      var deferred = $q.defer();

      materialAllocationBackendService.priorityChanged({projectId: SETTINGS.projectId}, model, function(response){
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot change material allocation priority');
      });

      return deferred.promise;
    }

    function getImportTemplate() {
      return materialAllocationBackendService.getImportTemplate({projectId: SETTINGS.projectId}).$promise.then(function(response) {
        return response;
      });
    }

    function getImportErrors(documentKey) {
      return materialAllocationBackendService.getImportErrors({projectId: SETTINGS.projectId, key: documentKey}).$promise.then(function(response) {
        return response;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('materialAllocationBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_MATERIALALLOCATION + 'demand/:id', {id: '@id'}, {

        getDemand: {url:API.BASE_URI_MATERIALALLOCATION + ':projectId/demand/:id', method:'GET', params:{projectId:'@projectId', id:'@id'}},
        getConstructionWorkpacks: {url:API.BASE_URI_MATERIALALLOCATION + ':projectId/demand/construction-workpacks', method:'GET', params:{projectId:'@projectId'}},
        getConstructionWorkpack: {url:API.BASE_URI_MATERIALALLOCATION + ':projectId/demand/construction-workpack/:id', method:'GET', params:{projectId:'@projectId', id:'@id'}},
        getConstructionWorkpackDemandTotals: {url:API.BASE_URI_MATERIALALLOCATION + ':projectId/demand/construction-workpack-demand-totals/:id', method:'GET', params:{projectId:'@projectId', id:'@id'}},
        createConstructionWorkpack: {url:API.BASE_URI_MATERIALALLOCATION + ':projectId/demand/create-construction-workpack', method:'POST', params:{projectId:'@projectId'}},
        updateConstructionWorkpack: {url:API.BASE_URI_MATERIALALLOCATION + ':projectId/demand/update-construction-workpack', method:'PUT', params:{projectId:'@projectId'}},
        deleteConstructionWorkpack: {url:API.BASE_URI_MATERIALALLOCATION + ':projectId/demand/delete-construction-workpack/:id', method:'DELETE', params:{projectId:'@projectId', id:'@id'}},
        getAllocationActivity: {url:API.BASE_URI_MATERIALALLOCATION + ':projectId/activity', method:'GET', params:{projectId:'@projectId'}},
        priorityChanged: {url:API.BASE_URI_MATERIALALLOCATION + ':projectId/demand/priority-changed', method:'POST', params:{projectId:'@projectId'}},

        getImportTemplate: {url:API.BASE_URI_MATERIALALLOCATION + ':projectId/demand/import-template', method:'GET', params:{projectId:'@projectId'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers){
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        },

        getImportErrors: {url:API.BASE_URI_MATERIALALLOCATION + ':projectId/demand/upload-errors/:key', method:'GET', params:{projectId:'@projectId', key:'@key'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers){
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        }

      });

      function parseHeaderFilename(headers){
        var header = headers('Content-Disposition');
        var result = header.split(';')[1].trim().split('=')[1];
        return result.replace(/"/g, '');
      }
    })
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('manifestService', manifestService);

  manifestService.$inject = ['$q', 'manifestBackendService', 'authorizationService', 'SETTINGS', 'urlHelperService','$odataresource', '$odata', 'API'];

  function manifestService($q, manifestBackendService, authorizationService, SETTINGS, urlHelperService, $odataresource, $odata, API) {

    var service = {
      getManifest: getManifest,
      getManifestsCompleted: getManifestsCompleted,
      getManifestsIncomplete: getManifestsIncomplete,
      getManifestsIncompleteCount: getManifestsIncompleteCount,
      createManifest: createManifest,
      addItemToManifest: addItemToManifest,
      addItemsToManifest: addItemsToManifest,
      editManifestRow: editManifestRow,
      addBagAndTagToManifest: addBagAndTagToManifest,
      addBagAndTagsToManifest: addBagAndTagsToManifest,
      returnItems: returnItems,
      returnBagAndTagItems: returnBagAndTagItems,
      completeManifest: completeManifest,
      cancelManifest: cancelManifest,
      getManifestItems: getManifestItems,
      getManifestBagAndTagItems: getManifestBagAndTagItems,
      removeItemFromManifest: removeItemFromManifest,
      removeBagAndTagItemFromManifest: removeBagAndTagItemFromManifest,
      getReferenceData: getReferenceData,
      getAddresses: getAddresses,
      getAddress: getAddress,
      createAddress: createAddress,
      updateAddress: updateAddress,
      deleteAddress: deleteAddress,
      searchAddresses: searchAddresses,
      getShippingNotes: getShippingNotes,
      getShippingNote: getShippingNote,
      createShippingNote: createShippingNote,
      updateShippingNote: updateShippingNote,
      deleteShippingNote: deleteShippingNote,
      saveShippingDetails: saveShippingDetails,
      saveCustomsStatus: saveCustomsStatus,
      saveShippingAddress: saveShippingAddress,
      addContainer: addContainer,
      searchManifestRows: searchManifestRows,
      getImportTemplate: getImportTemplate,
      getImportErrors: getImportErrors,
      getManifestTypes: getManifestTypes,
      updateManifestType: updateManifestType,
      getAgents: getAgents,
      getAgent: getAgent,
      deleteAgent: deleteAgent,
      createAgent: createAgent,
      updateAgent: updateAgent,
      reopenManifest: reopenManifest
    };

    return service;

    //////////////

    function getManifest(manifestId) {
      var deferred = $q.defer();

      manifestBackendService.getManifest({code: SETTINGS.projectCode, id: manifestId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getManifestItems(manifestId) {
      var deferred = $q.defer();

      manifestBackendService.getManifestItems({code: SETTINGS.projectCode, id:manifestId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getManifestBagAndTagItems(manifestId) {
      var deferred = $q.defer();

      manifestBackendService.getManifestBagAndTagItems({code: SETTINGS.projectCode, id:manifestId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getManifestsCompleted() {
      var deferred = $q.defer();

      manifestBackendService.getManifestsCompleted({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getManifestsIncomplete() {
      var deferred = $q.defer();

      manifestBackendService.getManifestsIncomplete({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getManifestsIncompleteCount() {
      return manifestBackendService.getManifestsIncompleteCount({code: SETTINGS.projectCode}).$promise;
    }

    function createManifest(theManifest) {
      var deferred = $q.defer();

      var newManifest = {
        id: '',
        description: theManifest.description,
        manifestTypeId: theManifest.manifestTypeId
      };

      manifestBackendService.createManifest({code:SETTINGS.projectCode}, newManifest, function(response){
        newManifest.id = response.manifestId;
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot create manifest.');
      });

      return deferred.promise;
    }

    function addItemToManifest(manifestId, item) {
      var deferred = $q.defer();

      manifestBackendService.addItemToManifest({code:SETTINGS.projectCode, id:manifestId}, item, function(response) {
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update manifest.');
      });

      return deferred.promise;
    }

    function addItemsToManifest(items) {
      var deferred = $q.defer();

      manifestBackendService.addItemsToManifest({ code: SETTINGS.projectCode, id: items.id },items,function(response) {
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update manifest.');
      });
   
      return deferred.promise;
    }

    function editManifestRow(manifestId, item) {
      var deferred = $q.defer();

      manifestBackendService.editManifestRow({code:SETTINGS.projectCode, id:manifestId}, item, function(response) {
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update manifest.');
      });

      return deferred.promise;
    }

    function addBagAndTagToManifest(manifestId, itemToAdd) {
      var deferred = $q.defer();

      manifestBackendService.addBagAndTagToManifest({code:SETTINGS.projectCode, id:manifestId}, itemToAdd, function(response) {
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update manifest.');
      });

      return deferred.promise;
    }

    function addBagAndTagsToManifest(manifestId, itemsToAdd) {
      var deferred = $q.defer();

      manifestBackendService.addBagAndTagsToManifest({code:SETTINGS.projectCode, id:manifestId}, itemsToAdd, function(response) {
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update manifest.');
      });

      return deferred.promise;
    }

    function returnItems(returnItems) {
      var deferred = $q.defer();

      manifestBackendService.returnItems({ code: SETTINGS.projectCode, id: returnItems.manifestId },returnItems,function(response) {
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update manifest.');
      });

      return deferred.promise;
    }

    function returnBagAndTagItems(returnItems) {
      var deferred = $q.defer();

      manifestBackendService.returnBagAndTagItems({ code: SETTINGS.projectCode, id: returnItems.manifestId },returnItems,function(response) {
        deferred.resolve(response);
      }, function(error) {
       deferred.reject(error);
       authorizationService.error(error, 'Cannot update manifest.');
      });
      
      return deferred.promise;
    }

    function completeManifest(manifestId) {
      var deferred = $q.defer();
 
      manifestBackendService.completeManifest({ code: SETTINGS.projectCode, id: manifestId },function(response) {
        deferred.resolve(response);
     },  function(error) {
       deferred.reject(error);
       authorizationService.error(error, 'Cannot complete manifest.');
     });

     return deferred.promise;
    }

    function cancelManifest(manifestId) {
      var deferred = $q.defer();
 
      manifestBackendService.cancelManifest({ code: SETTINGS.projectCode, id: manifestId },function(response) {
        deferred.resolve(response);
     },    function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot cancel manifest.');
      });

      return deferred.promise;
    }

    function reopenManifest(manifestId) {
      var deferred = $q.defer();

      manifestBackendService.reopenManifest({ code: SETTINGS.projectCode, id: manifestId },function(response) {
        deferred.resolve(response);
     },function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot reopen manifest.');
      });

      return deferred.promise;
    }

    function removeItemFromManifest(manifestId, itemToRemove) {
      var deferred = $q.defer();

      manifestBackendService.removeItemFromManifest({ code: SETTINGS.projectCode, id: manifestId },itemToRemove,function(response) {
        deferred.resolve(response);
      },  function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update manifest.');
      });

      return deferred.promise;
    }

    function removeBagAndTagItemFromManifest(manifestId, itemToRemove) {
      var deferred = $q.defer();

      manifestBackendService.removeBagAndTagItemFromManifest({ code: SETTINGS.projectCode, id: manifestId },itemToRemove,function(response) {
        deferred.resolve(response);
      },   function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update manifest.');
      });

      return deferred.promise;
    }

    function getImportTemplate() {
      return manifestBackendService.getImportTemplate({code: SETTINGS.projectCode}).$promise.then(function(response) {
        return response;
      });
    }

    function getImportErrors(manifestId, documentKey) {
      return manifestBackendService.getImportErrors({code: SETTINGS.projectCode, id: manifestId, key: documentKey}).$promise.then(function(response) {
        return response;
      });
    }

    function getReferenceData(data) {
      var deferred = $q.defer();

      manifestBackendService.getReferenceData({code: SETTINGS.projectCode}, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getAddresses() {
      var deferred = $q.defer();

      manifestBackendService.getAddresses({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getAddress(addressId) {
      var deferred = $q.defer();

      manifestBackendService.getAddress({code: SETTINGS.projectCode, id : addressId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function createAddress(address) {
      var deferred = $q.defer();

      manifestBackendService.createAddress({code: SETTINGS.projectCode}, address, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function updateAddress(address) {
      var deferred = $q.defer();

      manifestBackendService.updateAddress({code: SETTINGS.projectCode, id : address.id}, address, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function deleteAddress(addressId) {
      var deferred = $q.defer();

      manifestBackendService.deleteAddress({code: SETTINGS.projectCode, id : addressId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function searchAddresses(searchParams){
      var deferred = $q.defer();

      var all = $odataresource(API.BASE_URI_SHIPPING + 'odata/Addresses', {}, {}, { isodatav4 : true });

      var predicates = [];

      searchParams.searchTerm.split(" ").forEach(function (item) {

        var fields = ['address1','address2','address3','address4', 'postCode', 'telephoneNo', 'faxNo', 'vatNo', 'vatDefNo', 'country'];

        var combination = getPredicates(fields, item);

        predicates.push(combination);
      });

      var andPredicate = $odata.Predicate.and(predicates);

      all.odata().filter("isDeleted", false).filter(andPredicate).orderBy('address1').query(function(data){
        deferred.resolve(data);
      }, function(error){
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getPredicates(fields, item){

      var combo = [];

      angular.forEach(fields, function(value, key) {
        var predicate = new $odata.Func('contains', value, item);
        combo.push(predicate);
      });

      return $odata.Predicate.or(combo);
    }

    function getShippingNotes() {
      var deferred = $q.defer();

      manifestBackendService.getShippingNotes({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getShippingNote(noteId) {
      var deferred = $q.defer();

      manifestBackendService.getShippingNote({code: SETTINGS.projectCode, id : noteId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function createShippingNote(note) {
      var deferred = $q.defer();

      manifestBackendService.createShippingNote({code: SETTINGS.projectCode}, note, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function updateShippingNote(note) {
      var deferred = $q.defer();

      manifestBackendService.updateShippingNote({code: SETTINGS.projectCode, id : note.id}, note, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function deleteShippingNote(noteId) {
      var deferred = $q.defer();

      manifestBackendService.deleteShippingNote({code: SETTINGS.projectCode, id : noteId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function saveShippingDetails(manifestId, data) {
      var deferred = $q.defer();

      manifestBackendService.saveShippingDetails({code: SETTINGS.projectCode, id:manifestId}, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function saveCustomsStatus(manifestId, data) {
      var deferred = $q.defer();

      manifestBackendService.saveCustomsStatus({code: SETTINGS.projectCode, id:manifestId}, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function saveShippingAddress(manifestId, data) {
      var deferred = $q.defer();

      manifestBackendService.saveShippingAddress({code: SETTINGS.projectCode, id:manifestId}, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function addContainer(manifestId, data) {
      var deferred = $q.defer();

      manifestBackendService.addContainer({code: SETTINGS.projectCode, id:manifestId}, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function searchManifestRows(poNumbersSelected, materialCodesSelected, costCodesSelected, barcodesSelected, manifestsSelected, filter) {
      var deferred = $q.defer();

      if (poNumbersSelected.length > 0 || materialCodesSelected.length > 0 || costCodesSelected.length > 0 || barcodesSelected.length > 0 ||
        manifestsSelected.length > 0 || filter.length > 0) {

        var poNumbers = urlHelperService.getSelectedValues(poNumbersSelected, 'number');
        var materialCodes = urlHelperService.getSelectedValues(materialCodesSelected, 'materialCode');
        var costCodes = urlHelperService.getSelectedValues(costCodesSelected, 'costCode');
        var barcodes = urlHelperService.getSelectedValues(barcodesSelected, 'barcode');
        var manifests = urlHelperService.getSelectedValues(manifestsSelected, 'manifestNumber');

        var searchQuery = {
          poNumber: poNumbers,
          materialCode: materialCodes,
          costCode: costCodes,
          barcode: barcodes,
          documentNumber: '~',
          manifest: manifests,
          filter: filter
        };

        manifestBackendService.searchManifestRows({
          code: SETTINGS.projectCode
        }, searchQuery, function (response) {
          deferred.resolve(response);
        }, function (error) {
          deferred.reject(error);
        });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    function getManifestTypes() {
      var deferred = $q.defer();

      manifestBackendService.getManifestTypes({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function updateManifestType(manifestId, manifestTypeId) {
      var deferred = $q.defer();

      manifestBackendService.updateManifestType({ code: SETTINGS.projectCode, id: manifestId }, {manifestTypeId : manifestTypeId }, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getAgents() {
      var deferred = $q.defer();

      manifestBackendService.getAgents({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function deleteAgent(agentId) {
      var deferred = $q.defer();

      manifestBackendService.deleteAgent({code: SETTINGS.projectCode, id : agentId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function createAgent(agent) {
      var deferred = $q.defer();

      manifestBackendService.createAgent({code: SETTINGS.projectCode}, agent, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function updateAgent(agent) {
      var deferred = $q.defer();

      manifestBackendService.updateAgent({code: SETTINGS.projectCode, id : agent.id}, agent, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getAgent(agentId) {
      var deferred = $q.defer();

      manifestBackendService.getAgent({code: SETTINGS.projectCode, id : agentId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }


  }


})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('manifestBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_SHIPPING + 'manifests/:id', {id: '@id'}, {

        getManifest: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id', method:'GET', params:{code:'@code', id:'@id'}},
        getManifestsCompleted: {url:API.BASE_URI_SHIPPING + ':code/manifests/complete', method:'GET', params:{code:'@code'}, isArray:true},
        getManifestsIncomplete: {url:API.BASE_URI_SHIPPING + ':code/manifests/incomplete', method:'GET', params:{code:'@code'}, isArray:true},
        getManifestsIncompleteCount: {url:API.BASE_URI_SHIPPING + ':code/manifests/incomplete/count', method:'GET', params:{code:'@code'}},

        createManifest: {url:API.BASE_URI_SHIPPING + ':code/manifests/', method:'POST', params:{code:'@code'}},
        completeManifest: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/complete-manifest', method:'PUT', params:{code:'@code', id:'@id'}},
        cancelManifest: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/cancel-manifest', method:'PUT', params:{code:'@code', id:'@id'}},
        reopenManifest: { url: API.BASE_URI_SHIPPING + ':code/manifests/:id/reopen-manifest', method: 'PUT',params: {code: '@code',id: '@id'}},

        getManifestItems: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/manifest-items', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},
        getManifestBagAndTagItems: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/manifest-bag-and-tags', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},

        addItemToManifest: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/add-item', method:'PUT', params:{code:'@code', id:'@id'}},
        addItemsToManifest: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/add-items', method:'PUT', params:{code:'@code', id:'@id'}},
        editManifestRow: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/edit-item', method:'PUT', params:{code:'@code', id:'@id'}},
        addBagAndTagToManifest: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/add-bag-and-tag', method:'PUT', params:{code:'@code', id:'@id'}},
        addBagAndTagsToManifest: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/add-bag-and-tags', method:'PUT', params:{code:'@code', id:'@id'}},

        removeItemFromManifest: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/remove-item', method:'PUT', params:{code:'@code', id:'@id'}},
        removeBagAndTagItemFromManifest: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/remove-bag-and-tag', method:'PUT', params:{code:'@code', id:'@id'}},

        getReferenceData: {url:API.BASE_URI_SHIPPING + ':code/manifests/reference-data', method:'POST', params:{code:'@code'}, isArray:true},

        getAddresses: {url:API.BASE_URI_SHIPPING + ':code/manifests/addresses', method:'GET', params:{code:'@code'}, isArray:true},
        getAddress: {url:API.BASE_URI_SHIPPING + ':code/manifests/addresses/:id', method:'GET', params:{code:'@code', id:'@id'}},
        createAddress: {url:API.BASE_URI_SHIPPING + ':code/manifests/addresses', method:'POST', params:{code:'@code'}},
        updateAddress: {url:API.BASE_URI_SHIPPING + ':code/manifests/addresses/:id', method:'PUT', params:{code:'@code', id:'@id'}},
        deleteAddress: {url:API.BASE_URI_SHIPPING + ':code/manifests/addresses/:id', method:'DELETE', params:{code:'@code', id:'@id'}},

        getShippingNotes: {url:API.BASE_URI_SHIPPING + ':code/manifests/shipping-notes', method:'GET', params:{code:'@code'}, isArray:true},
        getShippingNote: {url:API.BASE_URI_SHIPPING + ':code/manifests/shipping-notes/:id', method:'GET', params:{code:'@code', id:'@id'}},
        createShippingNote: {url:API.BASE_URI_SHIPPING + ':code/manifests/shipping-notes', method:'POST', params:{code:'@code'}},
        updateShippingNote: {url:API.BASE_URI_SHIPPING + ':code/manifests/shipping-notes/:id', method:'PUT', params:{code:'@code', id:'@id'}},
        deleteShippingNote: {url:API.BASE_URI_SHIPPING + ':code/manifests/shipping-notes/:id', method:'DELETE', params:{code:'@code', id:'@id'}},

        getAgents: {url:API.BASE_URI_SHIPPING + ':code/manifests/agents', method:'GET', params:{code:'@code'}, isArray:true},
        getAgent: {url:API.BASE_URI_SHIPPING + ':code/manifests/agents/:id', method:'GET', params:{code:'@code', id:'@id'}},
        createAgent: {url:API.BASE_URI_SHIPPING + ':code/manifests/agents', method:'POST', params:{code:'@code'}},
        updateAgent: {url:API.BASE_URI_SHIPPING + ':code/manifests/agents/:id', method:'PUT', params:{code:'@code', id:'@id'}},
        deleteAgent: {url:API.BASE_URI_SHIPPING + ':code/manifests/agents/:id', method:'DELETE', params:{code:'@code', id:'@id'}},

        saveShippingDetails: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/shipping-details', method:'POST', params:{code:'@code', id:'@id'}},
        saveCustomsStatus: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/customs-status', method:'POST', params:{code:'@code', id:'@id'}},
        saveShippingAddress: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/shipping-address', method:'POST', params:{code:'@code', id:'@id'}},
        addContainer: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/add-container', method:'POST', params:{code:'@code', id:'@id'}},

        searchManifestRows: {url:API.BASE_URI_SHIPPING + ':code/manifests/search-manifest', method:'POST', params:{code:'@code'}, isArray:true},

        getManifestTypes: {url:API.BASE_URI_SHIPPING + ':code/manifests/types', method:'GET', params:{code:'@code'}, isArray:true},
        updateManifestType: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/update-type', method:'PUT', params:{code:'@code', id:'@id'}},

        getImportTemplate: {url:API.BASE_URI_SHIPPING + ':code/manifests/import-template', method:'GET', params:{code:'@code'},
            responseType: 'arraybuffer',
            transformResponse: function (data, headers){
                return {
                  data: data,
                  filename: parseHeaderFilename(headers)
                };
            }
        },

        getImportErrors: {url:API.BASE_URI_SHIPPING + ':code/manifests/:id/upload-errors/:key', method:'GET', params:{code:'@code', id:'@id', key:'@key'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers){
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        }

      });

      function parseHeaderFilename(headers){
        var header = headers('Content-Disposition');
        var result = header.split(';')[1].trim().split('=')[1];
        return result.replace(/"/g, '');
      }
    });
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('issueService', issueService);

  issueService.$inject = ['$q', 'issueBackendService', 'authorizationService', 'SETTINGS'];

  function issueService($q, issueBackendService, authorizationService, SETTINGS) {

    var service = {
      getIssue: getIssue,
      getIssuesCompleted: getIssuesCompleted,
      getIssuesIncomplete: getIssuesIncomplete,
      getIssuesIncompleteCount: getIssuesIncompleteCount,
      createIssue: createIssue,
      updateIssue: updateIssue,
      addItemToIssue: addItemToIssue,
      addIssueItems: addIssueItems,
      addBagAndTagToIssue: addBagAndTagToIssue,
      completeIssue: completeIssue,
      cancelIssue: cancelIssue,
      getIssueItems: getIssueItems,
      getIssueBagAndTagItems: getIssueBagAndTagItems,
      removeItemFromIssue: removeItemFromIssue,
      removeBagAndTagFromIssue: removeBagAndTagFromIssue,
      updateItemToIssue : updateItemToIssue
    };

    return service;

    //////////////

    function getIssue(issueId) {
      var deferred = $q.defer();

      issueBackendService.getIssue({code: SETTINGS.projectCode, id: issueId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getIssueItems(issueId) {
      var deferred = $q.defer();

      issueBackendService.getIssueItems({code: SETTINGS.projectCode, id:issueId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getIssueBagAndTagItems(issueId) {
      var deferred = $q.defer();

      issueBackendService.getIssueBagAndTagItems({code: SETTINGS.projectCode, id:issueId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getIssuesCompleted() {
      var deferred = $q.defer();

      issueBackendService.getIssuesCompleted({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getIssuesIncomplete() {
      var deferred = $q.defer();

      issueBackendService.getIssuesIncomplete({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getIssuesIncompleteCount() {
      return issueBackendService.getIssuesIncompleteCount({code: SETTINGS.projectCode}).$promise;
    }

    function createIssue(issue) {
      var deferred = $q.defer();

      var newIssue = {
        id: '',
        description: issue.description,
        costCode: issue.costCode,
        picklistId: issue.picklistId,
        defaultRefNo: issue.defaultRefNo
      };

      issueBackendService.createIssue({code:SETTINGS.projectCode}, newIssue, function(response){
        newIssue.id = response.issueId;
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot create issue.');
      });

      return deferred.promise;
    }

    function updateIssue(issue) {
      var deferred = $q.defer();

      issueBackendService.updateIssue({code:SETTINGS.projectCode, id:issue.id}, issue, function(response){
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot edit issue.');
      });

      return deferred.promise;
    }

    function addIssueItems(items) { 
      var deferred = $q.defer();
      
      issueBackendService.addIssueItems({code:SETTINGS.projectCode, id:items.id}, items, function(response) {
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update issue.');        
      });     

      return deferred.promise;
    }

    function addItemToIssue(issueId, storedItemLocationId, issueQuantity, refNo) {
      var deferred = $q.defer();

      var issueItem = {
        id: '',
        issueId: issueId,
        storedItemLocationId: storedItemLocationId,
        quantity: issueQuantity,
        defaultRefNo: refNo
      };

      issueBackendService.addItemToIssue({code:SETTINGS.projectCode, id:issueId}, issueItem, function(response) {
        issueItem.id = response.id;
        deferred.resolve(response);        
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update issue.');
      });

      return deferred.promise;
    }
    
    function updateItemToIssue(issueId, storedItemLocationId, issueQuantity) {
      var deferred = $q.defer();

      var issueItem = {        
        issueId: issueId,
        storedItemLocationId: storedItemLocationId,
        quantity: issueQuantity
      };

      issueBackendService.updateItemToIssue({code:SETTINGS.projectCode, id:issueId}, issueItem, function(response) {
        issueItem.id = response.id;
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update issue.');
      });

      return deferred.promise;
    }

    function addBagAndTagToIssue(issueId, bagAndTagId) {
      var deferred = $q.defer();

      var data = {
        id: '',
        bagAndTagId: bagAndTagId
      };

      issueBackendService.addBagAndTagToIssue({code:SETTINGS.projectCode, id:issueId}, data, function(response) {
        data.id = response.id;
        deferred.resolve(response);
      }, function(error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update issue.');
      });

      return deferred.promise;
    }

    function completeIssue(issueId) {
      return issueBackendService.completeIssue({code:SETTINGS.projectCode, id:issueId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot complete issue.');
        return error;
      });
    }

    function cancelIssue(issueId){
      return issueBackendService.cancelIssue({code:SETTINGS.projectCode, id:issueId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot cancel issue.');
        return error;
      });
    }

    function removeItemFromIssue(issueId, storedItemLocationId) {
      return issueBackendService.removeItemFromIssue({code:SETTINGS.projectCode, id:issueId, storedItemLocationId:storedItemLocationId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update issue.');
        return error;
      });
    }

    function removeBagAndTagFromIssue(issueId, bagAndTagId) {
      return issueBackendService.removeBagAndTagFromIssue({code:SETTINGS.projectCode, id:issueId, bagAndTagId:bagAndTagId}).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update issue.');
        return error;
      });
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('issueBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_WAREHOUSE + 'issues/:id', {id: '@id'}, {

        getIssue: {url:API.BASE_URI_WAREHOUSE + ':code/issues/:id', method:'GET', params:{code:'@code', id:'@id'}},
        getIssuesCompleted: {url:API.BASE_URI_WAREHOUSE + ':code/issues/complete', method:'GET', params:{code:'@code'}, isArray:true},
        getIssuesIncomplete: {url:API.BASE_URI_WAREHOUSE + ':code/issues/incomplete', method:'GET', params:{code:'@code'}, isArray:true},
        getIssuesIncompleteCount: {url:API.BASE_URI_WAREHOUSE + ':code/issues/incomplete/count', method:'GET', params:{code:'@code'}},
        createIssue: {url:API.BASE_URI_WAREHOUSE + ':code/issues/', method:'POST', params:{code:'@code'}},
        updateIssue: {url:API.BASE_URI_WAREHOUSE + ':code/issues/:id/update-issue', method:'PUT', params:{code:'@code', id:'@id'}},
        completeIssue: {url:API.BASE_URI_WAREHOUSE + ':code/issues/:id/complete-issue', method:'PUT', params:{code:'@code', id:'@id'}},
        cancelIssue: {url:API.BASE_URI_WAREHOUSE + ':code/issues/:id/cancel-issue', method:'PUT', params:{code:'@code', id:'@id'}},
        getIssueItems: {url:API.BASE_URI_WAREHOUSE + ':code/issues/:id/issue-items', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},
        getIssueBagAndTagItems: {url:API.BASE_URI_WAREHOUSE + ':code/issues/:id/bag-and-tags', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},
        addItemToIssue: {url:API.BASE_URI_WAREHOUSE + ':code/issues/:id/add-item', method:'PUT', params:{code:'@code', id:'@id'}},
        addIssueItems: {url:API.BASE_URI_WAREHOUSE + ':code/issues/:id/add-items', method:'PUT', params:{code:'@code', id:'@id'}},
        updateItemToIssue: {url:API.BASE_URI_WAREHOUSE + ':code/issues/:id/update-item', method:'PUT', params:{code:'@code', id:'@id'}},
        addBagAndTagToIssue: {url:API.BASE_URI_WAREHOUSE + ':code/issues/:id/add-bag-and-tag', method:'PUT', params:{code:'@code', id:'@id'}},
        removeItemFromIssue: {url:API.BASE_URI_WAREHOUSE + ':code/issues/:id/issue-items/:storedItemLocationId', method:'DELETE', params:{code:'@code', id:'@id', storedItemLocationId:'@storedItemLocationId'}},
        removeBagAndTagFromIssue: {url:API.BASE_URI_WAREHOUSE + ':code/issues/:id/bag-and-tags/:bagAndTagId', method:'DELETE', params:{code:'@code', id:'@id', bagAndTagId:'@bagAndTagId'}},

      });
    });
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('deliveryService', deliveryService);

  deliveryService.$inject = ['$q', 'deliveryBackendService', 'authorizationService', 'SETTINGS'];

  function deliveryService($q, deliveryBackendService, authorizationService, SETTINGS) {

    var service = {
      getDelivery: getDelivery,
      getAllDeliveries: getAllDeliveries,
      getDeliveryLines: getDeliveryLines,
      getCheckLines: getCheckLines,
      getStockItems: getStockItems,
      getShorts: getShorts,
      getFullOsdItems: getFullOsdItems,
      getReceivedOverages: getReceivedOverages,
      getReceivedItemsWithinTolerance: getReceivedItemsWithinTolerance,
      getPotentialOverages: getPotentialOverages,
      getUnresolvedOverages: getUnresolvedOverages,
      getUnresolvedInterventions: getUnresolvedInterventions,
      getInterventions: getInterventions,
      getCheckLine: getCheckLine,
      getCostCodes: getCostCodes,
      getStockItem: getStockItem,
      createDelivery: createDelivery,
      updateDeliveryLineQuantity: updateDeliveryLineQuantity,
      updateCheckLineQuantity: updateCheckLineQuantity,
      updateStockItemLocationQuantity: updateStockItemLocationQuantity,
      updateDeliveryLineSplitQuantity: updateDeliveryLineSplitQuantity,
      removeDeliveryLineSplit: removeDeliveryLineSplit,
      removeStockItemLocation: removeStockItemLocation,
      updateDeliveryLineInclusion: updateDeliveryLineInclusion,
      updateCheckLineInclusion: updateCheckLineInclusion,
      updateCheckLineInterventionRequired: updateCheckLineInterventionRequired,
      updateDeliveryLineSplitInterventionRequired: updateDeliveryLineSplitInterventionRequired,
      getIncompleteDeliveries: getIncompleteDeliveries,
      getIncompleteDeliveriesCount: getIncompleteDeliveriesCount,
      getCompleteDeliveries: getCompleteDeliveries,
      getCheckingDeliveries: getCheckingDeliveries,
      getCheckingDeliveriesCount: getCheckingDeliveriesCount,
      getStoringDeliveries: getStoringDeliveries,
      getStoringDeliveriesCount: getStoringDeliveriesCount,
      getStoredDeliveries: getStoredDeliveries,
      getOutstandingOsdDeliveries: getOutstandingOsdDeliveries,
      getOutstandingOsdDeliveriesCount: getOutstandingOsdDeliveriesCount,
      getInspectionDeliveries: getInspectionDeliveries,
      getInspectionDeliveriesCount: getInspectionDeliveriesCount,
      completeDelivery: completeDelivery,
      cancelDelivery: cancelDelivery,
      completeChecking: completeChecking,
      completeStoring: completeStoring,
      cancelChecking: cancelChecking,
      addDeliveryLineSplit: addDeliveryLineSplit,
      registerShort: registerShort,
      registerOverage: registerOverage,
      registerIntervention: registerIntervention,
      registerInspection: registerInspection,
      registerInspections: registerInspections,
      updateCostCode: updateCostCode,
      saveTraceInfo: saveTraceInfo,
      getTraceInfo: getTraceInfo,
      getWarehouses: getWarehouses,
      getWarehouse: getWarehouse,
      deleteWarehouse: deleteWarehouse,
      createWarehouse: createWarehouse,
      updateWarehouse: updateWarehouse,
      getLocations: getLocations,
      getLocationsIncludingQuarantined: getLocationsIncludingQuarantined,
      getLocation: getLocation,
      updateLocation: updateLocation,
      deleteLocation: deleteLocation,
      createLocation: createLocation,
      getLocationTypes: getLocationTypes,
      getLocationsForWarehouse: getLocationsForWarehouse,
      setStockItemLocationQuantity: setStockItemLocationQuantity,
      addStockItemLocation: addStockItemLocation,
      storeAllUnstoredStockItems: storeAllUnstoredStockItems,
      getOsdRegisterIncomplete: getOsdRegisterIncomplete,
      getOsdRegisterComplete: getOsdRegisterComplete,
      getOsdRegisterItem: getOsdRegisterItem,
      resolveOsd: resolveOsd,
      getDeliveryDefaultLocation: getDeliveryDefaultLocation,
      getPurchaseOrderLinesForExpediting: getPurchaseOrderLinesForExpediting,
      getPurchaseOrderLinesForExpeditingCount: getPurchaseOrderLinesForExpeditingCount,
      getPurchaseOrderLineDeliveries: getPurchaseOrderLineDeliveries,
      getVendorInspectionsIncomplete: getVendorInspectionsIncomplete,
      getVendorInspectionsIncompleteCount: getVendorInspectionsIncompleteCount,
      getVendorInspectionsComplete: getVendorInspectionsComplete,
      registerVendorInspection: registerVendorInspection,
      getVendorInspectionHistory: getVendorInspectionHistory,
      getImportTemplate: getImportTemplate,
      getImportErrors: getImportErrors
    };

    return service;

    ////////////

    function getTraceInfo(id, barcode) {
      var deferred = $q.defer();

      deliveryBackendService.getTraceInfo({
        code: SETTINGS.projectCode,
        id: id,
        barcode: barcode
      }, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function saveTraceInfo(id, barcode, traceInfo) {
      var deferred = $q.defer();

      deliveryBackendService.saveTraceInfo({
        code: SETTINGS.projectCode,
        id: id,
        barcode: barcode
      }, traceInfo, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getCompleteDeliveries() {
      var deferred = $q.defer();

      deliveryBackendService.getCompleteDeliveries({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getCheckingDeliveries() {
      var deferred = $q.defer();

      deliveryBackendService.getCheckingDeliveries({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getCheckingDeliveriesCount(){
      return deliveryBackendService.getCheckingDeliveriesCount({code: SETTINGS.projectCode}).$promise;
    }

    function getStoringDeliveries() {
      var deferred = $q.defer();

      deliveryBackendService.getStoringDeliveries({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getStoringDeliveriesCount() {
      return deliveryBackendService.getStoringDeliveriesCount({code: SETTINGS.projectCode}).$promise;
    }

    function getStoredDeliveries() {
      var deferred = $q.defer();

      deliveryBackendService.getStoredDeliveries({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getOutstandingOsdDeliveries() {
      var deferred = $q.defer();

      deliveryBackendService.getOutstandingOsdDeliveries({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getOutstandingOsdDeliveriesCount() {
      return deliveryBackendService.getOutstandingOsdDeliveriesCount({code: SETTINGS.projectCode}).$promise;
    }

    function getInspectionDeliveries() {
      var deferred = $q.defer();

      deliveryBackendService.getInspectionDeliveries({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getInspectionDeliveriesCount() {
      return deliveryBackendService.getInspectionDeliveriesCount({code: SETTINGS.projectCode}).$promise;
    }

    function getRecentDeliveries() {
      var deferred = $q.defer();

      deliveryBackendService.getRecentDeliveries({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getIncompleteDeliveries() {
      var deferred = $q.defer();

      deliveryBackendService.getIncompleteDeliveries({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getIncompleteDeliveriesCount() {
      return deliveryBackendService.getIncompleteDeliveriesCount({code: SETTINGS.projectCode}).$promise;
    }

    function getDelivery(deliveryId) {
      var deferred = $q.defer();

      deliveryBackendService.get({code: SETTINGS.projectCode, id: deliveryId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getAllDeliveries() {
      var deferred = $q.defer();

      deliveryBackendService.getAllDeliveries({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getDeliveryLines(deliveryId) {
      var deferred = $q.defer();

      deliveryBackendService.getDeliveryLines({code: SETTINGS.projectCode, id: deliveryId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getCheckLines(deliveryId) {
      var deferred = $q.defer();

      deliveryBackendService.getCheckLines({code: SETTINGS.projectCode, id: deliveryId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getStockItems(deliveryId) {
      var deferred = $q.defer();

      deliveryBackendService.getStockItems({code: SETTINGS.projectCode, id: deliveryId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getCheckLine(checkLineId) {
      var deferred = $q.defer();

      deliveryBackendService.getCheckLine({code: SETTINGS.projectCode, id: checkLineId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getCostCodes(){
      return deliveryBackendService.getCostCodes({code:SETTINGS.projectCode}).$promise.then(function (response) {
        return response;
      });
    }


    function getStockItem(stockItemId) {
      var deferred = $q.defer();

      deliveryBackendService.getStockItem({code: SETTINGS.projectCode, id: stockItemId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function createDelivery(delivery) {
      return (delivery.purchaseOrderType == 'purchaseOrder' ? deliveryBackendService.createDelivery : deliveryBackendService.createDeliveryFromMovement )
      ({
        code: SETTINGS.projectCode
      }, delivery).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot create delivery.');
        return error;
     });
    }

    function getShorts(deliveryId) {
      return deliveryBackendService.getShorts({code:SETTINGS.projectCode, id: deliveryId}).$promise.then(function(response) {
        return response;
      });
    }

    function getFullOsdItems(deliveryId) {
      return deliveryBackendService.getFullOsdItems({code:SETTINGS.projectCode, id: deliveryId}).$promise.then(function(response) {
        return response;
      });
    }

    function getReceivedOverages(deliveryId) {
      return deliveryBackendService.getReceivedOverages({code:SETTINGS.projectCode, id: deliveryId}).$promise.then(function(response) {
        return response;
      });
    }

    function getReceivedItemsWithinTolerance(deliveryId) {
      return deliveryBackendService.getReceivedItemsWithinTolerance({code:SETTINGS.projectCode, id: deliveryId}).$promise.then(function(response) {
        return response;
      });
    }

    function getPotentialOverages(deliveryId) {
      return deliveryBackendService.getPotentialOverages({code:SETTINGS.projectCode, id: deliveryId}).$promise.then(function(response) {
        return response;
      });
    }

    function getUnresolvedOverages(deliveryId) {
      return deliveryBackendService.getUnresolvedOverages({code:SETTINGS.projectCode, id: deliveryId}).$promise.then(function(response) {
        return response;
      });
    }

    function getUnresolvedInterventions(deliveryId) {
      return deliveryBackendService.getUnresolvedInterventions({code:SETTINGS.projectCode, id: deliveryId}).$promise.then(function(response) {
        return response;
      });
    }

    function getInterventions(deliveryId) {
      return deliveryBackendService.getInterventions({code:SETTINGS.projectCode, id: deliveryId}).$promise.then(function(response) {
        return response;
      });
    }

    function completeDelivery(deliveryId) {
      var deferred = $q.defer();

      deliveryBackendService.completeDelivery({code: SETTINGS.projectCode, id: deliveryId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot complete delivery.');
      });

      return deferred.promise;
    }

    function cancelDelivery(deliveryId) {
      var deferred = $q.defer();

      deliveryBackendService.cancelDelivery({code: SETTINGS.projectCode, id: deliveryId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot cancel delivery.');
      });

      return deferred.promise;
    }

    function completeChecking(deliveryId) {
      var deferred = $q.defer();

      deliveryBackendService.completeChecking({code: SETTINGS.projectCode, id: deliveryId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }


    function completeStoring(deliveryId) {
      var deferred = $q.defer();

      deliveryBackendService.completeStoring({code: SETTINGS.projectCode, id: deliveryId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function cancelChecking(deliveryId) {
      var deferred = $q.defer();

      deliveryBackendService.cancelChecking({code: SETTINGS.projectCode, id: deliveryId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function updateDeliveryLineQuantity(deliveryLineQuantity) {
      var deferred = $q.defer();

      deliveryBackendService.updateDeliveredQuantity({
        code: SETTINGS.projectCode,
        id: deliveryLineQuantity.deliveryLineId
      }, deliveryLineQuantity, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function updateCheckLineQuantity(checkLineQuantity) {
      var deferred = $q.defer();

      deliveryBackendService.updateCheckedQuantity({
        code: SETTINGS.projectCode,
        id: checkLineQuantity.checkLineId
      }, checkLineQuantity, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function updateStockItemLocationQuantity(stockItemLocationQuantity) {
      var deferred = $q.defer();

      deliveryBackendService.updateStockItemLocationQuantity({
        code: SETTINGS.projectCode,
        id: stockItemLocationQuantity.stockItemId,
        unstoredStockItemLocationId: stockItemLocationQuantity.id
      }, stockItemLocationQuantity, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function updateDeliveryLineSplitQuantity(deliveryLineSplitQuantity) {
      var deferred = $q.defer();

      deliveryBackendService.updateDeliveryLineSplitCheckedQuantity({
        code: SETTINGS.projectCode,
        id: deliveryLineSplitQuantity.checkLineId,
        barcode: deliveryLineSplitQuantity.barcode
      }, deliveryLineSplitQuantity, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function removeDeliveryLineSplit(deliveryLineSplitToRemove) {
      var deferred = $q.defer();

      deliveryBackendService.removeDeliveryLineSplit({
        code: SETTINGS.projectCode,
        id: deliveryLineSplitToRemove.checkLineId,
        barcode: deliveryLineSplitToRemove.barcode
      }, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function removeStockItemLocation(stockItemLocationToRemove) {
      var deferred = $q.defer();

      deliveryBackendService.removeStockItemLocation({
        code: SETTINGS.projectCode,
        id: stockItemLocationToRemove.stockItemId,
        unstoredStockItemLocationId: stockItemLocationToRemove.id
      }, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function updateDeliveryLineInclusion(deliveryLineIncluded) {

      var deferred = $q.defer();

      (deliveryLineIncluded.included ? deliveryBackendService.setDeliveryLineIncluded : deliveryBackendService.setDeliveryLineExcluded )
      ({
        code: SETTINGS.projectCode,
        id: deliveryLineIncluded.deliveryLineId
      }, deliveryLineIncluded, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function updateCheckLineInclusion(checkLineIncluded) {

      var deferred = $q.defer();

      (checkLineIncluded.included ? deliveryBackendService.setCheckLineIncluded : deliveryBackendService.setCheckLineExcluded )
      ({code: SETTINGS.projectCode, id: checkLineIncluded.checkLineId}, checkLineIncluded, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function updateCheckLineInterventionRequired(checkLineInterventionRequired) {

      return (checkLineInterventionRequired.interventionRequired ? deliveryBackendService.setCheckLineInterventionRequired : deliveryBackendService.setCheckLineInterventionNotRequired )
      ({code: SETTINGS.projectCode, id: checkLineInterventionRequired.checkLineId}, checkLineInterventionRequired).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update delivery.');
        return error;
      });
    }

    function updateDeliveryLineSplitInterventionRequired(deliveryLineSplitInterventionRequired) {

      return (deliveryLineSplitInterventionRequired.interventionRequired ? deliveryBackendService.setDeliveryLineSplitInterventionRequired : deliveryBackendService.setDeliveryLineSplitInterventionNotRequired )
      ({code: SETTINGS.projectCode, id: deliveryLineSplitInterventionRequired.checkLineId, barcode: deliveryLineSplitInterventionRequired.barcode}, deliveryLineSplitInterventionRequired).$promise.then(function(response) {
        return response;
      }, function(error){
        authorizationService.error(error, 'Cannot update delivery.');
        return error;
      });
    }

    function registerShort(short) {

      return deliveryBackendService.registerShort({code:SETTINGS.projectCode, id: short.checkLineId}, short).$promise.then(function(response) {
        return response;
      });
    }

    function registerOverage(overages) {

      return deliveryBackendService.registerOverage({code:SETTINGS.projectCode, id: overages.purchaseOrderLineId}, overages).$promise.then(function(response) {
        return response;
      });
    }

    function registerIntervention(intervention) {

      return deliveryBackendService.registerIntervention({code:SETTINGS.projectCode, id: intervention.purchaseOrderLineId}, intervention).$promise.then(function(response) {
        return response;
      });
    }

    function registerInspection(purchaseOrderLineId, inspection) {

      return deliveryBackendService.registerInspection({code:SETTINGS.projectCode, id: purchaseOrderLineId}, inspection).$promise.then(function(response) {
        return response;
      });
    }

    function registerInspections(deliveryId, inspections) {

      return deliveryBackendService.registerInspections({code:SETTINGS.projectCode, id: deliveryId}, inspections).$promise.then(function(response) {
        return response;
      });
    }

    function updateCostCode(lineToUpdate) {

      return deliveryBackendService.updateCostCode({code:SETTINGS.projectCode, id: lineToUpdate.purchaseOrderLineId}, lineToUpdate).$promise.then(function(response) {
        return response;
      });
    }

    function addDeliveryLineSplit(checkLineId) {
      var deferred = $q.defer();

      deliveryBackendService.addDeliveryLineSplit({code: SETTINGS.projectCode, id: checkLineId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function getWarehouses() {
      var deferred = $q.defer();

      deliveryBackendService.getWarehouses({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getWarehouse(warehouseId) {
      var deferred = $q.defer();

      deliveryBackendService.getWarehouse({code: SETTINGS.projectCode, id : warehouseId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function createWarehouse(warehouse) {
      var deferred = $q.defer();

      deliveryBackendService.createWarehouse({code: SETTINGS.projectCode}, warehouse, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function updateWarehouse(warehouse) {
      var deferred = $q.defer();

      deliveryBackendService.updateWarehouse({code: SETTINGS.projectCode, id : warehouse.id }, warehouse, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function deleteWarehouse(warehouseId) {
      var deferred = $q.defer();

      deliveryBackendService.deleteWarehouse({code: SETTINGS.projectCode, id : warehouseId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getLocations() {
      var deferred = $q.defer();

      deliveryBackendService.getLocations({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getLocationsIncludingQuarantined() {
      var deferred = $q.defer();

      deliveryBackendService.getLocationsIncludingQuarantined({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function createLocation(location) {
      var deferred = $q.defer();

      deliveryBackendService.createLocation({code: SETTINGS.projectCode}, location, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getLocation(locationId) {
      var deferred = $q.defer();

      deliveryBackendService.getLocation({code: SETTINGS.projectCode, id : locationId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function updateLocation(location) {
      var deferred = $q.defer();

      deliveryBackendService.updateLocation({code: SETTINGS.projectCode, id : location.id}, location, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function deleteLocation(locationId) {
      var deferred = $q.defer();

      deliveryBackendService.deleteLocation({code: SETTINGS.projectCode, id : locationId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }
    function getLocationTypes() {
      var deferred = $q.defer();

      deliveryBackendService.getLocationTypes({code: SETTINGS.projectCode}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getLocationsForWarehouse(warehouseId) {
      var deferred = $q.defer();

      deliveryBackendService.getLocationsForWarehouses({
        id: warehouseId,
        code: SETTINGS.projectCode
      }, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function setStockItemLocationQuantity(stockItemLocationQuantity) {
      var deferred = $q.defer();

      deliveryBackendService.setStockItemLocationQuantity({
        code: SETTINGS.projectCode,
        id: stockItemLocationQuantity.stockItemId,
        unstoredStockItemLocationId: stockItemLocationQuantity.id
      }, stockItemLocationQuantity, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function addStockItemLocation(stockItemLocation) {
      var deferred = $q.defer();

      deliveryBackendService.addStockItemLocation({
        code: SETTINGS.projectCode,
        id: stockItemLocation.stockItemId
      }, stockItemLocation, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function storeAllUnstoredStockItems(deliveryStockItem) {
      var deferred = $q.defer();

      deliveryBackendService.storeAllUnstoredStockItems({
        code: SETTINGS.projectCode,
        id: deliveryStockItem.deliveryId
      }, deliveryStockItem, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update delivery.');
      });

      return deferred.promise;
    }

    function getOsdRegisterIncomplete() {
      return deliveryBackendService.getOsdRegisterIncomplete({code: SETTINGS.projectCode}).$promise.then(function(response) {
        return response;
      });
    }

    function getOsdRegisterComplete() {
      return deliveryBackendService.getOsdRegisterComplete({code: SETTINGS.projectCode}).$promise.then(function(response) {
        return response;
      });
    }

    function getOsdRegisterItem(id) {
      return deliveryBackendService.getOsdRegisterItem({code: SETTINGS.projectCode, id: id}).$promise.then(function(response) {
        return response;
      });
    }

    function resolveOsd(id, acceptedQuantity, returnedQuantity, comments, storedItemLocations, quarantineStoredItemLocationId) {
      var data = {
        acceptedQuantity: acceptedQuantity,
        returnedQuantity: returnedQuantity,
        comments: comments,
        storedItemLocations: storedItemLocations,
        quarantineStoredItemLocationId: quarantineStoredItemLocationId
      };

      return deliveryBackendService.resolveOsd({code: SETTINGS.projectCode, id: id}, data).$promise.then(function(response) {
        return response;
      });
    }

    function getDeliveryDefaultLocation(id) {
      return deliveryBackendService.getDeliveryDefaultLocation({code: SETTINGS.projectCode, id: id}).$promise.then(function(response){
        return response;
      });
    }

    function getPurchaseOrderLinesForExpediting(timeInterval, buyerName, purchaseOrderNumber) {
      var data = {
        timeInterval: timeInterval,
        buyerName: buyerName,
        purchaseOrderNumber : purchaseOrderNumber
      };
      return deliveryBackendService.getPurchaseOrderLinesForExpediting({code: SETTINGS.projectCode}, data).$promise.then(function(response) {
        return response;
      });
    }

    function getPurchaseOrderLinesForExpeditingCount(timeInterval, buyerName, purchaseOrderNumber) {
      var data = {
        timeInterval: timeInterval,
        buyerName: buyerName,
        purchaseOrderNumber : purchaseOrderNumber
      };
      return deliveryBackendService.getPurchaseOrderLinesForExpeditingCount({code: SETTINGS.projectCode}, data).$promise;
    }

    function getPurchaseOrderLineDeliveries(id) {
      return deliveryBackendService.getPurchaseOrderLineDeliveries({code: SETTINGS.projectCode, id: id}).$promise;
    }

    function getVendorInspectionsIncomplete(supplierCode, timeInterval, purchaseOrderNumber) {
      var data = {
        supplierCode: supplierCode,
        timeInterval: timeInterval,
        purchaseOrderNumber : purchaseOrderNumber
      };
      return deliveryBackendService.getVendorInspectionsIncomplete({code: SETTINGS.projectCode}, data).$promise.then(function(response) {
        return response;
      });
    }

    function getVendorInspectionsIncompleteCount(supplierCode, timeInterval, purchaseOrderNumber) {
      var data = {
        supplierCode: supplierCode,
        timeInterval: timeInterval,
        purchaseOrderNumber : purchaseOrderNumber
      };
      return deliveryBackendService.getVendorInspectionsIncompleteCount({code: SETTINGS.projectCode}, data).$promise;
    }

    function getVendorInspectionsComplete() {
      return deliveryBackendService.getVendorInspectionsComplete({code: SETTINGS.projectCode}).$promise.then(function(response) {
        return response;
      });
    }

    function registerVendorInspection(id, data) {
      return deliveryBackendService.registerVendorInspection({code: SETTINGS.projectCode, id: id}, data).$promise.then(function(response) {
        return response;
      });
    }

    function getVendorInspectionHistory(id) {
      return deliveryBackendService.getVendorInspectionHistory({code: SETTINGS.projectCode, id:id}).$promise.then(function(response) {
        return response;
      });
    }

    function getImportTemplate() {
      return deliveryBackendService.getImportTemplate({code: SETTINGS.projectCode}).$promise.then(function (response){
        return response;
      });
    }

    function getImportErrors(documentKey) {
      return deliveryBackendService.getImportErrors({code: SETTINGS.projectCode, key: documentKey}).$promise.then(function(response) {
        return response;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('deliveryBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_WAREHOUSE + ':code/deliveries/:id', {code:'@code', id:'@id'}, {

        createDelivery: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/', method:'POST', params:{code:'@code'}},
        createDeliveryFromMovement: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/create-from-movement', method:'POST', params:{code:'@code'}},
        getDeliveryLines: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/delivery-lines', method:'GET', params:{code:'', id:''}, isArray:true},
        getCheckLines: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/check-lines', method:'GET', params:{code:'', id:''}, isArray:true},
        getCostCodes: {url: API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/cost-codes', method: 'GET', params:{code: '@code'}, isArray: true},
        getStockItems: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/stock-items', method:'GET', params:{code:'', id:''}, isArray:true},
        getShorts: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/shorts', method:'GET', params:{code:'', id:''}, isArray:true},
        getFullOsdItems: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/over-short-and-damaged', method:'GET', params:{code:'', id:''}, isArray:true},
        getReceivedOverages: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/received-overages', method:'GET', params:{code:'', id:''}, isArray:true},
        getReceivedItemsWithinTolerance: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/received-items-within-tolerance', method:'GET', params:{code:'', id:''}, isArray:true},
        getPotentialOverages: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/potential-overages', method:'GET', params:{code:'', id:''}, isArray:true},
        getUnresolvedOverages: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/unresolved-overages', method:'GET', params:{code:'', id:''}, isArray:true},
        getUnresolvedInterventions: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/unresolved-interventions', method:'GET', params:{code:'', id:''}, isArray:true},
        getInterventions: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/interventions', method:'GET', params:{code:'', id:''}, isArray:true},
        getCheckLine: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id', method:'GET', params:{code:'', id:''}},
        getStockItem: {url:API.BASE_URI_WAREHOUSE + ':code/stock-items/:id', method:'GET', params:{code:'', id:''}},
        completeDelivery: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/complete-delivery', method:'PUT', params: {code:'@code', id: '@id'}},
        cancelDelivery: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/cancel-delivery', method:'PUT', params: {code:'@code', id: '@id'}},
        storeAllUnstoredStockItems: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/store-all-unstored', method:'PUT', params: {code:'@code', id: '@id'}},

        getAllDeliveries: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries', method:'GET', params:{code:'@code'}, isArray: true},
        getIncompleteDeliveries: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/incomplete', method:'GET', params:{code:'@code'}, isArray: true},
        getIncompleteDeliveriesCount: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/incomplete/count', method:'GET', params:{code:'@code'}},
        getRecentDeliveries: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/recent', method:'GET', params:{code:'@code'}, isArray: true},
        getCompleteDeliveries: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/complete', method:'GET', params:{code:'@code'}, isArray: true},
        getCheckingDeliveries: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/checking', method:'GET', params:{code:'@code'}, isArray: true},
        getCheckingDeliveriesCount: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/checking/count', method:'GET', params:{code:'@code'}},
        getStoringDeliveries: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/storing', method:'GET', params:{code:'@code'}, isArray: true},
        getStoringDeliveriesCount: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/storing/count', method:'GET', params:{code:'@code'}},
        getStoredDeliveries: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/stored', method:'GET', params:{code:'@code'}, isArray: true},
        getOutstandingOsdDeliveries: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/outstanding-osd', method:'GET', params:{code:'@code'}, isArray: true},
        getOutstandingOsdDeliveriesCount: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/outstanding-osd/count', method:'GET', params:{code:'@code'}},
        getInspectionDeliveries: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/outstanding-inspection', method:'GET', params:{code:'@code'}, isArray: true},
        getInspectionDeliveriesCount: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/outstanding-inspection/count', method:'GET', params:{code:'@code'}},
        getPurchaseOrderLineDeliveries: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/:id/deliveries', method:'GET', params: {code:'@code', id: '@id'}, isArray: true},

        completeChecking: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/complete-checking', method:'PUT', params: {code:'@code', id: '@id'}},
        completeStoring: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/complete-storing', method:'PUT', params: {code:'@code', id: '@id'}},
        cancelChecking: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/cancel-checking', method:'PUT', params: {code:'@code', id: '@id'}},

        updateDeliveredQuantity: {url:API.BASE_URI_WAREHOUSE + ':code/delivery-lines/:id/quantity', method:'PUT', params: {code:'@code', id: '@id'}},
        setDeliveryLineIncluded: {url:API.BASE_URI_WAREHOUSE + ':code/delivery-lines/:id/included', method:'PUT', params: {code:'@code', id: '@id'}},
        setDeliveryLineExcluded: {url:API.BASE_URI_WAREHOUSE + ':code/delivery-lines/:id/included', method:'DELETE', params: {code:'@code', id: '@id'}},

        updateCheckedQuantity: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/quantity', method:'PUT', params: {code:'@code', id: '@id'}},
        updateDeliveryLineSplitCheckedQuantity: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/items/:barcode/quantity', method:'PUT', params: {code:'@code', id: '@id', barcode:'@barcode'}},
        updateStockItemLocationQuantity: {url:API.BASE_URI_WAREHOUSE + ':code/stock-items/:id/locations/:unstoredStockItemLocationId/quantity', method:'PUT', params: {code:'@code', id: '@id', unstoredStockItemLocationId:'@unstoredStockItemLocationId'}},
        removeDeliveryLineSplit: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/items/:barcode', method:'DELETE', params: {code:'@code', id: '@id', barcode:'@barcode'}},
        removeStockItemLocation: {url:API.BASE_URI_WAREHOUSE + ':code/stock-items/:id/locations/:unstoredStockItemLocationId', method:'DELETE', params: {code:'@code', id: '@id', unstoredStockItemLocationId:'@unstoredStockItemLocationId'}},
        setCheckLineIncluded: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/included', method:'PUT', params: {code:'@code', id: '@id'}},
        setCheckLineExcluded: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/included', method:'DELETE', params: {code:'@code', id: '@id'}},

        setCheckLineInterventionRequired: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/intervention-required', method:'PUT', params: {code:'@code', id: '@id'}},
        setCheckLineInterventionNotRequired: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/intervention-required', method:'DELETE', params: {code:'@code', id: '@id'}},

        setDeliveryLineSplitInterventionRequired: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/items/:barcode/intervention-required', method:'PUT', params: {code:'@code', id: '@id', barcode:'@barcode'}},
        setDeliveryLineSplitInterventionNotRequired: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/items/:barcode/intervention-required', method:'DELETE', params: {code:'@code', id: '@id', barcode:'@barcode'}},

        addDeliveryLineSplit: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/items', method:'POST', params: {code:'@code', id: '@id'}},

        saveTraceInfo: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/items/:barcode/trace-info', method:'PUT', params: {code:'@code', id: '@id', barcode: '@barcode'}},
        getTraceInfo: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/items/:barcode/trace-info', method:'GET', params: {code:'@code', id: '@id', barcode: '@barcode'}},

        registerShort: {url:API.BASE_URI_WAREHOUSE + ':code/check-lines/:id/register-short', method:'PUT', params: {code:'@code', id: '@id'}},
        registerOverage: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/:id/register-overage', method:'PUT', params: {code:'@code', id: '@id'}},
        registerIntervention: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/:id/register-intervention', method:'PUT', params: {code:'@code', id: '@id'}},
        registerInspection: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/:id/register-inspection', method:'PUT', params: {code:'@code', id: '@id'}},
        registerInspections: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/:id/register-inspections', method:'POST', params: {code:'@code', id: '@id'}},

        updateCostCode: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/:id/update-cost-code', method:'PUT', params: {code:'@code', id: '@id'}},

        getWarehouses: {url:API.BASE_URI_WAREHOUSE + ':code/warehouses', method:'GET', params: {code:'@code'}, isArray: true},
        createWarehouse: {url:API.BASE_URI_WAREHOUSE + ':code/warehouses', method:'POST', params: {code:'@code'}},
        getWarehouse: {url:API.BASE_URI_WAREHOUSE + ':code/warehouses/:id', method:'GET', params: {code:'@code', id:'@id'}},
        deleteWarehouse: {url:API.BASE_URI_WAREHOUSE + ':code/warehouses/:id', method:'DELETE', params: {code:'@code', id:'@id'}},
        updateWarehouse: {url:API.BASE_URI_WAREHOUSE + ':code/warehouses/:id', method:'PUT', params: {code:'@code', id : '@id'}},

        getLocations: {url:API.BASE_URI_WAREHOUSE + ':code/locations', method:'GET', params: {code:'@code'}, isArray: true},
        getLocationsIncludingQuarantined: {url:API.BASE_URI_WAREHOUSE + ':code/locations/including-quarantined', method:'GET', params: {code:'@code'}, isArray: true},
        getLocation: {url:API.BASE_URI_WAREHOUSE + ':code/locations/:id', method:'GET', params: {code:'@code', id:'@id'}},
        createLocation: {url:API.BASE_URI_WAREHOUSE + ':code/locations', method:'POST', params: {code:'@code'}},
        updateLocation: {url:API.BASE_URI_WAREHOUSE + ':code/locations/:id', method:'PUT', params: {code:'@code', id : '@id'}},
        deleteLocation: {url:API.BASE_URI_WAREHOUSE + ':code/locations/:id', method:'DELETE', params: {code:'@code', id:'@id'}},
        getLocationTypes: {url:API.BASE_URI_WAREHOUSE + ':code/locations/locationTypes', method:'GET', params: {code:'@code'}, isArray: true},

        getLocationsForWarehouses: {url:API.BASE_URI_WAREHOUSE + ':code/warehouses/:id/locations', method:'GET', params: {code:'@code', id:'@id'}, isArray: true},
        setStockItemLocationQuantity: {url:API.BASE_URI_WAREHOUSE + ':code/stock-items/:id/locations/:unstoredStockItemLocationId', method:'PUT', params: {code:'@code', id:'@id', unstoredStockItemLocationId:'@unstoredStockItemLocationId'}},
        addStockItemLocation: {url:API.BASE_URI_WAREHOUSE + ':code/stock-items/:id/locations', method:'POST', params: {code:'@code', id:'@id'}},

        getOsdRegisterIncomplete: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/osd-register-incomplete', method:'GET', params: {code:'@code'}, isArray: true},
        getOsdRegisterComplete: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/osd-register-complete', method:'GET', params: {code:'@code'}, isArray: true},
        getOsdRegisterItem: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/osd-register/:id', method:'GET', params: {code:'@code', id:'@id'}},
        resolveOsd: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/osd-resolve/:id', method:'PUT', params: {code:'@code', id:'@id'}},

        getDeliveryDefaultLocation: {url:API.BASE_URI_WAREHOUSE + ':code/deliveries/:id/default-location', method:'GET', params: {code:'@code', id:'@id'}},

        getPurchaseOrderLinesForExpediting: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/expediting', method:'POST', params: {code:'@code'}, isArray: true},
        getPurchaseOrderLinesForExpeditingCount: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/expediting/count', method:'POST', params: {code:'@code'}},
        getVendorInspectionsIncomplete: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/vendor-inspection-incomplete', method:'POST', params: {code:'@code'}, isArray: true},
        getVendorInspectionsIncompleteCount: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/vendor-inspection-incomplete/count', method:'POST', params: {code:'@code'}},
        getVendorInspectionsComplete: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/vendor-inspection-complete', method:'GET', params: {code:'@code'}, isArray: true},

        registerVendorInspection: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/:id/register-vendor-inspection', method:'PUT', params: {code:'@code', id:'@id'}},
        getVendorInspectionHistory: {url:API.BASE_URI_WAREHOUSE + ':code/purchase-order-lines/:id/vendor-inspection-history', method:'GET', params: {code:'@code', id:'@id'}, isArray: true},

        getImportTemplate: {url: API.BASE_URI_WAREHOUSE + ':code/import-export/warehouse-location-import-template', method:'GET', params:{code:'@code'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers){
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        },

        getImportErrors: {url: API.BASE_URI_WAREHOUSE + ':code/import-export/warehouse-location-upload-errors/:key', method: 'GET', params: {code:'@code', key:'@key'},
          responseType: 'arraybuffer',
          transformResponse: function (data, headers){
            return {
              data: data,
              filename: parseHeaderFilename(headers)
            };
          }
        }
      });

      function parseHeaderFilename(headers){
        var header = headers('Content-Disposition');
        var result = header.split(';')[1].trim().split('=')[1];
        return result.replace(/"/g, '');
      }
  });


})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('dataservice', dataservice);

  dataservice.$inject = ['$q','$odataresource', '$odata', 'API', 'SETTINGS'];


  function dataservice($q, $odataresource, $odata, API, SETTINGS) {
    var service =  {
      searchPurchaseOrders: searchPurchaseOrders,
      getPurchaseOrder: getPurchaseOrder
    };

    return service;

    ////////////

    function searchPurchaseOrders(searchParams){
      var deferred = $q.defer();

      var all = $odataresource(API.BASE_URI_PURCHASING + 'odata/PurchaseOrderLines', {}, {}, { isodatav4 : true });

      var predicates = [];

      searchParams.searchTerm.split(" ").forEach(function (item) {

        var fields = ['purchaseOrder/number','materialCode','purchaseOrder/supplierName','materialDescription', 'workpack', 'buyerName', 'costCode'];

        var combination = getPredicates(fields, item);

        predicates.push(combination);
      });

      if (searchParams.searchFromDate) {
        var fromDatePredicate = $odata.Predicate('purchaseOrder/date', '>=', searchParams.searchFromDate);
        predicates.push(fromDatePredicate);
      };

      if (searchParams.searchToDate) {
        var toDatePredicate = $odata.Predicate("purchaseOrder/date", "<=", searchParams.searchToDate);
        predicates.push(toDatePredicate);
      };

      var andPredicate = $odata.Predicate.and(predicates);

      all.odata().expand('purchaseOrder').filter("purchaseOrder/projectCode",SETTINGS.projectCode).filter(andPredicate).orderBy('purchaseOrder/number', 'desc').orderBy('lineNumber').query(function(data){
        deferred.resolve(data);
      }, function(error){
        deferred.reject(error);
      });

      return deferred.promise;
    }


    function getPredicates(fields, item){

      var combo = [];

      angular.forEach(fields, function(value, key) {
        var predicate = new $odata.Func('contains', value, item);
        combo.push(predicate);
      });

      return $odata.Predicate.or(combo);
    }

    function getPurchaseOrder(purchaseOrderId){
      var deferred = $q.defer();

      var purchaseOrder = $odataresource(API.BASE_URI_PURCHASING + 'odata/PurchaseOrders');

      purchaseOrder.odata().expand('lines').get(purchaseOrderId, function(data){
        deferred.resolve(data);
      }, function(error){
        deferred.reject(error);
      });

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('bagAndTagService', bagAndTagService);

  bagAndTagService.$inject = ['$q', 'bagAndTagBackendService', 'authorizationService', 'urlHelperService', 'SETTINGS'];

  function bagAndTagService($q, bagAndTagBackendService, authorizationService, urlHelperService, SETTINGS) {

    var service = {
      createBagAndTag: createBagAndTag,
      getBagAndTag: getBagAndTag,      
      getUnallocatedBagAndTags: getUnallocatedBagAndTags,
      getBagAndTagsIssued: getBagAndTagsIssued,
      getAllocatedBagAndTags: getAllocatedBagAndTags,
      getBagAndTagItems: getBagAndTagItems,
      getBagAndTagGroups: getBagAndTagGroups,
      addItemToBagAndTag: addItemToBagAndTag,
      getBagAndTags: getBagAndTags,
      deleteItemFromBagAndTag: deleteItemFromBagAndTag,
      deleteItemFromBagAndTagGroup: deleteItemFromBagAndTagGroup,
      deleteGroupFromBagAndTag: deleteGroupFromBagAndTag,
      deleteBagAndTag: deleteBagAndTag,
      createGroup: createGroup,
      getBagAndTagItemsAndGroups: getBagAndTagItemsAndGroups,
      updateBagAndTagGroupItem: updateBagAndTagGroupItem,
      searchBagAndTagHeaders: searchBagAndTagHeaders,
      searchBagAndTagHeadersPicklist: searchBagAndTagHeadersPicklist,
      searchBagAndTagHeadersManifest: searchBagAndTagHeadersManifest,
      getBagAndTagNumbers: getBagAndTagNumbers,
      getBagAndTagNumbersAll: getBagAndTagNumbersAll,
      getBagAndTagWorkpackNumbers: getBagAndTagWorkpackNumbers,
      getManifestBagAndTagWorkpackNumbers: getManifestBagAndTagWorkpackNumbers
    };

    return service;

    //////////////

    function createBagAndTag(bagAndTag) {
      var deferred = $q.defer();

      bagAndTagBackendService.createBagAndTag({code: SETTINGS.projectCode}, bagAndTag).$promise.then(function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot create bag & tag.');
      });

      return deferred.promise;
    }

    function getBagAndTag(bagAndTagId) {
      var deferred = $q.defer();

      bagAndTagBackendService.getBagAndTag({
        code: SETTINGS.projectCode,
        id: bagAndTagId
      }).$promise.then(function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getUnallocatedBagAndTags(){
      var deferred = $q.defer();

      bagAndTagBackendService.getUnallocatedBagAndTags({code: SETTINGS.projectCode}).$promise.then(function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getBagAndTagsIssued(){
      var deferred = $q.defer();

      bagAndTagBackendService.getBagAndTagsIssued({code: SETTINGS.projectCode}).$promise.then(function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getAllocatedBagAndTags(){
      var deferred = $q.defer();

      bagAndTagBackendService.getAllocatedBagAndTags({code: SETTINGS.projectCode}).$promise.then(function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getBagAndTagItems(bagAndTagId) {
      var deferred = $q.defer();

      bagAndTagBackendService.getBagAndTagItems({
        code: SETTINGS.projectCode,
        id: bagAndTagId
      }).$promise.then(function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getBagAndTagGroups(bagAndTagId) {
      var deferred = $q.defer();

      bagAndTagBackendService.getBagAndTagGroups({
        code: SETTINGS.projectCode,
        id: bagAndTagId
      }).$promise.then(function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getBagAndTags() {
      var deferred = $q.defer();

      bagAndTagBackendService.getBagAndTags({code: SETTINGS.projectCode}).$promise.then(function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function addItemToBagAndTag(bagAndTagId, storedItemId, storedItemLocationId, quantity) {
      var deferred = $q.defer();

      var bagAndTagItem = {
        id: '',
        bagAndTagStoredItemId: storedItemId,
        storedItemLocationId: storedItemLocationId,
        quantity: quantity
      };

      bagAndTagBackendService.addItemToBagAndTag({
        code: SETTINGS.projectCode,
        id: bagAndTagId
      }, bagAndTagItem, function (response) {
        bagAndTagItem.id = response.id;
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update bag & tag.');
      });

      return deferred.promise;
    }

    function deleteItemFromBagAndTag(bagAndTagId, storedItemLocationId) {
      var deferred = $q.defer();

      bagAndTagBackendService.deleteItemFromBagAndTag({
        code: SETTINGS.projectCode,
        id: bagAndTagId,
        storedItemLocationId: storedItemLocationId
      }).$promise.then(function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update bag & tag.');
      });

      return deferred.promise;
    }

    function deleteItemFromBagAndTagGroup(bagAndTagId, storedItemLocationId, storedItemParentId) {
      var deferred = $q.defer();

      bagAndTagBackendService.deleteItemFromBagAndTagGroup({
        code: SETTINGS.projectCode, id: bagAndTagId, storedItemLocationId: storedItemLocationId,
        storedItemParentId: storedItemParentId
      }).$promise.then(function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update bag & tag.');
      });

      return deferred.promise;
    }

    function deleteGroupFromBagAndTag(bagAndTagId, storedItemLocationId) {
      var deferred = $q.defer();

      bagAndTagBackendService.deleteGroupFromBagAndTag({
        code: SETTINGS.projectCode,
        id: bagAndTagId,
        storedItemLocationId: storedItemLocationId
      }, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update bag & tag.');
      });

      return deferred.promise;
    }

    function deleteBagAndTag(bagAndTagId) {
      var deferred = $q.defer();

      bagAndTagBackendService.deleteBagAndTag({code: SETTINGS.projectCode, id: bagAndTagId}, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot delete bag & tag.');
      });

      return deferred.promise;
    }

    function createGroup(bagAndTagId, description, locationId, selectedItems) {
      var deferred = $q.defer();

      var data = {
        description: description,
        locationId: locationId,
        selectedItems: []
      };

      for (var i = 0; i < selectedItems.length; i++) {
        var obj = {
          bagAndTagItemId: selectedItems[i].id,
          storedItemId: selectedItems[i].storedItemId,
          storedItemLocationId: selectedItems[i].storedItemLocationId,
          quantity: selectedItems[i].selectedQuantity,
          groupedQuantity: selectedItems[i].groupedQuantity
        };
        data.selectedItems.push(obj);
      }

      bagAndTagBackendService.createGroup({code: SETTINGS.projectCode, id: bagAndTagId}, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update bag & tag.');
      });

      return deferred.promise;
    }

    function getBagAndTagItemsAndGroups(bagAndTagId) {
      var deferred = $q.defer();

      bagAndTagBackendService.getBagAndTagItemsAndGroups({
        code: SETTINGS.projectCode,
        id: bagAndTagId
      }, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function updateBagAndTagGroupItem(bagAndTagId, storedItemId, oldStoredItemParentId, newStoredItemParentId, isContainer) {
      var deferred = $q.defer();

      var data = {
        storedItemId: storedItemId,
        oldStoredItemParentId: oldStoredItemParentId,
        newStoredItemParentId: newStoredItemParentId,
        isContainer: isContainer,
      };

      bagAndTagBackendService.updateBagAndTagGroupItem({
        code: SETTINGS.projectCode,
        id: bagAndTagId
      }, data, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
        authorizationService.error(error, 'Cannot update bag & tag.');
      });

      return deferred.response;
    }

    function searchBagAndTagHeaders(bagAndTagNumbersSelected, workpackNumbersSelected, issuesSelected, returnsSelected,
                                    poNumbersSelected, materialCodesSelected, costCodesSelected, barcodesSelected, locationsSelected, filter, returnsOnly) {
      var deferred = $q.defer();

      if (bagAndTagNumbersSelected.length > 0 || workpackNumbersSelected.length > 0 || issuesSelected.length > 0 || returnsSelected.length > 0 ||
        poNumbersSelected.length > 0 || materialCodesSelected.length > 0 || costCodesSelected.length > 0 || barcodesSelected.length > 0 || locationsSelected.length > 0 || filter.length > 0) {

        var bagAndTagNumbers = urlHelperService.getSelectedValues(bagAndTagNumbersSelected, 'number');
        var workpackNumbers = urlHelperService.getSelectedValues(workpackNumbersSelected, 'workpackNumber');
        var issues = urlHelperService.getSelectedValues(issuesSelected, 'id');
        var returns = urlHelperService.getSelectedValues(returnsSelected, 'id');
        var poNumbers = urlHelperService.getSelectedValues(poNumbersSelected, 'number');
        var materialCodes = urlHelperService.getSelectedValues(materialCodesSelected, 'materialCode');
        var costCodes = urlHelperService.getSelectedValues(costCodesSelected, 'costCode');
        var barcodes = urlHelperService.getSelectedValues(barcodesSelected, 'barcode');
        var locations = urlHelperService.getSelectedValues(locationsSelected, 'id');

        var searchQuery = {
          bagAndTagNumber: bagAndTagNumbers,
          workpackNumber: workpackNumbers,
          issue: issues,
          return: returns,
          poNumber: poNumbers,
          materialCode: materialCodes,
          costCode: costCodes,
          barcode: barcodes,
          location: locations,
          filter: filter,
          returnsOnly: returnsOnly
        };

        bagAndTagBackendService.search({
          code: SETTINGS.projectCode
        }, searchQuery, function (response) {
          deferred.resolve(response);
        }, function (error) {
          deferred.reject(error);
        });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    function searchBagAndTagHeadersPicklist(bagAndTagNumbersSelected, workpackNumbersSelected,
                                    poNumbersSelected, materialCodesSelected, costCodesSelected, barcodesSelected,  filter) {
      var deferred = $q.defer();

      if (bagAndTagNumbersSelected.length > 0 || workpackNumbersSelected.length > 0 ||
        poNumbersSelected.length > 0 || materialCodesSelected.length > 0 || costCodesSelected.length > 0 || barcodesSelected.length > 0 || filter.length > 0) {

        var bagAndTagNumbers = urlHelperService.getSelectedValues(bagAndTagNumbersSelected, 'number');
        var workpackNumbers = urlHelperService.getSelectedValues(workpackNumbersSelected, 'workpackNumber');
        var poNumbers = urlHelperService.getSelectedValues(poNumbersSelected, 'number');
        var materialCodes = urlHelperService.getSelectedValues(materialCodesSelected, 'materialCode');
        var costCodes = urlHelperService.getSelectedValues(costCodesSelected, 'costCode');
        var barcodes = urlHelperService.getSelectedValues(barcodesSelected, 'barcode');

        var searchQuery = {
          bagAndTagNumber: bagAndTagNumbers,
          workpackNumber: workpackNumbers,
          poNumber: poNumbers,
          materialCode: materialCodes,
          costCode: costCodes,
          barcode: barcodes,
          filter: filter
        };

        bagAndTagBackendService.searchPicklist({
          code: SETTINGS.projectCode
        }, searchQuery, function (response) {
          deferred.resolve(response);
        }, function (error) {
          deferred.reject(error);
        });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    function searchBagAndTagHeadersManifest(bagAndTagNumbersSelected, workpackNumbersSelected, issuesSelected, returnsSelected, transfersSelected,
                                            poNumbersSelected, materialCodesSelected, costCodesSelected, barcodesSelected, filter) {
      var deferred = $q.defer();

      if (bagAndTagNumbersSelected.length > 0 || workpackNumbersSelected.length > 0 || issuesSelected.length > 0 || returnsSelected.length > 0 || transfersSelected.length > 0 ||
        poNumbersSelected.length > 0 || materialCodesSelected.length > 0 || costCodesSelected.length > 0 || barcodesSelected.length > 0 || filter.length > 0) {

        var bagAndTagNumbers = urlHelperService.getSelectedValues(bagAndTagNumbersSelected, 'number');
        var workpackNumbers = urlHelperService.getSelectedValues(workpackNumbersSelected, 'workpackNumber');
        var issues = urlHelperService.getSelectedValues(issuesSelected, 'id');
        var returns = urlHelperService.getSelectedValues(returnsSelected, 'id');
        var transfers = urlHelperService.getSelectedValues(transfersSelected, 'id');
        var poNumbers = urlHelperService.getSelectedValues(poNumbersSelected, 'number');
        var materialCodes = urlHelperService.getSelectedValues(materialCodesSelected, 'materialCode');
        var costCodes = urlHelperService.getSelectedValues(costCodesSelected, 'costCode');
        var barcodes = urlHelperService.getSelectedValues(barcodesSelected, 'barcode');

        var searchQuery = {
          bagAndTagNumber: bagAndTagNumbers,
          workpackNumber: workpackNumbers,
          issue: issues,
          returns: returns,
          transfer: transfers,
          poNumber: poNumbers,
          materialCode: materialCodes,
          costCode: costCodes,
          barcode: barcodes,
          filter: filter
        };

        bagAndTagBackendService.searchManifest({
          code: SETTINGS.projectCode
        }, searchQuery, function (response) {
          deferred.resolve(response);
        }, function (error) {
          deferred.reject(error);
        });
      } else {
        deferred.resolve();
      }

      return deferred.promise;
    }

    function getBagAndTagGroupAndItems(bagAndTagId, groupId) {
      var deferred = $q.defer();

      bagAndTagBackendService.getBagAndTagGroupAndItems({
        code: SETTINGS.projectCode,
        id: bagAndTagId,
        groupId: groupId
      }, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getBagAndTagNumbers(hideIssue) {
      var deferred = $q.defer();

      var searchObject = {
        hideIssue : hideIssue
      };

      bagAndTagBackendService.getBagAndTagNumbers({
        code: SETTINGS.projectCode
      }, searchObject, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getBagAndTagNumbersAll() {
      var deferred = $q.defer();

      bagAndTagBackendService.getBagAndTagNumbersAll({
        code: SETTINGS.projectCode
      }, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getBagAndTagWorkpackNumbers(hideIssue) {
      var deferred = $q.defer();

      var searchObject = {
        hideIssue : hideIssue
      };

      bagAndTagBackendService.getBagAndTagWorkpackNumbers({
        code: SETTINGS.projectCode
      }, searchObject, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }

    function getManifestBagAndTagWorkpackNumbers(bagAndTagId) {
      var deferred = $q.defer();

      bagAndTagBackendService.getManifestBagAndTagWorkpackNumbers({
        code: SETTINGS.projectCode,
        id: bagAndTagId
      }, function (response) {
        deferred.resolve(response);
      }, function (error) {
        deferred.reject(error);
      });

      return deferred.promise;
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('bagAndTagBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_WAREHOUSE + 'bag-and-tag/:id', {id: '@id'}, {

        createBagAndTag: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag', method:'POST', params:{code:'@code'}},
        getBagAndTag: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/:id', method:'GET', params:{code:'@code', id:'@id'}},
        addItemToBagAndTag: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/:id/add-item', method:'PUT', params:{code:'@code', id:'@id'}},
        getBagAndTags: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag', method:'GET', params:{code:'@code'}, isArray:true},
        getBagAndTagItems: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/:id/bag-and-tag-items', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},
        getBagAndTagGroups: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/:id/bag-and-tag-groups', method:'GET', params:{code: '@code', id:'@id'}, isArray:true},
        deleteItemFromBagAndTag: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/:id/bag-and-tag-items/:storedItemLocationId', method:'DELETE', params:{code:'@code', id:'@id', storedItemLocationId:'@storedItemLocationId'}},
        deleteItemFromBagAndTagGroup: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/:id/bag-and-tag-items/:storedItemLocationId/:storedItemParentId', method:'DELETE', params:{code:'@code', id:'@id', storedItemLocationId:'@storedItemLocationId', storedItemParentId:'@storedItemParentId'}},
        deleteBagAndTag: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/:id', method:'DELETE', params:{code:'@code', id:'@id'}},
        createGroup: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/:id/create-group', method:'POST', params:{code:'@code', id:'@id'}},
        deleteGroupFromBagAndTag: {url:API.BASE_URI_WAREHOUSE + ":code/bag-and-tag/:id/bag-and-tag-groups/:storedItemLocationId", method:'DELETE', params:{code:'@code', id:'@id', storedItemLocationId:'@storedItemLocationId'}},
        getBagAndTagItemsAndGroups: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/:id/edit-groups', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},
        getBagAndTagGroupAndItems: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/:id/view-group/:groupId', method:'GET', params:{code:'@code', id:'@id', groupId:'@groupId'}, isArray:true},
        updateBagAndTagGroupItem: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/:id/edit-groups', method:'PUT', params:{code:'@code', id:'@id'}},
        search: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/search', method:'POST', params:{code:'@code'}, isArray:true},
        searchPicklist: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/search-picklist', method:'POST', params:{code:'@code'}, isArray:true},
        searchManifest: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/search-manifest', method:'POST', params:{code:'@code'}, isArray:true},
        getBagAndTagNumbers: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/bag-and-tag-numbers', method:'POST', params:{code:'@code'}, isArray:true},
        getBagAndTagNumbersAll: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/bag-and-tag-numbers-all', method:'POST', params:{code:'@code'}, isArray:true},
        getBagAndTagWorkpackNumbers: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/workpack-numbers', method:'POST', params:{code:'@code'}, isArray:true},
        getUnallocatedBagAndTags:{url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/unallocated', method:'GET', params:{code:'@code'}, isArray:true},
        getBagAndTagsIssued: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/issued', method:'GET', params:{code:'@code'}, isArray:true},
        getAllocatedBagAndTags: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/allocated', method:'GET', params:{code:'@code'}, isArray:true},
        getManifestBagAndTagWorkpackNumbers: {url:API.BASE_URI_WAREHOUSE + ':code/bag-and-tag/:id/manifest-workpack-numbers', method:'GET', params:{code:'@code', id:'@id'}, isArray:true},
      });
    });
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('adminService', adminService);

  adminService.$inject = ['adminBackendService', 'SETTINGS'];

  function adminService(adminBackendService, SETTINGS) {

    var service = {
      getUsers: getUsers,
      getUsersForProject: getUsersForProject,
      getUser: getUser,
      getRoles: getRoles,
      getPermissions: getPermissions,
      addClaim: addClaim,
      removeClaim: removeClaim,
      savePermissions: savePermissions,
      updatePassword: updatePassword,
      updateUserDetails: updateUserDetails,
      updateLockStatus: updateLockStatus,
      deleteUser: deleteUser,
      createUser: createUser,
      checkEmail: checkEmail,
      updateRole: updateRole
    };

    return service;

    //////////////////

    function getUsers() {
      return adminBackendService.getUsers().$promise.then(function (response) {
        return response;
      });

    }
    function getUsersForProject() {
      return adminBackendService.getUsersForProject(SETTINGS.projectCode).$promise.then(function (response) {
        return response;
      });
    }

    function getUser(id) {
      return adminBackendService.getUser({id: id}).$promise.then(function (response) {
        return response;
      });
    }

    function getRoles() {
      return adminBackendService.getRoles().$promise.then(function (response) {
        return response;
      });
    }

    function getPermissions(id) {
      return adminBackendService.getPermissions({id: id}).$promise.then(function (response) {
        return response;
      });
    }

    function addClaim(id, type, value) {
      var claim = {
        userId: id,
        type: type,
        value: value
      };

      return adminBackendService.addClaim({id: id}, claim).$promise.then(function (response) {
        return response;
      });
    }

    function removeClaim(id, type, value) {
      var claim = {
        userId: id,
        type: type,
        value: value
      };

      return adminBackendService.removeClaim({id: id}, claim).$promise.then(function (response) {
        return response;
      });
    }

    function savePermissions(id, permissions) {
      var claims = [];
      angular.forEach(permissions, function (resource) {
        angular.forEach(resource.permissions, function (value, key) {
          if (value === true) {
            var claim = {
              type: resource.resource,
              value: key
            };
            claims.push(claim);
          }
        });
      });
    }

    function updatePassword(id, oldPassword, newPassword){
      var data = {
        oldPassword: oldPassword,
        newPassword: newPassword
      };
      return adminBackendService.updatePassword({id: id}, data).$promise.then(function (response) {
        return response;
      }, function(error) {
        return error;
      });
    }

    function updateUserDetails(id, firstName, lastName, email, username, employeeId) {
      var data = {
        id: id,
        firstName: firstName,
        lastName: lastName,
        email: email,
        username: username,
        employeeId: employeeId
      };
      return adminBackendService.updateUserDetails({id: id}, data).$promise.then(function (response) {
        return response;
      });
    }

    function updateLockStatus(id, status) {
      return adminBackendService.updateLockStatus({id: id}, status).$promise.then(function (response) {
        return response;
      });
    }

    function deleteUser(id) {
      return adminBackendService.deleteUser({id: id}).$promise.then(function (response) {
        return response;
      });
    }

    function createUser(firstName, lastName, username, email, employeeId) {
      var data = {
        firstName: firstName,
        lastName: lastName,
        username: username,
        email: email,
        password: "materia",
        employeeId: employeeId
      };
      return adminBackendService.createUser(data).$promise.then(function (response) {
        return response;
      });
    }

    function checkEmail(email){
      var data = {
        email: email
      }
      return adminBackendService.checkEmail(data).$promise.then(function (response) {
        return response;
      });
    }

    function updateRole(id, type, value) {
      var claim = {
        userId: id,
        type: type,
        value: value
      };

      return adminBackendService.updateRole({id: id}, claim).$promise.then(function (response) {
        return response;
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('adminBackendService', function (API, $resource) {

      return $resource(API.BASE_URI_WAREHOUSE + 'admin/:id', {id: '@id'}, {

        getUsers: {url: API.BASE_URI_USERADMIN + 'users', method: 'GET', isArray: true},
        getUsersForProject: {url: API.BASE_URI_USERADMIN + 'users/:code', method: 'GET', params: {code: '@code'}, isArray: true},
        getUser: {url: API.BASE_URI_USERADMIN + 'user/:id', method: 'GET', params: {id: '@id'}},
        getRoles: {url: API.BASE_URI_USERADMIN + 'user/roles', method: 'GET', isArray: true},
        getPermissions: {url: API.BASE_URI_USERADMIN + 'user/:id/permissions', method: 'GET', params: {id: '@id'}, isArray: true},
        addClaim: {url: API.BASE_URI_USERADMIN + 'user/:id/add-claim', method: 'POST', params: {id: '@id'}},
        removeClaim: {url: API.BASE_URI_USERADMIN + 'user/:id/remove-claim', method: 'POST', params: {id: '@id'}},
        updatePassword: {url: API.BASE_URI_USERADMIN + 'user/:id/update-password', method: 'PUT', params: {id: '@id'}},
        updateUserDetails: {url: API.BASE_URI_USERADMIN + 'user/:id', method: 'PUT', params: {id: '@id'}},
        updateLockStatus: {url: API.BASE_URI_USERADMIN + 'user/:id/lock', method: 'PUT', params: {id: '@id'}},
        deleteUser: {url: API.BASE_URI_USERADMIN + 'user/:id', method: 'DELETE', params: {id: '@id'}},
        createUser: {url: API.BASE_URI_USERADMIN + 'user/create', method: 'POST'},
        checkEmail: {url: API.BASE_URI_USERADMIN + 'user/check-email', method: 'POST'},
        updateRole: {url: API.BASE_URI_USERADMIN + 'user/:id/role', method: 'PUT', params: {id: '@id'}}

      });
    });
})();

(function () {
  'use strict';

  angular.module('app.transfers', []);

})();

(function () {
  'use strict';

  angular
    .module('app.transfers')
    .controller('ViewTransfersCtrl', ViewTransfersCtrl);

  ViewTransfersCtrl.$inject = ['transferService'];

  /* @ngInject */
  function ViewTransfersCtrl(transferService) {
    var vm = this;
    vm.transfers = [];
    vm.completedTransfers = [];

    activate();

    ///////////////////////

    function activate(){

      transferService.getTransfers()
        .then(function(response) {
          vm.transfers = response;
        });

      transferService.getTransfersCompleted()
       .then(function(response) {
         vm.completedTransfers = response;
       });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.transfers')
    .controller('ViewTransferCtrl', ViewTransferCtrl);

  ViewTransferCtrl.$inject = ['$stateParams', '$filter', '$timeout', 'transferService', 'SweetAlert', '$uibModal', 'OidcManager', 'SETTINGS', 'API'];

  /* ngInject */
  function ViewTransferCtrl($stateParams, $filter, $timeout, transferService, SweetAlert, $uibModal, OidcManager, SETTINGS, API) {
    var vm = this;

    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.transferId = $stateParams.id;
    vm.transfer = {};
    vm.searching = false;
    vm.results = undefined;
    vm.bagAndTagResults = undefined;

    vm.transferItems = [];
    vm.transferCostCodeItems = [];
    vm.transferBagAndTagItemsOptions = [];
    vm.transferBagAndTagItems = [];
    vm.transferBagAndTagItemsContainer = [];
    vm.transferBagAndTagItemCount = 0;

    vm.validationErrors = [];
    vm.hasErrors = false;

    vm.tabs = {
      storedItemsActive: true,
      bagAndTagActive: false,
      storedItemsCostCodeActive: false,

      storedItemsResultsActive: true,
      bagAndTagResultsActive: false
    };

    vm.transferBagAndTagItems = vm.transferBagAndTagItemsContainer;

    vm.getTransfer = getTransfer;
    vm.getTransferItems = getTransferItems;
    vm.getTransferCostCodeItems = getTransferCostCodeItems;
    vm.fakeTransferItems = fakeTransferItems;
    vm.fakeTransferCostCodeItems = fakeTransferCostCodeItems;
    vm.addItems = addItems;
    vm.addCostCodeItems = addCostCodeItems;
    vm.removeItem = removeItem;
    vm.removeCostCodeItem = removeCostCodeItem;
    vm.returnItemToStock = returnItemToStock;
    vm.greaterThan = greaterThan;
    vm.completeTransfer = completeTransfer;
    vm.cancelTransfer = cancelTransfer;
    vm.showValidationErrors = showValidationErrors;
    vm.transferBagAndTag = transferBagAndTag;
    vm.updateItems = updateItems;
    vm.updateCostCodeItems = updateCostCodeItems;
    vm.removeBagAndTagItem = removeBagAndTagItem;
    vm.refreshBagAndTagItems = refreshBagAndTagItems;
    vm.fakeBagAndTagItems = fakeBagAndTagItems;
    vm.setActiveTab = setActiveTab;

    activate();

    ////////////////////

    function activate() {
      return getTransfer().then(function () {
        if (vm.transfer.transferStatus !== "Cancelled") {
          return getTransferItems().then(function () {
            return getTransferCostCodeItems().then(function () {
              return getTransferBagAndTagItems().then(function () {
                vm.transferBagAndTagItemCount = $filter('filter')(vm.transferBagAndTagItems, {bagAndTagId: '!' + null}, true).length;
                return vm.setActiveTab();
              });
            });
          });
        }
        else {
          vm.transferItems = [];
          vm.transferCostCodeItems = [];
          vm.transferBagAndTagItemsOptions = [];
          vm.transferBagAndTagItems = [];
          vm.transferBagAndTagItemsContainer = [];
        }
      });
    }

    function getTransfer() {
      return transferService.getTransfer(vm.transferId)
        .then(function (response) {
          vm.transfer = response;

          return vm.transfer;
        });
    }

    function getTransferItems() {
      return transferService.getTransferItems(vm.transferId)
        .then(function (response) {
          vm.transferItems = response;
        });
    }

    function getTransferCostCodeItems() {
      return transferService.getTransferCostCodeItems(vm.transferId)
        .then(function (response) {
          vm.transferCostCodeItems = response;
        });
    }


    function getTransferBagAndTagItems() {
      return transferService.getTransferBagAndTagItems(vm.transferId)
        .then(function (response) {
          vm.transferBagAndTagItemsContainer = response;
          bagAndTagItems.read();
        });
    }

    function fakeTransferItems(transferItems) {
      angular.forEach(transferItems, function (item) {
        if (!addToExistingItem(item)) {
          vm.transferItems.push(angular.copy(item));
        }
        deductQuantityFromStockItems(item.storedItemId, item.storedItemLocationId, item.newLocationId, item.costCode, item.barcode, item.selectedQuantity);
      });

      vm.tabs.storedItemsActive = true;
    }


    function fakeTransferCostCodeItems(transferItems) {
      angular.forEach(transferItems, function (item) {
        if (!addToExistingCostCodeItem(item)) {
          vm.transferCostCodeItems.push(angular.copy(item));
        }
        deductQuantityFromStockItems(item.storedItemId,item.storedItemLocationId, item.locationId, item.newCostCode, item.barcode, item.selectedQuantity);
      });

      vm.tabs.storedItemsCostCodeActive = true;
    }

    function addToExistingItem(item) {

      var storedItemLocation = $filter('filter')(vm.transferItems, {storedItemLocationId: item.storedItemLocationId, newLocationId: item.newLocationId})[0];

      if (storedItemLocation != undefined) {
        storedItemLocation.class = "badge-non-bold backgroundAnimated";
        storedItemLocation.selectedQuantity = parseFloat(storedItemLocation.selectedQuantity) + parseFloat(item.selectedQuantity);
        $timeout(function () {
          storedItemLocation.class = "badge-transparent";
        }, 1000);
        return true;
      }

    }

    function addToExistingCostCodeItem(item) {

      var storedItemLocation = $filter('filter')(vm.transferCostCodeItems, {storedItemLocationId: item.storedItemLocationId, newCostCode: item.newCostCode})[0];

      if (storedItemLocation != undefined) {
        storedItemLocation.class = "badge-non-bold backgroundAnimated";
        storedItemLocation.selectedQuantity = parseFloat(storedItemLocation.selectedQuantity) + parseFloat(item.selectedQuantity);
        $timeout(function () {
          storedItemLocation.class = "badge-transparent";
        }, 1000);
        return true;
      }

    }

    function fakeBagAndTagItems(transferBagAndTagItems) {
      angular.forEach(transferBagAndTagItems, function (item) {
        if (getIndexByAttribute(vm.transferBagAndTagItemsContainer, 'id', item.id) < 0) {
          vm.transferBagAndTagItemsContainer.push(angular.copy(item));
        }
      });
      refreshBagAndTagItems();

      vm.tabs.bagAndTagActive = true;
    }

    function deductQuantityFromStockItems(storedItemId, storedItemLocationId, locationId, costCode, barcode, qty) {

      var storedItem = $filter('filter')(vm.results, {storedItemId: storedItemId})[0];
      $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].isIncluded = false;
      $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].selectedQuantity = "";
      $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].quantity -= parseFloat(qty);

      var itemToIncrease = $filter('filter')(storedItem.storedItems, {locationId: locationId, costCode: costCode, barcode: barcode})[0];

      if(itemToIncrease != undefined) {
        itemToIncrease.class = "badge-non-bold backgroundAnimated";
        itemToIncrease.quantity += parseFloat(qty);
        $timeout(function () {
          itemToIncrease.class = "badge-transparent";
        }, 1000);
      }

    }

    function addItems(results) {
      $uibModal.open({
        templateUrl: 'app/common/addItemsModal.html',
        controller: 'AddItemsModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          items: function () {
            return results;
          },
          itemId: function () {
            return vm.transferId;
          },
          fakeItems: function () {
            return vm.fakeTransferItems;
          },
          isReturn: function () {
            return false;
          },
          updateItems: function () {
            return vm.updateItems;
          }
        }
      });
    }

    function addCostCodeItems(results) {
      $uibModal.open({
        templateUrl: 'app/transfers/addCostCodeItemsModal.html',
        controller: 'AddCostCodeItemsModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          items: function () {
            return results;
          },
          itemId: function () {
            return vm.transferId;
          },
          fakeItems: function () {
            return vm.fakeTransferCostCodeItems;
          },
          updateItems: function () {
            return vm.updateCostCodeItems;
          }
        }
      });
    }


    function removeItem(item) {
      if (vm.results !== undefined) {
        vm.returnItemToStock(item, false);
      }
      var index = vm.transferItems.indexOf(item);
      vm.transferItems.splice(index, 1);

      return transferService.removeItemFromTransfer(vm.transferId, item.storedItemLocationId, item.newLocationId)
        .then(function (response) {
          SweetAlert.swal("Item removed!", "Item removed from transfer.", "success");
        }, function (error) {
          showValidationErrors(error);
        });
    }

    function removeCostCodeItem(item) {
      if (vm.results !== undefined) {
        vm.returnItemToStock(item, true);
      }
      var index = vm.transferCostCodeItems.indexOf(item);
      vm.transferCostCodeItems.splice(index, 1);

      return transferService.removeCostCodeItemFromTransfer(vm.transferId, item.storedItemLocationId, item.newCostCode)
        .then(function (response) {
          SweetAlert.swal("Item removed!", "Item removed from transfer.", "success");
        }, function (error) {
          showValidationErrors(error);
        });
    }

    function returnItemToStock(item, isCostCode) {

      angular.forEach(vm.results, function(storedItem) {
        var storedItemLocation = $filter('filter')(storedItem.storedItems, {storedItemLocationId: item.storedItemLocationId})[0];

        if (storedItemLocation != undefined) {

          storedItemLocation.class = "badge-non-bold backgroundAnimated";
          storedItemLocation.quantity = parseFloat(storedItemLocation.quantity) + parseFloat(item.selectedQuantity);

          $timeout(function () {
            storedItemLocation.class = "badge-transparent";
          }, 1000);
        }

        var storedItemLocationToDecrease = $filter('filter')(storedItem.storedItems, {
          costCode: isCostCode ? item.newCostCode : item.costCode,
          barcode: item.barcode,
          locationId: isCostCode ? item.locationId : item.newLocationId})[0];

        if (storedItemLocationToDecrease != undefined) {

          storedItemLocationToDecrease.class = "badge-non-bold backgroundAnimated";
          storedItemLocationToDecrease.quantity = parseFloat(storedItemLocationToDecrease.quantity) - parseFloat(item.selectedQuantity);

          $timeout(function () {
            storedItemLocationToDecrease.class = "badge-transparent";
          }, 1000);
        }
      });

    }

    function transferBagAndTag(item) {
      $uibModal.open({
        templateUrl: 'app/transfers/addBagAndTagModal.html',
        controller: 'AddBagAndTagModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          bagAndTag: function () {
            return item;
          },
          transferId: function () {
            return vm.transferId;
          },
          fakeBagAndTagItems: function () {
            return vm.fakeBagAndTagItems;
          },
          postUpdateDelegate: function () {
            return refreshBagAndTagItems;
          }
        }
      });
    }

    function removeBagAndTagItem(item) {
      var index = getIndexByAttribute(vm.transferBagAndTagItemsContainer, 'id', item.id);
      var bagAndTagItem = $filter('filter')(vm.transferBagAndTagItemsContainer, {id: item.id});
      return transferService.removeBagAndTagItemFromTransfer(vm.transferId, item.storedItemLocationId, item.newLocationId, bagAndTagItem[0].bagAndTagId)
        .then(function (response) {
          vm.transferBagAndTagItemsContainer.splice(index, 1);
          bagAndTagItems.read();
          SweetAlert.swal("Item removed!", "Bag & tag item removed from transfer.", "success");
        }, function (error) {
          showValidationErrors(error);
        });
    }

    function getIndexByAttribute(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    }

    function completeTransfer() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "You can not edit the transfer after it is closed!",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, close it!",
          cancelButtonText: "Cancel",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return transferService.completeTransfer(vm.transferId)
            .then(function (response) {
                if (response.status !== 403) {
                  activate();
                  SweetAlert.swal("Closed!", "The transfer is now closed.", "success");
                }
                vm.loading = false;
              }, function (error) {
                showValidationErrors(error);
              }
            );
        });
    }

    function cancelTransfer() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "Cancelling this transfer will return all items to stock.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ED5565",
          confirmButtonText: "Yes, cancel it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return transferService.cancelTransfer(vm.transferId)
            .then(function (response) {
              if (response.status !== 403) {
                activate();
                SweetAlert.swal("Cancelled!", "The transfer is now cancelled.", "success");
              }
              vm.loading = false;
            }, function (error) {
              showValidationErrors(error);
            });
        });
    }

    function displayNotification(message) {
      SweetAlert.swal({
          title: "Quantity unavailable",
          text: message,
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Close",
          closeOnConfirm: false
        }
      );
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not search for stored items.');
      }
      vm.loading = false;
    }

    function greaterThan(prop, val) {
      return function (item) {
        return item[prop] > val;
      };
    }


    function updateItems(itemsToUpdate, locationId) {
      vm.itemsToTransfer = [];
      angular.forEach(itemsToUpdate, function (value, key) {
        vm.itemsToTransfer.push({
          storedItemId: value.id,
          storedItemLocationId: value.storedItemLocationId,
          quantity: parseFloat(value.selectedQuantity)
        });
      });

      var items = {
        transferId: vm.transferId,
        locationId: locationId,
        transferItems: vm.itemsToTransfer
      };
      return transferService.transferItems(items);
    }

    function updateCostCodeItems(itemsToUpdate, costCode) {
      vm.itemsToTransfer = [];
      angular.forEach(itemsToUpdate, function (value, key) {
        vm.itemsToTransfer.push({
          storedItemId: value.id,
          storedItemLocationId: value.storedItemLocationId,
          quantity: parseFloat(value.selectedQuantity)
        });
      });

      var items = {
        transferId: vm.transferId,
        costCode: costCode,
        transferItems: vm.itemsToTransfer
      };
      return transferService.transferCostCodeItems(items);
    }


    var bagAndTagItems = new kendo.data.TreeListDataSource({
      transport: {
        read: function (options) {
          vm.transferBagAndTagItems = angular.copy(vm.transferBagAndTagItemsContainer);
          var data = vm.transferBagAndTagItems;
          options.success(data);
        },
        dataType: "json"
      },
      schema: {
        model: {
          id: "id",
          expanded: true,
          fields: {
            parentId: {field: "bagAndTagId", nullable: true},
            id: {field: "id", type: "string"}
          }
        }
      }
    });

    vm.transferBagAndTagItemsOptions = {
      dataSource: bagAndTagItems,
      columns: [
        {
          template: "<span ng-show='dataItem.parentId === null'>" +
          "<wg-edit-grouped-items is-read-only='true' is-bag-and-tag-view='true' bag-and-tag-id='{{dataItem.id}}' description='{{dataItem.description}}'></wg-edit-grouped-items></span>",
          width: "71px"
        },
        {field: "description", title: "Description"},
        {
          title: "Previous Location",
          template: "<span ng-hide='dataItem.parentId === null'>{{ dataItem.warehouseName }}/{{ dataItem.locationName }}</span>"
        },
        {
          title: "New Location",
          template: "<span ng-hide='dataItem.parentId === null'>{{ dataItem.newWarehouseName }}/{{ dataItem.newLocationName }}</span>"
        },
        {
          template: "<button type='button' class='btn btn-danger btn-sm pull-right' ng-click='vm.removeBagAndTagItem(dataItem)' ng-hide='dataItem.parentId === null'><i class='fa fa-times' aria-hidden='true'></i></button>",
          width: "50px"
        }
      ]
    };

    function refreshBagAndTagItems() {
      bagAndTagItems.read();
    }

    function setActiveTab() {
      if (vm.transferItems.length > 0) {
        vm.tabs.storedItemsActive = true;
      }
      else if (vm.transferBagAndTagItems.length > 0) {
        vm.tabs.bagAndTagActive = true;
      }
      else if (vm.transferCostCodeItems.length > 0) {
        vm.tabs.storedItemsCostCodeActive = true;
      }

    }

  }
})
();

(function () {
  'use strict';

  angular
    .module('app.transfers')
    .controller('CreateTransferCtrl', CreateTransferCtrl);

  CreateTransferCtrl.$inject = ['transferService', '$state'];
  /* @ngInject */
  function CreateTransferCtrl(transferService, $state) {
    if ($state.transition) return;

    var vm = this;
    vm.loading = false;
    vm.transfer = {
      description: ''
    };

    vm.createTransfer = createTransfer;
    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;

    activate();

    /////////////////////

    function activate() {

    }

    function createTransfer() {
      vm.loading = true;
      return transferService.createTransfer(vm.transfer)
        .then(function(response) {
          if (response.status !== 403) {
            vm.hasErrors = false;
            $state.transitionTo('transfer.details', {id: response.transferId});
          }
          vm.loading = false;
        }, function(error){
          vm.hasErrors = true;
          showValidationErrors(error);
        });
    }

    function showValidationErrors(error){
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessages);
        }
      } else {
        vm.validationErrors.push('Could not create transfer.');
      }
      vm.loading = false;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.transfers')
    .controller('AddCostCodeItemsModalCtrl', AddCostCodeItemsModalCtrl);

  AddCostCodeItemsModalCtrl.$inject = ['$uibModalInstance', 'API', 'SETTINGS', 'OidcManager', 'items', 'itemId', 'fakeItems', 'updateItems'];

  function AddCostCodeItemsModalCtrl($uibModalInstance, API, SETTINGS, OidcManager, items, itemId, fakeItems, updateItems) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.transferItem = {};
    vm.items = items;
    vm.itemId = itemId;
    vm.fakeItems = fakeItems;
    vm.updateItems = updateItems;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.itemsToTransfer = [];

    /** Cost codes */
    vm.costCodes = [];
    vm.costCodesOptions = [];
    vm.costCodeSelected = undefined;

    activate();

    ///////////////

    function activate() {

    }


    vm.ok = function () {
      vm.saving = true;
      vm.saved = false;

      vm.updateItems(vm.items, vm.transferItem.costCode)
        .then(function (response) {

          vm.fakedItems = [];
          angular.forEach(vm.items, function (value, key) {
            vm.fakedItems.push({
              description: value.description,
              costCode: value.costCode,
              materialCode: value.materialCode,
              barcode: value.barcode,
              storedItemId: value.id,
              id: value.id,
              storedItemLocationId: value.storedItemLocationId,
              selectedQuantity: parseFloat(value.selectedQuantity),
              warehouseName: value.warehouseName,
              locationName: value.locationName,
              newCostCode: vm.transferItem.costCode
            });
          });

          vm.fakeItems(vm.fakedItems);

          vm.error = false;
          vm.saved = true;
          vm.saving = false;

        }, function () {

          vm.saved = false;
          vm.error = true;
          vm.saving = false;
        });
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };


    /** Cost Codes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/stored-items/cost-codes',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.costCodesOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false
    };

  }


})();


(function () {
  'use strict';

  angular
    .module('app.transfers')
    .controller('AddBagAndTagModalCtrl', AddBagAndTagModalCtrl);

  AddBagAndTagModalCtrl.$inject = ['$uibModalInstance', '$filter', 'transferService', 'API', 'SETTINGS', 'OidcManager', 'transferId', 'bagAndTag', 'fakeBagAndTagItems', 'postUpdateDelegate'];

  function AddBagAndTagModalCtrl($uibModalInstance, $filter, transferService, API, SETTINGS, OidcManager, transferId, bagAndTag, fakeBagAndTagItems, postUpdateDelegate) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.transferId = transferId;
    vm.fakeBagAndTagItems = fakeBagAndTagItems;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.itemsToTransfer = [];

    /** Locations */
    vm.locations = [];
    vm.locationOptions = [];
    vm.locationSelected = undefined;

    /** Stored items */
    vm.storedItems = [];
    vm.storedItemsOptions = [];

    activate();

    ///////////////

    function activate() {

    }

    vm.ok = function () {
      vm.saving = true;
      vm.saved = false;

      vm.itemsToTransfer = [];

      var selectedItems = $filter('filter')(vm.storedItemsOptions.dataSource.data(), {isIncluded: true});
      angular.forEach(selectedItems, function (value, key) {
        vm.itemsToTransfer.push({
          storedItemId: value.id,
          storedItemLocationId: value.storedItemLocationId,
          quantity: parseFloat(value.selectedQuantity),
          bagAndTagId: bagAndTag.id
        });
      });

      var items = {
        transferId: vm.transferId,
        locationId: vm.locationSelected.id,
        transferItems: vm.itemsToTransfer
      };

      transferService.transferItems(items)
        .then(function (response) {

          vm.fakeItems = [];

          vm.fakeItems.push({
            description: bagAndTag.description,
            materialCode: null,
            barcode: bagAndTag.barcode,
            storedItemId: bagAndTag.storedItemId,
            id: bagAndTag.id,
            storedItemLocationId: bagAndTag.storedItemLocationId,
            warehouseName: null,
            newWarehouseName: null,
            locationName: null,
            newLocationName: null,
            newLocationId: null,
            bagAndTagId: null,
            transferId: transferId,
            unitOfMeasureCode: null,
            selectedQuantity: 0,
            poNumber: null,
            poLineNumber: null
          });

          angular.forEach(selectedItems, function(value, key) {
            vm.fakeItems.push({
              description: value.description,
              materialCode: value.materialCode,
              barcode: value.barcode,
              storedItemId: value.id,
              id: value.id,
              storedItemLocationId: value.storedItemLocationId,
              warehouseName: value.warehouseName,
              newWarehouseName: vm.locationSelected.warehouseName,
              locationName: value.locationName,
              newLocationName: vm.locationSelected.name,
              newLocationId: vm.locationSelected.id,
              bagAndTagId: bagAndTag.id,
              transferId: transferId,
              unitOfMeasureCode: value.unitOfMeasureCode,
              selectedQuantity: value.selectedQuantity,
              poNumber: value.poNumber,
              poLineNumber: value.poLineNumber
            });
          });

          vm.fakeBagAndTagItems(vm.fakeItems);

          vm.error = false;
          vm.saved = true;
          vm.saving = false;
          postUpdateDelegate();
        }, function () {
          vm.saved = false;
          vm.error = true;
          vm.saving = false;
        });
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    /** Locations */

    vm.locations = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      },
      group: {field: "warehouseName"}
    };

    vm.locationOptions = {
      dataSource: vm.locations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };

    /** Stored items */

    var storedItems = new kendo.data.TreeListDataSource({
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/bag-and-tag/' + bagAndTag.id + '/edit-groups',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        },
        dataType: "json"
      },
      schema: {
        model: {
          id: "storedItemId",
          expanded: true,
          fields: {
            parentId: {field: "storedItemParentId", nullable: true},
            storedItemId: {field: "storedItemId", type: "string"}
          }
        }
      }
    });

    vm.storedItemsOptions = {
      dataSource: storedItems,
      height: 450,
      sortable: true,
      editable: {
        move: false
      },
      dataBound: function (e) {
        onDataBound(e);
      },
      columns: [
        {field: "description", title: "Description", width: "420px"},
        {field: "barcode", title: "Barcode", width: "140px"},
        {
          title: "Location", width: "150px",
          template: "<span ng-hide='dataItem.parentId !== null'>{{ dataItem.warehouseName }}/{{ dataItem.locationName }}</span>"
        },
        {
          title: "Qty",
          template: "<span ng-show='dataItem.selectedQuantity > 0'>{{dataItem.selectedQuantity}}</span>",
          width: "60px"
        },
        {
          template: "<span ng-hide='dataItem.parentId !== null'><input icheck type='checkbox' ng-model='dataItem.isIncluded'/></span>"
        }
      ]
    };

    function onDataBound(e) {
      var rows = e.sender.tbody.children();

      for (var i = 0; i < rows.length; i++) {
        var row = angular.element(rows[i]);
        var dataItem = e.sender.dataItem(row);

        if (dataItem.isContainer) {
          row.addClass("group-parent");
          row.addClass("isContainer");
        }
        else if (dataItem.parentId !== null) {
          row.addClass("group-child");
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.returns', []);

})();

(function () {
  'use strict';

  angular
    .module('app.returns')
    .controller('ViewReturnsCtrl', ViewReturnsCtrl);

  ViewReturnsCtrl.$inject = ['$state', 'returnService'];

  /* @ngInject */
  function ViewReturnsCtrl($state, returnService) {
    var vm = this;
    vm.completedReturns = [];
    vm.incompleteReturns = [];

    activate();

    ///////////////////////

    function activate(){

      returnService.getReturnsCompleted()
        .then(function(response) {
          vm.completedReturns = response;
        });

      returnService.getReturnsIncomplete()
        .then(function(response) {
          vm.incompleteReturns = response;
        });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.returns')
    .controller('ViewReturnCtrl', ViewReturnCtrl);

  ViewReturnCtrl.$inject = ['$stateParams', '$filter', '$timeout', 'returnService', 'SweetAlert', '$uibModal'];

  /* ngInject */
  function ViewReturnCtrl($stateParams, $filter, $timeout, returnService, SweetAlert, $uibModal) {
    var vm = this;

    vm.returnId = $stateParams.id;
    vm.return = {};
    vm.searching = false;
    vm.results = undefined;
    vm.bagAndTagResults = undefined;

    vm.returnItems = [];
    vm.returnBagAndTagItems = [];
    vm.returnBagAndTagItemsOptions = [];
    vm.returnBagAndTagItemsContainer = [];

    vm.validationErrors = [];
    vm.hasErrors = false;

    vm.tabs = {
      storedItemsActive: true,
      bagAngTagsActive: false,
      storedItemsResultsActive: true,
      bagAndTagResultsActive: false
    };

    vm.returnBagAndTagItems = vm.returnBagAndTagItemsContainer;

    vm.getReturn = getReturn;
    vm.completeReturn = completeReturn;
    vm.cancelReturn = cancelReturn;
    vm.addItems = addItems;
    vm.addBagAndTag = addBagAndTag;
    vm.fakeReturnItems = fakeReturnItems;
    vm.fakeReturnBagAndTagItems = fakeReturnBagAndTagItems;
    vm.removeItem = removeItem;
    vm.removeBagAndTagItem = removeBagAndTagItem;
    vm.showValidationErrors = showValidationErrors;
    vm.greaterThan = greaterThan;
    vm.updateItems = updateItems;

    activate();

    ////////////////////

    function activate() {
      return getReturn().then(function () {
        if(vm.return.returnStatus !== "Cancelled") {
          return getReturnItems().then(function () {
            return getReturnBagAndTagItems().then(function () {
            });
          });
        }
        else{
          vm.returnItems = [];
          vm.returnBagAndTagItems = [];
          vm.returnBagAndTagItemsOptions = [];
          vm.returnBagAndTagItemsContainer = [];
          refreshBagAndTagItems();
        }
      });
    }

    function completeReturn() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "You can not edit the return after it is complete!",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, complete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false},
        function(isConfirm){
          if (!isConfirm) return;
          vm.loading = true;
          return returnService.completeReturn(vm.returnId)
            .then(function(response) {
                vm.loading = false;
                activate();

                SweetAlert.swal("Completed!", "The return is now complete.", "success");
              },function(error){
                showValidationErrors(error);
              }
            );
        });
    }

    function cancelReturn() {
      SweetAlert.swal({
        title: "Are you sure?",
        text: "Cancelling this return will return all items to stock.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ED5565",
        confirmButtonText: "Yes, cancel it!",
        cancelButtonText: "Close",
        closeOnConfirm: false},
      function(isConfirm){
        if (!isConfirm) return;
        vm.loading = true;
        return returnService.cancelReturn(vm.returnId)
          .then(function(response) {
            vm.loading = false;
            activate();
            SweetAlert.swal("Cancelled!", "The return is now cancelled.", "success");
          }, function(error) {
            showValidationErrors(error);
          });
      });
    }

    function getReturn() {
      return returnService.getReturn(vm.returnId)
        .then(function(response) {
          vm.return = response;

          return vm.return;
        });
    }

    function getReturnItems() {
      return returnService.getReturnItems(vm.returnId)
        .then(function(response) {
          vm.returnItems = response;
        });
    }

    function getReturnBagAndTagItems() {
      return returnService.getReturnBagAndTagItems(vm.returnId)
        .then(function(response) {
          vm.returnBagAndTagItemsContainer = response;
          bagAndTagItems.read();
        });
    }


    function addItems(results) {
      $uibModal.open({
        templateUrl: 'app/common/addItemsModal.html',
        controller: 'AddItemsModalCtrl',
        controllerAs: 'vm',
        size:'lg',
        resolve: {
          items: function () {
            return results;
          },
          itemId: function () {
            return vm.returnId;
          },
          fakeItems: function(){
            return vm.fakeReturnItems;
          },
          isReturn: function(){
            return true;
          },
          updateItems: function(){
            return vm.updateItems;
          }
        }
      });
    }

    function fakeReturnItems(returnItems) {
      angular.forEach(returnItems, function(item){
        if (!addToExistingItem(item)) {
          vm.returnItems.push(angular.copy(item)); }
        deductQuantityFromStockItems(item.storedItemLocationId, item.issueNumber, item.selectedQuantity);
      });
    }

    function addToExistingItem(item) {
      for (var i=0;i < vm.returnItems.length; i++) {
        if (vm.returnItems[i].storedItemLocationId === item.storedItemLocationId && vm.returnItems[i].newLocationId === item.newLocationId && vm.returnItems[i].issueNumber === item.issueNumber ) {
          vm.returnItems[i].selectedQuantity = parseFloat(vm.returnItems[i].selectedQuantity) + parseFloat(item.selectedQuantity);
          vm.returnItems[i].class = "backgroundAnimated";
          $timeout(function () {
            vm.returnItems[i].class = "";
          }, 1000);
          return true;
        }
      }
    }

    function fakeReturnBagAndTagItems(returnBagAndTagItems){
      angular.forEach(returnBagAndTagItems, function(item) {
        var index = vm.returnBagAndTagItemsContainer.map(function(item) {
          return item.id;
        }).indexOf(item.id);
        if (index < 0) {
          vm.returnBagAndTagItemsContainer.push(angular.copy(item));
        } else {
          vm.returnBagAndTagItemsContainer[index].selectedQuantity = parseFloat(vm.returnBagAndTagItemsContainer[index].selectedQuantity) + parseFloat(item.selectedQuantity);
        }
      });
      refreshBagAndTagItems();
        vm.tabs.storedItemsActive = false;
        vm.tabs.bagAndTagsActive = true;
    }

    function addBagAndTag(item) {
      return returnService.addBagAndTagToReturn(vm.returnId, item.id)
        .then(function(response) {
          if (response.responseMessage === 'Success') {
            vm.returnBagAndTagItems.push(item);
            var index = vm.bagAndTagResults.indexOf(item);
            vm.bagAndTagResults.splice(index, 1);
            vm.tabs.bagAndTagsActive = true;
          } else {
            displayNotification(response.responseMessage);
          }
        });
    }

    function removeItem(item) {
      if (vm.results !== undefined) {
        returnItemToStock(item);
      }
      var index = vm.returnItems.indexOf(item);
      vm.returnItems.splice(index, 1);

      return returnService.removeItemFromReturn(vm.returnId, item.storedItemLocationId, item.newLocationId, item.issueItemId)
        .then(function(response) {

        },function(error){
          showValidationErrors(error);
        });
    }

    function returnItemToStock(item) {
      for (var i = 0; i < vm.results.length; i++) {
        if (vm.results[i].storedItemLocationId === item.storedItemLocationId && vm.results[i].issueNumber === item.issueNumber ) {
          vm.results[i].quantity = parseFloat(vm.results[i].quantity) + parseFloat(item.selectedQuantity);
          vm.results[i].class = "backgroundAnimated";
          $timeout(function () {
            vm.results[i].class = "";
          }, 1000);
          return true;
        }
      }
    }

    function deductQuantityFromStockItems(storedItemLocationId, issueNumber, qty) {
      $filter('filter')(vm.results, {storedItemLocationId: storedItemLocationId, issueNumber:issueNumber})[0].quantity -= qty;
      $filter('filter')(vm.results, {storedItemLocationId: storedItemLocationId, issueNumber:issueNumber})[0].selectedQuantity = "";
      $filter('filter')(vm.results, {storedItemLocationId: storedItemLocationId, issueNumber:issueNumber})[0].isIncluded = false;
    }

    function removeBagAndTagItem(item) {
      var bagAndTagItem = $filter('filter')(vm.returnBagAndTagItemsContainer, {returnItemId:item.returnItemId});
      var index = getIndexByAttribute(vm.returnBagAndTagItemsContainer, 'returnItemId', item.returnItemId);
      return returnService.removeBagAndTagItemFromReturn(vm.returnId, item.returnItemId)
        .then(function(response) {
          vm.returnBagAndTagItemsContainer.splice(index, 1);
          bagAndTagItems.read();
          SweetAlert.swal("Item removed!", "Bag & tag item removed from return.", "success");
        }, function(error) {
          showValidationErrors(error);
        });
    }

    function displayNotification(message) {
      SweetAlert.swal({
          title: "Quantity unavailable",
          text: message,
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Close",
          closeOnConfirm: false}
        );
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not search for stored items.');
      }
      vm.loading = false;
    }

    function greaterThan(prop, val){
      return function(item){
        return item[prop] > val;
      };
    }

    function updateItems(itemsToUpdate, locationId){
      vm.itemsToReturn = [];
      angular.forEach(itemsToUpdate, function (value, key) {
        vm.itemsToReturn.push({
          storedItemId: value.id,
          storedItemLocationId: value.storedItemLocationId,
          issueItemId: value.issueItemId,
          quantity: parseFloat(value.selectedQuantity)
        });
      });

      var items = {
        returnId: vm.returnId,
        locationId: locationId,
        returnItems: vm.itemsToReturn
      };
      return returnService.returnItems(items);
    }

    var bagAndTagItems = new kendo.data.TreeListDataSource({
      transport: {
        read: function (options) {
          vm.returnBagAndTagItems = angular.copy(vm.returnBagAndTagItemsContainer);
          var data = vm.returnBagAndTagItems;
          options.success(data);
        },
        dataType: "json"
      },
      schema: {
        model: {
          id: "id",
          expanded: true,
          fields: {
            parentId: {field: "bagAndTagId", nullable: true},
            id: {field: "id", type: "string"}
          }
        }
      }
    });

    vm.returnBagAndTagItemsOptions = {
      dataSource: bagAndTagItems,
      columns: [
        {
          template: "<span ng-show='dataItem.parentId === null'>" +
          "<wg-edit-grouped-items is-read-only='true' is-bag-and-tag-view='true' bag-and-tag-id='{{dataItem.id}}' description='{{dataItem.description}}'></wg-edit-grouped-items></span>",
          width: "71px"
        },
        {field: "description", title: "Description"},
        {
          title: "Material code",
          template: "<span ng-hide='dataItem.parentId === null'>{{ dataItem.materialCode }}</span>"
        },
        {
          title: "Location",
          template: "<span ng-hide='dataItem.parentId === null'>{{ dataItem.warehouseName }}/{{ dataItem.locationName }}</span>"
        },
        {
          title: "Qty",
          template: "<span ng-show='dataItem.selectedQuantity > 0'>{{dataItem.selectedQuantity}}</span>"
        },
        {
          template: "<span ng-show='dataItem.isReadOnly == false'><button type='button' class='btn btn-danger btn-sm pull-right' ng-click='vm.removeBagAndTagItem(dataItem)' ng-hide='dataItem.parentId === null'><i class='fa fa-times' aria-hidden='true'></i></button></span>",
          width: "50px"
        }
      ]
    };

    function refreshBagAndTagItems() {
      bagAndTagItems.read();
    }

    function getIndexByAttribute(array, attr, value) {
      for(var i = 0; i < array.length; i += 1) {
        if(array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.returns')
    .directive('wgReturnGroupedItems', wgReturnGroupedItems);

  wgReturnGroupedItems.$inject = ['$exceptionHandler'];

  /* @ngInject */
  function wgReturnGroupedItems($exceptionHandler) {
    var directive = {
      bindToController: true,
      controller: ReturnGroupedItemsCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        bagAndTag: '=',
        returnId: '@',
        postUpdateDelegate: '&',
        fakeBagAndTagItems: '='
      },
      templateUrl: 'app/returns/returnGroupedItems.html'
    };
    return directive;

    function link($scope, element, attrs) {

    }
  }

  ReturnGroupedItemsCtrl.$inject = ['$uibModal'];

  /* ngInject */
  function ReturnGroupedItemsCtrl($uibModal) {
    var vm = this;

    vm.bagAndTag = this.bagAndTag;
    vm.returnId = this.returnId;
    vm.fakeBagAndTagItems = this.fakeBagAndTagItems;

    vm.openGroupedItems = openGroupedItems;

    function openGroupedItems() {
      $uibModal.open({
        templateUrl: 'app/returns/returnGroupedItemsModal.html',
        controller: 'ReturnGroupedItemsModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          bagAndTag: function () {
            return vm.bagAndTag;
          },
          returnId: function () {
            return vm.returnId;
          },
          postUpdateDelegate: function () {
            return vm.postUpdateDelegate;
          },
          fakeBagAndTagItems: function () {
            return vm.fakeBagAndTagItems;
          }
        }
      });
    }
  }

  angular
    .module('app.returns')
    .controller('ReturnGroupedItemsModalCtrl', ReturnGroupedItemsModalCtrl);

  ReturnGroupedItemsModalCtrl.$inject = ['$uibModalInstance', '$filter', 'bagAndTagService', 'returnService', 'bagAndTag', 'returnId', 'postUpdateDelegate', 'OidcManager', 'API', 'SETTINGS', 'fakeBagAndTagItems'];

  function ReturnGroupedItemsModalCtrl($uibModalInstance, $filter, bagAndTagService, returnService, bagAndTag, returnId, postUpdateDelegate, OidcManager, API, SETTINGS, fakeBagAndTagItems) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.bagAndTagId = bagAndTag.id;
    vm.returnId = returnId;
    vm.title = "Return items from " + bagAndTag.description;
    vm.storedItems = [];
    vm.storedItemsOptions = [];

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.itemsToReturn = [];
    vm.fakeBagAndTagItems = fakeBagAndTagItems;

    /** Locations */
    vm.locations = [];
    vm.locationsOptions = [];
    vm.locationSelected = undefined;

    vm.greaterThan = greaterThan;

    activate();

    ////////////////////////

    function activate() {
      getBagAndTagItems();
    }

    function getBagAndTagItems() {
      return bagAndTagService.getBagAndTagItemsAndGroups(vm.bagAndTagId)
        .then(function (response) {
          vm.storedItems = response;
        });
    }

    vm.ok = function () {
      vm.saving = true;
      vm.saved = false;

      vm.itemsToReturn = [];

      var selectedItems = $filter('filter')(vm.storedItemsOptions.dataSource.data(), {isIncluded: true});
      angular.forEach(selectedItems, function (value, key) {
        vm.itemsToReturn.push({
          storedItemId: value.id,
          storedItemLocationId: value.storedItemLocationId,
          quantity: parseFloat(value.quantity),
          bagAndTagId: bagAndTag.id,
          isContainer: value.isContainer,
          bagAndTagIssueItemId: value.bagAndTagIssueItemId
        });
      });

      var items = {
        returnId: vm.returnId,
        locationId: vm.locationSelected.id,
        returnBagAndTagItems: vm.itemsToReturn
      };

      returnService.returnBagAndTagItems(items)
        .then(function (response) {

          vm.fakeItems = [];

          vm.fakeItems.push({
            description: bagAndTag.description,
            materialCode: null,
            barcode: bagAndTag.barcode,
            storedItemId: bagAndTag.storedItemId,
            id: bagAndTag.id,
            storedItemLocationId: bagAndTag.storedItemLocationId,
            warehouseName: null,
            newWarehouseName: null,
            locationName: null,
            newLocationName: null,
            newLocationId: null,
            bagAndTagId: null,
            returnId: returnId,
            returnItemId: null,
            unitOfMeasureCode: null,
            selectedQuantity: 0,
            poNumber: null,
            poLineNumber: null
          });

          angular.forEach(selectedItems, function(value, key) {
            vm.fakeItems.push({
              description: value.description,
              materialCode: value.materialCode,
              barcode: value.barcode,
              storedItemId: value.id,
              id: value.id,
              storedItemLocationId: value.storedItemLocationId,
              warehouseName: vm.locationSelected.warehouseName,
              newWarehouseName: vm.locationSelected.warehouseName,
              locationName: vm.locationSelected.name,
              newLocationName: vm.locationSelected.name,
              newLocationId: vm.locationSelected.id,
              bagAndTagId: bagAndTag.id,
              returnId: returnId,
              returnItemId: null,
              unitOfMeasureCode: value.unitOfMeasureCode,
              selectedQuantity: value.quantity,
              poNumber: value.poNumber,
              poLineNumber: value.poLineNumber
            });
          });

          vm.fakeBagAndTagItems(vm.fakeItems);

          vm.error = false;
          vm.saved = true;
          vm.saving = false;
          postUpdateDelegate();
        }, function () {
          vm.saved = false;
          vm.error = true;
          vm.saving = false;
        });
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
      postUpdateDelegate();
    };

    var storedItems = new kendo.data.TreeListDataSource({
      transport: {
        read: function (options) {
          return bagAndTagService.getBagAndTagItemsAndGroups(vm.bagAndTagId)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        },
        dataType: "json"
      },
      schema: {
        model: {
          id: "storedItemId",
          expanded: true,
          fields: {
            parentId: {field: "storedItemParentId", nullable: true},
            storedItemId: {field: "storedItemId", type: "string"}
          }
        }
      }
    });

    vm.storedItemsOptions = {
      dataSource: storedItems,
      height: 420,
      sortable: true,
      dataBound: function (e) {
        onDataBound(e);
      },
      columns: [
        {
          title: "Description",
          width: "390px",
          template: "{{ dataItem.description | uppercase }}"
        },
        {field: "barcode", title: "Barcode", width: "120px"},
        {field: "materialCode", title: "Material Code", width: "120px"},
        {
          title: "Qty",
          template: "<span ng-show='dataItem.issuedQuantity > 0'>{{dataItem.issuedQuantity}}</span>" +
                    "<span ng-if='dataItem.quantity > dataItem.issuedQuantity' class='pull-right'" +
                    "title='The issue quantity is greater than the quantity available.'>" +
                    "<i class='fa fa-warning text-danger'></i></span>",
          width: "65px"
        },
        {
          title: "Return",
          template: "<span ng-if='dataItem.isIncluded && dataItem.issuedQuantity > 0 && dataItem.parentId === null'>" +
                    "<input type='text' class='form-control' style='width:50px' numeric-only ng-model='dataItem.quantity' ng-bind='dataItem.issuedQuantity'>" +
                    "</span><span data-ng-if='!dataItem.isIncluded && dataItem.issuedQuantity > 0 && dataItem.parentId === null'>" +
                    "<input type='text' class='form-control' style='width:50px' ng-disabled='true'/></span>",
          width: "80px"
        },
        {
          template: "<span ng-hide='dataItem.parentId !== null || dataItem.issuedQuantity === 0'><input icheck type='checkbox' ng-model='dataItem.isIncluded'/></span>"
        }
      ]
    };

    function onDataBound(e) {
      var rows = e.sender.tbody.children();

      for (var i = 0; i < rows.length; i++) {
        var row = angular.element(rows[i]);
        var dataItem = e.sender.dataItem(row);

        if (dataItem.isContainer) {
          row.addClass("group-parent");
          row.addClass("isContainer");
        }
        else if (dataItem.parentId !== null) {
          row.addClass("group-child");
        }
      }
    }

    function refreshTreelist() {
      storedItems.read();
    }

    function greaterThan(prop, val) {
      return function (item) {
        return item[prop] > val;
      };
    }

    /** Locations */

    vm.locations = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      },
      group: {field: "warehouseName"}
    };

    vm.locationsOptions = {
      dataSource: vm.locations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.returns')
    .controller('CreateReturnCtrl', CreateReturnCtrl);

  CreateReturnCtrl.$inject = ['returnService', '$state'];
  /* @ngInject */
  function CreateReturnCtrl(returnService, $state) {
    if ($state.transition) return;

    var vm = this;
    vm.loading = false;
    vm.return = {
      description: ''
    };

    vm.createReturn = createReturn;
    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;

    activate();

    /////////////////////

    function activate() {

    }

    function createReturn() {
      vm.loading = true;
      return returnService.createReturn(vm.return)
        .then(function (response) {
          vm.hasErrors = false;
          $state.transitionTo('returns.details', {id: response.returnId});
        }, function (error) {
          if (error.status !== 403) {
            vm.hasErrors = true;
            showValidationErrors(error);
          }
          vm.loading = false;
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessages);
        }
      } else {
        vm.validationErrors.push('Could not create return.');
      }
      vm.loading = false;
    }

  }

})();

var AngularJs;function downloadAndSetup(n){var t="appInsightsSDK";window[t]="appInsights";var e=window[t],i=window[e]||function(t){function n(t){a[t]=function(){var n=arguments;a.queue.push(function(){a[t].apply(a,n)})}}var a={config:t,initialize:!0},e=document,i=window;setTimeout(function(){var n=e.createElement("script");n.src=t.url||"https://az416426.vo.msecnd.net/next/ai.2.min.js",e.getElementsByTagName("script")[0].parentNode.appendChild(n)});try{a.cookie=e.cookie}catch(t){}a.queue=[],a.version=2;for(var c=["Event","PageView","Exception","Trace","DependencyData","Metric","PageViewPerformance"];c.length;)n("track"+c.pop());n("startTrackPage"),n("stopTrackPage"),n("addTelemetryInitializer");var r="Track"+c[0];if(n("start"+r),n("stop"+r),!(!0===t.disableExceptionTracking||t.extensionConfig&&t.extensionConfig.ApplicationInsightsAnalytics&&!0===t.extensionConfig.ApplicationInsightsAnalytics.disableExceptionTracking)){n("_"+(c="onerror"));var s=i[c];i[c]=function(n,t,e,i,r){var o=s&&s(n,t,e,i,r);return!0!==o&&a["_"+c]({message:n,url:t,lineNumber:e,columnNumber:i,error:r}),o},t.autoExceptionInstrumented=!0}return a}(n);window[e]=i}!function(n){function t(){}(n.AppInsightJsV2||(n.AppInsightJsV2={})).ApplicationInsightsConfig=t}(AngularJs=AngularJs||{}),function(n){!function(n){var t=(e.isNullOrUndefined=function(n){return null==n},e.newGuid=function(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(i,function(n){var t=16*Math.random()|0;return("x"===n?t:3&t|8).toString(16)})},e.noop=angular.noop,e);function e(){}n.Utils=t;var i=/[xy]/g}(n.AppInsightJsV2||(n.AppInsightJsV2={}))}(AngularJs=AngularJs||{}),function(n){var t,e;function i(n){var t=this;i.errorOnHttpCall=!1,this._interceptFunction=angular.noop,n.decorator("$exceptionHandler",["$delegate",function(n){return t._origExceptionHandler=n,function(n){i.errorOnHttpCall||t._interceptFunction(n),t._origExceptionHandler(n)}}])}t=n.AppInsightJsV2||(n.AppInsightJsV2={}),i.prototype.setInterceptFunction=function(n){this._interceptFunction=n},i.prototype.getPrivateExceptionHanlder=function(){return t.Utils.isNullOrUndefined(this._origExceptionHandler)?angular.noop:this._origExceptionHandler},e=i,t.ExceptionInterceptor=e}(AngularJs=AngularJs||{}),function(n){var e,t;function o(n){var t=this;this._noop=e.Utils.noop,o.interceptFuntion=this._noop,n.decorator("$log",["$delegate",function(n){return t._debugFn=n.debug,t._infoFn=n.info,t._warnFn=n.warn,t._logFn=n.log,n.debug=angular.extend(t.delegator(t._debugFn,0),t._debugFn),n.info=angular.extend(t.delegator(t._infoFn,1),t._infoFn),n.warn=angular.extend(t.delegator(t._warnFn,2),t._warnFn),n.log=angular.extend(t.delegator(t._logFn,1),t._logFn),n}])}e=n.AppInsightJsV2||(n.AppInsightJsV2={}),o.prototype.setInterceptFunction=function(n){o.interceptFuntion=n},o.prototype.getPrivateLoggingObject=function(){return{debug:e.Utils.isNullOrUndefined(this._debugFn)?this._noop:this._debugFn,info:e.Utils.isNullOrUndefined(this._infoFn)?this._noop:this._infoFn,warn:e.Utils.isNullOrUndefined(this._warnFn)?this._noop:this._warnFn,error:this._noop,log:e.Utils.isNullOrUndefined(this._logFn)?this._noop:this._logFn}},o.prototype.delegator=function(i,r){function n(){var n=[].slice.call(arguments),t=n.join(" "),e=n.length;o.interceptFuntion(t,r,1<e?n[e-1]:{}),i.apply(null,n)}for(var t in i)n[t]=i[t];return n},t=o,e.LogInterceptor=t}(AngularJs=AngularJs||{}),function(n){var r,t;function e(n,t,e){var i=this;this.config=n,this.config.autoLogTracking&&t.setInterceptFunction(function(n,t,e){return i.trackTrace({message:n,severityLevel:t,properties:e})}),e.setInterceptFunction(function(n,t){return i.trackException({id:r.Utils.newGuid(),exception:n,severityLevel:3,properties:t})})}r=n.AppInsightJsV2||(n.AppInsightJsV2={}),e.prototype.trackEvent=function(n,t){try{appInsights.trackEvent(n,t)}catch(n){console.warn("Angular application insights Error [trackEvent]: ",n)}},e.prototype.startTrackEvent=function(n){try{appInsights.startTrackEvent(n)}catch(n){console.warn("Angular application insights Error [startTrackEvent]: ",n)}},e.prototype.stopTrackEvent=function(n,t,e){try{appInsights.stopTrackEvent(n,t,e)}catch(n){console.warn("Angular application insights Error [stopTrackEvent]: ",n)}},e.prototype.trackPageView=function(n,t){try{appInsights.trackPageView(n,t)}catch(n){console.warn("Angular application insights Error [trackPageView]: ",n)}},e.prototype.startTrackPage=function(n){try{appInsights.startTrackPage(n)}catch(n){console.warn("Angular application insights Error [startTrackPage]: ",n)}},e.prototype.stopTrackPage=function(n,t,e){try{appInsights.stopTrackPage(n,t,e)}catch(n){console.warn("Angular application insights Error [stopTrackPage]: ",n)}},e.prototype.trackMetric=function(n,t){try{appInsights.trackMetric(n,t)}catch(n){console.warn("Angular application insights Error [trackTrace]: ",n)}},e.prototype.trackException=function(n,t){try{appInsights.trackException(n,t)}catch(n){console.warn("Angular application insights Error [trackException]: ",n)}},e.prototype.trackTrace=function(n,t){try{appInsights.trackTrace(n,t)}catch(n){console.warn("Angular application insights Error [trackTrace]: ",n)}},e.prototype.flush=function(){try{appInsights.flush()}catch(n){console.warn("Angular application insights Error [flush]: ",n)}},e.prototype.setAuthenticatedUserContext=function(n,t,e){void 0===e&&(e=!1);try{appInsights.setAuthenticatedUserContext(n,t,e)}catch(n){console.warn("Angular application insights Error [setAuthenticatedUserContext]: ",n)}},e.prototype.clearAuthenticatedUserContext=function(){try{appInsights.clearAuthenticatedUserContext()}catch(n){console.warn("Angular application insights Error [clearAuthenticatedUserContext]: ",n)}},e.prototype._onerror=function(n){try{appInsights._onerror(n),this.config.enableDebug&&console.warn("Angular application insights Error [_onerror]: ",n.message)}catch(n){console.warn("Angular application insights Error [_onerror]: ",n)}},e.prototype.trackPageViewPerformance=function(n,t){try{appInsights.trackPageViewPerformance(n,t)}catch(n){console.warn("Angular application insights Error [trackPageViewPerformance]: ",n)}},e.prototype.addTelemetryInitializer=function(n){appInsights.addTelemetryInitializer(n)},e.prototype.init=function(){if(this.config)if(this.config.instrumentationKey)try{downloadAndSetup(this.config)}catch(n){console.warn("Angular application insights Error [downloadAndSetup]: ",n)}else console.warn("An instrumentationKey value is required to initialize ApplicationInsightsService");else console.warn("You need to initialize the ApplicationInsightsService with an instrumentationKey while angular js app bootstrap")},t=e,r.ApplicationInsightsService=t}(AngularJs=AngularJs||{}),function(n){!function(e){var i=angular.module("ApplicationInsightsModule",[]);i.provider("applicationInsightsService",function(){return new n}),i.config(["$provide",function(n){i.logInterceptor=new e.LogInterceptor(n),i.exceptionInterceptor=new e.ExceptionInterceptor(n)}]);var n=(t.prototype.configure=function(n){this._options=n},t);function t(){var t=this;this.$get=function(){var n=new e.ApplicationInsightsService(t._options,i.logInterceptor,i.exceptionInterceptor);return n.init(),n}}function h(n,t){return n.applicationName+t.path()}e.ApplicationInsightsProvider=n,i.run(["$rootScope","$location","applicationInsightsService",function(n,p,g){var o,l,u;g.addTelemetryInitializer(function(n){if(console.log("envelope",n),n.tags["ai.operation.name"]=h(g.config,p),"PageviewData"==n.baseType){var t=p.search();null!=typeof t&&(n.data.query=t)}"PageviewPerformanceData"==n.baseType&&(n.baseData.uri=p.absUrl())}),n.$on("$locationChangeStart",function(n,t,e){u=e,o=(new Date).getTime()}),n.$on("$locationChangeSuccess",function(n,t){if(g.config.enableDebug&&console.log(n,t,p.path()),!g.config.autoStateChangeTracking){var e=(new Date).getTime()-o,i=h(g.config,p);t&&(i+="#"+t);var r={name:i,url:p.absUrl(),refUri:u,measurements:{routeChangeDuration:e}};g.trackPageView(r),g.config.enableDebug&&console.log("$locationChangeSuccess->trackPageView",g)}}),n.$on("$stateChangeStart",function(n,t,e,i,r,o){u=t,g.config.autoStateChangeTracking&&(l=(new Date).getTime())}),n.$on("$stateChangeSuccess",function(n,t,e,i,r,o){if(g.config.enableDebug&&console.log(n,t,e,i,r,o,p.path()),g.config.autoStateChangeTracking){var a=(new Date).getTime()-l,c=h(g.config,p);t&&(c+="#"+t);var s={name:c,url:p.absUrl(),refUri:u,measurements:{routeChangeDuration:a}};g.trackPageView(s),g.config.enableDebug&&console.log("$stateChangeSuccess->trackPageView",c,t,{routeChangeDuration:a,refUri:i})}})}])}(n.AppInsightJsV2||(n.AppInsightJsV2={}))}(AngularJs=AngularJs||{});
(function () {
  'use strict';

  angular.module('app.reporting', []);

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('WarehouseTransactionReportCtrl', WarehouseTransactionReportCtrl);

  WarehouseTransactionReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function WarehouseTransactionReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.warehouses = [];
    vm.warehouseOptions = [];

    vm.warehouseSelected = {};

    vm.reportFormat = 'Pdf';
    vm.generating = false;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var warehouseId = ( vm.warehouseSelected == null || vm.warehouseSelected.id === "") ? null : vm.warehouseSelected.id;
      var dateFrom =  vm.dateFrom == null  ? null : vm.dateFrom;
      var dateTo =  vm.dateTo == null  ? null : vm.dateTo;



      var parameters = {
        ProjectCode: SETTINGS.projectCode,
        WarehouseId: warehouseId,
        DateFrom: dateFrom,
        DateTo: dateTo,
      };

      var data = {
        reportType: 'WarehouseTransaction',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** Warehouses*/

    vm.warehouses = new kendo.data.DataSource({
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/warehouses",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      },
      sort: { field:'name', dir: 'asc' }
    });

    vm.warehouseOptions = {
      dataSource: vm.warehouses,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('app.reporting')
    .controller('ViewReportingCtrl', ViewReportingCtrl);

  ViewReportingCtrl.$inject = [];

  /* @ngInject */
  function ViewReportingCtrl() {
    var vm = this;
    vm.reportType ='';

    vm.reportTypeData = new kendo.data.DataSource({
      transport: {
        read: function(options) {
          options.success([
            { 'value' : 'app/reporting/expeditingReport.html', 'text' : 'EXP001 - Expediting Report' },
            { 'value' : 'app/reporting/manifestReport.html', 'text' : 'MAN001 - Manifest Report' },
            { 'value' : 'app/reporting/osdReport.html', 'text' : 'OSD001 - OS&D Report' },
            { 'value' : 'app/reporting/psrReport.html', 'text' : 'PSR001 - PSR Report' },
            { 'value' : 'app/reporting/psrShippingReport.html', 'text' : 'PSR002 - PSR Report inc. Shipping' },
            { 'value' : 'app/reporting/stockAgingReport.html', 'text' : 'STO001 - Stock Aging Report' },
            { 'value' : 'app/reporting/stockBalanceReport.html', 'text' : 'STO002 - Stock Balance Report' },
            { 'value' : 'app/reporting/stockCheckSheetReport.html', 'text' : 'STO003 - Stock Check Sheet Report' },
            { 'value' : 'app/reporting/grnDetailsMonetaryValueReport.html', 'text' : 'GRN001 - GRN Details Report' },
            { 'value' : 'app/reporting/materialTrackingReport.html', 'text' : 'MAT004 - Material Tracking Report' },
            { 'value' : 'app/reporting/materialReceivingReport.html', 'text' : 'MAT003 - Material Receiving Report' },
            { 'value' : 'app/reporting/materialHistoryReport.html', 'text' : 'MAT001 - Material History Report' },
            { 'value' : 'app/reporting/issueReport.html', 'text' : 'ISS001 - Issue Report' },
            { 'value' : 'app/reporting/returnReport.html', 'text' : 'RET001 - Return Report' },
            { 'value' : 'app/reporting/shippedItemsReport.html', 'text' : 'SHI001 - Shipped Items Report' },
            { 'value' : 'app/reporting/picklistReport.html', 'text' : 'PIC001 - Picklist Report' },
            { 'value' : 'app/reporting/materialTransferReport.html', 'text' : 'MAT005 - Material Transfer Report' },
            { 'value' : 'app/reporting/warehouseTransactionReport.html', 'text' : 'WAR001 - Warehouse Transaction Report' },
            { 'value' : 'app/reporting/materialMovementReport.html', 'text' : 'MAT002 - Material Movement Report' },
            { 'value' : 'app/reporting/expeditingUpdateReport.html', 'text' : 'EXP002 - Expediting Update Report' },
            { 'value' : 'app/reporting/bagAndTagReport.html', 'text' : 'BAG001 - Bag & Tag Report'},
            { 'value' : 'app/reporting/manifestImportReport.html', 'text' : 'MAN002 - Manifest Import Report' },
            { 'value' : 'app/reporting/expeditingHistoryReport.html', 'text' : 'EXP003 - Expediting History Report' },
            { 'value' : 'app/reporting/inspectionReport.html', 'text' : 'INS001 - Outstanding Inspection Report' },
          ]);
        }
      },
      sort: { field:'text', dir: 'asc' }
    });

    vm.reportTypeOptions = {
      dataSource: vm.reportTypeData,
      dataTextField: 'text',
      dataValueField: 'value',
      placeholder: "Select a report"
    };

    activate();

    ///////////////////////

    function activate() {

    }

  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('StockCheckSheetReportCtrl', StockCheckSheetReportCtrl);

  StockCheckSheetReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function StockCheckSheetReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.costCodes = [];
    vm.costCodeOptions = [];
    vm.materialCodes = [];
    vm.materialCodeOptions = [];
    vm.purchaseOrderCodes = [];
    vm.purchaseOrderOptions = [];
    vm.warehouses = [];
    vm.warehousesOptions = [];
    vm.locations = [];
    vm.locationsOptions = [];

    vm.costCodeSelected = { };
    vm.materialCodeSelected = { };
    vm.purchaseOrderSelected = { };
    vm.warehouseSelected = { };
    vm.locationSelected = { };
    vm.reportFormat = 'Pdf';
    vm.generating = false;
    vm.showQuantity = 'True';

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;
      var costCode = ( vm.costCodeSelected == null || vm.costCodeSelected.costCode === "" ) ? null : vm.costCodeSelected.costCode;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.materialCode === "" ) ? null : vm.materialCodeSelected.materialCode;
      var purchaseOrder = ( vm.purchaseOrderSelected == null || vm.purchaseOrderSelected.number === "") ? null : vm.purchaseOrderSelected.number;
      var warehouse = ( vm.warehouseSelected == null || vm.warehouseSelected.name === "") ? null : vm.warehouseSelected.name;
      var location = ( vm.locationSelected == null || vm.locationSelected.id === "") ? null : vm.locationSelected.id;

      var parameters = {
        CostCode: costCode,
        MaterialCode: materialCode,
        PONumber: purchaseOrder,
        Warehouse: warehouse,
        Location: location,
        ShowQuantity: vm.showQuantity,
        ProjectCode: SETTINGS.projectCode
      };

      var data = {
        reportType: 'StockCheckSheet',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** CostCodes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.costCodeOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** MaterialCodes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      template: '{{dataItem.materialCode + " - " + dataItem.description}}',
      autoBind: false,
      placeholder: "ALL"
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

    vm.warehouses = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/warehouses",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      }
    };

    vm.warehousesOptions = {
      dataSource: vm.warehouses,
      dataTextField: "name",
      dataValueField: "id",
      template: '<span class="k-state-default">#: name #</span>',
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** Locations */

    vm.locations = {
      transport: {
        read: {
          url: vm.isMovement ? API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations/' + vm.warehouse : API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations',
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      },
      group: { field: "warehouseName" }
    };

    vm.locationsOptions = {
      placeholder: "ALL",
      dataSource: vm.locations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('StockBalanceReportCtrl', StockBalanceReportCtrl);

  StockBalanceReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager', 'bagAndTagService'];

  /* @ngInject */
  function StockBalanceReportCtrl(reportingService, API, SETTINGS, OidcManager, bagAndTagService) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.warehouses = [];
    vm.warehousesOptions = [];
    vm.locations = [];
    vm.locationsOptions = [];
    vm.costCodes = [];
    vm.costCodeOptions = [];
    vm.materialCodes = [];
    vm.materialCodeOptions = [];
    vm.purchaseOrderCodes = [];
    vm.purchaseOrderOptions = [];
    vm.bagAndTagNumbers = [];
    vm.bagAndTagNumbersOptions = [];
    vm.workpackNumbers = [];
    vm.workpackNumberOptions = [];
    vm.bagAndTagRefDocNumbers = [];
    vm.bagAndTagRefDocNumberOptions = [];

    vm.warehouseSelected = {};
    vm.locationSelected = {};
    vm.costCodeSelected = [];
    vm.materialCodeSelected = {};
    vm.purchaseOrderSelected = [];
    vm.bagAndTagSelected = {};
    vm.workpackNumberSelected = { };
    vm.reportFormat = 'Pdf';
    vm.generating = false;
    vm.incBagAndTag = '1';
    vm.bagAndTagRefDocNumberSelected = { };

    activate();

    /////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var warehouse = ( vm.warehouseSelected == null || vm.warehouseSelected.id === "" ) ? null : vm.warehouseSelected.id;
      var location = ( vm.locationSelected == null || vm.locationSelected.id === "" ) ? null : vm.locationSelected.id;
      var costCode = vm.costCodeSelected === "" ? null : vm.costCodeSelected;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.materialCode === "" ) ? null : vm.materialCodeSelected.materialCode;
      var purchaseOrder = (vm.purchaseOrderSelected == null || vm.purchaseOrderSelected.number === "") ? null : vm.purchaseOrderSelected.number;
      var bagAndTag = vm.bagAndTagSelected.number == "" ? null : vm.bagAndTagSelected.number;
      var description = vm.description == "" ? null : vm.description;
      var workpack = (vm.workpackNumberSelected == null || vm.workpackNumberSelected.workpackNumber === "") ? null : vm.workpackNumberSelected.workpackNumber;
      var includeBagAndTag = vm.incBagAndTag === "1" ? null : vm.incBagAndTag === "3" ? 1 : 0;
      var bagAndTagRefDocNumber = (vm.bagAndTagRefDocNumberSelected == null || vm.bagAndTagRefDocNumberSelected.workpackNumber === "") ? null : vm.bagAndTagRefDocNumberSelected.workpackNumber;


      var parameters = {
        Warehouse: warehouse,
        Location: location,
        MaterialCode: materialCode,
        CostCode: costCode,
        Description: description,
        PurchaseOrder: purchaseOrder,
        BagAndTagNumber: bagAndTag,
        Workpack: workpack,
        IncludeBagAndTag: includeBagAndTag,
        ProjectCode: SETTINGS.projectCode,
        BagAndTagRefDocNumber: bagAndTagRefDocNumber                
      };

      var data = {
        reportType: 'StockBalance',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });
    }

    /** CostCodes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.costCodeOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** MaterialCodes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      template: '{{dataItem.materialCode + " - " + dataItem.description}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

    /** Warehouses */

    vm.warehouses = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/warehouses",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      }
    };

    vm.warehousesOptions = {
      dataSource: vm.warehouses,
      dataTextField: "name",
      dataValueField: "id",
      template: '<span class="k-state-default">#: name #</span>',
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** Locations */

    vm.locations = {
      transport: {
        read: {
          url: vm.isMovement ? API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations/' + vm.warehouse : API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations',
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      },
      group: { field: "warehouseName" }
    };

    vm.locationsOptions = {
      placeholder: "ALL",
      dataSource: vm.locations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };

    /** Bag and Tag numbers */

    vm.bagAndTagNumbers = {
      transport: {
        read: function (options) {
          return bagAndTagService.getBagAndTagNumbers(false)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        }
      }
    };

    vm.bagAndTagNumbersOptions = {
      placeholder: "(Optional)",
      dataSource: vm.bagAndTagNumbers,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.description}}',
      autoBind: false
    };

    /** Workpack numbers */

    vm.workpackNumbers = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/workpack-numbers",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.workpackNumberOptions = {
      dataSource: vm.workpackNumbers,
      dataTextField: "workpackNumber",
      dataValueField: "workpackNumber",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL",
      template: '{{dataItem.workpackNumber}}'
    };

    /** Bag And Tag Ref Doc numbers */

    vm.bagAndTagRefDocNumbers = {
      transport: {
        read: function (options) {
          return bagAndTagService.getBagAndTagWorkpackNumbers(true)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        }
      }
    };

    vm.bagAndTagRefDocNumberOptions = {  
      dataSource: vm.bagAndTagRefDocNumbers,
      dataTextField: "workpackNumber",
      dataValueField: "workpackNumber",
      filter: "contains",
      template: '{{dataItem.workpackNumber}}',
      autoBind: false,
      placeholder: "ALL"
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('StockAgingReportCtrl', StockAgingReportCtrl);

  StockAgingReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function StockAgingReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.costCodes = [];
    vm.costCodeOptions = [];
    vm.materialCodes = [];
    vm.materialCodeOptions = [];
    vm.purchaseOrderCodes = [];
    vm.purchaseOrderOptions = [];

    vm.costCodeSelected = { };
    vm.materialCodeSelected = {  };
    vm.purchaseOrderSelected = {  };
    vm.reportFormat = 'Excel';
    vm.generating = false;

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var costCode = ( vm.costCodeSelected == null || vm.costCodeSelected.costCode === "" ) ? null : vm.costCodeSelected.costCode;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.materialCode === "" ) ? null : vm.materialCodeSelected.materialCode;
      var purchaseOrder = ( vm.purchaseOrderSelected == null || vm.purchaseOrderSelected.number === "") ? null : vm.purchaseOrderSelected.number;


      var parameters = {
        CostCode: costCode,
        MaterialCode: materialCode,
        PONumber: purchaseOrder,
        Months: vm.months,
        ProjectCode: SETTINGS.projectCode
      };

      var data = {
        reportType: 'StockAging',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** CostCodes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.costCodeOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** MaterialCodes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      template: '{{dataItem.materialCode + " - " + dataItem.description}}',
      autoBind: false,
      placeholder: "ALL"
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('ShippedItemsReportCtrl', ShippedItemsReportCtrl);

  ShippedItemsReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function ShippedItemsReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.costCodes = [];
    vm.costCodeOptions = [];
    vm.materialCodes = [];
    vm.materialCodeOptions = [];
    vm.purchaseOrderCodes = [];
    vm.purchaseOrderOptions = [];

    vm.costCodeSelected = { };
    vm.materialCodeSelected = {  };
    vm.purchaseOrderSelected = {  };
    vm.reportFormat = 'Excel';
    vm.generating = false;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var costCode = ( vm.costCodeSelected == null || vm.costCodeSelected.costCode === "" ) ? null : vm.costCodeSelected.costCode;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.materialCode === "" ) ? null : vm.materialCodeSelected.materialCode;
      var purchaseOrder = ( vm.purchaseOrderSelected == null || vm.purchaseOrderSelected.number === "") ? null : vm.purchaseOrderSelected.number;
      var dateFrom =  vm.dateFrom == null  ? null : vm.dateFrom;
      var dateTo =  vm.dateTo == null  ? null : vm.dateTo;
      var description = vm.description == "" ? null : vm.description;
      var container = vm.container == "" ? null : vm.container;
      var refDoc = vm.refDoc == "" ? null : vm.refDoc;
      var customsStatus = vm.customsStatus == "" ? null : vm.customsStatus;

      var parameters = {
        CostCode: costCode,
        MaterialCode: materialCode,
        PONumber: purchaseOrder,
        DateFrom: dateFrom,
        DateTo: dateTo,
        Description: description,
        Container: container,
        RefDoc: refDoc,
        CustomsStatus: customsStatus,
        ProjectCode: SETTINGS.projectCode
      };

      var data = {
        reportType: 'ShippedItems',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** CostCodes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.costCodeOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** MaterialCodes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      autoBind: false,
      template: '{{dataItem.materialCode + " - " + dataItem.description}}',
      placeholder: "ALL"
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('ReturnReportCtrl', ReturnReportCtrl);

  ReturnReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function ReturnReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.costCodes = [];
    vm.costCodeOptions = [];
    vm.materialCodes = [];
    vm.materialCodeOptions = [];
    vm.purchaseOrderOptions = [];
    vm.deliveryCodes = [];
    vm.deliveryOptions = [];

    vm.costCodeSelected = { };
    vm.materialCodeSelected = { };
    vm.purchaseOrderSelected = { };
    vm.deliverySelected = { };
    vm.reportFormat = 'Pdf';
    vm.generating = false;
    vm.monetaryValue = 'False';

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var costCode = ( vm.costCodeSelected == null || vm.costCodeSelected.costCode === "" ) ? null : vm.costCodeSelected.costCode;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.materialCode === "" ) ? null : vm.materialCodeSelected.materialCode;
      var purchaseOrder = ( vm.purchaseOrderSelected == null || vm.purchaseOrderSelected.number === "") ? null : vm.purchaseOrderSelected.number;
      var theReturn = ( vm.deliverySelected == null || vm.deliverySelected.number === "") ? null : vm.deliverySelected.number;
      var dateFrom =  vm.dateFrom == null  ? null : vm.dateFrom;
      var dateTo =  vm.dateTo == null  ? null : vm.dateTo;
      var description = vm.description = "" ? null : vm.description;

      var parameters = {
        CostCode: costCode,
        MaterialCode: materialCode,
        PONumber: purchaseOrder,
        ReturnNumber: theReturn,
        ReturnDateFrom: dateFrom,
        Description: description,
        ReturnDateTo: dateTo,
        ProjectCode: SETTINGS.projectCode
      };

      var data = {
        reportType: vm.monetaryValue == 'True' ? 'returnMonetaryValue' : 'return',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** CostCodes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.costCodeOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

  
    /** MaterialCodes */

    vm.deliveryCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/returns/complete",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.deliveryOptions = {
      dataSource: vm.deliveryCodes,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.description}}',
      autoBind: false,
      placeholder: "ALL"
    };

    /** MaterialCodes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      autoBind: false,
      template: '{{dataItem.materialCode + " - " + dataItem.description}}',
      placeholder: "ALL"
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('PsrShippingReportCtrl', PsrShippingReportCtrl);

  PsrShippingReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function PsrShippingReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.costCodes = [];
    vm.costCodeOptions = [];
    vm.materialCodes = [];
    vm.materialCodeOptions = [];
    vm.purchaseOrderCodes = [];
    vm.purchaseOrderOptions = [];
    vm.buyerNames = [];
    vm.buyerNameOptions = [];

    vm.description = '';
    vm.costCodeSelected = { };
    vm.materialCodeSelected = {  };
    vm.purchaseOrderSelected = {  };
    vm.buyerNameSelected = {};
    vm.reportFormat = 'Excel';
    vm.generating = false;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var costCode = ( vm.costCodeSelected == null || vm.costCodeSelected.costCode === "" ) ? null : vm.costCodeSelected.costCode;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.materialCode === "" ) ? null : vm.materialCodeSelected.materialCode;
      var purchaseOrder = ( vm.purchaseOrderSelected == null || vm.purchaseOrderSelected.number === "") ? null : vm.purchaseOrderSelected.number;
      var buyerName = ( vm.buyerNameSelected == null || vm.buyerNameSelected.buyerName === "" ) ? null : vm.buyerNameSelected.buyerName;
      var description = ( vm.description == null || vm.description === "") ? null : vm.description;
      var dateFrom =  vm.dateFrom == null  ? null : vm.dateFrom;
      var dateTo =  vm.dateTo == null  ? null : vm.dateTo;


      var parameters = {
        CostCode: costCode,
        MaterialCode: materialCode,
        PONumber: purchaseOrder,
        BuyerName: buyerName,
        Description: description,
        PODateFrom: dateFrom,
        PODateTo: dateTo,
        ProjectCode: SETTINGS.projectCode
      };

      var data = {
        reportType: 'PsrShipping',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** CostCodes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.costCodeOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** MaterialCodes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      autoBind: false,
      template: '{{dataItem.materialCode + " - " + dataItem.description}}',
      placeholder: "ALL"
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

        /** BuyerNames */

        vm.buyerNames = {
          transport: {
            read: {
              url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-order-lines/buyer-names",
              beforeSend: function (xhr) {
                xhr.setRequestHeader('Authorization', vm.bearerToken);
              }
            }
          }
        };
    
        vm.buyerNameOptions = {
          dataSource: vm.buyerNames,
          dataTextField: "buyerName",
          dataValueField: "buyerName",
          filter: "contains",
          autoBind: false,
          placeholder: "ALL"
        };

  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('PsrReportCtrl', PsrReportCtrl);

  PsrReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function PsrReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.costCodes = [];
    vm.costCodeOptions = [];
    vm.materialCodes = [];
    vm.materialCodeOptions = [];
    vm.purchaseOrderCodes = [];
    vm.purchaseOrderOptions = [];
    vm.buyerNames = [];
    vm.buyerNameOptions = [];

    vm.description = '';
    vm.costCodeSelected = { };
    vm.materialCodeSelected = {  };
    vm.purchaseOrderSelected = {  };
    vm.buyerNameSelected = {};
    vm.reportFormat = 'Excel';
    vm.generating = false;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var costCode = ( vm.costCodeSelected == null || vm.costCodeSelected.costCode === "" ) ? null : vm.costCodeSelected.costCode;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.materialCode === "" ) ? null : vm.materialCodeSelected.materialCode;
      var purchaseOrder = ( vm.purchaseOrderSelected == null || vm.purchaseOrderSelected.number === "") ? null : vm.purchaseOrderSelected.number;
      var buyerName = ( vm.buyerNameSelected == null || vm.buyerNameSelected.buyerName === "" ) ? null : vm.buyerNameSelected.buyerName;
      var description = ( vm.description == null || vm.description ==="") ? null : vm.description;
      var dateFrom =  vm.dateFrom == null  ? null : vm.dateFrom;
      var dateTo =  vm.dateTo == null  ? null : vm.dateTo;


      var parameters = {
        CostCode: costCode,
        MaterialCode: materialCode,
        PONumber: purchaseOrder,
        BuyerName: buyerName,
        Description: description,
        PODateFrom: dateFrom,
        PODateTo: dateTo,
        ProjectCode: SETTINGS.projectCode
      };

      var data = {
        reportType: 'Psr',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** CostCodes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.costCodeOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** MaterialCodes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      autoBind: false,
      template: '{{dataItem.materialCode + " - " + dataItem.description}}',
      placeholder: "ALL"
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

        /** BuyerNames */

        vm.buyerNames = {
          transport: {
            read: {
              url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-order-lines/buyer-names",
              beforeSend: function (xhr) {
                xhr.setRequestHeader('Authorization', vm.bearerToken);
              }
            }
          }
        };
    
        vm.buyerNameOptions = {
          dataSource: vm.buyerNames,
          dataTextField: "buyerName",
          dataValueField: "buyerName",
          filter: "contains",
          autoBind: false,
          placeholder: "ALL"
        };
  }

})();

(function () {
  'use strict';

  angular
    .module('app.reporting')
    .controller('PicklistReportCtrl', PicklistReportCtrl);

  PicklistReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function PicklistReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    /** Picklists */
    vm.picklists = [];
    vm.picklistsOptions = [];

    vm.picklistSelected = '';
    vm.reportFormat = 'Pdf';
    vm.generating = false;
    vm.picklistType = 'Mmt';

    activate();

    ///////////////////////

    function activate() {


    }


    function runReport() {
      vm.generating = true;
      var parameters = {
        PicklistNumber: vm.picklistSelected,
        ProjectCode: SETTINGS.projectCode
      };

      var data = {
        reportType: 'Picklist',
        reportFormat: vm.reportFormat,
        parametersString:  JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }


    /** Picklists */

    vm.picklists = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/picklists/picking",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.picklistsOptions = {
      placeholder: "(Required)",
      dataSource: vm.picklists,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.description}}',
      autoBind: false
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('OsdReportCtrl', OsdReportCtrl);

  OsdReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function OsdReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.suppliers = [];
    vm.supplierOptions = [];

    vm.supplierSelected = { supplierCode: 0, supplierName: 'ALL' };
    vm.reportFormat = 'Pdf';
    vm.generating = false;
    vm.osdStatus = '1';
    vm.orderBy = { value: 'Raised Date' };
    vm.orderByData = [];

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var supplierCode = ( vm.supplierSelected == null || vm.supplierSelected.supplierCode === "0" ) ? null : vm.supplierSelected.supplierCode;
      var statusId = vm.osdStatus === "0" ? null : vm.osdStatus;

      var parameters = {
        SupplierCode: supplierCode,
        StatusId: statusId,
        OrderBy: vm.orderBy.value,
        ProjectCode: SETTINGS.projectCode
      };

      var data = {
        reportType: 'OverShortDamaged',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** Suppliers */

    vm.suppliers = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-orders/suppliers-with-osd",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.supplierOptions = {
      dataSource: vm.suppliers,
      dataTextField: "supplierName",
      dataValueField: "supplierCode",
      filter: "contains",
      autoBind: false,
      template: '{{dataItem.supplierCode + " - " + dataItem.supplierName}}'
    };


    /** Order by */
    vm.orderByData = {
      transport: {
        read: function(options) {
          options.success([
              {'value' : 'Raised Date'},
              {'value' : 'Resolved Date'},
              {'value' : 'Supplier'},
              {'value' : 'Disposition'}
          ]);
        }
      }
    };

    vm.orderByOptions = {
      dataSource: vm.orderByData,
      dataTextField: 'value',
      dataValueField: 'value',
      autoBind: false,
      databound: function() {
        var noItems = this.list.find(".noDataMessage");

        if (!this.dataSource.view()[0]) {
          noItems.show();
          this.popup.open();
        } else {
          noItems.hide();
        }
      },
      close: function(e) {
        var widget = e.sender;

        if (!widget.shouldClose && !this.dataSource.view()[0]) {
          e.preventDefault();
        }
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('MaterialTransferReportCtrl', MaterialTransferReportCtrl);

  MaterialTransferReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function MaterialTransferReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.materialCodes = [];
    vm.materialCodeOptions = [];

    vm.transferNumbers = [];
    vm.transferNumberOptions = [];

    vm.transferNumberSelected = {};
    vm.materialCodeSelected = {};

    vm.reportFormat = 'Pdf';
    vm.generating = false;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var transferNumber = ( vm.transferNumberSelected == null || vm.transferNumberSelected.number === "") ? null : vm.transferNumberSelected.number;
      var dateFrom =  vm.dateFrom == null  ? null : vm.dateFrom;
      var dateTo =  vm.dateTo == null  ? null : vm.dateTo;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.code === "") ? null : vm.materialCodeSelected.code;


      var parameters = {
        ProjectCode: SETTINGS.projectCode,
        TransferNumber: transferNumber,
        MaterialCode: materialCode,
        DateFrom: dateFrom,
        DateTo: dateTo,
      };

      var data = {
        reportType: 'MaterialTransfer',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** Transfer Numbers */

    vm.transferNumbers = new kendo.data.DataSource({
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/transfers/all",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    });

    vm.transferNumberOptions = {
      dataSource: vm.transferNumbers,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.description}}',
      autoBind: false,
      placeholder: "ALL"
    };

    /** Material Codes */

    vm.materialCodes = new kendo.data.DataSource({
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + SETTINGS.projectCode + "/purchase-orders/materials",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    });

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "code",
      dataValueField: "code",
      filter: "contains",
      template: '{{dataItem.code + " - " + dataItem.description}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('MaterialTrackingReportCtrl', MaterialTrackingReportCtrl);

  MaterialTrackingReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function MaterialTrackingReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.costCodes = [];
    vm.costCodeOptions = [];
    vm.materialCodes = [];
    vm.materialCodeOptions = [];
    vm.purchaseOrderCodes = [];
    vm.purchaseOrderOptions = [];

    vm.costCodeSelected = { };
    vm.materialCodeSelected = {  };
    vm.purchaseOrderSelected = {  };
    vm.reportFormat = 'Excel';
    vm.generating = false;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var costCode = ( vm.costCodeSelected == null || vm.costCodeSelected.costCode === "" ) ? null : vm.costCodeSelected.costCode;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.materialCode === "" ) ? null : vm.materialCodeSelected.materialCode;
      var purchaseOrder = ( vm.purchaseOrderSelected == null || vm.purchaseOrderSelected.number === "") ? null : vm.purchaseOrderSelected.number;
      var dateFrom =  vm.dateFrom == null  ? null : vm.dateFrom;
      var dateTo =  vm.dateTo == null  ? null : vm.dateTo;
      var description = vm.description == "" ? null : vm.description;
      var container = vm.container == "" ? null : vm.container;
      var refDoc = vm.refDoc == "" ? null : vm.refDoc;
      var customsStatus = vm.customsStatus == "" ? null : vm.customsStatus;

      var parameters = {
        CostCode: costCode,
        MaterialCode: materialCode,
        PONumber: purchaseOrder,
        PODateFrom: dateFrom,
        PODateTo: dateTo,
        Description: description,
        Container: container,
        RefDoc: refDoc,
        CustomsStatus: customsStatus,
        ProjectCode: SETTINGS.projectCode
      };

      var data = {
        reportType: 'MaterialTracking',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** CostCodes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.costCodeOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** MaterialCodes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      autoBind: false,
      template: '{{dataItem.materialCode + " - " + dataItem.description}}',
      virtual: {
        itemHeight: 30
      },
      placeholder: "ALL"
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('MaterialReceivingReportCtrl', MaterialReceivingReportCtrl);

  MaterialReceivingReportCtrl.$inject = ['deliveryService', 'reportingService', 'API', 'SETTINGS', 'OidcManager', '$filter'];

  /* @ngInject */
  function MaterialReceivingReportCtrl(deliveryService, reportingService, API, SETTINGS, OidcManager, $filter) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.allDeliveries = [];
    vm.purchaseOrders = [];
    vm.purchaseOrdersOptions = [];
    vm.selectedPurchaseOrder = null;

    vm.deliveries = [];
    vm.deliveriesOptions = [];
    vm.selectedDelivery = null;

    vm.reportFormat = 'Pdf';
    vm.generating = false;


    activate();

    ///////////////////////

    function activate() {
      deliveryService.getAllDeliveries().then(function(data){
        angular.forEach(data, function(item){
          vm.allDeliveries.push(item);
        });

        angular.forEach(vm.allDeliveries, function(delivery){
          var poExists = $filter('filter')(vm.purchaseOrders, function(value){ return value.purchaseOrderId == delivery.purchaseOrderId });

          if (poExists.length == 0) vm.purchaseOrders.push(delivery);
        })
      });
    };

    function runReport() {
      vm.generating = true;

      var parameters = {
        DeliveryNumber: vm.selectedDelivery.number,
        ProjectCode : SETTINGS.projectCode
      };

      var data = {
        reportType: 'MaterialReceiving',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** Purchase orders */

    vm.purchaseOrdersOptions = {
      dataSource: vm.purchaseOrders,
      dataTextField: "purchaseOrderNumber",
      dataValueField: "purchaseOrderId",
      filter: "contains",
      autoBind: false,
      template: '<span class="k-state-default">#: purchaseOrderNumber #</span>',
      change: function(e){
        vm.selectedDelivery = null;
        vm.deliveriesDataSource.read()
      }
    };

    vm.deliveriesDataSource = new kendo.data.DataSource({
      transport: {
        read: function(options) {
          if (vm.selectedPurchaseOrder){
            var deliveries = $filter('filter')(vm.allDeliveries, function(value){ return value.purchaseOrderId == vm.selectedPurchaseOrder.purchaseOrderId });
            options.success(deliveries);
          };
        }
      }
    });

    vm.deliveriesOptions = {
      dataSource: vm.deliveriesDataSource,
      dataTextField: 'number',
      dataValueField: 'id',
      autoBind: false,
      databound: function() {
        var noItems = this.list.find(".noDataMessage");

        if (!this.dataSource.view()[0]) {
          noItems.show();
          this.popup.open();
        } else {
          noItems.hide();
        }
      },
      close: function(e) {
        var widget = e.sender;

        if (!widget.shouldClose && !this.dataSource.view()[0]) {
          e.preventDefault();
        }
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('MaterialMovementReportCtrl', MaterialMovementReportCtrl);

  MaterialMovementReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function MaterialMovementReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.materialCodes = [];
    vm.materialCodeOptions = [];

    vm.movementNumbers = [];
    vm.movementNumberOptions = [];

    vm.materialCodes = [];
    vm.materialCodeOptions = [];

    vm.warehouses = [];
    vm.warehouseOptions = [];

    vm.movementNumberSelected = {};
    vm.warehouseSelected = {};
    vm.materialCodeSelected = {};

    vm.reportFormat = 'Pdf';
    vm.generating = false;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var movementNumber = ( vm.movementNumberSelected == null || vm.movementNumberSelected.number === "") ? null : vm.movementNumberSelected.number;
      var dateFrom =  vm.dateFrom == null  ? null : vm.dateFrom;
      var dateTo =  vm.dateTo == null  ? null : vm.dateTo;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.code === "") ? null : vm.materialCodeSelected.code;
      var warehouseId = ( vm.warehouseSelected == null || vm.warehouseSelected.id === "") ? null : vm.warehouseSelected.id;


      var parameters = {
        ProjectCode: SETTINGS.projectCode,
        MovementNumber: movementNumber,
        MaterialCode: materialCode,
        WarehouseId: warehouseId,
        DateFrom: dateFrom,
        DateTo: dateTo,
      };

      var data = {
        reportType: 'MaterialMovement',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** Movement Numbers */

    vm.movementNumbers = new kendo.data.DataSource({
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/movements",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    });

    vm.movementNumberOptions = {
      dataSource: vm.movementNumbers,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      autoBind: false,
      template: '{{dataItem.number + " - " + dataItem.description}}',
      placeholder: "ALL"
    };

    /** Material Codes */

    vm.materialCodes = new kendo.data.DataSource({
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + SETTINGS.projectCode + "/purchase-orders/materials",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    });

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "code",
      dataValueField: "code",
      filter: "contains",
      template: '{{dataItem.code + " - " + dataItem.description}}',
      autoBind: false,
      virtual: {
        itemHeight: 30
      },
      placeholder: "ALL"
    };

    /** Warehouses*/

    vm.warehouses = new kendo.data.DataSource({
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/warehouses",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      },
      sort: { field:'name', dir: 'asc' }
    });

    vm.warehouseOptions = {
      dataSource: vm.warehouses,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('MaterialHistoryReportCtrl', MaterialHistoryReportCtrl);

  MaterialHistoryReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function MaterialHistoryReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.purchaseOrders = [];
    vm.puchaseOrderOptions = [];

    vm.materialCodes = [];
    vm.materialCodeOptions = [];

    vm.costCodes = [];
    vm.costCodeOptions = [];

    vm.costCodeSelected = {};
    vm.materialCodeSelected = {};
    vm.purchaseOrderSelected = {};

    vm.reportFormat = 'Pdf';
    vm.generating = false;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var costCode = ( vm.costCodeSelected == null || vm.costCodeSelected.costCode === "") ? null : vm.costCodeSelected.costCode;
      var dateFrom =  vm.dateFrom == null  ? null : vm.dateFrom;
      var dateTo =  vm.dateTo == null  ? null : vm.dateTo;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.code === "") ? null : vm.materialCodeSelected.code;
      var purchaseOrderNo = ( vm.purchaseOrderSelected == null || vm.purchaseOrderSelected.number === "") ? null : vm.purchaseOrderSelected.number;

      var parameters = {
        ProjectCode: SETTINGS.projectCode,
        CostCode: costCode,
        MaterialCode: materialCode,
        PONumber: purchaseOrderNo,
        DateFrom: dateFrom,
        DateTo: dateTo,
      };

      var data = {
        reportType: 'MaterialHistory',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** Cost Codes */

    vm.costCodes = new kendo.data.DataSource({
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + SETTINGS.projectCode + "/purchase-orders/cost-codes",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    });

    vm.costCodeOptions = {
      dataSource: vm.costCodes,
      dataTextField: "code",
      dataValueField: "code",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      placeholder: "ALL"
    };

    /** Material Codes */

    vm.materialCodes = new kendo.data.DataSource({
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + SETTINGS.projectCode + "/purchase-orders/materials",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    });

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "code",
      dataValueField: "code",
      filter: "contains",
      template: '{{dataItem.code + " - " + dataItem.description}}',
      autoBind: false,
      virtual: {
        itemHeight: 30
      },
      placeholder: "ALL"
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app.reporting')
    .controller('ManifestReportCtrl', ManifestReportCtrl);

  ManifestReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function ManifestReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    /** Manifests */
    vm.manifests = [];
    vm.manifestsOptions = [];

    vm.manifestSelected = '';
    vm.reportFormat = 'Pdf';
    vm.generating = false;
    vm.manifestType = 'manifestMMT';

    vm.orderBy = { value: 'PurchaseOrderNumber', order: 'Asc' };
    vm.orderByData = [];

    activate();

    ///////////////////////

    function activate() {

    }


    function runReport() {
      vm.generating = true;

      var orderBy =  ( vm.orderBy == null || vm.orderBy.value === "") ? "PurchaseOrderNumber" : vm.orderBy.value;
      var orderByDirection =  ( vm.orderBy == null || vm.orderBy.value === "") ? "Asc" : vm.orderBy.order;
      var parameters = {
        number: vm.manifestSelected,
        OrderBy: orderBy,
        OrderByDirection: orderByDirection
      };

      var data = {
        reportType: vm.manifestType,
        reportFormat: vm.reportFormat,
        parametersString:  JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }


    /** Manifests */

    vm.manifests = {
      transport: {
        read: {
          url: API.BASE_URI_SHIPPING + SETTINGS.projectCode + "/manifests/all",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.manifestsOptions = {
      placeholder: "(Required)",
      dataSource: vm.manifests,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      autoBind: false,
      template: '{{dataItem.number + " - " + dataItem.description}}',
    };

    /** Order by */
    
    vm.orderByData = {
      transport: {
        read: function(options) {
          options.success([
            {'text' : 'Purchase Order', 'value' : 'PurchaseOrderNumber', order: "Asc"},
            {'text' : 'Unit ID/Box', 'value' : 'Container', order: "Asc"},
            {'text' : 'Material Number', 'value' : 'MaterialCode', order: "Asc"},
            {'text' : 'Description', 'value' : 'Description', order: "Asc"}
          ]);
        }
      }
    };

    vm.orderByOptions = {
      dataSource: vm.orderByData,
      dataTextField: 'text',
      dataValueField: 'value',
      placeholder: "Purchase Order"
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('app.reporting')
    .controller('ManifestImportReportCtrl', ManifestImportReportCtrl);

  ManifestImportReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function ManifestImportReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.reportFormat = 'Excel';
    vm.generating = false;

    activate();

    ///////////////////////

    function activate() {

    }


    function runReport() {
      vm.generating = true;

      var parameters = {
        ProjectCode: SETTINGS.projectCode,
      };

      var data = {
        reportType: 'manifestImport',
        reportFormat: vm.reportFormat,
        parametersString:  JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('IssueReportCtrl', IssueReportCtrl);

  IssueReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function IssueReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.costCodes = [];
    vm.costCodeOptions = [];
    vm.materialCodes = [];
    vm.materialCodeOptions = [];
    vm.issueCodes = [];
    vm.issueOptions = [];
    vm.purchaseOrderOptions = [];
    vm.deliveryCodes = [];
    vm.deliveryOptions = [];
    vm.workpackNumbers = [];
    vm.workpackNumberOptions = [];

    vm.costCodeSelected = { };
    vm.materialCodeSelected = { };
    vm.issueSelected = { };
    vm.purchaseOrderSelected = { };
    vm.deliverySelected = { };
    vm.workpackNumberSelected = { };
    vm.reportFormat = 'Pdf';
    vm.generating = false;
    vm.monetaryValue = 'False';
    vm.issueStatus = '3';

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var costCode = ( vm.costCodeSelected == null || vm.costCodeSelected.costCode === "") ? null : vm.costCodeSelected.costCode;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.materialCode === "") ? null : vm.materialCodeSelected.materialCode;
      var purchaseOrder = ( vm.purchaseOrderSelected == null || vm.purchaseOrderSelected.number === "") ? null : vm.purchaseOrderSelected.number;
      var issue = ( vm.issueSelected == null || vm.issueSelected.number === "") ? null : vm.issueSelected.number;
      var workpack = vm.workpackNumberSelected.issuedToRefNo === "" ? null : vm.workpackNumberSelected.issuedToRefNo;
      var dateFrom =  vm.dateFrom == null  ? null : vm.dateFrom;
      var dateTo =  vm.dateTo == null  ? null : vm.dateTo;

      var issueStatusId = vm.issueStatus === "0" ? null : vm.issueStatus;

      var parameters = {
        CostCode: costCode,
        MaterialCode: materialCode,
        PONumber: purchaseOrder,
        IssueNumber: issue,
        IssueDateFrom: dateFrom,
        Workpack: workpack,
        IssueDateTo: dateTo,
        ProjectCode: SETTINGS.projectCode,
        IssueStatusId: issueStatusId
      };

      var data = {
        reportType: vm.monetaryValue == 'True' ? 'issueMonetaryValue' : 'issue',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** CostCodes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.costCodeOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** IssueCodes */

    vm.issueCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/issues/complete",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.issueOptions = {
      dataSource: vm.issueCodes,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      autoBind: false,
      template: '{{dataItem.number + " - " + dataItem.description}}',
      placeholder: "ALL"
    };

    /** MaterialCodes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL",
      template: '{{dataItem.materialCode + " - " + dataItem.description}}',
    };

    /** Workpack numbers */

    vm.workpackNumbers = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/issues/issued-to-ref-numbers",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.workpackNumberOptions = {
      dataSource: vm.workpackNumbers,
      dataTextField: "issuedToRefNo",
      dataValueField: "issuedToRefNo",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL",
      template: '{{dataItem.issuedToRefNo}}'
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]
    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

  }

})();

(function() {
    'use strict';
  
    angular
      .module('app.reporting')
      .controller('InspectionReportCtrl', InspectionReportCtrl);
  
      InspectionReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager', 'urlHelperService', 'timeIntervalService'];
  
    /* @ngInject */
    function InspectionReportCtrl(reportingService, API, SETTINGS, OidcManager, urlHelperService, timeIntervalService) {
      var vm = this;
      vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;
  
      vm.runReport = runReport;
  
      vm.suppliers = [];
      vm.supplierOptions = [];
      vm.purchaseOrderCodes = [];
      vm.purchaseOrderOptions = [];
      vm.refNumbers = [];
      vm.refNumberOptions = [];
      vm.costcodes = [];
      vm.costCodeOptions = [];

      vm.supplierSelected = {};
      vm.purchaseOrderSelected = [];
      vm.refNumberSelected = {};
      vm.costCodeSelected = {};
      vm.reportFormat = 'Excel';
      vm.generating = false;
  
      vm.calendar = {
        opened: {},
        dateFormat: 'dd-MMM-yyyy',
        dateOptions: {},
        maxDate: new Date(),
        open: function($event, which) {
          $event.preventDefault();
          $event.stopPropagation();
          vm.calendar.opened[which] = true;
        }
      };
  
      vm.inspectionTypes = [
        {'value' : 'Level 1', 'text' : 'Level-1 : Vendor inspection'},
        {'value' : 'Level 2', 'text' : 'Level-2 : Inspection On Delivery'}
      ];
  
      vm.inspectionType = {};
  
      activate();
  
      ///////////////////////
  
      function activate() {
  
      }
  
      function runReport() {
        vm.generating = true;
   
        var supplier = ( vm.supplierSelected == null || vm.supplierSelected.supplierCode === "" ) ? null : vm.supplierSelected.supplierCode;
        var purchaseOrder = ( vm.purchaseOrderSelected !=null && vm.purchaseOrderSelected.length > 0) ? urlHelperService.getSelectedValuesReport(vm.purchaseOrderSelected, 'number') : null;
        var dateFrom =  vm.dateFrom == null  ? null : vm.dateFrom;
        var dateTo =  vm.dateTo == null  ? null : vm.dateTo;
        var refNo = (vm.refNumberSelected == null || vm.refNumberSelected.refNo === "") ? null : vm.refNumberSelected.refNo;
        var costCode = ( vm.costCodeSelected == null || vm.costCodeSelected.costCode === "" ) ? null : vm.costCodeSelected.costCode;
        var inspectionType = vm.inspectionType === "" ? null : vm.inspectionType.value;
  
        var parameters = {
          SupplierCode: supplier,
          PONumber: purchaseOrder,
          DateFrom: dateFrom,
          DateTo: dateTo,
          RefNo: refNo,
          CostCode: costCode,
          InspectionType: inspectionType,
          ProjectCode: SETTINGS.projectCode
        };
  
        var data = {
          reportType: 'OutstandingInspection',
          reportFormat: vm.reportFormat,
          parametersString: JSON.stringify(parameters),
          parameters: {}
        };
  
        reportingService.prepAndRunReport(data).then(function(){
          vm.generating = false;
        });
  
      }
  
      
      /** Suppliers */
  
      vm.suppliers = {
        transport: {
          read: {
            url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-orders/suppliers",
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Authorization', vm.bearerToken);
            }
          }
        }
      };
  
      vm.supplierOptions = {
        dataSource: vm.suppliers,
        dataTextField: "supplierName",
        dataValueField: "supplierCode",
        filter: "contains",
        autoBind: false,
        placeholder: "ALL",
        template: '{{dataItem.supplierCode + " - " + dataItem.supplierName}}'
      };
  
      /** PurchaseOrder */
  
      vm.purchaseOrders = {
        type: 'odata-v4',
        pageSize: 40,
        serverPaging: true,
        serverFiltering: true,
        transport: {
          read: {
            url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
            beforeSend: function(xhr) {
              xhr.setRequestHeader('Authorization', vm.bearerToken)
            }
          }
        },
        filter:[
          { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
        ]
  
      };
  
      vm.purchaseOrderOptions = {
        height: 210,
        dataSource: vm.purchaseOrders,
        dataTextField: "number",
        dataValueField: "number",
        template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
        filter: "contains",
        virtual: {
          itemHeight: 30
        },
        autoBind: false,
        placeholder: "ALL"
      };
  
      /** Ref No */
  
      vm.refNumbers = {
        transport: {
          read: {
            url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-order-lines/ref-numbers",
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Authorization', vm.bearerToken)
            }
          }
        }
      };
  
      vm.refNumberOptions = {
        dataSource: vm.refNumbers,
        dataTextField: "refNo",
        dataValueField: "refNo",
        filter: "contains",
        autoBind: false,
        placeholder: "ALL"
      };

      /** CostCodes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-order-lines/cost-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.costCodeOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };
  
      /** Inspection Levels */
  
      vm.inspectionTypeData = {
        transport: {
          read: function(options) {
            options.success(vm.inspectionTypes);
          }
        }
      };
  
      vm.inspectionTypeOptions = {
        dataSource: vm.inspectionTypeData,
        dataTextField: 'text',
        dataValueField: 'value',
        autoBind: false,
        databound: function() {
          var noItems = this.list.find(".noDataMessage");
  
          if (!this.dataSource.view()[0]) {
            noItems.show();
            this.popup.open();
          } else {
            noItems.hide();
          }
        },
        close: function(e) {
          var widget = e.sender;
  
          if (!widget.shouldClose && !this.dataSource.view()[0]) {
            e.preventDefault();
          }
        }
      };
  
    }
  
  })();
(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('GrnDetailsMonetaryValueReportCtrl', GrnDetailsMonetaryValueReportCtrl);

  GrnDetailsMonetaryValueReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function GrnDetailsMonetaryValueReportCtrl(reportingService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.ircNumbers = [];
    vm.ircNumberOptions = [];
    vm.materialCodes = [];
    vm.materialCodeOptions = [];
    vm.purchaseOrderOptions = [];
    vm.deliveryCodes = [];
    vm.deliveryOptions = [];

    vm.ircNumberSelected = { };
    vm.materialCodeSelected = { };
    vm.purchaseOrderSelected = { };
    vm.deliverySelected = { };
    vm.reportFormat = 'Pdf';
    vm.generating = false;
    vm.monetaryValue = 'False';

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var ircNumber = ( vm.ircNumberSelected == null || vm.ircNumberSelected.ircNumber === "" ) ? null : vm.ircNumberSelected.ircNumber;
      var materialCode = ( vm.materialCodeSelected == null || vm.materialCodeSelected.materialCode === "" ) ? null : vm.materialCodeSelected.materialCode;
      var purchaseOrder = ( vm.purchaseOrderSelected == null || vm.purchaseOrderSelected.number === "") ? null : vm.purchaseOrderSelected.number;
      var delivery = ( vm.deliverySelected == null || vm.deliverySelected.number === "") ? null : vm.deliverySelected.number;
      var dateFrom =  vm.dateFrom == null  ? null : vm.dateFrom;
      var dateTo =  vm.dateTo == null  ? null : vm.dateTo;
      var description = vm.description == "" ? null : vm.description;

      var parameters = {
        IrcNumber: ircNumber,
        MaterialCode: materialCode,
        PONumber: purchaseOrder,
        DeliveryNumber: delivery,
        DeliveryDateFrom: dateFrom,
        Description: description,
        DeliveryDateTo: dateTo,
        ProjectCode: SETTINGS.projectCode
      };

      var data = {
        reportType: vm.monetaryValue == 'True' ? 'grnDetailsMonetaryValue' : 'grnDetails',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** IrcNumbers */

    vm.ircNumbers = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/irc-numbers",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.ircNumberOptions = {
      dataSource: vm.ircNumbers,
      dataTextField: "ircNumber",
      dataValueField: "ircNumber",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    

    /** MaterialCodes */

    vm.deliveryCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/deliveries/stored",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.deliveryOptions = {
      dataSource: vm.deliveryCodes,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** MaterialCodes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.materialCodeOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      template: '{{dataItem.materialCode + " - " + dataItem.description}}',
      autoBind: false,
      placeholder: "ALL"
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      filter: "contains",
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('app.reporting')
    .controller('ExpeditingUpdateReportCtrl', ExpeditingUpdateReportCtrl);

  ExpeditingUpdateReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager', 'stockService', 'urlHelperService', 'timeIntervalService'];

  /* @ngInject */
  function ExpeditingUpdateReportCtrl(reportingService, API, SETTINGS, OidcManager, stockService, urlHelperService, timeIntervalService) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.suppliers = [];
    vm.supplierOptions = [];
    vm.buyerNames = [];
    vm.buyerNameOptions = [];
    vm.purchaseOrderCodes = [];
    vm.purchaseOrderOptions = [];
    vm.refNumbers = [];
    vm.refNumberOptions = [];
    vm.purchaseOrderSelected = [];

    vm.supplierSelected = {};
    vm.buyerNameSelected = {};
    vm.refNumberSelected = {};
    vm.reportFormat = 'Pdf';
    vm.generating = false;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function ($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    vm.timeIntervals = [
      {'value' : 'ww:1', 'text' : '1 week'},
      {'value' : 'ww:2', 'text' : '2 weeks'},
      {'value' : 'ww:3', 'text' : '3 weeks'},
      {'value' : 'ww:4', 'text' : '4 weeks'},
      {'value' : 'ww:6', 'text' : '6 weeks'},
      {'value' : 'ww:8', 'text' : '8 weeks'},
      {'value' : 'ww:12', 'text' : '12 weeks'},
      {'value' : 'm:6', 'text' : '6 months'},
      {'value' : 'yy:-1', 'text' : 'OVERDUE'}
    ];

    vm.timeInterval = {};

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() { 
      vm.generating = true;

      var supplier = (vm.supplierSelected == null || vm.supplierSelected.supplierCode === "") ? null : vm.supplierSelected.supplierCode;
      var buyerName = (vm.buyerNameSelected == null || vm.buyerNameSelected.buyerName === "") ? null : vm.buyerNameSelected.buyerName;
      var purchaseOrder = ( vm.purchaseOrderSelected !=null && vm.purchaseOrderSelected.length > 0) ? urlHelperService.getSelectedValuesReport(vm.purchaseOrderSelected, 'number') : null;
      var dateFrom = timeIntervalService.getDateFrom(vm.dateFrom, vm.timeInterval.value);
      var dateTo = timeIntervalService.getDateTo(vm.dateTo, vm.timeInterval.value);
      var refNo = (vm.refNumberSelected == null || vm.refNumberSelected.refNo === "") ? null : vm.refNumberSelected.refNo;

      var parameters = {
        SupplierCode: supplier,
        BuyerName: buyerName,
        PONumber: purchaseOrder,
        DateFrom: dateFrom,
        DateTo: dateTo,
        RefNo: refNo,
        ProjectCode: SETTINGS.projectCode
      };

      var data = {
        reportType: 'ExpeditingUpdate',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function () {
        vm.generating = false;
      });

    }

    /** Suppliers */

    vm.suppliers = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-orders/suppliers",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.supplierOptions = {
      dataSource: vm.suppliers,
      dataTextField: "supplierName",
      dataValueField: "supplierCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL",
      template: '{{dataItem.supplierCode + " - " + dataItem.supplierName}}'
    };

    /** BuyerNames */

    vm.buyerNames = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-order-lines/buyer-names",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.buyerNameOptions = {
      dataSource: vm.buyerNames,
      dataTextField: "buyerName",
      dataValueField: "buyerName",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter: [
        {field: "projectCode", operator: "eq", value: SETTINGS.projectCode}
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      filter: "contains",
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

    /** Ref No */

    vm.refNumbers = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-order-lines/ref-numbers",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      }
    };

    vm.refNumberOptions = {
      dataSource: vm.refNumbers,
      dataTextField: "refNo",
      dataValueField: "refNo",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** Time intervals */

    vm.timeIntervalData = {
      transport: {
        read: function(options) {
          options.success(vm.timeIntervals);
        }
      }
    };

    vm.timeIntervalOptions = {
      dataSource: vm.timeIntervalData,
      dataTextField: 'text',
      dataValueField: 'value',
      autoBind: false,
      databound: function() {
        var noItems = this.list.find(".noDataMessage");

        if (!this.dataSource.view()[0]) {
          noItems.show();
          this.popup.open();
        } else {
          noItems.hide();
        }
      },
      close: function(e) {
        var widget = e.sender;

        if (!widget.shouldClose && !this.dataSource.view()[0]) {
          e.preventDefault();
        }
      }
    };
  }

})();

(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('ExpeditingReportCtrl', ExpeditingReportCtrl);

  ExpeditingReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager', 'urlHelperService', 'timeIntervalService'];

  /* @ngInject */
  function ExpeditingReportCtrl(reportingService, API, SETTINGS, OidcManager, urlHelperService, timeIntervalService) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    vm.suppliers = [];
    vm.supplierOptions = [];
    vm.buyerNames = [];
    vm.buyerNameOptions = [];
    vm.purchaseOrderCodes = [];
    vm.purchaseOrderOptions = [];
    vm.refNumbers = [];
    vm.refNumberOptions = [];
    vm.purchaseOrderSelected = [];

    vm.supplierSelected = {};
    vm.buyerNameSelected = {};
    vm.refNumberSelected = {};
    vm.reportFormat = 'Pdf';
    vm.generating = false;

    vm.orderBy = { value: 'EtaDate', order: 'Desc' };
    vm.orderByData = [];

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    vm.timeIntervals = [
      {'value' : 'ww:1', 'text' : '1 week'},
      {'value' : 'ww:2', 'text' : '2 weeks'},
      {'value' : 'ww:3', 'text' : '3 weeks'},
      {'value' : 'ww:4', 'text' : '4 weeks'},
      {'value' : 'ww:6', 'text' : '6 weeks'},
      {'value' : 'ww:8', 'text' : '8 weeks'},
      {'value' : 'ww:12', 'text' : '12 weeks'},
      {'value' : 'm:6', 'text' : '6 months'},
      {'value' : 'yy:-1', 'text' : 'OVERDUE'}
    ];

    vm.timeInterval = {};

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;
 
      var supplier = ( vm.supplierSelected == null || vm.supplierSelected.supplierCode === "" ) ? null : vm.supplierSelected.supplierCode;
      var buyerName = ( vm.buyerNameSelected == null || vm.buyerNameSelected.buyerName === "" ) ? null : vm.buyerNameSelected.buyerName;      
      var purchaseOrder = ( vm.purchaseOrderSelected !=null && vm.purchaseOrderSelected.length > 0) ? urlHelperService.getSelectedValuesReport(vm.purchaseOrderSelected, 'number') : null;
      var dateFrom = timeIntervalService.getDateFrom(vm.dateFrom, vm.timeInterval.value);
      var dateTo = timeIntervalService.getDateTo(vm.dateTo, vm.timeInterval.value);
      var refNo = (vm.refNumberSelected == null || vm.refNumberSelected.refNo === "") ? null : vm.refNumberSelected.refNo;
      var orderBy =  ( vm.orderBy == null || vm.orderBy.value === "") ? "EtaDate" : vm.orderBy.value;
      var orderByDirection =  ( vm.orderBy == null || vm.orderBy.value === "") ? "Desc" : vm.orderBy.order;

      var parameters = {
        SupplierCode: supplier,
        BuyerName: buyerName,
        PONumber: purchaseOrder,
        DateFrom: dateFrom,
        DateTo: dateTo,
        RefNo: refNo,
        OrderBy: orderBy,
        OrderByDirection: orderByDirection,
        ProjectCode: SETTINGS.projectCode
      };

      var data = {
        reportType: 'Expediting',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });

    }

    /** Order by */
    
    vm.orderByData = {
      transport: {
        read: function(options) {
          options.success([
            {'text' : 'ETA Date', 'value' : 'EtaDate', order: "Desc"},
            {'text' : 'Promised Date', 'value' : 'PromisedDate', order: "Desc"},
            {'text' : 'Supplier', 'value' : 'SupplierName', order: "Asc"},
            {'text' : 'Buyer', 'value' : 'BuyerName', order: "Asc"},
            {'text' : 'Purchase Order', 'value' : 'PONumber', order: "Asc"}
          ]);
        }
      }
    };

    vm.orderByOptions = {
      dataSource: vm.orderByData,
      dataTextField: 'text',
      dataValueField: 'value',
      placeholder: "ETA Date"
    };

    /** Suppliers */

    vm.suppliers = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-orders/suppliers",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.supplierOptions = {
      dataSource: vm.suppliers,
      dataTextField: "supplierName",
      dataValueField: "supplierCode",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL",
      template: '{{dataItem.supplierCode + " - " + dataItem.supplierName}}'
    };

    /** BuyerNames */

    vm.buyerNames = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-order-lines/buyer-names",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.buyerNameOptions = {
      dataSource: vm.buyerNames,
      dataTextField: "buyerName",
      dataValueField: "buyerName",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      filter: "contains",
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

    /** Ref No */

    vm.refNumbers = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-order-lines/ref-numbers",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      }
    };

    vm.refNumberOptions = {
      dataSource: vm.refNumbers,
      dataTextField: "refNo",
      dataValueField: "refNo",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL"
    };

    /** Time intervals */

    vm.timeIntervalData = {
      transport: {
        read: function(options) {
          options.success(vm.timeIntervals);
        }
      }
    };

    vm.timeIntervalOptions = {
      dataSource: vm.timeIntervalData,
      dataTextField: 'text',
      dataValueField: 'value',
      autoBind: false,
      databound: function() {
        var noItems = this.list.find(".noDataMessage");

        if (!this.dataSource.view()[0]) {
          noItems.show();
          this.popup.open();
        } else {
          noItems.hide();
        }
      },
      close: function(e) {
        var widget = e.sender;

        if (!widget.shouldClose && !this.dataSource.view()[0]) {
          e.preventDefault();
        }
      }
    };

  }

})();

(function() {
    'use strict';
  
    angular
      .module('app.reporting')
      .controller('ExpeditingHistoryReportCtrl', ExpeditingHistoryReportCtrl);
  
      ExpeditingHistoryReportCtrl.$inject = ['reportingService', 'API', 'SETTINGS', 'OidcManager', 'urlHelperService', 'timeIntervalService'];
  
    /* @ngInject */
    function ExpeditingHistoryReportCtrl(reportingService, API, SETTINGS, OidcManager, urlHelperService, timeIntervalService) {
      var vm = this;
      vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;
  
      vm.runReport = runReport;
  
      vm.suppliers = [];
      vm.supplierOptions = [];
      vm.purchaseOrderCodes = [];
      vm.purchaseOrderOptions = [];
      vm.refNumbers = [];
      vm.refNumberOptions = [];
      vm.purchaseOrderSelected = [];
  
      vm.supplierSelected = {};
      vm.refNumberSelected = {};
      vm.reportFormat = 'Excel';
      vm.generating = false;
  
      //vm.orderBy = { value: 'EtaDate', order: 'Desc' };
      //vm.orderByData = [];
  
      vm.calendar = {
        opened: {},
        dateFormat: 'dd-MMM-yyyy',
        dateOptions: {},
        maxDate: new Date(),
        open: function($event, which) {
          $event.preventDefault();
          $event.stopPropagation();
          vm.calendar.opened[which] = true;
        }
      };
  
      vm.timeIntervals = [
        {'value' : 'ww:1', 'text' : '1 week'},
        {'value' : 'ww:2', 'text' : '2 weeks'},
        {'value' : 'ww:3', 'text' : '3 weeks'},
        {'value' : 'ww:4', 'text' : '4 weeks'},
        {'value' : 'ww:6', 'text' : '6 weeks'},
        {'value' : 'ww:8', 'text' : '8 weeks'},
        {'value' : 'ww:12', 'text' : '12 weeks'},
        {'value' : 'm:6', 'text' : '6 months'},
        {'value' : 'yy:-1', 'text' : 'OVERDUE'}
      ];
  
      vm.timeInterval = {};
  
      activate();
  
      ///////////////////////
  
      function activate() {
  
      }
  
      function runReport() {
        vm.generating = true;
   
        var supplier = ( vm.supplierSelected == null || vm.supplierSelected.supplierCode === "" ) ? null : vm.supplierSelected.supplierCode;
        var purchaseOrder = ( vm.purchaseOrderSelected !=null && vm.purchaseOrderSelected.length > 0) ? urlHelperService.getSelectedValuesReport(vm.purchaseOrderSelected, 'number') : null;
        var dateFrom = timeIntervalService.getDateFrom(vm.dateFrom, vm.timeInterval.value);
        var dateTo = timeIntervalService.getDateTo(vm.dateTo, vm.timeInterval.value);
        var refNo = (vm.refNumberSelected == null || vm.refNumberSelected.refNo === "") ? null : vm.refNumberSelected.refNo;
        //var orderBy =  ( vm.orderBy == null || vm.orderBy.value === "") ? "EtaDate" : vm.orderBy.value;
        //var orderByDirection =  ( vm.orderBy == null || vm.orderBy.value === "") ? "Desc" : vm.orderBy.order;
  
        var parameters = {
          SupplierCode: supplier,
          PONumber: purchaseOrder,
          DateFrom: dateFrom,
          DateTo: dateTo,
          RefNo: refNo,
          //OrderBy: orderBy,
          //OrderByDirection: orderByDirection,
          ProjectCode: SETTINGS.projectCode
        };
  
        var data = {
          reportType: 'ExpeditingHistory',
          reportFormat: vm.reportFormat,
          parametersString: JSON.stringify(parameters),
          parameters: {}
        };
  
        reportingService.prepAndRunReport(data).then(function(){
          vm.generating = false;
        });
  
      }
  
      /** Order by */
      
      /** vm.orderByData = {
        transport: {
          read: function(options) {
            options.success([
              {'text' : 'ETA Date', 'value' : 'EtaDate', order: "Desc"},
              {'text' : 'Promised Date', 'value' : 'PromisedDate', order: "Desc"},
              {'text' : 'Supplier', 'value' : 'SupplierName', order: "Asc"},
              {'text' : 'Purchase Order', 'value' : 'PONumber', order: "Asc"}
            ]);
          }
        }
      }; */
  
      /** vm.orderByOptions = {
        dataSource: vm.orderByData,
        dataTextField: 'text',
        dataValueField: 'value',
        placeholder: "ETA Date"
      }; */
  
      /** Suppliers */
  
      vm.suppliers = {
        transport: {
          read: {
            url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-orders/suppliers",
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Authorization', vm.bearerToken);
            }
          }
        }
      };
  
      vm.supplierOptions = {
        dataSource: vm.suppliers,
        dataTextField: "supplierName",
        dataValueField: "supplierCode",
        filter: "contains",
        autoBind: false,
        placeholder: "ALL",
        template: '{{dataItem.supplierCode + " - " + dataItem.supplierName}}'
      };
  
      /** PurchaseOrder */
  
      vm.purchaseOrders = {
        type: 'odata-v4',
        pageSize: 40,
        serverPaging: true,
        serverFiltering: true,
        transport: {
          read: {
            url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
            beforeSend: function(xhr) {
              xhr.setRequestHeader('Authorization', vm.bearerToken)
            }
          }
        },
        filter:[
          { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
        ]
  
      };
  
      vm.purchaseOrderOptions = {
        height: 210,
        dataSource: vm.purchaseOrders,
        dataTextField: "number",
        dataValueField: "number",
        template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
        filter: "contains",
        virtual: {
          itemHeight: 30
        },
        autoBind: false,
        placeholder: "ALL"
      };
  
      /** Ref No */
  
      vm.refNumbers = {
        transport: {
          read: {
            url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-order-lines/ref-numbers",
            beforeSend: function (xhr) {
              xhr.setRequestHeader('Authorization', vm.bearerToken)
            }
          }
        }
      };
  
      vm.refNumberOptions = {
        dataSource: vm.refNumbers,
        dataTextField: "refNo",
        dataValueField: "refNo",
        filter: "contains",
        autoBind: false,
        placeholder: "ALL"
      };
  
      /** Time intervals */
  
      vm.timeIntervalData = {
        transport: {
          read: function(options) {
            options.success(vm.timeIntervals);
          }
        }
      };
  
      vm.timeIntervalOptions = {
        dataSource: vm.timeIntervalData,
        dataTextField: 'text',
        dataValueField: 'value',
        autoBind: false,
        databound: function() {
          var noItems = this.list.find(".noDataMessage");
  
          if (!this.dataSource.view()[0]) {
            noItems.show();
            this.popup.open();
          } else {
            noItems.hide();
          }
        },
        close: function(e) {
          var widget = e.sender;
  
          if (!widget.shouldClose && !this.dataSource.view()[0]) {
            e.preventDefault();
          }
        }
      };
  
    }
  
  })();
(function() {
  'use strict';

  angular
    .module('app.reporting')
    .controller('BagAndTagReportCtrl', BagAndTagReportCtrl);

  BagAndTagReportCtrl.$inject = ['reportingService', 'bagAndTagService', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function BagAndTagReportCtrl(reportingService, bagAndTagService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.runReport = runReport;

    /** Bag and Tags */
    vm.bagAndTagNumbers = [];
    vm.bagAndTagNumbersOptions = [];

    vm.bagAndTagSelected = '';
    vm.reportFormat = 'Pdf';
    vm.generating = false;

    activate();

    ///////////////////////

    function activate() {

    }

    function runReport() {
      vm.generating = true;

      var bagAndTag = vm.bagAndTagSelected.number == "" ? null : vm.bagAndTagSelected.number;

      var parameters = {
        ProjectCode: SETTINGS.projectCode,
        BagAndTagNumber: bagAndTag
      };

      var data = {
        reportType: 'BagAndTag',
        reportFormat: vm.reportFormat,
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });
    }

    /** Bag and Tag numbers */

    vm.bagAndTagNumbers = {
      transport: {
        read: function (options) {
          return bagAndTagService.getBagAndTagNumbersAll()
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        }
      }
    };

    vm.bagAndTagNumbersOptions = {
      placeholder: "(Optional)",
      dataSource: vm.bagAndTagNumbers,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.description}}',
      autoBind: false
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.purchase-orders', []);

})();

(function(){
  'use strict';

  angular
    .module('app.purchase-orders')
    .controller('ViewReceiptsCtrl', ViewReceiptsCtrl);

  ViewReceiptsCtrl.$inject = ['purchaseOrderService'];

  /* @ngInject */
  function ViewReceiptsCtrl(purchaseOrderService) {
    var vm = this;
    vm.incompletePurchaseOrderReceipts = [];
    vm.statusOptions = [
      {'value' : 'incomplete', 'text' : 'Incomplete'},
      {'value' : 'overdue', 'text' : 'Overdue only (receipted > 60 mins ago)'},
      {'value' : 'complete', 'text' : 'Completed'}
    ];

    vm.getReceiptedPurchaseOrders = getReceiptedPurchaseOrders;

    activate();

    //////////////////

    function activate(){
      getReceiptedPurchaseOrders();
    }

    function getReceiptedPurchaseOrders(){
      vm.statusSelected = vm.statusSelected ? vm.statusSelected : {'value' : 'incomplete', 'text' : 'Incomplete'};

      purchaseOrderService.getReceiptsIncomplete(vm.statusSelected.value)
        .then(function(response){
          vm.incompletePurchaseOrderReceipts = response;
        });
    }

    /** Order by */
    vm.receiptStatusData = {
      transport: {
        read: function(options) {
          options.success(vm.statusOptions);
        }
      }
    };

    vm.receiptStatusOptions = {
      dataSource: vm.receiptStatusData,
      dataTextField: 'text',
      dataValueField: 'value',
      autoBind: false,
      placeholder: "Incomplete",
      databound: function() {
        var noItems = this.list.find(".noDataMessage");

        if (!this.dataSource.view()[0]) {
          noItems.show();
          this.popup.open();
        } else {
          noItems.hide();
        }
      },
      close: function(e) {
        var widget = e.sender;

        if (!widget.shouldClose && !this.dataSource.view()[0]) {
          e.preventDefault();
        }
      }
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app.purchase-orders')
    .controller('ViewReceiptDetailsCtrl', ViewReceiptDetailsCtrl);

  ViewReceiptDetailsCtrl.$inject = [
    '$stateParams',
    '$window',
    'dataservice',
    'purchaseOrderService',
    'deliveryService'
  ];

  function ViewReceiptDetailsCtrl(
    $stateParams,
    $window,
    dataservice,
    purchaseOrderService,
    deliveryService
  ) {
    var vm = this;

    vm.purchaseOrderId = $stateParams.id;
    vm.purchaseOrder = {};
    vm.purchaseOrderLines = [];

    vm.backBtn = backBtn;
    vm.statusFilter = statusFilter;

   
    vm.receiptStatusOptions = [
      { text: 'All', value: 'all' },
      { text: 'Incomplete', value: 1 },
      { text: 'Overdue only (receipted > 60 mins ago)', value: 2 },
      { text: 'Complete', value: 3 }
    ];

   
    vm.statusSelected = vm.receiptStatusOptions[0];

    activate();


    function activate() {
      return getPurchaseOrder().then(function () {
        return purchaseOrderService
          .getReceiptedPurchaseOrderLines(vm.purchaseOrderId)
          .then(function (response) {
            vm.purchaseOrderLines = response;
          });
      });
    }

    function getPurchaseOrder() {
      return dataservice.getPurchaseOrder(vm.purchaseOrderId)
        .then(function (response) {
          vm.purchaseOrder = response;
          return vm.purchaseOrder;
        });
    }

   
    function statusFilter(item) {
      if (!vm.statusSelected || vm.statusSelected.value === 'all') {
        return true;
      }
      return item.receivedStatusId === vm.statusSelected.value;
    }

    function backBtn() {
      $window.history.back();
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app.purchase-orders')
    .controller('ViewPurchaseOrdersCtrl', ViewPurchaseOrdersCtrl);

  ViewPurchaseOrdersCtrl.$inject = ['purchaseOrderService', 'permissionService', 'FileSaver', 'Blob'];

  /* @ngInject */
  function ViewPurchaseOrdersCtrl(purchaseOrderService, permissionService, FileSaver, Blob){
    var vm = this;

    vm.isAdmin = permissionService.isAdmin();
    vm.canGetPurchaseOrder = vm.isAdmin === true ? true : permissionService.hasPermission("PurchaseOrders", "GetFromOracle");
    vm.incompletePurchaseOrders = [];
    vm.completePurchaseOrders = [];

    vm.downloadTemplate = downloadTemplate;

    activate();

    //////////////////////

    function activate()
    {
      purchaseOrderService.getIncompletePurchaseOrders()
        .then(function(response) {
          vm.incompletePurchaseOrders = response;
        });

      purchaseOrderService.getCompletePurchaseOrders()
        .then(function(response){
          vm.completePurchaseOrders = response;
        });
    }

    function downloadTemplate(){
      return purchaseOrderService.getImportTemplate()
        .then(function(response){
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.purchase-orders')
    .directive('wgViewHistory', wgViewHistory);

  wgViewHistory.$inject = [];

  /* @ngInject */
  function wgViewHistory() {
    var directive = {
      bindToController: true,
      controller: ViewHistoryCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        purchaseOrderId: '=',
        purchaseOrderLineId: '=',
        materialDescription: '='
      },
      templateUrl: 'app/purchase-orders/viewHistory.html'
    };

    return directive;

    function link($scope, element, attrs){

    }
  }

  ViewHistoryCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function ViewHistoryCtrl($uibModal) {
    var vm = this;

    vm.purchaseOrderId = this.purchaseOrderId;
    vm.purchaseOrderLineId = this.purchaseOrderLineId;
    vm.materialDescription = this.materialDescription;

    vm.openHistory = openHistory;

    function openHistory() {
      $uibModal.open({
        templateUrl: 'app/purchase-orders/viewHistoryModal.html',
        controller: 'ViewHistoryModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          purchaseOrderId: function () {
            return vm.purchaseOrderId
          },
          purchaseOrderLineId: function () {
            return vm.purchaseOrderLineId;
          },
          materialDescription: function () {
            return vm.materialDescription;
          }
        }
      });
    }
  }

  angular
    .module('app.purchase-orders')
    .controller('ViewHistoryModalCtrl', ViewHistoryModalCtrl);

  ViewHistoryModalCtrl.$inject = ['$uibModalInstance', 'purchaseOrderService', 'purchaseOrderId', 'purchaseOrderLineId', 'materialDescription', 'OidcManager'];

  function ViewHistoryModalCtrl($uibModalInstance, purchaseOrderService, purchaseOrderId, purchaseOrderLineId, materialDescription, OidcManager){
    var vm = this;
    vm.manager = OidcManager.OidcTokenManager();
    vm.purchaseOrderId = purchaseOrderId;
    vm.purchaseOrderLineId = purchaseOrderLineId;
    vm.materialDescription = materialDescription;

    vm.history = null;

    vm.loading = true;

    activate();

    //////////////////////////////

    function activate() {
      return getPurchaseOrderLineHistory().then(function () {
        vm.loading = false;
      });
    }

    function getPurchaseOrderLineHistory(){
      return purchaseOrderService.getPurchaseOrderLineHistory(vm.purchaseOrderId, vm.purchaseOrderLineId)
        .then(function(data){
          vm.history = data;
          vm.loading = false;
          return vm.history
        })
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }

})();

(function(){
  'use strict';

  angular
    .module('app.purchase-orders')
    .directive('wgPurchaseOrderLineDeliveries', wgPurchaseOrderLineDeliveries);

  wgPurchaseOrderLineDeliveries.$inject = [];

  /* @ngInject */
  function wgPurchaseOrderLineDeliveries() {
    var directive = {
      bindToController: true,
      controller: PurchaseOrderLineDeliveriesDirCtrl,
      controllerAs : 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/purchase-orders/purchaseOrderLineDeliveries.html',
      scope: {
        id: '='
      }
    };

    return directive;

    function link(scope, element, attrs){

    }
  }

  PurchaseOrderLineDeliveriesDirCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function PurchaseOrderLineDeliveriesDirCtrl($uibModal){
    var vm = this;

    vm.id = this.id;

    vm.openDeliveries = openDeliveries;

    function openDeliveries() {
      $uibModal.open({
        templateUrl: 'app/purchase-orders/purchaseOrderLineDeliveriesModal.html',
        controller: 'PurchaseOrderLineDeliveriesCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          id: function () {
            return vm.id;
          }
        }
      });
    }
  }

  angular
    .module('app.purchase-orders')
    .controller('PurchaseOrderLineDeliveriesCtrl', PurchaseOrderLineDeliveriesCtrl);

  PurchaseOrderLineDeliveriesCtrl.$inject = ['$state', '$uibModalInstance', 'deliveryService', 'id'];

  function PurchaseOrderLineDeliveriesCtrl($state, $uibModalInstance, deliveryService, id){
    var vm = this;

    vm.id = id;
    vm.purchaseOrderLine = {};
    vm.deliveries = [];
    vm.goToDelivery = goToDelivery;
    vm.loading = true;

    activate();

    /////////////////////////////

    function activate(){
      getPurchaseOrderLineDeliveries();
    }

    function getPurchaseOrderLineDeliveries() {
      return deliveryService.getPurchaseOrderLineDeliveries(vm.id)
        .then(function (response){
          vm.deliveries = response;
          vm.purchaseOrderLine = vm.deliveries[0];
          vm.loading = false;
        });
    }

    function goToDelivery(id){
      $state.go('deliveries.details', {id:id});
      vm.cancel();
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.purchase-orders')
    .controller('ImportPOItemsCtrl', ImportPOItemsCtrl);

  ImportPOItemsCtrl.$inject = ['$scope', 'API', 'SETTINGS', 'purchaseOrderService', 'FileSaver', 'Blob'];

  /* @ngInject */
  function ImportPOItemsCtrl($scope, API, SETTINGS, purchaseOrderService, FileSaver, Blob) {

    var vm = this;

    vm.loading = false;

    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;
    vm.downloadTemplate = downloadTemplate;
    vm.getImportErrors = getImportErrors;

    vm.importEndpoint = API.BASE_URI_PURCHASING + SETTINGS.projectCode + '/purchase-orders/upload';

    activate();

    ////////////////

    function activate() {
    }

    function downloadTemplate() {
      return purchaseOrderService.getImportTemplate()
        .then(function(response) {
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

    function getImportErrors(manifestId, documentKey){
      return purchaseOrderService.getImportErrors(manifestId, documentKey)
        .then(function(response) {
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not record delivery.');
      }
      vm.loading = false;
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.purchase-orders')
    .controller('GetPurchaseOrderCtrl', GetPurchaseOrderCtrl);

  GetPurchaseOrderCtrl.$inject = ['$timeout', 'purchaseOrderService'];

  /* @ngInject */
  function GetPurchaseOrderCtrl($timeout, purchaseOrderService){
    var vm = this;

    vm.loading = false;

    vm.purchaseOrderNumber = "";
    vm.queryId = "";
    vm.status = "";
    vm.loadingClass = "";
    vm.getPurchaseOrder = getPurchaseOrder;
    vm.successful = false;
    vm.response = {};

    var loadTime = 5000, errorCount = 0, loadPromise;

    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;

    activate();

    //////////////////////

    function activate(){

    }

    function getPurchaseOrder(){
      vm.successful = false;
      vm.loading = true;
      vm.status = "Request sent";
      vm.loadingClass = "loading";
      return purchaseOrderService.getPurchaseOrderFromOracle(vm.purchaseOrderNumber)
        .then(function (response) {
          vm.queryId = response.id;
          getQueryStatus();
          vm.loading = false;
        });
    }

    function getQueryStatus(){
      return purchaseOrderService.getPurchaseOrderQueryStatus(vm.queryId, vm.purchaseOrderNumber)
        .then(function(response) {
          if (response.status === 'Pending' || response.status === 'AwaitingResponse'){
            vm.status = response.status;
            nextLoad(++errorCount *2* loadTime);
          } else if (response.status === 'NotFound') {
            vm.status = response.message;
            vm.loadingClass = "";
            cancelNextLoad();
          } else {
            vm.successful = true;
            vm.response = response;
            cancelNextLoad();
          }
        });
    }

    function nextLoad(time){
      time = time || loadTime;
      cancelNextLoad();
      $timeout(getQueryStatus, time);
    }

    function cancelNextLoad() {
      $timeout.cancel(loadPromise);
    }

    function showValidationErrors(error){
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessages);
        }
      } else {
        vm.validationErrors.push('Could not create purchase order.');
      }
      vm.loading = false;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.purchase-orders')
    .controller('DetailsCtrl', DetailsCtrl);

  angular
    .module('app.purchase-orders')
    .controller('MyModalController', function ($uibModalInstance) {
      var vm = this;
      vm.ok = function () {
        $uibModalInstance.close();
      };

      vm.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };
    });

  DetailsCtrl.$inject = ['$stateParams', '$filter', 'dataservice', 'purchaseOrderService', 'purchaseOrderCompositeService','SweetAlert'];

  /* @ngInject */
  function DetailsCtrl($stateParams, $filter, dataservice, purchaseOrderService, purchaseOrderCompositeService, SweetAlert) {
    var vm = this;

    vm.purchaseOrderId = $stateParams.id;
    vm.highlight = $stateParams.highlight;
    vm.purchaseOrder = {};
    vm.purchaseOrderLines = [];
    vm.completionTotal = 0;
    vm.open = open;

    vm.getPurchaseOrder = getPurchaseOrder;
    vm.fakeLineItems = fakeLineItems;
    vm.deletePurchaseOrderLineItem = deletePurchaseOrderLineItem;
    vm.cancelPurchaseOrder = cancelPurchaseOrder;
    vm.completePurchaseOrder = completePurchaseOrder;

    activate();

    ////////////////

    function activate() {
      return getPurchaseOrder().then(function () {
        if(vm.purchaseOrder.statusId != 1) {
          return getPurchaseOrderLines(vm.purchaseOrderId).then(function () {
            getDeliveryCompletionTotal();
          });
        }
      });
    }

    function getPurchaseOrder() {
      return dataservice.getPurchaseOrder(vm.purchaseOrderId)
        .then(function (data) {
          vm.purchaseOrder = data;
          vm.purchaseOrder.isReadOnly = vm.purchaseOrder.statusId > 1;

          if(vm.purchaseOrder.statusId == 1) {
            vm.purchaseOrderLines = vm.purchaseOrder.lines;
          }

          return vm.purchaseOrder;
        });
    }

    function getPurchaseOrderLines(id) {
      return purchaseOrderCompositeService.getPurchaseOrderLines(id)
        .then(function (data) {
          vm.purchaseOrderLines = data.purchaseOrderLines;
        });
    }

    function getDeliveryCompletionTotal() {
      if (vm.purchaseOrderLines !== undefined){
        var itemsToBeReceived = $filter('filter')(vm.purchaseOrderLines, {isNonReceivable: false});

        if (itemsToBeReceived.length > 0)
          vm.completionTotal = ((itemsToBeReceived.sum("totalStoredQuantity") / itemsToBeReceived.sum("quantity")) * 100).toFixed(1);
      }
    }

    function fakeLineItems(item) {
      if (item !== undefined) {

        var lineItem = {
          id: item.id,
          lineNumber: item.lineNumber,
          materialCode: item.materialCode,
          costCode: item.costCode,
          description: item.description,
          quantity: item.quantity,
          unitOfMeasureCode: item.unitOfMeasureCode,
          unitPricePrice: item.price,
          unitPriceCurrencyCode: item.currencyCode
        };

        vm.purchaseOrder.lines.push(lineItem);
      }
    }

    function deletePurchaseOrderLineItem(id){
      SweetAlert.swal({
          title: "Are you sure?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ED5565",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return purchaseOrderService.deletePurchaseOrderLine(vm.purchaseOrderId, id)
            .then(function (response) {
              vm.loading = false;
              removeItem(id);
              SweetAlert.swal("Deleted!", "The line item is now deleted.", "success");
            }, function (error) {
              showValidationErrors(error);
            });
        });
    }

    function removeItem(id) {
      var item = $filter('filter')(vm.purchaseOrder.lines, {id: id})[0];
      var index = vm.purchaseOrder.lines.indexOf(item);
      vm.purchaseOrder.lines.splice(index, 1);
    }

    function cancelPurchaseOrder() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "Cancelling this purchase order will remove any associated line items.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ED5565",
          confirmButtonText: "Yes, cancel it!",
          cancelButtonText: "Close",
          closeOnConfirm: false},
        function(isConfirm){
          if (!isConfirm) return;
          vm.loading = true;
          return purchaseOrderService.cancelPurchaseOrder(vm.purchaseOrderId)
            .then(function(response) {
              vm.purchaseOrder.statusId = 2;
              vm.loading = false;
              activate();
              SweetAlert.swal("Cancelled!", "The purchase order is now cancelled.", "success");
            }, function(error) {
              showValidationErrors(error);
            });
        });
    }

    function completePurchaseOrder() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "You can not edit the purchase order after it is complete!",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, complete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false},
        function(isConfirm){
          if (!isConfirm) return;
          vm.loading = true;
          return purchaseOrderService.completePurchaseOrder(vm.purchaseOrderId)
            .then(function(response) {
                vm.purchaseOrder.statusId = 3;
                vm.loading = false;
                activate();

                SweetAlert.swal("Completed!", "The purchase order is now complete.", "success");
              },function(error){
                showValidationErrors(error);
              }
            );
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not search for stored items.');
      }
      vm.loading = false;
    }

    Array.prototype.sum = function(prop) {
      var total = 0;
      for (var i = 0, _len = this.length; i < _len; i++) {
        total += this[i][prop];
      }
      return total;
    };
  }

})();


(function () {
  'use strict';

  angular
    .module('app.purchase-orders')
    .controller('CreatePurchaseOrderCtrl', CreatePurchaseOrderCtrl);

  CreatePurchaseOrderCtrl.$inject = ['$timeout', '$state', 'purchaseOrderService'];
  /* @ngInject */
  function CreatePurchaseOrderCtrl($timeout, $state, purchaseOrderService) {
    if ($state.transition) return;

    var vm = this;
    vm.loading = false;
    vm.purchaseOrder = {
      number: '',
      description: '',
      supplierCode: '',
      supplierName: ''
    };

    vm.showInfo = false;
    vm.selectedSupplier = '';

    vm.suppliersOptions = [];

    vm.createPurchaseOrder = createPurchaseOrder;
    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;
    vm.showNumberInfo = showNumberInfo;

    activate();

    /////////////////////

    function activate() {

    }

    function createPurchaseOrder(){
      vm.loading = true;

      var combo = angular.element(document.getElementsByName('supplierName'));

      vm.purchaseOrder.supplierCode = combo.data("kendoComboBox").value();
      vm.purchaseOrder.supplierName = combo.data("kendoComboBox").text();
      return purchaseOrderService.createPurchaseOrder(vm.purchaseOrder)
        .then(function(response) {
          vm.hasErrors = false;
          $state.transitionTo('purchase-orders.details', {id: response.id});
        }, function(error){
          vm.hasErrors = true;
          showValidationErrors(error);
        });
    }

    /** Suppliers */

    vm.suppliers = {
      transport: {
        read: function (options) {
          return purchaseOrderService.getSuppliers()
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        },
        dataType: "json"
      }
    };

    vm.suppliersOptions = {
      placeholder: "Select supplier",
      dataSource: vm.suppliers,
      dataTextField: "supplierName",
      dataValueField: "supplierCode",
      suggest: true,
      autoBind: false
    };

    function showValidationErrors(error){
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          var messages = error.data.message;
          if (Array.isArray(messages)) {
            vm.validationErrors = vm.validationErrors.concat(messages);
          } else {
            vm.validationErrors.push(messages);
          }
        }
      } else {
        vm.validationErrors.push('Could not create purchase order.');
      }
      vm.loading = false;
    }

    function showNumberInfo(){
      $timeout(function () {
        vm.showInfo = !vm.showInfo;
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.purchase-orders')
    .directive('wgAddLineItem', wgAddLineItem);

  wgAddLineItem.$inject = [];

  /* @ngInject */
  function wgAddLineItem() {
    var directive = {
      bindToController: true,
      controller: AddLineItemCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        purchaseOrderId: '=',
        postUpdateDelegate: '&'
      },
      templateUrl: 'app/purchase-orders/addLineItem.html'
    };

    return directive;

    function link($scope, element, attrs) {

    }
  }

  AddLineItemCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function AddLineItemCtrl($uibModal) {
    var vm = this;

    vm.purchaseOrderId = this.purchaseOrderId;

    vm.openAddLineItem = openAddLineItem;

    function openAddLineItem() {
      $uibModal.open({
        templateUrl: 'app/purchase-orders/addLineItemModal.html',
        controller: 'AddLineItemModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          purchaseOrderId: function () {
            return vm.purchaseOrderId;
          },
          postUpdateDelegate: function () {
            return vm.postUpdateDelegate;
          }
        }
      });
    }
  }

  angular
    .module('app.purchase-orders')
    .controller('AddLineItemModalCtrl', AddLineItemModalCtrl);

  AddLineItemModalCtrl.$inject = ['$uibModalInstance', '$timeout', 'stockService', 'purchaseOrderService', 'projectService', 'OidcManager', 'API', 'SETTINGS', 'purchaseOrderId', 'postUpdateDelegate', 'SweetAlert'];

  function AddLineItemModalCtrl($uibModalInstance, $timeout, stockService, purchaseOrderService, projectService, OidcManager, API, SETTINGS, purchaseOrderId, postUpdateDelegate, SweetAlert) {
    var vm = this;
    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.materialCodeOptions = [];
    vm.costCodeOptions = [];
    vm.unitsOfMeasureOptions = [];
    vm.unitsOfMeasure = [];
    vm.currencyCodeOptions = [];

    vm.addAnother = false;

    vm.lineItem = {};

    activate();

    /////////////////////////////

    function activate(){
      return projectService.getProjectByCode().then(function (response) {
        vm.selectedCurrency = response.currencyCode;
      });
    }

    vm.ok = function () {

      vm.saving = true;

      vm.lineItem.currencyCode = vm.selectedCurrency;

      return purchaseOrderService.createPurchaseOrderLine(purchaseOrderId, vm.lineItem)
        .then(function (response) {

          vm.lineItem.id = response.id;
          vm.lineItem.lineNumber = response.lineNumber;

          vm.error = false;
          vm.saved = true;
          vm.saving = false;

          postUpdateDelegate({item: vm.lineItem});

          if (vm.addAnother) {
            resetModal();
          } else {
            $uibModalInstance.close();
            $timeout(function () {
              SweetAlert.swal("Saved!", "The purchase order item has been saved successfully.", "success");
            }, 500);
          }
        }, function (error) {

          vm.saved = false;
          vm.error = true;
          vm.saving = false;

          showValidationErrors(error);
        });
    };

    /** Material Codes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.materialCodesOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "id",
      suggest: true,
      autoBind: false,
      change: function (e) {
        getMaterialDetailsByStoredItemId(this.value());
      }
    };

    function getMaterialDetailsByStoredItemId(storedItemId) {
      return stockService.getMaterialDetailsByStoredItemId(storedItemId)
        .then(function (response) {
          vm.lineItem = response;
      });
    }

    /** Cost Codes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.costCodesOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      suggest: true,
      autoBind: false
    };

    /** Units of measure */

    vm.unitsOfMeasure = {
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + SETTINGS.projectCode + "/purchase-orders/uom",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.unitsOfMeasureOptions = {
      dataSource: vm.unitsOfMeasure,
      dataTextField: "descriptionWithCode",
      dataValueField: "code",
      filter: "contains",
      autoBind: false
    };

    /** Currency codes */

    var currencyCodes = {
      transport: {
        read: function (options) {
          return purchaseOrderService.getCurrencyCodes()
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        },
        dataType: "json"
      }
    };

    vm.currencyCodeOptions = {
      dataSource: currencyCodes,
      dataTextField: "code",
      dataValueField: "code",
      filter: "contains",
      autoBind: false
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    function resetModal() {
      vm.lineItem = {};
      resetCombo("materialCodes");
      resetCombo("costCodes");
      resetCombo("unitsOfMeasure");
      $timeout(function () {
        vm.saved = false;
      }, 4000);
    }

    function resetCombo(name){
      var combo = angular.element(document.getElementsByName(name));
      combo.data("kendoComboBox").value("");
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not save purchase order line item.');
      }
      vm.loading = false;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.purchase-orders')
    .directive('wgAddComment', wgAddComment);

  wgAddComment.$inject = [];

  /* @ngInject */
  function wgAddComment() {
    var directive = {
      bindToController: true,
      controller: AddCommentCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        purchaseOrderId: '=',
        number: '=',
        isLine: '=',
        lineItem: '='
      },
      templateUrl: 'app/purchase-orders/addComment.html'
    };

    return directive;

    function link($scope, element, attrs) {

    }
  }

  AddCommentCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function AddCommentCtrl($uibModal) {
    var vm = this;

    vm.purchaseOrderId = this.purchaseOrderId;
    vm.number = this.number;
    vm.isLine = this.isLine;
    vm.lineItem = this.lineItem;

    vm.openComments = openComments;

    function openComments() {
      $uibModal.open({
        templateUrl: 'app/purchase-orders/addCommentModal.html',
        controller: 'AddCommentModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          purchaseOrderId: function () {
            return vm.purchaseOrderId;
          },
          number: function () {
            return vm.number;
          },
          isLine: function () {
            return vm.isLine;
          },
          lineItem: function () {
            return vm.lineItem;
          }
        }
      });
    }
  }

  angular
    .module('app.purchase-orders')
    .controller('AddCommentModalCtrl', AddCommentModalCtrl);

  AddCommentModalCtrl.$inject = ['$uibModalInstance', '$timeout', 'purchaseOrderService', 'purchaseOrderId', 'number', 'isLine', 'lineItem', 'SweetAlert', 'OidcManager'];

  function AddCommentModalCtrl($uibModalInstance, $timeout, purchaseOrderService, purchaseOrderId, number, isLine, lineItem, SweetAlert, OidcManager) {
    var vm = this;
    vm.manager = OidcManager.OidcTokenManager();
    vm.purchaseOrderId = purchaseOrderId;
    vm.number = number;
    vm.isLine = isLine;
    vm.lineItem = lineItem;
    vm.getPurchaseOrderComments = getPurchaseOrderComments;
    vm.resetForm = resetForm;
    vm.item = {};
    vm.purchaseOrderComments = [];
    vm.loading = true;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function ($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();


    /////////////////////////////

    function activate() {
      return getPurchaseOrderComments().then(function () {
        vm.loading = false;
      });
    }

    function getPurchaseOrderComments() {
      return (isLine ? purchaseOrderService.getPurchaseOrderLineComments(vm.purchaseOrderId) : purchaseOrderService.getPurchaseOrderComments(vm.purchaseOrderId))
        .then(function (data) {
          vm.purchaseOrderComments = data;
          return vm.purchaseOrderComments;
        });
    }

    vm.ok = function () {

      vm.saving = true;

      return (isLine ? purchaseOrderService.addPurchaseOrderLineComment(vm.purchaseOrderId, vm.item) : purchaseOrderService.addPurchaseOrderComment(vm.purchaseOrderId, vm.item))
        .then(function (response) {

          vm.error = false;
          vm.saved = true;
          vm.saving = false;
          vm.item.createdDate = new Date().toISOString();
          vm.item.createdBy = vm.manager.profile.fullname;
          vm.purchaseOrderComments.push(angular.copy(vm.item));

          vm.resetForm();

          SweetAlert.swal("Saved!", "The comment was added successfully.", "success");


        }, function (error) {

          vm.saved = false;
          vm.error = true;
          vm.saving = false;

          showValidationErrors(error);
        });
    };


    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };


    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not save purchase order line item.');
      }
      vm.loading = false;
    }

    function resetForm() {
      vm.item.comments = '';
      vm.item.etaDate = '';
      vm.item.followUpDate = '';
      $timeout(function () {
        vm.saved = false;
      }, 4000);
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.projects', []);

})();

(function () {
  'use strict';

  angular
    .module('app.projects')
    .controller('ViewProjectsCtrl', ViewProjectsCtrl);

  ViewProjectsCtrl.$inject = ['$filter', 'projectService'];

  /* @ngInject */
  function ViewProjectsCtrl($filter, projectService) {
    var vm = this;
    vm.projects = [];
    vm.projectsStock = [];
    vm.projectsCombined = [];

    vm.getProjects = getProjects;
    vm.getProjectsStock = getProjectsStock;

    activate();

    ////////////////

    function activate() {
      return getProjects().then(function(){
        return getProjectsStock().then(function(){
          angular.forEach(vm.projects, function(value, key) {
            var proj = $filter('filter')(vm.projectsStock, {id: value.id});
            vm.projectsCombined.push(angular.extend(value, proj[0]));
          });
        });
      });
    }

    function getProjects() {
      return projectService.getProjects()
        .then(function(response) {
          vm.projects = response;

          return vm.projects;
        });
    }

    function getProjectsStock() {
      return projectService.getProjectsStock()
        .then(function(response) {
          vm.projectsStock = response;

          return vm.projectsStock;
        });
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.projects')
    .controller('ViewProjectCtrl', ViewProjectCtrl);

  ViewProjectCtrl.$inject = ['$stateParams', 'projectService'];

  /* @ngInject */
  function ViewProjectCtrl($stateParams, projectService) {
    var vm = this;

    vm.projectId = $stateParams.id;
    vm.project = {};

    vm.updateProject = updateProject;
    vm.getProject = getProject;

    activate();

    ////////////////

    function activate() {
      return getProject();
    }

    function getProject() {
      return projectService.getProject(vm.projectId)
        .then(function(response) {
          vm.project = response;

          if(Date.parse(vm.project.startDate))
            vm.project.startDate = new Date(vm.project.startDate);

          if(Date.parse(vm.project.endDate))
            vm.project.endDate = new Date(vm.project.endDate);

          return vm.project;
        });
    }

    function updateProject(){
      vm.loading = true;
      return projectService.updateProject(vm.project)
        .then(function(response){
          vm.loading = false;
        });
    }

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('app.projects')
    .controller('CreateProjectCtrl', CreateProjectCtrl);

  CreateProjectCtrl.$inject = ['projectService', '$state'];

  /* @ngInject */
  function CreateProjectCtrl(projectService, $state ) {
    if ($state.transition) return;

    var vm = this;
    vm.loading = false;
    vm.project = {
      name : '',
      code : '',
      client : '',
      currencyCode : '',
      startDate : '',
      endDate : '',
      subProject : '',
      allowLabelPrinting: true
    };

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    vm.createProject = createProject;
    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;

    activate();

    ////////////////

    function activate() {

    }


    function createProject() {
      vm.loading = true;
      return projectService.createProject(vm.project)
          .then(function(response) {
            vm.hasErrors = false;
            $state.transitionTo('projects.details', {id: response.projectId} );

          },function(error){
            vm.hasErrors = true;
            showValidationErrors(error);
          });
    }


    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not create project.');
      }
      vm.loading = false;
    }

  }

})();


(function () {
  'use strict';

  angular.module('app.picklists', []);

})();

(function () {
  'use strict';

  angular
    .module('app.picklists')
    .controller('ViewPicklistsCtrl', ViewPicklistsCtrl);

  ViewPicklistsCtrl.$inject = ['$state', 'picklistService'];

  /* @ngInject */
  function ViewPicklistsCtrl($state, picklistService) {
    var vm = this;
    vm.completedPicklists = [];
    vm.pickingPicklists = [];
    vm.incompletePicklists = [];

    vm.setActiveTab = setActiveTab;

    vm.tabs = {
      incompleteActive: true,
      pickingActive: false,
      completeActive: false
    };

    activate();

    ///////////////////////

    function activate(){

      picklistService.getPicklistsCompleted()
        .then(function(response) {
          vm.completedPicklists = response;
        });

      picklistService.getPicklistsPicking()
        .then(function(response) {
          vm.pickingPicklists = response;
        });

      picklistService.getPicklistsIncomplete()
        .then(function(response) {
          vm.incompletePicklists = response;
        });

      vm.setActiveTab();
    }


    function setActiveTab(){
      if($state.current.url=='complete'){
        vm.tabs.completeActive = true;
      }
      else if($state.current.url=='picking'){
        vm.tabs.pickingActive = true;
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.picklists')
    .controller('ViewPicklistCtrl', ViewPicklistCtrl);

  ViewPicklistCtrl.$inject = ['$scope','$stateParams', '$filter', '$timeout', 'picklistService', 'SweetAlert', '$uibModal'];

  /* ngInject */
  function ViewPicklistCtrl($scope,$stateParams, $filter, $timeout, picklistService, SweetAlert, $uibModal) {
    var vm = this;

    vm.picklistId = $stateParams.id;
    vm.picklist = {};
    vm.searching = false;
    vm.results = undefined;
    vm.bagAndTagResults = undefined;

    vm.picklistItems = [];
    vm.picklistBagAndTagItems = [];
    vm.validationErrors = [];
    vm.hasErrors = false;

    vm.tabs = {
      storedItemsActive: true,
      bagAngTagsActive: false,
      storedItemsResultsActive: true,
      bagAndTagResultsActive: false
    };


    vm.getPicklist = getPicklist;
    vm.completePicklist = completePicklist;
    vm.cancelPicklist = cancelPicklist;
    vm.reopenPicklist = reopenPicklist;
    vm.addItem = addItem;
    vm.addBagAndTag = addBagAndTag;
    vm.fakePicklistItems = fakePicklistItems;
    //vm.fakePicklistBagAndTagItems = fakePicklistBagAndTagItems;
    vm.removeItem = removeItem;
    vm.removeBagAndTag = removeBagAndTag;
    vm.showValidationErrors = showValidationErrors;
    vm.greaterThan = greaterThan;
    vm.updateItems = updateItems;

    activate();

    ////////////////////

    function activate() {
      return getPicklist().then(function () {
        if(vm.picklist.picklistStatus !== "Cancelled") {
          return getPicklistItems().then(function () {
            return getPicklistBagAndTagItems().then(function () {
            });
          });
        }
        else{
          vm.picklistItems = [];
          vm.picklistBagAndTagItems = [];
          vm.picklistBagAndTagItemsOptions = [];
          vm.picklistBagAndTagItemsContainer = [];
        }
      });
    }

    function completePicklist() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "You can not edit the picklist after it is complete!",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, complete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false},
        function(isConfirm){
          if (!isConfirm) return;
          vm.loading = true;
          return picklistService.completePicklist(vm.picklistId)
            .then(function(response) {
                vm.loading = false;
                activate();

                SweetAlert.swal("Completed!", "The picklist is now complete.", "success");
              },function(error){
                showValidationErrors(error);
              }
            );
        });
    }

    function cancelPicklist() {
      SweetAlert.swal({
        title: "Are you sure?",
        text: "Cancelling this picklist will remove all items.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ED5565",
        confirmButtonText: "Yes, cancel it!",
        cancelButtonText: "Close",
        closeOnConfirm: false},
      function(isConfirm){
        if (!isConfirm) return;
        vm.loading = true;
        return picklistService.cancelPicklist(vm.picklistId)
          .then(function(response) {
            vm.loading = false;
            activate();
            SweetAlert.swal("Cancelled!", "The picklist is now cancelled.", "success");
          }, function(error) {
            showValidationErrors(error);
          });
      });
    }

    
  function reopenPicklist() {
    SweetAlert.swal({
        title: "Are you sure?",
        text: "This will reopen the picklist for editing.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, reopen it!",
        cancelButtonText: "Cancel",
        closeOnConfirm: false
    }, function (isConfirm) {
        if (!isConfirm) return;
        vm.loading = true;
        return picklistService.reopenPicklist(vm.picklist.id)
            .then(function (response) {
                vm.loading = false;
                        
                activate();
                $scope.$broadcast('picklistIsReadOnly', false); 
                SweetAlert.swal("Reopened!", "The picklist has been reopened.", "success");
               
            }, function (error) {
                vm.loading = false;
                showValidationErrors(error);
            });
    });
}
 
   function getPicklist() {
      return picklistService.getPicklist(vm.picklistId)
        .then(function(response) {
          vm.picklist = response;

          return vm.picklist;
        });
    }

    function getPicklistItems() {
      return picklistService.getPicklistItems(vm.picklistId)
        .then(function(response) {
          vm.picklistItems = response;
        });
    }

    function getPicklistBagAndTagItems() {
      return picklistService.getPicklistBagAndTagItems(vm.picklistId)
        .then(function(response) {
          vm.picklistBagAndTagItems = response;
        });
    }


    function addItem(item) {
      return picklistService.addItemToPicklist(vm.picklistId, item.storedItemId, item.selectedQuantity)
        .then(function(response) {
          if (response.responseMessage === 'Success') {
            if (!addToExistingItem(item)) {
              vm.picklistItems.push(angular.copy(item)); }
            deductQuantityFromStockItems(item.storedItemId, item.selectedQuantity);
          } else {
            displayNotification(response.responseMessage);
          }
        });
    }

    function fakePicklistItems(returnItems) {
      angular.forEach(returnItems, function(item){
        if (!addToExistingItem(item)) {
          vm.picklistItems.push(angular.copy(item)); }
        deductQuantityFromStockItems(item.storedItemId, item.selectedQuantity);
      });
    }

    function addToExistingItem(item) {

      var storedItem = $filter('filter')(vm.picklistItems, {storedItemId: item.storedItemId})[0];

      if (storedItem != undefined) {
        storedItem.class = "badge-non-bold backgroundAnimated";
        storedItem.selectedQuantity = parseFloat(storedItem.selectedQuantity) + parseFloat(item.selectedQuantity);
        $timeout(function () {
          storedItem.class = "badge-transparent";
        }, 1000);
        return true;
      }

    }

    //function fakePicklistBagAndTagItems(returnBagAndTagItems){
    //  angular.forEach(returnBagAndTagItems, function(item) {
    //    var index = vm.picklistBagAndTagItemsContainer.map(function(item) {
    //      return item.id;
    //    }).indexOf(item.id);
    //    if (index < 0) {
    //      vm.picklistBagAndTagItemsContainer.push(angular.copy(item));
    //    } else {
    //      vm.picklistBagAndTagItemsContainer[index].selectedQuantity = parseFloat(vm.picklistBagAndTagItemsContainer[index].selectedQuantity) + parseFloat(item.selectedQuantity);
    //    }
    //  });
    //
    //    vm.tabs.storedItemsActive = false;
    //    vm.tabs.bagAndTagsActive = true;
    //}

    function addBagAndTag(item) {
      return picklistService.addBagAndTagToPicklist(vm.picklistId, item.id)
        .then(function(response) {
          if (response.responseMessage === 'Success') {
            vm.picklistBagAndTagItems.push(item);
            var index = vm.bagAndTagResults.indexOf(item);
            vm.bagAndTagResults.splice(index, 1);
            vm.tabs.bagAndTagsActive = true;
          } else {
            displayNotification(response.responseMessage);
          }
        });
    }

    function removeItem(item) {
      if (vm.results !== undefined) {
        returnItemToStock(item);
      }
      var index = vm.picklistItems.indexOf(item);
      vm.picklistItems.splice(index, 1);

      return picklistService.removeItemFromPicklist(vm.picklistId, item.storedItemId)
        .then(function(response) {

        },function(error){
          showValidationErrors(error);
        });
    }

    function returnItemToStock(item) {
        var storedItem = $filter('filter')(vm.results, {storedItemId: item.storedItemId})[0];

        if (storedItem != undefined) {

          storedItem.class = "badge-non-bold backgroundAnimated";
          storedItem.quantity = parseFloat(storedItem.quantity) + parseFloat(item.selectedQuantity);

          $timeout(function () {
            storedItem.class = "badge-transparent";
          }, 1000);
        }
    }

    function deductQuantityFromStockItems(storedItemId,  qty) {
      $filter('filter')(vm.results, {storedItemId: storedItemId})[0].quantity -= qty;
      $filter('filter')(vm.results, {storedItemId: storedItemId})[0].selectedQuantity = "";
      $filter('filter')(vm.results, {storedItemId: storedItemId})[0].isIncluded = false;
    }

    //function removeBagAndTagItem(item) {
    //  var bagAndTagItem = $filter('filter')(vm.picklistBagAndTagItemsContainer, {returnItemId:item.returnItemId});
    //  var index = getIndexByAttribute(vm.picklistBagAndTagItemsContainer, 'returnItemId', item.returnItemId);
    //  return picklistService.removeBagAndTagItemFromPicklist(vm.picklistId, item.returnItemId)
    //    .then(function(response) {
    //      vm.picklistBagAndTagItemsContainer.splice(index, 1);
    //      bagAndTagItems.read();
    //      SweetAlert.swal("Item removed!", "Bag & tag item removed from return.", "success");
    //    }, function(error) {
    //      showValidationErrors(error);
    //    });
    //}

    function removeBagAndTag(item) {
      var index = vm.picklistBagAndTagItems.indexOf(item);
      vm.picklistBagAndTagItems.splice(index, 1);

      return picklistService.removeBagAndTagFromPicklist(vm.picklistId, item.id)
        .then(function(response) {

        }, function(error) {
          showValidationErrors(error);
        });
    }

    function displayNotification(message) {
      SweetAlert.swal({
          title: "Quantity unavailable",
          text: message,
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Close",
          closeOnConfirm: false}
        );
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not search for stored items.');
      }
      vm.loading = false;
    }

    function greaterThan(prop, val){
      return function(item){
        return item[prop] > val;
      };
    }

    function updateItems(itemsToUpdate, locationId){
      vm.itemsToPicklist = [];
      angular.forEach(itemsToUpdate, function (value, key) {
        vm.itemsToPicklist.push({
          storedItemId: value.id,
          storedItemLocationId: value.storedItemLocationId,
          issueItemId: value.issueItemId,
          quantity: parseFloat(value.selectedQuantity)
        });
      });

      var items = {
        returnId: vm.picklistId,
        locationId: locationId,
        returnItems: vm.itemsToPicklist
      };
      return picklistService.returnItems(items);
    }






    function getIndexByAttribute(array, attr, value) {
      for(var i = 0; i < array.length; i += 1) {
        if(array[i][attr] === value) {
          return i;
        }
      }
      return -1;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.picklists')
    .directive('wgSearchCriteriaPicklist', wgSearchCriteriaPicklist);

  wgSearchCriteriaPicklist.$inject = [];

  /* @ngInject */
  function wgSearchCriteriaPicklist() {
    var directive = {
      bindToController: true,
      controller: SearchCriteriaPicklistCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        results: '=',
        bagAndTagResults: '=',
        disableBagAndTag: '@',
        tabs: '='
      },
      templateUrl: 'app/picklists/searchCriteriaPicklist.html'
    };

    return directive;

    function link(scope, element, attrs) {
      if (scope.results !== undefined) scope.results = this.results;
      if (scope.bagAndTagResults !== undefined) scope.bagAndTagResults = this.bagAndTagResults;
    }

  }

  SearchCriteriaPicklistCtrl.$inject = ['stockService', 'bagAndTagService', 'OidcManager', 'API', 'SETTINGS'];

  /* @ngInject */
  function SearchCriteriaPicklistCtrl(stockService, bagAndTagService, OidcManager, API, SETTINGS) {
    var vm = this;
    var results = this.results;
    var bagAndTagResults = this.bagAndTagResults;
    var tabs = this.tabs;

    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.disableBagAndTag = this.disableBagAndTag;

    /** Purchase Orders */
    vm.purchaseOrders = [];
    vm.purchaseOrdersOptions = [];
    vm.purchaseOrdersSelected = [];
    /** Material Codes */
    vm.materialCodes = [];
    vm.materialCodesOptions = [];
    vm.materialCodesSelected = [];
    /** Cost Codes */
    vm.codeCodes = [];
    vm.costCodesOptions = [];
    vm.costCodesSelected = [];
    /** Barcodes */
    vm.barcodes = [];
    vm.barcodesOptions = [];
    vm.barcodesSelected = [];

    /** Bag and Tag numbers */
    vm.bagAndTagNumbers = [];
    vm.bagAndTagNumbersOptions = [];
    vm.bagAndTagNumbersSelected = [];
    /** Bag and Tag Workpack numbers */
    vm.workpackNumbers = [];
    vm.workpackNumbersOptions = [];
    vm.workpackNumbersSelected = [];



    vm.filter = "";


    vm.doSearch = doSearch;
    vm.resetForm = resetForm;

    activate();

    /////////////////

    function activate() {

    }

    function doSearch() {
      vm.searching = true;
      return searchStoredItems().then(function () {
        if (!vm.disableBagAndTag) {
          return searchBagAndTagHeaders().then(function () {
            if (tabs !== undefined) {
              tabs.storedItemsResultsActive = (vm.results !== undefined && vm.bagAndTagResults === undefined) || (vm.results !== undefined && vm.bagAndTagResults !== undefined);
              tabs.bagAndTagResultsActive = (vm.results === undefined && vm.bagAndTagResults !== undefined);
            }
            vm.searching = false;
          });
        }
        vm.searching = false;
      });
    }

    function searchStoredItems() {
      return stockService.searchForPicklist(vm.purchaseOrdersSelected, vm.materialCodesSelected, vm.costCodesSelected, vm.barcodesSelected, vm.filter).then(function (data) {
        vm.results = data;
      });
    }

    function searchBagAndTagHeaders() {
      return bagAndTagService.searchBagAndTagHeadersPicklist(vm.bagAndTagNumbersSelected, vm.workpackNumbersSelected,
        vm.purchaseOrdersSelected, vm.materialCodesSelected, vm.costCodesSelected, vm.barcodesSelected, vm.filter).then(function (data) {
        vm.bagAndTagResults = data;
      });
    }

    function resetForm() {
      vm.purchaseOrdersSelected = [];
      vm.materialCodesSelected = [];
      vm.costCodesSelected = [];
      vm.barcodesSelected = [];
      vm.bagAndTagNumbersSelected = [];
      vm.workpackNumbersSelected = [];
      vm.filter = "";
      vm.results = undefined;
      vm.bagAndTagResults = undefined;
    }

    /** Purchase Orders */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrdersOptions = {
      height: 210,
      placeholder: "(Optional)",
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "id",
      filter: "contains",
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      template: '<span class="k-state-default">#: number # - #: supplierName # - #= kendo.toString(kendo.parseDate(date), \'dd-MMM-yyyy\') #</span>'
    };

    /** Material Codes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.materialCodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      autoBind: false
    };

    /** Cost Codes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.costCodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false
    };

    /** Barcodes */

    vm.barcodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/stored-items/barcodes',
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.barcodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.barcodes,
      dataTextField: "barcode",
      dataValueField: "barcode",
      filter: "contains",
      autoBind: false
    };

    /** Bag and Tag numbers */

    vm.bagAndTagNumbers = {
      transport: {
        read: function (options) {
          return bagAndTagService.getBagAndTagNumbers(true)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        }
      }
    };

    vm.bagAndTagNumbersOptions = {
      placeholder: "(Optional)",
      dataSource: vm.bagAndTagNumbers,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      autoBind: false
    };

    /** Bag and Tag workpack numbers */

    vm.workpackNumbers = {
      transport: {
        read: function (options) {
          return bagAndTagService.getBagAndTagWorkpackNumbers(true)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        }
      }
    };

    vm.workpackNumbersOptions = {
      placeholder: "(Optional)",
      dataSource: vm.workpackNumbers,
      dataTextField: "workpackNumber",
      dataValueField: "workpackNumber",
      filter: "contains",
      autoBind: false
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.picklists')
    .controller('CreatePicklistCtrl', CreatePicklistCtrl);

  CreatePicklistCtrl.$inject = ['picklistService', '$state'];
  /* @ngInject */
  function CreatePicklistCtrl(picklistService, $state) {
    if ($state.transition) return;

    var vm = this;
    vm.loading = false;
    vm.picklist = {
      description: ''
    };

    vm.createPicklist = createPicklist;
    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;

    activate();

    /////////////////////

    function activate() {

    }

    function createPicklist() {
      vm.loading = true;
      return picklistService.createPicklist(vm.picklist)
        .then(function (response) {
          vm.hasErrors = false;
          $state.transitionTo('picklists.details', {id: response.picklistId});
        }, function (error) {
          if (error.status !== 403) {
            vm.hasErrors = true;
            showValidationErrors(error);
          }
          vm.loading = false;
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessages);
        }
      } else {
        vm.validationErrors.push('Could not create picklist.');
      }
      vm.loading = false;
    }

  }

})();

(function(){
  'use strict';

  angular.module('app.osd-register', []);

})();

(function () {
  'use strict';

  angular
    .module('app.osd-register')
    .controller('ViewOsdRegisterCtrl', ViewOsdRegisterCtrl);

  ViewOsdRegisterCtrl.$inject = ['deliveryService'];
  /* @ngInject */
  function ViewOsdRegisterCtrl(deliveryService) {
    var vm = this;

    vm.osdRegisterIncomplete = [];
    vm.osdRegisterComplete = [];

    vm.refreshTabs = refreshTabs;

    activate();

    //////////////////////

    function activate()
    {
      deliveryService.getOsdRegisterIncomplete()
        .then(function(response) {
          vm.osdRegisterIncomplete = response;
        });

      deliveryService.getOsdRegisterComplete()
        .then(function(response) {
          vm.osdRegisterComplete = response;
        });
    }

    function refreshTabs() {
      activate();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.osd-register')
    .directive('wgOsdResolution', wgOsdResolution);

  wgOsdResolution.$inject = [];

  /* @ngInject */
  function wgOsdResolution() {
    var directive = {
      bindToController: true,
      controller: OsdResolutionCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/osd-register/osdResolution.html',
      scope: {
        id: '=',
        type: '=',
        postUpdateDelegate: '&'
      }
    };

    return directive;

    function link(scope, element, attrs) {

    }
  }

  OsdResolutionCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function OsdResolutionCtrl($uibModal) {
    var vm = this;

    vm.id = this.id;
    vm.type = this.type;
    vm.postUpdateDelegate = this.postUpdateDelegate;

    vm.openResolution = openResolution;

    function openResolution() {

      switch (vm.type){
        case 'Over':
        case 'Damaged':
        case 'Inspection':
        case 'Vendor Inspection':
        case 'Other':
          vm.ctrl = 'ResolveOverageModalCtrl';
          vm.template = 'app/osd-register/osdResolveOverageModal.html';
          break;
        case 'Short':
          vm.ctrl = 'ResolveShortageModalCtrl';
          vm.template = 'app/osd-register/osdResolveShortageModal.html';
          break;
      }

      $uibModal.open({
        templateUrl: vm.template,
        controller: vm.ctrl,
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          id: function () {
            return vm.id;
          },
          postUpdateDelegate: function () {
            return vm.postUpdateDelegate;
          }
        }
      });
    }
  }

  angular
    .module('app.osd-register')
    .controller('ResolveOverageModalCtrl', ResolveOverageModalCtrl);

  ResolveOverageModalCtrl.$inject = ['$uibModalInstance', 'deliveryService', 'id', 'postUpdateDelegate'];

  function ResolveOverageModalCtrl($uibModalInstance, deliveryService, id, postUpdateDelegate) {
    var vm = this;

    vm.id = id;
    vm.item = {};
    vm.locations = [];
    vm.storedItemLocations = [];

    vm.hasValidQuantities = hasValidQuantities;
    vm.updateAcceptedQuantity = updateAcceptedQuantity;

    activate();

    ////////////////////

    function activate(){
      getOsdRegisterItem();
      getLocations();
    }

    function getOsdRegisterItem(){
      return deliveryService.getOsdRegisterItem(vm.id)
        .then(function (response){
          vm.item = response;
          addDefaultStoredItemLocation(vm.item.deliveryId);
          vm.isVendorInspection = vm.item.inspectionItemId !== null;

          if (vm.isVendorInspection){
            vm.item.acceptedQuantity = 0;
            vm.item.returnedQuantity = vm.item.quantity;
          }

          switch (vm.item.type){
            case 'Over':
              vm.item.title = "Overage";
              break;
            case 'Damaged':
              vm.item.title = "Damaged";
              break;
            case 'Inspection':
              vm.item.title = "Inspection";
              break;
            case 'Vendor Inspection':
              vm.item.title = "Inspection";
              break;
            case 'Other':
              vm.item.title = "Other";
              break;
          }
        });
    }

    function getLocations() {
      return deliveryService.getLocations()
        .then(function(response) {
          vm.locations = response;
          return vm.locations;
        });
    }

    function addDefaultStoredItemLocation(id){
      return deliveryService.getDeliveryDefaultLocation(id)
        .then(function (response){
          var location = response;

          if (vm.item.quarantineItem != null){
            location.id = vm.item.quarantineItem.originalLocationId;
          }

          vm.item.storedItemLocations = [];
          vm.item.storedItemLocations.push({
            quantity: vm.item.acceptedQuantity,
            locationId: location.id
          });
          vm.item.defaultLocation = location;
        });
    }

    function updateAcceptedQuantity(){
      if (vm.item.acceptedQuantity > 0) {
          vm.item.storedItemLocations[0].quantity = vm.item.acceptedQuantity;
          vm.item.returnedQuantity = vm.item.quantity - vm.item.acceptedQuantity;
      } else {
        vm.item.storedItemLocations[0].quantity = undefined;
        vm.item.returnedQuantity = vm.item.quantity;
      }
    }

    function hasValidQuantities() {
      var acceptedQuantity = parseFloat(vm.item.acceptedQuantity);
      var returnedQuantity = parseFloat(vm.item.returnedQuantity);
      if (acceptedQuantity === 0) {
        return acceptedQuantity + returnedQuantity === vm.item.quantity;
      } else {
        return acceptedQuantity + returnedQuantity === vm.item.quantity && acceptedQuantity === getTotalStored();
      }
    }

    function getTotalStored() {
      var total = 0;
      if (vm.item.storedItemLocations !== undefined) {
        for (var i = 0; i < vm.item.storedItemLocations.length; i++) {
          var location = vm.item.storedItemLocations[i];
          total += parseFloat(location.quantity);
        }
      }
      return total;
    }

    vm.ok = function () {
      vm.error = false;
      return deliveryService.resolveOsd(vm.id, vm.item.acceptedQuantity, vm.item.returnedQuantity, vm.item.comments, vm.item.storedItemLocations, vm.item.quarantineStoredItemLocationId)
        .then(function (response){
            vm.saved = true;
            vm.error = false;
            vm.saving = false;
          }, function(error) {
            vm.errorMessage = error.data;
            vm.saved = false;
            vm.error = true;
            vm.saving = false;
        });
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
      postUpdateDelegate();
    };
  }

  angular
    .module('app.osd-register')
    .controller('ResolveShortageModalCtrl', ResolveShortageModalCtrl);

  ResolveShortageModalCtrl.$inject = ['$uibModalInstance', 'deliveryService', 'id', 'postUpdateDelegate'];

  function ResolveShortageModalCtrl($uibModalInstance, deliveryService, id, postUpdateDelegate) {
    var vm = this;

    vm.id = id;
    vm.item = {};

    activate();

    ////////////////////

    function activate(){
      getOsdRegisterItem();
    }

    function getOsdRegisterItem(){
      return deliveryService.getOsdRegisterItem(vm.id)
        .then(function (response){
          vm.item = response;
        });
    }

    vm.ok = function () {
      return deliveryService.resolveOsd(vm.id, 0, 0, vm.item.comments, null)
        .then(function (response){
          vm.saved = true;
        }, function() {
          vm.saved = false;
          vm.error = true;
          vm.saving = false;
        });
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
      postUpdateDelegate();
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app.osd-register')
    .directive('wgAddStoredItemLocation', wgAddStoredItemLocation);

  wgAddStoredItemLocation.$inject = [];

  /* @ngInject */
  function wgAddStoredItemLocation() {
    var directive = {
      bindToController: true,
      controller: AddStoredItemLocationCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/osd-register/addStoredItemLocation.html",
      scope: {
        storedItemLocation: '=',
        item: '=',
        locations: '=',
        index: '@'
      }
    };
    return directive;

    function link(scope, element, attrs){

    }
  }

  AddStoredItemLocationCtrl.$inject = ['$scope', '$timeout', 'SweetAlert'];

  /* @ngInject */
  function AddStoredItemLocationCtrl($scope, $timeout, SweetAlert){
    var vm = this;
    vm.storedItemLocation = this.storedItemLocation;
    vm.item = this.item;
    vm.locations = this.locations;
    vm.index = this.index;

    vm.locationSelected = {id: vm.storedItemLocation.locationId};
    vm.returnToOriginalStockLocation = vm.item.quarantineItemId !== null;

    vm.loading = false;
    vm.loadingRemoveButton = false;
    vm.validationErrors = false;
    vm.millisecondsToWaitBeforeSave = 700;
    vm.timeout = undefined;

    vm.removeStoredItemLocation = removeStoredItemLocation;
    vm.validateQuantity = validateQuantity;
    vm.debounceUpdate = debounceUpdate;
    vm.locationChanged = locationChanged;
    vm.showValidationErrors = showValidationErrors;

    $scope.$watch('vm.storedItemLocation.quantity', debounceUpdate);

    activate();

    /////////////////////

    function activate() {

    }

    function validateQuantity() {
      vm.validationErrors = false;

      var totalStored = getTotalStored();
      if(totalStored > vm.item.acceptedQuantity) {
        var error = {
          data: "The item will have a stored quantity of " + totalStored + " which exceeds the accepted quantity of " + vm.item.acceptedQuantity + "."
        };
        vm.showValidationErrors(error);
      } else {
        $scope.$emit('osdStoredItemLocationUpdated');
      }

      vm.loading = false;
    }

    function locationChanged() {
      if (vm.locationSelected !== null) {
        vm.loading = true;
        vm.validationErrors = false;
        vm.item.storedItemLocations[vm.index].locationId = vm.locationSelected.id;
      }
      else{
        vm.validationErrors = true;
      }
      vm.loading = false;
    }

    function removeStoredItemLocation(index) {
      vm.loading = true;
      vm.loadingRemoveButton = true;
      vm.validationErrors = false;

      vm.item.storedItemLocations.splice(index, 1);

      vm.loading = false;
      $scope.$emit('osdStoredItemLocationUpdated');
    }

    function debounceUpdate(newValue, oldValue) {
      if (newValue !== oldValue){
        if (vm.timeout) {
          $timeout.cancel(vm.timeout);
        }
        vm.loading = true;
        vm.timeout = $timeout(vm.validateQuantity, vm.millisecondsToWaitBeforeSave);
      }
    }

    function getTotalStored() {
      var total = 0;
      for (var i = 0; i < vm.item.storedItemLocations.length; i++){
        var location = vm.item.storedItemLocations[i];
        total += parseFloat(location.quantity);
      }
      return total;
    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
      vm.loadingRemoveButton = false;
      SweetAlert.swal({title: "Error", text: error.data, type: "error", html:true});
    }

    vm.locationsOptions = {
      autobind: false,
      dataSource: {
        data: vm.locations,
        group: {field: "warehouseName"}
      },
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>",
      headerTemplate: "<div class='noDataMessage'>No results found</div>",
      valueTemplate: ' #:warehouseName# - #:name#',
      dataBound: function () {
        var noItems = this.list.find(".noDataMessage");

        if (!this.dataSource.view()[0]) {
          noItems.show();
          this.popup.open();
        } else {
          noItems.hide();
        }
      },
      close: function(e) {
        var widget = e.sender;

        if (!widget.shouldClose && !this.dataSource.view()[0]) {
          e.preventDefault();
        }
      }
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('app.osd-register')
    .directive('wgAddStoredItem', wgAddStoredItem);

  wgAddStoredItem.$inject = [];

  /* @ngInject */
  function wgAddStoredItem() {
    var directive = {
      bindToController: true,
      controller: AddStoredItemCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/osd-register/addStoredItem.html",
      scope: {
        item: '=',
        locations: '=',
        isReadOnly: '='
      }
    };
    return directive;

    function link(scope, element, attrs){

    }
  }

  AddStoredItemCtrl.$inject = ['$scope', 'deliveryService'];

  /* @ngInject */
  function AddStoredItemCtrl($scope, deliveryService) {
    var vm = this;
    vm.item = this.item;
    vm.locations = this.locations;
    vm.isReadOnly = this.isReadOnly;

    vm.loading = false;
    vm.validationErrors = false;

    vm.refreshProgressBar = refreshProgressBar;
    vm.addStoredItemLocation = addStoredItemLocation;
    vm.showValidationErrors = showValidationErrors;

    $scope.$watch('vm.item.acceptedQuantity', refreshStoredQuantities);
    $scope.$on('osdStoredItemLocationUpdated', refreshStoredQuantities);

    activate();

    /////////////////

    function activate() {
      refreshProgressBar();
    }

    function refreshProgressBar() {
      vm.progressbarType = parseFloat(vm.item.acceptedQuantity) === parseFloat(vm.item.totalStoredQuantity) ? "primary" : "warning";
    }

    function refreshStoredQuantities() {
      vm.item.totalStoredQuantity = getTotalStored();
      vm.refreshProgressBar();
    }

    function getStockItem() {
      return deliveryService.getStockItem(vm.item.id)
        .then(function (response) {
          vm.item = response;
          vm.refreshProgressBar();
          return vm.item;
        });
    }

    function getTotalStored() {
      var total = 0;
      for (var i = 0; i < vm.item.storedItemLocations.length; i++){
        var location = vm.item.storedItemLocations[i];
        total += parseFloat(location.quantity);
      }
      return total;
    }

    function addStoredItemLocation() {
      var itemToAdd = {
        quantity: 0,
        locationId: vm.item.defaultLocation.id
      };

      vm.item.storedItemLocations.push(itemToAdd);
    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.osd-register')
    .directive('wgAddOsdFromStoredItem', wgAddOsdFromStoredItem);

  wgAddOsdFromStoredItem.$inject = [];

  /* @ngInject */
  function wgAddOsdFromStoredItem(){
    var directive = {
      bindToController: true,
      controller: AddOsdFromStoredItemCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/osd-register/addFromStoredItem.html",
      scope: {
        postUpdateDelegate: '&'
      }
    }

    return directive;

    function link(scope, element, attrs){

    }
  }

  AddOsdFromStoredItemCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function AddOsdFromStoredItemCtrl($uibModal) {
    var vm = this;
    vm.postUpdateDelegate = this.postUpdateDelegate;

    vm.openAddFromStoredItem = openAddFromStoredItem;

    function openAddFromStoredItem(){
      $uibModal.open({
        templateUrl: 'app/osd-register/addFromStoredItemModal.html',
        controller: AddOsdFromStoredItemModalCtrl,
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          postUpdateDelegate: function () {
            return vm.postUpdateDelegate;
          }
        }
      });
    }
  }

  angular
    .module('app.osd-register')
    .controller('AddOsdFromStoredItemModalCtrl', AddOsdFromStoredItemModalCtrl);

  AddOsdFromStoredItemModalCtrl.$inject = ['$scope', '$uibModalInstance', 'OidcManager', 'API', 'SETTINGS', 'stockService', 'bagAndTagService', 'postUpdateDelegate'];

  /* @ngInject */
  function AddOsdFromStoredItemModalCtrl($scope, $uibModalInstance, OidcManager, API, SETTINGS, stockService, bagAndTagService, postUpdateDelegate){
    var vm = this;

    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.availableQuantity = 0;

    vm.item = {};
    vm.results = [];
    vm.stockSearch = true;
    vm.issuesSelected = [];
    vm.filter = "";

    /** Stored Item Locations */
    vm.locations = [];
    vm.locationsOptions = [];
    vm.selectedLocation = [];
    /** Quarantine locations */
    vm.quarantineLocations = [];
    vm.quarantineLocationsOptions = [];
    vm.selectedQuarantineLocation = [];


    /** Purchase Orders */
    vm.purchaseOrders = [];
    vm.purchaseOrdersOptions = [];
    vm.purchaseOrdersSelected = [];
    /** Material Codes */
    vm.materialCodes = [];
    vm.materialCodesOptions = [];
    vm.materialCodesSelected = [];
    /** Cost Codes */
    vm.codeCodes = [];
    vm.costCodesOptions = [];
    vm.costCodesSelected = [];
    /** Barcodes */
    vm.barcodes = [];
    vm.barcodesOptions = [];
    vm.barcodesSelected = [];
    /** Locations */
    vm.locations = [];
    vm.locationsOptions = [];
    vm.locationsSelected = [];
    /** Bag and Tag Workpack numbers */
    vm.workpackNumbers = [];
    vm.workpackNumbersOptions = [];
    vm.workpackNumbersSelected = [];

    vm.doSearch = doSearch;
    vm.resetForm = resetForm;
    vm.selectItem = selectItem;

    activate();

    ////////////////////////////////

    function activate() {

    }

    function doSearch() {
      vm.searching = true;

      return searchStoredItems().then(function () {
        vm.searching = false;
      });
    }

    function searchStoredItems() {
      return stockService.searchStockItems(vm.purchaseOrdersSelected, vm.materialCodesSelected, vm.costCodesSelected, vm.barcodesSelected, vm.locationsSelected, vm.issuesSelected, vm.workpackNumbersSelected, vm.filter, false, vm.warehouse).then(function (data) {
        vm.results = data;
      });
    }

    function selectItem(item) {
          getStoredItemByStoredItemLocation(item.storedItemLocationId);
          vm.stockSearch = false;
    }

    vm.ok = function () {

      vm.saving = true;

      var itemToAdd = {
        originalStoredItemLocationId: vm.originalStoredItemLocationId,
        damagedQuantity: vm.damagedInterventionQuantity,
        otherQuantity: vm.otherInterventionQuantity,
        discrepancyDescription: vm.discrepancyDescription,
        quarantineLocationId: vm.selectedQuarantineLocation.id
      };

      stockService.createOverShortDamaged(vm.storedItemId, itemToAdd)
        .then(function (response) {

          vm.error = false;
          vm.saved = true;
          vm.saving = false;

          postUpdateDelegate({item: itemToAdd});

        }, function (error) {
          vm.saved = false;
          vm.error = true;
          vm.saving = false;

          showValidationErrors(error);
        });

    };

    function resetForm() {
      vm.purchaseOrdersSelected = [];
      vm.materialCodesSelected = [];
      vm.costCodesSelected = [];
      vm.barcodesSelected = [];
      vm.locationsSelected = [];
      vm.bagAndTagNumbersSelected = [];
      vm.workpackNumbersSelected = [];
      vm.issuesSelected = [];
      vm.filter = "";
      vm.results = undefined;
      vm.bagAndTagResults = undefined;
    }

    /** Quarantine Locations */

    vm.quarantineLocations = new kendo.data.DataSource({
      transport: {
        read: {
          url: function(options) {
            return API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations/' + vm.warehouseId + '/quarantine'},
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      },
      group: { field: "warehouseName" }
    });

    vm.quarantineLocationsOptions = {
      placeholder: "Select location",
      dataSource: vm.quarantineLocations,
      cascadeFrom: "location",
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };

    function getStoredItemByStoredItemLocation(storedItemLocationId) {
      return stockService.getStoredItemByStoredItemLocation(storedItemLocationId)
        .then(function (response) {
          if (response.description !== undefined){
            vm.descriptionIsReadOnly = true;
            vm.item = response;
            vm.storedItemId = response.id;
            vm.warehouseId = response.warehouseId;
            vm.availableQuantity = response.quantity;
            vm.quarantineLocationsOptions.dataSource.read();
            vm.damagedInterventionQuantity = 0;
            vm.otherInterventionQuantity = 0;
            vm.originalStoredItemLocationId = storedItemLocationId;
          }
        });
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };


    /** Purchase Orders */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + 'odata/PurchaseOrdersOData',
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken)
          }
        }
      },
      filter:[
        { field: "code", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrdersOptions = {
      height: 210,
      placeholder: "(Optional)",
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "purchaseOrderId",
      filter: "contains",
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      template: '<span class="k-state-default">#: number # - #: supplierName # - #= kendo.toString(kendo.parseDate(date), \'dd-MMM-yyyy\') #</span>'
    };


    /** Material Codes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.materialCodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      autoBind: false
    };

    /** Cost Codes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.costCodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false
    };

    /** Barcodes */

    vm.barcodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/stored-items/barcodes',
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.barcodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.barcodes,
      dataTextField: "barcode",
      dataValueField: "barcode",
      filter: "contains",
      autoBind: false
    };

    /** Locations */

    vm.locations = {
      transport: {
        read: {
          url: vm.isMovement ? API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations/' + vm.warehouse : API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations',
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      },
      group: { field: "warehouseName" }
    };

    vm.locationsOptions = {
      placeholder: "(Optional)",
      dataSource: vm.locations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };

    /** Bag and Tag workpack numbers */

    vm.workpackNumbers = {
      transport: {
        read: function (options) {
          return bagAndTagService.getBagAndTagWorkpackNumbers(true)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        }
      }
    };

    vm.workpackNumbersOptions = {
      placeholder: "(Optional)",
      dataSource: vm.workpackNumbers,
      dataTextField: "workpackNumber",
      dataValueField: "workpackNumber",
      filter: "contains",
      autoBind: false
    };

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessages);
        }
      } else {
        vm.validationErrors.push('Could not add OS&D from stock.');
      }
      vm.loading = false;
    }
  }

})();

(function () {
  'use strict';

  angular.module('app.movements', []);

})();

(function () {
  'use strict';

  angular
    .module('app.movements')
    .controller('ViewMovementsCtrl', ViewMovementsCtrl);

  ViewMovementsCtrl.$inject = ['$state', 'movementService'];

  /* @ngInject */
  function ViewMovementsCtrl($state, movementService) {
    var vm = this;
    vm.completedMovements = [];
    vm.incompleteMovements = [];
    vm.deliveryMovements = [];

    vm.setActiveTab = setActiveTab;

    vm.tabs = {
      incompleteActive: true,
      completeActive: false,
      deliveryActive: false
    };

    activate();

    ///////////////////////

    function activate(){

      movementService.getMovementsCompleted()
        .then(function(response) {
          vm.completedMovements = response;
        });


      movementService.getMovementsIncomplete()
        .then(function(response) {
          vm.incompleteMovements = response;
        });
      movementService.getMovementsDelivery()
        .then(function(response) {
          vm.deliveryMovements = response;
        });

      vm.setActiveTab();
    }


    function setActiveTab(){
      if($state.current.url=='complete'){
        vm.tabs.completeActive = true;
      }
      else if($state.current.url=='delivery'){
        vm.tabs.deliveryActive = true;
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.movements')
    .controller('ViewMovementCtrl', ViewMovementCtrl);

  ViewMovementCtrl.$inject = ['$scope','$stateParams', '$filter', '$timeout', 'movementService', 'SweetAlert', '$uibModal'];

  /* ngInject */
  function ViewMovementCtrl($scope, $stateParams, $filter, $timeout, movementService, SweetAlert, $uibModal) {
    var vm = this;
    $scope.controllerhasloaded = false;
    vm.movementId = $stateParams.id;
    vm.movement = {};
    vm.searching = false;
    vm.results = undefined;

    vm.movementItems = [];
    vm.validationErrors = [];
    vm.hasErrors = false;

    vm.tabs = {
      storedItemsActive: true,
      bagAngTagsActive: false,
      storedItemsResultsActive: true,
      bagAndTagResultsActive: false
    };


    vm.getMovement = getMovement;
    vm.completeMovement = completeMovement;
    vm.cancelMovement = cancelMovement;
    vm.addItem = addItem;
    vm.fakeMovementItems = fakeMovementItems;
    vm.removeItem = removeItem;
    vm.showValidationErrors = showValidationErrors;
    vm.greaterThan = greaterThan;
    vm.updateItems = updateItems;

    activate();

    ////////////////////

    function activate() {
      return getMovement().then(function () {
        if(vm.movement.movementStatus !== "Cancelled") {
          return getMovementItems().then(function () {
          });
        }
        else{
          vm.movementItems = [];
        }
      });
    }

    function completeMovement() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "You can not edit the movement after it is complete!",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, complete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false},
        function(isConfirm){
          if (!isConfirm) return;
          vm.loading = true;
          return movementService.completeMovement(vm.movementId)
            .then(function(response) {
                vm.loading = false;
                activate();

                SweetAlert.swal("Completed!", "The movement is now complete.", "success");
              },function(error){
                showValidationErrors(error);
              }
            );
        });
    }

    function cancelMovement() {
      SweetAlert.swal({
        title: "Are you sure?",
        text: "Cancelling this movement will remove all items.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ED5565",
        confirmButtonText: "Yes, cancel it!",
        cancelButtonText: "Close",
        closeOnConfirm: false},
      function(isConfirm){
        if (!isConfirm) return;
        vm.loading = true;
        return movementService.cancelMovement(vm.movementId)
          .then(function(response) {
            vm.loading = false;
            activate();
            SweetAlert.swal("Cancelled!", "The movement is now cancelled.", "success");
          }, function(error) {
            showValidationErrors(error);
          });
      });
    }

    function getMovement() {
      return movementService.getMovement(vm.movementId)
        .then(function(response) {
          vm.movement = response;
          $scope.controllerhasloaded = true;
          return vm.movement;
        });
    }

    function getMovementItems() {
      return movementService.getMovementItems(vm.movementId)
        .then(function(response) {
          vm.movementItems = response;
        });
    }


    function addItem(item) {
      return movementService.addItemToMovement(vm.movementId, item.storedItemLocationId, item.selectedQuantity)
        .then(function(response) {
          if (response.responseMessage === 'Success') {
            if (!addToExistingItem(item)) {
              vm.movementItems.push(angular.copy(item)); }
            deductQuantityFromStockItems(item.storedItemLocationId, item.storedItemId, item.selectedQuantity);
          } else {
            displayNotification(response.responseMessage);
          }
        });
    }

    function fakeMovementItems(returnItems) {
      angular.forEach(returnItems, function(item){
        if (!addToExistingItem(item)) {
          vm.movementItems.push(angular.copy(item)); }
        deductQuantityFromStockItems(item.storedItemLocationId, item.storedItemId, item.selectedQuantity);
      });
    }

    function addToExistingItem(item) {

      var storedItemLocation = $filter('filter')(vm.movementItems, {storedItemLocationId: item.storedItemLocationId})[0];

      if (storedItemLocation != undefined) {
        storedItemLocation.class = "badge-non-bold backgroundAnimated";
        storedItemLocation.selectedQuantity = parseFloat(storedItemLocation.selectedQuantity) + parseFloat(item.selectedQuantity);
        $timeout(function () {
          storedItemLocation.class = "badge-transparent";
        }, 1000);
        return true;
      }

    }



    function removeItem(item) {
      if (vm.results !== undefined) {
        returnItemToStock(item);
      }
      var index = vm.movementItems.indexOf(item);
      vm.movementItems.splice(index, 1);

      return movementService.removeItemFromMovement(vm.movementId, item.storedItemLocationId)
        .then(function(response) {

        },function(error){
          showValidationErrors(error);
        });
    }

    function returnItemToStock(item) {

      angular.forEach(vm.results, function(storedItem) {
        var storedItemLocation = $filter('filter')(storedItem.storedItems, {storedItemLocationId: item.storedItemLocationId })[0];

        if (storedItemLocation != undefined) {

          storedItemLocation.class = "badge-non-bold backgroundAnimated";
          storedItemLocation.quantity = parseFloat(storedItemLocation.quantity) + parseFloat(item.selectedQuantity);

          $timeout(function () {
            storedItemLocation.class = "badge-transparent";
          }, 1000);
        }
      });
    }

    function deductQuantityFromStockItems(storedItemLocationId, storedItemId,  qty) {

      var storedItem = $filter('filter')(vm.results, {storedItemId: storedItemId})[0];

      $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].quantity -= qty;
      $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].selectedQuantity = "";
      $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].isIncluded = false;
    }


    function displayNotification(message) {
      SweetAlert.swal({
          title: "Quantity unavailable",
          text: message,
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Close",
          closeOnConfirm: false}
        );
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not search for stored items.');
      }
      vm.loading = false;
    }

    function greaterThan(prop, val){
      return function(item){
        return item[prop] > val;
      };
    }

    function updateItems(itemsToUpdate, locationId){
      vm.itemsToMovement = [];
      angular.forEach(itemsToUpdate, function (value, key) {
        vm.itemsToMovement.push({
          storedItemId: value.id,
          storedItemLocationId: value.storedItemLocationId,
          issueItemId: value.issueItemId,
          quantity: parseFloat(value.selectedQuantity)
        });
      });

      var items = {
        returnId: vm.movementId,
        locationId: locationId,
        returnItems: vm.itemsToMovement
      };
      return movementService.returnItems(items);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.movements')
    .controller('CreateMovementCtrl', CreateMovementCtrl);

  CreateMovementCtrl.$inject = ['movementService', '$state', 'API', 'SETTINGS', 'OidcManager', 'projectService'];
  /* @ngInject */
  function CreateMovementCtrl(movementService, $state, API, SETTINGS, OidcManager, projectService) {
    if ($state.transition) return;

    var vm = this;

    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.loading = false;
    vm.movement = {
      description: '',
      warehouseId: '',
      newProjectId: ''
    };

    /** Warehouses */
    vm.warehouses = [];
    vm.warehousesOptions = [];

    /** Projects */
    vm.projects = [];
    vm.projectsOptions = [];

    vm.createMovement = createMovement;
    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;

    activate();

    /////////////////////

    function activate() {

    }

    function createMovement() {
      vm.loading = true;
      return movementService.createMovement(vm.movement)
        .then(function (response) {
          vm.hasErrors = false;
          $state.transitionTo('movements.details', {id: response.movementId});
        }, function (error) {
          if (error.status !== 403) {
            vm.hasErrors = true;
            showValidationErrors(error);
          }
          vm.loading = false;
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessages);
        }
      } else {
        vm.validationErrors.push('Could not create movement.');
      }
      vm.loading = false;
    }


    /** Warehouses */

    vm.warehouses = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/warehouses",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.warehousesOptions = {
      placeholder: "(Required)",
      dataSource: vm.warehouses,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false
    };

    /** Projects */

    vm.projects = {
      transport: {
        read: function(options){
          return projectService.getProjectsExcludeCurrent().then(function(response){
            var data = response;

            options.success(data);
          });
        }
      }
    };

    vm.projectsOptions = {
      placeholder: "(Optional)",
      dataSource: vm.projects,
      dataTextField: "code",
      dataValueField: "id",
      filter: "contains",
      autoBind: false
    };

  }

})();

(function () {
  'use strict';

  angular.module('app.material-allocation', []);

})();

(function () {
  'use strict';

  angular
    .module('app.material-allocation')
    .controller('ViewMaterialAllocationsCtrl', ViewMaterialAllocationsCtrl);

  ViewMaterialAllocationsCtrl.$inject = ['$rootScope', '$scope', '$state', '$uibModal', '$filter', '$timeout', 'materialAllocationService', 'permissionService', 'reportingService', 'FileSaver', 'Blob', 'SETTINGS'];

  /* @ngInject */
  function ViewMaterialAllocationsCtrl($rootScope, $scope, $state, $uibModal, $filter, $timeout, materialAllocationService, permissionService, reportingService, FileSaver, Blob, SETTINGS) {
    var vm = this;
    vm.constructionWorkpacks = [];
    vm.textFilter = '';
    vm.openModal = openModal;
    vm.downloadTemplate = downloadTemplate;
    vm.exportSummary = exportSummary;
    vm.clearFilter = clearFilter;
    vm.loadConstructionWorkpacks = loadConstructionWorkpacks;
    vm.priorityChanged = priorityChanged;
    vm.allocationActivityPercentage = 0;
    var loadPromise;
    var errorCount = 0;
    var loadTime = 5000;

    vm.isAdmin = permissionService.isAdmin();
    vm.canUpdatePriority = vm.isAdmin === true ? true : permissionService.hasPermission("MaterialAllocation", "Update");
    vm.canEdit = vm.isAdmin === true ? true : permissionService.hasPermission("MaterialAllocation", "Update");

    $rootScope.$on('constructionWorkpackCreated', loadConstructionWorkpacks);

    activate();

    ///////////////////////

    function activate() {
      loadConstructionWorkpacks();
      pollConstructionWorkpacks();
    }

    function loadConstructionWorkpacks() {
      return materialAllocationService.getConstructionWorkpacks()
        .then(function (response) {
          vm.constructionWorkpacks = response.result;
          vm.constructionWorkpacks = $filter('orderBy')(vm.constructionWorkpacks, 'rank');
        });
    }

    function downloadTemplate() {
      return materialAllocationService.getImportTemplate()
        .then(function(response) {
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

    function pollConstructionWorkpacks(){
      return getConstructionWorkpackFulfillment()
        .then(function(response){
          return getAllocationActivity()
            .then(function(response){
              errorCount = 0;
              nextLoad();
            })
            .catch(function(response){
              nextLoad(++errorCount * 2 * loadTime);
            });
        })
    }

    function getConstructionWorkpackFulfillment(){
      return materialAllocationService.getConstructionWorkpacks()
        .then(function(response){
          angular.forEach(response.result, function (item){
            var itemToUpdate = $filter('filter')(vm.constructionWorkpacks, { id: item.id})[0];
            if (itemToUpdate !== undefined) {
              itemToUpdate.fulfillmentShortPercentage = item.fulfillmentShortPercentage;
              itemToUpdate.fulfilledFromIssuedPercentage = item.fulfilledFromIssuedPercentage;
              itemToUpdate.fulfilledFromReservedPercentage = item.fulfilledFromReservedPercentage;
              itemToUpdate.fulfilledFromStockPercentage = item.fulfilledFromStockPercentage;
              itemToUpdate.fulfilledFromShippedPercentage = item.fulfilledFromShippedPercentage;
              itemToUpdate.fulfilledFromPurchasedPercentage = item.fulfilledFromPurchasedPercentage;
            }
          });
        })
    }

    function getAllocationActivity(x){
      return materialAllocationService.getAllocationActivity()
        .then(function(response){
          vm.allocationActivityPercentage = Math.round(parseFloat(response.PercentOfMaterialCodesBeingAllocated) * 100);
        })
    }

    function exportSummary(){
      var parameters = {
        ProjectId: SETTINGS.projectId
      };

      var data = {
        reportType: 'MaterialAllocationSummary',
        reportFormat: 'Excel',
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });
    }

    function openModal(item) {
      $uibModal.open({
        templateUrl: 'app/material-allocation/uploadDemandModal.html',
        controller: 'UploadDemandModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          lineItem: function () {
            return angular.copy(item);
          },
          isReadOnly: function () {
            return vm.isReadOnly;
          },
          updateItem: function () {
            return vm.updateItem;
          }
        }
      });
    }

    function clearFilter(){
      vm.textFilter = '';
    }

    function priorityChanged(index, item){
      var selectedItem = $filter('filter')(vm.constructionWorkpacks, { id: item.id})[0];
      var newIndex = vm.constructionWorkpacks.indexOf(selectedItem);

      if (newIndex === index) return;

      var oldChild = $filter('filter')(vm.constructionWorkpacks, { parentDemandId: item.id})[0];
      var newChild = vm.constructionWorkpacks[newIndex + 1];
      var secondLastItem = vm.constructionWorkpacks[vm.constructionWorkpacks.length - 2];

      var model = {
        selectedItemId: selectedItem.id,
        oldChildId: angular.isUndefined(oldChild) ? null : oldChild.id,
        newChildId: angular.isUndefined(newChild) ? null : newChild.id,
        secondLastItemId: secondLastItem.id,
        selectedItemNewIndex: newIndex
      };

      return materialAllocationService.priorityChanged(model)
        .then(function(response) {
          vm.saving = false;
          loadConstructionWorkpacks();
        }, function(error){
          vm.saving = false;
        });
    }

    var nextLoad = function(mill) {
      mill = mill || loadTime;
      cancelNextLoad();
      loadPromise = $timeout(pollConstructionWorkpacks, mill);
    };

    var cancelNextLoad = function() {
      $timeout.cancel(loadPromise);
    };

    $scope.$on('$destroy', function(){
      cancelNextLoad();
    });
  }

    angular
      .module('app.material-allocation')
      .controller('UploadDemandModalCtrl', UploadDemandModalCtrl);

    UploadDemandModalCtrl.$inject = ['$rootScope', '$uibModalInstance', 'lineItem', 'isReadOnly', 'updateItem', 'materialAllocationService', 'API', 'FileSaver', 'Blob', 'SETTINGS'];

    function UploadDemandModalCtrl($rootScope, $uibModalInstance, lineItem, isReadOnly, updateItem, materialAllocationService, API, FileSaver, Blob, SETTINGS) {
      var vm = this;
      vm.constructionWorkpark = lineItem;
      vm.isReadOnly = true;
      vm.updateItem = updateItem;
      vm.downloadTemplate = downloadTemplate;
      vm.getImportErrors = getImportErrors;

      vm.importEndpoint = API.BASE_URI_MATERIALALLOCATION + SETTINGS.projectId + '/demand/upload-demand/' + vm.constructionWorkpark.id;

      activate();

      ///////////////////////////////

      function activate() {

      }

      vm.cancel = function () {
        $uibModalInstance.dismiss('cancel');
        $rootScope.$emit('constructionWorkpackCreated');
      };

      function downloadTemplate() {
        return materialAllocationService.getImportTemplate()
          .then(function(response) {
            var file = new Blob([response.data]);
            FileSaver.saveAs(file, response.filename);
          });
      }

      function getImportErrors(documentKey) {
        return materialAllocationService.getImportErrors(documentKey)
          .then(function(response) {
            var file = new Blob([response.data]);
            FileSaver.saveAs(file, response.filename);
          });
      }
    }
})();

(function(){
  'use strict';

  angular
    .module('app.material-allocation')
    .controller('ViewMaterialAllocationCtrl', ViewMaterialAllocationCtrl);

  ViewMaterialAllocationCtrl.$inject = ['$stateParams', 'materialAllocationService', 'reportingService', 'SETTINGS'];

  /* ngInject */
  function ViewMaterialAllocationCtrl($stateParams, materialAllocationService, reportingService, SETTINGS){
    var vm = this;

    vm.constructionWorkpackId = $stateParams.id;
    vm.constructionWorkpack = {};
    vm.constructionWorkpackDemand = [];
    vm.exportDetail = exportDetail

    activate();

    ///////////////////////

    function activate(){
      return getConstructionWorkpack().then(function() {
        return getConstructionWorkpackDemandTotals(vm.constructionWorkpackId).then(function () {
        });
      });
    }

    function getConstructionWorkpack() {
      return materialAllocationService.getConstructionWorkpack(vm.constructionWorkpackId)
        .then(function(response){
          vm.constructionWorkpack = response.result;
        });
    }

    function getConstructionWorkpackDemandTotals() {
      return materialAllocationService.getConstructionWorkpackDemandTotals(vm.constructionWorkpackId, vm.constructionWorkpack.jobNumber)
        .then(function(response){
          vm.constructionWorkpackDemand = response.result;
        });
    }

    function exportDetail(){
      var parameters = {
        ProjectCode: SETTINGS.projectCode,
        DemandId: $stateParams.id,
        Filename: vm.constructionWorkpack.number
      };

      var data = {
        reportType: 'MaterialAllocationDetail',
        reportFormat: 'Excel',
        parametersString: JSON.stringify(parameters),
        parameters: {}
      };

      reportingService.prepAndRunReport(data).then(function(){
        vm.generating = false;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.material-allocation')
    .directive('wgUpdateConstructionWorkpack', wgUpdateConstructionWorkpack);

  wgUpdateConstructionWorkpack.$inject = [];

  /* @ngInject */
  function wgUpdateConstructionWorkpack(){
    var directive = {
      bindToController: true,
      controller: UpdateConstructionWorkpackDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/material-allocation/updateConstructionWorkpack.html',
      scope: {
        item: '=',
        postUpdateDelegate: '&'
      }
    };

    return directive;

    function link(scope, element, attrs){

    }
  }

  UpdateConstructionWorkpackDirCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function UpdateConstructionWorkpackDirCtrl($uibModal){
    var vm = this;
    vm.item = this.item;
    vm.postUpdateDelegate = this.postUpdateDelegate;

    vm.openModal = openModal;

    function openModal() {
      $uibModal.open({
        templateUrl: 'app/material-allocation/updateConstructionWorkpackModal.html',
        controller: 'UpdateConstructionWorkpackCtrl',
        controllerAs: 'vm',
        size: 'md',
        backdrop: 'static',
        resolve: {
          item: function () {
            return vm.item;
          },
          postUpdateDelegate: function () {
            return vm.postUpdateDelegate;
          }
        }
      });
    }
  }

  angular
    .module('app.material-allocation')
    .controller('UpdateConstructionWorkpackCtrl', UpdateConstructionWorkpackCtrl);

  UpdateConstructionWorkpackCtrl.$inject = ['$uibModalInstance', '$timeout', 'materialAllocationService', 'item', 'postUpdateDelegate', 'SweetAlert'];

  function UpdateConstructionWorkpackCtrl($uibModalInstance, $timeout, materialAllocationService, item, postUpdateDelegate, SweetAlert){
    var vm = this;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.item = item;

    activate();

    ////////////////////////////////

    function activate() {

    }

    vm.ok = function () {
      vm.saving = true;

      return materialAllocationService.updateConstructionWorkpack(vm.item)
        .then(function(response){
          vm.error = false;
          vm.saved = true;
          vm.saving = false;

          postUpdateDelegate();

          $uibModalInstance.close();
          $timeout(function() {
            SweetAlert.swal("Saved", "The construction workpack " + vm.item.number + " has been saved successfully.", "success")
          }, 500);
        }, function (error){
          vm.saved = false;
          vm.error = true;
          vm.saving = false;
          showValidationErrors(error);
      });
    }

    vm.delete = function () {
      SweetAlert.swal({
        title: 'Are you sure?',
        text: 'Deleting this construction workpack will remove all associated demand. This cannot be undone. Do you wish to continue?',
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Close",
        closeOnConfirm: false,
        closeOnCancel: true
      },
        function(isConfirm) {
          if (isConfirm) {
            deleteConstructionWorkpack();
          }
        });
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    function deleteConstructionWorkpack () {
      vm.saving = true;

      return materialAllocationService.deleteConstructionWorkpack(vm.item.constructionWorkpackId)
        .then(function(response){
          vm.error = false;
          vm.saved = true;
          vm.saving = false;

          postUpdateDelegate();

          $uibModalInstance.close();
          $timeout(function() {
            SweetAlert.swal("Saved", "The construction workpack " + vm.item.number + " has been successfully deleted.", "success")
          }, 500);
        }, function (error){
          vm.saved = false;
          vm.error = true;
          vm.saving = false;
          showValidationErrors(error);
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not save construction workpack.');
      }
      vm.loading = false;
    }
  }
})();

(function (){
  'use strict';

  angular
    .module('app.material-allocation')
    .directive('wgCreateConstructionWorkpack', wgCreateConstructionWorkpack);

  wgCreateConstructionWorkpack.$inject = [];

  /* @ngInject */
  function wgCreateConstructionWorkpack() {
    var directive = {
      bindToController: true,
      controller: CreateConstructionWorkpackDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/material-allocation/createConstructionWorkpack.html',
      scope: {
        postUpdateDelegate: '&'
      }
    };

    return directive;

    function link(scope, element, attrs){

    }
  }

  CreateConstructionWorkpackDirCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function CreateConstructionWorkpackDirCtrl($uibModal) {
    var vm = this;
    vm.postUpdateDelegate = this.postUpdateDelegate;

    vm.openCreateConstructionWorkpack = openCreateConstructionWorkpack;

    function openCreateConstructionWorkpack() {
      $uibModal.open({
        templateUrl: 'app/material-allocation/createConstructionWorkpackModal.html',
        controller: 'CreateConstructionWorkpackCtrl',
        controllerAs: 'vm',
        size: 'md',
        resolve: {
          postUpdateDelegate: function () {
            return vm.postUpdateDelegate;
          }
        }
      });
    }
  }

  angular
    .module('app.material-allocation')
    .controller('CreateConstructionWorkpackCtrl', CreateConstructionWorkpackCtrl);

  CreateConstructionWorkpackCtrl.$inject = ['$uibModalInstance', '$timeout', 'materialAllocationService', 'postUpdateDelegate', 'SweetAlert'];

  function CreateConstructionWorkpackCtrl($uibModalInstance, $timeout, materialAllocationService, postUpdateDelegate, SweetAlert){
    var vm = this;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.item = {};

    activate();

    ////////////////////////////////

    function activate() {

    }

    vm.ok = function () {
      vm.saving = true;

      return materialAllocationService.createConstructionWorkpack(vm.item)
        .then(function(response) {
          vm.error = false;
          vm.saved = true;
          vm.saving = false;

          postUpdateDelegate();

          if (vm.addAnother) {
            resetModal();
          } else {
            $uibModalInstance.close();
            $timeout(function () {
              SweetAlert.swal("Saved!", "The construction workpack " + vm.item.number + " has been saved successfully.", "success");
            }, 500);
          }
        }, function(error){
          vm.saved = false;
          vm.error = true;
          vm.saving = false;
          showValidationErrors(error);
        });
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    function resetModal() {
      vm.item = {};
      $timeout(function () {
        vm.saved = false;
      }, 4000);
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not save construction workpack.');
      }
      vm.loading = false;
    }
  }
})();

(function() {
  'use strict';

  angular.module('app.min-max', []);

})();

(function () {
  'use strict';

  angular
    .module('app.min-max')
    .controller('ViewMinMaxRegisterCtrl', ViewMinMaxRegisterCtrl);

  ViewMinMaxRegisterCtrl.$inject = ['minMaxService', '$uibModal'];

  /* @ngInject */
  function ViewMinMaxRegisterCtrl(minMaxService, $uibModal){
    var vm = this;

    vm.reorderedMinMaxItems = [];
    vm.notOrderedMinMaxItems = [];
    vm.incompleteMinMaxItems = [];

    vm.refreshTabs = refreshTabs;

    vm.openMinMax = openMinMax;

    activate();

    //////////////////////////////

    function activate(){
      getReorderedMinMaxItems();
      getNotOrderedMinMaxItems();
      getIncompleteMinMaxItems();
    }

    function getReorderedMinMaxItems() {
      minMaxService.getReorderedMinMaxItems()
        .then(function(response) {
          vm.reorderedMinMaxItems = response;
        });
    }

    function getNotOrderedMinMaxItems() {
      minMaxService.getNotOrderedMinMaxItems()
        .then(function(response) {
          vm.notOrderedMinMaxItems = response;
        });
    }

    function getIncompleteMinMaxItems() {
      minMaxService.getIncompleteMinMaxItems()
        .then(function(response) {
          vm.incompleteMinMaxItems = response;
        });
    }

    function refreshTabs(){
      activate();
    }

    function openMinMax(reorder, items) {
      $uibModal.open({
        templateUrl: 'app/min-max/minMaxActionModal.html',
        controller: 'MinMaxActionModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          items: function () {
            return items;
          },
          reorder: function () {
            return reorder;
          },
          postUpdateDelegate: function () {
            return vm.refreshTabs;
          }
        }
      });
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.min-max')
    .controller('ViewMinMaxPlanningCtrl', ViewMinMaxPlanningCtrl);

  ViewMinMaxPlanningCtrl.$inject = ['$scope', 'minMaxService', 'API', 'SETTINGS', 'OidcManager', 'FileSaver', 'Blob'];

  /* @ngInject */
  function ViewMinMaxPlanningCtrl($scope, minMaxService, API, SETTINGS, OidcManager, FileSaver, Blob) {
    var vm = this;

    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.minMaxItems = [];
    vm.refreshGrid = refreshGrid;
    vm.fakeDeleteItem = fakeDeleteItem;
    vm.setWarehouse = setWarehouse;
    vm.downloadTemplate = downloadTemplate;
    vm.exportMinMax = exportMinMax;

    activate();

    //////////////////////////

    function activate(){
      minMaxService.getMinMaxItems()
        .then(function (response){
          vm.minMaxItems = response;
        });
    }

    function fakeDeleteItem(item){
      var index = vm.minMaxItems.indexOf(item);
      vm.minMaxItems.splice(index, 1);
    }

    function refreshGrid(){
      activate();
    }

    function setWarehouse(){
      vm.warehouseQuery = vm.selectedWarehouse === null ? undefined : vm.selectedWarehouse;
    }

    function downloadTemplate(){
      return minMaxService.getImportTemplate()
        .then(function(response){
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

    function exportMinMax() {
      return minMaxService.getMinMaxExport()
        .then(function(response){
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

    $scope.$on('upload-complete', function(event, args) {
      refreshGrid();
    });

    /** Warehouses */

    vm.warehouses = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/warehouses',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.warehouseOptions = {
      placeholder: "ALL",
      dataSource: vm.warehouses,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false
    };


  }

})();

(function () {
  'use strict';

  angular
    .module('app.min-max')
    .directive('wgMinMaxRegisterActionedLine', wgMinMaxRegisterActionedLine);

  wgMinMaxRegisterActionedLine.$inject = [];

  /* @ngInject */
  function wgMinMaxRegisterActionedLine(){
    var directive = {
      bindToController: true,
      controller: MinMaxRegisterActionedLineCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'AE',
      scope: {
        item: '=',
        isReorder: '='
      },
      templateUrl: 'app/min-max/minMaxRegisterActionedLine.html'
    };

    return directive;

    function link(scope, element, attrs){

    }
  }

  MinMaxRegisterActionedLineCtrl.$inject = [];

  /* @ngInject */
  function MinMaxRegisterActionedLineCtrl() {
    var vm = this;

    vm.item = this.item;
    vm.isReorder = this.isReorder;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.min-max')
    .directive('wgMinMaxLineItem', wgMinMaxLineItem);

  wgMinMaxLineItem.$inject = [];

  /* @ngInject */
  function wgMinMaxLineItem() {
    var directive = {
      bindToController: true,
      controller: MinMaxLineItemCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'AE',
      scope: {
        item: '=',
        postUpdateDelegate: '&'
      },
      templateUrl: 'app/min-max/minMaxLineItem.html'
    };

    return directive;

    function link(scope, element, attrs) {

    }
  }

  MinMaxLineItemCtrl.$inject = ['$scope', 'minMaxService', 'SweetAlert'];

  /* @ngInject */
  function MinMaxLineItemCtrl($scope, minMaxService, SweetAlert) {
    var vm = this;

    vm.item = this.item;
    vm.postUpdateDelegate = this.postUpdateDelegate;
    vm.isInvalid = isInvalid;

    $scope.$watch('vm.item.minQuantity', checkIsDirty);
    $scope.$watch('vm.item.maxQuantity', checkIsDirty);
    $scope.$watch('vm.item.reorderQuantity', checkIsDirty);

    //////////////////////////

    vm.ok = function () {
      vm.saving = true;

      return minMaxService.updateMinMaxMaterialCode(vm.item)
        .then(function (response) {

          vm.item.isDirty = false;
          vm.saved = true;
          vm.saving = false;

        }, function (error) {

          vm.saved = false;
          vm.error = true;
          vm.saving = false;

          showValidationErrors(error);
        });
    }

    vm.delete = function () {

      SweetAlert.swal({
          title: "Are you sure?",
          text: "You can not undo this action!",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          return minMaxService.deleteMinMaxMaterialCode(vm.item.id)
            .then(function (response) {
              vm.postUpdateDelegate(vm.item);
              SweetAlert.swal("Deleted!", "The min/max for material code " + vm.item.materialCode + " has been deleted.", "success");
            });
        });
    }

    function checkIsDirty(newValue, oldValue) {
      if (newValue !== oldValue) {
        vm.item.isDirty = true;
      }
    }

    function isInvalid() {
      if (vm.item.isDirty) {
        return ((vm.item.minQuantity === null || vm.item.minQuantity === '0') || (vm.item.maxQuantity === null || vm.item.maxQuantity === '0') || (vm.item.reorderQuantity === null || vm.item.reorderQuantity === '0') || vm.item.minQuantity > vm.item.maxQuantity);
      }
    }

    vm.setActive = function () {
      return minMaxService.updateMinMaxMaterialCode(vm.item)
        .then(function (response) {
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not save min/max line item.');
      }
      vm.loading = false;
    }
  }

})();

(function () {
    'use strict';

    angular
      .module('app.min-max')
      .controller('MinMaxActionModalCtrl', MinMaxActionModalCtrl);

    MinMaxActionModalCtrl.$inject = ['$uibModalInstance', 'minMaxService', 'adminService', 'items', 'reorder', 'postUpdateDelegate'];

    function MinMaxActionModalCtrl($uibModalInstance, minMaxService, adminService, items, reorder, postUpdateDelegate) {
      var vm = this;

      vm.items = angular.copy(items);
      vm.reorder = reorder;
      vm.postUpdateDelegate = postUpdateDelegate;

      activate();

      ////////////////////

      function activate() {

      }

      vm.ok = function () {

        var dataToSave = {};

        dataToSave.actionItems = [];
        angular.forEach(vm.items, function (value, key) {
          dataToSave.actionItems.push({
            id: value.id,
            orderQuantity: value.orderQuantity
          });
        });

        dataToSave.buyerEmployeeId = vm.reorder ? vm.buyer.employeeId : 0;
        dataToSave.comments = vm.comments;

        return (vm.reorder ? minMaxService.reorder : minMaxService.dismiss )
        (dataToSave).then(function (response) {
          vm.saved = true;
          vm.postUpdateDelegate();
        }, function () {
          vm.saved = false;
          vm.error = true;
          vm.saving = false;
        });
      };

      /** Buyer */

      vm.buyers = {
        transport: {
          read: function (options) {
            return adminService.getUsersForProject()
              .then(function (response) {
                var data = response;
                options.success(data);
              });
          },
          dataType: "json"
        }
      };

      vm.buyerOptions = {
        placeholder: "Select buyer",
        dataSource: vm.buyers,
        dataTextField: "fullName",
        dataValueField: "employeeId",
        filter: "contains",
        autobind: false
      };

      vm.cancel = function () {
        $uibModalInstance.dismiss('cancel');
        // postUpdateDelegate();
      };
    }


  })();

(function () {
  'use strict';

  angular
    .module('app.min-max')
    .controller('ImportMaterialMinMaxItemsCtrl', ImportMaterialMinMaxItemsCtrl);

  ImportMaterialMinMaxItemsCtrl.$inject = ['API', 'SETTINGS', 'minMaxService', 'FileSaver', 'Blob'];

  /* @ngInject */
  function ImportMaterialMinMaxItemsCtrl(API, SETTINGS, minMaxService, FileSaver, Blob){

    var vm = this;

    vm.loading = false;

    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;
    vm.downloadTemplate = downloadTemplate;
    vm.getImportErrors = getImportErrors;

    vm.importEndpoint = API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/import-export/min-max-upload';

    activate();

    ////////////////////

    function activate() {

    }

    function downloadTemplate() {
      return minMaxService.getImportTemplate()
        .then(function(response) {
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

    function getImportErrors(parentId, documentKey) {
      return minMaxService.getImportErrors(documentKey)
        .then(function(response) {
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not import material min/max values.');
      }
      vm.loading = false;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.min-max')
    .directive('wgAddMinMaxMaterialCode', wgAddMinMaxMaterialCode);

  wgAddMinMaxMaterialCode.$inject = [];

  /* @ngInject */
  function wgAddMinMaxMaterialCode() {
    var directive = {
      bindToController: true,
      controller: AddMinMaxMaterialCodeDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/min-max/addMinMaxMaterialCode.html',
      scope: {
        postUpdateDelegate: '&'
      }
    };

    return directive;

    function link(scope, element, attrs) {

    }
  }

  AddMinMaxMaterialCodeDirCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function AddMinMaxMaterialCodeDirCtrl($uibModal) {
    var vm = this;
    vm.postUpdateDelegate = this.postUpdateDelegate;

    vm.openAddMinMaxItem = openAddMinMaxItem;

    function openAddMinMaxItem() {
      $uibModal.open({
        templateUrl: 'app/min-max/addMinMaxMaterialCodeModal.html',
        controller: 'AddMinMaxMaterialCodeCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          postUpdateDelegate: function () {
            return vm.postUpdateDelegate;
          }
        }
      });
    }
  }

  angular
    .module('app.min-max')
    .controller('AddMinMaxMaterialCodeCtrl', AddMinMaxMaterialCodeCtrl);

  AddMinMaxMaterialCodeCtrl.$inject = ['$uibModalInstance', '$timeout', 'minMaxService', 'stockService', 'OidcManager', 'API', 'SETTINGS', 'postUpdateDelegate', 'SweetAlert'];

  function AddMinMaxMaterialCodeCtrl($uibModalInstance, $timeout, minMaxService, stockService, OidcManager, API, SETTINGS, postUpdateDelegate, SweetAlert) {
    var vm = this;

    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.item = {};
    vm.item.reorderQuantity = 1;

    vm.descriptionIsReadOnly = true;
    vm.isValidQuantity = isValidQuantity;

    /** Material Codes */
    vm.materialCodes = [];
    vm.materialCodesOptions = [];
    vm.selectedMaterialCode = [];
    /** Warehouses */
    vm.warehouses = [];
    vm.warehouseOptions = [];
    vm.selectedWarehouse = [];

    activate();

    ////////////////////////////////

    function activate() {

    }

    vm.ok = function () {

      vm.saving = true;

      vm.item.warehouseIds = [];

      if (vm.selectedWarehouse !== undefined) {
        angular.forEach(vm.selectedWarehouse, function(value, key){
          vm.item.warehouseIds.push(value.id);
        });
      }

      vm.item.MaterialCode = vm.selectedMaterialCode;
      vm.item.description = "";

      return minMaxService.addMinMaxMaterialCode(vm.item)
        .then(function (response) {

          vm.error = false;
          vm.saved = true;
          vm.saving = false;

          postUpdateDelegate();

          if (vm.addAnother) {
            resetModal();
          } else {
            $uibModalInstance.close();
            $timeout(function () {
              SweetAlert.swal("Saved!", "The min/max values for material code " + vm.item.materialCode + " have been saved successfully.", "success");
            }, 500);
          }
        }, function (error) {

          vm.saved = false;
          vm.error = true;
          vm.saving = false;

          showValidationErrors(error);
        });
    }

    /** Material Codes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.materialCodesOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "id",
      suggest: true,
      autoBind: false,
      change: function (e) {
        getStoredItemByMaterialCode(this.value());
      }
    };

    /** Warehouses */

    vm.warehouses = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/warehouses',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.warehouseOptions = {
      dataSource: vm.warehouses,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false
    };

    function getStoredItemByMaterialCode(storedItemId) {
      return stockService.getMaterialDetailsByStoredItemId(storedItemId)
        .then(function (response) {
          vm.item.materialCode = response.materialCode;

          if (response.description !== undefined){
            vm.descriptionIsReadOnly = true;
            vm.item.description = response.description;
          } else {
            vm.descriptionIsReadOnly = false;
          }
        });
    }

    function isValidQuantity(){
      if(vm.item.minQuantity !== undefined && vm.item.maxQuantity !== undefined) {
        return parseFloat(vm.item.minQuantity) < parseFloat(vm.item.maxQuantity);
      } else {
        return true;
      }
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    function resetModal() {
      vm.item = {};
      resetCombo("materialCode");
      resetMultiSelect("warehouse");
      $timeout(function () {
        vm.saved = false;
      }, 4000);
    }

    function resetCombo(name) {
      var combo = angular.element(document.getElementsByName(name));
      combo.data("kendoComboBox").value("");
    }

    function resetMultiSelect(name) {
      var multiSelect = angular.element(document.getElementsByName(name));
      multiSelect.data("kendoMultiSelect").value("");
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not save min/max line item.');
      }
      vm.loading = false;
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.manifests', []);

})();

(function () {
  'use strict';

  angular
    .module('app.manifests')
    .controller('ViewManifestsCtrl', ViewManifestsCtrl);

  ViewManifestsCtrl.$inject = ['$state', 'manifestService'];

  /* @ngInject */
  function ViewManifestsCtrl($state, manifestService) {
    var vm = this;
    vm.completedManifests = [];
    vm.incompleteManifests = [];

    activate();

    ///////////////////////

    function activate(){

      manifestService.getManifestsCompleted()
        .then(function(response) {
          vm.completedManifests = response;
        });

      manifestService.getManifestsIncomplete()
        .then(function(response) {
          vm.incompleteManifests = response;
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.manifests')
    .controller('ViewManifestCtrl', ViewManifestCtrl);

  ViewManifestCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'manifestService','bagAndTagService', 'SweetAlert', '$uibModal', 'SETTINGS', 'API', 'OidcManager', '$filter', 'permissionService'];

  /* ngInject */
  function ViewManifestCtrl($scope, $stateParams, $timeout, manifestService, bagAndTagService, SweetAlert, $uibModal, SETTINGS, API, OidcManager, $filter, permissionService) {
    var vm = this;

    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;
    vm.manifestId = $stateParams.id;
    vm.manifest = {};
    vm.searching = false;
    vm.results = undefined;
    vm.bagAndTagResults = undefined;
    vm.manifestResults = undefined;
    vm.movementResults = undefined;

    vm.isAdmin = permissionService.isAdmin();
    vm.canEditManifestType = vm.isAdmin === true ? true : permissionService.hasPermission("Manifest", "Edit");

    vm.manifestItems = [];
    vm.manifestTypes = [];
    vm.manifestBagAndTagItems = [];
    vm.bagAndTagsResult = [];
    vm.selectedItems = [];
    vm.selectedBagAndTags = [];
    vm.typeOptions = [];
    vm.showTypeDropDown = false;
    vm.savingManifestType = false;
    vm.selectAllIssues = false;
    vm.selectAllReturns = false;
    vm.selectAllTransfers = false;
    vm.selectAllDeliveries = false;
    vm.selectAllPurchaseOrders = false;
    vm.selectAllManifests = false;
    vm.selectAllMovements = false;
    vm.selectAllBagAndTag = false;

    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.dataHasLoaded = false;

    vm.tabs = {
      storedItemsActive: true,
      bagAngTagsActive: false,
      storedItemsResultsActive: true,
      bagAndTagResultsActive: false
    };

    vm.getManifest = getManifest;
    vm.getManifestTypes = getManifestTypes;
    vm.getManifestItems = getManifestItems;
    vm.completeManifest = completeManifest;
    vm.reopenManifest = reopenManifest;
    vm.cancelManifest = cancelManifest;
    vm.addItem = addItem;
    vm.addManifestItem = addManifestItem;
    vm.addStockItem = addStockItem;
    vm.addMovementItem = addMovementItem;
    vm.addToExistingItem = addToExistingItem;
    vm.addToExistingBagAndTag = addToExistingBagAndTag;
    vm.addBagAndTag = addBagAndTag;
    vm.getBagAndTagItemsAndGroups = getBagAndTagItemsAndGroups;
    vm.removeItem = removeItem;
    vm.removeBagAndTagItem = removeBagAndTagItem;
    vm.showValidationErrors = showValidationErrors;
    vm.addContainer = addContainer;
    vm.updateItems = updateItems;
    vm.fakeLineItems = fakeLineItems;
    vm.saveUpdatedManifestType = saveUpdatedManifestType;

    vm.addIssueItems = addIssueItems;
    vm.addReturnItems = addReturnItems;
    vm.addTransferItems = addTransferItems;
    vm.addDeliveryItems = addDeliveryItems;
    vm.addPurchaseOrderItems = addPurchaseOrderItems;
    vm.addManifestItems = addManifestItems;
    vm.addMovementItems = addMovementItems;
    vm.addBagAndTagItems = addBagAndTagItems;
    

    activate();

    ////////////////////

    function activate() {
      return getManifest().then(function () {
        vm.dataHasLoaded = true;
        return getManifestTypes().then(function () {
          if (vm.manifest.manifestStatus !== "Cancelled") {
            return getManifestItems().then(function () {
              return getManifestBagAndTagItems().then(function () {
              });
            });
          }
          else {
            vm.manifestItems = [];
            vm.manifestBagAndTagItems = [];
          }
        });
      });
    }

    function completeManifest() {
      var containsAnyDualUse = $filter('filter')(vm.manifestItems, {isDualUse: true}).length;

      SweetAlert.swal({
          title: "Are you sure?",
          text: "<span class='bold-and-red'>"+(containsAnyDualUse ? containsAnyDualUse + " item(s) are identified as being Dual Use. </span><br/>":"") +"You can not edit the manifest after it is complete!",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, complete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false,
          html: true
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return manifestService.completeManifest(vm.manifestId)
            .then(function (response) {
                vm.loading = false;
                activate();
                $scope.$broadcast('manifestIsReadOnly', true);
                SweetAlert.swal("Completed!", "The manifest is now complete.", "success");
              }, function (error) {
                showValidationErrors(error);
              }
            );
        });
    }

    function cancelManifest() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "Cancelling this cancel this manifest",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ED5565",
          confirmButtonText: "Yes, cancel it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return manifestService.cancelManifest(vm.manifestId)
            .then(function (response) {
              vm.loading = false;
              activate();
              $scope.$broadcast('manifestIsReadOnly', true);
              SweetAlert.swal("Cancelled!", "The manifest is now cancelled.", "success");
            }, function (error) {
              showValidationErrors(error);
            });
        });
    }
    

    function saveUpdatedManifestType() {
      vm.savingManifestType = true;
      manifestService.updateManifestType(vm.manifestId, vm.manifest.manifestTypeId)
        .then(function (response) {
          vm.manifest.manifestType = response.manifestType;
          vm.manifest.number = response.number;
          vm.savingManifestType = false;
          vm.showTypeDropDown = false;
        });
    }

    function getManifest() {
      return manifestService.getManifest(vm.manifestId)
        .then(function (response) {
          vm.manifest = response;
          return vm.manifest;
        });
    }

    function getManifestItems() {
      return manifestService.getManifestItems(vm.manifestId)
        .then(function (response) {
          vm.manifestItems = response;
        });
    }

    function getManifestTypes() {
      return manifestService.getManifestTypes()
        .then(function (response) {
          vm.manifestTypes = response;
        });
    }

    function getManifestBagAndTagItems() {
      return manifestService.getManifestBagAndTagItems(vm.manifestId)
        .then(function (response) {
          vm.manifestBagAndTagItems = response;
        });
    }

    function addManifestItem(item, isMultiSelect) {
      var manifestItem = angular.copy(item);

      manifestItem.refDoc = item.manifestNumber === null ? '' : item.manifestNumber;

      if (item.code != SETTINGS.projectCode)
        manifestItem.refDoc = manifestItem.refDoc + ' (' + item.code + ')';

      if (isMultiSelect) {
        var item = createManifestItemDto(manifestItem);
        vm.selectedItems.push(item);
        return;
      }

      addItem(manifestItem);
    }

    function addStockItem(item, isMultiSelect) {
      var stockItem = angular.copy(item);

      stockItem.refDoc = item.documentNumber === null ? '' : item.documentNumber;

      if (isMultiSelect) {
        var item = createManifestItemDto(stockItem);
        vm.selectedItems.push(item);
        return;
      }

      addItem(stockItem);
    }

    function addMovementItem(item, isMultiSelect) {
      var movementItem = angular.copy(item);

      movementItem.refDoc = item.movementNumber === null ? '' : item.movementNumber;
      movementItem.selectedQuantity = item.requestedQuantity;

      if (isMultiSelect) {
        var item = createManifestItemDto(movementItem);
        vm.selectedItems.push(item);
        return;
      }

      addItem(movementItem);
    }

    function addItem(item) {
      if (!isValidQuantity(item)) {
        SweetAlert.swal("Invalid Quantity!", "Unable to add the selected quantity as the total would exceed the original quantity of " + item.quantity + " for this item.", "error");
        return;
      }

      if(item.isDualUse) {
        SweetAlert.swal({
            title: "Are you sure?",
            text: "You are about to add an item to the manifest that have been identified as being Dual Use. Click 'Confirm' to continue.",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1ab394",
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            closeOnConfirm: true
          },
          function (isConfirm) {
            if (!isConfirm) return;
            addTheItem(item)
          });
      }
      else {
        addTheItem(item);
      }
    }

    function addTheItem(item)
    {
      var itemToAdd = createManifestItemDto(item);
      return manifestService.addItemToManifest(vm.manifestId, itemToAdd)
        .then(function (response) {
          item.selectedQuantity = "";
          itemToAdd.id = response.id;
          fakeManifestItem(itemToAdd);
        });
    }

    function isValidQuantity(item) {
      for (var i = 0; i < vm.manifestItems.length; i++) {
        if (
            vm.manifestItems[i].description === item.description &&
            isComparison(vm.manifestItems[i].costCode, item.costCode) &&
            isComparison(vm.manifestItems[i].barcode, item.barcode) &&
            vm.manifestItems[i].purchaseOrderNumber === item.poNumber &&
            vm.manifestItems[i].purchaseOrderLineNumber == item.poLineNumber.toString() &&
            vm.manifestItems[i].refDoc === (item.manifestNumber === undefined ? item.documentNumber : item.manifestNumber)
        ) {
          var existingQuantity = vm.manifestItems[i].quantity;
          if (parseFloat(existingQuantity) + parseFloat(item.selectedQuantity) > parseFloat(item.quantity)) return false;
        }
      }
      return true;
    }

    function fakeManifestItem(item) {
      if (!addToExistingItem(item)) {
        vm.manifestItems.push(angular.copy(item));
        vm.tabs.storedItemsActive = true;
      }
    }

    function fakeManifestBagAndTagItem(item) {
      if (!addToExistingBagAndTagItem(item)) {
        vm.manifestBagAndTagItems.push(angular.copy(item));
        vm.tabs.bagAndTagsActive = true;
      }
    }

    function getBagAndTagItemsAndGroups(item) {
      return  bagAndTagService.getBagAndTagItemsAndGroups(item.id)
      .then(function (response) {
        vm.bagAndTagsResult = response;
        vm.bagAndTagsResult = $filter('filter')(vm.bagAndTagsResult, {isContainer: false});
        var bagAndTagItems = $filter('filter')(vm.bagAndTagsResult, {storedItemParentId: null});
        if(bagAndTagItems.length > 0)
        vm.bagAndTagsResult = bagAndTagItems;
        return vm.bagAndTagsResult;
      });
    }

    function addBagAndTag(item, isMultiSelect) {
      var bagAndTagNumber = item.number;
      var refDoc = item.documentNumber;
      return bagAndTagService.getManifestBagAndTagWorkpackNumbers(item.id).then(function (response) {
        var bagAndTagWorkpackNumbers = response;

        return getBagAndTagItemsAndGroups(item).then(function () {
          angular.forEach(vm.bagAndTagsResult, function(bagAndTags) {
            angular.forEach(bagAndTagWorkpackNumbers, function(bagAndTagWorkpackNumbers) {
              if (bagAndTags.bagAndTagId === bagAndTagWorkpackNumbers.bagAndTagId && bagAndTags.poNumber === bagAndTagWorkpackNumbers.poNumber && bagAndTags.poLineNumber == bagAndTagWorkpackNumbers.poLineNumber) {
                if(bagAndTagWorkpackNumbers.issueWorkpackNumber != null)
                  bagAndTags.workpack = bagAndTagWorkpackNumbers.issueWorkpackNumber
                else if(bagAndTagWorkpackNumbers.bagAndTagWorkpackNumber != null)
                  bagAndTags.workpack = bagAndTagWorkpackNumbers.bagAndTagWorkpackNumber
                else
                  bagAndTags.workpack = bagAndTagWorkpackNumbers.purchaseOrderWorkPackNumber
              }
          });
      });

        angular.forEach(vm.bagAndTagsResult, function (item) {
          var item = createManifestBagAndTagDto(item,bagAndTagNumber,refDoc);
          vm.selectedBagAndTags.push(item);
         });

          if (vm.selectedBagAndTags.length > 0) {
            var items = {
              id: vm.manifestId,
              manifestItems: vm.selectedBagAndTags
            };

            if(isMultiSelect == true)
              vm.selectedBagAndTags= [];

          return manifestService.addItemsToManifest(items).then(function (response) {
              angular.forEach(items.manifestItems, function (item) {
                fakeManifestBagAndTagItem(item);
                vm.selectedBagAndTags = [];
              });
            });
          }
        });
      });
    }

    function createManifestItemDto(item) {
      var itemToAdd = {
        addDate: item.addDate,
        sweuValue: item.sweuValue,
        boxNumber: item.boxNumber,
        description: item.description,
        costCode: item.costCode,
        materialCode: item.materialCode,
        barcode: item.barcode == null ? '' : item.barcode,
        unitOfMeasureCode: item.unitOfMeasureCode,
        purchaseOrderNumber: item.poNumber,
        purchaseOrderLineNumber: item.poLineNumber,
        purchaseOrderLineId: item.purchaseOrderLineId,
        isDualUse: item.isDualUse,
        refDoc: item.refDoc == null ? '' : item.refDoc,
        container: item.container == null ? '' : item.container,
        workpack: item.workpack == null ? '' : item.workpack,
        unloadingPoint: item.unloadingPoint == null ? '' : item.unloadingPoint,
        price: item.price == null ? '' : item.price,
        quantity: item.selectedQuantity,
        commodityCode: (item.hsCommodityCode == null ? item.commodityCode: item.hsCommodityCode),
        origin: item.origin,
        customsStatus: item.customsStatus == null ? 'FCG': item.customsStatus,
        fcgValue: parseFloat(item.price).toFixed(2) * parseFloat(item.selectedQuantity).toFixed(2)
      };

      return itemToAdd;
    }

    function createManifestBagAndTagDto(item,bagAndTagNumber,refDoc) {
        var itemToAdd = {
          addDate: null,
          sweuValue: null,
          boxNumber: null,
          description: item.description,
          costCode: item.costCode,
          materialCode: item.materialCode,
          barcode: item.barcode === null ? '' : item.barcode,
          unitOfMeasureCode: item.unitOfMeasureCode,
          purchaseOrderNumber: item.poNumber,
          purchaseOrderLineNumber: item.poLineNumber,
          refDoc: refDoc,
          container: null,
          workpack: item.workpack === null ? '' : item.workpack,
          unloadingPoint: item.unloadingPoint === null ? '' : item.unloadingPoint,
          price:  null ,
          quantity: item.selectedQuantity,
          commodityCode: (item.hsCommodityCode == null ? item.commodityCode: item.hsCommodityCode),
          origin: item.origin,
          customsStatus: item.customsStatus == null ? 'FCG': item.customsStatus,
          fcgValue: null,
          bagAndTagNumber : bagAndTagNumber
        };

        return itemToAdd;
      }


    function addToExistingItem(item) {
      for (var i = 0; i < vm.manifestItems.length; i++) {
        if (
            vm.manifestItems[i].description === item.description &&
            isComparison(vm.manifestItems[i].costCode, item.costCode) &&
            isComparison(vm.manifestItems[i].barcode, item.barcode) &&
            vm.manifestItems[i].purchaseOrderNumber === item.purchaseOrderNumber &&
            vm.manifestItems[i].purchaseOrderLineNumber == item.purchaseOrderLineNumber &&
            vm.manifestItems[i].refDoc === item.refDoc
        ) {
          vm.manifestItems[i].quantity = parseFloat(vm.manifestItems[i].quantity) + parseFloat(item.quantity);
          vm.manifestItems[i].class = "backgroundAnimated";
          $timeout(function () {
            vm.manifestItems[i].class = "";
          }, 1000);
          return true;
        }
      }
    }

    function addToExistingBagAndTagItem(item) {
      for (var i = 0; i < vm.manifestBagAndTagItems.length; i++) {
        if (
            vm.manifestBagAndTagItems[i].description === item.description &&
            isComparison(vm.manifestBagAndTagItems[i].costCode, item.costCode) &&
            isComparison(vm.manifestBagAndTagItems[i].barcode, item.barcode) &&
            vm.manifestBagAndTagItems[i].purchaseOrderNumber === item.purchaseOrderNumber &&
            vm.manifestBagAndTagItems[i].purchaseOrderLineNumber == item.purchaseOrderLineNumber &&
            vm.manifestBagAndTagItems[i].refDoc === item.refDoc
        ) {
          vm.manifestBagAndTagItems[i].quantity = parseFloat(vm.manifestBagAndTagItems[i].quantity) + parseFloat(item.quantity);
          vm.manifestBagAndTagItems[i].class = "backgroundAnimated";
          $timeout(function () {
            vm.manifestBagAndTagItems[i].class = "";
          }, 1000);
          return true;
        }
      }
    }

    function isComparison(manifestItem, selectedItem) {
      if (manifestItem === undefined || manifestItem === null || manifestItem === "")
        manifestItem = null;
      if (selectedItem === undefined || selectedItem === null || selectedItem === "")
        selectedItem = null;
      if (manifestItem === selectedItem) return true;
      return false;
    }

    function addToExistingBagAndTag(item) {
      for (var i = 0; i < vm.manifestBagAndTagItems.length; i++) {
        if (vm.manifestBagAndTagItems[i].bagAndTagId === item.bagAndTagId) {
          vm.manifestBagAndTagItems[i].class = "backgroundAnimated";
          $timeout(function () {
            vm.manifestBagAndTagItems[i].class = "";
          }, 1000);
          return true;
        }
      }
    }

    function addSelectedItems() {
      if (vm.selectedItems.length > 0) {

        var items = {
          id: vm.manifestId,
          manifestItems: vm.selectedItems
        };

        return manifestService.addItemsToManifest(items).then(function (response) {
          angular.forEach(items.manifestItems, function (item) {
            fakeManifestItem(item);
            vm.selectedItems = [];
          });
        });
      }
    }

    function addSelectedBagAndTags() {
      if (vm.selectedBagAndTags.length > 0) {

        var items = {
          bagAndTags: vm.selectedBagAndTags
        };

        return manifestService.addBagAndTagsToManifest(vm.manifestId, items).then(function (response) {
          angular.forEach(items.bagAndTags, function (item) {
            vm.manifestBagAndTagItems.push(item);
            vm.selectedBagAndTags = [];
            vm.tabs.bagAndTagsActive = true;
          });
        });
      }
    }

    function removeItem(item) {

     if(item.bagAndTagNumber == null || item.bagAndTagNumber == undefined)
     {
        var index = vm.manifestItems.indexOf(item);
        vm.manifestItems.splice(index, 1);
     }
      else
     {
        var index = vm.manifestBagAndTagItems.indexOf(item);
        vm.manifestBagAndTagItems.splice(index,1);
     }

      var itemToRemove = {
        id: item.id,
      };

      return manifestService.removeItemFromManifest(vm.manifestId, itemToRemove)
        .then(function (response) {
          SweetAlert.swal("Item removed!", "Item removed from manifest.", "success");
        }, function (error) {
          showValidationErrors(error);
        });
    }

    function removeBagAndTagItem(item) {
      var itemToRemove = {
        bagAndTagId: item.bagAndTagId
      };

      var index = vm.manifestBagAndTagItems.indexOf(item);
      vm.manifestBagAndTagItems.splice(index, 1);

      return manifestService.removeBagAndTagItemFromManifest(vm.manifestId, itemToRemove)
        .then(function (response) {
          SweetAlert.swal("Item removed!", "Bag & tag item removed from manifest.", "success");
        }, function (error) {
          showValidationErrors(error);
        });
    }

    function addContainer(items) {
      $uibModal.open({
        templateUrl: 'app/manifests/addContainerModal.html',
        controller: 'AddContainerModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          items: function () {
            return items;
          },
          updateItems: function () {
            return vm.updateItems;
          }
        }
      });
    }

    function fakeLineItems(itemToAdd) {
      if (!addToExistingItem(itemToAdd)) {
        vm.manifestItems.push(angular.copy(itemToAdd));
        vm.tabs.storedItemsActive = true;
      }
    }

    function updateItems(itemsToUpdate, container) {

      var items = {
        container: container,
        manifestRows: itemsToUpdate
      };

      var result = manifestService.addContainer(vm.manifestId, items);

      var selectedItems = $filter('filter')(vm.manifestItems, {isIncluded: true});
      angular.forEach(selectedItems, function(item){
        item.isIncluded = false;
      });

      return result;
    }

    function addIssueItems() {
      var selectedItems = $filter('filter')(vm.results.issues, {isIncluded: true});
      addItems("issueItems", selectedItems);
    }

    function addReturnItems() {
      var selectedItems = $filter('filter')(vm.results.returns, {isIncluded: true});
      addItems("returnItems", selectedItems);
    }

    function addTransferItems() {
      var selectedItems = $filter('filter')(vm.results.transfers, {isIncluded: true});
      addItems("transferItems", selectedItems);
    }

    function addDeliveryItems() {
      var selectedItems = $filter('filter')(vm.results.deliveries, {isIncluded: true});
      addItems("deliveryItems", selectedItems);
    }

    function addPurchaseOrderItems() {
      var selectedItems = $filter('filter')(vm.results.purchaseOrders, {isIncluded: true});
      addItems("purchaseOrderItems", selectedItems);
    }

    function addManifestItems() {
      var selectedItems = $filter('filter')(vm.manifestResults, {isIncluded: true});
      addItems("manifestItems", selectedItems);
    }

    function addMovementItems() {
      var selectedItems = $filter('filter')(vm.movementResults, {isIncluded: true});
      addItems("movementItems", selectedItems);
    }

    function addBagAndTagItems() {
      var selectedItems = $filter('filter')(vm.bagAndTagResults, {isIncluded: true});
      addItems("bagAndTagItems", selectedItems);
    }

    function addItems(itemType, selectedItems) {
      var containsAnyDualUse = $filter('filter')(selectedItems, {isDualUse: true}).length;

      SweetAlert.swal({
          title: "Are you sure?",
          text: "You are about to add " + selectedItems.length + " item(s) to the manifest. "+ (containsAnyDualUse? "<br /><span class='bold-and-red'>"+containsAnyDualUse + " item(s) are identified as being Dual Use. </span><br />":"") +" Click 'Confirm' to continue.",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          closeOnConfirm: false,
        html:true
        },
        function (isConfirm) {
          if (!isConfirm) return;

          var addItems = true;

          switch (itemType) {
            case 'issueItems':
            case 'returnItems':
            case 'transferItems':
            case 'deliveryItems':
            case 'purchaseOrderItems':
              angular.forEach(selectedItems, function (item) {
                if (!isValidQuantity(item)) {
                  addItems = notifyOfInvalidQuantity();
                } else {
                  addStockItem(item, true);
                }
              });
              break;
            case 'manifestItems':
              angular.forEach(selectedItems, function (item) {
                if (!isValidQuantity(item)) {
                  addItems = notifyOfInvalidQuantity();
                } else {
                  addManifestItem(item, true);
                }
              });
              break;
            case 'movementItems':
              angular.forEach(selectedItems, function (item) {
                if (!isValidQuantity(item)) {
                  addItems = notifyOfInvalidQuantity();
                } else {
                  addMovementItem(item, true);
                }
              });
              break;
            case 'bagAndTagItems':
              angular.forEach(selectedItems, function (item) {
                addBagAndTag(item, true);
              });
              break;
          }

          if (addItems) {
            addSelectedItems();
            addSelectedBagAndTags();

            SweetAlert.swal("Complete!", "The items were added successfully.", "success");
          }
        });
    }
 

    function reopenManifest() {
      SweetAlert.swal({
        title: "Are you sure?",
        text: "This will reopen the manifest for editing.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, reopen it!",
        cancelButtonText: "Cancel",
        closeOnConfirm: false
      }, function (isConfirm) {
        if (!isConfirm) return;

        vm.loading = true;

        return manifestService.reopenManifest(vm.manifest.id)
          .then(function (response) {
          vm.loading = false;
          activate();
          $scope.$broadcast('manifestIsReadOnly', false);
          SweetAlert.swal("Reopened!", "The manifest has been reopened.", "success");
        }, function (error) {
          vm.loading = false;
          showValidationErrors(error);
        });
      });
    }
 
 

    function notifyOfInvalidQuantity() {
      SweetAlert.swal("Invalid Quantity!", "One or more of the selected items has a quantity that exceeds the original quantity for that item.", "error");
      return false;
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not search for stored items.');
      }
      vm.loading = false;
    }

    $scope.$on('upload-complete', function (event, args) {
      getManifestItems();
    });

    /** Manifest Types */

    vm.types = {
      transport: {
        read: {
          url: API.BASE_URI_SHIPPING + SETTINGS.projectCode + "/manifests/types",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.typeOptions = {
      placeholder: "Select a type",
      dataSource: vm.types,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.manifests')
    .directive('wgStoredItemManifest', wgStoredItemManifest);

  wgStoredItemManifest.$inject = [];

  /* @ngInject */
  function wgStoredItemManifest() {
    var directive = {
      bindToController: true,
      controller: StoredItemManifestDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/manifests/storedItemManifest.html",
      scope: {
        item: '=',
        delivery: '=',
        return: '=',
        purchaseOrder: '=',
        manifest: '=',
        highlight: '=',
        isReturn: '=',
        addItem: '&'
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  StoredItemManifestDirCtrl.$inject = ['$scope'];

  /* @ngInject */
  function StoredItemManifestDirCtrl($scope) {
    var vm = this;
    vm.item = this.item;
    vm.delivery = this.delivery;
    vm.purchaseOrder = this.purchaseOrder;
    vm.manifest = this.manifest;
    vm.highlight = this.highlight;
    vm.isReturn = this.isReturn;
    vm.return = this.return;

    vm.loading = false;
    vm.validationErrors = false;
    vm.addItem = this.addItem;
    vm.showValidationErrors = showValidationErrors;

    activate();

    ////////////////////////

    function activate() {

    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.manifests')
    .directive('wgShippingDetails', wgShippingDetails);

  wgShippingDetails.$inject = [];

  /* @ngInject */
  function wgShippingDetails() {
    var directive = {
      bindToController: true,
      controller: ShippingDetailsCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/manifests/shippingDetails.html",
      scope: {
        manifest: '='
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }


  ShippingDetailsCtrl.$inject = ['$scope', 'manifestService', 'projectService', 'adminService', '$stateParams', 'SweetAlert', 'API', 'SETTINGS','OidcManager'];

  /* @ngInject */
  function ShippingDetailsCtrl($scope, manifestService, projectService, adminService, $stateParams, SweetAlert, API, SETTINGS, OidcManager) {

    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.manifest = this.manifest;
    vm.manifestId = vm.manifest.id;

    vm.loading = false;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    vm.agentsOptions = [];
    vm.transportTypesOptions = [];
    vm.soldToPartyOptions = [];
    vm.shipToDestinationOptions = [];
    vm.currencyOptions = [];
    vm.freightOptions = [];
    vm.shippingNotesOptions = [];

    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;
    vm.saveShippingDetails = saveShippingDetails;
    vm.appendShippingNotes = appendShippingNotes;
    vm.getProjectCode = getProjectCode;

    activate();

    ////////////////

    function activate() {
        if(Date.parse(vm.manifest.shipDate))
          vm.manifest.shipDate = new Date(vm.manifest.shipDate);

        if(Date.parse(vm.manifest.etaDate))
          vm.manifest.etaDate = new Date(vm.manifest.etaDate);

        if(Date.parse(vm.manifest.receiptDate))
          vm.manifest.receiptDate = new Date(vm.manifest.receiptDate);

        if(vm.manifest.shippingNotes.notes == null){
          vm.manifest.shippingNotes.notes = '';
        }
        return getProjectCode().then(function () {
        });
    }


    function getProjectCode() {
      return projectService.getProjectByCode()
        .then(function (response) {
          vm.manifest.currency = response.currencyCode;
        });
    }

    function saveShippingDetails() {
      vm.loading = true;

      var dataToSave = {
        shipDate:vm.manifest.shipDate,
        etaDate:vm.manifest.etaDate,
        receiptDate:vm.manifest.receiptDate,
        estimatedShipDays:vm.manifest.estimatedShipDays,
        transportTypeId:vm.manifest.transportTypeId,
        agentId:vm.manifest.agentId,
        soldToPartyId:vm.manifest.soldToPartyId,
        shipToDestinationId:vm.manifest.shipToDestinationId,
        currencyId:vm.manifest.currencyId,
        vessel:vm.manifest.vessel === null ? '' : vm.manifest.vessel,
        shippingNotes:vm.manifest.shippingNotes.notes,
        freightOriginator:vm.manifest.freightOriginator
      };

      return manifestService.saveShippingDetails(vm.manifestId, dataToSave)
        .then(function(response) {
          vm.loading = false;
          SweetAlert.swal("Saved!", "Successfully saved shipping details.", "success");
        },function(error){
          vm.hasErrors = true;
          showValidationErrors(error);
        });
    }

    function appendShippingNotes() {
      vm.manifest.shippingNotes.notes += vm.shippingNotes.notes + '\r\r';
    }


    /** Agents */

    vm.agents = {
      transport: {
        read: function (options) {
          var data = {
            type: 'agent'
          };
          return manifestService.getReferenceData(data)
            .then(function (response) {
              var data = response;

              options.success(data);
            });
        },
        dataType: "json"
      }
    };

    vm.agentsOptions = {
      placeholder: "Select agent",
      dataSource: vm.agents,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autobind: false
    };

    /** Ship to destination */

    vm.shipToDestination = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      serverSorting: true,
      sort: { field: "address1", dir: "asc" },
      transport: {
        read: {
          url: API.BASE_URI_SHIPPING + "odata/Addresses",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      }
  };

    vm.shipToDestinationOptions = {
      placeholder: "Select ship to destination",
      dataSource: vm.shipToDestination,
      dataTextField: "address1",
      dataValueField: "id",
      filter: "contains",
      filtering: function(ev) {
        var filterValue = ev.filter != undefined ? ev.filter.value : '';
        ev.preventDefault();

        this.dataSource.filter({
          logic: "or",
          filters: [
            {
              field: "address1",
              operator: "contains",
              value: filterValue
            },
            {
              field: "address2",
              operator: "contains",
              value: filterValue
            },
            {
              field: "address3",
              operator: "contains",
              value: filterValue
            },
            {
              field: "address4",
              operator: "contains",
              value: filterValue
            }
          ]
        });
      },
      virtual: {
        itemHeight: 30,
        mapValueTo: "dataItem",
        valueMapper: function(options) {
          $.ajax({
            url: API.BASE_URI_SHIPPING + "odata/Addresses("+options.value+")?format=json",
            type: "GET",
            data: '',
            success: function (data) {
              options.success(data);
            },
            beforeSend: function(xhr) {
              xhr.setRequestHeader('Authorization', vm.bearerToken)
            }
          })
        }
      },
      autoBind: false,
      template: '<span class="k-state-default">#: address1 # - #: address2 # - #: address3 # - #: address4 #</span>'
    };

    /** Transport types */

    vm.transportTypes = {
      transport: {
        read: function (options) {
          var data = {
            type: 'transportType'
          };
          return manifestService.getReferenceData(data)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        },
        dataType: "json"
      }
    };

    vm.transportTypesOptions = {
      placeholder: "Select transport type",
      dataSource: vm.transportTypes,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autobind: false
    };

    /** Sold to party */

    vm.soldToParty = {
      transport: {
        read: function (options) {
          var data = {
            type: 'soldToParty'
          };
          return manifestService.getReferenceData(data)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        },
        dataType: "json"
      }
    };

    vm.soldToPartyOptions = {
      placeholder: "Select sold to party",
      dataSource: vm.soldToParty,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autobind: false
    };

    /** Currency */

    vm.currency = {
      transport: {
        read: function (options) {
          var data = {
            type: 'currency'
          };
          return manifestService.getReferenceData(data)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        },
        dataType: "json"
      }
    };

    vm.currencyOptions = {
      placeholder: "Select currency",
      dataSource: vm.currency,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autobind: false
    };

    /** Shipping Notes */

    vm.shippingNotes = {
      transport: {
        read: function (options) {
          return manifestService.getShippingNotes()
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        },
        dataType: "json"
      }
    };

    vm.shippingNotesOptions = {
      placeholder: "Select shipping notes",
      dataSource: vm.shippingNotes,
      dataTextField: "title",
      dataValueField: "title",
      filter: "contains",
      autobind: false
    };

    /** Freight */

    vm.freight = {
      transport: {
        read: function (options) {
          return adminService.getUsersForProject()
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        },
        dataType: "json"
      }
    };

    vm.freightOptions = {
      placeholder: "Select freight originator",
      dataSource: vm.freight,
      dataTextField: "fullName",
      dataValueField: "fullName",
      filter: "contains",
      autobind: false
    };

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not update shipping details.');
      }
      vm.loading = false;
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.manifests')
    .directive('wgShippingAddress', wgShippingAddress);

  wgShippingAddress.$inject = [];

  /* @ngInject */
  function wgShippingAddress() {
    var directive = {
      bindToController: true,
      controller: ShippingAddressCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/manifests/shippingAddress.html",
      scope: {
        manifest: '='
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  ShippingAddressCtrl.$inject = ['$scope', 'manifestService', '$stateParams', 'SweetAlert', 'API', 'OidcManager'];

  /* @ngInject */
  function ShippingAddressCtrl($scope, manifestService, $stateParams, SweetAlert, API, OidcManager) {

    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;
    vm.manifest = this.manifest;
    vm.manifestId = vm.manifest.id;

    vm.loading = false;

    vm.shipFromAddressOptions = [];
    vm.deliverToAddressOptions = [];

    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;
    vm.saveShippingAddress = saveShippingAddress;

    activate();

    ////////////////

    function activate() {
    }


    function saveShippingAddress() {
      vm.loading = true;

      var dataToSave = {
        shipFromAddress1:vm.manifest.shipFromAddress.address1,
        shipFromAddress2:vm.manifest.shipFromAddress.address2,
        shipFromAddress3:vm.manifest.shipFromAddress.address3,
        shipFromAddress4:vm.manifest.shipFromAddress.address4,
        shipFromPostCode:vm.manifest.shipFromAddress.postCode,
        shipFromTelephoneNo:vm.manifest.shipFromAddress.telephoneNo,
        shipFromFaxNo:vm.manifest.shipFromAddress.faxNo,
        shipFromVatNo:vm.manifest.shipFromAddress.vatNo,
        shipFromVatDefNo:vm.manifest.shipFromAddress.vatDefNo,
        shipFromCountry:vm.manifest.shipFromAddress.country,
        shipFromSweuNo:vm.manifest.shipFromAddress.sweuNo,
        shipFromExportLicence:vm.manifest.shipFromAddress.exportLicence,

        deliverToAddress1:vm.manifest.deliverToAddress.address1,
        deliverToAddress2:vm.manifest.deliverToAddress.address2,
        deliverToAddress3:vm.manifest.deliverToAddress.address3,
        deliverToAddress4:vm.manifest.deliverToAddress.address4,
        deliverToPostCode:vm.manifest.deliverToAddress.postCode,
        deliverToTelephoneNo:vm.manifest.deliverToAddress.telephoneNo,
        deliverToFaxNo:vm.manifest.deliverToAddress.faxNo,
        deliverToVatNo:vm.manifest.deliverToAddress.vatNo,
        deliverToVatDefNo:vm.manifest.deliverToAddress.vatDefNo,
        deliverTocountry:vm.manifest.deliverToAddress.country,
        deliverToSweuNo:vm.manifest.deliverToAddress.sweuNo,
        deliverToExportLicence:vm.manifest.deliverToAddress.exportLicence,

        fao: vm.manifest.fao
      };


      return manifestService.saveShippingAddress(vm.manifestId, dataToSave)
        .then(function(response) {
          vm.loading = false;
          SweetAlert.swal("Saved!", "Successfully saved shipping address.", "success");
        },function(error){
          vm.hasErrors = true;
          showValidationErrors(error);
        });
    }


    /** Addresses */

    vm.address = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      serverSorting: true,
      sort: { field: "address1", dir: "asc" },
      transport: {
        read: {
          url: API.BASE_URI_SHIPPING + "odata/Addresses",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      }
    };

    vm.shipFromAddressOptions = {
      placeholder: "Select ship from address",
      dataSource: vm.address,
      dataTextField: "address1",
      dataValueField: "address1",
      filter: "contains",
      filtering: function(ev) {
        var filterValue = ev.filter != undefined ? ev.filter.value : '';
        ev.preventDefault();

        this.dataSource.filter({
          logic: "or",
          filters: [
            {
              field: "address1",
              operator: "contains",
              value: filterValue
            },
            {
              field: "address2",
              operator: "contains",
              value: filterValue
            },
            {
              field: "address3",
              operator: "contains",
              value: filterValue
            },
            {
              field: "address4",
              operator: "contains",
              value: filterValue
            }
          ]
        });
      },
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      template: '<span class="k-state-default">#: address1 # - #: address2 # - #: address3 # - #: address4 #</span>'
    };

    vm.deliverToAddressOptions = {
      placeholder: "Select deliver to address",
      dataSource: vm.address,
      dataTextField: "address1",
      dataValueField: "address1",
      filter: "contains",
      filtering: function(ev) {
        var filterValue = ev.filter != undefined ? ev.filter.value : '';
        ev.preventDefault();

        this.dataSource.filter({
          logic: "or",
          filters: [
            {
              field: "address1",
              operator: "contains",
              value: filterValue
            },
            {
              field: "address2",
              operator: "contains",
              value: filterValue
            },
            {
              field: "address3",
              operator: "contains",
              value: filterValue
            },
            {
              field: "address4",
              operator: "contains",
              value: filterValue
            }
          ]
        });
      },
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      template: '<span class="k-state-default">#: address1 # - #: address2 # - #: address3 #- #: address4 #</span>'
    };

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not record delivery.');
      }
      vm.loading = false;
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.manifests')
    .directive('wgSearchCriteriaManifest', wgSearchCriteriaManifest);

  wgSearchCriteriaManifest.$inject = [];

  /* @ngInject */
  function wgSearchCriteriaManifest() {
    var directive = {
      bindToController: true,
      controller: SearchCriteriaManifestCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        results: '=',
        bagAndTagResults: '=',
        manifestResults: '=',
        movementResults: '=',
        disableBagAndTag: '@',
        filter: '=',
        tabs: '='
      },
      templateUrl: 'app/manifests/searchCriteriaManifest.html'
    };

    return directive;

    function link(scope, element, attrs) {
      if (scope.results !== undefined) scope.results = this.results;
      if (scope.bagAndTagResults !== undefined) scope.bagAndTagResults = this.bagAndTagResults;
      if (scope.manifestResults !== undefined) scope.manifestResults = this.manifestResults;
      if (scope.movementResults !== undefined) scope.movementResults = this.movementResults;
    }

  }

  SearchCriteriaManifestCtrl.$inject = ['$filter','stockService', 'bagAndTagService', 'manifestService', 'movementService', 'OidcManager', 'API', 'SETTINGS'];

  /* @ngInject */
  function SearchCriteriaManifestCtrl($filter, stockService, bagAndTagService, manifestService, movementService, OidcManager, API, SETTINGS) {
    var vm = this;
    vm.results = this.results;
    vm.bagAndTagResults = this.bagAndTagResults;
    vm.manifestResults = this.manifestResults;
    vm.movementResults = this.movementResults;
    var filter = this.filter;
    var tabs = this.tabs;

    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.disableBagAndTag = this.disableBagAndTag;

    /** Purchase Orders */
    vm.purchaseOrders = [];
    vm.purchaseOrdersOptions = [];
    vm.purchaseOrdersSelected = [];

    /** Material Codes */
    vm.materialCodes = [];
    vm.materialCodesOptions = [];
    vm.materialCodesSelected = [];

    /** Cost Codes */
    vm.codeCodes = [];
    vm.costCodesOptions = [];
    vm.costCodesSelected = [];

    /** Barcodes */
    vm.barcodes = [];
    vm.barcodesOptions = [];
    vm.barcodesSelected = [];

    /** Manifests */
    vm.manifests = [];
    vm.manifestsOptions = [];
    vm.manifestsSelected = [];

    /** Bag and Tag numbers */
    vm.bagAndTagNumbers = [];
    vm.bagAndTagNumbersOptions = [];
    vm.bagAndTagNumbersSelected = [];

    /** Bag and Tag Workpack numbers */
    vm.workpackNumbers = [];
    vm.workpackNumbersOptions = [];
    vm.workpackNumbersSelected = [];

    /** Issues */
    vm.issues = [];
    vm.issuesOptions = [];
    vm.issuesSelected = [];

    /** Returns */
    vm.returns = [];
    vm.returnsOptions = [];
    vm.returnsSelected = [];

    /** Transfers */
    vm.transfers = [];
    vm.transfersOptions = [];
    vm.transfersSelected = [];

    /** Deliveries */
    vm.deliveries = [];
    vm.deliveriesOptions = [];
    vm.deliveriesSelected = [];

    /** Movements */
    vm.movements = [];
    vm.movementsOptions = [];
    vm.movementsSelected = [];

    vm.filter = "";


    vm.doSearch = doSearch;
    vm.resetForm = resetForm;
    vm.resetResults = resetResults;
    vm.setActiveTab = setActiveTab;
    vm.resetTabs = resetTabs;

    activate();

    /////////////////

    function activate() {

    }

    function doSearch() {
      vm.searching = true;

      return searchStoredItems().then(function () {
        return searchBagAndTagHeaders().then(function () {
          return searchMovements().then(function () {
          return searchManifests().then(function () {
            if (tabs !== undefined) {
              vm.setActiveTab();
            }
            vm.searching = false;
            filter = vm.filter;
          });
        });
      });
     });
    }

    function searchStoredItems() {
      vm.resetResults();
      return stockService.searchStockItemsManifest(vm.purchaseOrdersSelected, vm.materialCodesSelected, vm.costCodesSelected, vm.barcodesSelected,
        vm.issuesSelected, vm.transfersSelected, vm.deliveriesSelected, vm.returnsSelected, vm.filter).then(function (data) {
        vm.results = data;
      });
    }

    function searchBagAndTagHeaders() {
      return bagAndTagService.searchBagAndTagHeadersManifest(vm.bagAndTagNumbersSelected, vm.workpackNumbersSelected, vm.issuesSelected, vm.returnsSelected, vm.transfersSelected,
        vm.purchaseOrdersSelected, vm.materialCodesSelected, vm.costCodesSelected, vm.barcodesSelected, vm.filter).then(function (data) {
        vm.bagAndTagResults = data;
      });
    }

    function searchManifests() {
      return manifestService.searchManifestRows(vm.purchaseOrdersSelected, vm.materialCodesSelected, vm.costCodesSelected, vm.barcodesSelected,
        vm.manifestsSelected, vm.filter).then(function (data) {
        vm.manifestResults = data;
      });
    }

    function searchMovements() {
      return movementService.searchMovementItems(vm.movementsSelected, vm.filter).then(function (data) {
        vm.movementResults = data;
      });
    }

    function resetForm() {
      vm.purchaseOrdersSelected = [];
      vm.materialCodesSelected = [];
      vm.costCodesSelected = [];
      vm.barcodesSelected = [];
      vm.manifestsSelected = [];
      vm.bagAndTagNumbersSelected = [];
      vm.workpackNumbersSelected = [];
      vm.issuesSelected = [];
      vm.returnsSelected = [];
      vm.transfersSelected = [];
      vm.deliveriesSelected = [];
      vm.movementsSelected = [];
      vm.filter = "";

      vm.resetTabs();
      vm.resetResults();
    }

    function resetResults(){
      vm.results = undefined;
      vm.bagAndTagResults = undefined;
      vm.manifestResults = undefined;
      vm.movementResults = undefined;
    }

    function resetTabs(){
      tabs.bagAndTagResultsActive = false;
      tabs.storedItemsResultsActive = false;
      tabs.issuesResultsActive = false;
      tabs.returnsResultsActive = false;
      tabs.transfersResultsActive = false;
      tabs.deliveriesResultsActive = false;
      tabs.purchaseOrdersResultsActive = false;
      tabs.manifestsResultsActive = false;
      tabs.movementsResultsActive = false;
    }

    function setActiveTab(){

      vm.resetTabs();

      tabs.bagAndTagResultsActive = (vm.results === undefined && vm.bagAndTagResults !== undefined);

      if(vm.results !== undefined) {
       if (vm.results.issues !== null && vm.results.issues.length){
          tabs.issuesResultsActive = true;
        }
        else if (vm.results.returns !== null && vm.results.returns.length){
          tabs.returnsResultsActive = true;
        }
        else if (vm.results.transfers !== null && vm.results.transfers.length){
          tabs.transfersResultsActive = true;
        }
        else if (vm.results.deliveries !== null && vm.results.deliveries.length){
          tabs.deliveriesResultsActive = true;
        }
        else if(vm.results.purchaseOrders !== null && vm.results.purchaseOrders.length){
          tabs.purchaseOrdersResultsActive = true;
        }
      }
      else if (vm.manifestResults !== undefined){
        tabs.manifestsResultsActive = true;
      }
      else if (vm.movementResults !== undefined){
        tabs.movementsResultsActive = true;
      }
    }

    /** Purchase Orders */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrdersOptions = {
      height: 210,
      placeholder: "(Optional)",
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "id",
      filter: "contains",
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      template: '<span class="k-state-default">#: number # - #: supplierName # - #= kendo.toString(kendo.parseDate(date), \'dd-MMM-yyyy\') #</span>'
    };

    /** Material Codes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.materialCodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      autoBind: false
    };

    /** Cost Codes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.costCodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false
    };

    /** Barcodes */

    vm.barcodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/stored-items/barcodes',
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.barcodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.barcodes,
      dataTextField: "barcode",
      dataValueField: "barcode",
      filter: "contains",
      autoBind: false
    };

    /** Bag and Tag numbers */

    vm.bagAndTagNumbers = {
      transport: {
        read: function (options) {
          return bagAndTagService.getBagAndTagNumbers(false)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        }
      }
    };

    vm.bagAndTagNumbersOptions = {
      placeholder: "(Optional)",
      dataSource: vm.bagAndTagNumbers,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      autoBind: false
    };

    /** Bag and Tag workpack numbers */

    vm.workpackNumbers = {
      transport: {
        read: function (options) {
          return bagAndTagService.getBagAndTagWorkpackNumbers(false)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        }
      }
    };

    vm.workpackNumbersOptions = {
      placeholder: "(Optional)",
      dataSource: vm.workpackNumbers,
      dataTextField: "workpackNumber",
      dataValueField: "workpackNumber",
      filter: "contains",
      autoBind: false
    };

    /** Issues */

    vm.issues = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/issues/complete",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.issuesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.issues,
      dataTextField: "number",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      template: '<span class="k-state-default">#: number # - #: description #</span>'
    };

    /** Returns */

    vm.returns = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/returns/complete",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.returnsOptions = {
      placeholder: "(Optional)",
      dataSource: vm.returns,
      dataTextField: "number",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      template: '<span class="k-state-default">#: number # - #: description #</span>'
    };


    /** Transfers */

    vm.transfers = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/transfers/complete",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.transfersOptions = {
      placeholder: "(Optional)",
      dataSource: vm.transfers,
      dataTextField: "number",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      template: '<span class="k-state-default">#: number # - #: description #</span>'
    };

    /** Deliveries */

    vm.deliveries = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/deliveries/stored",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.deliveriesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.deliveries,
      dataTextField: "number",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      template: '<span class="k-state-default">#: number #</span>'
    };

    /** Manifests */

    vm.manifests = new kendo.data.DataSource({
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_SHIPPING + "odata/ManifestHeadersOData",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    });

    vm.manifestsOptions = {
      placeholder: "(Optional)",
      dataSource: vm.manifests,
      dataTextField: "manifestNumber",
      dataValueField: "manifestNumber",
      filter: "contains",
      autoBind: false,
      virtual: {
        itemHeight: 30
      },
      template: '<span class="k-state-default">[#:code#] #:manifestNumber # </span>',
    };

    /** Movements */

    vm.movements = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/movements/complete",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.movementsOptions = {
      placeholder: "(Optional)",
      dataSource: vm.movements,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      autoBind: false,
      template: '<span class="k-state-default">#: number #</span>'

    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app.manifests')
    .directive('wgMovementItemManifest', wgMovementItemManifest);

  wgMovementItemManifest.$inject = [];

  /* @ngInject */
  function wgMovementItemManifest() {
    var directive = {
      bindToController: true,
      controller: MovementItemManifestDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/manifests/movementItemManifest.html",
      scope: {
        item: '=',
        highlight: '=',
        addItem: '&'
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  MovementItemManifestDirCtrl.$inject = ['$scope'];

  /* @ngInject */
  function MovementItemManifestDirCtrl($scope) {
    var vm = this;
    vm.item = this.item;
    vm.highlight = this.highlight;

    vm.loading = false;
    vm.validationErrors = false;
    vm.addItem = this.addItem;
    vm.showValidationErrors = showValidationErrors;

    activate();

    ////////////////////////

    function activate() {

    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app.manifests')
    .directive('wgIncludedItemManifest', wgIncludedItemManifest);

  wgIncludedItemManifest.$inject = [];

  /* @ngInject */
  function wgIncludedItemManifest() {
    var directive = {
      bindToController: true,
      controller: IncludedItemManifestDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: 'app/manifests/includedItemManifest.html',
      scope: {
        item: '=',
        isReadOnly: '=',
        removeItem: '&',
        manifestId: '='
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  IncludedItemManifestDirCtrl.$inject = ['$uibModal', 'manifestService'];

  function IncludedItemManifestDirCtrl($uibModal, manifestService) {
    var vm = this;
    vm.item = this.item;
    vm.isReadOnly = this.isReadOnly;
    vm.manifestId = this.manifestId;

    vm.loading = false;
    vm.validationErrors = false;
    vm.removeItem = this.removeItem;
    vm.showValidationErrors = showValidationErrors;
    vm.openModal = openModal;
    vm.saveItem = saveItem;
    vm.postUpdateDelegate = postUpdateDelegate;

    activate();

    ////////////////////////

    function activate() {

    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }

    function openModal() {
      $uibModal.open({
        templateUrl: 'app/manifests/addManifestLineItemModal.html',
        controller: 'AddManifestLineItemModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          manifestId: function () {
            return vm.manifestId;
          },
          postUpdateDelegate: function () {
            return vm.postUpdateDelegate;
          },
          lineItem:function(){
            return angular.copy(vm.item);
          },
          isAdd: function(){
            return false;
          },
          saveItem: function(){
            return vm.saveItem;
          },
          isReadOnly: function(){
            return vm.isReadOnly;
          }
        }
      });
    }

    function saveItem(itemToSave){
      itemToSave.manifestRowId = vm.item.id;
      return manifestService.editManifestRow(vm.manifestId, itemToSave);
    }

    function postUpdateDelegate(itemToSave){
      vm.item = itemToSave.item;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.manifests')
    .directive('wgImportItems', wgImportItems);

  wgImportItems.$inject = [];

  /* @ngInject */
  function wgImportItems() {
    var directive = {
      bindToController: true,
      controller: ImportItemsCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/manifests/importItems.html",
      scope: {
        manifest: '='
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }


  ImportItemsCtrl.$inject = ['$scope', 'API', 'SETTINGS', 'manifestService', '$stateParams', 'FileSaver', 'Blob'];

  /* @ngInject */
  function ImportItemsCtrl($scope, API, SETTINGS, manifestService, $stateParams, FileSaver, Blob) {

    var vm = this;
    vm.manifest = this.manifest;
    vm.manifestId = vm.manifest.id;

    vm.loading = false;

    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;
    vm.downloadTemplate = downloadTemplate;
    vm.getImportErrors = getImportErrors;

    vm.importEndpoint = API.BASE_URI_SHIPPING + SETTINGS.projectCode + '/manifests/' + vm.manifestId + '/upload';

    activate();

    ////////////////

    function activate() {
    }


    function downloadTemplate() {
      return manifestService.getImportTemplate()
        .then(function(response) {
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

    function getImportErrors(manifestId, documentKey){
      return manifestService.getImportErrors(manifestId, documentKey)
        .then(function(response) {
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not record delivery.');
      }
      vm.loading = false;
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.manifests')
    .directive('wgCustomsStatus', wgCustomsStatus);

  wgCustomsStatus.$inject = [];

  /* @ngInject */
  function wgCustomsStatus() {
    var directive = {
      bindToController: true,
      controller: CustomsStatusCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/manifests/customsStatus.html",
      scope: {
        manifest: '='
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }


  CustomsStatusCtrl.$inject = ['$scope', 'manifestService', '$stateParams', 'SweetAlert'];

  /* @ngInject */
  function CustomsStatusCtrl($scope, manifestService, $stateParams, SweetAlert) {

    var vm = this;
    vm.manifest = this.manifest;
    vm.manifestId = vm.manifest.id;

    vm.loading = false;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };


    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;
    vm.saveCustomsStatus = saveCustomsStatus;

    activate();

    ////////////////

    function activate() {
        if(Date.parse(vm.manifest.clearanceDate)) {
          vm.manifest.clearanceDate = new Date(vm.manifest.clearanceDate);
        }
        if(vm.manifest.customsType == null) {
          vm.manifest.customsType = '';
        }
    }

    function saveCustomsStatus() {
      vm.loading = true;

      var dataToSave = {
        clearanceDate:vm.manifest.clearanceDate,
        agentRefNo:vm.manifest.agentRefNo,
        customsType:vm.manifest.customsType,
        declaration:vm.manifest.declaration,
        awb:vm.manifest.awb,
        customsComplete:vm.manifest.customsComplete,
        tempImport:vm.manifest.tempImport
      };

      return manifestService.saveCustomsStatus(vm.manifestId, dataToSave)
        .then(function(response) {
          vm.loading = false;
          SweetAlert.swal("Saved!", "Successfully saved customs status.", "success");
        },function(error){
          vm.hasErrors = true;
          showValidationErrors(error);
        });
    }


    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not update customs status.');
      }
      vm.loading = false;
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.manifests')
    .controller('CreateManifestCtrl', CreateManifestCtrl);

  CreateManifestCtrl.$inject = ['manifestService', '$state', 'OidcManager', 'SETTINGS', 'API'];
  /* @ngInject */
  function CreateManifestCtrl(manifestService, $state, OidcManager, SETTINGS, API) {
    if ($state.transition) return;

    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;
    vm.loading = false;
    vm.manifest = {
      description: '',
      manifestTypeId: ''
    };

    /** Manifest Types */
    vm.types = [];
    vm.typeOptions = [];

    vm.createManifest = createManifest;
    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;

    activate();

    /////////////////////

    function activate() {

    }

    function createManifest() {
      vm.loading = true;
      return manifestService.createManifest(vm.manifest)
        .then(function(response) {
          vm.hasErrors = false;
          $state.transitionTo('manifests.details', {id: response.manifestId});
        }, function(error){
          vm.hasErrors = true;
          showValidationErrors(error);
        });
    }

    function showValidationErrors(error){
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessages);
        }
      } else {
        vm.validationErrors.push('Could not create manifest.');
      }
      vm.loading = false;
    }

    /** Manifest Types */

    vm.types = {
      transport: {
        read: {
          url: API.BASE_URI_SHIPPING + SETTINGS.projectCode + "/manifests/types",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.typeOptions = {
      placeholder: "Select a type",
      dataSource: vm.types,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false
    };

  }

})();

(function () {
  'use strict';

  angular
    .module('app.manifests')
    .directive('wgAddManifestLineItem', wgAddManifestLineItem);

  wgAddManifestLineItem.$inject = [];
  /* @ngInject */

  function wgAddManifestLineItem() {
    var directive = {
      bindToController: true,
      controller: AddManifestLineItemCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        manifestId: '=',
        postUpdateDelegate: '&',
        isReadOnly: '='
      },
      templateUrl: 'app/manifests/addManifestLineItem.html'
    };

    return directive;

    function link($scope, element, attrs) {

    }
  }

  AddManifestLineItemCtrl.$inject = ['$uibModal', 'manifestService'];

  /* @ngInject */
  function AddManifestLineItemCtrl($uibModal, manifestService) {
    var vm = this;

    vm.manifestId = this.manifestId;
    vm.isReadOnly = this.isReadOnly;

    vm.openAddLineItem = openAddLineItem;
    vm.saveItem = saveItem;

    function openAddLineItem() {
      $uibModal.open({
        templateUrl: 'app/manifests/addManifestLineItemModal.html',
        controller: 'AddManifestLineItemModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          postUpdateDelegate: function () {
            return vm.postUpdateDelegate;
          },
          lineItem: function () {
            return {
              materialCode: '',
              costCode: '',
              unitOfMeasureCode: '',
              manifestId: vm.manifestId
            };
          },
          isAdd: function () {
            return true;
          },
          saveItem: function () {
            return vm.saveItem;
          },
          isReadOnly: function () {
            return vm.isReadOnly;
          }
        }
      });
    }

    function saveItem(itemToSave) {
      return manifestService.addItemToManifest(vm.manifestId, itemToSave);
    }

  }

  angular
    .module('app.manifests')
    .controller('AddManifestLineItemModalCtrl', AddManifestLineItemModalCtrl);

  AddManifestLineItemModalCtrl.$inject = ['$uibModalInstance', '$timeout', 'purchaseOrderService', 'stockService', 'OidcManager', 'API', 'SETTINGS', 'postUpdateDelegate', 'SweetAlert', 'lineItem', 'isAdd', 'saveItem', 'isReadOnly'];

  function AddManifestLineItemModalCtrl($uibModalInstance, $timeout, purchaseOrderService, stockService, OidcManager, API, SETTINGS, postUpdateDelegate, SweetAlert, lineItem, isAdd, saveItem, isReadOnly) {
    var vm = this;
    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.materialCodeOptions = [];
    vm.costCodeOptions = [];
    vm.unitsOfMeasureOptions = [];

    vm.addAnother = false;

    vm.lineItem = lineItem;
    vm.isAdd = isAdd;
    vm.saveItem = saveItem;
    vm.storedItem = {};
    vm.isReadOnly = isReadOnly;

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    activate();

    ///////////////////////////////

    function activate() {
      if(Date.parse(vm.lineItem.addDate)) {
        vm.lineItem.addDate = new Date(vm.lineItem.addDate);
      }
    }

    vm.ok = function () {

      vm.saving = true;

      var itemToAdd = {
        id: vm.lineItem.id,
        manifestRowId: vm.lineItem.id,
        manifestId: vm.lineItem.manifestId,
        description: vm.lineItem.description,
        costCode: vm.lineItem.costCode === null ? '' : vm.lineItem.costCode,
        materialCode: vm.lineItem.materialCode === null ? '' : vm.lineItem.materialCode,
        barcode: vm.lineItem.barcode === null ? '' : vm.lineItem.barcode,
        unitOfMeasureCode: vm.lineItem.unitOfMeasureCode,
        purchaseOrderLineId: vm.lineItem.purchaseOrderLineId, 
        purchaseOrderNumber: vm.lineItem.purchaseOrderNumber === null ? '' : vm.lineItem.purchaseOrderNumber,
        purchaseOrderLineNumber: vm.lineItem.purchaseOrderLineNumber === null ? '' : vm.lineItem.purchaseOrderLineNumber,
        refDoc: vm.lineItem.refDoc === null ? '' : vm.lineItem.refDoc,
        quantity: vm.lineItem.quantity,
        price: vm.lineItem.price,
        unloadingPoint: vm.lineItem.unloadingPoint === null ? '' : vm.lineItem.unloadingPoint,
        workpack: vm.lineItem.workpack === null ? '' : vm.lineItem.workpack,
        container: vm.lineItem.container === null ? '' : vm.lineItem.container,
        commodityCode: vm.lineItem.commodityCode === null ? '' : vm.lineItem.commodityCode,
        boxNumber: vm.lineItem.boxNumber === null ? '' : vm.lineItem.boxNumber,
        origin: vm.lineItem.origin === null ? '' : vm.lineItem.origin,
        customsStatus: vm.lineItem.customsStatus === null ? 'FCG' : vm.lineItem.customsStatus,
        fcgValue: vm.lineItem.fcgValue === null ? '' : vm.lineItem.fcgValue,
        sweuValue: vm.lineItem.sweuValue === null ? '' : vm.lineItem.sweuValue,
        addDate: vm.lineItem.addDate,
        bagAndTagNumber: vm.lineItem.bagAndTagNumber,
        isDualUse: vm.lineItem.isDualUse
      };

      vm.saveItem(itemToAdd)
        .then(function (response) {

          if(vm.isAdd){
            itemToAdd.id = response.id;
            itemToAdd.manifestRowId = response.id;
          }
          vm.error = false;
          vm.saved = true;
          vm.saving = false;

          postUpdateDelegate({item: itemToAdd});

          if (vm.addAnother) {
            resetModal();
          } else {
            $uibModalInstance.close();
            $timeout(function () {
              SweetAlert.swal("Saved!", "The manifest item has been saved successfully.", "success");
            }, 500);
          }
        }, function (error) {
          vm.saved = false;
          vm.error = true;
          vm.saving = false;

          showValidationErrors(error);
        });

    };

    /** Material Codes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.materialCodesOptions = {
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "id",
      suggest: true,
      autoBind: true,
      value: vm.lineItem.materialCode,
      change: function (e) {
        getStoredItemByMaterialCode(this.value());
      }
    };

    function getStoredItemByMaterialCode(storedItemId) {
      return stockService.getMaterialDetailsByStoredItemId(storedItemId)
        .then(function (response) {
          vm.storedItem = response;
          vm.lineItem.materialCode = vm.storedItem.materialCode;
          vm.lineItem.description = vm.storedItem.description;
          vm.lineItem.unitOfMeasureCode = vm.storedItem.unitOfMeasureCode;
          vm.lineItem.price= vm.storedItem.price;
          vm.lineItem.costCode = vm.storedItem.costCode;
        });
    }

    /** Cost Codes */

    vm.costCodes = {
      transport: {
        read: function (options) {
          return stockService.getCostCodes()
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        },
        dataType: "json"
      }
    };

    vm.costCodesOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      suggest: true,
      autoBind: true,
      value: vm.lineItem.costCode
    };

    /** Units of measure */

    vm.unitsOfMeasure = {
      transport: {
        read: function (options) {
          return purchaseOrderService.getUnitsOfMeasure()
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        },
        dataType: "json"
      }
    };

    vm.unitsOfMeasureOptions = {
      dataSource: vm.unitsOfMeasure,
      dataTextField: "descriptionWithCode",
      dataValueField: "code",
      filter: "contains",
      autoBind: true,
      value: vm.lineItem.unitOfMeasureCode
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    function resetModal() {
      vm.lineItem = {};
      resetCombo("materialCodes");
      resetCombo("costCodes");
      resetCombo("unitsOfMeasure");
      $timeout(function () {
        vm.saved = false;
      }, 4000);
    }

    function resetCombo(name) {
      var combo = angular.element(document.getElementsByName(name));
      combo.data("kendoComboBox").value("");
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not save manifest line item.');
      }
      vm.loading = false;
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('app.manifests')
    .controller('AddContainerModalCtrl', AddContainerModalCtrl);

  AddContainerModalCtrl.$inject = ['$uibModalInstance', 'items', 'updateItems'];

  function AddContainerModalCtrl($uibModalInstance, items, updateItems) {
    var vm = this;

    vm.items = items;
    vm.updateItems = updateItems;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.container = '';

    activate();

    ///////////////

    function activate() {

    }

    vm.ok = function () {
      vm.saving = true;
      vm.saved = false;

      vm.updateItems(vm.items, vm.container)
        .then(function (response) {

          angular.forEach(vm.items, function (value, key) {
            value.container = vm.container;
          });


          vm.error = false;
          vm.saved = true;
          vm.saving = false;

        }, function () {

          vm.saved = false;
          vm.error = true;
          vm.saving = false;
        });
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

  }


})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgVendorInspectionWidget', wgVendorInspectionWidget);

  wgVendorInspectionWidget.$inject = [];

  /* @ngInject */
  function wgVendorInspectionWidget() {
    var directive = {
      bindToController: true,
      controller: VendorInspectionWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/vendorInspectionWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  VendorInspectionWidgetCtrl.$inject = ['deliveryService'];

  /* @ngInject */
  function VendorInspectionWidgetCtrl(deliveryService) {
    var vm = this;

    vm.itemCount = 0;
    vm.supplierCode = 0;
    vm.timeInterval = 'ww:1';
    vm.purchaseOrderSelected = null;
    activate();

    function activate(){
      deliveryService.getVendorInspectionsIncompleteCount(vm.supplierCode, vm.timeInterval, vm.purchaseOrderSelected)
        .then(function(response) {
         vm.itemCount = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgStoringDeliveriesWidget', wgStoringDeliveriesWidget);

  wgStoringDeliveriesWidget.$inject = [];

  /* @ngInject */
  function wgStoringDeliveriesWidget() {
    var directive = {
      bindToController: true,
      controller: StoringDeliveriesWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/storingDeliveriesWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  StoringDeliveriesWidgetCtrl.$inject = ['deliveryService'];

  /* @ngInject */
  function StoringDeliveriesWidgetCtrl(deliveryService) {
    var vm = this;

    vm.deliveryCount = 0;
    activate();

    function activate(){
      deliveryService.getStoringDeliveriesCount()
        .then(function(response) {
         vm.deliveryCount = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgReadyForPickingPicklistsWidget', wgReadyForPickingPicklistsWidget);

  wgReadyForPickingPicklistsWidget.$inject = [];

  /* @ngInject */
  function wgReadyForPickingPicklistsWidget() {
    var directive = {
      bindToController: true,
      controller: ReadyForPicklistsWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/readyForPickingPicklistsWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  ReadyForPicklistsWidgetCtrl.$inject = ['picklistService'];

  /* @ngInject */
  function ReadyForPicklistsWidgetCtrl(picklistService) {
    var vm = this;

    vm.itemCount = 0;
    activate();

    function activate(){
      picklistService.getPicklistsPickingCount()
        .then(function(response) {
         vm.itemCount = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgPotentialOverageDeliveriesWidget', wgPotentialOverageDeliveriesWidget);

  wgPotentialOverageDeliveriesWidget.$inject = [];

  /* @ngInject */
  function wgPotentialOverageDeliveriesWidget() {
    var directive = {
      bindToController: true,
      controller: PotentialOverageDeliveriesWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/potentialOverageDeliveriesWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  PotentialOverageDeliveriesWidgetCtrl.$inject = ['deliveryService'];

  /* @ngInject */
  function PotentialOverageDeliveriesWidgetCtrl(deliveryService) {
    var vm = this;

    vm.deliveryCount = 0;
    activate();

    function activate(){
      deliveryService.getOutstandingOsdDeliveriesCount()
        .then(function(response) {
         vm.deliveryCount = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular.module('app.expediting', []);

})();

(function () {
  'use strict';

  angular
    .module('app.expediting')
    .directive('wgOneWeekExpeditingWidget', wgOneWeekExpeditingWidget);

  wgOneWeekExpeditingWidget.$inject = [];

  /* @ngInject */
  function wgOneWeekExpeditingWidget() {
    var directive = {
      bindToController: true,
      controller: OneWeekExpeditingCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/oneWeekExpeditingWidget.html",
      scope: {
        timeInterval: '=',
        title: '='
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  OneWeekExpeditingCtrl.$inject = ['deliveryService'];

  /* @ngInject */
  function OneWeekExpeditingCtrl(deliveryService) {
    var vm = this;
    vm.timeInterval = this.timeInterval;
    vm.title = this.title;
    vm.count = {};
    vm.currentPage = 1;
    vm.loading = true;

    activate();

    function activate(){
      deliveryService.getPurchaseOrderLinesForExpeditingCount(vm.timeInterval, null)
        .then(function(response) {
          vm.count = response.count;
          vm.loading = false;
      });
    }
  }

})();


(function () {
  'use strict';

  angular.module('app.main', []);

})();

(function () {
  'use strict';

  angular.module('app.main')
    .controller('NavigationCtrl', NavigationCtrl);

  NavigationCtrl.$inject = ['OidcManager', 'permissionService'];

  function NavigationCtrl(OidcManager, permissionService){
    var vm = this;

    vm.manager = OidcManager.OidcTokenManager();

    vm.isAdmin = isAdmin();
    vm.isSuperUser = vm.isAdmin === true ? true : permissionService.hasPermission("WarehouseAdmin", "Read");
    vm.allowBagAndTag = vm.isAdmin === true ? true : permissionService.hasPermission("BagAndTag", "Read");
    vm.allowDeliveries = vm.isAdmin === true ? true : permissionService.hasPermission("Deliveries", "Read");
    vm.allowInspections = vm.isAdmin === true ? true : permissionService.hasPermission("Inspection", "Read");
    vm.allowExpediting = vm.isAdmin === true ? true : permissionService.hasPermission("Expediting", "Read");
    vm.allowIssues = vm.isAdmin === true ? true : permissionService.hasPermission("Issues", "Read");
    vm.allowManifests = vm.isAdmin === true ? true : permissionService.hasPermission("Manifest", "Read");
    vm.allowPurchaseOrders = vm.isAdmin === true ? true : permissionService.hasPermission("PurchaseOrders", "Read");
    vm.allowReturns = vm.isAdmin === true ? true : permissionService.hasPermission("Returns", "Read");
    vm.allowTransfers = vm.isAdmin === true ? true : permissionService.hasPermission("Transfers", "Read");
    vm.allowReporting = vm.isAdmin === true ? true : permissionService.hasPermission("Reporting", "Read");
    vm.allowPicklists = vm.isAdmin === true ? true : permissionService.hasPermission("Picklists", "Read");
    vm.allowMovements = vm.isAdmin === true ? true : permissionService.hasPermission("Movements", "Read");
    vm.allowOsdRegister = vm.isAdmin === true ? true : permissionService.hasPermission("OSD", "Read");
    vm.allowMinMaxRegister = vm.isAdmin === true ? true : permissionService.hasPermission("MaterialMinMax", "Read");
    vm.allowMinMaxPlanning = vm.isAdmin === true ? true : permissionService.hasPermission("MaterialMinMax", "Read");
    vm.allowMinMax = vm.isAdmin === true ? true : permissionService.hasPermission("MaterialMinMax", "Read");
    vm.allowMaterialAllocation = vm.isAdmin === true ? true : permissionService.hasPermission("MaterialAllocation", "Read");

    vm.allowSearch = vm.allowPurchaseOrders || vm.allowDeliveries || vm.allowIssues || vm.allowReturns || vm.allowTransfers || vm.allowManifests;

    vm.allowWarehouseFunctions = vm.allowIssues || vm.allowReturns || vm.allowBagAndTag || vm.allowPicklists || vm.allowMovements || vm.allowTransfers;

    function isAdmin(){
      if (!vm.manager.expired){
        if (vm.manager.profile.role !== undefined){
          return vm.manager.profile.role.toUpperCase() === "ADMIN";
        } else {
          return false;
        }
      }
    }

  }

})();

(function () {
  'use strict';

  angular.module('app.main')
    .controller('MainCtrl', MainCtrl);

  MainCtrl.$inject = ['$rootScope', '$timeout', '$localStorage', 'OidcManager', 'permissionService', 'ProjectSelectorAPI', 'SETTINGS', '$state', 'logOutService', 'projectService'];

  function MainCtrl($rootScope, $timeout, $localStorage, OidcManager, permissionService, ProjectSelectorAPI, SETTINGS, $state, logOutService, projectService) {
    var vm = this;

    if ($localStorage.defaultProjectCode) {
      SETTINGS.projectCode = $localStorage.defaultProjectCode;
      SETTINGS.projectId = $localStorage.defaultProjectId;
    }

    vm.setProjectCode = setProjectCode;

    vm.$state = $state;

    vm.projectSelectorApi = ProjectSelectorAPI;

    vm.manager = OidcManager.OidcTokenManager();
    $timeout(function () {
      if (($localStorage.isProjectSet === undefined && !vm.manager.expired ) || SETTINGS.projectCode == "") {
        vm.setProjectCode();
      }

    }, 1000);

    vm.isAdmin = isAdmin();
    vm.showDeliveriesWidget =  vm.isAdmin === true ? true : permissionService.hasPermission("Deliveries", "Read");
    vm.showInspectionsWidget = vm.isAdmin === true ? true : permissionService.hasPermission("Inspection", "Read");
    vm.showIssuesWidget = vm.isAdmin === true ? true : permissionService.hasPermission("Issues", "Read");
    vm.showReturnsWidget = vm.isAdmin === true ? true : permissionService.hasPermission("Returns", "Read");
    vm.showTransfersWidget = vm.isAdmin === true ? true : permissionService.hasPermission("Transfers", "Read");
    vm.showMovementsWidget = vm.isAdmin === true ? true : permissionService.hasPermission("Movements", "Read");
    vm.showBagsAndTagsWidget = vm.isAdmin === true ? true : permissionService.hasPermission("BagAndTag", "Read");
    vm.showMinMaxWidget = vm.isAdmin === true ? true : permissionService.hasPermission("MaterialMinMax", "Read");
    vm.showPicklistsWidget = vm.isAdmin === true ? true : permissionService.hasPermission("Picklists", "Read");
    vm.showExpeditingWidget = vm.isAdmin === true ? true : permissionService.hasPermission("Expediting", "Read");
    vm.showManifestWidget = vm.isAdmin === true ? true : permissionService.hasPermission("Manifest", "Read");
    vm.showOSDWidget = vm.isAdmin === true ? true : permissionService.hasPermission("OSD", "Read");

    setReceiptWidget()

    function setReceiptWidget() {
      getProject()
        .then(function () {
          if (vm.project.enableSync) {
            vm.showReceiptsWidget = vm.isAdmin === true ? true : permissionService.hasPermission("Deliveries", "Read");
          }
          else {
            vm.showReceiptsWidget = false;
          }
        });
    }


    vm.logOut = function () {
      vm.manager.removeToken();
      window.location = "index.html";
    };

    vm.logOutOfIdSrv = function () {
      logOutService.logOutOfIdSrv();
    };

    // if no id token or expired => redirect to get one
    if (vm.manager.expired) {
      logOutService.logOutDueToTokenExpiry();
    }

    function getProject(){
      return projectService.getProject(SETTINGS.projectId)
        .then(function(response) {
          vm.project = response;
        });
    }

    function isArray(obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    }

    function setProjectCode() {
      var defaultProject = permissionService.getDefaultProject();
      if (isArray(defaultProject)) {
        vm.projectSelectorApi.openProjects();
      }
      else if (defaultProject !== SETTINGS.projectCode && defaultProject != undefined) {
        vm.projectSelectorApi.saveProject(defaultProject);
      }
    }

    function isAdmin(){
      return permissionService.isAdmin();
    }

    $rootScope.$on('projectSelectedEvent', setReceiptWidget);
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgInspectionDeliveriesWidget', wgInspectionDeliveriesWidget);

  wgInspectionDeliveriesWidget.$inject = [];

  /* @ngInject */
  function wgInspectionDeliveriesWidget() {
    var directive = {
      bindToController: true,
      controller: InspectionDeliveriesWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/inspectionDeliveriesWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  InspectionDeliveriesWidgetCtrl.$inject = ['deliveryService'];

  /* @ngInject */
  function InspectionDeliveriesWidgetCtrl(deliveryService) {
    var vm = this;

    vm.deliveryCount = 0;
    activate();

    function activate(){
      deliveryService.getInspectionDeliveriesCount()
        .then(function(response) {
         vm.deliveryCount = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgIncompleteTransfersWidget', wgIncompleteTransfersWidget);

  wgIncompleteTransfersWidget.$inject = [];

  /* @ngInject */
  function wgIncompleteTransfersWidget() {
    var directive = {
      bindToController: true,
      controller: IncompleteTransfersWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/incompleteTransfersWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  IncompleteTransfersWidgetCtrl.$inject = ['transferService'];

  /* @ngInject */
  function IncompleteTransfersWidgetCtrl(transferService) {
    var vm = this;

    vm.count = 0;
    activate();

    function activate(){
      transferService.getTransfersCount()
        .then(function(response) {
         vm.count = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgIncompleteReturnsWidget', wgIncompleteReturnsWidget);

  wgIncompleteReturnsWidget.$inject = [];

  /* @ngInject */
  function wgIncompleteReturnsWidget() {
    var directive = {
      bindToController: true,
      controller: IncompleteReturnsWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/incompleteReturnsWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  IncompleteReturnsWidgetCtrl.$inject = ['returnService'];

  /* @ngInject */
  function IncompleteReturnsWidgetCtrl(returnService) {
    var vm = this;

    vm.returnCount = 0;
    activate();

    function activate(){
      returnService.getReturnsIncompleteCount()
        .then(function(response) {
         vm.returnCount = response.count;
      });
    }
  }

})();


(function(){
  'use strict';

  angular
    .module('app.purchase-orders')
    .directive('wgIncompleteReceiptsWidget', wgIncompleteReceiptsWidget);

  wgIncompleteReceiptsWidget.$inject = [];

  /* @ngInject */
  function wgIncompleteReceiptsWidget() {
    var directive = {
      bindToController: true,
      controller: IncompleteReceiptsWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/main/incompleteReceiptsWidget.html',
      scope: {}
    };

    return directive;

    function link(scope, element, attrs){

    }
  }

  IncompleteReceiptsWidgetCtrl.$inject = ['purchaseOrderService'];

  /* @ngInject */
  function IncompleteReceiptsWidgetCtrl(purchaseOrderService) {
    var vm = this;

    vm.itemCount = 0;
    activate();

    function activate(){
      purchaseOrderService.getReceiptsIncompleteCount()
        .then(function(response) {
          vm.itemCount = response.count;
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgIncompletePicklistsWidget', wgIncompletePicklistsWidget);

  wgIncompletePicklistsWidget.$inject = [];

  /* @ngInject */
  function wgIncompletePicklistsWidget() {
    var directive = {
      bindToController: true,
      controller: IncompletePicklistsWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/incompletePicklistsWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  IncompletePicklistsWidgetCtrl.$inject = ['picklistService'];

  /* @ngInject */
  function IncompletePicklistsWidgetCtrl(picklistService) {
    var vm = this;

    vm.itemCount = 0;
    activate();

    function activate(){
      picklistService.getPicklistsIncompleteCount()
        .then(function(response) {
         vm.itemCount = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgIncompleteMovementsWidget', wgIncompleteMovementsWidget);

  wgIncompleteMovementsWidget.$inject = [];

  /* @ngInject */
  function wgIncompleteMovementsWidget() {
    var directive = {
      bindToController: true,
      controller: IncompleteMovementsWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/incompleteMovementsWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  IncompleteMovementsWidgetCtrl.$inject = ['movementService'];

  /* @ngInject */
  function IncompleteMovementsWidgetCtrl(movementService) {
    var vm = this;

    vm.count = 0;
    activate();

    function activate(){
      movementService.getMovementsIncompleteCount()
        .then(function(response) {
         vm.count = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgIncompleteMinMaxWidget', wgIncompleteMinMaxWidget);

  wgIncompleteMinMaxWidget.$inject = [];

  /* @ngInject */
  function wgIncompleteMinMaxWidget() {
    var directive = {
      bindToController: true,
      controller: IncompleteMinMaxWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/incompleteMinMaxWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  IncompleteMinMaxWidgetCtrl.$inject = ['minMaxService'];

  /* @ngInject */
  function IncompleteMinMaxWidgetCtrl(minMaxService) {
    var vm = this;

    vm.itemCount = 0;
    activate();

    function activate(){
      minMaxService.getIncompleteMinMaxItemsCount()
        .then(function(response) {
         vm.itemCount = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgIncompleteManifestsWidget', wgIncompleteManifestsWidget);

  wgIncompleteManifestsWidget.$inject = [];

  /* @ngInject */
  function wgIncompleteManifestsWidget() {
    var directive = {
      bindToController: true,
      controller: IncompleteManifestsWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/incompleteManifestsWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  IncompleteManifestsWidgetCtrl.$inject = ['manifestService'];

  /* @ngInject */
  function IncompleteManifestsWidgetCtrl(manifestService) {
    var vm = this;

    vm.manifestCount = 0;
    activate();

    function activate(){
      manifestService.getManifestsIncompleteCount()
        .then(function(response) {
         vm.manifestCount = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgIncompleteIssuesWidget', wgIncompleteIssuesWidget);

  wgIncompleteIssuesWidget.$inject = [];

  /* @ngInject */
  function wgIncompleteIssuesWidget() {
    var directive = {
      bindToController: true,
      controller: IncompleteIssuesWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/incompleteIssuesWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  IncompleteIssuesWidgetCtrl.$inject = ['issueService'];

  /* @ngInject */
  function IncompleteIssuesWidgetCtrl(issueService) {
    var vm = this;

    vm.issueCount = 0;
    activate();

    function activate(){
      issueService.getIssuesIncompleteCount()
        .then(function(response) {
         vm.issueCount = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgIncompleteDeliveriesWidget', wgIncompleteDeliveriesWidget);

  wgIncompleteDeliveriesWidget.$inject = [];

  /* @ngInject */
  function wgIncompleteDeliveriesWidget() {
    var directive = {
      bindToController: true,
      controller: IncompleteDeliveriesWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/incompleteDeliveriesWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  IncompleteDeliveriesWidgetCtrl.$inject = ['deliveryService'];

  /* @ngInject */
  function IncompleteDeliveriesWidgetCtrl(deliveryService) {
    var vm = this;

    vm.deliveryCount = 0;

    activate();

    function activate(){
      deliveryService.getIncompleteDeliveriesCount()
        .then(function(response) {
         vm.deliveryCount = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgCheckingDeliveriesWidget', wgCheckingDeliveriesWidgetCtrl);

  wgCheckingDeliveriesWidgetCtrl.$inject = [];

  /* @ngInject */
  function wgCheckingDeliveriesWidgetCtrl() {
    var directive = {
      bindToController: true,
      controller: CheckingDeliveriesWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/checkingDeliveriesWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  CheckingDeliveriesWidgetCtrl.$inject = ['deliveryService'];

  /* @ngInject */
  function CheckingDeliveriesWidgetCtrl(deliveryService) {
    var vm = this;

    vm.deliveryCount = 0;
    activate();

    function activate(){
      deliveryService.getCheckingDeliveriesCount()
        .then(function(response) {
         vm.deliveryCount = response.count;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgBagAndTagsWidget', wgBagAndTagsWidget);

  wgBagAndTagsWidget.$inject = [];

  /* @ngInject */
  function wgBagAndTagsWidget() {
    var directive = {
      bindToController: true,
      controller: BagAndTagsWidgetCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/main/bagAndTagsWidget.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  BagAndTagsWidgetCtrl.$inject = ['bagAndTagService'];

  /* @ngInject */
  function BagAndTagsWidgetCtrl(bagAndTagService) {
    var vm = this;

    vm.bagAndTagCount = 0;
    activate();

    function activate(){
      bagAndTagService.getBagAndTags()
        .then(function(response) {
         vm.bagAndTagCount = response.length;
      });
    }
  }

})();


(function () {
  'use strict';

  angular.module('app.issues', []);

})();

(function () {
  'use strict';

  angular
    .module('app.issues')
    .controller('ViewIssuesCtrl', ViewIssuesCtrl);

  ViewIssuesCtrl.$inject = ['$state', 'issueService'];

  /* @ngInject */
  function ViewIssuesCtrl($state, issueService) {
    var vm = this;
    vm.completedIssues = [];
    vm.incompleteIssues = [];

    activate();

    ///////////////////////

    function activate(){

      issueService.getIssuesCompleted()
        .then(function(response) {
          vm.completedIssues = response;
        });

      issueService.getIssuesIncomplete()
        .then(function(response) {
          vm.incompleteIssues = response;
        });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.issues')
    .controller('ViewIssueCtrl', ViewIssueCtrl);

  ViewIssueCtrl.$inject = ['$stateParams', '$filter', '$timeout', 'issueService', 'stockService', 'SweetAlert','$uibModal'];

  /* ngInject */
  function ViewIssueCtrl($stateParams, $filter, $timeout, issueService, stockService, SweetAlert,$uibModal) {
    var vm = this;

    vm.issueId = $stateParams.id;
    vm.issue = {};
    vm.searching = false;
    vm.results = undefined;
    vm.bagAndTagResults = undefined;

    vm.selectedAll = false;

    vm.picklistItems = [];
    vm.picklistBagAndTagItems = [];
    vm.issueItems = [];
    vm.issueBagAndTagItems = [];

    vm.validationErrors = [];
    vm.hasErrors = false;

    vm.tabs = {
      storedItemsActive: true,
      bagAngTagsActive: false,
      storedItemsResultsActive: true,
      bagAndTagResultsActive: false
    };

    vm.getIssue = getIssue;
    vm.getPicklistItems = getPicklistItems;
    vm.getPicklistBagAndTagItems = getPicklistBagAndTagItems;
    vm.updateIssue = updateIssue;
    vm.completeIssue = completeIssue;
    vm.cancelIssue = cancelIssue;
    vm.addItem = addItem;
    vm.updateItem = updateItem;
    vm.addPicklistItem = addPicklistItem;
    vm.addBagAndTag = addBagAndTag;
    vm.removeItem = removeItem;
    vm.removeBagAndTag = removeBagAndTag;
    vm.addIssueItems = addIssueItems;
    vm.showValidationErrors = showValidationErrors;
    vm.openModal = openModal;

    activate();

    ////////////////////

    function activate() {
      return getIssue().then(function () {
        if(vm.issue.issueStatus !== "Cancelled") {
          return getIssueItems().then(function () {
            return getIssueBagAndTagItems().then(function () {

              if(vm.issue.isPicklist){
                return getPicklistItems().then(function () {
                  return getPicklistBagAndTagItems().then(function () {

                  });
                });
              }
            });
          });
        }
        else{
          vm.issueItems = [];
          vm.issueBagAndTagItems = [];
        }
      });
    }

    function updateIssue() {
      return issueService.updateIssue(vm.issue)
        .then(function(response){
      });
    }

    function completeIssue() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "You can not edit the issue after it is complete!",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, complete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false},
        function(isConfirm){
          if (!isConfirm) return;
          vm.loading = true;
          return issueService.completeIssue(vm.issueId)
            .then(function(response) {
                vm.loading = false;
                activate();

                SweetAlert.swal("Completed!", "The issue is now complete.", "success");
              },function(error){
                showValidationErrors(error);
              }
            );
        });
    }

    function cancelIssue() {
      SweetAlert.swal({
        title: "Are you sure?",
        text: "Cancelling this issue will return all items to stock.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ED5565",
        confirmButtonText: "Yes, cancel it!",
        cancelButtonText: "Close",
        closeOnConfirm: false},
      function(isConfirm){
        if (!isConfirm) return;
        vm.loading = true;
        return issueService.cancelIssue(vm.issueId)
          .then(function(response) {
            vm.loading = false;
            activate();
            SweetAlert.swal("Cancelled!", "The issue is now cancelled.", "success");
          }, function(error) {
            showValidationErrors(error);
          });
      });
    }

    function getIssue() {
      return issueService.getIssue(vm.issueId)
        .then(function(response) {
          vm.issue = response;

          return vm.issue;
        });
    }

    function getPicklistItems() {
      return stockService.getPicklistItemsForIssue(vm.issue.picklistId)
        .then(function(response) {
          vm.picklistItems = response;

          return vm.picklistItems;
        });
    }

    function getPicklistBagAndTagItems() {
      return stockService.getPicklistBagAndTagItemsForIssue(vm.issue.picklistId)
        .then(function(response) {
          vm.picklistBagAndTagItems = response;

          return vm.picklistBagAndTagItems;
        });
    }

    function getIssueItems() {
      return issueService.getIssueItems(vm.issueId)
        .then(function(response) {
          vm.issueItems = response;          
        });
    }

    function getIssueBagAndTagItems() {
      return issueService.getIssueBagAndTagItems(vm.issueId)
        .then(function(response) {
          vm.issueBagAndTagItems = response;
        });
    }

    function addIssueItems() { 
        var selectedItems = [];

      angular.forEach(vm.results, function (result){
        angular.forEach(result.storedItems, function (item) { 
          if(item.isIncluded && item.selectedQuantity > 0) { 
           selectedItems.push(item);
          }
        }); 
      }); 
        
        var items = { 
          id: vm.issueId,
          issueItems: selectedItems
        };

        return issueService.addIssueItems(items)
        .then(function(response) {
          if (response.responseMessage === 'Success') { 
            angular.forEach(items.issueItems, function(item){
              if (!addToExistingItem(item)) {
                vm.issueItems.push(angular.copy(item)); }
              deductQuantityFromStockItems(item.storedItemLocationId, item.storedItemId, item.selectedQuantity);
            });
          }
        });   
    } 

    function addItem(item) { 
      var refNo = vm.issue.defaultRefNo === "" ? item.workpack : vm.issue.defaultRefNo;    
      return issueService.addItemToIssue(vm.issueId, item.storedItemLocationId, item.selectedQuantity, refNo)
        .then(function(response) {
          if (response.responseMessage === 'Success') {
            if (!addToExistingItem(item)) {
              vm.issueItems.push(angular.copy(item)); }
            deductQuantityFromStockItems(item.storedItemLocationId, item.storedItemId, item.selectedQuantity);
          } else {                   
                  displayNotification(response.responseMessage);            
          }
        });
    }

    function updateItem(item) { 
      if(item.selectedQuantity == 0){
        var response = "";
        var storedItemLocation = $filter('filter')(vm.issueItems, {storedItemLocationId: item.storedItemLocationId})[0]; 
        return removeItem(storedItemLocation).then(function(){
        return response;
        });          
      }
      else{
      return issueService.updateItemToIssue(vm.issueId, item.storedItemLocationId, item.selectedQuantity)
        .then(function(response) {
          if (response.responseMessage === 'Success') {
            updateToExistingItem(item);             
            var quantityToUpdate = parseFloat(item.selectedQuantity) - parseFloat((item.oldSelectedQuantity == undefined )? 0.00 :item.oldSelectedQuantity);              
            deductQuantityFromStockItems(item.storedItemLocationId, item.storedItemId, quantityToUpdate);            
          }   
          return response ;          
        });  
      }    
    }    

    function addPicklistItem(item) {
      return issueService.addItemToIssue(vm.issueId, item.storedItemLocationId, item.issueQuantity)
        .then(function(response) {
          if (response.responseMessage === 'Success') {
            if (!addToExistingItemPicklist(item)) {
              var newItem = angular.copy(item);
              newItem.selectedQuantity = item.issueQuantity;
              vm.issueItems.push(newItem);
            }
            vm.getPicklistItems();
            //deductQuantityFromStockItemsPicklist(item.storedItemLocationId, item.storedItemId, item.issueQuantity);
          } else {
            displayNotification(response.responseMessage);
          }
        });
    }

    function addToExistingItem(item) {

      var storedItemLocation = $filter('filter')(vm.issueItems, {storedItemLocationId: item.storedItemLocationId})[0];

      if (storedItemLocation != undefined) {
        storedItemLocation.class = "badge-non-bold backgroundAnimated";
        storedItemLocation.selectedQuantity = parseFloat(storedItemLocation.selectedQuantity) + parseFloat(item.selectedQuantity);       
        $timeout(function () {
          storedItemLocation.class = "badge-transparent";
        }, 1000);
        return true;
      }
    }

    function updateToExistingItem(item) {

      var storedItemLocation = $filter('filter')(vm.issueItems, {storedItemLocationId: item.storedItemLocationId})[0];

      if (storedItemLocation != undefined) {
        storedItemLocation.class = "badge-non-bold backgroundAnimated";        
        storedItemLocation.selectedQuantity = parseFloat(item.selectedQuantity);
        $timeout(function () {
          storedItemLocation.class = "badge-transparent";
        }, 1000);
        return true;
      }
    }

    function addToExistingItemPicklist(item) {

      var storedItemLocation = $filter('filter')(vm.issueItems, {storedItemLocationId: item.storedItemLocationId})[0];

      if (storedItemLocation != undefined) {
        storedItemLocation.class = "badge-non-bold backgroundAnimated";
        storedItemLocation.selectedQuantity = parseFloat(storedItemLocation.selectedQuantity) + parseFloat(item.issueQuantity);        
        $timeout(function () {
          storedItemLocation.class = "badge-transparent";
        }, 1000);
        return true;
      }
    }

    function addBagAndTag(item) {
      return issueService.addBagAndTagToIssue(vm.issueId, item.id)
        .then(function(response) {
          if (response.responseMessage === 'Success') {
            vm.issueBagAndTagItems.push(item);

            if(vm.issue.isPicklist){
              vm.picklistBagAndTagItems.splice(vm.picklistBagAndTagItems.indexOf(item), 1);
            }
            else {
              vm.bagAndTagResults.splice(vm.bagAndTagResults.indexOf(item), 1);
            }
            vm.tabs.bagAndTagsActive = true;
          } else {
            displayNotification(response.responseMessage);
          }
        });
    }

    function removeItem(item) {
      if (vm.results !== undefined) {
        returnItemToStock(item);
      }
      var index = vm.issueItems.indexOf(item);      
      vm.issueItems.splice(index, 1); 
      return issueService.removeItemFromIssue(vm.issueId, item.storedItemLocationId)
        .then(function(response) {

          if(vm.issue.isPicklist){
            vm.getPicklistItems();
          }
        },function(error){
          showValidationErrors(error);
        });
    }

    function returnItemToStock(item) {

      angular.forEach(vm.results, function(storedItem) {
        var storedItemLocation = $filter('filter')(storedItem.storedItems, {storedItemLocationId: item.storedItemLocationId})[0];

        if (storedItemLocation != undefined) { 

          storedItemLocation.class = "badge-non-bold backgroundAnimated";
          storedItemLocation.quantity = parseFloat(storedItemLocation.quantity) + parseFloat((item.selectedQuantity == 0 ? item.oldSelectedQuantity:item.selectedQuantity));          
         
          $timeout(function () {
            storedItemLocation.class = "badge-transparent";
          }, 1000);
        }
      });
    }

    function deductQuantityFromStockItems(storedItemLocationId, storedItemId, qty) {
      var quantityFromSearch,quantityFromIncludedItem;
      if(vm.results != undefined){
        var storedItem = $filter('filter')(vm.results, {storedItemId: storedItemId})[0];
          if(storedItem != undefined){
          $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].selectedQuantity = "";
          $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].quantity -= parseFloat(qty);
          quantityFromSearch = $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].quantity;}
        }
        var storedItemLocation = $filter('filter')(vm.issueItems, {storedItemLocationId: storedItemLocationId})[0];                
        if(storedItemLocation !=null){
          storedItemLocation.oldSelectedQuantity = storedItemLocation.selectedQuantity;
          storedItemLocation.availableQuantity -= parseFloat(qty);
          quantityFromIncludedItem = parseFloat(storedItemLocation.availableQuantity);         
        }   
        if(quantityFromSearch !=undefined)  {
          storedItemLocation.availableQuantity = quantityFromSearch;
        }  
        if(!isNaN(quantityFromIncludedItem) && quantityFromIncludedItem !=undefined && vm.results != undefined && storedItem != undefined){ 
          $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].quantity =quantityFromIncludedItem;
        }
     
    }

    function deductQuantityFromStockItemsPicklist(storedItemLocationId, storedItemId, qty) {
      var storedItem = $filter('filter')(vm.picklistItems, {storedItemId: storedItemId})[0];
      storedItem.issuedQuantity += parseFloat(qty);

      $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].selectedQuantity -= parseFloat(qty);
      $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].issueQuantity = "";
    }

    function removeBagAndTag(item) {
      var index = vm.issueBagAndTagItems.indexOf(item);
      vm.issueBagAndTagItems.splice(index, 1);

      return issueService.removeBagAndTagFromIssue(vm.issueId, item.id)
        .then(function(response) {

          if(vm.issue.isPicklist){
            vm.getPicklistBagAndTagItems();
          }
        }, function(error) {
          showValidationErrors(error);
        });
    }

    function displayNotification(message) {
      SweetAlert.swal({
          title: "Quantity unavailable",
          text: message,
          type: "error",
          showCancelButton: false,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Close",
          closeOnConfirm: false}
        );
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not search for stored items.');
      }
      vm.loading = false;
    }   

    function openModal(item) { 
      $uibModal.open({
        templateUrl: 'app/issues/updateIssueItemQuantity.html',
        controller: 'UpdateIssueItemQuantityModalCtrl',       
        controllerAs: 'vm',
        size: 'lg',
        resolve: {         
          lineItem:function(){
            return angular.copy(item);
          },          
          isReadOnly: function(){
            return vm.isReadOnly;
          },
          updateItem: function(){
            return vm.updateItem;
          }
        }
      });
    }

  }

  angular
    .module('app.issues')
    .controller('UpdateIssueItemQuantityModalCtrl', UpdateIssueItemQuantityModalCtrl);

    UpdateIssueItemQuantityModalCtrl.$inject = ['$uibModalInstance', '$timeout','SweetAlert', 'lineItem', 'isReadOnly','updateItem'];

  function UpdateIssueItemQuantityModalCtrl($uibModalInstance, $timeout,SweetAlert, lineItem,isReadOnly,updateItem) {
    var vm = this;
    vm.lineItem = lineItem;
    vm.isReadOnly = true;
    vm.updateItem = updateItem;
    vm.location = vm.lineItem.warehouseName +'/' +vm.lineItem.locationName ;

    activate();

    ///////////////////////////////

    function activate() {
      
    }

    vm.ok = function () {

      vm.saving = true;

      var itemToAdd = {
        availableQuantity: vm.lineItem.availableQuantity,
        barcode: vm.lineItem.barcode,
        description: vm.lineItem.description,
        id: vm.lineItem.id,
        issueDescription: vm.lineItem.issueDescription,
        issueId: vm.lineItem.issueId,
        issueNumber: vm.lineItem.issueNumber,
        locationName: vm.lineItem.locationName,
        materialCode: vm.lineItem.materialCode,
        oldSelectedQuantity: vm.lineItem.oldSelectedQuantity,
        selectedQuantity: vm.lineItem.selectedQuantity,
        storedItemId: vm.lineItem.storedItemId,
        storedItemLocationId: vm.lineItem.storedItemLocationId,
        warehouseName: vm.lineItem.warehouseName,
        workpack: vm.lineItem.workpack        
      };
     
      updateItem(itemToAdd).then(function (response) {
        var response = response;
        if (response.responseMessage === 'Success' || response == ""){
          vm.saved = true;
          vm.saving = false;
          vm.lineItem.oldSelectedQuantity = itemToAdd.selectedQuantity;
          $uibModalInstance.close();
          $timeout(function () {
            SweetAlert.swal("Saved!", "The issue item has been saved successfully.", "success");
          }, 500);
        }
        else{
          vm.errorMessage = response.responseMessage;
          vm.saved = false;
          vm.error = true;
          vm.saving = false;
        }
      });           
    };

       vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };    
  }
  
  
})();

(function () {
  'use strict';

  angular
    .module('app.issues')
    .directive('wgStoredItemPicklist', wgStoredItemPicklist);

  wgStoredItemPicklist.$inject = [];

  /* @ngInject */
  function wgStoredItemPicklist() {
    var directive = {
      bindToController: true,
      controller: StoredItemPicklistDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/issues/storedItemPicklist.html",
      scope: {
        item: '=',
        addItem: '&'
      }
    };
    return directive;

    function link(scope, element, attrs) {
    }
  }

  StoredItemPicklistDirCtrl.$inject = ['$scope'];

  /* @ngInject */
  function StoredItemPicklistDirCtrl($scope) {
    var vm = this;
    vm.item = this.item;

    vm.loading = false;
    vm.validationErrors = false;
    vm.addItem = this.addItem;
    vm.showValidationErrors = showValidationErrors;

    activate();

    ////////////////////////

    function activate() {

    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.issues')
    .controller('CreateIssueCtrl', CreateIssueCtrl);

  CreateIssueCtrl.$inject = ['issueService', '$state', 'OidcManager', 'SETTINGS', 'API'];
  /* @ngInject */
  function CreateIssueCtrl(issueService, $state, OidcManager, SETTINGS, API) {
    if ($state.transition) return;

    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;
    vm.loading = false;
    vm.issue = {
      description: '',
      costCode: '',
      picklistId: ''
    };

    /** Cost Codes */
    vm.codeCodes = [];
    vm.costCodesOptions = [];

    /** Picklists */
    vm.picklists = [];
    vm.picklistsOptions = [];

    vm.createIssue = createIssue;
    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;

    activate();

    /////////////////////

    function activate() {

    }

    function createIssue() {
      vm.loading = true;
      return issueService.createIssue(vm.issue)
        .then(function(response) {
          vm.hasErrors = false;
          $state.transitionTo('issues.details', {id: response.issueId});
        }, function(error){
          vm.hasErrors = true;
          showValidationErrors(error);
        });
    }

    function showValidationErrors(error){
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessages);
        }
      } else {
        vm.validationErrors.push('Could not create issue.');
      }
      vm.loading = false;
    }

    /** Cost Codes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.costCodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false
    };

    /** Picklists */

    vm.picklists = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/picklists/picking",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.picklistsOptions = {
      placeholder: "(Optional)",
      dataSource: vm.picklists,
      dataTextField: "number",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      template: '<span class="k-state-default">#: number # - #: description #</span>'
    };

  }

})();

(function () {
  'use strict';

  angular.module('app.inspections', []);

})();

(function () {
  'use strict';

  angular
    .module('app.inspections')
    .directive('wgViewVendorInspectionHistory', wgViewVendorInspectionHistory);

  wgViewVendorInspectionHistory.$inject = [];
  /* @ngInject */

  function wgViewVendorInspectionHistory() {
    var directive = {
      bindToController: true,
      controller: ViewVendorInspectionHistoryCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/inspections/viewVendorInspectionHistory.html',
      scope: {
        id: '='
      }
    };

    return directive;

    function link(scope, element, attrs) {

    }
  }

  ViewVendorInspectionHistoryCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function ViewVendorInspectionHistoryCtrl($uibModal) {
    var vm = this;

    vm.id = this.id;

    vm.openHistory = openHistory;

    function openHistory() {
      $uibModal.open({
        templateUrl: 'app/inspections/viewVendorInspectionHistoryModal.html',
        controller: 'ViewVendorInspectionHistoryModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          id: function () {
            return vm.id;
          }
        }
      });
    }

  }

  angular
    .module('app.inspections')
    .controller('ViewVendorInspectionHistoryModalCtrl', ViewVendorInspectionHistoryModalCtrl);

  ViewVendorInspectionHistoryModalCtrl.$inject = ['$uibModalInstance', 'deliveryService', 'id'];

  function ViewVendorInspectionHistoryModalCtrl($uibModalInstance, deliveryService, id) {
    var vm = this;

    vm.id = id;
    vm.item = {};
    vm.items = [];
    vm.loading = true;

    activate();

    /////////////////////////

    function activate() {
      getVendorInspectionHistory();
    }

    function getVendorInspectionHistory() {
      return deliveryService.getVendorInspectionHistory(vm.id)
        .then(function (response) {
          vm.items = response;
          vm.item = vm.items[0];
          vm.loading = false;
        });
    }

    vm.cancel = function (){
      $uibModalInstance.dismiss('cancel');
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app.inspections')
    .controller('ViewInspectionsCtrl', ViewInspectionsCtrl);

  ViewInspectionsCtrl.$inject = ['$filter', 'deliveryService', 'API', 'SETTINGS', 'OidcManager'];
  /* @ngInject */

  function ViewInspectionsCtrl($filter, deliveryService, API, SETTINGS, OidcManager) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.completedInspections = [];
    vm.incompleteInspections = [];
    vm.supplierSelected = { supplierCode: 0, supplierName: 'ALL' };
    vm.timeInterval = { value : 'yy:-1', text: 'OVERDUE' };
    vm.activeTab = 'incomplete';

    vm.lastSupplier = '';
    vm.lastTime = '';
    vm.purchaseOrderSelected = null;

    vm.inspectionCompleted = inspectionCompleted;
    vm.getVendorInspectionsIncomplete = getVendorInspectionsIncomplete;
    vm.setActiveTab = setActiveTab;

    activate();

    ///////////////////////

    function activate(){
      getVendorInspectionsComplete();
      getVendorInspectionsIncomplete();
    }

    function getVendorInspectionsComplete() {
      deliveryService.getVendorInspectionsComplete()
        .then(function(response) {
          vm.completedInspections = response;
        });
    }

    function getVendorInspectionsIncomplete() {
      deliveryService.getVendorInspectionsIncomplete(vm.supplierSelected.supplierCode, vm.timeInterval.value, vm.purchaseOrderSelected)
        .then(function(response) {
          vm.incompleteInspections = response;
          vm.lastSupplier = angular.copy(vm.supplierSelected.supplierName);
          vm.lastTime = angular.copy(vm.timeInterval.text);
        });
    }

    function inspectionCompleted(id, passedQuantity) {
      if (id !== undefined) {
        var item = $filter('filter')(vm.incompleteInspections, {id: id})[0];
        if (item !== undefined) {
          if (item.quantityRequiringInspection - parseFloat(passedQuantity) === 0) {
            var index = vm.incompleteInspections.indexOf(item);
            vm.incompleteInspections.splice(index, 1);
            getVendorInspectionsComplete();
          } else {
            item.quantityRequiringInspection = item.quantityRequiringInspection - parseFloat(passedQuantity);
          }
        }
      }
    }

    function setActiveTab(tab){
      vm.activeTab = tab;
    }

    /** Suppliers */

    vm.suppliers = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-orders/suppliers-with-inspection",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.supplierOptions = {
      dataSource: vm.suppliers,
      dataTextField: "supplierName",
      dataValueField: "supplierCode",
      filter: "contains",
      autoBind: false,
      template: '<span class="k-state-default">#: supplierName #</span>'
    };


    /** Order by */
    vm.timeIntervalData = {
      transport: {
        read: function(options) {
          options.success([
            {'value' : 'yy:-1', 'text' : 'OVERDUE'},
            {'value' : 'ww:1', 'text' : '1 week'},
            {'value' : 'ww:2', 'text' : '2 weeks'},
            {'value' : 'ww:3', 'text' : '3 weeks'},
            {'value' : 'm:1', 'text' : '1 month'},
            {'value' : 'm:3', 'text' : '3 months'},
            {'value' : 'm:6', 'text' : '6 months'}

          ]);
        }
      }
    };

    vm.timeIntervalOptions = {
      dataSource: vm.timeIntervalData,
      dataTextField: 'text',
      dataValueField: 'value',
      autoBind: false
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app.expediting')
    .controller('ViewExpeditingCtrl', ViewExpeditingCtrl);

  ViewExpeditingCtrl.$inject = ['deliveryService', 'SETTINGS', 'API', 'OidcManager', '$stateParams', '$filter'];
  /* @ngInject */

  function ViewExpeditingCtrl(deliveryService, SETTINGS, API, OidcManager, $stateParams, $filter) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;
    vm.lines = [];
    vm.loading = false;

    vm.purchaseOrderSelected = null;
    vm.buyerNameSelected = null;
    vm.timeIntervals = [
      {'value' : 'ww:1', 'text' : '1 week'},
      {'value' : 'ww:2', 'text' : '2 weeks'},
      {'value' : 'ww:3', 'text' : '3 weeks'},
      {'value' : 'ww:4', 'text' : '4 weeks'},
      {'value' : 'ww:6', 'text' : '6 weeks'},
      {'value' : 'ww:8', 'text' : '8 weeks'},
      {'value' : 'ww:12', 'text' : '12 weeks'},
      {'value' : 'm:6', 'text' : '6 months'},
      {'value' : 'yy:-1', 'text' : 'OVERDUE'},
      {'value' : null, 'text' : 'ALL'}
    ];

    vm.timeInterval =  $filter('filter')(vm.timeIntervals, {value: ($stateParams ? $stateParams.timeInterval : 'ww:1')})[0];

    vm.lastBuyer = '';
    vm.lastTime = '';
    vm.lastPO = '';

    vm.getPurchaseOrderLinesForExpediting = getPurchaseOrderLinesForExpediting;

    activate();

    ///////////////////////

    function activate(){
      getPurchaseOrderLinesForExpediting();
    }


    function getPurchaseOrderLinesForExpediting() {
      vm.loading = true;

      vm.timeInterval = vm.timeInterval ? vm.timeInterval : { value : 'ww:1', text: '1 week' };

      deliveryService.getPurchaseOrderLinesForExpediting( vm.timeInterval.value, vm.buyerNameSelected, vm.purchaseOrderSelected )
        .then(function(response) {
          vm.lines = response;
          vm.loading = false;

          vm.lastBuyer = angular.copy(vm.buyerNameSelected);
          vm.lastTime = angular.copy(vm.timeInterval.text);
          vm.lastPO = angular.copy(vm.purchaseOrderSelected);
        });
    }


    /** Order by */
    vm.timeIntervalData = {
      transport: {
        read: function(options) {
          options.success(vm.timeIntervals);
        }
      }
    };

    vm.timeIntervalOptions = {
      dataSource: vm.timeIntervalData,
      dataTextField: 'text',
      dataValueField: 'value',
      autoBind: false,
      placeholder: "1 week",
      databound: function() {
        var noItems = this.list.find(".noDataMessage");

        if (!this.dataSource.view()[0]) {
          noItems.show();
          this.popup.open();
        } else {
          noItems.hide();
        }
      },
      close: function(e) {
        var widget = e.sender;

        if (!widget.shouldClose && !this.dataSource.view()[0]) {
          e.preventDefault();
        }
      }
    };

    /** PurchaseOrder */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrderOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      template: '{{dataItem.number + " - " + dataItem.supplierName + " (" + (dataItem.date|date:"MM/dd/yyyy") + ")"}}',
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      placeholder: "ALL"
    };

    /** Buyer names */

    vm.buyerNames = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/purchase-order-lines/buyer-names",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      }
    };

    vm.buyerNameOptions = {
      dataSource: vm.buyerNames,
      dataTextField: "buyerName",
      dataValueField: "buyerName",
      filter: "contains",
      autoBind: false,
      placeholder: "ALL",
      template: '<span class="k-state-default">#: buyerName #</span>',
    };
  }

})();

(function () {
  'use strict';

  angular
    .module('app.expediting')
    .directive('wgOneWeekExpediting', wgOneWeekExpediting);

  wgOneWeekExpediting.$inject = [];

  /* @ngInject */
  function wgOneWeekExpediting() {
    var directive = {
      bindToController: true,
      controller: OneWeekExpeditingCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/expediting/oneWeekExpediting.html",
      scope: {
        timeInterval: '=',
        title: '='
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  OneWeekExpeditingCtrl.$inject = ['deliveryService'];

  /* @ngInject */
  function OneWeekExpeditingCtrl(deliveryService) {
    var vm = this;
    vm.timeInterval = this.timeInterval;
    vm.title = this.title;
    vm.lines = [];
    vm.currentPage = 1;
    vm.loading = true;

    activate();

    function activate(){
      deliveryService.getPurchaseOrderLinesForExpediting(vm.timeInterval, null)
        .then(function(response) {
         vm.lines = response;
          vm.loading = false;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .controller('ViewDeliveryCtrl', ViewDeliveryCtrl);

  ViewDeliveryCtrl.$inject = ['deliveryService', '$state'];

  /* @ngInject */
  function ViewDeliveryCtrl(deliveryService, $state) {
    var vm = this;
    vm.openDeliveries = [];
    vm.completeDeliveries = [];
    vm.checkingDeliveries = [];
    vm.inspectionDeliveries = [];
    vm.potentialOverageDeliveries = [];
    vm.storingDeliveries = [];
    vm.storedDeliveries = [];

    vm.setActiveTab = setActiveTab;

    vm.tabs = {
      incompleteActive: true,
      checkingActive: false,
      inspectionActive: false,
      osdActive: false,
      storingActive: false,
      storedActive: false
    };

    activate();

    ////////////////

    function activate() {

      deliveryService.getIncompleteDeliveries()
        .then(function(response) {
          vm.openDeliveries = response;
        });

      deliveryService.getCompleteDeliveries()
        .then(function(response) {
          vm.completeDeliveries = response;
        });

      deliveryService.getCheckingDeliveries()
        .then(function(response) {
          vm.checkingDeliveries = response;
        });

      deliveryService.getInspectionDeliveries()
        .then(function(response) {
          vm.inspectionDeliveries = response;
        });

      deliveryService.getOutstandingOsdDeliveries()
        .then(function(response) {
          vm.potentialOverageDeliveries = response;
        });

      deliveryService.getStoringDeliveries()
        .then(function(response) {
          vm.storingDeliveries = response;
        });

      deliveryService.getStoredDeliveries()
        .then(function(response) {
          vm.storedDeliveries = response;
        });

      vm.setActiveTab();
    }

    function setActiveTab(){
      if($state.current.url=='stored'){
        vm.tabs.storedActive = true;
      }
      else if($state.current.url=='storing'){
        vm.tabs.storingActive = true;
      }
      else if($state.current.url=='inspection'){
        vm.tabs.inspectionActive = true;
      }
      else if($state.current.url=='osd'){
        vm.tabs.osdActive = true;
      }
      else if($state.current.url=='checking'){
        vm.tabs.checkingActive = true;
      }
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgUnstoredStockItemLocation', wgUnstoredStockItemLocation);

  wgUnstoredStockItemLocation.$inject = [];

  /* @ngInject */
  function wgUnstoredStockItemLocation() {
    var directive = {
      bindToController: true,
      controller: UnstoredStockItemLocationCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        warehouses: '=',
        locations: '=',
        deliveryId: '=',
        getStockItems: '&'
      },
      templateUrl: 'app/deliveries/unstoredStockItemLocation.html'
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  UnstoredStockItemLocationCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function UnstoredStockItemLocationCtrl($uibModal) {
    var vm = this;
    vm.locations = this.locations;
    vm.deliveryId = this.deliveryId;
    vm.getStockItems = this.getStockItems;

    vm.openSetAllLocations = openSetAllLocations;

    activate();

    ////////////////

    function activate() {

    }

    function openSetAllLocations() {
       $uibModal.open({
         templateUrl: 'app/deliveries/unstoredStockItemLocationModal.html',
         controller: 'UnstoredStockItemLocationModalCtrl',
         controllerAs: 'vm',
         resolve: {
           locations: function () {
             return vm.locations;
           },
           deliveryId: function () {
             return vm.deliveryId;
           },
           getStockItems: function () {
             return vm.getStockItems;
           }
         }
       });
    }
  }

  angular
    .module('app.deliveries')
    .controller('UnstoredStockItemLocationModalCtrl', UnstoredStockItemLocationModalCtrl);

  UnstoredStockItemLocationModalCtrl.$inject = ['$uibModalInstance', 'deliveryService', 'locations', 'deliveryId', 'getStockItems'];

  function UnstoredStockItemLocationModalCtrl($uibModalInstance, deliveryService, locations, deliveryId, getStockItems) {
    var vm = this;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.locations = locations;
    vm.deliveryId = deliveryId;
    vm.getStockItems = getStockItems;

    vm.ok = ok;
    vm.cancel = cancel;

    activate();


    ////////////////

    function activate() {

    }

    function ok() {

      if (vm.location !== null) {
        vm.saving = true;
        vm.saved = false;

        var deliveryStockItem = {
          deliveryId: vm.deliveryId,
          locationId: vm.location.id
        };

        return deliveryService.storeAllUnstoredStockItems(deliveryStockItem)
          .then(function (response) {
            vm.getStockItems();
            vm.error = false;
            vm.saved = true;
            vm.saving = false;
          }, function() {

            vm.saved = false;
            vm.error = true;
            vm.saving = false;
          });
      }
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel');
    }

    vm.locationsOptions = {
      autobind: false,
      dataSource: {
        data: vm.locations,
        group: {field: "warehouseName"}
      },
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>",
      valueTemplate: ' #:warehouseName# - #:name#'
    };
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .controller('StockItemsCtrl', StockItemsCtrl);

  StockItemsCtrl.$inject = ['$scope', '$stateParams', '$filter', 'deliveryService', 'SweetAlert'];

  /* @ngInject */
  function StockItemsCtrl($scope, $stateParams, $filter, deliveryService, SweetAlert) {
    var vm = this;
    vm.deliveryId = $stateParams.id;
    vm.loading = false;
    /** Locations */
    vm.locations = [];

    vm.stockItems = [];

    vm.location = {};
    vm.getLocations = getLocations;

    vm.getStockItems = getStockItems;

    vm.anyInvalid = false;
    vm.checkForInvalid = checkForInvalid;
    vm.setAllLocations = setAllLocations;

    $scope.$on('osd-registered', getStockItems);
    $scope.$on('checking-complete', getStockItems);

    activate();

    ////////////////

    function activate() {
      return vm.getLocations().then(function() {
        return vm.getStockItems();
      });
    }

    function getLocations() {
      return deliveryService.getLocations()
        .then(function(response) {
          vm.locations = response;
          return vm.locations;
        });
    }


    function getStockItems() {
      return deliveryService.getStockItems(vm.deliveryId)
        .then(function(response) {
          vm.stockItems = response;
          vm.checkForInvalid();
          return vm.stockItems;
        });
    }

    function checkForInvalid(){
      vm.anyInvalid = false;
      angular.forEach(vm.stockItems, function(value, key){
        if (value.checkedEqualsStored == false){
          vm.anyInvalid = true;
        }
      });
    }

    function setAllLocations() {
      if (vm.location !== null) {
        vm.loading = true;
        vm.validationErrors = false;
        var deliveryStockItem = {
          deliveryId: vm.deliveryId,
          locationId: vm.location.id
        };

        return deliveryService.storeAllUnstoredStockItems(deliveryStockItem)
          .then(function (response) {
            vm.loading = false;
            vm.getStockItems();
          }, function (error) {
            showValidationErrors(error);
          });
      }
      else{
        vm.validationErrors = true;
      }
    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
      SweetAlert.swal({title: "Error", text: error.data, type: "error", html:true});
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgStockItemLocation', wgStockItemLocation);

  wgStockItemLocation.$inject = [];

  /* @ngInject */
  function wgStockItemLocation() {
    var directive = {
      bindToController: true,
      controller: StockItemLocationDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/deliveries/stockItemLocation.html",
      scope: {
        stockItemLocation: '=',
        item: '=',
        locations: '=',
        isReadonly: '=',
        hadOsd: '=',
        isComplete: '=',
        index: '@',
        getStockItem: '&'
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  StockItemLocationDirCtrl.$inject = ['$scope','$timeout','deliveryService', 'SweetAlert', '$filter'];

  /* @ngInject */
  function StockItemLocationDirCtrl($scope, $timeout, deliveryService, SweetAlert, $filter) {
    var vm = this;
    vm.stockItemLocation = this.stockItemLocation;
    vm.item = this.item;
    vm.isReadonly = this.isReadonly;
    vm.hadOsd = this.hadOsd;
    vm.isComplete = this.isComplete;
    vm.index = this.index;
    vm.locationsOptions = this.locationsOptions;
    vm.locations = this.locations;
    vm.getStockItem = this.getStockItem;

    vm.locationSelectedId = vm.stockItemLocation.locationId;

    $scope.$watch('vm.stockItemLocation.locationId', function(newVal, oldVal, sco){

      var dataSource = new kendo.data.DataSource({
        data: $filter('filter')(vm.locations, function(value){ return value.id === newVal }),
        group: {field: "warehouseName"}
      });
    
      var dropdownlist = $("#" + sco.vm.stockItemLocation.id).data("kendoDropDownList")
      if(dropdownlist && newVal !== oldVal)
        dropdownlist.setDataSource(dataSource);

      vm.locationSelectedId = newVal; 
    });

    vm.loading = false;
    vm.loadingRemoveButton = false;
    vm.validationErrors = false;
    vm.millisecondsToWaitBeforeSave = 700;
    vm.timeout = undefined;

    vm.removeStockItemLocation = removeStockItemLocation;
    vm.saveUpdates = saveUpdates;
    vm.debounceUpdate = debounceUpdate;
    vm.showValidationErrors = showValidationErrors;
    vm.locationChanged = locationChanged;

   $scope.$watch('vm.stockItemLocation.quantity', debounceUpdate);

    activate();

    ////////////////

    function activate() {

    }


    function saveUpdates() {
      vm.validationErrors = false;
      var quantityToUpdate = {
        stockItemId: vm.item.id,
        id: vm.stockItemLocation.id,
        quantity: vm.stockItemLocation.quantity
      };

      return deliveryService.updateStockItemLocationQuantity(quantityToUpdate)
        .then(function(response) {
          vm.loading = false;
          vm.getStockItem();
        },function(error){
          showValidationErrors(error);
          vm.getStockItem();
        });
    }


    function removeStockItemLocation() {
      vm.loading = true;
      vm.loadingRemoveButton = true;
      vm.validationErrors = false;
      var stockItemLocationToRemove = {
        stockItemId: vm.item.id,
        id: vm.stockItemLocation.id
      };

      return deliveryService.removeStockItemLocation(stockItemLocationToRemove)
        .then(function(response) {
          vm.loading = false;
          vm.loadingRemoveButton = false;
          vm.getStockItem();
        },function(error){
          showValidationErrors(error);
        });
    }

    function debounceUpdate(newValue, oldValue) {
      if (newValue != oldValue) {

        if (vm.timeout) {
          $timeout.cancel(vm.timeout);
        }
        vm.loading = true;
        vm.timeout = $timeout(vm.saveUpdates, vm.millisecondsToWaitBeforeSave);

      }
    }


    function locationChanged() {
      if (vm.locationSelectedId !== null) {
        vm.loading = true;
        vm.validationErrors = false;
        var itemToUpdate = {
          stockItemId: vm.item.id,
          id: vm.stockItemLocation.id,
          locationId: vm.locationSelectedId,
          quantity: vm.stockItemLocation.quantity
        };

        return deliveryService.setStockItemLocationQuantity(itemToUpdate)
          .then(function (response) {
            vm.loading = false;
          }, function (error) {
            showValidationErrors(error);
          });
      }
      else{
        vm.validationErrors = true;
      }
    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
      vm.loadingRemoveButton = false;
      SweetAlert.swal({title: "Error", text: error.data, type: "error", html:true});
    }

    vm.locationsOptions = {
      autobind: false,
      dataSource: {
        data: $filter('filter')(vm.locations, function(value){ return value.id === vm.locationSelectedId }),
        group: {field: "warehouseName"}
      },
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>",
      valueTemplate: ' #:warehouseName# - #:name#',
      open: function(){
        var dataSource = new kendo.data.DataSource({
          data: vm.locations,
          group: {field: "warehouseName"}
        });
        $(this)[0].setDataSource(dataSource);
      }
    };
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgStockItem', wgStockItem);

  wgStockItem.$inject = [];

  /* @ngInject */
  function wgStockItem() {
    var directive = {
      bindToController: true,
      controller: StockItemDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/deliveries/stockItem.html",
      scope: {
        item: '=',
        locations: '=',
        isReadonly: '=',
        getStockItems: '&',
        hideDescription: '='
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  StockItemDirCtrl.$inject = ['$scope','deliveryService'];

  /* @ngInject */
  function StockItemDirCtrl($scope, deliveryService) {
    var vm = this;
    vm.item = this.item;
    vm.warehouses = this.warehouses;
    vm.locations = this.locations;
    vm.isReadonly = this.isReadonly;
    vm.getStockItems = this.getStockItems;

    vm.warehouse = {
      id:vm.item.warehouseId,
      name:vm.item.warehouseName
    };

    vm.location = {
      id:vm.item.locationId,
      name:vm.item.locationName
    };

    vm.loading = false;
    vm.validationErrors = false;

    vm.refreshProgressBar = refreshProgressBar;
    vm.addStockItemLocation = addStockItemLocation;
    vm.getStockItem = getStockItem;
    vm.showValidationErrors = showValidationErrors;

    if(!vm.isReadonly) {
      $scope.$watch('vm.item.checkedEqualsStored', function () {
        vm.getStockItems();
      });
    }

    activate();

    ////////////////

    function activate() {
      refreshProgressBar();
    }

    function refreshProgressBar(){
      vm.progressbarType = vm.item.totalQuantity === vm.item.totalStoredQuantity ? "primary" : "warning";
    }

    function getStockItem() {
      return deliveryService.getStockItem(vm.item.id)
        .then(function (response) {
          vm.item = response;
          vm.refreshProgressBar();
          return vm.item;
        });
    }

    function addStockItemLocation() {
      vm.loading = true;
      vm.validationErrors = false;

      var itemToAdd = {
        stockItemId: vm.item.id,
        deliveryId: vm.item.deliveryId
      };

      return deliveryService.addStockItemLocation(itemToAdd)
        .then(function (response) {
          vm.loading = false;
          vm.getStockItem();
        }, function (error) {
          showValidationErrors(error);
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .controller('SaveDeliveryCtrl', SaveDeliveryCtrl);

  SaveDeliveryCtrl.$inject = ['$scope','$timeout','deliveryService', 'purchaseOrderService'];

  /* @ngInject */
  function SaveDeliveryCtrl($scope, $timeout, deliveryService, purchaseOrderService) {
    var vm = this;
    vm.loading = false;
    vm.validationErrors = false;
    vm.millisecondsToWaitBeforeSave = 700;
    vm.timeout = undefined;

    vm.quantityToDisplay = quantityToDisplay;

    vm.includedChanged = includedChanged;
    vm.saveUpdates = saveUpdates;
    vm.debounceUpdate = debounceUpdate;
    vm.showValidationErrors = showValidationErrors;
    vm.setLinesReceivability = setLinesReceivability;

    $scope.$watch('line.statedQuantity', debounceUpdate);

    $scope.$watch('line.isIncluded', includedChanged);

    $scope.$watch('line.isNonReceivable', nonReceivableChanged);

    activate();

    ////////////////

    function activate() {

    }


    function saveUpdates() {
      vm.validationErrors = false;
      var quantityToUpdate = {
        deliveryLineId: $scope.line.id,
        quantity: $scope.line.statedQuantity
      };

      return deliveryService.updateDeliveryLineQuantity(quantityToUpdate)
        .then(function(response) {
          vm.loading = false;
        },function(error){
          showValidationErrors(error);
        });
    }


    function setLinesReceivability(deliveryLine){
      deliveryLine.isNonReceivable = !deliveryLine.isNonReceivable;
      deliveryLine.isIncluded = false;
    }

    function quantityToDisplay() {
      if ($scope.line.isIncluded) {
        vm.quantityToDisplay = $scope.line.statedQuantity;
      }
      else {
        vm.quantityToDisplay = '';
      }
    }

    function nonReceivableChanged (newValue, oldValue){
      if (newValue !== oldValue) {
        var lineToUpdate = {
          purchaseOrderLineId: $scope.line.purchaseOrderLineId,
          isNonReceivable: $scope.line.isNonReceivable
        };

        return purchaseOrderService.updatePOLineReceivability(lineToUpdate)
          .then(function (response) {
          }, function (error) {
            showValidationErrors(error);
          });
      }
    }

    function includedChanged(newValue, oldValue) {
      if (newValue !== oldValue) {
        var lineToUpdate = {
          deliveryLineId: $scope.line.id,
          included: $scope.line.isIncluded
        };

        return deliveryService.updateDeliveryLineInclusion(lineToUpdate)
          .then(function (response) {
          }, function (error) {
            showValidationErrors(error);
          });
      }
    }

    function debounceUpdate(newValue, oldValue) {
      if (newValue != oldValue) {

        if (vm.timeout) {
          $timeout.cancel(vm.timeout);
        }
        vm.loading = true;
        vm.timeout = $timeout(saveUpdates, vm.millisecondsToWaitBeforeSave);

      }
    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .controller('OverShortAndDamagedCtrl', OverShortAndDamagedCtrl);

  OverShortAndDamagedCtrl.$inject = ['$scope', '$stateParams', 'deliveryService'];

  /* @ngInject */
  function OverShortAndDamagedCtrl($scope, $stateParams, deliveryService) {
    var vm = this;
    vm.deliveryId = $stateParams.id;
    vm.loading = false;

    vm.fullOsdItems = [];

    vm.displayOverages = displayOverages;
    vm.getFullOsdItems = getFullOsdItems;

    $scope.$on('checking-complete', activate);
    $scope.$on('osd-registered', activate);

    activate();

    ////////////////

    function activate() {

      vm.displayOverages();
    }

    function displayOverages() {

      return getFullOsdItems().then(function () {
      });
    }

    function getFullOsdItems() {
      return deliveryService.getFullOsdItems(vm.deliveryId)
        .then(function (response) {
          vm.fullOsdItems = response;
          return vm.fullOsdItems;
        });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .controller('InspectionsCtrl', InspectionsCtrl);

  InspectionsCtrl.$inject = ['$scope', '$stateParams', '$uibModal', '$filter', 'deliveryService', 'permissionService', 'OidcManager'];

  /* @ngInject */
  function InspectionsCtrl($scope, $stateParams, $uibModal, $filter, deliveryService, permissionService, OidcManager) {
    var vm = this;
    vm.deliveryId = $stateParams.id;
    vm.loading = false;

    vm.manager = OidcManager.OidcTokenManager();

    vm.fullOsdItems = [];
    vm.selectedAll = false;

    vm.displayInspections = displayInspections;
    vm.getFullOsdItems = getFullOsdItems;
    vm.inspectItems = inspectItems;

    $scope.$on('checking-complete', activate);
    $scope.$on('short-registered', activate);

    activate();

    ////////////////

    function activate() {
      vm.isAdmin = isAdmin();
      vm.allowInspections = vm.isAdmin === true ? true : permissionService.hasPermission("Inspection", "Complete");

      vm.displayInspections();
    }

    function displayInspections() {
      return getFullOsdItems().then(function () {
        vm.selectedAll = false;
      });
    }

    function getFullOsdItems() {
      return deliveryService.getFullOsdItems(vm.deliveryId)
        .then(function (response) {
          vm.fullOsdItems = response;
          return vm.fullOsdItems;
        });
    }

    function inspectItems(items) {
      $uibModal.open({
        templateUrl: 'app/deliveries/inspection/addInspectionsModal.html',
        controller: 'AddInspectionsModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          items: function () {
            return $filter('filter')(items, function(item){ return item.isIncluded === true && (item.checkLine.requiresInspection === true || item.hasInspections === true) });
          },
          postUpdateDelegate: function () {
            return null;
          }
        }
      });
    }

    function isAdmin(){
      if (!vm.manager.expired){
        if (vm.manager.profile.role !== undefined){
          return vm.manager.profile.role.toUpperCase() === "ADMIN";
        } else {
          return false;
        }
      }
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgIncompleteDeliveries', wgIncompleteDeliveries);

  wgIncompleteDeliveries.$inject = [];

  /* @ngInject */
  function wgIncompleteDeliveries() {
    var directive = {
      bindToController: true,
      controller: IncompleteDeliveriesCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: "app/deliveries/incompleteDeliveries.html",
      scope: {}
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  IncompleteDeliveriesCtrl.$inject = ['deliveryService'];

  /* @ngInject */
  function IncompleteDeliveriesCtrl(deliveryService) {
    var vm = this;

    vm.deliveries = [];
    vm.currentPage = 1;
    vm.loading = true;

    activate();

    function activate(){
      deliveryService.getIncompleteDeliveries()
        .then(function(response) {
         vm.deliveries = response;
          vm.loading = false;
      });
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .controller('EditDeliveryCtrl', EditDeliveryCtrl);

  EditDeliveryCtrl.$inject = ['$rootScope', '$stateParams', 'deliveryService', 'stockService', 'SweetAlert'];

  /* @ngInject */
  function EditDeliveryCtrl($rootScope, $stateParams, deliveryService, stockService, SweetAlert) {
    var vm = this;

    vm.deliveryId = $stateParams.id;
    vm.delivery = {};
    vm.deliveryLines = [];
    vm.checkLines = [];

    vm.selectedAll = false;

    vm.getDelivery = getDelivery;
    vm.getDeliveryLines = getDeliveryLines;
    vm.getCheckLines = getCheckLines;

    vm.costCodes = [];
    vm.getCostCodes = getCostCodes;


    vm.validationErrors = [];
    vm.showValidationErrors = showValidationErrors;
    vm.completeDelivery = completeDelivery;
    vm.cancelDelivery = cancelDelivery;
    vm.completeChecking = completeChecking;
    vm.completeStoring = completeStoring;
    vm.cancelChecking = cancelChecking;
    vm.setActiveTab = setActiveTab;

    vm.deliveryStatus = "";

    vm.tabs = {
      deliveryActive: true,
      checkingActive: false,
      inspectionActive: false,
      osdActive: false,
      storeActive: false
    };

    $rootScope.$on('cost-code-updated', getDeliveryLines);
    $rootScope.$on('osd-registered', getDelivery);


    activate();

    ////////////////

    function activate() {

      return getDelivery().then(function () {
        return getDeliveryLines().then(function () {
          return getCostCodes().then(function () {
            return getCheckLines().then(function () {
              return setActiveTab();
            });
          });
        });
      });
    }

    function getDelivery() {
      return deliveryService.getDelivery(vm.deliveryId)
        .then(function (response) {
          vm.delivery = response;
          vm.deliveryStatus = setDeliveryStatus();
          return vm.delivery;
        });
    }

    function getDeliveryLines() {
      return deliveryService.getDeliveryLines(vm.deliveryId)
        .then(function (response) {
          vm.deliveryLines = response;

          return vm.deliveryLines;
        });
    }

    function getCheckLines() {
      return deliveryService.getCheckLines(vm.deliveryId)
        .then(function (response) {
          vm.checkLines = response;

          return vm.checkLines;
        });
    }

    function getCostCodes() {
      return stockService.getCostCodes()
        .then(function (response) {
          vm.costCodes = response;
          return vm.costCodes;
        });
    }

    function completeDelivery() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "You can not edit the delivery lines after it is confirmed!",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, confirm it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return deliveryService.completeDelivery(vm.deliveryId)
            .then(function (response) {
                vm.loading = false;
                activate();

                SweetAlert.swal("Confirmed!", "The delivery is now ready for checking.", "success");
              }, function (error) {
                showValidationErrors(error);
              }
            );
        });
    }

    function cancelDelivery() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "You can not edit the delivery after it is cancelled!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ED5565",
          confirmButtonText: "Yes, cancel it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return deliveryService.cancelDelivery(vm.deliveryId)
            .then(function (response) {
                vm.loading = false;
                activate();

                SweetAlert.swal("Cancelled!", "The delivery is now cancelled.", "success");

              }, function (error) {
                showValidationErrors(error);
              }
            );
        });
    }

    function completeChecking() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "Checking can not be edited after it is complete!",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, complete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return deliveryService.completeChecking(vm.deliveryId)
            .then(function (response) {
                vm.loading = false;
                activate();

                SweetAlert.swal("Completed!", "Checking is now complete.", "success");
                $rootScope.$broadcast('checking-complete');
              }, function (error) {
                showValidationErrors(error);
              }
            );
        });
    }

    function completeStoring() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "Storing can not be edited after it is complete!",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, store it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return deliveryService.completeStoring(vm.deliveryId)
            .then(function (response) {
                vm.loading = false;
                activate();

                SweetAlert.swal("Completed!", "Storing is now complete.", "success");

              }, function (error) {
                showValidationErrors(error);
              }
            );
        });
    }

    function cancelChecking() {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "Checking can not be edited after it is cancelled!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ED5565",
          confirmButtonText: "Yes, cancel it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return deliveryService.cancelChecking(vm.deliveryId)
            .then(function (response) {
                vm.loading = false;
                activate();

                SweetAlert.swal("Cancelled!", "Checking is now cancelled.", "success");

              }, function (error) {
                showValidationErrors(error);
              }
            );
        });
    }

    function showValidationErrors(error) {

      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not complete delivery.');
      }
      vm.loading = false;
    }


    function setActiveTab() {

      if (vm.delivery.hasInspections) {
        vm.tabs.inspectionActive = true;
      }
      else if (vm.delivery.hasPotentialOsd || vm.delivery.hasInterventions || vm.delivery.hasOutstandingShort) {
        vm.tabs.osdActive = true;
      }
      else if (vm.delivery.storingStatus === 'Storing' || vm.delivery.storingStatus === 'Stored') {
        vm.tabs.storeActive = true;
      }
      if (vm.delivery.checkingStatus === 'Checking') {
        vm.tabs.checkingActive = true;
      }
      if (vm.delivery.deliveryStatus === 'Incomplete') {
        vm.tabs.deliveryActive = true;
      }
    }

    function setDeliveryStatus(){
      return vm.delivery.deliveryStatus === 'Cancelled' ? vm.delivery.deliveryStatus : vm.delivery.deliveryStatus === 'Complete' ? 'Delivered' : 'In delivery';
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgDeliveryLineSplit', deliveryLineSplitItem);

  deliveryLineSplitItem.$inject = [];

  /* @ngInject */
  function deliveryLineSplitItem() {
    var directive = {
      bindToController: true,
      controller: DeliveryLineSplitDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/deliveries/deliveryLineSplit.html",
      scope: {
        deliveryLineSplit: '=',
        line: '=',
        index: '@',
        getCheckLine: '&'
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  DeliveryLineSplitDirCtrl.$inject = ['$scope','$timeout','deliveryService'];

  /* @ngInject */
  function DeliveryLineSplitDirCtrl($scope, $timeout, deliveryService) {
    var vm = this;
    vm.deliveryLineSplit = this.deliveryLineSplit;
    vm.line = this.line;
    vm.index = this.index;
    vm.getCheckLine = this.getCheckLine;

    vm.loading = false;
    vm.validationErrors = false;
    vm.millisecondsToWaitBeforeSave = 700;
    vm.timeout = undefined;

    vm.removeDeliveryLineSplit = removeDeliveryLineSplit;
    vm.saveUpdates = saveUpdates;
    vm.debounceUpdate = debounceUpdate;
    vm.showValidationErrors = showValidationErrors;
    vm.interventionRequiredChanged = interventionRequiredChanged;

    $scope.$watch('vm.deliveryLineSplit.checkedQuantity', debounceUpdate);
    $scope.$watch('vm.deliveryLineSplit.interventionRequired', interventionRequiredChanged);

    activate();

    ////////////////

    function activate() {

    }


    function saveUpdates() {
      vm.validationErrors = false;
      var quantityToUpdate = {
        checkLineId: vm.line.id,
        barcode: vm.deliveryLineSplit.barcode,
        quantity: vm.deliveryLineSplit.checkedQuantity
      };

      return deliveryService.updateDeliveryLineSplitQuantity(quantityToUpdate)
        .then(function(response) {
          vm.loading = false;
          vm.getCheckLine();
        },function(error){
          showValidationErrors(error);
        });
    }

    function interventionRequiredChanged(newValue, oldValue) {
      if (newValue !== oldValue) {
        var lineToUpdate = {
          checkLineId: vm.line.id,
          barcode: vm.deliveryLineSplit.barcode,
          interventionRequired: vm.deliveryLineSplit.interventionRequired
        };

        return deliveryService.updateDeliveryLineSplitInterventionRequired(lineToUpdate)
          .then(function (response) {
          }, function (error) {
            showValidationErrors(error);
          });
      }
    }

    function removeDeliveryLineSplit() {
      vm.loading = true;
      vm.validationErrors = false;
      var deliveryLineSplitToRemove = {
        checkLineId: vm.line.id,
        barcode: vm.deliveryLineSplit.barcode
      };

      return deliveryService.removeDeliveryLineSplit(deliveryLineSplitToRemove)
        .then(function(response) {
          vm.loading = false;
          vm.getCheckLine();
        },function(error){
          showValidationErrors(error);
        });
    }

    function debounceUpdate(newValue, oldValue) {
      if (newValue != oldValue) {

        if (vm.timeout) {
          $timeout.cancel(vm.timeout);
        }
        vm.loading = true;
        vm.timeout = $timeout(saveUpdates, vm.millisecondsToWaitBeforeSave);

      }
    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .controller('CreateDeliveryCtrl', CreateDeliveryCtrl);

  CreateDeliveryCtrl.$inject = ['deliveryService', '$state', 'API', 'SETTINGS', 'OidcManager'];

  /* @ngInject */
  function CreateDeliveryCtrl(deliveryService, $state, API, SETTINGS, OidcManager) {
    if ($state.transition) return;

    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;
    var vm = this;
    vm.loading = false;


    vm.delivery = {
      purchaseOrderId : '',
      warehouseId : '',
      supplierDeliveryNumber : '',
      date : '',
      comments : '',
      movementId:'',
      purchaseOrderType: 'purchaseOrder'
    };
    vm.purchaseOrders = [];
    vm.purchaseOrdersOptions = [];

    vm.movements = [];
    vm.movementsOptions = [];

    vm.warehouses = [];
    vm.warehousesOptions = [];

    vm.calendar = {
      opened: {},
      dateFormat: 'dd-MMM-yyyy',
      dateOptions: {},
      maxDate: new Date(),
      open: function($event, which) {
        $event.preventDefault();
        $event.stopPropagation();
        vm.calendar.opened[which] = true;
      }
    };

    vm.createDelivery = createDelivery;
    vm.typeChanged = typeChanged;
    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;

    activate();

    ////////////////

    function activate() {



      vm.purchaseOrders = {
        type: 'odata-v4',
        pageSize: 40,
        serverPaging: true,
        serverFiltering: true,
        transport: {
          read: {
            url: API.BASE_URI_WAREHOUSE + 'odata/PurchaseOrdersOData',
            beforeSend: function(xhr) {
              xhr.setRequestHeader('Authorization', bearerToken)
            }
          }
        },
        filter:[
          { field: "code", operator: "eq", value: SETTINGS.projectCode },
          { field: "fullyReceived", operator: "eq", value: false }
        ]

      };

      vm.purchaseOrdersOptions = {
        height: 210,
        dataSource: vm.purchaseOrders,
        dataTextField: "number",
        dataValueField: "purchaseOrderId",
        filter: "contains",
        virtual: {
          itemHeight: 30
        },
        autoBind: false,
        template: '<span class="k-state-default">#: number # - #: supplierName # - #= kendo.toString(kendo.parseDate(date), \'dd-MMM-yyyy\') #</span>'
      };


      vm.movements = {
        transport: {
          read: {
            url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/movements/complete-for-delivery",
            beforeSend: function(xhr) {
              xhr.setRequestHeader('Authorization', bearerToken)
            }
          }
        }
      };

      vm.movementsOptions = {
        dataSource: vm.movements,
        dataTextField: "number",
        dataValueField: "id",
        filter: "contains",

        autoBind: false,
        template: '<span class="k-state-default">#: number # - #: description # </span>'
      };

      vm.warehouses = {
        transport: {
          read: {
            url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/warehouses",
            beforeSend: function(xhr) {
              xhr.setRequestHeader('Authorization', bearerToken)
            }
          }
        }
      };

      vm.warehousesOptions = {
        dataSource: vm.warehouses,
        dataTextField: "name",
        dataValueField: "id",
        template: '<span class="k-state-default">#: name #</span>'
      };

    }


    function createDelivery() {
      vm.loading = true;
      return deliveryService.createDelivery(vm.delivery)
          .then(function(response) {
            vm.hasErrors = false;
            $state.transitionTo('deliveries.details', {id: response.deliveryId} );

          },function(error){
            vm.hasErrors = true;
            showValidationErrors(error);
          });
    }

    function typeChanged(){
      if(vm.delivery.purchaseOrderType == "purchaseOrder") {
        vm.delivery.movementId = '';
      }
      else {
        vm.delivery.purchaseOrderId = '';
      }
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not record delivery.');
      }
      vm.loading = false;
    }

  }

})();


(function () {
  'use strict';

  angular
    .module('app.deliveries')
    .directive('wgCheckLine', wgCheckLine);

  wgCheckLine.$inject = [];

  /* @ngInject */
  function wgCheckLine() {
    var directive = {
      bindToController: true,
      controller: CheckLineDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/deliveries/checkLine.html",
      scope: {
        line: '=',
        isMovement: '=',
        costCodes: '='
      }
    };
    return directive;

    function link(scope, element, attrs) {
    }
  }

  CheckLineDirCtrl.$inject = ['$scope','$timeout','deliveryService', 'OidcManager', '$rootScope'];

  /* @ngInject */
  function CheckLineDirCtrl($scope, $timeout, deliveryService, OidcManager, $rootScope) {
    var vm = this;
    vm.line = this.line;
    vm.isMovement = this.isMovement;
    vm.costCodes = this.costCodes;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;
    vm.costCodeOptions = [];

    vm.loading = false;
    vm.validationErrors = false;
    vm.millisecondsToWaitBeforeSave = 700;
    vm.timeout = undefined;
    vm.includedChanged = includedChanged;
    vm.interventionRequiredChanged = interventionRequiredChanged;
    vm.costCodeChanged = costCodeChanged;

    vm.addDeliveryLineSplit = addDeliveryLineSplit;
    vm.getCheckLine = getCheckLine;
    vm.saveUpdates = saveUpdates;
    vm.debounceUpdate = debounceUpdate;
    vm.showValidationErrors = showValidationErrors;

    $scope.$watch('vm.line.checkedQuantity', debounceUpdate);
    $scope.$watch('vm.line.isIncluded', includedChanged);
    $scope.$watch('vm.line.interventionRequired', interventionRequiredChanged);
    $scope.$watch('vm.line.costCode', costCodeChanged);

    activate();

    ////////////////

    function activate() {

    }

    function saveUpdates() {
      vm.validationErrors = false;
      var quantityToUpdate = {
        checkLineId: vm.line.id,
        quantity: vm.line.checkedQuantity
      };

      return deliveryService.updateCheckLineQuantity(quantityToUpdate)
        .then(function(response) {
          vm.loading = false;
        },function(error){
          showValidationErrors(error);
        });
    }


    function addDeliveryLineSplit() {
      vm.loading = true;
      vm.validationErrors = false;

      return deliveryService.addDeliveryLineSplit(vm.line.id)
        .then(function (response) {
          vm.loading = false;
          vm.getCheckLine();
        }, function (error) {
          showValidationErrors(error);
        });
    }


    function getCheckLine() {
      return deliveryService.getCheckLine(vm.line.id)
        .then(function (response) {
          vm.line = response;
          return vm.line;
        });
    }

    function includedChanged(newValue, oldValue) {
      if (newValue !== oldValue) {
        var lineToUpdate = {
          checkLineId: vm.line.id,
          included: vm.line.isIncluded
        };

        return deliveryService.updateCheckLineInclusion(lineToUpdate)
          .then(function (response) {
          }, function (error) {
            showValidationErrors(error);
          });
      }
    }

    function interventionRequiredChanged(newValue, oldValue) {
      if (newValue !== oldValue) {
        var lineToUpdate = {
          checkLineId: vm.line.id,
          interventionRequired: vm.line.interventionRequired
        };

        return deliveryService.updateCheckLineInterventionRequired(lineToUpdate)
          .then(function (response) {
          }, function (error) {
            showValidationErrors(error);
          });
      }
    }

    function costCodeChanged(newValue, oldValue) {
      if (newValue !== oldValue) {
        var lineToUpdate = {
          checkLineId: vm.line.id,
          costCode: vm.line.costCode == null ? '' : vm.line.costCode,
          purchaseOrderLineId: vm.line.purchaseOrderLineId
        };

        return deliveryService.updateCostCode(lineToUpdate)
          .then(function (response) {
            $rootScope.$broadcast('cost-code-updated');
          }, function (error) {
            showValidationErrors(error);
          });
      }
    }

    function debounceUpdate(newValue, oldValue) {
      if (newValue != oldValue) {

        if (vm.timeout) {
          $timeout.cancel(vm.timeout);
        }
        vm.loading = true;
        vm.timeout = $timeout(saveUpdates, vm.millisecondsToWaitBeforeSave);

      }
    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }


    vm.costCodesOptions = {
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      suggest: true,
      value: vm.line.costCode,
      autoBind: true
    };

  }

})();


(function () {

  'use strict';

  angular
    .module('app.core', [
      /*
       * Angular modules
       */
      'ngCookies', 'ngTouch', 'ngSanitize', 'ngResource', 'ngAnimate', 'ngStorage',
      /*
       * Our reusable cross app code modules
       */
      'blocks.exception', 'blocks.logger', 'blocks.router',

      /*
       * 3rd Party modules
       */
      //'ui.router',
      'ui.bootstrap',
      'ui.bootstrap.datepicker',
      'ui.bootstrap.progressbar',
      'ODataResources',
      'angular.filter',
      'kendo.directives',
      'angularUtils.directives.dirPagination',
      'angularSpinners',
      'angular-ladda',
      'oitozero.ngSweetAlert',
      'underscore',
      'SignalR',
      'angularMoment',
      'naturalSort',
      'xeditable',
      'tableSort',
      'ngFileSaver',
      'dndLists',
      'ApplicationInsightsModule'
    ]);
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('permissionService', permissionService);

  permissionService.$inject = ['$filter', 'OidcManager', '$localStorage'];
  /* @ngInject */

  function permissionService($filter, OidcManager, $localStorage) {

    var oidcManager = OidcManager.OidcTokenManager();

    var service = {
      hasPermission: hasPermission,
      getDefaultProject: getDefaultProject,
      isAdmin: isAdmin
    };

    function hasPermission(resource, action){
      if (oidcManager.profile !== undefined){
        if (oidcManager.profile.hasOwnProperty(resource)){
          var resourceObj = oidcManager.profile[resource];
          if (isArray(resourceObj)){
            return $filter('filter')(resourceObj, action).length > 0;
          } else {
            return resourceObj.toUpperCase() === action.toUpperCase();
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    function isAdmin(){
      if (!oidcManager.expired){
        if (oidcManager.profile.role !== undefined){
          return oidcManager.profile.role.toUpperCase() === "ADMIN";
        } else {
          return false;
        }
      }
    }

    function getDefaultProject(){
      if ($localStorage.permissions !== undefined){
        var userProjects = $filter('filter')($localStorage.permissions.project);
        return userProjects;
      }
    }

    function isArray(obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    }

    return service;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('permissionInterceptor', permissionInterceptor)
    .config(['$httpProvider', function ($httpProvider) {
      $httpProvider.interceptors.push('permissionInterceptor');
    }]);

  permissionInterceptor.$inject = ['OidcManager', '$localStorage'];
  /* @ngInject */
  function permissionInterceptor(OidcManager, $localStorage) {
    var service = this;

    var oidcManager = OidcManager.OidcTokenManager();

    if (!oidcManager.expired) {
      oidcManager.oidcClient.loadUserProfile(oidcManager.access_token)
        .then(function (userInfoValues) {
          $localStorage.$default({
            permissions: userInfoValues
          });
        });
    }

    return service;
  }

})();

(function() {
  'use strict';

  /**
   * INSPINIA - Responsive Admin Theme
   * 2.3
   *
   * Custom scripts
   */

  $(document).ready(function () {

    // Full height
    function fix_height() {
      var heightWithoutNavbar = $("body > #wrapper").height() - 61;
      $(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

      var navbarHeigh = $('nav.navbar-default').height();
      var wrapperHeigh = $('#page-wrapper').height();

      if (navbarHeigh > wrapperHeigh) {
        $('#page-wrapper').css("min-height", navbarHeigh + "px");
      }

      if (navbarHeigh < wrapperHeigh) {
        $('#page-wrapper').css("min-height", $(window).height() + "px");
      }

      if ($('body').hasClass('fixed-nav')) {
        if (navbarHeigh > wrapperHeigh) {
          $('#page-wrapper').css("min-height", navbarHeigh - 60 + "px");
        } else {
          $('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
        }
      }
    }

    $(window).bind("load resize scroll", function () {
      if (!$("body").hasClass('body-small')) {
        fix_height();
      }
    });

    setTimeout(function () {
      fix_height();
    });
  });

  // Shrink menu when screen is less than 1380px but greater than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 1381 && angular.element(document).width() > 768) {
      angular.element('body').addClass('mini-navbar');
      angular.element('#expand-sidebar').removeClass('fa-angle-double-left');
      angular.element('#expand-sidebar').addClass('fa-angle-double-right');
      angular.element('#expand-sidebar').attr('title','Expand sidebar');
    }
    else{
      angular.element('body').removeClass('mini-navbar');
      angular.element('#expand-sidebar').removeClass('fa-angle-double-right');
      angular.element('#expand-sidebar').addClass('fa-angle-double-left');
      angular.element('#expand-sidebar').attr('title','Collapse sidebar');
    }

    if (angular.element(document).width() <= 768) {
      angular.element('body').addClass('body-small');
    } else {
      angular.element('body').removeClass('body-small');
    }

  });
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .run(runBlock);

  runBlock.$inject = ['$rootScope', 'OidcManager', 'API','editableOptions', 'editableThemes'];

  /* @ngInject */
  function runBlock($rootScope, OidcManager, API, editableOptions, editableThemes) {
    editableOptions.theme = 'bs3';    

    $rootScope.$on('$stateChangeStart', function(event) {
      var manager = OidcManager.OidcTokenManager()
      if (manager.access_token === undefined) {
        event.preventDefault();

        // get the token using implicit flow
        var url = API.BASE_URI_IDENTITY + "connect/authorize?" +
          "client_id=materiaImplicit&" +
          "redirect_uri=" + encodeURI(API.BASE_URI_PROTOCOL + "/app/auth/callback.html") + "&" +
          "response_type=token&" +
          "scope=materia";

        window.location = url;
      }
    })
  }


})();

/* global toastr:false */
(function () {
  'use strict';

  angular
    .module('app.core')
    .constant('toastr', toastr);
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .config(function ($stateProvider, $urlRouterProvider) {
      $stateProvider

        .state('index', {
          abstract: true,
          url: "/index",
          templateUrl: "app/components/common/content.html"
        })
        .state('index.main', {
          url: "/main",
          templateUrl: "app/main/main.html",
          data: {pageTitle: 'Home'}
        })

        .state('purchase-orders', {
          abstract: true,
          url: "/purchase-orders",
          templateUrl: "app/components/common/content.html"
        })
        .state('purchase-orders.view', {
          url: "/non-po",
          templateUrl: "app/purchase-orders/viewPurchaseOrders.html",
          data: {pageTitle: 'Non-PO receipts'}
        })
        .state('purchase-orders.details', {
          url: "/:id/",
          templateUrl: "app/purchase-orders/details.html",
          data: {pageTitle: 'Purchase Order: PO123ABC'}
        })

        .state('receipts', {
          abstract: true,
          url: "/receipts",
          templateUrl: "app/components/common/content.html"
        })
        .state('receipts.view', {
          url: "/",
          templateUrl: "app/purchase-orders/viewReceipts.html"
        })
        .state('receipts.details', {
          url: "/:id/",
          templateUrl: "app/purchase-orders/viewReceiptDetails.html"
        })

        .state('deliveries', {
          abstract: true,
          url: "/deliveries",
          templateUrl: "app/components/common/content.html"
        })
        .state('deliveries.create', {
          url: "/create",
          templateUrl: "app/deliveries/createDelivery.html",
          data: {pageTitle: 'Create A Delivery'}
        })
        .state('deliveries.details', {
          url: "/:id/",
          templateUrl: "app/deliveries/editDelivery.html",
          data: {pageTitle: 'Delivery: Del-1234'}
        })
        .state('deliveries.view', {
          url: "/",
          templateUrl: "app/deliveries/viewDelivery.html"
        })
        .state('deliveries.view.incomplete', {
          url: "incomplete",
          templateUrl: "app/deliveries/viewDelivery.html"
        })
        .state('deliveries.view.checking', {
          url: "checking",
          templateUrl: "app/deliveries/viewDelivery.html"
        })
        .state('deliveries.view.inspection', {
          url: "inspection",
          templateUrl: "app/deliveries/viewDelivery.html"
        })
        .state('deliveries.view.osd', {
          url: "osd",
          templateUrl: "app/deliveries/viewDelivery.html"
        })
        .state('deliveries.view.storing', {
          url: "storing",
          templateUrl: "app/deliveries/viewDelivery.html"
        })
        .state('deliveries.view.stored', {
          url: "stored",
          templateUrl: "app/deliveries/viewDelivery.html"
        })

        .state('projects', {
          abstract: true,
          url: "/projects",
          templateUrl: "app/components/common/content.html"
        })
        .state('projects.create', {
          url: "/create",
          templateUrl: "app/projects/createProject.html",
          data: {pageTitle: 'Create A Project'}
        })
        .state('projects.details', {
          url: "/:id/",
          templateUrl: "app/projects/viewProject.html"
        })
        .state('projects.view', {
          url: "/",
          templateUrl: "app/projects/viewProjects.html"
        })

        .state('issues', {
          abstract: true,
          url: "/issues",
          templateUrl: "app/components/common/content.html"
        })
        .state('issues.view', {
          url: "/",
          templateUrl: "app/issues/viewIssues.html"
        })
        .state('issues.details', {
          url: "/:id/",
          templateUrl: "app/issues/viewIssue.html"
        })

        .state('bagAndTag', {
          abstract: true,
          url: "/bagAndTag",
          templateUrl: "app/components/common/content.html"
        })
        .state('bagAndTag.view', {
          url: "/",
          templateUrl: "app/bag-and-tag/viewBagAndTags.html"
        })
        .state('bagAndTag.details', {
          url: "/:id/",
          templateUrl: "app/bag-and-tag/viewBagAndTag.html"
        })

        .state('transfer', {
          abstract: true,
          url: "/transfer",
          templateUrl: "app/components/common/content.html"
        })
        .state('transfer.view', {
          url: "/",
          templateUrl: "app/transfers/viewTransfers.html"
        })
        .state('transfer.details', {
          url: "/:id/",
          templateUrl: "app/transfers/viewTransfer.html"
        })

        .state('returns', {
          abstract: true,
          url: "/returns",
          templateUrl: "app/components/common/content.html"
        })
        .state('returns.view', {
          url: "/",
          templateUrl: "app/returns/viewReturns.html"
        })
        .state('returns.details', {
          url: "/:id/",
          templateUrl: "app/returns/viewReturn.html"
        })

        .state('search', {
          abstract: true,
          url: "/search",
          templateUrl: "app/components/common/content.html"
        })
        .state('search.purchase-orders', {
          url: "/purchase-orders?term&fromDate&toDate&page",
          templateUrl: "app/search/search.html",
          data: {pageTitle: 'Purchase Order Search'}
        })
        .state('search.returns', {
          url: "/returns?term&page",
          templateUrl: "app/search/searchReturn.html",
          data: {pageTitle: 'Return Search'}
        })
        .state('search.transfer', {
          url: "/transfers?term&page",
          templateUrl: "app/search/searchTransfer.html",
          data: {pageTitle: 'Transfer Search'}
        })
        .state('search.issues', {
          url: "/issues?term&page",
          templateUrl: "app/search/searchIssue.html",
          data: {pageTitle: 'Issue Search'}
        })
        .state('search.deliveries', {
          url: "/deliveries?term&page",
          templateUrl: "app/search/searchDelivery.html",
          data: {pageTitle: 'Delivery Search'}
        })
        .state('search.manifests', {
          url: "/manifests?term&page",
          templateUrl: "app/search/searchManifest.html",
          data: {pageTitle: 'Manifest Search'}
        })

        .state('manifests', {
          abstract: true,
          url: "/manifests",
          templateUrl: "app/components/common/content.html"
        })
        .state('manifests.view', {
          url: "/",
          templateUrl: "app/manifests/viewManifests.html"
        })
        .state('manifests.details', {
          url: "/:id/",
          templateUrl: "app/manifests/viewManifest.html"
        })

        .state('picklists', {
          abstract: true,
          url: "/picklists",
          templateUrl: "app/components/common/content.html"
        })
        .state('picklists.view', {
          url: "/",
          templateUrl: "app/picklists/viewPicklists.html"
        })
        .state('picklists.view.picking', {
          url: "picking",
          templateUrl: "app/picklists/viewPicklists.html"
        })
        .state('picklists.view.complete', {
          url: "complete",
          templateUrl: "app/picklists/viewPicklists.html"
        })
        .state('picklists.details', {
          url: "/:id/",
          templateUrl: "app/picklists/viewPicklist.html"
        })

        .state('movements', {
          abstract: true,
          url: "/movements",
          templateUrl: "app/components/common/content.html"
        })
        .state('movements.view', {
          url: "/",
          templateUrl: "app/movements/viewMovements.html"
        })
        .state('movements.details', {
          url: "/:id/",
          templateUrl: "app/movements/viewMovement.html"
        })

        .state('osdRegister', {
          abstract: true,
          url: "/osd-register",
          templateUrl: "app/components/common/content.html"
        })
        .state('osdRegister.view', {
          url: "/",
          templateUrl: "app/osd-register/viewOsdRegister.html"
        })

        .state('admin', {
          abstract: true,
          url: "/admin",
          templateUrl: "app/components/common/content.html"
        })
        .state('admin.view', {
          url: "/",
          templateUrl: "app/admin/viewAdmin.html"
        })
        .state('admin.users', {
          url: "/users",
          templateUrl: "app/admin/viewUsers.html"
        })
        .state('admin.userdetails', {
          url: "/user/:id/",
          templateUrl: "app/admin/viewUser.html"
        })
        .state('admin.importStockBalance', {
          url: "/stock-balance-import",
          templateUrl: "app/admin/importStockBalance.html"
        })
        .state('admin.warehouses', {
          url: "/warehouses",
          templateUrl: "app/admin/viewWarehouses.html"
        })
        .state('admin.warehousedetails', {
          url: "/warehouse/:id/",
          templateUrl: "app/admin/viewWarehouse.html"
        })
        .state('admin.shippingAddresses', {
          url: "/shippingAddresses?term&page",
          templateUrl: "app/admin/viewShippingAddresses.html"
        })
        .state('admin.shippingAddressDetails', {
          url: "/shipping-address/:id/",
          templateUrl: "app/admin/viewShippingAddress.html"
        })
        .state('admin.shippingNotes', {
          url: "/shippingNotes",
          templateUrl: "app/admin/viewShippingNotes.html"
        })
        .state('admin.agents', {
          url: "/agents",
          templateUrl: "app/admin/viewAgents.html"
        })

        .state('reporting', {
          abstract: true,
          url: "/reporting",
          templateUrl: "app/components/common/content.html"
        })
        .state('reporting.view', {
          url: "/",
          templateUrl: "app/reporting/viewReporting.html"
        })

        .state('inspections', {
          abstract: true,
          url: "/inspections",
          templateUrl: "app/components/common/content.html"
        })
        .state('inspections.view', {
          url: "/",
          templateUrl: "app/inspections/viewInspections.html"
        })

        .state('expediting', {
          abstract: true,
          url: "/expediting",
          templateUrl: "app/components/common/content.html"
        })
        .state('expediting.view', {
          url: "/:timeInterval",
          templateUrl: "app/expediting/viewExpediting.html"
        })

        .state('minMax', {
          abstract: true,
          url: "/min-max",
          templateUrl: "app/components/common/content.html"
        })
        .state('minMax.register', {
          url: "/register",
          templateUrl: "app/min-max/viewMinMaxRegister.html",
          data: {pageTitle: 'Register'}
        })
        .state('minMax.planning', {
          url: "/planning",
          templateUrl: "app/min-max/viewMinMaxPlanning.html",
          data: {pageTitle: 'Planning'}
        })

        .state('materialAllocation', {
          abstract: true,
          url: "/material-allocation",
          templateUrl: "app/components/common/content.html"
        })
        .state('materialAllocation.view', {
          url: "/",
          templateUrl: "app/material-allocation/viewMaterialAllocations.html"
        })
        .state('materialAllocation.details', {
          url: "/:id/",
          templateUrl: "app/material-allocation/viewMaterialAllocation.html"
        })
      ;

      $urlRouterProvider.otherwise(function ($injector) {
        var $state = $injector.get("$state");
        $state.go("index.main");
      });
    })
    .config(function ($animateProvider) {
      $animateProvider.classNameFilter(/^(?:(?!ng-animate-disabled).)*$/);
    })
    .config([
      'applicationInsightsServiceProvider', function (applicationInsightsServiceProvider) {
        applicationInsightsServiceProvider.configure({
          instrumentationKey: '#{appinsights.key}',
          applicationName: '#{appinsights.name}'
        });
      }
    ]);


  angular
    .module('app.core')
    .run(AppRun)
    .value('SETTINGS', {
      projectCode: '',
      projectId: ''
    });

  AppRun.$inject = ['$rootScope', '$state', '$stateParams', 'permissionService'];

  function AppRun($rootScope, $state, $stateParams) {
    $rootScope.$state = $state;
    $rootScope.$stateParams = $stateParams;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('authorizationService', authorizationService);

  authorizationService.$inject = ['$rootScope', '$state', 'SweetAlert'];
  /* @ngInject */
  function authorizationService($rootScope, $state, SweetAlert) {

    var service = {
      error: error,
      forbidden: forbidden
    };

    function error(error, message) {
      switch (error.status) {
        case 403:
          return forbidden(error, message);
      }
    }

    function forbidden(error, message) {
          SweetAlert.swal({
              title: "Unauthorized",
              text: message,
              type: "error",
              showCancelButton: false,
              confirmButtonColor: "#1ab394",
              confirmButtonText: "Close",
              closeOnConfirm: false
            }
          );
    }
    return service;
  }
})();

(function() {
  'use strict';

 angular.module("app.core")
.constant("API", {
    "BASE_URI": "#{iis.hostname}",
    "BASE_URI_WAREHOUSE": "#{api.base-uri.warehouse}",
    "BASE_URI_PURCHASING": "#{api.base-uri.purchasing}",
    "BASE_URI_PROJECT": "#{api.base-uri.project}",
    "BASE_URI_SHIPPING": "#{api.base-uri.shipping}",
    "BASE_URI_REPORTING": "#{api.base-uri.reporting}",
    "BASE_URI_IDENTITY": "#{identity.base-uri}",
    "BASE_URI_PROTOCOL": "#{base-uri-protocol}",
    "BASE_URI_SIGNALR": "#{api.base-uri.signalr}",
    "BASE_URI_USERADMIN": "#{api.base-uri.useradmin}",
    "BASE_URI_MATERIALALLOCATION": "#{api.base-uri.material-allocation}",
    "BASE_URI_COMPOSITE_GATEWAY": "#{api.base-uri.composite-gateway}"
});
 
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('apiInterceptor', apiInterceptor)
    .config(['$httpProvider', function ($httpProvider) {
      $httpProvider.interceptors.push('apiInterceptor');
    }]);

  apiInterceptor.$inject = ['$rootScope', 'OidcManager', '$q'];
  /* @ngInject */
  function apiInterceptor($rootScope, OidcManager, $q) {
    var service = this;
    var canceller = $q.defer();

    service.request = function (config) {
      config.headers.authorization = "Bearer " + OidcManager.OidcTokenManager().access_token;
      config.timeout = canceller.promise;
      return config;
    };

    service.responseError = function (response) {
      switch (response.status) {
        case 401:
          $rootScope.$broadcast('unauthorized');
          break;
        case 403:
          //$rootScope.$broadcast('unauthorizedActionEvent');
          break;
      }
      return $q.reject(response);
    };

    return service;
  }

})();

(function () {
  'use strict';

  angular.module('app.bagAndTag', []);

})();

(function () {
  'use strict';

  angular
    .module('app.bagAndTag')
    .controller('ViewBagAndTagsCtrl', ViewBagAndTagsCtrl);

  ViewBagAndTagsCtrl.$inject = ['bagAndTagService'];

  /* @ngInject */
  function ViewBagAndTagsCtrl( bagAndTagService) {
    var vm = this;
    vm.allocatedBagAndtags = [];
    vm.unAllocatedBagAndtags = [];
    vm.issuedBagAndtags = [];
   
    activate();

    ///////////////////////

    function activate(){
      
      bagAndTagService.getBagAndTagsIssued()
        .then(function(response) {
          vm.issuedBagAndtags = response;
        });

      bagAndTagService.getUnallocatedBagAndTags()
        .then(function(response) {
          vm.unAllocatedBagAndtags = response;
        });

      bagAndTagService.getAllocatedBagAndTags()
        .then(function(response) {
          vm.allocatedBagAndtags = response;
        });
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('app.bagAndTag')
    .controller('ViewBagAndTagCtrl', ViewBagAndTagCtrl);

  ViewBagAndTagCtrl.$inject = ['$stateParams', '$timeout', '$filter', 'SweetAlert', 'bagAndTagService'];

  /* ngInject */
  function ViewBagAndTagCtrl($stateParams, $timeout, $filter, SweetAlert, bagAndTagService) {
    var vm = this;

    vm.bagAndTagId = $stateParams.id;
    vm.bagAndTag = {};
    vm.searching = false;
    vm.isDeleted = false;
    vm.results = undefined;

    vm.bagAndTagItems = undefined;
    vm.bagAndTagGroups = undefined;
    vm.selectedItems = [];

    vm.validationErrors = [];
    vm.hasErrors = false;

    vm.tabs = {
      storedItemsActive: true,
      groupsActive: false
    };

    vm.getBagAndTag = getBagAndTag;
    vm.getBagAndTagItems = getBagAndTagItems;
    vm.addItem = addItem;
    vm.removeItem = removeItem;
    vm.removeGroup = removeGroup;
    vm.showValidationErrors = showValidationErrors;
    vm.deleteBagAndTag = deleteBagAndTag;
    vm.updateSelected = updateSelected;
    vm.groupAdded = groupAdded;
    vm.refreshIncludedItemsAndGroups = refreshIncludedItemsAndGroups;

    activate();

    ////////////////////

    function activate() {
      return getBagAndTag().then(function () {
        if(!vm.bagAndTag.isDeleted) {
          return getBagAndTagItems().then(function () {
            return getBagAndTagGroups().then(function () {
            });
          });
        }
        else{
          vm.isDeleted = vm.bagAndTag.isDeleted;
          vm.bagAndTagItems = [];
        }
      });
    }

    function getBagAndTag() {
      return bagAndTagService.getBagAndTag(vm.bagAndTagId)
        .then(function(response) {
          vm.bagAndTag = response;

          return vm.bagAndTag;
        });
    }

    function getBagAndTagItems() {
      return bagAndTagService.getBagAndTagItems(vm.bagAndTagId)
        .then(function(response) {
          vm.bagAndTagItems = response;
        });
    }

    function getBagAndTagGroups() {
      return bagAndTagService.getBagAndTagGroups(vm.bagAndTagId)
        .then(function(response) {
          vm.bagAndTagGroups = response;
        });
    }

    function addItem(item) {
      return bagAndTagService.addItemToBagAndTag(vm.bagAndTagId, item.id, item.storedItemLocationId, item.selectedQuantity)
        .then(function(response) {
          if (response.responseMessage === 'Success') {
            if (!addToExistingItem(item)) {
              item.storedItemId = item.id;
              vm.bagAndTagItems.push(angular.copy(item));
            }
            deductQuantityFromStockItems(item.storedItemLocationId, item.storedItemId, item.selectedQuantity);
          } else {
            displayNotification(response.responseMessage);
          }
        });
    }

    function addToExistingItem(item) {

      var storedItemLocation = $filter('filter')(vm.bagAndTagItems, {storedItemLocationId: item.storedItemLocationId})[0];

      if (storedItemLocation != undefined) {
        storedItemLocation.class = "badge-non-bold backgroundAnimated";
        storedItemLocation.selectedQuantity = parseFloat(storedItemLocation.selectedQuantity) + parseFloat(item.selectedQuantity);
        $timeout(function () {
          storedItemLocation.class = "badge-transparent";
        }, 1000);
        return true;
      }

    }

    function groupAdded() {
      refreshIncludedItemsAndGroups();
      vm.tabs.groupsActive = true;
    }

    function refreshIncludedItemsAndGroups() {
      getBagAndTagItems();
      getBagAndTagGroups();
    }


    function removeItem(item) {
      if (vm.results !== undefined) {
        returnItemToStock(item);
      }
      var index = vm.bagAndTagItems.indexOf(item);
      vm.bagAndTagItems.splice(index, 1);

      updateSelected();

      return bagAndTagService.deleteItemFromBagAndTag(vm.bagAndTagId, item.storedItemLocationId, null)
        .then(function(response) {

        },function(error){
          showValidationErrors(error);
        });
    }

    function removeGroup(item) {
      SweetAlert.swal({
          title: "Are you sure?",
          text: "This option will delete the group and return all the associated items back into stock. Do you wish to continue?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ED5565",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false},
        function(isConfirm){
          if (!isConfirm) return;
          vm.loading = true;
          return bagAndTagService.deleteGroupFromBagAndTag(vm.bagAndTagId, item.storedItemLocationId)
            .then(function(response) {
              vm.loading = false;
              getBagAndTagGroups();
              SweetAlert.swal("Deleted!", "The bag & tag group is now deleted.", "success");
            }, function(error) {
              showValidationErrors(error);
            });
        });
    }

    function returnItemToStock(item) {
      angular.forEach(vm.results, function(storedItem) {
        var storedItemLocation = $filter('filter')(storedItem.storedItems, {storedItemLocationId: item.storedItemLocationId})[0];

        if (storedItemLocation != undefined) {

          storedItemLocation.class = "badge-non-bold backgroundAnimated";
          storedItemLocation.quantity = parseFloat(storedItemLocation.quantity) + parseFloat(item.selectedQuantity);

          $timeout(function () {
            storedItemLocation.class = "badge-transparent";
          }, 1000);
        }
      });

    }

    function deductQuantityFromStockItems(storedItemLocationId, storedItemId, qty) {
      var storedItem = $filter('filter')(vm.results, {storedItemId: storedItemId})[0];
      $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].quantity -= qty;
      $filter('filter')(storedItem.storedItems, {storedItemLocationId: storedItemLocationId})[0].selectedQuantity = "";
    }

    function updateSelected() {
      vm.selectedItems = $filter('filter')(vm.bagAndTagItems, {isIncluded: true});
    }

    function deleteBagAndTag() {
      SweetAlert.swal({
          title: "Are you sure?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#ED5565",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false},
        function(isConfirm){
          if (!isConfirm) return;
          vm.loading = true;
          return bagAndTagService.deleteBagAndTag(vm.bagAndTagId)
            .then(function(response) {
              vm.loading = false;
              activate();
              SweetAlert.swal("Deleted!", "The bag & tag is now deleted.", "success");
              vm.isDeleted = true;
            }, function(error) {
              showValidationErrors(error);
            });
        });
    }

    function displayNotification(message) {
      SweetAlert.swal({
        title: "Quantity unavailable",
        text: message,
        type: "error",
        showCancelButton: false,
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Close",
        closeOnConfirm: false}
      );
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not search for stored items.');
      }
      vm.loading = false;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.bagAndTag')
    .controller('CreateBagAndTagCtrl', CreateBagAndTagCtrl);

  CreateBagAndTagCtrl.$inject = ['bagAndTagService', 'deliveryService', '$state'];
  /* @ngInject */
  function CreateBagAndTagCtrl(bagAndTagService, deliveryService, $state) {
    if ($state.transition) return;

    var vm = this;

    vm.loading = false;
    vm.bagAndTag = {
      description: ''
    };

    vm.warehouses = [];

    vm.getWarehouses = getWarehouses;
    vm.createBagAndTag = createBagAndTag;
    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;

    activate();

    /////////////////////

    function activate() {

      vm.getWarehouses();

    }

    function getWarehouses() {
      return deliveryService.getWarehouses()
        .then(function(response) {
          vm.warehouses = response;
          return vm.warehouses;
        });
    }

    function createBagAndTag() {
      vm.loading = true;

      var bagAndTagToCreate = {
        description: vm.bagAndTag.description,
        workpackNumber: vm.bagAndTag.workpackNumber
      };

      return bagAndTagService.createBagAndTag(bagAndTagToCreate)
        .then(function(response) {
          vm.hasErrors = false;
          $state.transitionTo('bagAndTag.details', {id: response.bagAndTagId});
        }, function(error){
          vm.hasErrors = true;
          showValidationErrors(error);
        });
    }

    function showValidationErrors(error){
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessages);
        }
      } else {
        vm.validationErrors.push('Could not create container.');
      }
      vm.loading = false;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.bagAndTag')
    .directive('wgConsolidateItems', wgConsolidateItems);

  wgConsolidateItems.$inject = ['$exceptionHandler'];

  /* @ngInject */
  function wgConsolidateItems($exceptionHandler) {
    var directive = {
      bindToController: true,
      controller: ConsolidateItemsCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope : {
        bagAndTagId: '@',
        selectedItems: '=',
        description: '@',
        locationId: '@',
        postUpdateDelegate: '&',
        selectedAll: '='
      },
      templateUrl: 'app/bag-and-tag/consolidateItems.html'
    };
    return directive;

    function link(scope, element, attrs) {
      try {
        if (!attrs.bagAndTagId) {
          throw(new Error("\"bag-and-tag\" must be included attribute."));
        }
        if (!attrs.selectedItems) {
          throw(new Error("\"selected-items\" must be included attribute."));
        }
      }
      catch (error) {
        $exceptionHandler(error);
      }
    }
  }

  ConsolidateItemsCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function ConsolidateItemsCtrl($uibModal) {
    var vm = this;

    vm.bagAndTagId = this.bagAndTagId;
    vm.selectedItems = this.selectedItems;
    vm.description = this.description;
    vm.locationId = this.locationId;
    vm.postUpdateDelegate = this.postUpdateDelegate;
    vm.selectedAll = this.selectedAll;

    vm.openConsolidateItems = openConsolidateItems;

    function openConsolidateItems() {
      $uibModal.open({
        templateUrl: 'app/bag-and-tag/consolidateItemsModal.html',
        controller: 'ConsolidateItemsModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          bagAndTagId: function () {
            return vm.bagAndTagId;
          },
          selectedItems: function () {
            return vm.selectedItems;
          },
          description: function () {
            return vm.description;
          },
          locationId: function() {
            return vm.locationId;
          },
          postUpdateDelegate: function() {
            return vm.postUpdateDelegate;
          }
        }
      });
    }
  }

  angular
    .module('app.bagAndTag')
    .controller('ConsolidateItemsModalCtrl', ConsolidateItemsModalCtrl);

  ConsolidateItemsModalCtrl.$inject = ['$rootScope', '$uibModalInstance', 'bagAndTagService', 'bagAndTagId',
                                        'selectedItems', 'description', 'locationId', 'postUpdateDelegate', 'OidcManager', 'API', 'SETTINGS'];

  function ConsolidateItemsModalCtrl($rootScope, $uibModalInstance, bagAndTagService, bagAndTagId,
                                     selectedItems, description, locationId, postUpdateDelegate, OidcManager, API, SETTINGS) {
    var vm = this;

    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.bagAndTagId = bagAndTagId;
    vm.selectedItems = selectedItems;
    vm.description = description;
    vm.locationId = locationId;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.locations = [];
    vm.locationsOptions = [];
    vm.locationSelected = [];

    vm.greaterThan = greaterThan;
    vm.equalTo = equalTo;

    activate();

    /////////////////

    function activate() {
      angular.forEach(vm.selectedItems, function(value, key) {
        value.groupedQuantity = value.selectedQuantity;
      });
    }

    vm.ok = function () {
      vm.saving = true;
      vm.saved = true;

      bagAndTagService.createGroup(vm.bagAndTagId, vm.description, vm.locationId, vm.selectedItems)
        .then(function(response) {
          postUpdateDelegate();
          $rootScope.$broadcast('group-created');

          vm.error = false;
          vm.saved = true;
          vm.saving = false;

        }, function() {

          vm.saved = false;
          vm.error = true;
          vm.saving = false;

        });
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    /** Locations */

    vm.locations = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations',
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      },
      group: { field: "warehouseName" }
    };

    vm.locationsOptions = {
      placeholder: "Choose a location...",
      dataSource: vm.locations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };

    function greaterThan(prop1, prop2){
      return function(item){
        var val1 = parseFloat(item[prop1]);
        var val2 = parseFloat(item[prop2]);
        return val1 > val2;
      };
    }

    function equalTo(prop, val){
      return function(item){
        var result = item[prop] === val;
        return result;
      };
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.common')
    .factory('urlHelperService', urlHelperService);

  function urlHelperService() {
    var service = {
      buildUrl: buildUrl,
      getSelectedValues: getSelectedValues,
      getSelectedValuesReport:getSelectedValuesReport
    };

    return service;

    ///////////////////////

    function getSelectedValues(params, property) {
      if (!params) return;
      var parts = [];
      forEachSorted(params, function (value, key) {
        if (value == null || value == undefined) return;
        if (angular.isObject(value)) {
          value = JSON.parse(angular.toJson(value));
          if (value.hasOwnProperty(property)) {
            value = getPropertyValue(value, property);
          }
        }
        parts.push(value);
      });

      if (parts.length == 0) {
        parts = "~"; } else {
        parts = parts.join('|');
      }

      return parts;
    }

    function getSelectedValuesReport(params, property) {
      if (!params) return;
      var parts = [];
      forEachSorted(params, function (value, key) {
        if (value == null || value == undefined) return;
        if (angular.isObject(value)) {
          value = JSON.parse(angular.toJson(value));
          if (value.hasOwnProperty(property)) {
            value = getPropertyValue(value, property); 
          }
        }
        parts.push(value);
      });

      if (parts.length == 0) {
        parts = ""; } else {
        parts = parts.join(',');
      }

      return parts;
    }

    function buildUrl(url, params, property) {
      if (!params) return url;
      var parts = [];
      var values = [];
      forEachSorted(params, function (value, key) {
        if (value == null || value == undefined) return;
        if (angular.isObject(value)) {
          value = JSON.parse(angular.toJson(value));
          if (value.hasOwnProperty(property)) {
            value = getPropertyValue(value, property);
          }
        }
        parts.push(encodeURIComponent(value));
      });
      values.push(encodeURIComponent(property) + '=' + parts.join('|'));

      return url + ((url.indexOf('?') == -1) ? '?' : '&') + values.join('&');
    }

    function forEachSorted(obj, iterator, context) {
      var keys = sortedKeys(obj);
      for (var i = 0; i < keys.length; i++) {
        iterator.call(context, obj[keys[i]], keys[i]);
      }
      return keys;
    }

    function sortedKeys(obj) {
      var keys = [];
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
      return keys.sort();
    }

    function getPropertyValue(obj, property) {
      if(typeof obj === 'undefined') { return false; }
      var _index = property.indexOf('.');
      if(_index > -1) {
        return getPropertyValue(obj[property.substring(0, _index)], property.substr(_index + 1));
      }
      return obj[property];
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgTraceInfo', wgTraceInfo);

  wgTraceInfo.$inject = ['$uibModal', '$exceptionHandler'];

  /* @ngInject */
  function wgTraceInfo($uibModal, $exceptionHandler) {
    var directive = {
      bindToController: true,
      controller: TraceInfoCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        checkLineId: '@',
        barcode: '@',
        description: '@'
      },
      templateUrl: 'app/common/traceInfo.html'
    };
    return directive;

    function link(scope, element, attrs) {
      try {
        if (!attrs.barcode) {
          throw( new Error( "\"trace-number\" must be included attribute."))
        }

        if (!attrs.checkLineId) {
          throw( new Error( "\"check-line-id\" must be included attribute."))
        }
      }
      catch (error) {
        $exceptionHandler(error);
      }
    }
  }

  TraceInfoCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function TraceInfoCtrl($uibModal) {
    var vm = this;

    vm.barcode = this.barcode;
    vm.description = this.description;
    vm.checkLineId = this.checkLineId;

    vm.openTraceInfo = openTraceInfo;

    function openTraceInfo() {
      $uibModal.open({
        templateUrl: 'app/common/traceInfoModal.html',
        controller: 'TraceInfoModalCtrl',
        controllerAs: 'vm',
        resolve: {
          barcode: function () {
            return vm.barcode;
          },
          description: function () {
            return vm.description;
          },
          checkLineId: function () {
            return vm.checkLineId;
          }
        }
      });
    };
  }

  angular
    .module('app.common')
    .controller('TraceInfoModalCtrl', TraceInfoModalCtrl);

  TraceInfoModalCtrl.$inject = ['$uibModalInstance', 'deliveryService', 'barcode', 'description', 'checkLineId', '$timeout'];

  function TraceInfoModalCtrl($uibModalInstance, deliveryService, barcode, description, checkLineId, $timeout) {
    var vm = this;

    vm.barcode = barcode;
    vm.description = description;
    vm.checkLineId = checkLineId;

    vm.oemPartNumber = '';
    vm.supplierPartNumber = '';
    vm.clientStockCode = '';
    vm.tagNumber = '';
    vm.heatCastNumber = '';
    vm.ircNumber = '';
    vm.hsCommodityCode = '';
    vm.origin = '';
    vm.customsStatus = '';

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    activate();

    function activate() {
      deliveryService.getTraceInfo(vm.checkLineId, vm.barcode)
        .then(function (response) {
          vm.oemPartNumber = response.oemPartNumber;
          vm.supplierPartNumber = response.supplierPartNumber;
          vm.clientStockCode = response.clientStockCode;
          vm.tagNumber = response.tagNumber;
          vm.heatCastNumber = response.heatCastNumber;
          vm.ircNumber = response.ircNumber;
          vm.hsCommodityCode = response.hsCommodityCode;
          vm.origin = response.origin;
          vm.customsStatus = response.customsStatus;
        });
    }

    vm.ok = function () {
      vm.saving = true;
      vm.saved = false;

        deliveryService.saveTraceInfo(vm.checkLineId, vm.barcode, {
          oemPartNumber: vm.oemPartNumber,
          supplierPartNumber: vm.supplierPartNumber,
          clientStockCode: vm.clientStockCode,
          tagNumber: vm.tagNumber,
          heatCastNumber: vm.heatCastNumber,
          ircNumber: vm.ircNumber,
          hsCommodityCode: vm.hsCommodityCode,
          origin: vm.origin,
          customsStatus: vm.customsStatus
        })
          .then(function(response) {
            vm.deliveries = response;

            vm.error = false;
            vm.saved = true;
            vm.saving = false;
          }, function() {

            vm.saved = false;
            vm.error = true;
            vm.saving = false;
          });
      };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }

})();


(function(){
  'use strict';

  angular
    .module('app.common')
    .factory('timeIntervalService', timeIntervalService);

  timeIntervalService.$inject = ['$filter'];

  function timeIntervalService($filter){

    var service = {
      getDateFrom: getDateFrom,
      getDateTo: getDateTo,
    };

    return service;

    ///////////////////

    function getDateFrom(dateFrom, timeInterval){
      if (dateFrom == null && timeInterval == null) return null;

      if (timeInterval != null){
        if (timeInterval.indexOf("-") !== -1){
          return addDays(timeInterval);
        } else {
          var result = new Date();
          result.setDate(result.getDate());
          return formatDate(result);
        }
      }

      return dateFrom == null ? null : dateFrom
    }

    function getDateTo(dateTo, timeInterval){
      if (dateTo == null && timeInterval == null) return null;

      if (timeInterval != null){
        if (timeInterval.indexOf("-") !== -1){
          var result = new Date();
          result.setDate(result.getDate());
          return formatDate(result);
        } else {
          return addDays(timeInterval)
        }
      }

      return dateTo == null ? null : dateTo
    }

    function addDays(interval) {
      var parts = interval.split(":");
      var period = parts[0];
      var duration = parts[1];
      var days = 0;

      switch (period) {
        case "ww":
          days = duration * 7;
          break;
        case "m":
          days = duration * 30;
          break;
        case "yy":
          days = duration * 365;
          break;
      }

      var result = new Date();
      result.setDate(result.getDate() + days);
      return formatDate(result);
    }

    function formatDate(date){
      return $filter('date')(date, "yyyy-MM-dd");
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgStoredItemCheckboxes', wgStoredItemCheckboxes);

  wgStoredItemCheckboxes.$inject = [];

  /* @ngInject */
  function wgStoredItemCheckboxes() {
    var directive = {
      bindToController: true,
      controller: StoredItemCheckboxesDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/common/storedItemCheckboxes.html",
      scope: {
        item: '=',
        hideLocation: '=',
        includeIssue: '='
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  StoredItemCheckboxesDirCtrl.$inject = [];

  /* @ngInject */
  function StoredItemCheckboxesDirCtrl() {
    var vm = this;
    vm.item = this.item;
    vm.hideLocation = this.hideLocation;
    vm.includeIssue = this.includeIssue;
    vm.item.selectedQuantity = undefined;

    vm.loading = false;
    vm.validationErrors = false;
    vm.showValidationErrors = showValidationErrors;

    activate();

    ////////////////////////

    function activate() {

    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgStoredItem', wgStoredItem);

  wgStoredItem.$inject = [];

  /* @ngInject */
  function wgStoredItem() {
    var directive = {
      bindToController: true,
      controller: StoredItemDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/common/storedItem.html",
      scope: {
        item: '=',
        hideLocation: '=',
        isPicklist: '=',
        addItem: '&',
        Selected: '=',
        showCheckbox: '='
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  StoredItemDirCtrl.$inject = ['$scope'];

  /* @ngInject */
  function StoredItemDirCtrl($scope) {
    var vm = this;
    vm.item = this.item;
    vm.hideLocation = this.hideLocation;
    vm.isPicklist = this.isPicklist;
    vm.item.selectedQuantity = undefined;

    vm.loading = false;
    vm.validationErrors = false;
    vm.addItem = this.addItem;
    vm.showValidationErrors = showValidationErrors;
    vm.selectedAll=false;
    vm.showCheckbox = this.showCheckbox;
    activate();

    ////////////////////////

    function activate() {

    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgSplitInspectionItem', wgSplitInspectionItem);

  wgSplitInspectionItem.$inject = [];

  /* @ngInject */
  function wgSplitInspectionItem() {
    var directive = {
      bindToController: true,
      controller: SplitInspectionItemCtrl,
      controllerAs : 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: 'app/common/splitInspectionItem.html',
      scope: {
        item: '=',
        warehouseId: '=',
        index: '='
      }
    };

    return directive;

    function link (scope, element, attrs){

    }
  }

  SplitInspectionItemCtrl.$inject = ['OidcManager', 'API', 'SETTINGS'];

  function SplitInspectionItemCtrl(OidcManager, API, SETTINGS) {
    var vm = this;
    vm.item = this.item;
    vm.warehouseId = this.warehouseId;
    vm.index = this.index;

    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.hasFailedInspection = hasFailedInspection;

    /** Quarantine locations */
    vm.quarantineLocations = [];
    vm.quarantineLocationsOptions = [];
    vm.selectedQuarantineLocationId = '';

    activate();

    //////////////////////

    function activate() {

    }

    function hasFailedInspection(failedInspectionQuantity) {
      return parseFloat(failedInspectionQuantity) > 0;
    }

    /** Quarantine Locations */

    vm.quarantineLocations = new kendo.data.DataSource({
      transport: {
        read: {
          url: function(options) {
            return API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations/' + vm.warehouseId + '/quarantine'},
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      },
      group: { field: "warehouseName" }
    });

    vm.quarantineLocationsOptions = {
      placeholder: "Select location",
      dataSource: vm.quarantineLocations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgSmallProgressBar', wgSmallProgressBar);

  wgSmallProgressBar.$inject = [];

  /* @ngInject */
  function wgSmallProgressBar() {
    var directive = {
      bindToController: true,
      controller: SmallProgressBarCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      templateUrl: 'app/common/smallProgressBar.html',
      scope: {
        title: '@',
        total: '=',
        progress: '=?',
        inline: '=?',
        displayTotals: '=?'
      }
    }

    return directive;

    function link(scope, element, attrs){

    }
  }

  SmallProgressBarCtrl.$inject = [];

  /* @ngInject */
  function SmallProgressBarCtrl() {
    var vm = this;
    vm.title = this.title;
    vm.total = this.total;
    vm.progress = this.progress;
    vm.inline = this.inline;
    vm.displayTotals = this.displayTotals;
  }

})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgSelectProject', wgSelectProject);

  wgSelectProject.$inject = [];

  /* @ngInject */
  function wgSelectProject() {
    var directive = {
      bindToController: true,
      controller: SelectProjectCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {},
      templateUrl: 'app/common/selectProject.html'
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  SelectProjectCtrl.$inject = ['SETTINGS', 'ProjectSelectorAPI', 'projectService'];

  /* @ngInject */
  function SelectProjectCtrl(SETTINGS, ProjectSelectorAPI, projectService) {
    var vm = this;
    vm.projectCode = SETTINGS.projectCode;
    vm.project = {};

    vm.api = ProjectSelectorAPI;

    activate();

    ////////////////

    function activate() {
      return projectService.getProjectByCode(vm.projectCode).then(function(response) {
        vm.project = response;
      })

    }

  }

  angular
    .module('app.common')
    .controller('SelectProjectModalCtrl', SelectProjectModalCtrl);

  SelectProjectModalCtrl.$inject = ['$uibModalInstance', '$localStorage', '$rootScope', '$filter', 'OidcManager', 'SETTINGS', 'ProjectSelectorAPI', 'projectService'];

  function SelectProjectModalCtrl($uibModalInstance, $localStorage, $rootScope, $filter, OidcManager, SETTINGS, ProjectSelectorAPI, projectService) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.projectCode = SETTINGS.projectCode;
    vm.projectId = '';
    vm.isProjectSet = $localStorage.isProjectSet !== undefined;

    vm.api = ProjectSelectorAPI;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.project = {};
    vm.projects = [];
    vm.projectOptions = [];
    vm.projectsSource = [];

    vm.ok = ok;
    vm.cancel = cancel;

    activate();

    ////////////////

    function activate() {

      vm.projects = {
        transport: {
          read: function(options){
            return projectService.getProjects(true).then(function(response){
              var data = response;
              vm.projectsSource = response;
              options.success(data);
            });
          }
        },
        sort:{
          field:"name",
          dir: "asc"
        }
      };

      vm.projectOptions = {
        dataSource: vm.projects,
        dataTextField: "code",
        dataValueField: "code",
        template: '<span class="k-state-default">#: name # - #: code #</span>'
      };
    }

    function ok() {
      vm.saving = true;
      vm.saved = false;

      vm.project = $filter('filter')(vm.projectsSource, {code: vm.projectCode})[0];

      vm.api.saveProject(vm.project.code, vm.project.id);
      vm.error = false;
      vm.saved = true;
      vm.saving = false;

      vm.isProjectSet = true;

      $rootScope.$broadcast('projectSelectedEvent');
    }

    function cancel() {
      vm.api.modalStatus('close');
      $uibModalInstance.dismiss('cancel');
    }
  }

})();


(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgSearchCriteria', wgSearchCriteria);

  wgSearchCriteria.$inject = [];

  /* @ngInject */
  function wgSearchCriteria() {
    var directive = {
      bindToController: true,
      controller: SearchCriteriaCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        results: '=',
        bagAndTagResults: '=',
        returnsOnly: '=',
        disableBagAndTag: '@',
        tabs: '=',
        isMovement: '=',
        warehouse: '='
      },
      templateUrl: 'app/common/searchCriteria.html'
    };

    return directive;

    function link(scope, element, attrs) {
      if (scope.results !== undefined) scope.results = this.results;
      if (scope.bagAndTagResults !== undefined) scope.bagAndTagResults = this.bagAndTagResults;
    }

  }

  SearchCriteriaCtrl.$inject = ['stockService', 'bagAndTagService', 'OidcManager', 'API', 'SETTINGS'];

  /* @ngInject */
  function SearchCriteriaCtrl(stockService, bagAndTagService, OidcManager, API, SETTINGS) {
    var vm = this;
    var results = this.results;
    var bagAndTagResults = this.bagAndTagResults;
    var returnsOnly = this.returnsOnly;
    var tabs = this.tabs;
    vm.isMovement = this.isMovement;
    vm.warehouse = this.warehouse;

    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.disableBagAndTag = this.disableBagAndTag;

    /** Purchase Orders */
    vm.purchaseOrders = [];
    vm.purchaseOrdersOptions = [];
    vm.purchaseOrdersSelected = [];
    /** Material Codes */
    vm.materialCodes = [];
    vm.materialCodesOptions = [];
    vm.materialCodesSelected = [];
    /** Cost Codes */
    vm.codeCodes = [];
    vm.costCodesOptions = [];
    vm.costCodesSelected = [];
    /** Barcodes */
    vm.barcodes = [];
    vm.barcodesOptions = [];
    vm.barcodesSelected = [];
    /** Locations */
    vm.locations = [];
    vm.locationsOptions = [];
    vm.locationsSelected = [];
    /** Bag and Tag numbers */
    vm.bagAndTagNumbers = [];
    vm.bagAndTagNumbersOptions = [];
    vm.bagAndTagNumbersSelected = [];
    /** Bag and Tag Workpack numbers */
    vm.workpackNumbers = [];
    vm.workpackNumbersOptions = [];
    vm.workpackNumbersSelected = [];
    /** Issues */
    vm.issuesNumbers = [];
    vm.issuesOptions = [];
    vm.issuesSelected = [];


    vm.filter = "";


    vm.doSearch = doSearch;
    vm.resetForm = resetForm;

    activate();

    /////////////////

    function activate() {

    }

    function doSearch() {
      vm.searching = true;

      return searchStoredItems().then(function () {
        if (!vm.disableBagAndTag) {
          return searchBagAndTagHeaders().then(function () {
            if (tabs !== undefined) {
              tabs.storedItemsResultsActive = (vm.results !== undefined && vm.bagAndTagResults === undefined) || (vm.results !== undefined && vm.bagAndTagResults !== undefined);
              tabs.bagAndTagResultsActive = (vm.results === undefined && vm.bagAndTagResults !== undefined);
            }
            vm.searching = false;
          });
        }
        vm.searching = false;
      });
    }

    function searchStoredItems() {
      return stockService.searchStockItems(vm.purchaseOrdersSelected, vm.materialCodesSelected, vm.costCodesSelected, vm.barcodesSelected, vm.locationsSelected, vm.issuesSelected,
        vm.workpackNumbersSelected, vm.filter, vm.returnsOnly, vm.warehouse).then(function (data) {
        vm.results = data;
      });
    }

    function searchBagAndTagHeaders() {
      return bagAndTagService.searchBagAndTagHeaders(vm.bagAndTagNumbersSelected, vm.workpackNumbersSelected, vm.issuesSelected, [],
        vm.purchaseOrdersSelected, vm.materialCodesSelected, vm.costCodesSelected, vm.barcodesSelected, vm.locationsSelected, vm.filter, vm.returnsOnly).then(function (data) {
        vm.bagAndTagResults = data;
      });
    }

    function resetForm() {
      vm.purchaseOrdersSelected = [];
      vm.materialCodesSelected = [];
      vm.costCodesSelected = [];
      vm.barcodesSelected = [];
      vm.locationsSelected = [];
      vm.bagAndTagNumbersSelected = [];
      vm.workpackNumbersSelected = [];
      vm.issuesSelected = [];
      vm.filter = "";
      vm.results = undefined;
      vm.bagAndTagResults = undefined;
    }

    /** Purchase Orders */

    vm.purchaseOrders = {
      type: 'odata-v4',
      pageSize: 40,
      serverPaging: true,
      serverFiltering: true,
      transport: {
        read: {
          url: API.BASE_URI_PURCHASING + "odata/PurchaseOrders",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken)
          }
        }
      },
      filter:[
        { field: "projectCode", operator: "eq", value: SETTINGS.projectCode }
      ]

    };

    vm.purchaseOrdersOptions = {
      height: 210,
      dataSource: vm.purchaseOrders,
      placeholder: "(Optional)",
      dataTextField: "number",
      dataValueField: "id",
      filter: "contains",
      virtual: {
        itemHeight: 30
      },
      autoBind: false,
      template: '<span class="k-state-default">#: number # - #: supplierName # - #= kendo.toString(kendo.parseDate(date), \'dd-MMM-yyyy\') #</span>'
    };

    /** Material Codes */

    vm.materialCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/material-codes",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.materialCodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.materialCodes,
      dataTextField: "materialCode",
      dataValueField: "materialCode",
      filter: "contains",
      autoBind: false
    };

    /** Cost Codes */

    vm.costCodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/stored-items/cost-codes",
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.costCodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.costCodes,
      dataTextField: "costCode",
      dataValueField: "costCode",
      filter: "contains",
      autoBind: false
    };

    /** Barcodes */

    vm.barcodes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/stored-items/barcodes',
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.barcodesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.barcodes,
      dataTextField: "barcode",
      dataValueField: "barcode",
      filter: "contains",
      autoBind: false
    };

    /** Locations  */

    vm.locations = {
      transport: {
        read: {
          url: vm.isMovement ? API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations/warehouse/' + vm.warehouse : API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations',
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      },
      group: { field: "warehouseName" }
    };

    vm.locationsOptions = {
      placeholder: "(Optional)",
      dataSource: vm.locations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };

    /** Bag and Tag numbers */

    vm.bagAndTagNumbers = {
      transport: {
        read: function (options) {
          return bagAndTagService.getBagAndTagNumbers(!returnsOnly)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        }
      }
    };

    vm.bagAndTagNumbersOptions = {
      placeholder: "(Optional)",
      dataSource: vm.bagAndTagNumbers,
      dataTextField: "number",
      dataValueField: "number",
      filter: "contains",
      autoBind: false
    };

    /** Bag and Tag workpack numbers */

    vm.workpackNumbers = {
      transport: {
        read: function (options) {
          return stockService.getRefNumbers(true)
            .then(function (response) {
              var data = response;
              options.success(data);
            });
        }
      }
    };

    vm.workpackNumbersOptions = {
      placeholder: "(Optional)",
      dataSource: vm.workpackNumbers,
      dataTextField: "workpackNumber",
      dataValueField: "workpackNumber",
      filter: "contains",
      autoBind: false
    };

    /** Issues */

    vm.issues = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/issues/complete",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.issuesOptions = {
      placeholder: "(Optional)",
      dataSource: vm.issues,
      dataTextField: "number",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      template: '<span class="k-state-default">#: number # - #: description #</span>'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgPurchaseOrderLine', wgPurchaseOrderLine);

  wgPurchaseOrderLine.$inject = [];

  /* @ngInject */
  function wgPurchaseOrderLine(){
    var directive = {
      bindToController: true,
      controller: PurchaseOrderLineCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: 'app/common/purchaseOrderLine.html',
      scope: {
        item: '=',
        isManual: '=',
        statusId: '=',
        deletePurchaseOrderLineItem : '&'
      }
    };

    return directive;

    function link(scope, element, attrs) {

    }
  }

  PurchaseOrderLineCtrl.$inject = ['purchaseOrderService','purchaseOrderCompositeService'];

  /* @ngInject */
  function PurchaseOrderLineCtrl(purchaseOrderService,purchaseOrderCompositeService) {
    var vm = this;
    vm.item = this.item;
    vm.isManual = this.isManual;
    vm.statusId = this.statusId;
    vm.deletePurchaseOrderLineItem = this.deletePurchaseOrderLineItem;

    vm.loading = false;
    vm.validationErrors = false;
    vm.showValidationErrors = showValidationErrors;
    vm.setLinesReceivability = setLinesReceivability;

    vm.setDualUse = setDualUse;

    activate();

    ////////////////////////

    function activate() {

    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }


    function setLinesReceivability(poLine) {
      poLine.isNonReceivable = !poLine.isNonReceivable;

      var lineToUpdate = {
        purchaseOrderLineId: poLine.id,
        isNonReceivable: poLine.isNonReceivable
      };

      return purchaseOrderService.updatePOLineReceivability(lineToUpdate)
        .then(function (response) {
        }, function (error) {
          showValidationErrors(error);
        });
    }

    function setDualUse(poLine) {
      poLine.isDualUse = !poLine.isDualUse;

      var lineToUpdate = {
        id: poLine.id,
        isDualUse: poLine.isDualUse
      };

      return purchaseOrderCompositeService.updateDualUse(lineToUpdate)
          .then(function (response) {
          }, function (error) {
            showValidationErrors(error);
          });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .factory('ProjectSelectorAPI', ProjectSelectorAPI);

  ProjectSelectorAPI.$inject = ['$uibModal', '$state', '$localStorage', 'SETTINGS'];

  /* @ngInject */
  function ProjectSelectorAPI($uibModal, $state, $localStorage, SETTINGS) {
    var isOpen = false;

    return {
      openProjects: openProjects,
      modalStatus: modalStatus,
      saveProject: saveProject,
      isOpen: isOpen
    };

    function openProjects() {
      if (!isOpen) {
        $uibModal.open({
          templateUrl: 'app/common/selectProjectModal.html',
          controller: 'SelectProjectModalCtrl',
          controllerAs: 'vm',
          resolve: {},
          backdrop: 'static'
        });
        isOpen = true;
      }
    }

    function saveProject(projectCode, projectId){
      SETTINGS.projectCode = projectCode;
      SETTINGS.projectId = projectId;

      $localStorage.$default({
        isProjectSet : true
      });

      $localStorage.defaultProjectCode = projectCode;
      $localStorage.defaultProjectId = projectId;

      isOpen = false;
      $state.go('index.main', {}, {reload: true});
    }

    function modalStatus(value) {
      isOpen = value === 'open';
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgModalStoredItem', wgModalStoredItem);

  wgModalStoredItem.$inject = [];

  /* @ngInject */
  function wgModalStoredItem() {
    var directive = {
      bindToController: true,
      controller: ModalStoredItemDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/common/modalStoredItem.html",
      scope: {
        item: '=',
        selectItem: '&'
      }
    };

    return directive;

    function link(scope, element, attrs){

    }
  }

  ModalStoredItemDirCtrl.$inject = [];

  /* @ngInject */
  function ModalStoredItemDirCtrl() {
    var vm = this;
    vm.item = this.item;
    vm.selectItem = this.selectItem;

    activate();

    //////////////////////////

    function activate(){

    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .factory('logOutService', logOutService);

  logOutService.$inject = ['OidcManager', '$localStorage'];

  function logOutService(OidcManager, $localStorage) {

    var service = {
      logOutOfIdSrv: logOutOfIdSrv,
      logOutDueToTokenExpiry : logOutDueToTokenExpiry
    };

    return service;

    //////////////////

    function clearLocalStorage(){
      delete $localStorage.permissions;
    }

    function logOutOfIdSrv() {
      var manager = OidcManager.OidcTokenManager();
      clearLocalStorage();
      manager.redirectForLogout();
    }

    function logOutDueToTokenExpiry() {
      var manager = OidcManager.OidcTokenManager();
      clearLocalStorage();
      manager.redirectForToken();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgLogOut', wgLogOut);

  /* @ngInject */
  function wgLogOut() {
    var directive = {
      bindToController: true,
      controller: LogOutCtrl,
      controllerAs: 'vm',
      scope: {},
      templateUrl: 'app/common/logOut.html'
    };
    return directive;
  }
  LogOutCtrl.$inject = ['logOutService', 'OidcManager'];

  /* ngInject */
  function LogOutCtrl(logOutService, OidcManager) {
    var vm = this;

    vm.manager = OidcManager.OidcTokenManager();

    vm.name = vm.manager.profile.fullname;
    vm.email = Array.isArray(vm.manager.profile.email) ? vm.manager.profile.email[0] : vm.manager.profile.email

    vm.logOutOfIdSrv = function(){
      logOutService.logOutOfIdSrv();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgInspectionItem', wgInspectionItem);

  wgInspectionItem.$inject = [];

  /* @ngInject */
  function wgInspectionItem() {
    var directive = {
      bindToController: true,
      controller: InspectionItemCtrl,
      controllerAs : 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: 'app/common/inspectionItem.html',
      scope: {
        item: '=',
        warehouseId: '=',
        index: '='
      }
    };

    return directive;

    function link (scope, element, attrs){

    }
  }

  InspectionItemCtrl.$inject = ['OidcManager', 'API', 'SETTINGS'];

  function InspectionItemCtrl(OidcManager, API, SETTINGS) {
    var vm = this;
    vm.item = this.item;
    vm.warehouseId = this.warehouseId;
    vm.index = this.index;

    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.maxInspectionQuantity = vm.item.checkLine.checkedQuantity;

    vm.checkedQuantity = vm.item.checkLine.checkedQuantity;
    vm.item.failedQuantity = 0;
    vm.passedQuantity = passedQuantity;
    vm.hasFailedInspection = hasFailedInspection;

    /** Quarantine locations */
    vm.quarantineLocations = [];
    vm.quarantineLocationsOptions = [];
    vm.selectedQuarantineLocationId = '';

    activate();

    //////////////////////

    function activate() {

    }

    function passedQuantity() {
      var total = parseFloat(vm.item.checkLine.checkedQuantity || 0) - parseFloat(vm.item.failedQuantity || 0);
      return total || 0;
    }

    function hasFailedInspection(failedQuantity) {
      return parseFloat(failedQuantity) > 0;
    }

    /** Quarantine Locations */

    vm.quarantineLocations = new kendo.data.DataSource({
      transport: {
        read: {
          url: function(options) {
            return API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations/' + vm.warehouseId + '/quarantine'},
          beforeSend: function(xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      },
      group: { field: "warehouseName" }
    });

    vm.quarantineLocationsOptions = {
      placeholder: "Select location",
      dataSource: vm.quarantineLocations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('app.common')
    .directive('wgIncludedItemMultiSelect', wgIncludedItemMultiSelect);

  wgIncludedItemMultiSelect.$inject = [];

  /* @ngInject */
  function wgIncludedItemMultiSelect() {
    var directive = {
      bindToController: true,
      controller: IncludedItemMultiSelectDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: 'app/common/includedItemMultiSelect.html',
      scope: {
        item: '=',
        isReadOnly: '=',
        removeItem: '&',
        updateSelected: '&'
      }
    };
    return directive;

    function link(scope, element, attrs) {
    }
  }

  IncludedItemMultiSelectDirCtrl.$inject = [];

  function IncludedItemMultiSelectDirCtrl() {
    var vm = this;
    vm.item = this.item;
    vm.isReadOnly = this.isReadOnly;

    vm.loading = false;
    vm.validationErrors = false;
    vm.removeItem = this.removeItem;
    vm.updateSelected = this.updateSelected;
    vm.showValidationErrors = showValidationErrors;

    activate();

    ////////////////////////

    function activate() {

    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app.common')
    .directive('wgIncludedItem', wgIncludedItem);

  wgIncludedItem.$inject = [];

  /* @ngInject */
  function wgIncludedItem() {
    var directive = {
      bindToController: true,
      controller: IncludedItemDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: 'app/common/includedItem.html',
      scope: {
        item: '=',
        isReadOnly: '=',
        isIssueWithPicklist: '=',
        removeItem: '&',
        includeNewLocations: '=',
        hideOldLocations: '=',
        noLocations: '=',
        includeIssue: '=',
        showCostCode: '=',
        updateItem: '&',
        openModal: '&'
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  IncludedItemDirCtrl.$inject = ['$uibModal'];

  function IncludedItemDirCtrl($uibModal) {
    var vm = this;
    vm.item = this.item;
    vm.isReadOnly = this.isReadOnly;
    vm.isIssueWithPicklist = this.isIssueWithPicklist;
    vm.includeNewLocations = this.includeNewLocations;
    vm.hideOldLocations = this.hideOldLocations;

    vm.loading = false;
    vm.validationErrors = false;
    vm.removeItem = this.removeItem;
    vm.showValidationErrors = showValidationErrors;


    activate();

    ////////////////////////

    function activate() {

    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }



  }



})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgIncludedBagAndTagItem', wgIncludedBagAndTagItem);

  wgIncludedBagAndTagItem.$inject = [];

  /* @ngInject */
  function wgIncludedBagAndTagItem() {
    var directive = {
      bindToController: true,
      controller: IncludedBagAndTagItemCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: 'app/common/includedBagAndTagItem.html',
      scope: {
        item: '=',
        isReadOnly: '=',
        manifest: '=',
        removeItem: '&'
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  IncludedBagAndTagItemCtrl.$inject = [];

  function IncludedBagAndTagItemCtrl() {
    var vm = this;
    vm.item = this.item;
    vm.isReadOnly = this.isReadOnly;
    vm.manifest = this.manifest;

    vm.loading = false;
    vm.validationErrors = false;
    vm.removeItem = this.removeItem;
    vm.showValidationErrors = showValidationErrors;

    activate();

    //////////////////////////

    function activate() {

    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgGroupItem', wgGroupItem);

  wgGroupItem.$inject = [];

  /* @ngInject */
  function wgGroupItem() {
    var directive = {
      bindToController: true,
      controller: GroupItemDirCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/common/groupItem.html",
      scope: {
        item: '=',
        isReadOnly: '=',
        removeGroup: '&'
      }
    };

    return directive;

    function link(scope, element, attrs) {

    }
  }

  GroupItemDirCtrl.$inject = [];

  /* @ngInject */
  function GroupItemDirCtrl() {
    var vm = this;
    vm.item = this.item;
    vm.isReadOnly = this.isReadOnly;

    vm.loading = false;
    vm.validationErrors = false;
    vm.removeGroup = this.removeGroup;
    vm.showValidationErrors = showValidationErrors;

    activate();

    ///////////////////////////

    function activate() {

    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgEditGroupedItems', wgEditGroupedItems);

  wgEditGroupedItems.$inject = ['$exceptionHandler'];

  /* @ngInject */
  function wgEditGroupedItems($exceptionHandler) {
    var directive = {
      bindToController: true,
      controller: EditGroupedItemsCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'E',
      scope: {
        bagAndTagId: '@',
        groupId: '@',
        enableButton: '=',
        postUpdateDelegate: '&',
        isReadOnly: '@',
        isBagAndTagView: '@',
        description: '@'
      },
      template: '<ng-include src="btnUrl"></ng-include>'
    };
    return directive;

    function link($scope, element, attrs) {
      if (attrs.isReadOnly === "true") {
        $scope.btnUrl = 'app/common/viewGroupContents.html';
      } else {
        $scope.btnUrl = 'app/common/editGroupedItems.html';
      }
    }
  }

  EditGroupedItemsCtrl.$inject = ['$uibModal'];

  /* @ngInject */
  function EditGroupedItemsCtrl($uibModal) {
    var vm = this;

    vm.bagAndTagId = this.bagAndTagId;
    vm.groupdId = this.groupdId;
    vm.postUpdateDelegate = this.postUpdateDelegate;
    vm.isReadOnly = this.isReadOnly;
    vm.isBagAndTagView = this.isBagAndTagView;
    vm.description = this.description;

    vm.openGroupedItems = openGroupedItems;

    function openGroupedItems() {
      $uibModal.open({
        templateUrl: 'app/common/editGroupedItemsModal.html',
        controller: 'EditGroupedItemsModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          bagAndTagId: function () {
            return vm.bagAndTagId;
          },
          groupId: function () {
            return vm.groupId;
          },
          postUpdateDelegate: function () {
            return vm.postUpdateDelegate;
          },
          isReadOnly: function () {
            if (vm.isReadOnly === "true") {
              return true;
            } else {
              return false;
            }
          },
          isBagAndTagView: function () {
            if (vm.isBagAndTagView === "true") {
              return true;
            } else {
              return false;
            }
          },
          description: function () {
            return vm.description;
          }
        }
      });
    }
  }

  angular
    .module('app.common')
    .controller('EditGroupedItemsModalCtrl', EditGroupedItemsModalCtrl);

  EditGroupedItemsModalCtrl.$inject = ['$uibModalInstance', 'bagAndTagService', 'bagAndTagId', 'groupId', 'isBagAndTagView', 'description',
    'postUpdateDelegate', 'isReadOnly', 'SweetAlert', 'OidcManager', 'API', 'SETTINGS'];

  function EditGroupedItemsModalCtrl($uibModalInstance, bagAndTagService, bagAndTagId, groupId, isBagAndTagView, description,
                                     postUpdateDelegate, isReadOnly, SweetAlert, OidcManager, API, SETTINGS) {
    var vm = this;
    var apiEndpoint = API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/bag-and-tag/' + bagAndTagId;

    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.bagAndTagId = bagAndTagId;
    vm.groupId = groupId;
    vm.title = isReadOnly ? "Details for " + description : "Edit groups";
    vm.isReadOnly = isReadOnly;
    vm.isBagAndTagView = isBagAndTagView;
    vm.storedItems = [];
    vm.storedItemsOptions = [];
    vm.removeItem = removeItem;

    activate();

    /////////////////////////

    function activate() {
      if (groupId === undefined) {
        apiEndpoint += '/edit-groups';
      } else {
        apiEndpoint += '/view-group/' + groupId;
      }
    }

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
      postUpdateDelegate();
    };

    var storedItems = new kendo.data.TreeListDataSource({
      transport: {
        read: {
          url: apiEndpoint,
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        },
        dataType: "json"
      },
      schema: {
        model: {
          id: "storedItemId",
          expanded: true,
          fields: {
            parentId: {field: "storedItemParentId", nullable: true},
            storedItemId: {field: "storedItemId", type: "string"}
          }
        }
      }
    });

    vm.storedItemsOptions = {
      dataSource: storedItems,
      height: 450,
      sortable: true,
      editable: {
        move: !isReadOnly
      },
      dataBound: function (e) {
        onDataBound(e);
      },
      drag: function (e) {
        onDrag(e);
      },
      drop: function (e) {
        onDrop(e);
      },
      columns: [
        {
          title: "Description",
          width: "420px",
          template: "{{ dataItem.description | uppercase }}"
        },
        {field: "barcode", title: "Barcode", width: "140px"},
        {
          title: "Location", width: "150px",
          template: "<span ng-hide='dataItem.parentId !== null'>{{ dataItem.warehouseName }}/{{ dataItem.locationName }}</span>"
        },
        {
          title: "Qty",
          template: "<span ng-show='dataItem.selectedQuantity > 0'>{{dataItem.selectedQuantity}}</span>"
        },
        {
          template: "<button type='button' class='btn btn-danger btn-sm pull-right' ng-click='vm.removeItem(dataItem)' ng-hide='vm.isReadOnly'><i class='fa fa-times' aria-hidden='true'></i></button>"
        }
      ]
    };

    function onDataBound(e) {
      var rows = e.sender.tbody.children();

      for (var i = 0; i < rows.length; i++) {
        var row = angular.element(rows[i]);
        var dataItem = e.sender.dataItem(row);

        if (dataItem.isContainer) {
          row.addClass("group-parent");
          row.addClass("isContainer");
        }
        else if (dataItem.parentId !== null) {
          row.addClass("group-child");
        }
      }
    }

    function onDrag(e) {
      var targetRoot = (e.target).parentsUntil(".k-treelist-group" && ".isContainer", ".k-grid-content", "k-grid-header").length == 1;
      if (targetRoot && e.status !== "add") {
        e.setStatus("k-denied");
      }
    }

    function onDrop(e) {
      var isGrid = e.dropTarget.classList.contains("k-header");
      var isContainer = false;

      if (e.destination !== undefined){
        if (e.destination.id === e.source.parentId){
          e.setValid(false);
          return;
        }
        isContainer = e.destination.isContainer;
      } else {
        if (isGrid && e.source.parentId === null){
          e.setValid(false);
          return;
        }
        isContainer = isGrid;
      }

      if (!e.valid | !isContainer) {
        e.setValid(false);
        return;
      }
      var storedItemId = e.source.storedItemId;
      var oldStoredItemParentId = e.source.parentId;
      var newStoredItemParentId = e.destination === undefined ? null : e.destination.storedItemId;
      var isContainer = e.source.isContainer;

      bagAndTagService.updateBagAndTagGroupItem(bagAndTagId, storedItemId, oldStoredItemParentId, newStoredItemParentId, isContainer);
    }

    function removeItem(item) {
      if (item.isContainer) {
        SweetAlert.swal({
            title: "Are you sure?",
            text: "This option will delete the group and return all the associated items back into stock. Do you wish to continue?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ED5565",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Close",
            closeOnConfirm: false
          },
          function (isConfirm) {
            if (!isConfirm) return;
            vm.loading = true;
            return bagAndTagService.deleteGroupFromBagAndTag(vm.bagAndTagId, item.storedItemLocationId)
              .then(function (response) {
                vm.loading = false;
                refreshTreelist();
                SweetAlert.swal("Deleted!", "The bag & tag group is now deleted.", "success");
              }, function (error) {
                showValidationErrors(error);
              });
          });
      } else {
        if (item.parentId === null) {
          SweetAlert.swal({
              title: "Are you sure?",
              text: "This option will delete the item from this bag & tag and return it into stock. Do you wish to continue?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#ED5565",
              confirmButtonText: "Yes, delete it!",
              cancelButtonText: "Close",
              closeOnConfirm: false
            },
            function (isConfirm) {
              if (!isConfirm) return;
              return bagAndTagService.deleteItemFromBagAndTag(vm.bagAndTagId, item.storedItemLocationId)
                .then(function (response) {
                  refreshTreelist();
                  SweetAlert.swal("Deleted!", "The item is now deleted.", "success");
                }, function (error) {
                  showValidationErrors(error);
                });
            });
        } else {
          SweetAlert.swal({
              title: "Are you sure?",
              text: "This option will delete the item from this group and return it into stock. Do you wish to continue?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#ED5565",
              confirmButtonText: "Yes, delete it!",
              cancelButtonText: "Close",
              closeOnConfirm: false
            },
            function (isConfirm) {
              if (!isConfirm) return;
              return bagAndTagService.deleteItemFromBagAndTagGroup(vm.bagAndTagId, item.storedItemLocationId, item.parentId)
                .then(function (response) {
                  refreshTreelist();
                  SweetAlert.swal("Deleted!", "The item is now deleted.", "success");
                }, function (error) {
                  showValidationErrors(error);
                });
            });
        }
      }
    }

    function refreshTreelist() {
      storedItems.read();
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not search for stored items.');
      }
      vm.loading = false;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.common')
    .factory('OidcManager', OidcManager);

 OidcManager.$inject = ['API'];

  function OidcManager(API) {

    var config = {
      client_id: "materiaImplicit",
      redirect_uri: API.BASE_URI_PROTOCOL + "/app/auth/oidccallback.html",
      response_type: "id_token token",
      scope: "openid profile materia email roles",
      authority: API.BASE_URI_IDENTITY,
      post_logout_redirect_uri: API.BASE_URI_PROTOCOL + "/#/index/main/",
      silent_redirect_uri: API.BASE_URI_PROTOCOL + "/app/auth/silentrefreshframe.html",
      silent_renew: true
    };

    var manager = new OidcTokenManager(config);

    return {
      OidcTokenManager: function () {
        return manager;
      }
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .directive('wgBagAndTagItem', wgBagAndTagItem);

  wgBagAndTagItem.$inject = [];

  /* @ngInject */
  function wgBagAndTagItem() {
    var directive = {
      bindToController: true,
      controller: BagAndTagItemCtrl,
      controllerAs: 'vm',
      link: link,
      restrict: 'EA',
      templateUrl: "app/common/bagAndTagItem.html",
      scope: {
        item: '=',
        manifest: '=',
        enableAdd: '@?',
        addItem: '&?',
        enableTransfer: '@?',
        transferItem: '&?',
        returnsOnly: '@?',
        returnId: '@?',
        fakeBagAndTagItems: '=?'
      }
    };
    return directive;

    function link(scope, element, attrs) {

    }
  }

  BagAndTagItemCtrl.$inject = ['$scope'];

  function BagAndTagItemCtrl($scope) {
    var vm = this;
    vm.item = this.item;
    vm.manifest = this.manifest;

    vm.loading = false;
    vm.validationErrors = false;
    vm.enableAdd = (this.enableAdd === "true");
    vm.addItem = this.addItem;
    vm.enableTransfer = (this.enableTransfer === "true");
    vm.transferItem = this.transferItem;
    vm.returnsOnly = (this.returnsOnly === "true");
    vm.returnId = this.returnId;
    vm.fakeBagAndTagItems = this.fakeBagAndTagItems;
    vm.showValidationErrors = showValidationErrors;

    activate();

    ////////////////////

    function activate() {

    }

    function showValidationErrors(error) {
      vm.validationErrors = true;
      vm.loading = false;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.common')
    .controller('AddItemsModalCtrl', AddItemsModalCtrl);

  AddItemsModalCtrl.$inject = ['$uibModalInstance', 'API', 'SETTINGS', 'OidcManager', 'items', 'itemId', 'fakeItems', 'isReturn', 'updateItems'];

  function AddItemsModalCtrl($uibModalInstance, API, SETTINGS, OidcManager, items, itemId, fakeItems, isReturn, updateItems) {
    var vm = this;
    vm.bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.items = items;
    vm.itemId = itemId;
    vm.fakeItems = fakeItems;
    vm.updateItems = updateItems;
    vm.isReturn = isReturn;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;

    vm.itemsToTransfer = [];

    /** Locations */
    vm.locations = [];
    vm.locationsOptions = [];
    vm.locationSelected = undefined;

    activate();

    ///////////////

    function activate() {

    }


    vm.ok = function () {
      vm.saving = true;
      vm.saved = false;

      vm.updateItems(vm.items, vm.locationSelected.id)
        .then(function (response) {

          vm.fakedItems = [];
          angular.forEach(vm.items, function (value, key) {
            vm.fakedItems.push({
              description: value.description,
              materialCode: value.materialCode,
              barcode: value.barcode,
              storedItemId: value.id,
              id: value.id,
              storedItemLocationId: value.storedItemLocationId,
              selectedQuantity: parseFloat(value.selectedQuantity),
              warehouseName: value.warehouseName,
              newWarehouseName: vm.locationSelected.warehouseName,
              locationName: value.locationName,
              newLocationName: vm.locationSelected.name,
              newLocationId: vm.locationSelected.id,
              issueNumber: value.issueNumber,
              issueItemId: value.issueItemId
            });
          });

          vm.fakeItems(vm.fakedItems);

          vm.error = false;
          vm.saved = true;
          vm.saving = false;

        }, function (error) {
          if (error.status !== 403) {
            vm.saved = false;
            vm.error = true;
            vm.saving = false;
          }
          else {
            $uibModalInstance.dismiss('cancel');
          }
        });
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };


    /** Locations */

    vm.locations = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/locations',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', vm.bearerToken);
          }
        }
      },
      group: {field: "warehouseName"}
    };

    vm.locationsOptions = {
      dataSource: vm.locations,
      dataTextField: "name",
      dataValueField: "id",
      filter: "contains",
      autoBind: false,
      fixedGroupTemplate: "Warehouse: #=data#",
      groupTemplate: "<div style='color: black;'>Warehouse: #:data#</div>"
    };

  }


})();


(function() {
  'use strict';

  angular
    .module("app.common")
    .factory("tokencontainer", [tokencontainer]);

  tokencontainer.$inject = ['API'];

  function tokencontainer(API) {

    var container = {
      token: ""
    };

    var setToken = function (token) {
      container.token = token;
    };

    var getToken = function () {

      if (container.token === "") {
        if (localStorage.getItem("access_token") === null) {

          // get the token using implicit flow
          var url = API.BASE_URI_IDENTITY + "connect/authorize?" +
                    "client_id=materiaImplicit&" +
                    "redirect_uri=" + encodeURI(API.BASE_URI_PROTOCOL + "/app/auth/callback.html") + "&" +
                    "response_type=token&" +
                    "scope=materia, roles";

          // redirect tp the identity server
          window.location = url;
        }
        else {
          // set the token in localStorage
          setToken(localStorage.access_token);
        }
      }
      return container;
    };

    return {
      getToken: getToken
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.admin', []);

})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('ViewWarehousesCtrl', ViewWarehousesCtrl);

  ViewWarehousesCtrl.$inject = ['deliveryService', 'SweetAlert', '$filter', '$scope'];

  /* @ngInject */
  function ViewWarehousesCtrl(deliveryService, SweetAlert, $filter, $scope) {
    var vm = this;

    vm.warehouses = [];
    vm.deleteWarehouse = deleteWarehouse;

    activate();

    ///////////////////////

    function activate() {

      deliveryService.getWarehouses()
        .then(function(response) {
          vm.warehouses = response;
        });
    }

    function refreshGrid(){
      activate();
    }

    function deleteWarehouse(warehouseId) {
      SweetAlert.swal({
          title: "Are you sure?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return deliveryService.deleteWarehouse(warehouseId)
            .then(function (response) {
              vm.loading = false;
                vm.warehouses = $filter('filter')(vm.warehouses, function(value, index){ return value.id !== warehouseId });
                SweetAlert.swal("Deleted!", "The warehouse has been deleted.", "success");
              }, function (error) {
                vm.loading = false;
                SweetAlert.swal({title: "Unable to delete warehouse!", text: typeof error.data ==='object' ? error.data.exceptionMessage: error.data, type: "error", html:true});
              }
            );
        });
    }

    $scope.$on('upload-complete', function(event, args) {
      refreshGrid();
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('ViewWarehouseCtrl', ViewWarehouseCtrl);

  ViewWarehouseCtrl.$inject = ['$scope', '$timeout', '$stateParams', '$state', '$filter', 'deliveryService', 'SweetAlert', '$uibModal'];

  /* @ngInject */

  function ViewWarehouseCtrl($scope, $timeout, $stateParams, $state, $filter, deliveryService, SweetAlert, $uibModal) {
    var vm = this;

    vm.warehouseId = $stateParams.id;
    vm.warehouse = {};
    vm.locations = [];
    vm.locationId = undefined;
    vm.millisecondsToWaitBeforeValidation = 700;
    vm.timeout = undefined;

    vm.isNewWarehouse = vm.warehouseId === "";
    vm.pageTitle = (vm.isNewWarehouse ? 'Create' : 'Edit') + ' warehouse';

    vm.updateWarehouse = updateWarehouse;

    vm.updateLocation = updateLocation;
    vm.deleteLocation = deleteLocation;
    vm.openAddLocationModal = openAddLocationModal;

    vm.getLocationsforWarehouse = getLocationsforWarehouse;

    activate();

    //////////////////

    function activate() {

      if (!vm.isNewWarehouse) {
        deliveryService.getWarehouse(vm.warehouseId)
          .then(function (response) {
            vm.warehouse = response;
            vm.getLocationsforWarehouse()
          });
      }
    }

    function getLocationsforWarehouse(){
      deliveryService.getLocationsForWarehouse(vm.warehouseId)
        .then(function(response){
          vm.locations = response;
        });
    }

    function updateWarehouse() {
      if (vm.isNewWarehouse) {
        return deliveryService.createWarehouse(vm.warehouse)
          .then(function (response) {
            $state.transitionTo('admin.warehouses');
            SweetAlert.swal("Created!", "The warehouse has been successfully created.", "success");
          });
      } else {
        return deliveryService.updateWarehouse(vm.warehouse)
          .then(function (response) {
            $state.transitionTo('admin.warehouses');
            SweetAlert.swal("Updated!", "The warehouse has been successfully updated.", "success");
        });
      }
    }

    function openAddLocationModal() {
      $uibModal.open({
        templateUrl: 'app/admin/addUpdateLocationModal.html',
        controller: 'AddLocationModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          warehouseId: function () {
            return vm.warehouseId;
          },
          locationId: function(){
            return vm.locationId;
          },
          locations: function(){
            return vm.locations;
          }
        }
      }).result
        .then(function(){
          SweetAlert.swal("Saved!", "The location has been saved successfully.", "success");
          vm.locationId = null;
        })
        .catch(function(){
          vm.locationId = null;
        });
    }

    function updateLocation(locationId) {
      vm.locationId = locationId;
      vm.openAddLocationModal();
    }

    function deleteLocation(locationId) {
      SweetAlert.swal({
          title: "Are you sure?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return deliveryService.deleteLocation(locationId)
            .then(function (response) {
                vm.loading = false;
                vm.locations = $filter('filter')(vm.locations, function(value, index){ return value.id !== locationId });
                SweetAlert.swal("Deleted!", "The location has been deleted.", "success");
              }, function (error) {
                vm.loading = false;
                SweetAlert.swal({title: "Unable to delete location.", text: typeof error.data ==='object' ? error.data.exceptionMessage: error.data, type: "error", html:true});
              }
            );
        });
    }
  }
})();


(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('ViewUsersCtrl', ViewUsersCtrl);

  ViewUsersCtrl.$inject = ['adminService'];

  /* @ngInject */
  function ViewUsersCtrl(adminService) {
    var vm = this;

    vm.users = [];
    vm.textFilter = "";
    vm.clearFilter = clearFilter;

    activate();

    ///////////////////////

    function activate() {

      adminService.getUsers()
        .then(function(response) {
          vm.users = response;
        });
    }

    function clearFilter(){
      vm.textFilter = '';
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('ViewUserCtrl', ViewUserCtrl);

  ViewUserCtrl.$inject = ['$scope', '$timeout', '$stateParams', '$state', '$filter', 'adminService', 'projectService', 'SweetAlert'];

  /* @ngInject */

  function ViewUserCtrl($scope, $timeout, $stateParams, $state, $filter, adminService, projectService, SweetAlert) {
    var vm = this;

    vm.userId = $stateParams.id;
    vm.user = {};
    vm.roles = [];
    vm.projects = [];
    vm.permissions = [];
    vm.isAdmin = false;
    vm.initialised = false;
    vm.emailExists = false;
    vm.millisecondsToWaitBeforeValidation = 700;
    vm.timeout = undefined;
    vm.passwordError = "";

    vm.password = {
      oldPassword: "",
      newPassword: "",
      confirmPassword: ""
    };

    vm.isNewAccount = vm.userId === "";
    vm.originalEmail = "";

    vm.editRoleClaim = editRoleClaim;
    vm.editProjectClaim = editProjectClaim;
    vm.editPermission = editPermission;
    vm.updatePassword = updatePassword;
    vm.updateUserDetails = updateUserDetails;
    vm.updateLockStatus = updateLockStatus;
    vm.deleteUser = deleteUser;
    vm.clearPasswordError = clearPasswordError;    

    $scope.$watch('vm.user.email', debounceUpdate);

    activate();

    //////////////////

    function activate() {

      if (!vm.isNewAccount) {
        adminService.getUser(vm.userId)
          .then(function (response) {
            vm.user = response;
            vm.originalEmail = angular.copy(vm.user.email);
            adminService.getRoles()
              .then(function (response) {
                vm.roles = response;
                setSelectedRoles();
                projectService.getProjects()
                  .then(function (response) {
                    vm.projects = response;
                    setSelectedProjects();
                    adminService.getPermissions(vm.userId)
                      .then(function (response) {
                        vm.permissions = response;  
                        vm.initialised = true;                                                        
                      });
                  });
              });
          });
      }
    }

    function setSelectedRoles() {
      angular.forEach(vm.roles, function (role) {
        if ($filter('filter')(vm.user.claims, {type: "role", value: role.name}).length > 0) {
          role.isIncluded = true;
          vm.user.role = role.name;
        } else {
          role.isIncluded = false;
        }
      });
    }

    function setSelectedProjects() {
      angular.forEach(vm.projects, function (project) {
        if ($filter('filter')(vm.user.claims, {type: "project", value: project.code}).length > 0) {
          project.isIncluded = true;
        } else {
          project.isIncluded = false;
        }
      });
    }

    $scope.$watch("vm.user.role", function(newRole, oldRole){        
        if (vm.initialised) editRoleClaim(newRole);        
    });
    
    function editRoleClaim(role) {
        adminService.updateRole(vm.userId, "role", role).then(function (response) {
          adminService.getPermissions(vm.userId)
            .then(function (response) {
              $timeout(function () {
                vm.permissions = response;
                vm.user.role = role;
              });
            });
        });
    }

    function addRoleClaim(value) {
      adminService.addClaim(vm.userId, "role", value);
    }

    function removeRoleClaim(value) {
      adminService.removeClaim(vm.userId, "role", value);
    }

    function editProjectClaim(id) {
      var project = $filter('filter')(vm.projects, {id: id});
      if (project[0].isIncluded) {
        addProjectClaim(project[0]);
      } else {
        removeProjectClaim(project[0]);
      }
    }

    function addProjectClaim(project) {
      adminService.addClaim(vm.userId, "project", project.code);
      adminService.addClaim(vm.userId, "projectId", project.id);
    }

    function removeProjectClaim(project) {
      adminService.removeClaim(vm.userId, "project", project.code);
      adminService.removeClaim(vm.userId, "projectId", project.id);
    }

    function editPermission(resource, action) {
      var resourceLine = $filter('filter')(vm.permissions, {resource: resource});
      angular.forEach(resourceLine[0].permissions, function (value, key) {
        if (key.toUpperCase() === action.toUpperCase()) {
          if (value === true) {
            adminService.addClaim(vm.userId, resourceLine[0].resource, key);
          } else {
            adminService.removeClaim(vm.userId, resourceLine[0].resource, key);
          }
        }
      });
    }

    function updatePassword() {
      vm.passwordError = undefined;
      return adminService.updatePassword(vm.userId, vm.password.oldPassword, vm.password.newPassword)
        .then(function (response) {
          if (response.$resolved) {
            SweetAlert.swal("Updated!", "Password updated successfully.", "success");
          } else if (response.status === 403) {
            vm.passwordError = response.data.message;
          }
        });
    }

    function updateUserDetails() {
      if (vm.isNewAccount) {
        return adminService.createUser(vm.user.firstName, vm.user.lastName, vm.user.username, vm.user.email, vm.user.employeeId)
          .then(function (response) {
            $state.transitionTo('admin.userdetails', {id: response.userId});
          });
      } else {
        adminService.updateUserDetails(vm.userId, vm.user.firstName, vm.user.lastName, vm.user.email, vm.user.username, vm.user.employeeId);
        SweetAlert.swal("Updated!", "The user account has been successfully updated.", "success");
      }
    }

    function updateLockStatus() {
      vm.user.isLoginAllowed = !vm.user.isLoginAllowed;
      adminService.updateLockStatus(vm.userId, vm.user.isLoginAllowed);
    }

    function deleteUser() {
      SweetAlert.swal({
          title: "Are you sure?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return adminService.deleteUser(vm.userId)
            .then(function (response) {
                vm.loading = false;
                $state.transitionTo('admin.view');
                SweetAlert.swal("Deleted!", "The user account has been deleted.", "success");
              }, function (error) {
                showValidationErrors(error);
              }
            );
        });
    }

    function clearPasswordError(){
      vm.passwordError = "";
    }

    function debounceUpdate(newValue, oldValue) {
      if (newValue !== oldValue) {

        if (vm.timeout) {
          $timeout.cancel(vm.timeout);
        }

        vm.check = true;
        $timeout(adminService.checkEmail(newValue).then(function (response) {
            var exists = response.exists;
            if (vm.isNewAccount && exists) {
              vm.emailExists = true;
            }
            else if (!vm.isNewAccount) {
              if (vm.user.email !== vm.originalEmail && exists) {
                vm.emailExists = true;
              } else {
                vm.emailExists = false;
              }
            } else {
              vm.emailExists = false;
            }
          }
        ), vm.millisecondsToWaitBeforeValidation);

        vm.check = false;
      }
    }

    $scope.$watch(function(){
      return $scope.vm.user.firstName;
    }, function(newValue, oldValue){
      if (vm.isNewAccount && angular.isDefined(vm.user.firstName))
        $scope.vm.user.username = $scope.vm.user.firstName;
    }, true);

    $scope.$watch(function(){
      return $scope.vm.user.lastName;
    }, function(newValue, oldValue){
      if (vm.isNewAccount && angular.isDefined(vm.user.lastName))
        $scope.vm.user.username = $scope.vm.user.firstName + '.' + vm.user.lastName;
    }, true);

    $scope.$watch(function(){
      return $scope.vm.user.username;
    }, function(newValue, oldValue){
      if (vm.isNewAccount && angular.isDefined(vm.user.firstName) && angular.isDefined(vm.user.lastName))
        $scope.vm.user.email = $scope.vm.user.username + '@woodplc.com';
    }, true);

  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('ViewShippingNotesCtrl', ViewShippingNotesCtrl);

  ViewShippingNotesCtrl.$inject = ['manifestService', 'SweetAlert', '$state', '$filter','$uibModal'];

  /* @ngInject */
  function ViewShippingNotesCtrl(manifestService, SweetAlert, $state, $filter, $uibModal) {
    var vm = this;

    vm.notes = [];
    vm.displayNoteLength = 130;
    vm.deleteNote = deleteNote;
    vm.updateNote = updateNote;
    vm.openAddNoteModal = openAddNoteModal;

    activate();

    ///////////////////////

    function activate() {
        manifestService.getShippingNotes()
        .then(function(response) {
          vm.notes = response;
        });
    }

    function openAddNoteModal(noteId) {
      $uibModal.open({
        templateUrl: 'app/admin/addUpdateNoteModal.html',
        controller: 'AddNoteModalCtrl',
        controllerAs: 'vm',
        size: 'lg',
        resolve: {
          noteId: function(){
            return noteId;
          },
          notes: function(){
            return vm.notes;
          }
        }
      }).result
        .then(function(){
          SweetAlert.swal("Saved!", "The note has been saved successfully.", "success");
        })
        .catch(function(){
        });
    }

    function updateNote(noteId) {
      vm.openAddNoteModal(noteId);
    }

    function deleteNote(noteId) {
      SweetAlert.swal({
          title: "Are you sure?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return manifestService.deleteShippingNote(noteId)
            .then(function (response) {
              vm.loading = false;
                vm.notes = $filter('filter')(vm.notes, function(value, index){ return value.id !== noteId });
                SweetAlert.swal("Deleted!", "The note has been deleted.", "success");
              }, function (error) {
                showValidationErrors(error);
              }
            );
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not save the note.');
      }
      vm.loading = false;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('ViewShippingAddressesCtrl', ViewShippingAddressesCtrl);

  ViewShippingAddressesCtrl.$inject = ['manifestService', 'SweetAlert', '$state', '$filter', '$stateParams'];

  /* @ngInject */
  function ViewShippingAddressesCtrl(manifestService, SweetAlert, $state, $filter, $stateParams) {
    if ($state.transition) return;

    var vm = this;

    vm.addresses = [];
    vm.itemsPerPage = 10;
    vm.currentPage = $stateParams.page || 1;
    vm.deleteAddress = deleteAddress;
    vm.resetCurrentPage = resetCurrentPage;

    vm.searching = false;
    vm.doSearch = doSearch;
    vm.clearSearch = clearSearch;
    vm.pageChange = pageChange;

    vm.searchParams = {
      searchTerm : $stateParams.term || ''
    };

    activate();

    ///////////////////////

    function activate() {
      vm.doSearch();
    }

    function deleteAddress(addressId) {
      SweetAlert.swal({
          title: "Are you sure?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Close",
          closeOnConfirm: false
        },
        function (isConfirm) {
          if (!isConfirm) return;
          vm.loading = true;
          return manifestService.deleteAddress(addressId)
            .then(function (response) {
              vm.loading = false;
                vm.addresses = $filter('filter')(vm.addresses, function(value, index){ return value.id !== addressId });
                SweetAlert.swal("Deleted!", "The address has been deleted.", "success");
              }, function (error) {
                showValidationErrors(error);
              }
            );
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not save the address.');
      }
      vm.loading = false;
    }

    function doSearch() {
      vm.searching = true;

      return manifestService.searchAddresses(vm.searchParams).then(function(data) {
        vm.addresses = data;
        vm.totalItems = vm.addresses.length;
        vm.lastSearchParams = angular.copy(vm.searchParams);
        pageChange(vm.currentPage);
        vm.searching = false;
      });
    }
    function clearSearch(){
      vm.searchParams.searchTerm = "";
      vm.doSearch();
    }

    function resetCurrentPage() {
      vm.currentPage = 1;
    }

    function pageChange(newPageNumber){
      $state.transitionTo('admin.shippingAddresses',
        {
          term: vm.searchParams.searchTerm,
          page: newPageNumber
        },
        {
          notify: false
        });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('ViewShippingAddressCtrl', ViewShippingAddressCtrl);

  ViewShippingAddressCtrl.$inject = ['$scope', '$timeout', '$stateParams', '$state', '$filter', 'manifestService', 'SweetAlert'];

  /* @ngInject */

  function ViewShippingAddressCtrl($scope, $timeout, $stateParams, $state, $filter, manifestService, SweetAlert) {
    var vm = this;

    vm.addressId = $stateParams.id;
    vm.address = {};
    vm.addresses = [];
    vm.millisecondsToWaitBeforeValidation = 700;
    vm.timeout = undefined;

    vm.isNewAddress = vm.addressId === "";
    vm.pageTitle = (vm.isNewAddress ? 'Create' : 'Edit') + ' shipping address';

    vm.updateAddress = updateAddress;

    activate();

    //////////////////

    function activate() {

      if (!vm.isNewAddress) {
        manifestService.getAddress(vm.addressId)
          .then(function (response) {
            vm.address = response;
          });
      }
    }

    function updateAddress() {

      vm.address.telephoneNo = vm.address.telephoneNo == null ? '' : vm.address.telephoneNo;
      vm.address.faxNo = vm.address.faxNo == null ? '' : vm.address.faxNo;
      vm.address.vatNo = vm.address.vatNo == null ? '' : vm.address.vatNo;
      vm.address.vatDefNo = vm.address.vatDefNo == null ? '' : vm.address.vatDefNo;

      if (vm.isNewAddress) {
        return manifestService.createAddress(vm.address)
          .then(function (response) {
            $state.transitionTo('admin.shippingAddresses');
            SweetAlert.swal("Created!", "The address has been successfully created.", "success");
          });
      } else {
        return manifestService.updateAddress(vm.address)
          .then(function (response) {
            $state.transitionTo('admin.shippingAddresses');
            SweetAlert.swal("Updated!", "The address has been successfully updated.", "success");
        });
      }
    }
  }
})();

(function () {
    'use strict';
  
    angular
      .module('app.admin')
      .controller('ViewAgentsCtrl', ViewAgentsCtrl);
  
    ViewAgentsCtrl.$inject = ['manifestService', 'SweetAlert', '$state', '$filter','$uibModal'];
  
    /* @ngInject */
    function ViewAgentsCtrl(manifestService, SweetAlert, $state, $filter, $uibModal) {
      var vm = this;
  
      vm.name = [];
      vm.displayDetailsLength = 130;
      vm.deleteAgent = deleteAgent;
      vm.updateAgent = updateAgent;
      vm.openAddAgentModal = openAddAgentModal;
  
      activate();
  
      ///////////////////////
  
      function activate() {
        manifestService.getAgents()
          .then(function(response) {
            vm.name = response;
          });
      }
  
      function openAddAgentModal(agentId) {
        $uibModal.open({
          templateUrl: 'app/admin/addUpdateAgentModal.html',
          controller: 'AddAgentModalCtrl',
          controllerAs: 'vm',
          size: 'lg',
          resolve: {
            agentId: function(){
              return agentId;
            },
            name: function(){
              return vm.name;
            }
          }
        }).result
          .then(function(){
            SweetAlert.swal("Saved!", "The agent has been saved successfully.", "success");
          })
          .catch(function(){
          });
      }
  
      function updateAgent(agentId) {
        vm.openAddAgentModal(agentId);
      }
  
      function deleteAgent(agentId) {
        SweetAlert.swal({
            title: "Are you sure?",
            type: "info",
            showCancelButton: true,
            confirmButtonColor: "#1ab394",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Close",
            closeOnConfirm: false
          },
          function (isConfirm) {
            if (!isConfirm) return;
            vm.loading = true;
            return manifestService.deleteAgent(agentId)
              .then(function (response) {
                vm.loading = false;
                  vm.name = $filter('filter')(vm.name, function(value, index){ return value.id !== agentId });
                  SweetAlert.swal("Deleted!", "The agent has been deleted.", "success");
                }, function (error) {
                  if (error.status === 500 && error.data.exceptionMessage === "The agent cannot be deleted because they have associated manifests.") {
                      SweetAlert.swal("Cannot Delete", "The agent cannot be deleted because they have associated manifests.", "error");
                  } else {
                      showValidationErrors(error);
                  }
                }
              );
          });
      }
  
      function showValidationErrors(error) {
        vm.validationErrors = [];
        if (error.data && angular.isObject(error.data)) {
          for (var key in error.data) {
            vm.validationErrors.push(error.data[key].ErrorMessage);
          }
        } else {
          vm.validationErrors.push('Could not save the agent.');
        }
        vm.loading = false;
      }
    }
  
  })();
  
(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('ViewAdminCtrl', ViewAdminCtrl);

  ViewAdminCtrl.$inject = ['OidcManager', 'permissionService'];

  /* @ngInject */
  function ViewAdminCtrl(OidcManager, permissionService) {
    var vm = this;

    vm.manager = OidcManager.OidcTokenManager();

    vm.isAdmin = isAdmin();
    vm.isSuperUser = vm.isAdmin === true ? true : permissionService.hasPermission("WarehouseAdmin", "Read");

    activate();

    ///////////////////////

    function activate() {

    }

    function isAdmin(){
      if (!vm.manager.expired){
        if (vm.manager.profile.role !== undefined){
          return vm.manager.profile.role.toUpperCase() === "ADMIN";
        } else {
          return false;
        }
      }
    }
  }

})();

(function(){
  'use strict';

  angular
    .module('app.admin')
    .controller('ImportWarehousesCtrl', ImportWarehousesCtrl);

  ImportWarehousesCtrl.$inject = ['API', 'SETTINGS', 'deliveryService', 'FileSaver', 'Blob'];

  /* @ngInject */
  function ImportWarehousesCtrl(API, SETTINGS, deliveryService, FileSaver, Blob){
    var vm = this;
    vm.downloadTemplate = downloadTemplate;
    vm.getImportErrors = getImportErrors;

    vm.importEndpoint = API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/import-export/warehouse-location-upload';

    activate();

    ////////////////////

    function activate(){

    }

    function downloadTemplate() {
      return deliveryService.getImportTemplate()
        .then(function(response) {
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

    function getImportErrors(documentKey) {
      return deliveryService.getImportErrors(documentKey)
        .then(function(response) {
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('ImportStockBalanceCtrl', ImportStockBalanceCtrl);

  ImportStockBalanceCtrl.$inject = ['API', 'SETTINGS', 'stockService', 'FileSaver', 'Blob']

  /* @ngInject */
  function ImportStockBalanceCtrl(API, SETTINGS, stockService, FileSaver, Blob) {
    var vm = this;

    vm.loading = false;

    vm.validationErrors = [];
    vm.hasErrors = false;
    vm.showValidationErrors = showValidationErrors;
    vm.downloadTemplate = downloadTemplate;
    vm.getImportErrors = getImportErrors;

    vm.importEndpoint = API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + '/import-export/stock-balance-upload';

    activate();

    /////////////////////////

    function activate(){

    }

    function downloadTemplate() {
      return stockService.getImportTemplate()
        .then(function(response) {
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

    function getImportErrors(documentKey) {
      return stockService.getImportErrors(documentKey)
        .then(function(response) {
          var file = new Blob([response.data]);
          FileSaver.saveAs(file, response.filename);
        });
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not record delivery.');
      }
      vm.loading = false;
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('AddNoteModalCtrl', AddNoteModalCtrl);

  AddNoteModalCtrl.$inject = ['$timeout', 'manifestService', 'API', 'SETTINGS','$uibModalInstance', 'noteId', 'notes'];

  /* @ngInject */

  function AddNoteModalCtrl($timeout, manifestService, API, SETTINGS, $uibModalInstance, noteId, notes) {
    var vm = this;

    vm.note = {};
    vm.addAnother = false;
    vm.note.code = SETTINGS.projectCode;
    vm.noteId = noteId;
    vm.notes = notes;
    vm.isNewNote = noteId == null;


    vm.saving = false;
    vm.saved = false;
    vm.error = false;
    vm.modalTitle = (vm.isNewNote ? 'Create' : 'Edit') + ' shipping note';

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    vm.save = function () {
      vm.saving = true;

      if(vm.isNewNote){
        return manifestService.createShippingNote(vm.note)
          .then(function (success) {
              addNewNote(success.shippingNoteId);
              afterSaveCompleteSuccess(success);
            },
            function(error){
              afterSaveCompleteError(error);
            });
      }
      else {
        return manifestService.updateShippingNote(vm.note)
          .then(
            function (success) {
              updateNewNote(vm.note);
              afterSaveCompleteSuccess(success);
            },
            function(error){
              afterSaveCompleteError(error);
            });
      }
    };

    activate();

    //////////////////

    function activate() {
      if (vm.noteId){
        manifestService.getShippingNote(vm.noteId)
          .then(function (response) {
            vm.note = response;
        });
      }
    }

    function addNewNote(noteId){
      vm.note.id = noteId;
      vm.notes.push(vm.note);
    }

    function updateNewNote(note){
      vm.notes.forEach(function(item){
        if (item.id === note.id) {
          item.title = note.title;
          item.notes = note.notes;
        }
      });
    }

    function afterSaveCompleteSuccess(response){
      vm.error = false;
      vm.saved = true;
      vm.saving = false;

      if (vm.addAnother) {
        resetModal();
      } else {
        $uibModalInstance.close();
      }
    }

    function afterSaveCompleteError (error) {

      vm.saved = false;
      vm.error = true;
      vm.saving = false;

      showValidationErrors(error);
    }

    function resetModal() {
      vm.note = {};
      vm.location.code = code;

      $timeout(function () {
        vm.saved = false;
      }, 4000);
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
        for (var key in error.data) {
          vm.validationErrors.push(error.data[key].ErrorMessage);
        }
      } else {
        vm.validationErrors.push('Could not save the location.');
      }
      vm.loading = false;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin')
    .controller('AddLocationModalCtrl', AddLocationModalCtrl);

  AddLocationModalCtrl.$inject = ['$scope', 'OidcManager', 'warehouseId', 'locationId', 'locations', '$timeout', 'deliveryService', 'API', 'SETTINGS','$uibModalInstance'];

  /* @ngInject */

  function AddLocationModalCtrl($scope, OidcManager, warehouseId, locationId, locations, $timeout, deliveryService, API, SETTINGS, $uibModalInstance) {
    var vm = this;

    var bearerToken = 'Bearer ' + OidcManager.OidcTokenManager().access_token;

    vm.location = {};
    vm.locationTypes = [];
    vm.addAnother = false;
    vm.location.warehouseId = warehouseId;
    vm.locationId = locationId;
    vm.locations = locations;
    vm.isNewLocation = locationId == null;

    vm.saving = false;
    vm.saved = false;
    vm.error = false;
    vm.modalTitle = (vm.isNewLocation ? 'Create' : 'Edit') + ' location';

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    vm.save = function () {
      vm.saving = true;

      if(vm.isNewLocation){
        return deliveryService.createLocation(vm.location)
          .then(function (success) {
              addNewLocation(success.locationId);
              afterSaveCompleteSuccess(success)
            },
            function(error){
              afterSaveCompleteError(error);
            });
      }
      else {
        return deliveryService.updateLocation(vm.location)
          .then(
            function (success) {
              updateLocation();
              afterSaveCompleteSuccess(success)
            },
            function(error){
              afterSaveCompleteError(error);
            });
      }
    };

    activate();

    vm.locationTypes = {
      transport: {
        read: {
          url: API.BASE_URI_WAREHOUSE + SETTINGS.projectCode + "/locations/locationTypes",
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', bearerToken);
          }
        }
      }
    };

    vm.locationTypesOptions = {
      dataSource: vm.locationTypes,
      dataTextField: "name",
      dataValueField: "id",
      suggest: true,
      autoBind: false,
      change: function (e) {
      }
    };

    //////////////////

    function activate() {
      if (vm.locationId){
        deliveryService.getLocation(vm.locationId)
          .then(function (response) {
            vm.location = response;
        });
      }
    }
    function addNewLocation(locationId){
      deliveryService.getLocation(locationId)
        .then(function (response) {
          vm.locations.push(response);
        });
    }

    function updateLocation(){
      deliveryService.getLocation(vm.locationId)
        .then(function (response) {
          vm.locations.forEach(function(item){
            if (item.id === response.id) {
              item.name = response.name;
              item.locationTypeId = response.locationTypeId;
              item.locationType = response.locationType;
            }
          });
        });
    }

    function afterSaveCompleteSuccess(response){
      vm.error = false;
      vm.saved = true;
      vm.saving = false;

      if (vm.addAnother) {
        resetModal();
      } else {
        $uibModalInstance.close();
      }
    }

    function afterSaveCompleteError (error) {

      vm.saved = false;
      vm.error = true;
      vm.saving = false;

      showValidationErrors(error);
    }

    function resetCombo(name) {
      var combo = angular.element(document.getElementsByName(name));
      combo.data("kendoComboBox").value("");
    }

    function resetModal() {
      vm.location = {};
      vm.location.warehouseId = warehouseId;
      resetCombo("LocationType");
      $timeout(function () {
        vm.saved = false;
      }, 4000);
    }

    function showValidationErrors(error) {
      vm.validationErrors = [];
      if (error.data && angular.isObject(error.data)) {
          vm.validationErrors.push(error.data.exceptionMessage);
      } else if (error.status === 409){
        vm.validationErrors.push(error.statusText);
      } else {
        vm.validationErrors.push('Could not save the location.');
      }
      vm.loading = false;
    }

  }
})();

(function () {
    'use strict';
  
    angular
      .module('app.admin')
      .controller('AddAgentModalCtrl', AddAgentModalCtrl);
  
      AddAgentModalCtrl.$inject = ['$timeout', 'manifestService', 'API', 'SETTINGS','$uibModalInstance', 'agentId', 'name'];
  
    /* @ngInject */
  
    function AddAgentModalCtrl($timeout, manifestService, API, SETTINGS, $uibModalInstance, agentId, name) {
      var vm = this;
  
      vm.agent = {};
      vm.addAnother = false;
      vm.agent.code = SETTINGS.projectCode;
      vm.agentId = agentId;
      vm.name = name;
      vm.isNewAgent = agentId == null;
  
  
      vm.saving = false;
      vm.saved = false;
      vm.error = false;
      vm.modalTitle = (vm.isNewAgent ? 'Create' : 'Edit') + ' agent';
  
      vm.cancel = function () {
        $uibModalInstance.dismiss('cancel');
      };
  
      vm.save = function () {
        vm.saving = true;
  
        if(vm.isNewAgent){
          return manifestService.createAgent(vm.agent)
            .then(function (success) {
                addNewAgent(success.agentId);
                afterSaveCompleteSuccess(success);
              },
              function(error){
                afterSaveCompleteError(error);
              });
        }
        else {
          return manifestService.updateAgent(vm.agent)
            .then(
              function (success) {
                updateNewAgent(vm.agent);
                afterSaveCompleteSuccess(success);
              },
              function(error){
                afterSaveCompleteError(error);
              });
        }
      };
  
      activate();
  
      //////////////////
  
      function activate() {
        if (vm.agentId){
          manifestService.getAgent(vm.agentId)
            .then(function (response) {
              vm.agent = response;
          });
        }
      }
  
      function addNewAgent(agentId){
        vm.agent.id = agentId;
        vm.name.push(vm.agent);
      }
  
      function updateNewAgent(agent){
        vm.name.forEach(function(item){
          if (item.id === agent.id) {
            item.name = agent.name;
          }
        });
      }
  
      function afterSaveCompleteSuccess(response){
        vm.error = false;
        vm.saved = true;
        vm.saving = false;
  
        if (vm.addAnother) {
          resetModal();
        } else {
          $uibModalInstance.close();
        }
      }
  
      function afterSaveCompleteError (error) {
  
        vm.saved = false;
        vm.error = true;
        vm.saving = false;
  
        showValidationErrors(error);
      }
  
      function resetModal() {
        vm.agent = {};
        vm.location.code = code;
  
        $timeout(function () {
          vm.saved = false;
        }, 4000);
      }
  
       function showValidationErrors(error) {
         vm.validationErrors = [];
         if (error.data && angular.isObject(error.data)) {
           for (var key in error.data) {
             vm.validationErrors.push(error.data[key].ErrorMessage);
           }
         } else {
           vm.validationErrors.push('Could not save the agent.');
         }
         vm.loading = false;
       }
  
    }
  })();
  
(function () {
  'use strict';

  // Create a module for naturalSorting
  angular.module("naturalSort", [])

    // The core natural service
    .factory("naturalService", ["$locale", function ($locale) {
      "use strict";
      // amount of extra zeros to padd for sorting
      var padding = function (value) {
          return "00000000000000000000".slice(value.length);
        },

        // Converts a value to a string.  Null and undefined are converted to ''
        toString = function (value) {
          if (value === null || value === undefined) return '';
          return '' + value;
        },

        // Calculate the default out-of-order date format (dd/MM/yyyy vs MM/dd/yyyy)
        natDateMonthFirst = $locale.DATETIME_FORMATS.shortDate.charAt(0) === "M",
        // Replaces all suspected dates with a standardized yyyy-m-d, which is fixed below
        fixDates = function (value) {
          // first look for dd?-dd?-dddd, where "-" can be one of "-", "/", or "."
          return toString(value).replace(/(\d\d?)[-\/\.](\d\d?)[-\/\.](\d{4})/, function ($0, $m, $d, $y) {
            // temporary holder for swapping below
            var t = $d;
            // if the month is not first, we'll swap month and day...
            if (!natDateMonthFirst) {
              // ...but only if the day value is under 13.
              if (Number($d) < 13) {
                $d = $m;
                $m = t;
              }
            } else if (Number($m) > 12) {
              // Otherwise, we might still swap the values if the month value is currently over 12.
              $d = $m;
              $m = t;
            }
            // return a standardized format.
            return $y + "-" + $m + "-" + $d;
          });
        },

        // Fix numbers to be correctly padded
        fixNumbers = function (value) {
          // First, look for anything in the form of d.d or d.d.d...
          return value.replace(/(\d+)((\.\d+)+)?/g, function ($0, integer, decimal, $3) {
            // If there's more than 2 sets of numbers...
            if (decimal !== $3) {
              // treat as a series of integers, like versioning,
              // rather than a decimal
              return $0.replace(/(\d+)/g, function ($d) {
                return padding($d) + $d;
              });
            } else {
              // add a decimal if necessary to ensure decimal sorting
              decimal = decimal || ".0";
              return padding(integer) + integer + decimal + padding(decimal);
            }
          });
        },

        // Finally, this function puts it all together.
        natValue = function (value) {
          return fixNumbers(fixDates(value));
        };

      // The actual object used by this service
      return {
        naturalValue: natValue,
        naturalSort: function (a, b) {
          a = natValue(a);
          b = natValue(b);
          return (a < b) ? -1 : ((a > b) ? 1 : 0);
        }
      };
    }])

    // Attach a function to the rootScope so it can be accessed by "orderBy"
    .run(["$rootScope", "naturalService", function ($rootScope, naturalService) {
      "use strict";
      $rootScope.natural = function (field) {
        return function (item) {
          return naturalService.naturalValue(item[field]);
        };
      };
    }]);
})();

(function() {

  'use strict';

  angular
    .module('app', [
        'app.core',
        'app.common',
        'app.main',
        'app.services',
        'app.purchase-orders',
        'app.deliveries',
        'app.projects',
        'app.issues',
        'app.transfers',
        'app.returns',
        'app.bagAndTag',
        'app.manifests',
        'app.reporting',
        'app.admin',
        'app.search',
        'app.picklists',
        'app.movements',
        'app.osd-register',
        'app.inspections',
        'app.expediting',
        'app.min-max',
        'app.material-allocation'
    ]);
})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/admin/addUpdateAgentModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-sticky-note modal-icon\"></i><h4 class=\"modal-title\">{{vm.modalTitle}}</h4></div><div class=\"modal-body p-b-xxs\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Agents *</label><div class=\"col-lg-6\"><input type=\"text\" maxlength=\"100\" required=\"\" class=\"form-control\" ng-model=\"vm.agent.name\" style=\"width: 95%\"></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Item successfully saved.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error saving the item.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.save()\" ladda=\"vm.saving\" ng-disabled=\"vm.agent.name == undefined || vm.saved\">Save</button></div></div>");
$templateCache.put("app/admin/addUpdateLocationModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-compass modal-icon\"></i><h4 class=\"modal-title\">{{vm.modalTitle}}</h4></div><div class=\"modal-body p-b-xxs\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Name *</label><div class=\"col-lg-6\"><input type=\"text\" maxlength=\"30\" required=\"\" class=\"form-control\" ng-model=\"vm.location.name\" style=\"width: 95%\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Location type *</label><div class=\"col-lg-6\"><select kendo-combo-box=\"\" k-options=\"vm.locationTypesOptions\" ng-model=\"vm.location.locationTypeId\" name=\"LocationType\" style=\"width:100%\" ng-disabled=\"vm.saving\"></select></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Item successfully saved.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{ error }}</li></ul></div><span class=\"pr20\" ng-if=\"vm.isNewLocation\"><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.addAnother\"> Add another</span> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.save()\" ladda=\"vm.saving\" ng-disabled=\"vm.location.name == undefined || vm.location.locationTypeId == undefined || vm.saved\">Save</button></div></div>");
$templateCache.put("app/admin/addUpdateNoteModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-sticky-note modal-icon\"></i><h4 class=\"modal-title\">{{vm.modalTitle}}</h4></div><div class=\"modal-body p-b-xxs\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Title *</label><div class=\"col-lg-6\"><input type=\"text\" maxlength=\"100\" required=\"\" class=\"form-control\" ng-model=\"vm.note.title\" style=\"width: 95%\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Notes *</label><div class=\"col-lg-9\"><textarea type=\"text\" rows=\"15\" required=\"\" class=\"form-control\" ng-model=\"vm.note.notes\" style=\"width: 100%\"></textarea></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Item successfully saved.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error saving the item.</div><span class=\"pr20\" ng-if=\"vm.isNewLocation\"><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.addAnother\"> Add another</span> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.save()\" ladda=\"vm.saving\" ng-disabled=\"vm.note.title == undefined || vm.note.notes == undefined || vm.saved\">Save</button></div></div>");
$templateCache.put("app/admin/importStockBalance.html","<div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ImportStockBalanceCtrl as vm\"><form role=\"form\" name=\"poImport\"><div class=\"ibox-title\"><h5 for=\"product_name\">Stock balance import</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-12\"><button ladda=\"vm.loading\" type=\"submit\" class=\"btn btn-primary m-t-n-xs\" ng-click=\"vm.downloadTemplate()\"><i class=\"fa fa-download\"></i> Download template</button></div></div><div class=\"ibox\"></div><div class=\"row\"><div class=\"dz-container dropzone border-dashed\" dropzone=\"\" parent-id=\"\" import-endpoint=\"vm.importEndpoint\" get-import-errors=\"vm.getImportErrors(documentKey)\" id=\"dropzone\"><div class=\"dz-message\"><h4><i class=\"fa fa-upload fa-lg\"></i> Drop files here or click to upload</h4></div><div id=\"previews\"><div id=\"template\" class=\"dz-file-preview\"><div class=\"dz-file-preview-top\"><div id=\"upload-image\" class=\"dz-image\"><span class=\"preview\"><img data-dz-thumbnail=\"\"></span></div><div id=\"upload-info\" class=\"dz-info-upload\"><p class=\"dz-name\" data-dz-name=\"\"></p><p class=\"size\" data-dz-size=\"\"></p><strong class=\"error text-danger\" data-dz-errormessage=\"\"></strong></div><div class=\"dz-remove\"><button data-dz-remove=\"\" class=\"btn btn-danger delete pull-right\"><i class=\"fa fa-times\"></i></button></div><div class=\"clearfix\"></div><div class=\"progress progress-striped active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" aria-valuenow=\"0\" id=\"progressBar\" style=\"width: 100%; height: 5px; position: absolute; bottom: 0px; margin-top: 10px;\"><div class=\"progress-bar progress-bar-success\" style=\"width:0%;\" data-dz-uploadprogress=\"\"></div></div></div><div class=\"dz-file-preview-bottom\"></div></div></div></div></div></div></form></div>");
$templateCache.put("app/admin/importWarehouses.html","<div ng-controller=\"ImportWarehousesCtrl as vm\"><button ladda=\"vm.loading\" type=\"submit\" class=\"btn btn-primary m-t-n-xs\" ng-click=\"vm.downloadTemplate()\"><i class=\"fa fa-download\"></i> Download template</button><div class=\"row pt8\"><div class=\"dz-container dropzone border-dashed\" dropzone=\"\" parent-id=\"\" import-endpoint=\"vm.importEndpoint\" get-import-errors=\"vm.getImportErrors(documentKey)\" id=\"dropzone\"><div class=\"dz-message\"><h4><i class=\"fa fa-upload fa-lg\"></i> Drop files here or click to upload</h4></div><div id=\"previews\"><div id=\"template\" class=\"dz-file-preview\"><div class=\"dz-file-preview-top\"><div id=\"upload-image\" class=\"dz-image\"><span class=\"preview\"><img data-dz-thumbnail=\"\"></span></div><div id=\"upload-info\" class=\"dz-info-upload\"><p class=\"dz-name\" data-dz-name=\"\"></p><p class=\"size\" data-dz-size=\"\"></p><strong class=\"error text-danger\" data-dz-errormessage=\"\"></strong></div><div class=\"dz-remove\"><button data-dz-remove=\"\" class=\"btn btn-danger delete pull-right\"><i class=\"fa fa-times\"></i></button></div><div class=\"clearfix\"></div><div class=\"progress progress-striped active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" aria-valuenow=\"0\" id=\"progressBar\" style=\"width: 100%; height: 5px; position: absolute; bottom: 0px; margin-top: 10px;\"><div class=\"progress-bar progress-bar-success\" style=\"width:0%;\" data-dz-uploadprogress=\"\"></div></div></div><div class=\"dz-file-preview-bottom\"></div></div></div></div></div></div>");
$templateCache.put("app/admin/viewAdmin.html","<div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ViewAdminCtrl as vm\"><div class=\"row\"><div class=\"col-lg-4\"><div class=\"ibox-title\"><h5 for=\"product_name\">Admin functions</h5></div><div class=\"ibox-content\"><div class=\"widget style1 blue-bg\" ng-if=\"vm.isAdmin\"><div class=\"row\"><a ui-sref=\"projects.view\" title=\"Projects\" class=\"no-color\"><div class=\"col-xs-3\"><i class=\"fa fa-pencil-square-o fa-2x\"></i></div><div class=\"col-xs-9 text-right\"><h4>Manage projects</h4></div></a></div></div><div class=\"widget style1 navy-bg\" ng-if=\"vm.isAdmin\"><div class=\"row\"><a ui-sref=\"admin.users\" class=\"no-color\"><div class=\"col-xs-3\"><i class=\"fa fa-users fa-2x\"></i></div><div class=\"col-xs-9 text-right\"><h4>Manage users</h4></div></a></div></div><div class=\"widget style1 lazur-bg\" ng-if=\"vm.isAdmin\"><div class=\"row\"><a ui-sref=\"admin.importStockBalance\" class=\"no-color\"><div class=\"col-xs-3\"><i class=\"fa fa-upload fa-2x\"></i></div><div class=\"col-xs-9 text-right\"><h4>Import stock balance</h4></div></a></div></div><div class=\"widget style1 blue-bg\" ng-if=\"vm.isSuperUser\"><div class=\"row\"><a ui-sref=\"admin.warehouses\" class=\"no-color\"><div class=\"col-xs-3\"><i class=\"fa fa-archive fa-2x\"></i></div><div class=\"col-xs-9 text-right\"><h4>Manage warehouses</h4></div></a></div></div><div class=\"widget style1 red-bg\" ng-if=\"vm.isSuperUser\"><div class=\"row\"><a ui-sref=\"admin.shippingAddresses\" class=\"no-color\"><div class=\"col-xs-3\"><i class=\"fa fa-book fa-2x\"></i></div><div class=\"col-xs-9 text-right\"><h4>Manage shipping addresses</h4></div></a></div></div><div class=\"widget style1 yellow-bg\" ng-if=\"vm.isSuperUser\"><div class=\"row\"><a ui-sref=\"admin.shippingNotes\" class=\"no-color\"><div class=\"col-xs-3\"><i class=\"fa fa-sticky-note fa-2x\"></i></div><div class=\"col-xs-9 text-right\"><h4>Manage shipping notes</h4></div></a></div></div><div class=\"widget style1 red-bg\" ng-if=\"vm.isAdmin\"><div class=\"row\"><a ui-sref=\"admin.agents\" class=\"no-color\"><div class=\"col-xs-3\"><i class=\"fa fa-users fa-2x\"></i></div><div class=\"col-xs-9 text-right\"><h4>Manage agents</h4></div></a></div></div></div></div></div></div>");
$templateCache.put("app/admin/viewAgents.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Admin</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"admin.view\">Home</a></li><li class=\"active\"><strong>Agents</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ViewAgentsCtrl as vm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox-title\"><h5 for=\"product_name\">Agents</h5></div><div class=\"ibox-content\"><button class=\"btn btn-success\" ng-click=\"vm.openAddAgentModal()\"><i class=\"fa fa-sticky-note\"></i> Create agent</button><table class=\"table\"><thead><tr><th class=\"col-xs-3\">Agents</th><th class=\"col-xs-2\"></th></tr></thead><tbody><tr ng-repeat=\"agent in vm.name | orderBy:\'name\'\"><td>{{agent.name}}</td><td><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.updateAgent(agent.id)\">Edit</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.deleteAgent(agent.id)\"><span class=\"fa fa-times\"></span></button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin/viewShippingAddress.html","<div ng-controller=\"ViewShippingAddressCtrl as vm\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Admin</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"admin.view\">Home</a></li><li><a ui-sref=\"admin.shippingAddresses\">Shipping addresses</a></li><li class=\"active\"><strong>{{vm.pageTitle}}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-8\"><div class=\"ibox-title\"><h5 for=\"product_name\">Address details</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"addressDetailsForm\" ng-submit=\"vm.updateAddress()\"><div class=\"row\"><div class=\"col-md-12 pt4\"><label>Address 1</label> <input type=\"text\" name=\"address1\" required=\"\" class=\"form-control k-textbox\" ng-model=\"vm.address.address1\" tabindex=\"1\"></div></div><div class=\"row\"><div class=\"col-md-12 pt4\"><label>Address 2</label> <input type=\"text\" name=\"address2\" required=\"\" class=\"form-control k-textbox\" ng-model=\"vm.address.address2\" tabindex=\"2\"></div></div><div class=\"row\"><div class=\"col-md-12 pt4\"><label>Address 3</label> <input type=\"text\" name=\"address3\" required=\"\" class=\"form-control k-textbox\" ng-model=\"vm.address.address3\" tabindex=\"3\"></div></div><div class=\"row\"><div class=\"col-md-12 pt4\"><label>Address 4</label> <input type=\"text\" name=\"address4\" required=\"\" class=\"form-control k-textbox\" ng-model=\"vm.address.address4\" tabindex=\"4\"></div></div><div class=\"row\"><div class=\"col-md-4 pt4\"><label>Post code</label> <input type=\"text\" name=\"postCode\" required=\"\" class=\"form-control k-textbox\" ng-model=\"vm.address.postCode\" tabindex=\"5\"></div></div><div class=\"row\"><div class=\"col-md-4 pt4\"><label>Telephone No.</label> <input type=\"text\" name=\"telephoneNo\" class=\"form-control k-textbox\" ng-model=\"vm.address.telephoneNo\" tabindex=\"6\"></div><div class=\"col-md-4 pt4\"><label>Fax No.</label> <input type=\"text\" name=\"faxNo\" class=\"form-control k-textbox\" ng-model=\"vm.address.faxNo\" tabindex=\"7\"></div></div><div class=\"row\"><div class=\"col-md-4 pt4\"><label>VAT No.</label> <input type=\"text\" name=\"vatNo\" class=\"form-control k-textbox\" ng-model=\"vm.address.vatNo\" tabindex=\"8\"></div><div class=\"col-md-4 pt4\"><label>VAT Def No.</label> <input type=\"text\" name=\"vatDefNo\" class=\"form-control k-textbox\" ng-model=\"vm.address.vatDefNo\" tabindex=\"9\"></div></div><div class=\"row add-pd-b\"><div class=\"col-md-8 pt4\"><label>Country</label> <input type=\"text\" name=\"country\" required=\"\" class=\"form-control k-textbox\" ng-model=\"vm.address.country\" tabindex=\"10\"></div></div><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"addressDetailsForm.address1.$error.required || addressDetailsForm.address2.$error.required || addressDetailsForm.address3.$error.required || addressDetailsForm.address4.$error.required || addressDetailsForm.postCode.$error.required || addressDetailsForm.telephoneNo.$error.required || addressDetailsForm.faxNo.$error.required || addressDetailsForm.vatNo.$error.required || addressDetailsForm.vatDefNo.$error.required || addressDetailsForm.country.$error.required\">Save</button></form></div></div></div></div></div>");
$templateCache.put("app/admin/viewShippingAddresses.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Admin</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"admin.view\">Home</a></li><li class=\"active\"><strong>Shipping addresses</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ViewShippingAddressesCtrl as vm\"><div class=\"row add-pd-b\"><div class=\"col-lg-12\"><div class=\"ibox-title\"><h5>Address Search</h5></div><div class=\"ibox-content\"><div class=\"row m-t-sm\"><div class=\"col-lg-12\"><form role=\"form\" ng-submit=\"vm.resetCurrentPage(); vm.doSearch()\"><div class=\"form-group\"><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchParams.searchTerm\" placeholder=\"Enter text to search for ...\"></div><div class=\"col-sm-2\"><button type=\"submit\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-click=\"vm.resetCurrentPage(); vm.doSearch(vm.searchTerm)\">Go!</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.resetCurrentPage(); vm.clearSearch()\"><i class=\"fa fa-eraser\"></i> Clear</button></div></div></form></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox-title\"><h5 for=\"product_name\">Shipping Addresses</h5><i ng-if=\"vm.searchParams.searchTerm\" class=\"pull-right\"><span ng-if=\"vm.totalItems > 0\">Showing {{vm.totalItems}} items that match the search term</span> <span ng-if=\"vm.totalItems == 0\">No items matched the search term</span></i></div><div class=\"ibox-content\"><a ui-sref=\"admin.shippingAddressDetails\"><button class=\"btn btn-success\"><i class=\"fa fa-book\"></i> Create address</button></a><table class=\"table\"><thead><tr><th class=\"col-xs-2\">Address 1</th><th class=\"col-xs-2\">Address 2</th><th class=\"col-xs-2\">Address 3</th><th class=\"col-xs-2\">Address 4</th><th class=\"col-xs-1\">Post code</th><th class=\"col-xs-1\">Tel No.</th><th class=\"col-xs-2\"></th></tr></thead><tbody><tr dir-paginate=\"address in vm.addresses | itemsPerPage: vm.itemsPerPage\" current-page=\"vm.currentPage\"><td ng-bind-html=\"::address.address1 | highlight:vm.lastSearchParams.searchTerm\"></td><td ng-bind-html=\"::address.address2 | highlight:vm.lastSearchParams.searchTerm\"></td><td ng-bind-html=\"::address.address3 | highlight:vm.lastSearchParams.searchTerm\"></td><td ng-bind-html=\"::address.address4 | highlight:vm.lastSearchParams.searchTerm\"></td><td ng-bind-html=\"::address.postCode | highlight:vm.lastSearchParams.searchTerm\"></td><td ng-bind-html=\"::address.telephoneNo | highlight:vm.lastSearchParams.searchTerm\"></td><td><div class=\"pull-right\"><button ui-sref=\"admin.shippingAddressDetails({id:address.id})\" type=\"button\" class=\"btn btn-primary\">Edit</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.deleteAddress(address.id)\"><span class=\"fa fa-times\"></span></button></div></td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/admin/viewShippingNotes.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Admin</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"admin.view\">Home</a></li><li class=\"active\"><strong>Shipping notes</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ViewShippingNotesCtrl as vm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox-title\"><h5 for=\"product_name\">Shipping Notes</h5></div><div class=\"ibox-content\"><button class=\"btn btn-success\" ng-click=\"vm.openAddNoteModal()\"><i class=\"fa fa-sticky-note\"></i> Create note</button><table class=\"table\"><thead><tr><th class=\"col-xs-3\">Title</th><th class=\"col-xs-7\">Notes</th><th class=\"col-xs-2\"></th></tr></thead><tbody><tr ng-repeat=\"note in vm.notes | orderBy:\'title\'\"><td>{{note.title}}</td><td>{{note.notes | truncate: vm.displayNoteLength}}</td><td><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.updateNote(note.id)\">Edit</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.deleteNote(note.id)\"><span class=\"fa fa-times\"></span></button></div></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/admin/viewUser.html","<div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ViewUserCtrl as vm\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"tabs-container\"><uib-tabset><uib-tab><uib-tab-heading>User details</uib-tab-heading><div class=\"panel-body\"><form role=\"form\" name=\"userDetailsForm\" ng-submit=\"vm.updateUserDetails()\"><div class=\"row\"><div class=\"col-md-6 pt4\"><label>First name</label> <input type=\"text\" name=\"firstName\" required=\"\" class=\"form-control k-textbox\" ng-model=\"vm.user.firstName\" tabindex=\"1\"></div></div><div class=\"row\"><div class=\"col-md-6 pt4\"><label>Last name</label> <input type=\"text\" name=\"lastName\" required=\"\" class=\"form-control k-textbox\" ng-model=\"vm.user.lastName\" tabindex=\"2\"></div></div><div class=\"row\"><div class=\"col-md-6 pt4\"><label>Email</label> <input type=\"email\" name=\"email\" required=\"\" class=\"form-control k-textbox\" ng-model=\"vm.user.email\" tabindex=\"3\"></div><div class=\"col-md-4 user-info\"><span data-ng-if=\"vm.check\"><i class=\"fa fa-cog fa-spin\"></i></span> <span data-ng-if=\"vm.emailExists\" class=\"text-danger\" title=\"This email address is already in use.\"><i class=\"fa fa-times text-danger\"></i> This email address is already in use.</span></div></div><div class=\"row\"><div class=\"col-md-6 pt4\"><label>Username</label> <input type=\"text\" name=\"username\" required=\"\" class=\"form-control k-textbox\" ng-model=\"vm.user.username\" tabindex=\"4\"></div></div><div class=\"row add-pd-b\"><div class=\"col-md-6 pt4\"><label>Employee ID</label> <input type=\"text\" name=\"username\" required=\"\" class=\"form-control k-textbox\" ng-model=\"vm.user.employeeId\" tabindex=\"5\"></div></div><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"userDetailsForm.firstName.$error.required || userDetailsForm.lastName.$error.required || userDetailsForm.email.$error.required || userDetailsForm.username.$error.required || vm.emailExists\">Save</button></form></div></uib-tab><uib-tab ng-if=\"!vm.isNewAccount\"><uib-tab-heading>Password</uib-tab-heading><div class=\"panel-body\"><form role=\"form\" name=\"passwordForm\" ng-submit=\"vm.updatePassword()\"><div class=\"row\"><div class=\"col-md-6 pt4\"><label>Old password</label> <input type=\"password\" name=\"oldPassword\" class=\"form-control k-textbox\" required=\"\" ng-model=\"vm.password.oldPassword\" ng-change=\"vm.clearPasswordError()\"></div><div class=\"col-md-4 user-info\"><span class=\"text-danger\" ng-show=\"vm.passwordError !== \'\' && vm.passwordError !== undefined\"><i class=\"fa fa fa-warning text-danger\">{{vm.passwordError}}</i></span></div></div><div class=\"row\"><div class=\"col-md-6 pt4\"><label>New password</label> <input type=\"password\" name=\"password\" class=\"form-control k-textbox\" required=\"\" ng-model=\"vm.password.newPassword\"></div><div class=\"col-md-4\"></div></div><div class=\"row add-pd-b\"><div class=\"col-md-6 pt4\"><label>Confirm new password</label> <input type=\"password\" class=\"form-control k-textbox\" required=\"\" name=\"confirm_password\" ng-model=\"vm.password.confirmPassword\" password-verify=\"vm.password.newPassword\"></div><div class=\"col-md-4 user-info\"><span class=\"text-danger\" ng-show=\"passwordForm.confirm_password.$error.passwordVerify\"><i class=\"fa fa fa-warning text-danger\">New password fields are not equal.</i></span></div></div><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"vm.password.oldPassword === \'\' || vm.password.newPassword === \'\' || vm.password.confirmPassword === \'\' || passwordForm.confirm_password.$error.passwordVerify\">Change password</button></form></div></uib-tab><uib-tab ng-if=\"!vm.isNewAccount\"><uib-tab-heading>Projects</uib-tab-heading><div class=\"panel-body\"><table class=\"table\"><thead><th>Code</th><th>Name</th></thead><tbody><tr ng-repeat=\"project in vm.projects\"><td>{{project.code}}</td><td>{{project.name}}</td><td><input icheck=\"\" type=\"checkbox\" ng-model=\"project.isIncluded\" ng-change=\"vm.editProjectClaim(project.id)\"></td></tr></tbody></table></div></uib-tab><uib-tab ng-if=\"!vm.isNewAccount\"><uib-tab-heading>Role</uib-tab-heading><div class=\"panel-body\"><table class=\"table\"><thead><th>Name</th></thead><tbody><tr ng-repeat=\"role in vm.roles | orderBy: \'name\'\"><td>{{role.name}}</td><td><input icheck=\"\" type=\"radio\" ng-model=\"vm.user.role\" ng-value=\"role.name\" name=\"role\"></td></tr></tbody></table></div></uib-tab><uib-tab ng-if=\"!vm.isNewAccount || !vm.isAdmin\"><uib-tab-heading>Permissions</uib-tab-heading><div class=\"panel-body\"><table class=\"table\"><thead><th>Resource</th><th style=\"text-align:center; width: 12%\">Create</th><th style=\"text-align:center; width: 12%\">Read</th><th style=\"text-align:center; width: 12%\">Update</th><th style=\"text-align:center; width: 12%\">Edit</th><th style=\"text-align:center; width: 12%\">Delete</th><th style=\"text-align:center; width: 12%\">Complete</th><th style=\"text-align:center; width: 12%\">Cancel</th></thead><tbody><tr ng-repeat=\"row in vm.permissions | orderBy:\'resource\'\"><td>{{row.resource}}</td><td align=\"center\"><input icheck=\"\" type=\"checkbox\" ng-if=\"row.permissions.create !== undefined\" ng-model=\"row.permissions.create\" ng-change=\"vm.editPermission(row.resource, \'Create\')\"></td><td align=\"center\"><input icheck=\"\" type=\"checkbox\" ng-if=\"row.permissions.read !== undefined\" ng-model=\"row.permissions.read\" ng-change=\"vm.editPermission(row.resource, \'Read\')\"></td><td align=\"center\"><input icheck=\"\" type=\"checkbox\" ng-if=\"row.permissions.update !== undefined\" ng-model=\"row.permissions.update\" ng-change=\"vm.editPermission(row.resource, \'Update\')\"></td><td align=\"center\"><input icheck=\"\" type=\"checkbox\" ng-if=\"row.permissions.edit !== undefined\" ng-model=\"row.permissions.edit\" ng-change=\"vm.editPermission(row.resource, \'Edit\')\"></td><td align=\"center\"><input icheck=\"\" type=\"checkbox\" ng-if=\"row.permissions.delete !== undefined\" ng-model=\"row.permissions.delete\" ng-change=\"vm.editPermission(row.resource, \'Delete\')\"></td><td align=\"center\"><input icheck=\"\" type=\"checkbox\" ng-if=\"row.permissions.complete !== undefined\" ng-model=\"row.permissions.complete\" ng-change=\"vm.editPermission(row.resource, \'Complete\')\"></td><td align=\"center\"><input icheck=\"\" type=\"checkbox\" ng-if=\"row.permissions.cancel !== undefined\" ng-model=\"row.permissions.cancel\" ng-change=\"vm.editPermission(row.resource, \'Cancel\')\"></td></tr></tbody></table></div></uib-tab></uib-tabset></div></div><div class=\"col-sm-3 user-info\" ng-if=\"!vm.isNewAccount\"><div class=\"ibox-content\"><label>User</label><br><span>{{vm.user.firstName}} {{vm.user.lastName}}</span><br><br><label>Primary role</label><br><span>{{vm.user.role}}</span><br><br><label>Status</label><br><span>{{ vm.user.isLoginAllowed === true ? \'Active\' : \'Locked\' }}</span><br><br><label>Last logged in</label><br><span>{{vm.user.lastLogin | date: \'dd-MMM-yyyy HH:mm\'}}</span><br><br><button class=\"btn btn-warning user-btn\" ng-click=\"vm.updateLockStatus()\">{{ vm.user.isLoginAllowed === true ? \'Lock account\' : \'Unlock account\'}}</button> <button class=\"btn btn-danger user-btn\" ng-click=\"vm.deleteUser()\">Delete account</button></div></div></div></div>");
$templateCache.put("app/admin/viewUsers.html","<div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ViewUsersCtrl as vm\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"ibox-title\"><h5 for=\"product_name\">Users</h5></div><div class=\"ibox-content\"><div class=\"pb-20\"><a ui-sref=\"admin.userdetails\"><button class=\"btn btn-primary\"><i class=\"fa fa-user-plus\"></i> Create user</button></a></div><div class=\"form-group\" ng-if=\"vm.users.length\"><div class=\"btn-group\"><input type=\"text\" class=\"form-control filter-input\" ng-model=\"vm.textFilter\" placeholder=\"Filter list\" style=\"width: 250px\"></div><div class=\"btn-group\"><button class=\"btn btn-default\" ng-click=\"vm.clearFilter()\">Clear filter</button></div></div><dir-pagination-controls boundary-links=\"true\" pagination-id=\"userlist\"></dir-pagination-controls><table class=\"table\"><thead><tr><th>Name</th><th>Email</th><th>Status</th><th></th></tr></thead><tbody><tr dir-paginate=\"user in vm.users | filter: vm.textFilter | itemsPerPage: 15\" pagination-id=\"userlist\"><td>{{user.fullName}}</td><td>{{user.email}}</td><td>{{user.status}}</td><td><a ui-sref=\"admin.userdetails({id:user.id})\"><button class=\"btn btn-primary pull-right\">Edit</button></a></td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"userlist\"></dir-pagination-controls></div></div></div></div>");
$templateCache.put("app/admin/viewWarehouse.html","<div ng-controller=\"ViewWarehouseCtrl as vm\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Admin</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"admin.view\">Home</a></li><li><a ui-sref=\"admin.warehouses\">Warehouses</a></li><li class=\"active\"><strong>{{vm.isNewWarehouse ? \'Create warehouse\' : \'Edit warehouse\'}}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-6\"><div class=\"tabs-container\"><uib-tabset><uib-tab><uib-tab-heading>Warehouse details</uib-tab-heading><div class=\"panel-body\"><form role=\"form\" name=\"warehouseDetailsForm\" ng-submit=\"vm.updateWarehouse()\"><div class=\"row\"><div class=\"col-md-6 pt4\"><label>Name</label> <input type=\"text\" maxlength=\"30\" name=\"name\" required=\"\" class=\"form-control k-textbox\" ng-model=\"vm.warehouse.name\" tabindex=\"1\"></div></div><div class=\"row\"><div class=\"col-md-6 pt4\"><label>Inv Org Code</label> <input type=\"text\" maxlength=\"50\" name=\"invOrgCode\" class=\"form-control k-textbox\" ng-model=\"vm.warehouse.invOrgCode\" tabindex=\"2\"></div></div><div class=\"row\"><div class=\"col-md-6 pt4\"><label>Oracle Project Number</label> <input type=\"text\" maxlength=\"50\" name=\"oracleProjectNumber\" class=\"form-control k-textbox\" ng-model=\"vm.warehouse.oracleProjectNumber\" tabindex=\"3\"></div></div><div class=\"row\"><div class=\"col-md-6 pt4\"><label>Oracle Task Number</label> <input type=\"text\" maxlength=\"50\" name=\"oracleTaskNumber\" class=\"form-control k-textbox\" ng-model=\"vm.warehouse.oracleTaskNumber\" tabindex=\"4\"></div></div><div class=\"row add-pd-b\"><div class=\"col-md-6 pt4\"><label>Oracle Location Code</label> <input type=\"text\" maxlength=\"150\" name=\"oracleLocationCode\" class=\"form-control k-textbox\" ng-model=\"vm.warehouse.oracleLocationCode\" tabindex=\"5\"></div></div><button class=\"btn btn-primary\" type=\"submit\" ng-disabled=\"warehouseDetailsForm.name.$error.required\">Save</button></form></div></uib-tab><uib-tab ng-if=\"vm.warehouse.id\"><uib-tab-heading>Locations in {{vm.warehouse.name}}</uib-tab-heading><div class=\"panel-body\"><button class=\"btn btn-success\" ng-click=\"vm.openAddLocationModal()\"><i class=\"fa fa-plus\"></i> Create location</button><table class=\"table\"><thead><th>Name</th><th>Type</th><th></th></thead><tbody><tr ng-repeat=\"location in vm.locations | orderBy:\'name\'\"><td>{{location.name}}</td><td><span ng-class=\"location.locationType == \'Quarantine\' ? \'fa fa-exclamation-triangle\' : \'\'\"></span> {{location.locationType}}</td><td><div class=\"pull-right\"><button class=\"btn btn-primary\" ng-click=\"vm.updateLocation(location.id)\">Edit</button> <button class=\"btn btn-danger\" ng-click=\"vm.deleteLocation(location.id)\">Delete</button></div></td></tr></tbody></table></div></uib-tab></uib-tabset></div></div></div></div></div>");
$templateCache.put("app/admin/viewWarehouses.html","<div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10\"><h2>Admin</h2><ol class=\"breadcrumb\"><li><a ui-sref=\"admin.view\">Home</a></li><li class=\"active\"><strong>Warehouses</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ViewWarehousesCtrl as vm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"tabs-container\"><uib-tabset><uib-tab><uib-tab-heading><i class=\"fa fa-archive\"></i> Warehouses</uib-tab-heading><div class=\"panel-body\"><div class=\"col-lg-6\"><a ui-sref=\"admin.warehousedetails\"><button class=\"btn btn-success\"><i class=\"fa fa-archive\"></i> Create warehouse</button></a><table class=\"table\"><thead><tr><th class=\"col-xs-9\">Name</th><th class=\"col-xs-3\"></th></tr></thead><tbody><tr ng-repeat=\"warehouse in vm.warehouses | orderBy:\'name\'\"><td>{{warehouse.name}}</td><td><div class=\"pull-right\"><button ui-sref=\"admin.warehousedetails({id:warehouse.id})\" type=\"button\" class=\"btn btn-primary\">Edit</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.deleteWarehouse(warehouse.id)\"><span class=\"fa fa-times\"></span></button></div></td></tr></tbody></table></div></div></uib-tab><uib-tab><uib-tab-heading><i class=\"fa fa-upload\"></i> Import</uib-tab-heading><div class=\"panel-body\"><div ng-include=\"\'app/admin/importWarehouses.html\'\"></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/auth/callback.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title></title></head><body><script>\r\n    // if the URI contains a #, try to process the token\r\n    if (window.location.hash) {\r\n      processTokenCallback();\r\n    }\r\n\r\n    function processTokenCallback() {\r\n      var hash = window.location.hash.substr(1);\r\n\r\n      var result = hash.split(\'&\').reduce(function (result, item) {\r\n        var parts = item.split(\'=\');\r\n        result[parts[0]] = parts[1];\r\n        return result;\r\n      }, {});\r\n\r\n      if (!result.error && result.access_token !== undefined) {\r\n        localStorage[\"access_token\"] = result.access_token;\r\n\r\n        // redirect\r\n        window.location = window.location.protocol + \'//\' + window.location.host + \"/\";\r\n      }\r\n      else {\r\n        alert(\"Error: \" + (error.message || error));\r\n      }\r\n    }\r\n  </script></body></html>");
$templateCache.put("app/auth/locallogout.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title></title></head><body><script src=\"/bower_components/oidc-token-manager/dist/oidc-token-manager.js\"></script><script>\r\n      var manager = new OidcTokenManager();\r\n      // remove the token\r\n      manager.removeToken();\r\n    </script></body></html>");
$templateCache.put("app/auth/oidccallback.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title></title></head><body><script src=\"/bower_components/oidc-token-manager/dist/oidc-token-manager.js\"></script><script>\r\n      var config = {\r\n        client_id: \"materiaImplicit\",\r\n        load_user_profile: false,\r\n        <!-- build:uri -->\r\n        redirect_uri: \"http://localhost:9000/app/auth/oidccallback.html\",\r\n        authority: \"http://localhost:52746/identity/\"\r\n        <!-- endbuild -->\r\n      };\r\n\r\n      var manager = new OidcTokenManager(config);\r\n\r\n      // process the token\r\n      manager.processTokenCallbackAsync().then(function ()\r\n      {\r\n        <!-- build:tokenCallback -->\r\n        window.location = \"http://localhost:9000/#/\";\r\n        <!-- endbuild -->\r\n      },\r\n      function()\r\n      {\r\n        <!-- build:errorTokenCallback -->\r\n        window.location = \"http://localhost:9000/#/\";\r\n        <!-- endbuild -->\r\n      });\r\n\r\n    </script></body></html>");
$templateCache.put("app/auth/silentrefreshframe.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title></title></head><body><script src=\"/bower_components/oidc-token-manager/dist/oidc-token-manager.js\"></script><script>\r\n      var manager = new OidcTokenManager();\r\n      manager.processTokenCallbackSilent();\r\n    </script></body></html>");
$templateCache.put("app/bag-and-tag/consolidateItems.html","<button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.openConsolidateItems()\" ng-disabled=\"vm.selectedItems.length < 2 && !vm.selectedAll\"><i class=\"fa fa-object-group\" aria-hidden=\"true\"></i> Consolidate items</button>");
$templateCache.put("app/bag-and-tag/consolidateItemsModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-object-group modal-icon\"></i><h4 class=\"modal-title\">Consolidate items</h4><small class=\"font-bold\">You have chosen to group the {{vm.selectedItems.length}} selected item.</small></div><div class=\"modal-body p-b-xxs\"><form class=\"form-horizontal\" name=\"save\"><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Description</label><div class=\"col-lg-9\"><textarea required=\"\" type=\"text\" class=\"form-control\" style=\"resize: none;\" ng-model=\"vm.description\" ng-disabled=\"vm.saved\" name=\"groupDescription\" ng-class=\"{ \'has-error\' : save.groupDescription.$invalid && !save.groupDescription.$pristine }\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Location</label><div class=\"col-lg-9\"><div class=\"input-group\" style=\"width:100%;\"><select required=\"\" kendo-drop-down-list=\"\" k-options=\"vm.locationsOptions\" ng-model=\"vm.locationId\" ng-disabled=\"vm.saved\" name=\"location\" ng-class=\"{ \'has-error\' : save.location.$invalid && !save.location.$pristine }\" style=\"width:100%\"></select></div></div></div><div class=\"hr-line-dashed\"></div><table class=\"table materia-grouped-row\"><tbody ng-repeat=\"item in vm.selectedItems | orderBy: \'description\'\"><tr ng-class=\"transferItem.class\"><td colspan=\"4\" class=\"item-description\">{{item.description | uppercase}}</td></tr><tr ng-class=\"item.class\"><td><pre class=\"inline btn btn-sm btn-default no-hover\">{{item.materialCode}}</pre></td><td><pre class=\"inline btn btn-sm btn-default no-hover\">{{item.barcode}}</pre></td><td>{{item.unitOfMeasureCode}}</td><td>{{item.warehouseName}} / {{item.locationName}} <span ng-if=\"(item.groupedQuantity === \'0\' || item.groupedQuantity > item.selectedQuantity)\" class=\"pull-right\" title=\"Please enter a quantity between 1 and {{item.selectedQuantity}}.\"><i class=\"fa fa-warning text-danger\"></i></span></td><td><input type=\"text\" class=\"form-control\" name=\"quantity\" ng-model=\"item.groupedQuantity\" required=\"\" ng-disabled=\"vm.saved\" numeric-only=\"\"></td></tr></tbody></table></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Group successfully created.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error creating the group.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-hide=\"vm.saved\" ng-disabled=\"save.$invalid || (vm.selectedItems | filter:{isIncluded:true} | filter:vm.greaterThan(\'groupedQuantity\', \'selectedQuantity\')).length || (vm.selectedItems | filter:{isIncluded:true} | filter:vm.equalTo(\'groupedQuantity\', \'0\')).length\">Save</button></div></div>");
$templateCache.put("app/bag-and-tag/viewBagAndTag.html","<div ng-controller=\"ViewBagAndTagCtrl as vm\"><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"m-b-md\"><h2><span class=\"text-nowrap\">Bag & Tag {{ vm.bagAndTag.number }}</span> <small><strong class=\"text-nowrap\">{{vm.bagAndTag.description }}</strong></small> <span class=\"badge label-danger\" ng-if=\"vm.isDeleted\">Deleted</span> <span class=\"badge label-warning\" ng-if=\"!vm.bagAndTag.issueNumber\">Un-Allocated</span> <span class=\"badge label-primary\" ng-if=\"vm.bagAndTag.issueStatusId === 1\">Allocated</span> <span class=\"badge label-primary\" ng-if=\"vm.bagAndTag.issueStatusId === 3\">Issued</span></h2><span class=\"text-nowrap\"><span ng-if=\"vm.bagAndTag.workpackNumber.length\"><strong>Workpack Number:</strong> {{vm.bagAndTag.workpackNumber}} |</span> <strong>Issue Number:</strong> <span ng-if=\"vm.bagAndTag.issueNumber\"><a ui-sref=\"issues.details({id:vm.bagAndTag.issueId})\">{{vm.bagAndTag.issueNumber}}</a> |</span> <span ng-if=\"!vm.bagAndTag.issueNumber\">\"Un-Allocated\" |</span> <strong>Created by:</strong> {{vm.bagAndTag.createdBy}} | <strong>Created Date:</strong> {{vm.bagAndTag.createdDate | date: \'dd-MMM-yyyy\'}}</span></div><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-8\" ng-if=\"!vm.isDeleted && !vm.bagAndTag.isReadOnly\"><wg-search-criteria results=\"vm.results\" disable-bag-and-tag=\"true\"></wg-search-criteria><div class=\"ibox-content\" ng-show=\"vm.results\"><div><table class=\"table materia-grouped-row\" ng-show=\"vm.results.length\"><thead><tr><th>PO / Item</th><th>Material code</th><th>Barcode</th><th>UOM</th><th>Cost code</th><th>Location</th><th>Avail. Qty</th><th>Issue Qty</th><th></th></tr></thead><tbody ng-repeat=\"item in vm.results\" item=\"item\" wg-stored-item=\"\" add-item=\"vm.addItem(item)\"></tbody></table><div ng-show=\"!vm.results.length\">No results found.</div></div></div></div><div ng-class=\"!vm.bagAndTag.isReadOnly && !vm.isDeleted ? \'col-lg-4\' : \'col-lg-12\'\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Included items</h5></div><div class=\"ibox-footer\" ng-if=\"!vm.isDeleted && !vm.bagAndTag.isReadOnly\"><div ng-cloak=\"\"><div class=\"pull-left\"><div class=\"btn-toolbar\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-warning\" ng-disabled=\"vm.bagAndTagItems.length || vm.bagAndTagGroups.length\" ng-click=\"vm.deleteBagAndTag()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Delete</button></div><div class=\"btn-group\"><wg-consolidate-items bag-and-tag-id=\"{{vm.bagAndTagId}}\" selected-items=\"vm.selectedItems\" selected-all=\"vm.selectedAll\" post-update-delegate=\"vm.groupAdded()\"></wg-consolidate-items></div><div class=\"btn-group\"><wg-edit-grouped-items bag-and-tag-id=\"{{vm.bagAndTagId}}\" enable-button=\"!vm.bagAndTagGroups.length\" is-editable=\"true\" post-update-delegate=\"vm.refreshIncludedItemsAndGroups()\"></wg-edit-grouped-items></div></div></div><div class=\"clearfix\"></div></div></div><div class=\"ibox-content\" ng-show=\"!vm.bagAndTagItems.length && !vm.bagAndTagGroups.length\"><p><strong>No items have been included in this bag & tag.</strong></p><p ng-if=\"!vm.isDeleted\">Use the search function to find stock...</p></div></div><div class=\"tabs-container items-container\" ng-if=\"vm.bagAndTagItems.length || vm.bagAndTagGroups.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.bagAndTagItems.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.bagAndTagItems.length\">No stock items have been included in this bag & tag.</strong><div ng-if=\"vm.bagAndTagItems.length\"><div ng-show=\"vm.bagAndTagItems.length\"><table class=\"table materia-grouped-row\"><thead><tr><th><span ng-if=\"!vm.bagAndTag.isReadOnly\"><input type=\"checkbox\" ng-model=\"vm.selectedAll\" icheck-all=\"vm.bagAndTagItems.isIncluded\"></span></th><th>Material code</th><th>Barcode</th><th>Qty</th><th data-sort-ignore=\"true\" ng-if=\"!vm.bagAndTag.isReadOnly\"></th></tr></thead><tbody wg-included-item-multi-select=\"\" ng-repeat=\"item in vm.bagAndTagItems\" item=\"item\" is-read-only=\"vm.bagAndTag.isReadOnly\" remove-item=\"vm.removeItem(item)\" update-selected=\"vm.updateSelected()\"></tbody></table></div></div></div></uib-tab><uib-tab active=\"vm.tabs.groupsActive\"><uib-tab-heading>Groups <span class=\"badge label-info\">{{vm.bagAndTagGroups.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.bagAndTagGroups.length\">No groups have been included in this bag & tag.</strong><div ng-if=\"vm.bagAndTagGroups.length\"><table class=\"table materia-grouped-row\"><thead><tr><th></th><th>Barcode</th><th>Location</th><th></th></tr></thead><tbody wg-group-item=\"\" ng-repeat=\"item in vm.bagAndTagGroups\" item=\"item\" is-read-only=\"vm.bagAndTag.isReadOnly\" remove-group=\"vm.removeGroup(item)\"></tbody></table></div></div></uib-tab></uib-tabset></div></div></div></div></div>");
$templateCache.put("app/bag-and-tag/viewBagAndTags.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><form role=\"form\" name=\"createForm\" ng-submit=\"vm.createBagAndTag()\" ng-controller=\"CreateBagAndTagCtrl as vm\"><div class=\"ibox-title\"><h5>Create a Bag & Tag</h5></div><div class=\"form-group\"><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-7\"><label class=\"control-label\" for=\"description\">Description *</label> <input type=\"text\" class=\"form-control\" name=\"description\" placeholder=\"Enter a description\" required=\"\" ng-model=\"vm.bagAndTag.description\" ng-class=\"{ \'has-error\' : createForm.description.$invalid && !createForm.description.$pristine }\"></div><div class=\"col-lg-3\"><label class=\"control-label\" for=\"workpackNumber\">Workpack Number</label> <input type=\"text\" class=\"form-control\" name=\"workpackNumber\" placeholder=\"(Optional)\" ng-model=\"vm.bagAndTag.workpackNumber\"></div><div class=\"col-lg-2 label-pad\"><button type=\"submit\" ladda=\"vm.loading\" class=\"btn btn-primary\" ng-disabled=\"createForm.$invalid\" style=\"margin-left:-2px\">Create Bag & Tag</button></div></div></div></div></div></form></div></div><div class=\"tabs-container\" ng-controller=\"ViewBagAndTagsCtrl as vm\"><uib-tabset><uib-tab><uib-tab-heading>Un-Allocated <span class=\"badge label-warning\">{{vm.unAllocatedBagAndtags.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.unAllocatedBagAndtags.length\">There are no Un-Allocated Bag and Tags.</strong><div ng-if=\"vm.unAllocatedBagAndtags.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"unallocated\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Workpack No.</th><th class=\"col-xs-1 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"bagAndTag in vm.unAllocatedBagAndtags | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"unallocated\"><td><a ui-sref=\"bagAndTag.details({id:bagAndTag.id})\">{{ bagAndTag.number }}</a></td><td>{{ bagAndTag.description }}</td><td>{{ bagAndTag.workpackNumber}}</td><td>{{ bagAndTag.createdBy }}</td><td>{{ bagAndTag.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"unallocated\"></dir-pagination-controls></div></div></uib-tab><uib-tab><uib-tab-heading>Allocated <span class=\"badge label-primary\">{{vm.allocatedBagAndtags.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.allocatedBagAndtags.length\">There are no allocated Bag and Tags.</strong><div ng-if=\"vm.allocatedBagAndtags.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"allocated\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Workpack No.</th><th class=\"col-xs-2 text-nowrap\">Issue No.</th><th class=\"col-xs-1 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"bagAndTag in vm.allocatedBagAndtags | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"allocated\"><td><a ui-sref=\"bagAndTag.details({id:bagAndTag.id})\">{{ bagAndTag.number }}</a></td><td>{{ bagAndTag.description }}</td><td>{{ bagAndTag.workpackNumber}}</td><td>{{ bagAndTag.issueNumber}}</td><td>{{ bagAndTag.createdBy }}</td><td>{{ bagAndTag.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"allocated\"></dir-pagination-controls></div></div></uib-tab><uib-tab><uib-tab-heading>Issued <span class=\"badge label-info\">{{vm.issuedBagAndtags.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.issuedBagAndtags.length\">There are no Issued Bag and Tags.</strong><div ng-if=\"vm.issuedBagAndtags.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"issued\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Workpack No.</th><th class=\"col-xs-2 text-nowrap\">Issue No.</th><th class=\"col-xs-1 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"bagAndTag in vm.issuedBagAndtags | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"issued\"><td><a ui-sref=\"bagAndTag.details({id:bagAndTag.id})\">{{ bagAndTag.number }}</a></td><td>{{ bagAndTag.description }}</td><td>{{ bagAndTag.workpackNumber}}</td><td>{{ bagAndTag.issueNumber}}</td><td>{{ bagAndTag.createdBy }}</td><td>{{ bagAndTag.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"issued\"></dir-pagination-controls></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/common/addItemsModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i ng-class=\"vm.isReturn ? \'fa fa-mail-reply modal-icon\' : \'fa fa-exchange modal-icon\'\"></i><h4 class=\"modal-title\">{{vm.isReturn ? \"Return items\" : \"Transfer location\"}}</h4></div><div class=\"modal-body p-b-xxs\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\">New location</label><div class=\"col-lg-8\"><select required=\"\" kendo-drop-down-list=\"\" k-options=\"vm.locationsOptions\" k-ng-model=\"vm.locationSelected\" style=\"width:100%\" ng-disabled=\"vm.saved\"></select></div></div><div class=\"hr-line-dashed\"></div><table class=\"table materia-grouped-row\"><tbody ng-repeat=\"item in vm.items | orderBy: \'description\'\"><tr ng-class=\"item.class\"><td colspan=\"4\" class=\"item-description\">{{item.description | uppercase}}</td></tr><tr ng-class=\"item.class\"><td ng-if=\"vm.isReturn\">{{item.issueNumber}}</td><td><pre class=\"inline btn btn-sm btn-default no-hover\">{{item.materialCode}}</pre></td><td><pre class=\"inline btn btn-sm btn-default no-hover\">{{item.barcode}}</pre></td><td>{{item.unitOfMeasureCode}}</td><td ng-hide=\"vm.isReturn\">{{item.warehouseName}} / {{item.locationName}}</td><td><input type=\"text\" class=\"form-control\" ng-model=\"item.selectedQuantity\" numeric-only=\"\" ng-disabled=\"true\"></td></tr></tbody></table></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Successfully {{vm.isReturn ? \"returned\" : \"transferred\" }} items.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error {{vm.isReturn ? \"returning\" : \"transferring\" }} items.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.locationSelected == undefined || vm.saved\">{{vm.isReturn ? \"Return\" : \"Transfer\" }}</button></div></div>");
$templateCache.put("app/common/bagAndTagItem.html","<tr ng-class=\"vm.item.class\"><td><wg-edit-grouped-items is-read-only=\"true\" is-bag-and-tag-view=\"true\" bag-and-tag-id=\"{{vm.item.id}}\" description=\"{{vm.item.description}}\"></wg-edit-grouped-items></td><td colspan=\"6\" class=\"item-description\">{{vm.item.description | uppercase}}</td></tr><tr add-bag-and-tag-to-issue=\"vm.addBagAndTagToIssue(item)\" ng-class=\"vm.item.class\"><td><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.isIncluded\" ng-checked=\"vm.item.isIncluded\"></td><td ng-if=\"vm.manifest\">{{vm.item.documentNumber}}</td><td ng-if=\"vm.returnsOnly\">{{vm.item.issueNumber}}</td><td>{{vm.item.number}}</td><td>{{vm.item.workpackNumber}}</td><td><button class=\"btn btn-primary btn-sm pull-right\" ng-click=\"vm.addItem(vm.item)\" ng-show=\"vm.enableAdd\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button> <button class=\"btn btn-primary btn-sm pull-right\" ng-click=\"vm.transferItem(vm.item)\" ng-show=\"vm.enableTransfer\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button><wg-return-grouped-items ng-if=\"vm.returnsOnly\" description=\"{{vm.item.description}}\" bag-and-tag=\"vm.item\" fake-bag-and-tag-items=\"vm.fakeBagAndTagItems\" return-id=\"{{vm.returnId}}\"></wg-return-grouped-items></td></tr>");
$templateCache.put("app/common/editGroupedItems.html","<button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.openGroupedItems()\" ng-disabled=\"vm.enableButton\"><i class=\"fa fa-pencil-square-o\" aria-hidden=\"true\"></i> Edit groups</button>");
$templateCache.put("app/common/editGroupedItemsModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-pencil-square-o modal-icon\" ng-if=\"!vm.isReadOnly && !vm.isBagAndTagView\"></i> <i class=\"fa fa-object-group modal-icon\" ng-if=\"vm.isReadOnly && !vm.isBagAndTagView\"></i> <i class=\"fa fa-tags modal-icon\" ng-if=\"vm.isBagAndTagView\"></i><h4 class=\"modal-title\">{{vm.title}}</h4></div><div class=\"modal-body p-b-xxs\"><kendo-treelist id=\"treelist\" options=\"vm.storedItemsOptions\" style=\"width: 835px\"></kendo-treelist></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Close</button></div></div>");
$templateCache.put("app/common/groupItem.html","<tr><td style=\"width: 50px\"><wg-edit-grouped-items is-read-only=\"true\" bag-and-tag-id=\"{{vm.item.bagAndTagId}}\" group-id=\"{{vm.item.storedItemId}}\" description=\"{{vm.item.description}}\"></wg-edit-grouped-items></td><td colspan=\"3\" class=\"item-description\">{{vm.item.description | uppercase}}</td></tr><tr><td></td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.barcode }}</pre></td><td>{{vm.item.warehouseName}}/{{vm.item.locationName}}</td><td class=\"pull-right\"><button type=\"button\" class=\"btn btn-danger btn-sm\" ng-if=\"!vm.isReadOnly\" ng-click=\"vm.removeGroup(vm.item)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></td></tr>");
$templateCache.put("app/common/includedBagAndTagItem.html","<tr ng-class=\"vm.item.class\"><td style=\"width: 50px\"><wg-edit-grouped-items ng-if=\"!vm.manifest\" is-read-only=\"true\" is-bag-and-tag-view=\"true\" bag-and-tag-id=\"{{vm.item.id}}\" description=\"{{vm.item.description}}\"></wg-edit-grouped-items><wg-edit-grouped-items ng-if=\"vm.manifest\" is-read-only=\"true\" is-bag-and-tag-view=\"true\" bag-and-tag-id=\"{{vm.item.bagAndTagId}}\" description=\"{{vm.item.description}}\"></wg-edit-grouped-items></td><td colspan=\"6\" class=\"item-description\">{{vm.item.description | uppercase}}</td></tr><tr add-bag-and-tag-to-issue=\"vm.addBagAndTagToIssue(item)\" ng-class=\"vm.item.class\"><td ng-if=\"!vm.manifest\"></td><td ng-if=\"vm.manifest\"><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.isIncluded\" ng-disabled=\"vm.isReadOnly\"></td><td ng-if=\"vm.manifest\">{{vm.item.refDoc}}</td><td>{{vm.item.number}}</td><td>{{vm.item.workpackNumber}}</td><td ng-if=\"vm.manifest\">{{vm.item.container}}</td><td><button class=\"btn btn-danger btn-sm pull-right\" ng-click=\"vm.removeItem(vm.item)\" ng-if=\"!vm.isReadOnly\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></td></tr>");
$templateCache.put("app/common/includedItem.html","<tr><td colspan=\"6\" class=\"item-description\"><table><tr><td ng-if=\"!vm.isReadOnly && !vm.isIssueWithPicklist\" style=\"vertical-align:text-top;\"><button class=\"btn btn-sm btn-white rowlink\" style=\"margin-right:10px;\" ng-click=\"vm.openModal()\"><i class=\"fa fa-edit\" aria-hidden=\"true\"></i></button></td><td>{{vm.item.description | uppercase}}</td></tr></table></td></tr><tr class=\"remove-border\"><td ng-if=\"vm.includeIssue\">{{vm.item.issueNumber}}</td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.materialCode }}</pre></td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.barcode }}</pre></td><td><span ng-class=\"vm.item.class\" class=\"badge-transparent\">{{ vm.item.selectedQuantity }}</span></td><td ng-hide=\"vm.noLocations || vm.hideOldLocations\">{{vm.item.warehouseName}} / {{vm.item.locationName}}</td><td ng-if=\"vm.includeNewLocations\" ng-hide=\"vm.noLocations\">{{vm.item.newWarehouseName}} / {{vm.item.newLocationName}}</td><td ng-if=\"vm.showCostCode\">{{vm.item.costCode}}</td><td ng-if=\"vm.showCostCode\">{{vm.item.newCostCode}}</td><td ng-if=\"!vm.isReadOnly\"><button type=\"button\" class=\"btn btn-danger btn-sm pull-right\" ng-click=\"vm.removeItem(vm.item)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></td></tr>");
$templateCache.put("app/common/includedItemMultiSelect.html","<tr><td colspan=\"5\" class=\"item-description\">{{vm.item.description | uppercase}}</td></tr><tr class=\"remove-border\"><td><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.isIncluded\" ng-checked=\"vm.item.isIncluded\" ng-if=\"!vm.isReadOnly\" ng-change=\"vm.updateSelected()\"></td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.materialCode }}</pre></td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.barcode }}</pre></td><td><span ng-class=\"vm.item.class\" class=\"badge-transparent\">{{vm.item.selectedQuantity}}</span></td><td ng-if=\"!vm.isReadOnly\"><button type=\"button\" class=\"btn btn-danger btn-sm pull-right\" ng-click=\"vm.removeItem(vm.item)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></td></tr>");
$templateCache.put("app/common/inspectionItem.html","<div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"inspection-item-number\">{{vm.item.checkLine.lineNumber}}</div><div class=\"inspection-item-description\">{{vm.item.checkLine.description | uppercase}}</div><table class=\"table remove-margin-b\"><thead><tr><th class=\"col-lg-3\"></th><th class=\"col-lg-3\">Inspected Quantity *</th><th class=\"col-lg-3\">Passed Quantity</th><th class=\"col-lg-3\">Failed Quantity *</th></tr></thead><tbody><tr><td></td><td ng-class=\"{ \'has-error\' : (saveForm[\'checkedQuantity\' + vm.index].$invalid && !saveForm[\'checkedQuantity\' + vm.index].$pristine) || saveForm[\'checkedQuantity\' + vm.index].$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.checkedQuantity\" name=\"checkedQuantity{{$index}}\" ng-disabled=\"true\" ng-max=\"vm.maxInspectionQuantity\" numeric-only=\"\"></td><td><input type=\"text\" class=\"form-control\" ng-value=\"vm.passedQuantity()\" name=\"passedQuantity\" ng-disabled=\"true\"></td><td ng-class=\"{ \'has-error\' : (saveForm[\'failedQuantity\' + vm.index].$invalid && !saveForm[\'failedQuantity\' + vm.index].$pristine) || saveForm[\'failedQuantity\' + vm.index].$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.failedQuantity\" name=\"failedQuantity{{vm.index}}\" ng-min=\"0\" ng-max=\"vm.checkedQuantity\" ng-model-options=\"{allowInvalid: true}\" numeric-only=\"\"></td></tr><tr class=\"remove-border\"><td colspan=\"4\" class=\"remove-border\"><span class=\"text-danger\" ng-show=\"saveForm[\'failedQuantity\' + vm.index].$error.ngMin || saveForm[\'failedQuantity\' + vm.index].$error.ngMax\">Failed quantity must be between 0 and {{vm.maxInspectionQuantity}}.</span> <span class=\"text-danger\" ng-show=\"saveForm[\'checkedQuantity\' + vm.index].$error.ngMax\">Inspected quantity must not be greater than {{vm.maxInspectionQuantity}}.</span></td></tr><tr class=\"remove-border\" ng-show=\"vm.hasFailedInspection(vm.item.failedQuantity)\"><td colspan=\"4\" class=\"remove-border\"><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Comments *</label><div class=\"col-lg-9\"><textarea type=\"text\" class=\"form-control\" ng-model=\"vm.item.comments\" style=\"resize: none;\" ng-disabled=\"vm.saved\" ng-required=\"vm.hasFailedInspection(vm.item.failedQuantity)\"></textarea></div></div></td></tr><tr class=\"remove-border\" ng-show=\"vm.hasFailedInspection(vm.item.failedQuantity)\"><td colspan=\"4\" class=\"remove-border\"><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Quarantine location *</label><div class=\"col-lg-9\"><select kendo-combo-box=\"\" k-options=\"vm.quarantineLocationsOptions\" ng-model=\"vm.item.selectedQuarantineLocationId\" name=\"location\" style=\"width:100%\" ng-disabled=\"vm.saved\" ng-required=\"vm.hasFailedInspection(vm.item.failedQuantity)\" require-valid-option=\"\"></select></div></div></td></tr></tbody></table></div></div>");
$templateCache.put("app/common/logOut.html","<a ng-click=\"vm.logOutOfIdSrv()\"><i class=\"fa fa-sign-out\"></i> Log out ({{vm.name}} {{vm.email}})</a>");
$templateCache.put("app/common/modalStoredItem.html","<tr><td colspan=\"11\" class=\"item-description\">{{vm.item.description | uppercase}}</td></tr><tr ng-class=\"vm.item.class\" ng-repeat=\"stockItemLocation in vm.item.storedItems\"><td class=\"text-nowrap\"><span ng-if=\"$first\">{{vm.item.poNumber}} / {{vm.item.poLineNumber}}</span></td><td><span ng-if=\"$first\">{{stockItemLocation.costCode}}</span></td><td class=\"text-nowrap\"><span ng-if=\"$first\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.materialCode }}</pre></span></td><td class=\"text-nowrap\"><span ng-if=\"$first\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.barcode }}</pre></span></td><td><span ng-if=\"$first\">{{vm.item.unitOfMeasureCode}}</span></td><td>{{stockItemLocation.warehouseName}} / {{stockItemLocation.locationName}}</td><td>{{stockItemLocation.quantity}}</td><td><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.selectItem({item:stockItemLocation})\">Select</button></td></tr>");
$templateCache.put("app/common/purchaseOrderLine.html","<tr><td colspan=\"{{ vm.isManual && vm.statusId === 1 ? \'6\' : \'14\' }}\" class=\"item-description\"><span ng-if=\"!vm.item.isNonReceivable\" ng-bind-html=\"vm.item.description | highlight:vm.highlight | uppercase\"></span> <span ng-if=\"vm.item.isNonReceivable\"><s><span ng-bind-html=\"vm.item.description | highlight:vm.highlight | uppercase\"></span></s></span></td><td colspan=\"2\" ng-if=\"vm.statusId != 1\"><wg-small-progress-bar title=\"Delivery completion\" total=\"vm.item.quantity\" progress=\"vm.item.totalStoredQuantity\" display-totals=\"true\" inline=\"true\" ng-if=\"!vm.item.isNonReceivable\"></wg-small-progress-bar></td><td class=\"text-nowrap comments-btn-container\"><wg-view-history purchase-order-id=\"vm.item.purchaseOrderId\" purchase-order-line-id=\"vm.item.id\" material-description=\"vm.item.description\"></wg-view-history><wg-add-comment purchase-order-id=\"vm.item.id\" number=\"vm.purchaseOrder.number\" is-line=\"true\" line-item=\"vm.item\" ng-if=\"!vm.isManual\"></wg-add-comment><span class=\"btn-group\" ng-if=\"!vm.isManual\"><button type=\"button\" data-toggle=\"dropdown\" class=\"btn btn-default dropdown-toggle\">...</button><ul class=\"dropdown-menu pull-right\"><li><a ng-click=\"vm.setLinesReceivability(vm.item)\">{{!vm.item.isNonReceivable ? \'Set as non-receivable\' : \'Set as receivable\'}}</a></li><li><a ng-click=\"vm.setDualUse(vm.item)\">{{!vm.item.isDualUse ? \'Material identified as being Dual Use\' : \'Material not classified as Dual Use\'}}</a></li></ul></span></td></tr><tr ng-if=\"!vm.item.isNonReceivable\"><td>{{ vm.item.lineNumber }}</td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover text-nowrap\">{{ vm.item.materialCode  | highlight:vm.highlight }}</pre></td><td class=\"text-nowrap\" ng-bind-html=\"vm.item.costCode | highlight:vm.highlight\"></td><td class=\"text-nowrap\" ng-if=\"vm.statusId != 1\" ng-bind-html=\"vm.item.workpack | highlight:vm.highlight\"></td><td class=\"text-nowrap\" ng-if=\"vm.statusId != 1\" ng-bind-html=\"vm.item.buyerName | highlight:vm.highlight\"></td><td class=\"text-nowrap\" ng-if=\"vm.statusId != 1\" ng-bind-html=\"vm.item.etaDate | date:\'dd-MMM-yyyy\'\"></td><td class=\"text-nowrap\" ng-if=\"vm.statusId != 1\" ng-bind-html=\"vm.item.promisedDate | date:\'dd-MMM-yyyy\'\"></td><td class=\"text-nowrap\" ng-if=\"vm.statusId != 1\" style=\"text-align: right\">{{ vm.item.price | number: 2 }} {{ vm.item.currencyCode }}</td><td class=\"text-nowrap\" ng-if=\"vm.statusId == 1\" style=\"text-align: right\">{{ vm.item.unitPricePrice | number: 2 }} {{ vm.item.unitPriceCurrencyCode }}</td><td class=\"col-md-1\" style=\"text-align: center\">{{ vm.item.unitOfMeasureCode }}</td><td class=\"col-md-1\" ng-if=\"vm.statusId != 1\"><span class=\"badge {{ vm.item.isDualUse ? \'badge-danger\' : \'\' }}\">{{ vm.item.isDualUse| yesNo }}</span></td><td class=\"col-md-1\" ng-if=\"vm.statusId == 1\">{{ vm.item.quantity }}</td><td class=\"col-md-1\" ng-if=\"vm.statusId != 1\"><span class=\"badge badge-info\" uib-tooltip=\"Ordered quantity: {{vm.item.quantity}}\">{{ vm.item.quantity }}</span></td><td class=\"col-md-1\" ng-if=\"vm.statusId != 1\"><span class=\"badge {{ vm.item.outstandingQuantity > 0 ? \'badge-success\' : \'\' }}\" uib-tooltip=\"Outstanding quantity: {{vm.item.outstandingQuantity}}\">{{ vm.item.outstandingQuantity }}</span></td><td class=\"col-md-1\" ng-if=\"vm.statusId != 1\"><span class=\"badge {{ vm.item.deliveryInProgressQuantity > 0 ? \'badge-warning\' : \'\' }}\" uib-tooltip=\"Quantity in delivery: {{vm.item.deliveryInProgressQuantity}}\">{{ vm.item.deliveryInProgressQuantity }}</span></td><td class=\"col-md-1\" ng-if=\"vm.statusId != 1\"><span class=\"badge {{ vm.item.osdQuantity > 0 ? \'badge-danger\' : \'\' }}\" uib-tooltip=\"Unresolved OS&D: {{vm.item.osdQuantity}}\">{{ vm.item.osdQuantity }}</span></td><td class=\"col-md-1\" ng-if=\"vm.statusId != 1\"><span class=\"badge {{ vm.item.quarantineQuantity > 0 ? \'badge-warning\' : \'\' }}\" uib-tooltip-html=\"\'Total taken into storage: {{vm.item.totalStoredQuantity}} {{ vm.item.quarantineQuantity > 0 ? \'<br />In Quarantine: \' + vm.item.quarantineQuantity : \'\' }}\'\">{{ vm.item.totalStoredQuantity }}</span></td><td class=\"col-md-1\" ng-if=\"vm.statusId != 1\"><span class=\"badge\" uib-tooltip=\"Total issued: {{vm.item.issuedQuantity}}\">{{ vm.item.issuedQuantity }}</span></td><td class=\"col-md-1\" ng-if=\"vm.statusId != 1\"><span class=\"badge {{ vm.item.availableQuantity > 0 ? \'badge-primary\' : \'\' }}\" uib-tooltip=\"Available quantity: {{vm.item.availableQuantity}}\">{{ vm.item.availableQuantity }}</span></td><td class=\"text-nowrap\" ng-if=\"vm.isManual && vm.statusId === 1\"><button class=\"btn btn-danger\" title=\"Delete line item\" ng-click=\"vm.deletePurchaseOrderLineItem({id :vm.item.id})\"><i class=\"fa fa-times\"></i></button></td></tr><tr ng-if=\"vm.item.isNonReceivable\"><td colspan=\"17\"></td></tr>");
$templateCache.put("app/common/searchCriteria.html","<form role=\"form\" name=\"searchForm\" ng-submit=\"vm.doSearch()\"><div class=\"ibox-title\"><h5 ng-if=\"!vm.returnsOnly\">Search for stock</h5><h5 ng-if=\"vm.returnsOnly\">Search for issued items</h5></div><div class=\"ibox-content\"><div class=\"form-group remove-margin-b\"><div class=\"row\"><div class=\"col-md-3 pt4\"><label class=\"control-label\">PO number</label><div class=\"input-group\" style=\"width:100%;\"><select name=\"purchaseOrder\" kendo-multi-select=\"\" k-options=\"vm.purchaseOrdersOptions\" k-ng-model=\"vm.purchaseOrdersSelected\" style=\"width: 100%;\" ng-class=\"{ \'has-error\' : searchForm.purchaseOrder.$invalid && !searchForm.purchaseOrder.$pristine }\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Material code</label><div class=\"input-group\" style=\"width:100%;\"><select kendo-multi-select=\"\" k-options=\"vm.materialCodesOptions\" style=\"width: 100%;\" k-ng-model=\"vm.materialCodesSelected\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Cost code</label><div class=\"input-group\" style=\"width:100%;\"><select kendo-multi-select=\"\" k-options=\"vm.costCodesOptions\" k-ng-model=\"vm.costCodesSelected\" style=\"width:100%\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Barcode</label><div class=\"input-group\" style=\"width:100%;\"><select kendo-multi-select=\"\" k-options=\"vm.barcodesOptions\" k-ng-model=\"vm.barcodesSelected\" style=\"width:100%\"></select></div></div></div><div class=\"row\"><div class=\"col-md-3 pt4\" ng-if=\"!vm.returnsOnly\"><label class=\"control-label\">Location</label><div class=\"input-group\" style=\"width:100%;\"><select kendo-multi-select=\"\" k-options=\"vm.locationsOptions\" k-ng-model=\"vm.locationsSelected\" style=\"width:100%\"></select></div></div><div ng-if=\"vm.returnsOnly\" class=\"col-md-3 pt4\"><label class=\"control-label\">Issue</label><div class=\"input-group\" style=\"width: 100%\"><select kendo-multi-select=\"\" k-options=\"vm.issuesOptions\" k-ng-model=\"vm.issuesSelected\" style=\"width: 100%\"></select></div></div><div class=\"col-md-3 pt4\" ng-if=\"!vm.disableBagAndTag\"><label class=\"control-label\">Bag & Tag number</label><div class=\"input-group\" style=\"width: 100%\"><select kendo-multi-select=\"\" k-options=\"vm.bagAndTagNumbersOptions\" k-ng-model=\"vm.bagAndTagNumbersSelected\" style=\"width: 100%\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Ref. number</label><div class=\"input-group\" style=\"width: 100%\"><select kendo-multi-select=\"\" k-options=\"vm.workpackNumbersOptions\" k-ng-model=\"vm.workpackNumbersSelected\" style=\"width: 100%\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Description</label><div class=\"input-group\" style=\"width: 100%\"><input type=\"text\" class=\"form-control k-textbox\" name=\"description\" placeholder=\"Enter a description\" ng-model=\"vm.filter\"></div></div></div></div></div><div class=\"ibox-footer\"><button type=\"submit\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-disabled=\"!vm.purchaseOrdersSelected.length && !vm.materialCodesSelected.length && !vm.costCodesSelected.length && !vm.barcodesSelected.length && !vm.locationsSelected.length && !vm.bagAndTagNumbersSelected.length && !vm.workpackNumbersSelected.length && !vm.issuesSelected.length && !vm.filter.length\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> Search</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.resetForm()\"><i class=\"fa fa-eraser\" aria-hidden=\"true\"></i> Clear</button></div></form>");
$templateCache.put("app/common/selectProject.html","Current Project: <button type=\"button\" class=\"btn btn-success navbar-btn\" ng-click=\"vm.api.openProjects()\">{{vm.project.name}} - {{vm.projectCode}}</button>");
$templateCache.put("app/common/selectProjectModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-pencil-square-o modal-icon\"></i><h4 class=\"modal-title\">Choose a Project</h4></div><div class=\"modal-body p-b-xxs\"><form class=\"form-horizontal\" name=\"selectProject\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Select Project</label><div class=\"col-lg-8\"><select kendo-combo-box=\"\" ng-model=\"vm.projectCode\" k-options=\"vm.projectOptions\" class=\"form-control\" name=\"project\" required=\"\"></select></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Successfully changed project to <strong>{{vm.projectCode}}</strong>.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error changing project to <strong>{{vm.projectCode}}</strong>.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving || !vm.isProjectSet\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\">Save</button></div></div>");
$templateCache.put("app/common/smallProgressBar.html","<div class=\"{{ vm.inline === true ? \'sm-progress-container-inline\' : \'sm-progress-container\' }}\"><small class=\"{{ vm.inline === true ? \'\' : \'text-full-height\'}}\">{{ vm.title }}: {{ vm.displayTotals === true ? vm.progress + \'/\' + vm.total : vm.total + \'%\' }}</small><div class=\"progress progress-mini\"><div ng-style=\"{width: vm.displayTotals === true ? (vm.progress/vm.total)*100 + \'%\': vm.total + \'%\'}\" class=\"progress-bar\"></div></div></div>");
$templateCache.put("app/common/splitInspectionItem.html","<div class=\"panel panel-default\"><div class=\"panel-body\"><div class=\"inspection-item-number\">{{vm.item.checkLine.lineNumber}}</div><div class=\"inspection-item-description\">{{vm.item.checkLine.description | uppercase}}</div><div ng-repeat=\"inspection in vm.item.inspections\"><table class=\"table remove-margin-b\"><thead><tr><th class=\"col-lg-3\"></th><th class=\"col-lg-3\">Inspected Quantity *</th><th class=\"col-lg-3\">Passed Quantity</th><th class=\"col-lg-3\">Failed Quantity *</th></tr></thead><tbody><tr><td>{{inspection.barcode}}</td><td ng-class=\"{ \'has-error\' : (saveForm[\'checkedQuantity\' + $index].$invalid && !saveForm[\'checkedQuantity\' + $index].$pristine) || saveForm[\'checkedQuantity\' + $index].$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.inspections[$index].checkedQuantity\" name=\"checkedQuantity\" ng-disabled=\"true\" ng-max=\"vm.item.inspections[$index].checkedQuantity\" numeric-only=\"\"></td><td><input type=\"text\" class=\"form-control\" ng-value=\"(vm.item.inspections[$index].checkedQuantity - vm.item.inspections[$index].failedInspectionQuantity)\" name=\"passedQuantity\" ng-disabled=\"true\"></td><td ng-class=\"{ \'has-error\' : (saveForm[\'failedInspectionQuantity\' + $index].$invalid && !saveForm[\'failedInspectionQuantity\' + $index].$pristine) || saveForm[\'failedInspectionQuantity\' + $index].$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.inspections[$index].failedInspectionQuantity\" name=\"failedInspectionQuantity\" ng-min=\"0\" ng-max=\"vm.item.inspections[$index].checkedQuantity\" ng-model-options=\"{allowInvalid: true}\" numeric-only=\"\"></td></tr><tr class=\"remove-border\"><td colspan=\"4\" class=\"remove-border\"><span class=\"text-danger\" ng-show=\"saveForm[\'failedInspectionQuantity\' + vm.index].$error.ngMin || saveForm[\'failedInspectionQuantity\' + vm.index].$error.ngMax\">Failed quantity must be between 0 and {{inspection.checkedQuantity}.</span> <span class=\"text-danger\" ng-show=\"saveForm[\'checkedQuantity\' + vm.index].$error.ngMax\">Inspected quantity must not be greater than {{inspection.checkedQuantity}}.</span></td></tr><tr class=\"remove-border\" ng-show=\"vm.hasFailedInspection(vm.item.inspections[$index].failedInspectionQuantity)\"><td colspan=\"4\" class=\"remove-border\"><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Comments *</label><div class=\"col-lg-9\"><textarea type=\"text\" class=\"form-control\" ng-model=\"vm.item.inspections[$index].comments\" style=\"resize: none;\" ng-disabled=\"vm.saved\" ng-required=\"vm.hasFailedInspection(vm.item.inspections[$index].failedInspectionQuantity)\"></textarea></div></div></td></tr><tr class=\"remove-border\" ng-show=\"vm.hasFailedInspection(vm.item.inspections[$index].failedInspectionQuantity)\"><td colspan=\"4\" class=\"remove-border\"><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Quarantine location *</label><div class=\"col-lg-9\"><select kendo-combo-box=\"\" k-options=\"vm.quarantineLocationsOptions\" ng-model=\"vm.item.inspections[$index].selectedQuarantineLocationId\" name=\"location{{inspection.barcode}}\" style=\"width:100%\" ng-disabled=\"vm.saved\" ng-required=\"vm.hasFailedInspection(vm.item.inspections[$index].failedInspectionQuantity)\"></select></div></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/common/storedItem.html","<tr><td colspan=\"11\" class=\"item-description\">{{vm.item.description | uppercase}}</td></tr><tr add-item-to-issue=\"vm.addItemToIssue(item)\" ng-class=\"vm.item.class\" ng-repeat=\"stockItemLocation in vm.item.storedItems\" ng-if=\"!vm.isPicklist\"><td ng-if=\"vm.showCheckbox\"><span><input icheck=\"\" type=\"checkbox\" ng-model=\"stockItemLocation.isIncluded\" ng-checked=\"stockItemLocation.isIncluded\"></span></td><td class=\"text-nowrap\"><span ng-if=\"$first\">{{vm.item.poNumber}} / {{vm.item.poLineNumber}}</span></td><td class=\"text-nowrap\"><span ng-if=\"$first\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.materialCode }}</pre></span></td><td class=\"text-nowrap\"><span ng-if=\"$first\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.barcode }}</pre></span></td><td><span ng-if=\"$first\">{{vm.item.unitOfMeasureCode}}</span></td><td>{{stockItemLocation.costCode}}</td><td ng-hide=\"vm.hideLocation\">{{stockItemLocation.warehouseName}} / {{stockItemLocation.locationName}}</td><td><span ng-class=\"stockItemLocation.class\" class=\"badge-transparent\">{{stockItemLocation.quantity}}</span> <span ng-if=\"stockItemLocation.selectedQuantity > stockItemLocation.quantity\" class=\"pull-right\" title=\"The issue quantity is greater than the quantity available.\"><i class=\"fa fa-warning text-danger\"></i></span></td><td><input type=\"text\" class=\"form-control\" style=\"width:50px\" numeric-only=\"\" ng-model=\"stockItemLocation.selectedQuantity\"></td><td><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.addItem({item: stockItemLocation})\" ng-disabled=\"!stockItemLocation.selectedQuantity.length || stockItemLocation.selectedQuantity == 0 || stockItemLocation.selectedQuantity > stockItemLocation.quantity\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></td></tr><tr add-item-to-issue=\"vm.addItemToIssue(item)\" ng-if=\"vm.isPicklist\"><td class=\"text-nowrap\">{{vm.item.poNumber}} / {{vm.item.poLineNumber}}</td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.materialCode }}</pre></td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.barcode }}</pre></td><td>{{vm.item.unitOfMeasureCode}}</td><td>{{vm.item.costCode}}</td><td ng-hide=\"vm.hideLocation\">{{vm.item.warehouseName}} / {{vm.item.locationName}}</td><td><span ng-class=\"vm.item.class\" class=\"badge-transparent\">{{vm.item.quantity}}</span> <span ng-if=\"vm.item.selectedQuantity > vm.item.quantity\" class=\"pull-right\" title=\"The issue quantity is greater than the quantity available.\"><i class=\"fa fa-warning text-danger\"></i></span></td><td><input type=\"text\" class=\"form-control\" style=\"width:50px\" numeric-only=\"\" ng-model=\"vm.item.selectedQuantity\"></td><td><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.addItem({item: vm.item})\" ng-disabled=\"!vm.item.selectedQuantity.length || vm.item.selectedQuantity == 0 || vm.item.selectedQuantity > vm.item.quantity\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></td></tr>");
$templateCache.put("app/common/storedItemCheckboxes.html","<tr><td colspan=\"11\" class=\"item-description\">{{vm.item.description | uppercase}}</td></tr><tr add-item-to-issue=\"vm.addItemToIssue(item)\" ng-class=\"vm.item.class\" ng-repeat=\"stockItemLocation in vm.item.storedItems\" ng-if=\"!vm.includeIssue\"><td><input icheck=\"\" type=\"checkbox\" ng-model=\"stockItemLocation.isIncluded\" ng-disabled=\"stockItemLocation.quantity == 0\"></td><td class=\"text-nowrap\"><span ng-if=\"$first\">{{vm.item.poNumber}} / {{vm.item.poLineNumber}}</span></td><td ng-if=\"vm.includeIssue\">{{vm.item.issueNumber}}</td><td class=\"text-nowrap\"><span ng-if=\"$first\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.materialCode }}</pre></span></td><td class=\"text-nowrap\"><span ng-if=\"$first\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.barcode }}</pre></span></td><td><span ng-if=\"$first\">{{vm.item.unitOfMeasureCode}}</span></td><td>{{stockItemLocation.costCode}}</td><td ng-hide=\"vm.hideLocation\">{{stockItemLocation.warehouseName}} / {{stockItemLocation.locationName}}</td><td><span ng-class=\"stockItemLocation.class\" class=\"badge-transparent\">{{stockItemLocation.quantity}}</span> <span ng-if=\"stockItemLocation.selectedQuantity > stockItemLocation.quantity && stockItemLocation.isIncluded\" class=\"pull-right\" title=\"The issue quantity is greater than the quantity available.\"><i class=\"fa fa-warning text-danger\"></i></span></td><td><span data-ng-if=\"stockItemLocation.isIncluded\"><input type=\"text\" class=\"form-control\" style=\"width:50px\" numeric-only=\"\" ng-model=\"stockItemLocation.selectedQuantity\" ng-bind=\"stockItemLocation.quantity\"></span> <span data-ng-if=\"!stockItemLocation.isIncluded\"><input type=\"text\" class=\"form-control\" style=\"width:50px\" ng-disabled=\"true\"></span></td></tr><tr add-item-to-issue=\"vm.addItemToIssue(item)\" ng-if=\"vm.includeIssue\"><td><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.isIncluded\" ng-disabled=\"vm.item.quantity == 0\"></td><td class=\"text-nowrap\">{{vm.item.poNumber}} / {{vm.item.poLineNumber}}</td><td ng-if=\"vm.includeIssue\">{{vm.item.issueNumber}}</td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.materialCode }}</pre></td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.barcode }}</pre></td><td>{{vm.item.unitOfMeasureCode}}</td><td>{{vm.item.costCode}}</td><td ng-hide=\"vm.hideLocation\">{{vm.item.warehouseName}} / {{vm.item.locationName}}</td><td><span ng-class=\"vm.item.class\" class=\"badge-transparent\">{{vm.item.quantity}}</span> <span ng-if=\"vm.item.selectedQuantity > vm.item.quantity && vm.item.isIncluded\" class=\"pull-right\" title=\"The issue quantity is greater than the quantity available.\"><i class=\"fa fa-warning text-danger\"></i></span></td><td><span data-ng-if=\"vm.item.isIncluded\"><input type=\"text\" class=\"form-control\" style=\"width:50px\" numeric-only=\"\" ng-model=\"vm.item.selectedQuantity\" ng-bind=\"vm.item.quantity\"></span> <span data-ng-if=\"!vm.item.isIncluded\"><input type=\"text\" class=\"form-control\" style=\"width:50px\" ng-disabled=\"true\"></span></td></tr>");
$templateCache.put("app/common/traceInfo.html","<pre class=\"m-b-none inline btn btn-sm btn-default\" ng-click=\"vm.openTraceInfo()\">{{ vm.barcode }}</pre>");
$templateCache.put("app/common/traceInfoModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-info modal-icon\"></i><h4 class=\"modal-title\">{{vm.barcode}}</h4><small class=\"font-bold\">{{vm.description}}</small> <span kendo-barcode=\"\" k-type=\"\'code128\'\" ng-model=\"vm.barcode\" k-height=\"50\" class=\"p-b-none\" style=\"width: 250px; margin: 20px auto 0px;\"></span></div><div class=\"modal-body p-b-xxs\"><form class=\"form-horizontal\" name=\"save\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\">OEM Part Number</label><div class=\"col-lg-8\"><input class=\"form-control\" type=\"text\" ng-maxlength=\"50\" maxlength=\"50\" ng-model=\"vm.oemPartNumber\"></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Supplier Part Number</label><div class=\"col-lg-8\"><input class=\"form-control\" type=\"text\" ng-maxlength=\"50\" maxlength=\"50\" ng-model=\"vm.supplierPartNumber\"></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Client Stock Code</label><div class=\"col-lg-8\"><input class=\"form-control\" type=\"text\" ng-maxlength=\"50\" maxlength=\"50\" ng-model=\"vm.clientStockCode\"></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Tag Number</label><div class=\"col-lg-8\"><input class=\"form-control\" type=\"text\" ng-maxlength=\"50\" maxlength=\"50\" ng-model=\"vm.tagNumber\"></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Heat/Cast Number</label><div class=\"col-lg-8\"><input class=\"form-control\" type=\"text\" ng-maxlength=\"50\" maxlength=\"50\" ng-model=\"vm.heatCastNumber\"></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">IRC Number</label><div class=\"col-lg-8\"><input class=\"form-control\" type=\"text\" ng-maxlength=\"50\" maxlength=\"50\" ng-model=\"vm.ircNumber\"></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">HS Commodity Code</label><div class=\"col-lg-8\"><input class=\"form-control\" type=\"text\" ng-maxlength=\"50\" maxlength=\"50\" ng-model=\"vm.hsCommodityCode\"></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Origin</label><div class=\"col-lg-8\"><input class=\"form-control\" type=\"text\" ng-maxlength=\"50\" maxlength=\"50\" ng-model=\"vm.origin\"></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Customs Status</label><div class=\"col-lg-8\"><input class=\"form-control\" type=\"text\" ng-maxlength=\"50\" maxlength=\"50\" ng-model=\"vm.customsStatus\"></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Successfully saved extra information for <strong>{{vm.barcode}}</strong>.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error saving extra information for <strong>{{vm.barcode}}</strong>.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\">Save</button></div></div>");
$templateCache.put("app/common/viewGroupContents.html","<button class=\"btn btn-sm btn-white\" tooltip=\"View contents\" ng-click=\"vm.openGroupedItems()\"><i class=\"fa fa-list-ul\" aria-hidden=\"true\"></i></button>");
$templateCache.put("app/deliveries/checkLine.html","<tr class=\"new-border\"><td ng-if=\"!vm.line.isComplete\"><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.line.isIncluded\" ng-checked=\"vm.line.isIncluded\" ng-disabled=\"vm.isMovement\"></td><td>{{ vm.line.lineNumber }}</td><td class=\"width-200\"><span ng-if=\"vm.isMovement && !vm.line.isComplete\"><select kendo-combo-box=\"\" k-options=\"vm.costCodesOptions\" required=\"\" ng-model=\"vm.line.costCode\" k-ng-delay=\"vm.line.costCode\" name=\"costCodes\" style=\"width:100%\" ng-disabled=\"vm.saving\"></select></span> <span ng-if=\"!vm.isMovement || vm.line.isComplete\">{{ vm.line.costCode }}</span></td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.line.materialCode }}</pre></td><td class=\"text-nowrap\"><wg-trace-info barcode=\"{{vm.line.barcode}}\" check-line-id=\"{{vm.line.id}}\" description=\"{{vm.line.description}}\" ng-hide=\"vm.line.deliveryLineSplits.length\"></wg-trace-info></td><td>{{ vm.line.description }}</td><td>{{ vm.line.unitOfMeasureCode }}</td><td>{{vm.line.inspectionType== \'V\'? \'Vendor\' : vm.line.inspectionType== \'I\'? \'Warehouse\' : \'None\' }}</td><td>{{ vm.line.statedQuantity }} <span data-ng-if=\"!vm.line.deliveryLineSplits.length\"><span ng-if=\"vm.line.checkedQuantity != vm.line.statedQuantity\" class=\"pull-right\" title=\"The checked quantity is different to the delivery note quantity.\"><i class=\"fa fa-warning text-danger\"></i></span></span> <span data-ng-if=\"vm.line.deliveryLineSplits.length\"><span ng-if=\"vm.line.totalCheckedQuantity != vm.line.statedQuantity\" class=\"pull-right\" title=\"The checked quantity is different to the delivery note quantity.\"><i class=\"fa fa-warning text-danger\"></i></span></span></td><td><span data-ng-if=\"vm.line.isIncluded\" class=\"ng-animate-disabled\"><span data-ng-if=\"!vm.line.deliveryLineSplits.length\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.line.checkedQuantity\" ng-readonly=\"vm.line.isComplete\" numeric-only=\"\"><div class=\"input-group-addon\" style=\"width: 40px\" ng-if=\"!vm.line.isComplete && vm.line.isIncluded\"><span data-ng-if=\"!vm.loading && !vm.validationErrors\" title=\"Data saved successfully.\"><i class=\"fa fa-check text-navy\"></i></span> <span data-ng-if=\"vm.loading && !vm.validationErrors\"><i class=\"fa fa-cog fa-spin\"></i></span> <span data-ng-if=\"vm.validationErrors\" title=\"Data not saved. Try again.\"><i class=\"fa fa-times text-danger\"></i></span></div></div></span> <span data-ng-if=\"vm.line.deliveryLineSplits.length\" class=\"ng-animate-disabled\"><input type=\"text\" class=\"form-control\" ng-disabled=\"true\" ng-model=\"vm.line.totalCheckedQuantity\"></span></span> <span data-ng-if=\"!vm.line.isIncluded\"><input type=\"text\" class=\"form-control\" ng-disabled=\"true\"></span></td><td><span ng-if=\"!vm.line.deliveryLineSplits.length\"><span ng-if=\"!vm.line.isComplete\" tooltip-placement=\"bottom\" uib-tooltip=\"Select this if this is item requires manual intervention for OS&D. This is not available if the item requires inspection.\"><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.line.interventionRequired\" ng-checked=\"vm.line.interventionRequired\" ng-disabled=\"vm.line.isComplete || vm.line.requiresInspection || !vm.line.isIncluded\"></span> <span ng-if=\"vm.line.isComplete\">{{vm.line.interventionRequired| yesNo }}</span></span></td><td ng-if=\"!vm.line.isComplete\"><a class=\"btn btn-primary btn-sm\" ng-click=\"vm.addDeliveryLineSplit()\" ng-disabled=\"vm.line.isComplete || !vm.line.isIncluded || (vm.line.checkedQuantity === 1 && vm.line.unitOfMeasureCode === \'EA\')\"><i class=\"fa fa-plus\"></i></a></td></tr><tr wg-delivery-line-split=\"\" ng-repeat=\"deliveryLineSplit in vm.line.deliveryLineSplits | orderBy: \'number\' track by $index\" delivery-line-split=\"deliveryLineSplit\" line=\"vm.line\" index=\"{{$index}}\" get-check-line=\"vm.getCheckLine()\" data-ng-if=\"vm.line.isIncluded\"></tr>");
$templateCache.put("app/deliveries/checkLines.html","<div ng-cloak=\"\" ng-if=\"vm.delivery.checkingStatus === \'Checking\'\"><div class=\"pull-left\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.completeChecking()\" ng-disabled=\"!(vm.checkLines | filter:{isIncluded: true} | filter:{costCode:\'\'}).length\"><i class=\"fa fa-check-square-o\"></i> Complete</button> <button type=\"submit\" class=\"btn btn-warning\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.cancelChecking()\"><i class=\"fa fa-times\"></i> Cancel</button></div><div class=\"clearfix\"></div><hr></div><div class=\"row\" ng-if=\"vm.delivery.checkingStatus === \'Check\'\"><div class=\"panel-body no-border\">The previous stage(s) should be completed before clicking this tab.</div></div><form role=\"form\" ng-if=\"vm.delivery.deliveryStatus == \'Complete\'\"><div class=\"row\"><table class=\"table\"><thead><tr><th ng-if=\"vm.delivery.checkingStatus === \'Checking\'\"></th><th>Line No.</th><th>Cost Code</th><th>Material Code</th><th>Barcode</th><th>Description</th><th>UOM</th><th>Inspect</th><th>Stated Quantity</th><th class=\"width-150\">Checked Quantity</th><th>Intervention Required</th><th ng-if=\"vm.delivery.checkingStatus === \'Checking\'\">Splits</th></tr></thead><tbody wg-check-line=\"\" ng-repeat=\"line in vm.checkLines | orderBy:natural(\'lineNumber\')\" line=\"line\" is-movement=\"vm.delivery.isMovement\" cost-codes=\"vm.costCodes\"></tbody></table></div></form>");
$templateCache.put("app/deliveries/createDelivery.html","<div ng-controller=\"CreateDeliveryCtrl as vm\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox-title\"><h5>Record a delivery</h5></div><div class=\"form-group\"><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div><form role=\"form\" name=\"createForm\" ng-submit=\"vm.createDelivery()\"><div class=\"row\"><div class=\"col-md-6 form-group\"><label><input icheck=\"\" type=\"radio\" ng-model=\"vm.delivery.purchaseOrderType\" value=\"purchaseOrder\" ng-change=\"vm.typeChanged()\"> Purchase Order</label> <label><input icheck=\"\" type=\"radio\" ng-model=\"vm.delivery.purchaseOrderType\" value=\"movement\" ng-change=\"vm.typeChanged()\"> Movement</label></div></div><div class=\"row\"><div class=\"col-md-3 form-group\" ng-if=\"vm.delivery.purchaseOrderType == \'purchaseOrder\'\" ng-class=\"{ \'has-error\' : createForm.purchaseOrder.$invalid && !createForm.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order &nbsp; <i class=\"fa fa-info-circle\" uib-tooltip=\"If the PO does not exist in the dropdown list below you can use the \'Get Purchase Order\' function on the Purchase Orders page to retrieve it from Oracle.\" tooltip-placement=\"bottom\"></i></label><select kendo-combo-box=\"\" ng-model=\"vm.delivery.purchaseOrderId\" k-options=\"vm.purchaseOrdersOptions\" class=\"form-control\" name=\"purchaseOrder\" id=\"purchaseOrder\" required=\"\" require-valid-option=\"\" ng-class=\"{ \'has-error\' : createForm.purchaseOrder.$invalid && !createForm.purchaseOrder.$pristine }\"></select></div><div class=\"col-md-3 form-group\" ng-if=\"vm.delivery.purchaseOrderType == \'movement\'\" ng-class=\"{ \'has-error\' : createForm.movement.$invalid && !createForm.movement.$pristine }\"><label class=\"control-label\" for=\"movement\">Movement</label><select kendo-combo-box=\"\" ng-model=\"vm.delivery.movementId\" k-options=\"vm.movementsOptions\" class=\"form-control\" name=\"movement\" id=\"movement\" required=\"\" require-valid-option=\"\" ng-class=\"{ \'has-error\' : createForm.movement.$invalid && !createForm.movement.$pristine }\"></select></div><div class=\"col-md-3 form-group\" ng-class=\"{ \'has-error\' : createForm.warehouse.$invalid && !createForm.warehouse.$pristine }\"><label class=\"control-label\" for=\"warehouse\">Warehouse</label><select kendo-combo-box=\"\" ng-model=\"vm.delivery.warehouseId\" k-options=\"vm.warehousesOptions\" class=\"form-control\" name=\"warehouse\" id=\"warehouse\" required=\"\" require-valid-option=\"\" ng-class=\"{ \'has-error\' : createForm.warehouse.$invalid && !createForm.warehouse.$pristine }\"></select></div><div class=\"col-md-3 form-group\" ng-class=\"{ \'has-error\' : createForm.reference.$invalid && !createForm.reference.$pristine }\"><label class=\"control-label\" for=\"reference\">Supplier Reference</label> <input type=\"text\" class=\"form-control k-textbox\" ng-model=\"vm.delivery.supplierDeliveryNumber\" name=\"reference\" id=\"reference\" required=\"\" ng-class=\"{ \'has-error\' : createForm.reference.$invalid && !createForm.reference.$pristine }\" uib-tooltip=\"Information from supplier delivery documentation, delivery note number, supplier PO number, etc.\" tooltip-placement=\"bottom\"></div><div class=\"col-md-3 form-group\" ng-class=\"{ \'has-error\' : (createForm.date.$invalid && !createForm.date.$pristine) || (createForm.dateMobile.$invalid && !createForm.dateMobile.$pristine) }\"><label class=\"control-label\" for=\"date\">Date</label><div class=\"input-group date hidden-xs\"><input type=\"text\" name=\"date\" id=\"date\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'win\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" uib-tooltip=\"Recorded date to be date that goods were physically received at the warehouse.\" tooltip-placement=\"bottom\" ng-model=\"vm.delivery.date\" is-open=\"vm.calendar.opened.win\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" max-date=\"vm.calendar.maxDate\" date-to-iso=\"\" required=\"\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'win\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div><div class=\"input-group date visible-xs\"><datepicker name=\"dateMobile\" ng-model=\"vm.delivery.date\" is-open=\"vm.calendar.opened.win\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" max-date=\"vm.calendar.maxDate\" required=\"\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'win\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></datepicker></div></div></div><div class=\"row\"><div class=\"form-group col-md-12\"><label class=\"control-label\">Comments</label> <textarea type=\"text\" class=\"form-control\" ng-model=\"vm.delivery.comments\" style=\"resize: none;\"></textarea></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" ladda=\"vm.loading\" class=\"btn btn-primary\" data-style=\"expand-right\" ng-disabled=\"createForm.$invalid\"><i class=\"fa fa-check\"></i> Save</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/deliveries/deliveryLines.html","<div ng-cloak=\"\" ng-if=\"!vm.delivery.isReadOnly\"><div class=\"pull-left\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.completeDelivery()\" ng-disabled=\"!(vm.deliveryLines | filter: {isIncluded: true}).length\"><i class=\"fa fa-check-square-o\"></i> Confirm</button> <button type=\"submit\" class=\"btn btn-warning\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.cancelDelivery()\"><i class=\"fa fa-times\"></i> Cancel</button></div><div class=\"clearfix\"></div><hr></div><form role=\"form\"><div class=\"row\"><table class=\"table\"><thead><tr><th ng-if=\"!vm.delivery.isReadOnly\"><span><input type=\"checkbox\" ng-model=\"vm.selectedAll\" icheck-all=\"vm.deliveryLines.isIncluded\" icheck-ignore=\"isNonReceivable\"></span></th><th>Line No.</th><th>Cost Code</th><th>Material Code</th><th>Description</th><th>UOM</th><th>Inspect</th><th class=\"text-nowrap\">Outstanding Qty</th><th class=\"col-lg-2 col-xs-3\">Delivery Qty</th><th class=\"col-lg-1 col-xs-2\"></th></tr></thead><tbody ng-repeat=\"line in vm.deliveryLines | filter: (vm.delivery.isReadOnly || \'\') && {isIncluded: true} | orderBy:natural(\'lineNumber\')\" ng-controller=\"SaveDeliveryCtrl as sv\" class=\"te\"><tr ng-if=\"line.isNonReceivable\"><s><td ng-if=\"!vm.delivery.isReadOnly\"><input icheck=\"\" type=\"checkbox\" ng-model=\"line.isIncluded\" ng-checked=\"line.isIncluded || vm.delivery.isMovement\" ng-disabled=\"vm.delivery.isMovement || line.isNonReceivable\"></td><td><s>{{ line.lineNumber }}</s></td><td><s>{{ line.costCode }}</s></td><td><s>{{ line.materialCode }}</s></td><td><s>{{ line.description }}</s></td><td><s>{{ line.unitOfMeasureCode }}</s></td><td><s>{{ line.inspectionType== \'V\'? \'Vendor\' : line.inspectionType== \'I\'? \'Warehouse\' : \'None\' }}</s></td><td><s>{{ line.outstandingQuantity }}</s></td><td><s>{{line.statedQuantity}}</s></td><td><div class=\"btn-group pull-right\" ng-if=\"!vm.delivery.isMovement\"><button type=\"button\" data-toggle=\"dropdown\" class=\"btn btn-default dropdown-toggle\">...</button><ul class=\"dropdown-menu pull-right\"><li><a ng-click=\"sv.setLinesReceivability(line)\">{{!line.isNonReceivable ? \'Set as non-receivable\' : \'Set as receivable\'}}</a></li></ul></div></td></s></tr><tr ng-if=\"!line.isNonReceivable\"><td ng-if=\"!vm.delivery.isReadOnly\"><input icheck=\"\" type=\"checkbox\" ng-model=\"line.isIncluded\" ng-checked=\"line.isIncluded\" ng-disabled=\"vm.delivery.isMovement || line.isNonReceivable\"></td><td>{{ line.lineNumber }}</td><td>{{ line.costCode }}</td><td><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ line.materialCode }}</pre></td><td>{{ line.description }}</td><td>{{ line.unitOfMeasureCode }}</td><td>{{ line.inspectionType== \'V\'? \'Vendor\' : line.inspectionType== \'I\'? \'Warehouse\' : \'None\' }}</td><td>{{ line.outstandingQuantity }}</td><td><div class=\"input-group\"><span ng-if=\"line.isIncluded\" class=\"ng-animate-disabled\"><input type=\"text\" class=\"form-control\" ng-model=\"line.statedQuantity\" ng-readonly=\"vm.delivery.isReadOnly || !line.isIncluded || vm.delivery.isMovement\" numeric-only=\"\"></span> <span ng-if=\"!line.isIncluded\" class=\"ng-animate-disabled\"><input type=\"text\" class=\"form-control\" ng-readonly=\"true\"></span><div class=\"input-group-addon\" style=\"width: 40px\" ng-if=\"!vm.delivery.isReadOnly && line.isIncluded\"><span ng-if=\"!sv.loading && !sv.validationErrors\"><i class=\"fa fa-check text-navy\"></i></span> <span ng-if=\"sv.loading && !sv.validationErrors\"><i class=\"fa fa-cog fa-spin\"></i></span> <span ng-if=\"sv.validationErrors\"><i class=\"fa fa-times text-danger\"></i></span></div></div></td><td><div class=\"btn-group pull-right\" ng-if=\"!vm.delivery.isMovement\"><button type=\"button\" data-toggle=\"dropdown\" class=\"btn btn-default dropdown-toggle\">...</button><ul class=\"dropdown-menu pull-right\"><li><a ng-click=\"sv.setLinesReceivability(line)\">{{!line.isNonReceivable ? \'Set as non-receivable\' : \'Set as receivable\'}}</a></li></ul></div></td></tr></tbody></table></div></form>");
$templateCache.put("app/deliveries/deliveryLineSplit.html","<td ng-class=\"{\'remove-border\': vm.index!=0}\" ng-if=\"!vm.line.isComplete\"></td><td ng-class=\"{\'remove-border\': vm.index!=0}\"></td><td ng-class=\"{\'remove-border\': vm.index!=0}\"></td><td ng-class=\"{\'remove-border\': vm.index!=0}\"></td><td><wg-trace-info barcode=\"{{vm.deliveryLineSplit.barcode}}\" check-line-id=\"{{vm.line.id}}\" description=\"{{vm.line.description}}\"></wg-trace-info></td><td>{{ vm.deliveryLineSplit.name }}</td><td></td><td></td><td></td><td><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.deliveryLineSplit.checkedQuantity\" ng-disabled=\"vm.line.isComplete\" numeric-only=\"\"><div class=\"input-group-addon\" ng-if=\"!vm.line.isComplete\"><span data-ng-if=\"!vm.loading && !vm.validationErrors\"><i class=\"fa fa-check text-navy\" title=\"Data saved successfully.\"></i></span> <span data-ng-if=\"vm.loading && !vm.validationErrors\"><i class=\"fa fa-cog fa-spin\"></i></span> <span data-ng-if=\"vm.validationErrors\" title=\"Data not saved. Try again.\"><i class=\"fa fa-times text-danger\"></i></span></div></div></td><td><span ng-if=\"!vm.line.isComplete\"><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.deliveryLineSplit.interventionRequired\" ng-checked=\"vm.deliveryLineSplit.interventionRequired\" ng-disabled=\"vm.line.isComplete || vm.line.requiresInspection\"></span> <span ng-if=\"vm.line.isComplete\">{{vm.deliveryLineSplit.interventionRequired| yesNo }}</span></td><td ng-if=\"!vm.line.isComplete\"><a class=\"btn btn-danger btn-sm\" ng-click=\"vm.removeDeliveryLineSplit()\" ladda=\"vm.loading\" ng-disabled=\"vm.line.isComplete\"><i class=\"fa fa-minus\"></i></a></td>");
$templateCache.put("app/deliveries/editDelivery.html","<div ng-controller=\"EditDeliveryCtrl as vm\"><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"m-b-md\"><h2><span class=\"text-nowrap\">Delivery {{ vm.delivery.number }}</span> <small><strong class=\"text-nowrap\">{{vm.delivery.supplierName }}</strong></small> <small><span class=\"text-nowrap\">{{vm.delivery.warehouseName }}</span></small></h2></div><div class=\"alert alert-danger\" ng-show=\"vm.validationErrors.length > 0\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><dl class=\"dl-horizontal\"><dt>Status:</dt><dd><span ng-class=\"!vm.delivery.isReadOnly ? \'badge label-warning\' : (vm.deliveryStatus === \'Cancelled\') ? \'badge label-danger\' : \'badge label-primary\'\">{{vm.deliveryStatus}}</span> <span ng-class=\"vm.delivery.checkingStatus === \'Check\' ? \'badge\' : (vm.delivery.checkingStatus === \'Checking\') ? \'badge label-warning\' : \'badge label-primary\'\">{{vm.delivery.checkingStatus}}</span> <span ng-class=\"vm.delivery.inspectionStatus === \'Inspection\' ? \'badge\' : (vm.delivery.inspectionStatus === \'Inspecting\') ? \'badge label-warning\' : \'badge label-primary\'\">{{vm.delivery.inspectionStatus}}</span> <span ng-if=\"vm.delivery.hasPotentialOsd || vm.delivery.hasInterventions || vm.delivery.hasOutstandingShort\" ng-class=\"\'badge label-warning\'\">OS&D</span> <span ng-class=\"vm.delivery.storingStatus === \'Store\' ? \'badge\' : (vm.delivery.storingStatus === \'Storing\') ? \'badge label-warning\' : \'badge label-primary\'\">{{vm.delivery.storingStatus}}</span></dd></dl></div></div><div class=\"row\"><div class=\"row\"><div class=\"col-lg-8\"><div class=\"row\"><div class=\"col-lg-6\"><dl class=\"dl-horizontal\"><dt><span ng-if=\"vm.delivery.isMovement\">Movement:</span> <span ng-if=\"!vm.delivery.isMovement\">Purchase Order:</span></dt><dd>{{ vm.delivery.purchaseOrderNumber }}</dd><dt>Supplier Reference:</dt><dd>{{ vm.delivery.supplierDeliveryNumber }}</dd><dt>Created By:</dt><dd>{{ vm.delivery.createdBy }}</dd></dl></div><div class=\"col-lg-6\"><dl class=\"dl-horizontal\"><dt>Delivery Date:</dt><dd>{{ vm.delivery.date | date:\'dd-MMM-yyyy\' }}</dd><dt>PO Date:</dt><dd>{{ vm.delivery.purchaseOrderDate | date:\'dd-MMM-yyyy\' }}</dd><dt>Created Date:</dt><dd>{{ vm.delivery.createdDate | date:\'dd-MMM-yyyy\' }}</dd></dl></div></div><div class=\"row\" ng-if=\"vm.delivery.comments\"><div class=\"col-lg-12\"><dl class=\"dl-horizontal\"><dt>Comments:</dt><dd class=\"pre-wrap\">{{ vm.delivery.comments }}</dd></dl></div></div></div></div></div></div></div><div class=\"\"><div class=\"\"><div class=\"tabs-container\"><uib-tabset><uib-tab active=\"vm.tabs.deliveryActive\"><uib-tab-heading><i class=\"fa fa-truck\"></i>1. Delivery note</uib-tab-heading><div class=\"panel-body\"><div ng-include=\"\'app/deliveries/deliveryLines.html\'\"></div></div></uib-tab><uib-tab active=\"vm.tabs.checkingActive\"><uib-tab-heading><i class=\"fa fa-clipboard\"></i>2. Checking</uib-tab-heading><div class=\"panel-body\"><div ng-include=\"\'app/deliveries/checkLines.html\'\"></div></div></uib-tab><uib-tab active=\"vm.tabs.inspectionActive\"><uib-tab-heading><i class=\"fa fa-search\"></i>3. Inspection</uib-tab-heading><div class=\"panel-body\"><div ng-include=\"\'app/deliveries/inspections.html\'\"></div></div></uib-tab><uib-tab active=\"vm.tabs.osdActive\"><uib-tab-heading><i ng-class=\"vm.delivery.hasPotentialOsd || vm.delivery.hasInterventions || vm.delivery.hasOutstandingShort ? \'fa fa-warning text-danger\' : \'fa fa-warning\'\"></i>OS&D</uib-tab-heading><div class=\"panel-body\"><div ng-include=\"\'app/deliveries/overShortAndDamaged.html\'\"></div></div></uib-tab><uib-tab active=\"vm.tabs.storeActive\"><uib-tab-heading><i class=\"fa fa-archive\"></i>4. Store</uib-tab-heading><div class=\"panel-body\"><div ng-include=\"\'app/deliveries/stockItems.html\'\"></div></div></uib-tab></uib-tabset></div></div></div></div></div></div></div>");
$templateCache.put("app/deliveries/incompleteDeliveries.html","<div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"m-t-none m-b\">Incomplete Deliveries <span class=\"badge label-primary\" ng-if=\"vm.deliveries.length && !vm.loading\">{{ vm.deliveries.length }}</span></h5></div></div><div class=\"ibox-tools\"></div></div><div class=\"ibox-content\"><div ng-if=\"vm.deliveries.length && !vm.loading\" class=\"animated fadeIn\"><table class=\"table\"><thead><tr><th class=\"col-xs-2\">#</th><th class=\"col-xs-2\">Purchase Order</th><th class=\"col-xs-2 text-nowrap\">Date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"delivery in vm.deliveries | orderBy: number | itemsPerPage: 5\" current-page=\"vm.currentPage\"><td><a ui-sref=\"deliveries.details({id:delivery.id})\">{{ delivery.number }}</a></td><td>{{ delivery.purchaseOrderNumber }}</td><td>{{ delivery.date | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\"></dir-pagination-controls></div><div ng-if=\"!vm.deliveries.length && !vm.loading\" class=\"animated fadeIn\"><strong>There are no incomplete deliveries.</strong></div><div class=\"sk-spinner sk-spinner-three-bounce\" ng-if=\"vm.loading\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div></div>");
$templateCache.put("app/deliveries/inspections.html","<div class=\"feed-activity-list\" ng-controller=\"InspectionsCtrl as ic\"><div class=\"add-pd-b pl8\" ng-if=\"vm.delivery.inspectionStatus === \'Inspecting\'\"><input type=\"checkbox\" ng-model=\"ic.selectedAll\" icheck-all=\"ic.fullOsdItems.isIncluded\" icheck-ignore=\"inspectionIsComplete\" ng-disabled=\"vm.delivery.isMovement\"> <span class=\"pl10\"><wg-add-inspections items=\"ic.fullOsdItems\" post-update-delegate=\"ic.displayInspections()\" warehouse-id=\"{{vm.delivery.warehouseId}}\"></wg-add-inspections></span></div><div ng-repeat=\"checkLine in ic.fullOsdItems | filter: {hasInspections:true} | orderBy: \'checkLine.poLineNumber\'\"><table class=\"table materia-grouped-row margin-b-5\"><tr><td style=\"width: 30px\"><input icheck=\"\" type=\"checkbox\" ng-model=\"checkLine.isIncluded\" ng-checked=\"checkLine.isIncluded\" ng-disabled=\"!checkLine.inspections.length\" ng-if=\"vm.delivery.inspectionStatus === \'Inspecting\'\"></td><td class=\"item-description\">{{checkLine.checkLine.description | uppercase}}</td></tr></table><table class=\"table no-border\" ng-if=\"checkLine.inspections.length && !(checkLine.shorts | filter: shortRegistered==false).length\"><tbody ng-repeat=\"inspection in checkLine.inspections\"><tr><td style=\"width:50px;\">{{inspection.poLineNumber}}</td><td class=\"width-125\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{inspection.barcode}}</pre></td><td><span class=\"badge label-danger\">Inspection required</span> You must perform an inspection before continuing.</td><td class=\"text-right\"><span ng-if=\"ic.allowInspections\"><wg-add-inspection item=\"inspection\" post-update-delegate=\"ic.displayInspections()\" warehouse-id=\"{{vm.delivery.warehouseId}}\" max-inspection-quantity=\"inspection.checkedQuantity\"></wg-add-inspection></span></td></tr><tr ng-if=\"!ic.allowInspections\"><td colspan=\"3\"><div class=\"well remove-margin-b\"><small class=\"text-navy\"><i class=\"fa fa-info\"></i> An inspector must inspect this item before proceeding.</small></div></td></tr></tbody></table><table class=\"table no-border\" ng-if=\"checkLine.inspections.length && (checkLine.shorts | filter: shortRegistered==false).length\"><tbody ng-repeat=\"inspection in checkLine.inspections\"><tr><td style=\"width:50px;\">{{inspection.poLineNumber}}</td><td class=\"width-125\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{inspection.barcode}}</pre></td><td><span class=\"badge label-danger\">Inspection required</span> Register the short on the OS&D tab before continuing.</td></tr></tbody></table><table class=\"table no-border\" ng-if=\"checkLine.resolvedInspections.length\"><tbody ng-repeat=\"inspection in checkLine.resolvedInspections\"><tr><td style=\"width:50px;\">{{inspection.poLineNumber}}</td><td class=\"width-125\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{inspection.barcode}}</pre></td><td>Passed inspection: <strong>{{inspection.passedInspectionQuantity}}</strong>. Failed inspection: <strong>{{inspection.failedInspectionQuantity}}</strong>. The checked quantity was <strong>{{inspection.checkedQuantity}}</strong>.</td></tr><tr ng-hide=\"!inspection.inspectionComments\"><td></td><td colspan=\"3\"><small class=\"text-muted\"><strong>{{inspection.inspectionUser}}</strong></small> <small am-time-ago=\"inspection.inspectionDate\" title=\"{{inspection.inspectionDate | date:\'dd-MMM-yyyy - HH:mm\'}}\"></small><div class=\"well remove-margin-b\"><dl class=\"dl-horizontal remove-margin-b\"><dt ng-if=\"inspection.ircNumber\"><strong>IRC Number:</strong></dt><dd ng-if=\"inspection.ircNumber\">{{inspection.ircNumber }}</dd><dt><strong>Comments:</strong></dt><dd>{{inspection.inspectionComments}}</dd></dl></div></td></tr></tbody></table></div><div class=\"row\" ng-if=\"vm.delivery.inspectionStatus === \'Inspection\'\"><div class=\"panel-body no-border\">Any lines that require inspection will appear on this tab.</div></div></div>");
$templateCache.put("app/deliveries/overShortAndDamaged.html","<div class=\"feed-activity-list\" ng-controller=\"OverShortAndDamagedCtrl as osd\"><div ng-repeat=\"checkLine in osd.fullOsdItems | filter: {hasOsd:true} | orderBy: \'checkLine.poLineNumber\'\"><table class=\"table materia-grouped-row margin-b-5\"><tr><td class=\"item-description\">{{checkLine.checkLine.description | uppercase}}</td></tr></table><table class=\"table no-border\" ng-if=\"checkLine.shorts.length\"><tbody ng-repeat=\"short in checkLine.shorts\"><tr><td style=\"width:50px;\">{{short.poLineNumber}}</td><td class=\"width-125\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{short.barcode}}</pre></td><td><span class=\"badge\">Short</span> of <strong>{{short.shortQuantity}}</strong>. The delivery note quantity was <strong>{{short.statedQuantity}}</strong> but the checked quantity was <strong>{{short.checkedQuantity}}</strong>.</td><td class=\"text-right\" ng-hide=\"short.shortRegistered\"><wg-register-short barcode=\"{{short.barcode}}\" check-line-id=\"{{short.checkLineId}}\" description=\"{{short.description}}\" get-shorts=\"osd.displayOverages()\"></wg-register-short></td></tr><tr ng-hide=\"!short.shortRegistered\"><td></td><td colspan=\"3\"><small class=\"text-muted\"><strong>{{short.interventionUser}}</strong></small> <small am-time-ago=\"short.interventionDate\" title=\"{{short.interventionDate | date:\'dd-MMM-yyyy - HH:mm\'}}\"></small><div class=\"well remove-margin-b\">{{short.shortComments}}</div></td></tr></tbody></table><table class=\"table no-border\" ng-if=\"checkLine.interventions.length && !(checkLine.shorts | filter: shortRegistered==false).length\"><tbody ng-repeat=\"intervention in checkLine.interventions\"><tr><td style=\"width:50px;\">{{intervention.poLineNumber}}</td><td class=\"width-125\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{intervention.barcode}}</pre></td><td><span class=\"badge label-danger\">Intervention required</span> You must resolve an intervention before continuing.</td><td class=\"text-right\"><wg-register-intervention barcode=\"{{intervention.barcode}}\" check-line-id=\"{{intervention.checkLineId}}\" delivery-id=\"{{osd.deliveryId}}\" warehouse-id=\"{{vm.delivery.warehouseId}}\" purchase-order-line-id=\"{{intervention.purchaseOrderLineId}}\" description=\"{{intervention.description}}\" display-overages=\"osd.displayOverages()\" checked-quantity=\"{{intervention.unresolvedQuantity}}\"></wg-register-intervention></td></tr></tbody></table><table class=\"table no-border\" ng-if=\"!checkLine.interventions.length\"><tbody ng-repeat=\"potentialOverage in checkLine.potentialOverages\"><tr class=\"white-bg\"><td style=\"width:50px;\">{{potentialOverage.poLineNumber}}</td><td class=\"width-125\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{potentialOverage.barcode}}</pre></td><td colspan=\"2\"><span class=\"badge label-danger\">Potential overage</span> of <strong>{{potentialOverage.requiredOverageQuantity}}</strong>. The delivery note quantity was <strong>{{potentialOverage.statedQuantity}}</strong> and the total checked quantity was <strong>{{potentialOverage.checkedQuantity}}</strong>. <span ng-if=\"potentialOverage.interventionUnresolvedQuantity > 0\">There was an intervention of <strong>{{potentialOverage.interventionUnresolvedQuantity}}</strong> registered. The good quantity was therefore <strong>{{potentialOverage.checkedQuantity-potentialOverage.interventionUnresolvedQuantity}}</strong>.</span> This is outwith the tolerance of <strong>{{potentialOverage.receivingToleranceMultiplied}}%</strong>. The outstanding quantity on the purchase order line is <strong>{{potentialOverage.quantityOutstanding}}</strong>.</td><td class=\"text-right\"><wg-register-overage barcode=\"{{potentialOverage.barcode}}\" check-line-id=\"{{potentialOverage.checkLineId}}\" delivery-id=\"{{osd.deliveryId}}\" warehouse-id=\"{{vm.delivery.warehouseId}}\" purchase-order-line-id=\"{{potentialOverage.purchaseOrderLineId}}\" description=\"{{potentialOverage.description}}\" display-overages=\"osd.displayOverages()\" potential-overages=\"potentialOverage.potentialOverageItems\" quantity-outstanding=\"{{potentialOverage.quantityOutstanding}}\" required-overage=\"{{potentialOverage.requiredOverageQuantity}}\"></wg-register-overage></td></tr></tbody></table><table class=\"table no-border\" ng-if=\"checkLine.unresolvedInterventions.length\"><tbody ng-repeat=\"unresolvedIntervention in checkLine.unresolvedInterventions\"><tr><td style=\"width:50px;\">{{unresolvedIntervention.poLineNumber}}</td><td class=\"width-125\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{unresolvedIntervention.barcode}}</pre></td><td><span class=\"badge\">Was registered as an intervention of <strong>{{unresolvedIntervention.interventionUnresolvedQuantity}}</strong>.</span> Damaged: <strong>{{unresolvedIntervention.interventionDamagedUnresolvedQuantity}}</strong>. Other: <strong>{{unresolvedIntervention.interventionOtherUnresolvedQuantity}}</strong>. The checked quantity was <strong>{{unresolvedIntervention.receivedItemCheckedQuantity}}</strong>. The good quantity was therefore <strong>{{unresolvedIntervention.receivedItemCheckedQuantity-unresolvedIntervention.interventionUnresolvedQuantity}}</strong>.</td></tr><tr ng-hide=\"!unresolvedIntervention.interventionUnresolvedQuantity\"><td></td><td colspan=\"3\"><small class=\"text-muted\"><strong>{{unresolvedIntervention.interventionUser}}</strong> {{unresolvedIntervention.interventionDate | date:\'dd-MMM-yyyy - HH:mm\'}}</small><div class=\"well remove-margin-b\">{{unresolvedIntervention.interventionDiscrepancyDescription}}</div></td></tr></tbody></table><table class=\"table no-border\" ng-if=\"checkLine.unresolvedOverages.length\"><tbody ng-repeat=\"unresolvedOverage in checkLine.unresolvedOverages\"><tr><td style=\"width:50px;\">{{unresolvedOverage.poLineNumber}}</td><td class=\"width-125\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{unresolvedOverage.barcode}}</pre></td><td><span class=\"badge\">Was registered as an overage of <strong>{{unresolvedOverage.overageUnresolvedQuantity}}</strong>.</span> The delivery note quantity was <strong>{{unresolvedOverage.statedQuantity}}</strong> but the total checked quantity was <strong>{{unresolvedOverage.checkedQuantity}}</strong>. <span ng-if=\"unresolvedOverage.checkedQuantity != unresolvedOverage.receivedItemCheckedQuantity\">The split checked quantity was <strong>{{unresolvedOverage.receivedItemCheckedQuantity}}</strong>.</span> <span ng-if=\"unresolvedOverage.interventionUnresolvedQuantity > 0\">There was an intervention of <strong>{{unresolvedOverage.interventionUnresolvedQuantity}}</strong> registered.</span> The good quantity was therefore <strong>{{unresolvedOverage.receivedItemCheckedQuantity-unresolvedOverage.overageUnresolvedQuantity - unresolvedOverage.interventionUnresolvedQuantity}}</strong>.</td></tr><tr ng-hide=\"!unresolvedOverage.overageUnresolvedQuantity\"><td></td><td colspan=\"3\"><small class=\"text-muted\"><strong>{{unresolvedOverage.interventionUser}}</strong></small> <small am-time-ago=\"unresolvedOverage.interventionDate\" title=\"{{unresolvedOverage.interventionDate | date:\'dd-MMM-yyyy - HH:mm\'}}\"></small><div class=\"well remove-margin-b\">{{unresolvedOverage.overageDiscrepancyDescription}}</div></td></tr></tbody></table><table class=\"table no-border\" ng-if=\"checkLine.receivedOverages.length\"><tbody ng-repeat=\"receivedOverage in checkLine.receivedOverages\"><tr><td style=\"width:50px;\">{{receivedOverage.poLineNumber}}</td><td class=\"width-125\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{receivedOverage.barcode}}</pre></td><td><span class=\"badge\">Had an overage</span> of <strong>{{receivedOverage.overageQuantity}}</strong> but was received as the total is within the outstanding quantity. The delivery note quantity was <strong>{{receivedOverage.statedQuantity}}</strong> but the checked quantity was <strong>{{receivedOverage.checkedQuantity}}</strong>. <span ng-if=\"receivedOverage.interventionUnresolvedQuantity > 0\">There was an intervention of <strong>{{receivedOverage.interventionUnresolvedQuantity}}</strong> registered. The good quantity was therefore <strong>{{receivedOverage.checkedQuantity-receivedOverage.interventionUnresolvedQuantity}}</strong>.</span></td></tr></tbody></table><table class=\"table no-border\" ng-if=\"checkLine.receivedItemWithinTolerances.length\"><tbody ng-repeat=\"receivedItem in checkLine.receivedItemWithinTolerances\"><tr><td style=\"width:50px;\">{{receivedItem.poLineNumber}}</td><td class=\"width-125\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{receivedItem.barcode}}</pre></td><td>Was received as the checked quantity was within the tolerance of <strong>{{receivedItem.receivingToleranceMultiplied}}%</strong> of the outstanding quantity. The delivery note quantity was <strong>{{receivedItem.statedQuantity}}</strong> and the total checked quantity was <strong>{{receivedItem.checkedQuantity}}</strong>. <span ng-if=\"receivedItem.checkedQuantity != receivedItem.itemCheckedQuantity\">The checked quantity for this split was <strong>{{receivedItem.itemCheckedQuantity}}</strong>.</span> <span ng-if=\"receivedItem.interventionUnresolvedQuantity > 0\">There was an intervention of <strong>{{receivedItem.interventionUnresolvedQuantity}}</strong> registered. The good quantity was therefore <strong>{{receivedItem.itemCheckedQuantity-receivedItem.interventionUnresolvedQuantity}}</strong>.</span></td></tr></tbody></table></div><div class=\"row\" ng-if=\"!osd.fullOsdItems.length || !(osd.fullOsdItems | filter: {hasOsd:true}).length\"><div class=\"panel-body no-border\">Any lines that require OS&D will appear on this tab.</div></div></div>");
$templateCache.put("app/deliveries/stockItem.html","<tr ng-if=\"!vm.hideDescription\"><td colspan=\"9\" class=\"item-description\">{{vm.item.description | uppercase}}</td></tr><tr class=\"new-border\"><td style=\"width:50px;\">{{ vm.item.poLineNumber }}</td><td>{{ vm.item.costCode }}</td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.materialCode }}</pre></td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.barcode }}</pre></td><td>{{ vm.item.unitOfMeasureCode }}</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.totalQuantity\" ng-readonly=\"true\"></td><td class=\"text-right\" colspan=\"2\"><span ng-hide=\"vm.isReadonly || vm.item.isComplete\"><small>{{vm.item.totalQuantity - vm.item.totalStoredQuantity}} outstanding</small><uib-progressbar max=\"vm.item.totalQuantity\" value=\"vm.item.totalStoredQuantity\" type=\"{{vm.progressbarType}}\" title=\"Stored Quantity / Total\"><span style=\"color:black; white-space:nowrap;\">{{vm.item.totalStoredQuantity}} / {{vm.item.totalQuantity}}</span></uib-progressbar></span></td><td><a class=\"btn btn-primary btn-sm\" ng-click=\"vm.addStockItemLocation()\" ladda=\"vm.loading\" ng-hide=\"vm.isReadonly || vm.item.isComplete\"><i class=\"fa fa-plus\"></i></a></td></tr><tr wg-stock-item-location=\"\" ng-repeat=\"stockItemLocation in vm.item.unstoredStockItemLocations track by $index\" stock-item-location=\"stockItemLocation\" item=\"vm.item\" index=\"{{$index}}\" locations=\"vm.locations\" get-stock-item=\"vm.getStockItem()\" is-readonly=\"vm.isReadonly\" had-osd=\"vm.item.overShortDamagedItems !== null\" is-complete=\"vm.item.isComplete\"></tr>");
$templateCache.put("app/deliveries/stockItemLocation.html","<td></td><td colspan=\"5\" ng-class=\"{\'remove-border\': vm.index!=0}\"><span ng-if=\"vm.index === \'0\' && vm.hadOsd && vm.isComplete\">Stored via <span ng-repeat=\"osdItem in vm.item.overShortDamagedItems\"><span class=\"badge label-danger\">{{ osdItem.number }}</span></span></span></td><td><select required=\"\" id=\"{{vm.stockItemLocation.id}}\" kendo-drop-down-list=\"\" k-options=\"vm.locationsOptions\" k-ng-delay=\"vm.locationsOptions\" k-value-primitive=\"true\" k-ng-model=\"vm.locationSelectedId\" k-on-change=\"vm.locationChanged(kendoEvent)\" style=\"width:100%\" ng-disabled=\"vm.isReadonly || vm.hadOsd && vm.item.isComplete\"></select></td><td><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.stockItemLocation.quantity\" ng-disabled=\"vm.isReadonly || vm.hadOsd && vm.item.isComplete\" numeric-only=\"\"><div class=\"input-group-addon\" ng-if=\"!vm.isReadonly\"><span data-ng-if=\"!vm.loading && !vm.validationErrors\"><i class=\"fa fa-check text-navy\"></i></span> <span data-ng-if=\"vm.loading && !vm.validationErrors\"><i class=\"fa fa-cog fa-spin\"></i></span> <span data-ng-if=\"vm.validationErrors\"><i class=\"fa fa-times text-danger\"></i></span></div></div></td><td><a class=\"btn btn-danger btn-sm\" ng-click=\"vm.removeStockItemLocation()\" ladda=\"vm.loadingRemoveButton\" ng-if=\"!vm.isReadonly && !vm.hadOsd\" ng-disabled=\"vm.isReadonly\"><i class=\"fa fa-minus\"></i></a></td>");
$templateCache.put("app/deliveries/stockItems.html","<div ng-controller=\"StockItemsCtrl as si\"><div ng-cloak=\"\" ng-if=\"vm.delivery.storingStatus === \'Storing\' && si.stockItems.length > 0\"><div class=\"btn-toolbar\"><div class=\"btn-group\"><button type=\"submit\" class=\"btn btn-primary btn-primary-spacing\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.completeStoring()\" ng-disabled=\"si.anyInvalid\"><i class=\"fa fa-check-square-o\"></i> Complete</button> <span ng-if=\"si.osdOutstandingCount !== undefined && si.osdOutstandingCount > 0\">This delivery contains {{si.osdOutstandingCount}} unresolved OS&D items.</span></div><div class=\"btn-group\"><wg-unstored-stock-item-location delivery-id=\"vm.delivery.id\" locations=\"si.locations\" get-stock-items=\"si.getStockItems()\"></wg-unstored-stock-item-location></div><span class=\"badge label-danger osd-delivery-pad\" ng-if=\"!vm.delivery.osdIsResolved\">This delivery has {{vm.delivery.osdRegisterItemCount - vm.delivery.osdRegisterItemResolvedCount}} out of {{ vm.delivery.osdRegisterItemCount }} OS&D item(s) remaining.</span></div><div class=\"hr-line-dashed\"></div></div><div class=\"row\" ng-if=\"vm.delivery.storingStatus === \'Store\' || si.stockItems.length == 0\"><div class=\"panel-body no-border\"><span ng-if=\"vm.delivery.osdRegisterItemCount === 0\">The previous stage(s) should be completed before clicking this tab.</span> <span ng-if=\"vm.delivery.osdRegisterItemCount > 0\">This delivery has {{vm.delivery.osdRegisterItemCount}} outstanding OS&D item(s) requiring resolution.</span></div></div><form role=\"form\" ng-if=\"vm.delivery.storingStatus !== \'Store\' && si.stockItems.length > 0\"><div class=\"row\"><table class=\"table materia-grouped-row\"><thead><tr><th>Line No.</th><th>Cost Code</th><th>Material Code</th><th>Barcode</th><th>UOM</th><th class=\"width-150\">Checked Quantity</th><th class=\"width-200\">Location</th><th class=\"width-150\">Stored Quantity</th><th ng-if=\"!vm.delivery.isStoringReadOnly\"></th></tr></thead><tbody wg-stock-item=\"\" ng-repeat=\"item in si.stockItems | orderBy: \'poLineNumberSortOrder\' track by $index\" item=\"item\" locations=\"si.locations\" is-readonly=\"vm.delivery.isStoringReadOnly\"></tbody></table></div></form></div>");
$templateCache.put("app/deliveries/unstoredStockItemLocation.html","<button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.openSetAllLocations()\"><i class=\"fa fa-location-arrow\"></i> Set all locations</button>");
$templateCache.put("app/deliveries/unstoredStockItemLocationModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-location-arrow modal-icon\"></i><h4 class=\"modal-title\">Set all locations</h4></div><div class=\"modal-body p-b-xxs\"><form class=\"form-horizontal\" name=\"save\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Location</label><div class=\"col-lg-8\"><select required=\"\" kendo-drop-down-list=\"\" k-options=\"vm.locationsOptions\" k-ng-model=\"vm.location\" style=\"width:100%\"></select></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Successfully updated the location of all stock items to <strong>{{vm.location.warehouseName}} - {{vm.location.name}}</strong>.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error the saving stock item locations.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.location.id == null\">Save</button></div></div>");
$templateCache.put("app/deliveries/viewDelivery.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div ng-include=\"\'app/deliveries/createDelivery.html\'\"></div><div class=\"tabs-container\" ng-controller=\"ViewDeliveryCtrl as vm\"><uib-tabset><uib-tab active=\"vm.tabs.incompleteActive\" ui-sref=\"deliveries.view.incomplete\"><uib-tab-heading><i class=\"fa fa-truck\"></i>Incomplete deliveries <span class=\"badge label-primary\">{{ vm.openDeliveries.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.openDeliveries.length\">There are no incomplete deliveries.</strong><div ng-if=\"vm.openDeliveries.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-3 text-nowrap\">Purchase Order</th><th class=\"col-xs-2 text-nowrap\">Supplier</th><th class=\"col-xs-2 text-nowrap\">Supplier Reference</th><th class=\"col-xs-1 text-nowrap\">Date</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"delivery in vm.openDeliveries | orderBy: number | itemsPerPage: 15\" pagination-id=\"incomplete\"><td><a ui-sref=\"deliveries.details({id:delivery.id})\">{{ delivery.number }}</a></td><td>{{ delivery.purchaseOrderNumber }}</td><td>{{ delivery.supplierName }}</td><td>{{ delivery.supplierDeliveryNumber }}</td><td>{{ delivery.date | date:\'dd-MMM-yyyy\' }}</td><td>{{ delivery.createdBy }}</td><td>{{ delivery.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls></div></div></uib-tab><uib-tab active=\"vm.tabs.checkingActive\" ui-sref=\"deliveries.view.checking\"><uib-tab-heading><i class=\"fa fa-clipboard\"></i>Checking <span class=\"badge label-primary\">{{ vm.checkingDeliveries.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.checkingDeliveries.length\">There are no deliveries being checked.</strong><div ng-if=\"vm.checkingDeliveries.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"checking\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-3 text-nowrap\">Purchase Order</th><th class=\"col-xs-2 text-nowrap\">Supplier</th><th class=\"col-xs-2 text-nowrap\">Supplier Reference</th><th class=\"col-xs-1 text-nowrap\">Date</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"delivery in vm.checkingDeliveries | orderBy: number | itemsPerPage: 15\" pagination-id=\"checking\"><td><a ui-sref=\"deliveries.details({id:delivery.id})\">{{ delivery.number }}</a></td><td>{{ delivery.purchaseOrderNumber }}</td><td>{{ delivery.supplierName }}</td><td>{{ delivery.supplierDeliveryNumber }}</td><td>{{ delivery.date | date:\'dd-MMM-yyyy\' }}</td><td>{{ delivery.createdBy }}</td><td>{{ delivery.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"checking\"></dir-pagination-controls></div></div></uib-tab><uib-tab active=\"vm.tabs.inspectionActive\" ui-sref=\"deliveries.view.inspection\"><uib-tab-heading><i class=\"fa fa-search\"></i>Inspection <span class=\"badge label-primary\">{{ vm.inspectionDeliveries.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.inspectionDeliveries.length\">There are no deliveries requiring inspection.</strong><div ng-if=\"vm.inspectionDeliveries.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"inspections\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-3 text-nowrap\">Purchase Order</th><th class=\"col-xs-2 text-nowrap\">Supplier</th><th class=\"col-xs-2 text-nowrap\">Supplier Reference</th><th class=\"col-xs-1 text-nowrap\">Date</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"delivery in vm.inspectionDeliveries | orderBy: number | itemsPerPage: 15\" pagination-id=\"inspections\"><td><a ui-sref=\"deliveries.details({id:delivery.id})\">{{ delivery.number }}</a></td><td>{{ delivery.purchaseOrderNumber }}</td><td>{{ delivery.supplierName }}</td><td>{{ delivery.supplierDeliveryNumber }}</td><td>{{ delivery.date | date:\'dd-MMM-yyyy\' }}</td><td>{{ delivery.createdBy }}</td><td>{{ delivery.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"inspections\"></dir-pagination-controls></div></div></uib-tab><uib-tab active=\"vm.tabs.osdActive\" ui-sref=\"deliveries.view.osd\"><uib-tab-heading><i class=\"fa fa-warning\"></i>OS&D <span class=\"badge label-primary\">{{ vm.potentialOverageDeliveries.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.potentialOverageDeliveries.length\">There are no deliveries requiring OS&D.</strong><div ng-if=\"vm.potentialOverageDeliveries.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"potentialOverage\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-3 text-nowrap\">Purchase Order</th><th class=\"col-xs-2 text-nowrap\">Supplier</th><th class=\"col-xs-2 text-nowrap\">Supplier Reference</th><th class=\"col-xs-1 text-nowrap\">Date</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"delivery in vm.potentialOverageDeliveries | orderBy: number | itemsPerPage: 15\" pagination-id=\"potentialOverage\"><td><a ui-sref=\"deliveries.details({id:delivery.id})\">{{ delivery.number }}</a></td><td>{{ delivery.purchaseOrderNumber }}</td><td>{{ delivery.supplierName }}</td><td>{{ delivery.supplierDeliveryNumber }}</td><td>{{ delivery.date | date:\'dd-MMM-yyyy\' }}</td><td>{{ delivery.createdBy }}</td><td>{{ delivery.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"potentialOverage\"></dir-pagination-controls></div></div></uib-tab><uib-tab active=\"vm.tabs.storingActive\" ui-sref=\"deliveries.view.storing\"><uib-tab-heading><i class=\"fa fa-archive\"></i>Storing <span class=\"badge label-primary\">{{ vm.storingDeliveries.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.storingDeliveries.length\">There are no deliveries being stored.</strong><div ng-if=\"vm.storingDeliveries.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"storing\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-3 text-nowrap\">Purchase Order</th><th class=\"col-xs-2 text-nowrap\">Supplier</th><th class=\"col-xs-2 text-nowrap\">Supplier Reference</th><th class=\"col-xs-1 text-nowrap\">Date</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"delivery in vm.storingDeliveries | orderBy: number | itemsPerPage: 15\" pagination-id=\"storing\"><td><a ui-sref=\"deliveries.details({id:delivery.id})\">{{ delivery.number }}</a></td><td>{{ delivery.purchaseOrderNumber }}</td><td>{{ delivery.supplierName }}</td><td>{{ delivery.supplierDeliveryNumber }}</td><td>{{ delivery.date | date:\'dd-MMM-yyyy\' }}</td><td>{{ delivery.createdBy }}</td><td>{{ delivery.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"storing\"></dir-pagination-controls></div></div></uib-tab><uib-tab active=\"vm.tabs.storedActive\" ui-sref=\"deliveries.view.stored\"><uib-tab-heading><i class=\"fa fa-check\"></i>Stored <span class=\"badge label-primary\">{{ vm.storedDeliveries.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.storedDeliveries.length\">There are no deliveries stored.</strong><div ng-if=\"vm.storedDeliveries.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"stored\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-3 text-nowrap\">Purchase Order</th><th class=\"col-xs-2 text-nowrap\">Supplier</th><th class=\"col-xs-2 text-nowrap\">Supplier Reference</th><th class=\"col-xs-1 text-nowrap\">Date</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"delivery in vm.storedDeliveries | orderBy: number | itemsPerPage: 15\" pagination-id=\"stored\"><td><a ui-sref=\"deliveries.details({id:delivery.id})\">{{ delivery.number }}</a></td><td>{{ delivery.purchaseOrderNumber }}</td><td>{{ delivery.supplierName }}</td><td>{{ delivery.supplierDeliveryNumber }}</td><td>{{ delivery.date | date:\'dd-MMM-yyyy\' }}</td><td>{{ delivery.createdBy }}</td><td>{{ delivery.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"stored\"></dir-pagination-controls></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/expediting/oneWeekExpediting.html","<div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><div class=\"row\"><div class=\"col-xs-12\"><h5 class=\"m-t-none m-b\">{{vm.title}} <span class=\"badge label-primary\" ng-if=\"vm.lines.length && !vm.loading\">{{ vm.lines.length }}</span></h5></div></div><div class=\"ibox-tools\"></div></div><div class=\"ibox-content\"><div ng-if=\"vm.lines.length && !vm.loading\" class=\"animated fadeIn\"><div class=\"table-responsive\"><table class=\"table materia-grouped-row\"><thead><tr><th class=\"col-xs-1 text-nowrap\">PO No/Item</th><th class=\"col-xs-2 text-nowrap\">Supplier</th><th class=\"col-xs-1 text-nowrap\">Ordered</th><th class=\"col-xs-1 text-nowrap\">Received</th><th class=\"col-xs-1 text-nowrap\">Promised Date</th><th class=\"col-xs-1 text-nowrap\">Eta Date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\" dir-paginate=\"line in vm.lines | orderBy: number | orderBy: poLineNumber | itemsPerPage: 5\" pagination-id=\"vm.timeInterval\"><tr><td colspan=\"8\" class=\"item-description\"><a ui-sref=\"purchase-orders.details({id:line.purchaseOrderId})\">{{line.description | uppercase}}</a></td></tr><tr><td><a ui-sref=\"purchase-orders.details({id:line.purchaseOrderId})\">{{ line.poNumber }}/{{ line.poLineNumber }}</a></td><td>{{ line.supplierName }}</td><td>{{ line.orderedQuantity }} {{ line.unitOfMeasureCode }}</td><td>{{ line.quantityReceived }}</td><td>{{ line.promisedDate | date:\'dd-MMM-yyyy\' }}</td><td>{{ line.etaDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table></div><dir-pagination-controls boundary-links=\"true\" pagination-id=\"vm.timeInterval\"></dir-pagination-controls></div><div ng-if=\"!vm.lines.length && !vm.loading\" class=\"animated fadeIn\"><strong>There are no {{vm.title}}.</strong></div><div class=\"sk-spinner sk-spinner-three-bounce\" ng-if=\"vm.loading\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div></div>");
$templateCache.put("app/expediting/viewExpediting.html","<div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ViewExpeditingCtrl as vm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row add-pd-b\"><div class=\"col-lg-12\"><form role=\"form\" name=\"inspectionsFilter\"><div class=\"ibox-title\"><h5>Expediting filters</h5></div><div class=\"ibox-content\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3\"><label class=\"control-label\" for=\"buyerName\">Buyer</label><select kendo-combo-box=\"\" k-options=\"vm.buyerNameOptions\" ng-model=\"vm.buyerNameSelected\" k-ng-delay=\"vm.buyerNameSelected\" name=\"buyerName\" id=\"buyerName\" class=\"form-control\"></select></div><div class=\"col-md-3\"><label class=\"control-label\" for=\"timeInterval\">Arriving within</label><select kendo-combo-box=\"\" k-options=\"vm.timeIntervalOptions\" k-ng-model=\"vm.timeInterval\" name=\"timeInterval\" id=\"timeInterval\" class=\"form-control\"></select></div><div class=\"col-md-3\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" ng-model=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\"></select></div><div class=\"col-md-2 label-pad\"><button type=\"button\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-click=\"vm.getPurchaseOrderLinesForExpediting()\">Go!</button></div></div></div></div></form></div></div><div class=\"ibox-title\"><h3>{{vm.lines.length}} items for \"{{vm.lastTime}}\" for buyer \"{{vm.lastBuyer ? vm.lastBuyer : \'ALL\'}}\" {{vm.lastPO ? \' on purchase order \"\' + vm.lastPO + \'\"\' : \'\'}}.</h3></div><div class=\"ibox-content\"><div class=\"panel-body\"><strong ng-if=\"!vm.lines.length && !vm.loading\">There are no items in the selected dates.</strong><div ng-if=\"vm.lines.length && !vm.loading\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"lines\"></dir-pagination-controls><table class=\"table materia-grouped-row\"><thead><tr><th class=\"col-xs-1 text-nowrap\">PO No/Item</th><th>Supplier</th><th>Ordered</th><th>Received</th><th>UOM</th><th class=\"col-xs-1 text-nowrap\">Material Code</th><th class=\"col-xs-1 text-nowrap\">Cost Code</th><th>Buyer</th><th class=\"col-xs-1 text-nowrap\">Promised Date</th><th class=\"col-xs-1 text-nowrap\">ETA Date</th><th class=\"col-xs-1 text-nowrap\">Follow up Date</th><th>Expediting comments</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\" dir-paginate=\"line in vm.lines | orderBy: \'number\' | orderBy: poLineNumber | itemsPerPage: 15\" pagination-id=\"lines\"><tr><td colspan=\"12\" class=\"item-description\"><a ui-sref=\"purchase-orders.details({id:line.purchaseOrderId})\">{{line.description | uppercase}}</a></td></tr><tr><td><a ui-sref=\"purchase-orders.details({id:line.purchaseOrderId})\">{{ line.poNumber }}/{{ line.poLineNumber }}</a></td><td>{{ line.supplierName }}</td><td>{{ line.orderedQuantity }}</td><td>{{ line.quantityReceived }}</td><td>{{ line.unitOfMeasureCode }}</td><td>{{ line.materialCode }}</td><td>{{ line.costCode }}</td><td>{{ line.buyerName }}</td><td>{{ line.promisedDate | date:\'dd-MMM-yyyy\' }}</td><td>{{ line.etaDate | date:\'dd-MMM-yyyy\' }}</td><td>{{ line.followUpDate | date:\'dd-MMM-yyyy\' }}</td><td>{{ line.expeditingComments }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"lines\"></dir-pagination-controls></div><div class=\"sk-spinner sk-spinner-three-bounce\" ng-if=\"vm.loading\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div></div></div></div></div></div>");
$templateCache.put("app/inspections/viewInspections.html","<div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ViewInspectionsCtrl as vm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row add-pd-b\"><div class=\"col-lg-12\"><form role=\"form\" name=\"inspectionsFilter\"><div class=\"ibox-title\"><h5>Vendor Inspection filters {{ vm.tabs.index }}</h5></div><div class=\"ibox-content\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3\"><label class=\"control-label\" for=\"supplier\">Supplier</label><select kendo-combo-box=\"\" k-options=\"vm.supplierOptions\" k-ng-model=\"vm.supplierSelected\" k-ng-delay=\"vm.supplierSelected\" name=\"supplier\" id=\"supplier\" class=\"form-control\" ng-disabled=\"vm.activeTab === \'completed\'\"></select></div><div class=\"col-md-3\"><label class=\"control-label\" for=\"timeInterval\">Promised within</label><select kendo-combo-box=\"\" k-options=\"vm.timeIntervalOptions\" k-ng-model=\"vm.timeInterval\" name=\"timeInterval\" id=\"timeInterval\" class=\"form-control\" ng-disabled=\"vm.activeTab === \'completed\'\"></select></div><div class=\"col-md-3\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" ng-model=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" ng-disabled=\"vm.activeTab === \'completed\'\"></select></div><div class=\"col-md-3 label-pad\"><button type=\"button\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-click=\"vm.getVendorInspectionsIncomplete()\" ng-disabled=\"vm.activeTab === \'completed\'\">Go!</button></div></div></div></div></form></div></div><div class=\"tabs-container\"><uib-tabset><uib-tab ng-click=\"vm.setActiveTab(\'incomplete\')\"><uib-tab-heading><i class=\"fa fa-warning\"></i>Incomplete <span class=\"badge label-warning\">{{vm.incompleteInspections.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.incompleteInspections.length\">There are no items promised within \"{{vm.lastTime}}\" for supplier \"{{vm.lastSupplier}}\".</strong><div ng-if=\"vm.incompleteInspections.length\"><h4>{{vm.incompleteInspections.length}} items promised within \"{{vm.lastTime}}\" for supplier \"{{vm.lastSupplier}}\".</h4><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">PO No/Item</th><th class=\"col-xs-4 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Supplier</th><th class=\"col-xs-1 text-nowrap visible-lg\">Ordered</th><th class=\"col-xs-1 text-nowrap\">Outstanding</th><th class=\"col-xs-1 text-nowrap\">UOM</th><th class=\"col-xs-1 text-nowrap\">Material Code</th><th class=\"col-xs-1 text-nowrap hidden-sm\">Cost Code</th><th class=\"col-xs-1 text-nowrap\">Promised Date</th><th></th></tr></thead><tbody><tr dir-paginate=\"line in vm.incompleteInspections | orderBy: [\'poNumber\', natural(\'poLineNumber\')] | itemsPerPage: 15\" pagination-id=\"incomplete\"><td>{{ line.poNumber }}/{{ line.poLineNumber }}</td><td>{{ line.description }}</td><td>{{ line.supplierName }}</td><td class=\"visible-lg\">{{ line.orderedQuantity }}</td><td>{{ line.quantityRequiringInspection }}</td><td>{{ line.unitOfMeasureCode }}</td><td>{{ line.materialCode }}</td><td class=\"hidden-sm\">{{ line.costCode }}</td><td>{{ line.promisedDate | date:\'dd-MMM-yyyy\' }}</td><td><wg-add-inspection item=\"line\" is-vendor-inspection=\"true\" post-update-delegate=\"vm.inspectionCompleted(id, passedQuantity)\" max-inspection-quantity=\"line.quantityRequiringInspection\"></wg-add-inspection></td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls></div></div></uib-tab><uib-tab ng-click=\"vm.setActiveTab(\'completed\')\"><uib-tab-heading><i class=\"fa fa-check-square-o\"></i>Completed <span class=\"badge label-primary\">{{ vm.completedInspections.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.completedInspections.length\">There are no completed inspections.</strong><div ng-if=\"vm.completedInspections.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completed\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">PO No/Item</th><th class=\"col-xs-4 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Supplier</th><th class=\"col-xs-1 text-nowrap\">Ordered</th><th class=\"col-xs-1 text-nowrap\">Passed</th><th class=\"col-xs-1 text-nowrap\">UOM</th><th class=\"col-xs-1 text-nowrap\">Material Code</th><th class=\"col-xs-1 text-nowrap\">Cost Code</th><th></th></tr></thead><tbody class=\"rowlink\"><tr dir-paginate=\"line in vm.completedInspections | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"completed\"><td><a ui-sref=\"inspection.details({id:line.id})\">{{ line.poNumber }}/{{ line.poLineNumber }}</a></td><td>{{ line.description }}</td><td>{{ line.supplierName }}</td><td>{{ line.orderedQuantity }}</td><td>{{ line.quantityPassedInspection }}</td><td>{{ line.unitOfMeasureCode }}</td><td>{{ line.materialCode }}</td><td>{{ line.costCode }}</td><td><wg-view-vendor-inspection-history id=\"line.id\"></wg-view-vendor-inspection-history></td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completed\"></dir-pagination-controls></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/inspections/viewVendorInspectionHistory.html","<button class=\"btn btn-primary\" ng-click=\"vm.openHistory()\">Details</button>");
$templateCache.put("app/inspections/viewVendorInspectionHistoryModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Inspection history - {{vm.item.materialCode}}</h4><h4>{{vm.item.supplierName}}</h4><small class=\"font-bold\">{{vm.item.description | uppercase}}</small></div><div class=\"modal-body p-b-xxs\"><div class=\"sk-spinner sk-spinner-three-bounce\" ng-if=\"vm.loading\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div><div id=\"vertical-timeline\" class=\"vertical-container light-timeline\"><div class=\"vertical-timeline-block\" ng-repeat=\"item in vm.items\"><div class=\"vertical-timeline-icon navy-bg\"><i class=\"fa fa-check-square-o\"></i></div><div class=\"vertical-timeline-content\"><h4>Inspected: {{ item.quantityInspected }} | <span class=\"text-navy\">Passed: {{ item.quantityPassed }}</span> | <span class=\"text-danger\">Failed: {{ item.quantityFailed }}</span></h4><p>{{ item.comments }}</p><div class=\"alert alert-info\" ng-if=\"item.osdStatusId === 3\"><h5>OS&D #{{ item.osdNumber }}</h5><p>{{ item.osdComments }}</p>{{ item.osdCompletedBy }}<br><small>Completed <span am-time-ago=\"item.createdDate\" title=\"{{item.osdCompletedDate | date:\'dd-MMM-yyyy HH:mm\'}}\"></span></small></div><div class=\"alert alert-danger\" ng-if=\"item.osdStatusId === 1\"><h5>OS&D #{{ item.osdNumber }} - Unresolved.</h5></div><span class=\"vertical-date\">{{ item.createdBy }}<br><small am-time-ago=\"item.createdDate\" title=\"{{item.createdDate | date:\'dd-MMM-yyyy HH:mm\'}}\"></small></span></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button></div></div>");
$templateCache.put("app/manifests/addContainerModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-ship modal-icon\"></i><h4 class=\"modal-title\">Add container</h4></div><div class=\"modal-body p-b-xxs\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Container</label><div class=\"col-lg-8\"><input required=\"\" ng-model=\"vm.container\" class=\"form-control k-textbox\" ng-disabled=\"vm.saved\"></div></div><div class=\"hr-line-dashed\"></div><table class=\"table materia-grouped-row\"><tbody ng-repeat=\"item in vm.items | orderBy: \'description\'\"><tr ng-class=\"item.class\"><td colspan=\"7\" class=\"item-description\">{{item.description | uppercase}}</td></tr><tr ng-class=\"item.class\"><td>{{item.documentNumber}}</td><td ng-if=\"!vm.bagAndTag\">{{item.purchaseOrderNumber}} / {{item.purchaseOrderLineNumber}}</td><td ng-if=\"!vm.bagAndTag\">{{item.costCode}}</td><td ng-if=\"!vm.bagAndTag\" class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ item.materialCode }}</pre></td><td ng-if=\"!vm.bagAndTag\" class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\" ng-if=\"item.barcode.length\">{{ item.barcode }}</pre><span ng-if=\"!item.barcode.length\">n/a</span></td><td ng-if=\"vm.bagAndTag\">{{item.number}}</td><td ng-if=\"vm.bagAndTag\">{{item.workpackNumber}}</td><td>{{item.container}}</td><td ng-if=\"!vm.bagAndTag\">{{item.quantity}}</td></tr></tbody></table></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Successfully added container to items.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error adding container to items.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.container == \'\' || vm.saved\">Add container</button></div></div>");
$templateCache.put("app/manifests/addManifestLineItem.html","<button class=\"btn btn-success\" ng-click=\"vm.openAddLineItem()\" title=\"Add a new line item\"><i class=\"fa fa-plus\"></i> Add line item</button>");
$templateCache.put("app/manifests/addManifestLineItemModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-ship modal-icon\"></i><h4 class=\"modal-title\" ng-if=\"vm.isAdd\">Add line item</h4><h4 class=\"modal-title\" ng-if=\"!vm.isAdd\">Edit line item</h4></div><div class=\"modal-body p-b-xxs transfer-bag-and-tag\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">PO number / ID</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.purchaseOrderNumber\" ng-disabled=\"vm.isReadOnly\"></div><label class=\"col-lg-2 control-label\">Quantity *</label><div class=\"col-lg-4\"><input type=\"text\" required=\"\" numeric-only=\"\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.quantity\" ng-disabled=\"vm.isReadOnly\" style=\"width: 100%\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Line number</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-disabled=\"vm.isReadOnly\" ng-model=\"vm.lineItem.purchaseOrderLineNumber\"></div><label class=\"col-lg-2 control-label\">UOM *</label><div class=\"col-lg-4\"><select kendo-combo-box=\"\" k-options=\"vm.unitsOfMeasureOptions\" required=\"\" ng-model=\"vm.lineItem.unitOfMeasureCode\" k-ng-delay=\"vm.lineItem.unitOfMeasureCode\" name=\"unitsOfMeasure\" style=\"width:100%\" ng-disabled=\"vm.saving || vm.isReadOnly\"></select></div></div><div class=\"form-group\"><label class=\"col-lg-6\"></label> <label class=\"col-lg-2 control-label\">Price *</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.price\" ng-disabled=\"vm.isReadOnly\" placeholder=\"0.00\" style=\"width: 100%\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" required=\"\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Description *</label><div class=\"col-lg-10\"><textarea required=\"\" type=\"text\" class=\"form-control\" style=\"resize: none; width: 100%\" ng-model=\"vm.lineItem.description\" name=\"itemDescription\" rows=\"4\" ng-disabled=\"vm.isReadOnly\" ng-class=\"{ \'has-error\' : save.itemDescription.$invalid && !save.itemDescription.$pristine }\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Material code</label><div class=\"col-lg-4\"><select kendo-combo-box=\"\" k-options=\"vm.materialCodesOptions\" ng-model=\"vm.lineItem.materialCode\" k-ng-delay=\"vm.lineItem.materialCode\" name=\"materialCodes\" style=\"width:100%\" ng-disabled=\"vm.saving || vm.isReadOnly\"></select></div><label class=\"col-lg-2 control-label\">Cost code</label><div class=\"col-lg-4\"><select kendo-combo-box=\"\" k-options=\"vm.costCodesOptions\" ng-model=\"vm.lineItem.costCode\" k-ng-delay=\"vm.lineItem.costCode\" name=\"costCodes\" style=\"width:100%\" ng-disabled=\"vm.saving || vm.isReadOnly\"></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Barcode</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.barcode\" ng-disabled=\"vm.isReadOnly\"></div><label class=\"col-lg-2 control-label\">Container</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.container\" ng-disabled=\"vm.isReadOnly\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Ref Doc</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.refDoc\" ng-disabled=\"vm.isReadOnly\"></div><label class=\"col-lg-2 control-label\">Workpack</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.workpack\" ng-disabled=\"vm.isReadOnly\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">SWEU Value</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.sweuValue\" ng-disabled=\"vm.isReadOnly\"></div><label class=\"col-lg-2 control-label\">Add Date</label><div class=\"col-lg-4\"><div class=\"input-group date\"><input type=\"text\" name=\"addDate\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'addDate\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.lineItem.addDate\" is-open=\"vm.calendar.opened.addDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" placeholder=\"Enter Add Date\" ng-disabled=\"vm.isReadOnly\" ng-class=\"{ \'has-error\' : saveForm.addDate.$invalid && !saveForm.addDate.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'addDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">HS Commodity Code</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.commodityCode\" ng-disabled=\"vm.isReadOnly\"></div><label class=\"col-lg-2 control-label\">Box Number</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.boxNumber\" ng-disabled=\"vm.isReadOnly\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Origin</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.origin\" ng-disabled=\"vm.isReadOnly\"></div><label class=\"col-lg-2 control-label\">Customs Status</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.customsStatus\" ng-disabled=\"vm.isReadOnly\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">FCG Value</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.fcgValue\" ng-disabled=\"vm.isReadOnly\"></div><label class=\"col-lg-2 control-label\">Unloading Point</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.unloadingPoint\" ng-disabled=\"vm.isReadOnly\"></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Item successfully saved.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error saving the item.</div><span class=\"pr20\" ng-if=\"vm.isAdd\"><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.addAnother\"> Add another</span> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-if=\"!vm.isReadOnly\" ng-disabled=\"saveForm.$invalid\">Save</button></div></div>");
$templateCache.put("app/manifests/customsStatus.html","<form role=\"form\" name=\"customs\"><div class=\"row\"><div class=\"col-md-12\"><button ladda=\"vm.loading\" type=\"submit\" class=\"btn btn-primary m-t-n-xs\" ng-if=\"!vm.manifest.isReadOnly\" ng-disabled=\"details.$invalid\" ng-click=\"vm.saveCustomsStatus()\"><i class=\"fa fa-check\"></i> Save Customs Status</button></div></div><div class=\"ibox\"></div><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : customs.customsType.$invalid && !customs.customsType.$pristine }\"><label class=\"control-label\" for=\"customsType\">Customs Type</label><select kendo-combo-box=\"\" ng-model=\"vm.manifest.customsType\" class=\"form-control\" name=\"customsType\" id=\"customsType\" ng-readonly=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : customs.customsType.$invalid && !customs.customsType.$pristine }\"><option value=\"\" selected=\"\" ng-disabled=\"true\">Select customs type</option><option value=\"IMPORT\">IMPORT</option><option value=\"EXPORT\">EXPORT</option><option value=\"DIRECT\">DIRECT</option></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : customs.agentRefNo.$invalid && !customs.agentRefNo.$pristine }\"><label class=\"control-label\" for=\"agentRefNo\">Agent Ref No</label> <input class=\"form-control k-textbox\" name=\"agentRefNo\" id=\"agentRefNo\" ng-readonly=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : customs.agentRefNo.$invalid && !customs.agentRefNo.$pristine }\" ng-model=\"vm.manifest.agentRefNo\" placeholder=\"Enter Agent Ref No\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : customs.declaration.$invalid && !customs.declaration.$pristine }\"><label class=\"control-label\" for=\"agentRefNo\">Declaration</label> <input class=\"form-control k-textbox\" name=\"declaration\" id=\"declaration\" ng-readonly=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : customs.declaration.$invalid && !customs.declaration.$pristine }\" ng-model=\"vm.manifest.declaration\" placeholder=\"Enter Declaration\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : customs.awb.$invalid && !customs.awb.$pristine }\"><label class=\"control-label\" for=\"awb\">AWB</label> <input class=\"form-control k-textbox\" name=\"awb\" id=\"awb\" ng-readonly=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : customs.awb.$invalid && !customs.awb.$pristine }\" ng-model=\"vm.manifest.awb\" placeholder=\"Enter AWB\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : customs.clearanceDate.$invalid && !customs.clearanceDate.$pristine }\"><label class=\"control-label\" for=\"clearanceDate\">Clearance Date</label><div class=\"input-group date\"><input type=\"text\" name=\"clearanceDate\" id=\"clearanceDate\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'clearanceDate\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.manifest.clearanceDate\" is-open=\"vm.calendar.opened.clearanceDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" ng-readonly=\"vm.manifest.isReadOnly\" ng-disabled=\"vm.manifest.isReadOnly\" placeholder=\"Enter Clearance Date\" ng-class=\"{ \'has-error\' : customs.clearanceDate.$invalid && !customs.clearanceDate.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'clearanceDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"customsComplete\">Customs Complete?</label> <input class=\"form-control\" icheck=\"\" type=\"checkbox\" name=\"customsComplete\" id=\"customsComplete\" ng-readonly=\"vm.manifest.isReadOnly\" ng-disabled=\"vm.manifest.isReadOnly\" ng-model=\"vm.manifest.customsComplete\" checked=\"vm.manifest.customsComplete\"> <label class=\"control-label\" for=\"tempImport\">Temp Import?</label> <input class=\"form-control\" icheck=\"\" type=\"checkbox\" name=\"tempImport\" id=\"tempImport\" ng-readonly=\"vm.manifest.isReadOnly\" ng-disabled=\"vm.manifest.isReadOnly\" ng-model=\"vm.manifest.tempImport\" checked=\"vm.manifest.tempImport\"></div></div></div></form>");
$templateCache.put("app/manifests/importItems.html","<div><form role=\"form\" name=\"addressForm\"><div class=\"row\"><div class=\"col-md-12\"><button ladda=\"vm.loading\" type=\"submit\" class=\"btn btn-primary m-t-n-xs\" ng-if=\"!vm.manifest.isReadOnly\" ng-click=\"vm.downloadTemplate()\"><i class=\"fa fa-download\"></i> Download template</button></div></div><div class=\"ibox\"></div><div class=\"row\"><div class=\"dz-container dropzone border-dashed\" dropzone=\"\" parent-id=\"vm.manifestId\" import-endpoint=\"vm.importEndpoint\" get-import-errors=\"vm.getImportErrors(parentId, documentKey)\" id=\"dropzone\"><div class=\"dz-message\"><h4><i class=\"fa fa-upload fa-lg\"></i> Drop files here or click to upload</h4></div><div id=\"previews\"><div id=\"template\" class=\"dz-file-preview\"><div class=\"dz-file-preview-top\"><div id=\"upload-image\" class=\"dz-image\"><span class=\"preview\"><img data-dz-thumbnail=\"\"></span></div><div id=\"upload-info\" class=\"dz-info-upload\"><p class=\"dz-name\" data-dz-name=\"\"></p><p class=\"size\" data-dz-size=\"\"></p><strong class=\"error text-danger\" data-dz-errormessage=\"\"></strong></div><div class=\"dz-remove\"><button data-dz-remove=\"\" class=\"btn btn-danger delete pull-right\"><i class=\"fa fa-times\"></i></button></div><div class=\"progress progress-striped active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" aria-valuenow=\"0\" id=\"progressBar\" style=\"width: 100%; height: 5px; position: absolute; bottom: 0px; margin-top: 10px;\"><div class=\"progress-bar progress-bar-success\" style=\"width:0%;\" data-dz-uploadprogress=\"\"></div></div></div><div class=\"dz-file-preview-bottom\"></div></div></div></div></div></form></div>");
$templateCache.put("app/manifests/includedItemManifest.html","<tr ng-class=\"vm.item.class\" ng-click=\"vm.openModal()\"><td colspan=\"9\" class=\"item-description\">{{vm.item.description | uppercase}}</td></tr><tr ng-class=\"vm.item.class\" class=\"remove-border\" ng-click=\"vm.openModal()\"><td><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.isIncluded\" ng-disabled=\"vm.isReadOnly\"></td><td><span ng-if=\"vm.item.isDualUse\"><i class=\"fa fa-warning text-danger\" title=\"Item is identified as being Dual Use\"></i></span> {{vm.item.refDoc}}</td><td>{{vm.item.purchaseOrderNumber}} / {{vm.item.purchaseOrderLineNumber}}</td><td>{{vm.item.barcode}}</td><td>{{vm.item.container}}</td><td>{{vm.item.quantity}}</td><td ng-if=\"!vm.isReadOnly\"><button type=\"button\" class=\"btn btn-danger btn-sm pull-right\" ng-click=\"vm.removeItem(vm.item)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button></td></tr>");
$templateCache.put("app/manifests/manifestItems.html","<div class=\"col-lg-7 b-r\" ng-if=\"!vm.manifest.isReadOnly\"><wg-search-criteria-manifest results=\"vm.results\" bag-and-tag-results=\"vm.bagAndTagResults\" manifest-results=\"vm.manifestResults\" movement-results=\"vm.movementResults\" tabs=\"vm.tabs\" filter=\"vm.filter\"></wg-search-criteria-manifest><div class=\"panel-title remove-pd-b\" ng-if=\"vm.results !== undefined || vm.bagAndTagResults != undefined || vm.manifestResults != undefined || vm.movementResults != undefined\"><div class=\"tabs-container items-container add-pd-b\"><uib-tabset><uib-tab active=\"vm.tabs.issuesResultsActive\" ng-if=\"vm.results.issues.length\"><uib-tab-heading>Issues <span class=\"badge label-info\">{{vm.results.issues.length ? vm.results.issues.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results.issues\"><div class=\"btn-toolbar add-pd-b\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.addIssueItems((vm.results.issues | greaterThanZero: 0))\" ng-disabled=\"!(vm.results.issues | greaterThanZero: 0).length || (vm.results.issues | invalidQuantity:0).length\">Add selected to manifest</button></div><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ts-wrapper=\"\"><thead><tr><th><span><input type=\"checkbox\" ng-model=\"vm.selectAllIssues\" icheck-all=\"vm.results.issues.isIncluded\"></span></th><th ts-criteria=\"issueNumber\" ts-default=\"\">Issue</th><th ts-criteria=\"(poNumber + \'/\' + poLineNumber)|natural\" ts-default=\"\">PO / Item</th><th ts-criteria=\"costCode\">Cost code</th><th ts-criteria=\"materialCode\">Material code</th><th ts-criteria=\"barcode\">Barcode</th><th ts-criteria=\"unitOfMeasureCode\">UOM</th><th ts-criteria=\"locationName\">Location</th><th ts-criteria=\"quantity|parseFloat\">Issue Qty</th><th ts-criteria=\"selectedQuantity|parseFloat\">Manifest Qty</th><th></th></tr></thead><tbody ng-repeat=\"item in vm.results.issues\" item=\"item\" ts-repeat=\"\" wg-stored-item-manifest=\"\" add-item=\"vm.addStockItem(item)\" highlight=\"vm.filter\"></tbody></table></div></div><div ng-show=\"!vm.results.issues.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.returnsResultsActive\" ng-if=\"vm.results.returns.length\"><uib-tab-heading>Returns <span class=\"badge label-info\">{{vm.results.returns.length ? vm.results.returns.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results.returns\"><div class=\"btn-toolbar add-pd-b\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.addReturnItems((vm.results.returns | greaterThanZero: 0))\" ng-disabled=\"!(vm.results.returns | greaterThanZero: 0).length || (vm.results.returns | invalidQuantity:0).length\">Add selected to manifest</button></div><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ts-wrapper=\"\"><thead><tr><th><span><input type=\"checkbox\" ng-model=\"vm.selectAllReturns\" icheck-all=\"vm.results.returns.isIncluded\"></span></th><th ts-criteria=\"documentNumber\" ts-default=\"\">Return</th><th ts-criteria=\"issueNumber\">Issue</th><th ts-criteria=\"(poNumber + \'/\' + poLineNumber)|natural\" ts-default=\"\">PO / Item</th><th ts-criteria=\"costCode\">Cost code</th><th ts-criteria=\"materialCode\">Material code</th><th ts-criteria=\"barcode\">Barcode</th><th ts-criteria=\"unitOfMeasureCode\">UOM</th><th ts-criteria=\"locationName\">Location</th><th ts-criteria=\"quantity|parseFloat\">Return Qty</th><th ts-criteria=\"selectedQuantity|parseFloat\">Manifest Qty</th><th></th></tr></thead><tbody ng-repeat=\"item in vm.results.returns\" item=\"item\" ts-repeat=\"\" wg-stored-item-manifest=\"\" add-item=\"vm.addStockItem(item)\" highlight=\"vm.filter\" is-return=\"true\"></tbody></table></div></div><div ng-show=\"!vm.results.returns.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.transfersResultsActive\" ng-if=\"vm.results.transfers.length\"><uib-tab-heading>Transfers <span class=\"badge label-info\">{{vm.results.transfers.length ? vm.results.transfers.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results.transfers\"><div class=\"btn-toolbar add-pd-b\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.addTransferItems((vm.results.transfers | greaterThanZero: 0))\" ng-disabled=\"!(vm.results.transfers | greaterThanZero: 0).length || (vm.results.transfers | invalidQuantity:0).length\">Add selected to manifest</button></div><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ts-wrapper=\"\"><thead><tr><th><span><input type=\"checkbox\" ng-model=\"vm.selectAllTransfers\" icheck-all=\"vm.results.transfers.isIncluded\"></span></th><th ts-criteria=\"documentNumber\" ts-default=\"\">Transfer</th><th ts-criteria=\"(poNumber + \'/\' + poLineNumber)|natural\" ts-default=\"\">PO / Item</th><th ts-criteria=\"costCode\">Cost code</th><th ts-criteria=\"materialCode\">Material code</th><th ts-criteria=\"barcode\">Barcode</th><th ts-criteria=\"unitOfMeasureCode\">UOM</th><th ts-criteria=\"locationName\">Location</th><th ts-criteria=\"quantity|parseFloat\">Transfer Qty</th><th ts-criteria=\"selectedQuantity|parseFloat\">Manifest Qty</th><th></th></tr></thead><tbody ng-repeat=\"item in vm.results.transfers\" item=\"item\" ts-repeat=\"\" wg-stored-item-manifest=\"\" add-item=\"vm.addStockItem(item)\" highlight=\"vm.filter\"></tbody></table></div></div><div ng-show=\"!vm.results.transfers.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.deliveriesResultsActive\" ng-if=\"vm.results.deliveries.length\"><uib-tab-heading>Deliveries <span class=\"badge label-info\">{{vm.results.deliveries.length ? vm.results.deliveries.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results.deliveries\"><div class=\"btn-toolbar add-pd-b\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.addDeliveryItems((vm.results.deliveries | greaterThanZero: 0))\" ng-disabled=\"!(vm.results.deliveries | greaterThanZero: 0).length || (vm.results.deliveries | invalidQuantity:0).length\">Add selected to manifest</button></div><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ts-wrapper=\"\"><thead><tr><th><span><input type=\"checkbox\" ng-model=\"vm.selectAllDeliveries\" icheck-all=\"vm.results.deliveries.isIncluded\"></span></th><th ts-criteria=\"documentNumber\" ts-default=\"\">Delivery</th><th ts-criteria=\"(poNumber + \'/\' + poLineNumber)|natural\" ts-default=\"\">PO / Item</th><th ts-criteria=\"costCode\">Cost code</th><th ts-criteria=\"materialCode\">Material code</th><th ts-criteria=\"barcode\">Barcode</th><th ts-criteria=\"unitOfMeasureCode\">UOM</th><th ts-criteria=\"quantity|parseFloat\">Checked Qty</th><th ts-criteria=\"selectedQuantity|parseFloat\">Manifest Qty</th><th></th></tr></thead><tbody ng-repeat=\"item in vm.results.deliveries\" item=\"item\" ts-repeat=\"\" wg-stored-item-manifest=\"\" add-item=\"vm.addStockItem(item)\" delivery=\"true\" highlight=\"vm.filter\"></tbody></table></div></div><div ng-show=\"!vm.results.deliveries.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.purchaseOrdersResultsActive\" ng-if=\"vm.results.purchaseOrders.length\"><uib-tab-heading>Purchase Orders <span class=\"badge label-info\">{{vm.results.purchaseOrders.length ? vm.results.purchaseOrders.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results.purchaseOrders\"><div class=\"btn-toolbar add-pd-b\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.addPurchaseOrderItems((vm.results.purchaseOrders | greaterThanZero: 0))\" ng-disabled=\"!(vm.results.purchaseOrders | greaterThanZero: 0).length || (vm.results.purchaseOrders | invalidQuantity:0).length\">Add selected to manifest</button></div><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ts-wrapper=\"\"><thead><tr><th><span><input type=\"checkbox\" ng-model=\"vm.selectAllPurchaseOrders\" icheck-all=\"vm.results.purchaseOrders.isIncluded\"></span></th><th ts-criteria=\"documentNumber\" ts-default=\"\">PO Number</th><th ts-criteria=\"(poNumber + \'/\' + poLineNumber)|natural\" ts-default=\"\">PO / Item</th><th ts-criteria=\"costCode\">Cost code</th><th ts-criteria=\"materialCode\">Material code</th><th ts-criteria=\"unitOfMeasureCode\">UOM</th><th ts-criteria=\"quantity|parseFloat\">Ordered Qty</th><th ts-criteria=\"selectedQuantity|parseFloat\">Manifest Qty</th><th></th></tr></thead><tbody ng-repeat=\"item in vm.results.purchaseOrders\" item=\"item\" ts-repeat=\"\" wg-stored-item-manifest=\"\" add-item=\"vm.addStockItem(item)\" purchase-order=\"true\" highlight=\"vm.filter\"></tbody></table></div></div><div ng-show=\"!vm.results.purchaseOrders.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.manifestsResultsActive\" ng-if=\"vm.manifestResults.length\"><uib-tab-heading>Manifests <span class=\"badge label-info\">{{vm.manifestResults.length ? vm.manifestResults.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.manifestResults\"><div class=\"btn-toolbar add-pd-b\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.addManifestItems((vm.manifestResults | greaterThanZero: 0))\" ng-disabled=\"!(vm.manifestResults | greaterThanZero: 0).length || (vm.manifestResults | invalidQuantity:0).length\">Add selected to manifest</button></div><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ts-wrapper=\"\"><thead><tr><th><span><input type=\"checkbox\" ng-model=\"vm.selectAllManifests\" icheck-all=\"vm.manifestResults.isIncluded\"></span></th><th ts-criteria=\"documentNumber\" ts-default=\"\">Manifest Number</th><th ts-criteria=\"refDoc\">Ref Doc</th><th ts-criteria=\"(poNumber + \'/\' + poLineNumber)|natural\" ts-default=\"\">PO / Item</th><th ts-criteria=\"costCode\">Cost code</th><th ts-criteria=\"materialCode\">Material code</th><th ts-criteria=\"barcode\">Barcode</th><th ts-criteria=\"unitOfMeasureCode\">UOM</th><th ts-criteria=\"container\">Container</th><th ts-criteria=\"quantity|parseFloat\">Manifest Qty</th><th ts-criteria=\"selectedQuantity|parseFloat\">Manifest Qty</th><th></th></tr></thead><tbody ng-repeat=\"item in vm.manifestResults\" item=\"item\" ts-repeat=\"\" wg-stored-item-manifest=\"\" add-item=\"vm.addManifestItem(item)\" manifest=\"true\" highlight=\"vm.filter\"></tbody></table></div></div><div ng-show=\"!vm.manifestResults.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.movementsResultsActive\" ng-if=\"vm.movementResults.length\"><uib-tab-heading>Movements <span class=\"badge label-info\">{{vm.movementResults.length ? vm.movementResults.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.movementResults\"><div class=\"btn-toolbar add-pd-b\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.addMovementItems((vm.movementResults | greaterThanZero: 0))\" ng-disabled=\"!(vm.movementResults | movementGreaterThanZero: 0).length || (vm.movementResults | movementInvalidQuantity:0).length\">Add selected to manifest</button></div><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ts-wrapper=\"\"><thead><tr><th><span><input type=\"checkbox\" ng-model=\"vm.selectAllMovements\" icheck-all=\"vm.movementResults.isIncluded\"></span></th><th ts-criteria=\"documentNumber\" ts-default=\"\">Movement Number</th><th ts-criteria=\"(poNumber + \'/\' + poLineNumber)|natural\" ts-default=\"\">PO / Item</th><th ts-criteria=\"costCode\">Cost code</th><th ts-criteria=\"materialCode\">Material code</th><th ts-criteria=\"barcode\">Barcode</th><th ts-criteria=\"unitOfMeasureCode\">UOM</th><th ts-criteria=\"locationName\">Location name</th><th ts-criteria=\"quantity|parseFloat\">Movement Qty</th><th ts-criteria=\"selectedQuantity|parseFloat\">Manifest Qty</th><th></th></tr></thead><tbody ng-repeat=\"item in vm.movementResults\" item=\"item\" ts-repeat=\"\" wg-movement-item-manifest=\"\" add-item=\"vm.addMovementItem(item)\" highlight=\"vm.filter\"></tbody></table></div></div><div ng-show=\"!vm.movementResults.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagResultsActive\" ng-if=\"vm.bagAndTagResults.length\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.bagAndTagResults.length ? vm.bagAndTagResults.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.bagAndTagResults.length\"><div class=\"btn-toolbar add-pd-b\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.addBagAndTagItems((vm.bagAndTagResults | greaterThanZero: 0))\">Add selected to manifest</button></div><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ng-show=\"vm.bagAndTagResults\" ts-wrapper=\"\"><thead><th><span><input type=\"checkbox\" ng-model=\"vm.selectAllBagAndTag\" icheck-all=\"vm.bagAndTagResults.isIncluded\"></span></th><th ts-criteria=\"documentNumber\">Ref Doc</th><th ts-criteria=\"number\">Bag & Tag Number</th><th ts-criteria=\"workpackNumber\">Workpack number</th><th></th></thead><tbody ng-repeat=\"item in vm.bagAndTagResults\" item=\"item\" wg-bag-and-tag-item=\"\" ts-repeat=\"\" manifest=\"true\" add-item=\"vm.addBagAndTag(item)\" enable-add=\"true\"></tbody></table></div></div><div ng-show=\"!vm.bagAndTagResults.length\">No results found.</div></div></uib-tab></uib-tabset></div></div></div><div ng-class=\"!vm.manifest.isReadOnly ? \'col-lg-5\' : \'col-lg-12\'\"><div class=\"float-e-margins\"><h4 class=\"m-t-none m-b\">Included items</h4><div class=\"m-t-none m-b\" ng-if=\"!vm.manifest.isReadOnly\"><div ng-cloak=\"\"><div class=\"pull-left\"><div class=\"btn-toolbar\"><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!vm.manifestItems.length && !vm.manifestBagAndTagItems.length\" data-style=\"expand-right\" ng-click=\"vm.completeManifest()\"><i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i> Complete</button></div><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"vm.cancelManifest()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Cancel</button></div><div class=\"btn-group\"><wg-add-manifest-line-item manifest-id=\"vm.manifestId\" post-update-delegate=\"vm.fakeLineItems(item)\" is-read-only=\"vm.manifest.isReadOnly\"></wg-add-manifest-line-item></div></div></div><div class=\"clearfix\"></div></div></div><div class=\"m-t-none m-b\" ng-show=\"!vm.manifestItems.length && !vm.manifestBagAndTagItems.length\"><p><strong>No items have been included in this manifest.</strong></p><p ng-if=\"!vm.manifest.isReadOnly\">Use the search function to find stock...</p></div><div class=\"tabs-container items-container\" ng-if=\"vm.manifestItems.length || vm.manifestBagAndTagItems.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.manifestItems.length ? vm.manifestItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.manifestItems.length\">No stock items have been included in this manifest.</strong><div ng-show=\"vm.manifestItems.length\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-if=\"!vm.manifest.isReadOnly\" ng-click=\"vm.addContainer((vm.manifestItems | filter:{isIncluded: true}))\" ng-disabled=\"!(vm.manifestItems | filter:{isIncluded: true}).length\">Add container</button><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ts-wrapper=\"\"><thead><tr><th><input type=\"checkbox\" ng-model=\"vm.selectedAll\" icheck-all=\"vm.manifestItems.isIncluded\" ng-disabled=\"vm.manifest.isReadOnly\"></th><th ts-criteria=\"[container, refDoc]\">Ref Doc</th><th ts-criteria=\"[container, (purchaseOrderNumber + \'/\' + purchaseOrderLineNumber | natural)]\" ts-default=\"\">PO / Item</th><th ts-criteria=\"[container, barcode]\">Barcode</th><th ts-criteria=\"container\">Container</th><th ts-criteria=\"quantity | parseFloat\">Qty</th><th ng-if=\"!vm.manifest.isReadOnly\"></th></tr></thead><tbody wg-included-item-manifest=\"\" ng-repeat=\"item in vm.manifestItems\" item=\"item\" ts-repeat=\"\" class=\"rowlink\" is-read-only=\"vm.manifest.isReadOnly\" remove-item=\"vm.removeItem(item)\" manifest-id=\"vm.manifest.id\"></tbody></table></div></div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.manifestBagAndTagItems.length ? vm.manifestBagAndTagItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.manifestBagAndTagItems.length\">No bag & tag items have been included in this manifest.</strong><div ng-show=\"vm.manifestBagAndTagItems.length\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-if=\"!vm.manifest.isReadOnly\" ng-click=\"vm.addContainer((vm.manifestBagAndTagItems | filter:{isIncluded: true}))\" ng-disabled=\"!(vm.manifestBagAndTagItems | filter:{isIncluded: true}).length\">Add container</button><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ng-if=\"vm.manifestBagAndTagItems.length\" ts-wrapper=\"\"><thead><tr><th><input type=\"checkbox\" ng-model=\"vm.selectedAllBagAndTag\" icheck-all=\"vm.manifestBagAndTagItems.isIncluded\" ng-disabled=\"vm.manifest.isReadOnly\"></th><th ts-criteria=\"[container, refDoc]\">Ref Doc</th><th ts-criteria=\"[container, (purchaseOrderNumber + \'/\' + purchaseOrderLineNumber | natural)]\" ts-default=\"\">PO / Item</th><th ts-criteria=\"container\">Container</th><th ts-criteria=\"quantity | parseFloat\">Manifest Qty</th><th ng-if=\"!vm.manifest.isReadOnly\"></th><th></th></tr></thead><tbody wg-included-item-manifest=\"\" ng-repeat=\"item in vm.manifestBagAndTagItems\" ts-repeat=\"\" item=\"item\" manifest-id=\"vm.manifest.id\" class=\"rowlink\" is-read-only=\"vm.manifest.isReadOnly\" remove-item=\"vm.removeItem(item)\"></tbody></table></div></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("app/manifests/movementItemManifest.html","<tr><td colspan=\"12\" class=\"item-description\" ng-bind-html=\"::vm.item.description | uppercase | highlight:vm.highlight\"></td></tr><tr add-item-to-issue=\"vm.addItemToIssue(item)\" ng-class=\"vm.item.class\"><td><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.isIncluded\" ng-checked=\"vm.item.isIncluded\"></td><td class=\"text-nowrap\">{{vm.item.movementNumber}}</td><td class=\"text-nowrap\">{{vm.item.poNumber}} / {{vm.item.poLineNumber}}</td><td>{{vm.item.costCode}}</td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.materialCode }}</pre></td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\" ng-if=\"vm.item.barcode.length\">{{ vm.item.barcode }}</pre><span ng-if=\"!vm.item.barcode.length\">n/a</span></td><td>{{vm.item.unitOfMeasureCode}}</td><td>{{vm.item.warehouseName}} / {{vm.item.locationName}}</td><td>{{vm.item.selectedQuantity}} <span ng-if=\"vm.item.requestedQuantity > vm.item.selectedQuantity\" class=\"pull-right\" title=\"The issue quantity is greater than the quantity available.\"><i class=\"fa fa-warning text-danger\"></i></span></td><td><input type=\"text\" class=\"form-control\" style=\"width:50px\" numeric-only=\"\" ng-model=\"vm.item.requestedQuantity\"></td><td><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.addItem(vm.item)\" ng-disabled=\"!vm.item.requestedQuantity.length || vm.item.requestedQuantity == 0 || vm.item.requestedQuantity > vm.item.selectedQuantity\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></td></tr>");
$templateCache.put("app/manifests/searchCriteriaManifest.html","<form role=\"form\" name=\"searchForm\" ng-submit=\"vm.doSearch()\"><h4 class=\"m-t-none m-b\">Search for stock</h4><div class=\"m-t-none m-b\"><div class=\"form-group remove-margin-b\"><div class=\"row\"><div class=\"col-md-3 pt4\"><label class=\"control-label\">Issues</label><div class=\"input-group\" style=\"width: 100%\"><select kendo-multi-select=\"\" k-options=\"vm.issuesOptions\" k-ng-model=\"vm.issuesSelected\" style=\"width: 100%\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Return</label><div class=\"input-group\" style=\"width: 100%\"><select kendo-multi-select=\"\" k-options=\"vm.returnsOptions\" k-ng-model=\"vm.returnsSelected\" style=\"width: 100%\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Transfer</label><div class=\"input-group\" style=\"width: 100%\"><select kendo-multi-select=\"\" k-options=\"vm.transfersOptions\" k-ng-model=\"vm.transfersSelected\" style=\"width: 100%\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Delivery</label><div class=\"input-group\" style=\"width: 100%\"><select kendo-multi-select=\"\" k-options=\"vm.deliveriesOptions\" k-ng-model=\"vm.deliveriesSelected\" style=\"width: 100%\"></select></div></div></div><div class=\"row\"><div class=\"col-md-3 pt4\"><label class=\"control-label\">PO number</label><div class=\"input-group\" style=\"width:100%;\"><select name=\"purchaseOrder\" kendo-multi-select=\"\" k-options=\"vm.purchaseOrdersOptions\" k-ng-model=\"vm.purchaseOrdersSelected\" style=\"width: 100%;\" ng-class=\"{ \'has-error\' : searchForm.purchaseOrder.$invalid && !searchForm.purchaseOrder.$pristine }\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Material code</label><div class=\"input-group\" style=\"width:100%;\"><select kendo-multi-select=\"\" k-options=\"vm.materialCodesOptions\" style=\"width: 100%;\" k-ng-model=\"vm.materialCodesSelected\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Cost code</label><div class=\"input-group\" style=\"width:100%;\"><select kendo-multi-select=\"\" k-options=\"vm.costCodesOptions\" k-ng-model=\"vm.costCodesSelected\" style=\"width:100%\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Barcode</label><div class=\"input-group\" style=\"width:100%;\"><select kendo-multi-select=\"\" k-options=\"vm.barcodesOptions\" k-ng-model=\"vm.barcodesSelected\" style=\"width:100%\"></select></div></div></div><div class=\"row\"><div class=\"col-md-3 pt4\"><label class=\"control-label\">Bag & Tag number</label><div class=\"input-group\" style=\"width: 100%\"><select kendo-multi-select=\"\" k-options=\"vm.bagAndTagNumbersOptions\" k-ng-model=\"vm.bagAndTagNumbersSelected\" style=\"width: 100%\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Workpack number</label><div class=\"input-group\" style=\"width: 100%\"><select kendo-multi-select=\"\" k-options=\"vm.workpackNumbersOptions\" k-ng-model=\"vm.workpackNumbersSelected\" style=\"width: 100%\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Manifest</label><div class=\"input-group\" style=\"width:100%;\"><select kendo-multi-select=\"\" k-options=\"vm.manifestsOptions\" k-ng-model=\"vm.manifestsSelected\" style=\"width:100%\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Description</label><div class=\"input-group\" style=\"width: 100%\"><input type=\"text\" class=\"form-control k-textbox\" name=\"description\" placeholder=\"Enter a description\" ng-model=\"vm.filter\"></div></div></div><div class=\"row\"><div class=\"col-md-3 pt4\"><label class=\"control-label\">Movement number</label><div class=\"input-group\" style=\"width: 100%\"><select kendo-multi-select=\"\" k-options=\"vm.movementsOptions\" k-ng-model=\"vm.movementsSelected\" style=\"width: 100%\"></select></div></div></div></div></div><div class=\"m-t-none m-b\"><button type=\"submit\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-disabled=\"!vm.purchaseOrdersSelected.length && !vm.materialCodesSelected.length && !vm.costCodesSelected.length && !vm.barcodesSelected.length && !vm.manifestsSelected.length && !vm.bagAndTagNumbersSelected.length && !vm.workpackNumbersSelected.length && !vm.issuesSelected.length && !vm.transfersSelected.length && !vm.deliveriesSelected.length && !vm.returnsSelected.length && !vm.movementsSelected.length && !vm.filter.length\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> Search</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.resetForm()\"><i class=\"fa fa-eraser\" aria-hidden=\"true\"></i> Clear</button></div></form>");
$templateCache.put("app/manifests/shippingAddress.html","<div><form role=\"form\" name=\"addressForm\"><div class=\"row\"><div class=\"col-md-12\"><button ladda=\"vm.loading\" type=\"submit\" class=\"btn btn-primary m-t-n-xs\" ng-if=\"!vm.manifest.isReadOnly\" ng-disabled=\"addressForm.$invalid\" ng-click=\"vm.saveShippingAddress()\"><i class=\"fa fa-check\"></i> Save Shipping Addresses</button></div></div><div class=\"ibox\"></div><div class=\"row\"><div class=\"col-sm-6 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : addressForm.shipFromAddressHidden.$invalid }\"><label class=\"control-label\" for=\"shipFromAddressHidden\">Ship From Destination Address *</label><select kendo-combo-box=\"\" k-ng-model=\"vm.manifest.shipFromAddress\" k-options=\"vm.shipFromAddressOptions\" class=\"form-control\" name=\"shipFromAddress1\" ng-disabled=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : addressForm.shipFromAddressHidden.$invalid }\"></select><input type=\"hidden\" name=\"shipFromAddressHidden\" ng-model=\"vm.manifest.shipFromAddress\" required=\"\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.shipFromAddress.address2\" placeholder=\"Address Line 2\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.shipFromAddress.address3\" placeholder=\"Address Line 3\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.shipFromAddress.address4\" placeholder=\"Address Line 4\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.shipFromAddress.postCode\" placeholder=\"Post Code\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.shipFromAddress.telephoneNo\" placeholder=\"Telephone No\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.shipFromAddress.faxNo\" placeholder=\"Fax No\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.shipFromAddress.vatNo\" placeholder=\"VAT No\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.shipFromAddress.vatDefNo\" placeholder=\"VAT Def No\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.shipFromAddress.country\" placeholder=\"Country\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"sweuNo\">SWEU No</label> <input class=\"form-control k-textbox\" ng-model=\"vm.manifest.shipFromAddress.sweuNo\" name=\"sweuNo\" ng-readonly=\"vm.manifest.isReadOnly\" placeholder=\"SWEU No\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"exportLicence\">Export Licence</label> <input class=\"form-control k-textbox\" ng-model=\"vm.manifest.shipFromAddress.exportLicence\" name=\"exportLicence\" ng-readonly=\"vm.manifest.isReadOnly\" placeholder=\"Export Licence\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : addressForm.deliverToAddressHidden.$invalid }\"><label class=\"control-label\" for=\"deliverToAddressHidden\">Deliver To Address *</label><select kendo-combo-box=\"\" k-ng-model=\"vm.manifest.deliverToAddress\" k-options=\"vm.deliverToAddressOptions\" class=\"form-control\" name=\"deliverToAddress\" ng-disabled=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : addressForm.deliverToAddressHidden.$invalid }\"></select><input type=\"hidden\" name=\"deliverToAddressHidden\" ng-model=\"vm.manifest.deliverToAddress\" required=\"\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.deliverToAddress.address2\" placeholder=\"Address Line 2\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.deliverToAddress.address3\" placeholder=\"Address Line 3\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.deliverToAddress.address4\" placeholder=\"Address Line 4\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.deliverToAddress.postCode\" placeholder=\"Post Code\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.deliverToAddress.telephoneNo\" placeholder=\"Telephone No\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.deliverToAddress.faxNo\" placeholder=\"Fax No\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.deliverToAddress.vatNo\" placeholder=\"VAT No\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.deliverToAddress.vatDefNo\" placeholder=\"VAT Def No\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><input class=\"form-control\" ng-model=\"vm.manifest.deliverToAddress.country\" placeholder=\"Country\" ng-readonly=\"vm.manifest.isReadOnly\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"fao\">FAO</label> <input class=\"form-control k-textbox\" ng-model=\"vm.manifest.fao\" name=\"fao\" ng-readonly=\"vm.manifest.isReadOnly\" placeholder=\"FAO\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"sweuNo\">SWEU No</label> <input class=\"form-control k-textbox\" ng-model=\"vm.manifest.deliverToAddress.sweuNo\" name=\"sweuNo\" ng-readonly=\"vm.manifest.isReadOnly\" placeholder=\"SWEU No\"></div><div class=\"form-group\"><label class=\"control-label\" for=\"exportLicence\">Export Licence</label> <input class=\"form-control k-textbox\" ng-model=\"vm.manifest.deliverToAddress.exportLicence\" name=\"exportLicence\" ng-readonly=\"vm.manifest.isReadOnly\" placeholder=\"Export Licence\"></div></div></div></form></div>");
$templateCache.put("app/manifests/shippingDetails.html","<form role=\"form\" name=\"details\"><div class=\"row\"><div class=\"col-md-12\"><button ladda=\"vm.loading\" type=\"submit\" class=\"btn btn-primary m-t-n-xs\" ng-if=\"!vm.manifest.isReadOnly\" ng-disabled=\"details.$pristine\" ng-click=\"vm.saveShippingDetails()\"><i class=\"fa fa-check\"></i> Save Shipping Details</button></div></div><div class=\"ibox\"></div><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\"><label class=\"control-label\" for=\"shipDate\">Ship Date</label><div class=\"input-group date\"><input type=\"text\" name=\"shipDate\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'shipDate\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.manifest.shipDate\" is-open=\"vm.calendar.opened.shipDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"shipDate\" ng-readonly=\"vm.manifest.isReadOnly\" ng-disabled=\"vm.manifest.isReadOnly\" placeholder=\"Enter Ship Date\" date-to-iso=\"\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'shipDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"etaDate\">ETA Date</label><div class=\"input-group date\"><input type=\"text\" name=\"etaDate\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'etaDate\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.manifest.etaDate\" is-open=\"vm.calendar.opened.etaDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"etaDate\" ng-readonly=\"vm.manifest.isReadOnly\" ng-disabled=\"vm.manifest.isReadOnly\" placeholder=\"Enter ETA Date\" date-to-iso=\"\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'etaDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"receiptDate\">Receipt Date</label><div class=\"input-group date\"><input type=\"text\" name=\"receiptDate\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'receiptDate\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.manifest.receiptDate\" is-open=\"vm.calendar.opened.receiptDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"receiptDate\" ng-readonly=\"vm.manifest.isReadOnly\" ng-disabled=\"vm.manifest.isReadOnly\" placeholder=\"Enter Receipt Date\" date-to-iso=\"\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'receiptDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : details.estimatedShipDays.$invalid && !details.estimatedShipDays.$pristine }\"><label class=\"control-label\" for=\"estimatedShipDays\">Estimated Ship Days</label> <input class=\"form-control k-textbox\" name=\"estimatedShipDays\" ng-class=\"{ \'has-error\' : details.estimatedShipDays.$invalid && !details.estimatedShipDays.$pristine }\" numeric-only=\"\" id=\"estimatedShipDays\" ng-readonly=\"vm.manifest.isReadOnly\" ng-model=\"vm.manifest.estimatedShipDays\" placeholder=\"Enter Estimated Ship Days\"></div></div><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : details.shipToDestination.$invalid && !details.shipToDestination.$pristine }\"><label class=\"control-label\" for=\"shipToDestination\">Ship To Destination</label><select kendo-combo-box=\"\" ng-model=\"vm.manifest.shipToDestinationId\" k-ng-delay=\"vm.shipToDestinationOptions\" k-options=\"vm.shipToDestinationOptions\" class=\"form-control\" name=\"shipToDestination\" id=\"shipToDestination\" ng-readonly=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : details.shipToDestination.$invalid && !details.shipToDestination.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : details.agent.$invalid && !details.agent.$pristine }\"><label class=\"control-label\" for=\"agent\">Agent</label><select kendo-combo-box=\"\" ng-model=\"vm.manifest.agentId\" k-ng-delay=\"vm.agentsOptions\" k-options=\"vm.agentsOptions\" class=\"form-control\" name=\"agent\" id=\"agent\" ng-readonly=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : details.agent.$invalid && !details.agent.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : details.transportType.$invalid && !details.transportType.$pristine }\"><label class=\"control-label\" for=\"transportType\">Transport Type</label><select kendo-combo-box=\"\" ng-model=\"vm.manifest.transportTypeId\" k-ng-delay=\"vm.transportTypesOptions\" k-options=\"vm.transportTypesOptions\" class=\"form-control\" name=\"transportType\" id=\"transportType\" ng-readonly=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : details.transportType.$invalid && !details.transportType.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : details.soldToParty.$invalid && !details.soldToParty.$pristine }\"><label class=\"control-label\" for=\"soldToParty\">Sold To Party</label><select kendo-combo-box=\"\" ng-model=\"vm.manifest.soldToPartyId\" k-ng-delay=\"vm.soldToPartyOptions\" k-options=\"vm.soldToPartyOptions\" class=\"form-control\" name=\"soldToParty\" id=\"soldToParty\" ng-readonly=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : details.soldToParty.$invalid && !details.soldToParty.$pristine }\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : details.vessel.$invalid && !details.vessel.$pristine }\"><label class=\"control-label\" for=\"vessel\">Vessel</label> <input class=\"form-control k-textbox\" name=\"vessel\" id=\"vessel\" ng-readonly=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : details.vessel.$invalid && !details.vessel.$pristine }\" ng-model=\"vm.manifest.vessel\" placeholder=\"Enter Vessel\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : details.currency.$invalid && !details.currency.$pristine }\"><label class=\"control-label\" for=\"currency\">Currency</label><select kendo-combo-box=\"\" ng-model=\"vm.manifest.currencyId\" k-ng-delay=\"vm.currencyOptions\" k-options=\"vm.currencyOptions\" class=\"form-control\" name=\"currency\" id=\"currency\" ng-readonly=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : details.currency.$invalid && !details.currency.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : details.freight.$invalid && !details.freight.$pristine }\"><label class=\"control-label\" for=\"freight\">Freight Originator</label><select kendo-combo-box=\"\" ng-model=\"vm.manifest.freightOriginator\" k-ng-delay=\"vm.freightOptions\" k-options=\"vm.freightOptions\" class=\"form-control\" name=\"freight\" id=\"freight\" ng-readonly=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : details.freight.$invalid && !details.freight.$pristine }\"></select></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : details.shippingNotes.$invalid && !details.shippingNotes.$pristine }\"><label class=\"control-label\" for=\"shippingNotes\">Shipping Notes</label><div class=\"row\"><div class=\"col-sm-9\"><select kendo-combo-box=\"\" k-ng-model=\"vm.shippingNotes\" k-options=\"vm.shippingNotesOptions\" class=\"form-control\" name=\"shippingNotes\" id=\"shippingNotes\" ng-readonly=\"vm.manifest.isReadOnly\" ng-class=\"{ \'has-error\' : details.shippingNotes.$invalid && !details.shippingNotes.$pristine }\"></select></div><div class=\"col-sm-3\"><button class=\"btn btn-primary\" ng-click=\"vm.appendShippingNotes()\" ng-disabled=\"!vm.shippingNotes.notes.length\" ng-if=\"!vm.manifest.isReadOnly\">Append</button></div></div></div><div class=\"form-group\"><textarea type=\"text\" class=\"form-control\" ng-model=\"vm.shippingNotes.notes\" style=\"resize: none;\" rows=\"10\" ng-readonly=\"true\"></textarea></div></div><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"control-label\"></label> <textarea type=\"text\" class=\"form-control\" ng-model=\"vm.manifest.shippingNotes.notes\" ng-readonly=\"vm.manifest.isReadOnly\" style=\"resize: none;\" rows=\"13\"></textarea></div></div></div></form>");
$templateCache.put("app/manifests/storedItemManifest.html","<tr><td colspan=\"12\" class=\"item-description\" ng-bind-html=\"::vm.item.description | uppercase | highlight:vm.highlight\"></td></tr><tr add-item-to-issue=\"vm.addItemToIssue(item)\" ng-class=\"vm.item.class\"><td><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.isIncluded\" ng-checked=\"vm.item.isIncluded\"></td><td ng-if=\"vm.manifest\">{{vm.item.manifestNumber}}</td><td ng-if=\"!vm.manifest\">{{vm.item.documentNumber}}</td><td ng-if=\"vm.return\">{{vm.item.issueNumber}}</td><td ng-if=\"vm.manifest\">{{vm.item.refDoc}}</td><td ng-if=\"vm.isReturn\">{{vm.item.issueNumber}}</td><td class=\"text-nowrap\"><span ng-if=\"vm.item.isDualUse\"><i class=\"fa fa-warning text-danger\" title=\"Item is identified as being Dual Use\"></i></span> {{vm.item.poNumber}} / {{vm.item.poLineNumber}}</td><td>{{vm.item.costCode}}</td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.materialCode }}</pre></td><td class=\"text-nowrap\" ng-hide=\"vm.purchaseOrder\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\" ng-if=\"vm.item.barcode.length\">{{ vm.item.barcode }}</pre></td><td>{{vm.item.unitOfMeasureCode}}</td><td ng-if=\"vm.manifest\">{{vm.item.container}}</td><td ng-hide=\"vm.delivery || vm.purchaseOrder || vm.manifest\">{{vm.item.warehouseName}} / {{vm.item.locationName}}</td><td>{{vm.item.quantity}} <span ng-if=\"vm.item.selectedQuantity > vm.item.quantity\" class=\"pull-right\" title=\"The issue quantity is greater than the quantity available.\"><i class=\"fa fa-warning text-danger\"></i></span></td><td><input type=\"text\" class=\"form-control\" style=\"width:60px\" numeric-only=\"\" ng-model=\"vm.item.selectedQuantity\"></td><td><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.addItem(vm.item)\" ng-disabled=\"vm.item.selectedQuantity == 0 || vm.item.selectedQuantity > vm.item.quantity\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></td></tr>");
$templateCache.put("app/manifests/viewManifest.html","<div ng-controller=\"ViewManifestCtrl as vm\"><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"m-b-md\"><h2><a href=\"#\" ng-class=\"{\'disabled-class\': vm.manifest.isReadOnly || !vm.canEditManifestType}\" edit-disabled=\"vm.manifest.isReadOnly || !vm.canEditManifestType\" editable-select=\"vm.manifest.manifestTypeId\" e-ng-options=\"x.id as x.name for x in vm.manifestTypes\" onaftersave=\"vm.saveUpdatedManifestType()\">{{ vm.manifest.manifestType }}</a> {{ vm.manifest.number }} <small><strong class=\"text-nowrap\">{{vm.manifest.description }}</strong></small> <span ng-class=\"!vm.manifest.isReadOnly ? \'badge label-warning\' : (vm.manifest.manifestStatus === \'Cancelled\') ? \'badge label-danger\' : \'badge label-primary\'\">{{vm.manifest.manifestStatus}}</span></h2><span class=\"text-nowrap\"><strong>Created by:</strong> {{vm.manifest.createdBy}} | <strong>Created date:</strong> {{vm.manifest.createdDate | date: \'dd-MMM-yyyy\'}}</span></div><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div></div></div></div></div></div></div><div style=\"margin-bottom: 20px;\"><button class=\"btn btn-warning\" ng-click=\"vm.reopenManifest()\" ng-if=\"vm.manifest.manifestStatus === \'Complete\'\">Reopen Manifest</button></div><div class=\"\"><div class=\"tabs-container\"><uib-tabset><uib-tab active=\"vm.tabs.itemsActive\"><uib-tab-heading><i class=\"fa fa-truck\"></i> Items</uib-tab-heading><div class=\"panel-body\" style=\"padding-left: 0;padding-right:0\"><div ng-include=\"\'app/manifests/manifestItems.html\'\"></div></div></uib-tab><uib-tab active=\"vm.tabs.addressActive\"><uib-tab-heading><i class=\"fa fa-map-marker\"></i> Shipping Addresses</uib-tab-heading><div class=\"panel-body\"><wg-shipping-address manifest=\"vm.manifest\" ng-if=\"vm.dataHasLoaded\"></wg-shipping-address></div></uib-tab><uib-tab active=\"vm.tabs.detailsActive\"><uib-tab-heading><i class=\"fa fa-info\"></i> Shipping Details</uib-tab-heading><div class=\"panel-body\"><wg-shipping-details manifest=\"vm.manifest\" ng-if=\"vm.dataHasLoaded\"></wg-shipping-details></div></uib-tab><uib-tab active=\"vm.tabs.customsStatusActive\"><uib-tab-heading><i class=\"fa fa-money\"></i> Customs Status</uib-tab-heading><div class=\"panel-body\"><wg-customs-status manifest=\"vm.manifest\" ng-if=\"vm.dataHasLoaded\"></wg-customs-status></div></uib-tab><uib-tab active=\"vm.tabs.importActive\"><uib-tab-heading><i class=\"fa fa-upload\"></i> Import</uib-tab-heading><div class=\"panel-body\"><wg-import-items manifest=\"vm.manifest\" ng-if=\"vm.dataHasLoaded\"></wg-import-items></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/manifests/viewManifests.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><form role=\"form\" name=\"createForm\" ng-submit=\"vm.createManifest()\" ng-controller=\"CreateManifestCtrl as vm\"><div class=\"ibox-title\"><h5 for=\"product_name\">Create a manifest</h5></div><div class=\"form-group\"><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-8\"><label class=\"control-label\" for=\"description\">Description *</label> <input type=\"text\" class=\"form-control k-textbox\" name=\"description\" id=\"description\" placeholder=\"Enter a description\" required=\"\" ng-model=\"vm.manifest.description\" ng-class=\"{ \'has-error\' : createForm.name.$invalid && !createForm.name.$pristine }\"></div><div class=\"col-lg-2\"><label class=\"control-label\" for=\"type\">Type *</label><select kendo-combo-box=\"\" ng-model=\"vm.manifest.manifestTypeId\" k-ng-delay=\"vm.manifest.manifestTypeId\" k-options=\"vm.typeOptions\" class=\"form-control\" name=\"type\" id=\"type\" required=\"\" ng-class=\"{ \'has-error\' : createForm.type.$invalid && !createForm.type.$pristine }\"></select></div><div class=\"col-lg-2 label-pad\"><button type=\"submit\" ladda=\"vm.loading\" class=\"btn btn-primary\" ng-disabled=\"createForm.$invalid\">Create manifest</button></div></div></div></div></div></form></div></div><div class=\"tabs-container\" ng-controller=\"ViewManifestsCtrl as vm\"><uib-tabset><uib-tab><uib-tab-heading><i class=\"fa fa-warning\"></i>Incomplete <span class=\"badge label-warning\">{{vm.incompleteManifests.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.incompleteManifests.length\">There are no incomplete manifests.</strong><div ng-if=\"vm.incompleteManifests.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-2 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-2 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"item in vm.incompleteManifests | orderBy: \'createdDate\' : true | itemsPerPage: 15\" pagination-id=\"incomplete\"><td><a ui-sref=\"manifests.details({id:item.id})\">{{ item.number }}</a></td><td>{{ item.description }}</td><td>{{ item.createdBy }}</td><td>{{ item.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls></div></div></uib-tab><uib-tab><uib-tab-heading><i class=\"fa fa-check-square-o\"></i>Completed <span class=\"badge label-primary\">{{ vm.completedManifests.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.completedManifests.length\">There are no completed manifests.</strong><div ng-if=\"vm.completedManifests.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completed\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-2 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-2 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"item in vm.completedManifests | orderBy: \'createdDate\' : true | itemsPerPage: 15\" pagination-id=\"completed\"><td><a ui-sref=\"manifests.details({id:item.id})\">{{ item.number }}</a></td><td>{{ item.description }}</td><td>{{ item.completedBy }}</td><td>{{ item.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completed\"></dir-pagination-controls></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/main/bagAndTagsWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"bagAndTag.view\" class=\"inheritColors\"><div class=\"ibox-content homePageWidget\"><h4>Bag and tags</h4><i class=\"fa fa-tags fa-3x\"></i><h1 title=\"Total : {{vm.bagAndTagCount}}\" class=\"pull-right text-white font-bold\">{{ vm.bagAndTagCount | truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/checkingDeliveriesWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"deliveries.view.checking\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Needing checked</h4><i class=\"fa fa-clipboard fa-3x\"></i><h1 title=\"Total to be checked : {{vm.deliveryCount}}\" class=\"pull-right text-white font-bold\">{{ vm.deliveryCount | truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/incompleteDeliveriesWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"deliveries.view.incomplete\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Incomplete deliveries</h4><i class=\"fa fa-truck fa-3x\"></i><h1 title=\"Total incomplete : {{vm.deliveryCount}}\" class=\"pull-right text-white font-bold\">{{ vm.deliveryCount| truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/incompleteIssuesWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"issues.view\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Incomplete issues</h4><i class=\"fa fa-mail-forward fa-3x\"></i><h1 title=\"Total incomplete : {{vm.issueCount}}\" class=\"pull-right text-white font-bold\">{{ vm.issueCount| truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/incompleteManifestsWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"manifests.view\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Incomplete manifests</h4><i class=\"fa fa-ship fa-3x\"></i><h1 title=\"Total incomplete : {{vm.manifestCount}}\" class=\"pull-right text-white font-bold\">{{ vm.manifestCount| truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/incompleteMinMaxWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"minMax.register\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Outstanding min max items</h4><i class=\"fa fa-line-chart fa-3x\"></i><h1 title=\"Total outstanding : {{vm.itemCount}}\" class=\"pull-right text-white font-bold\">{{ vm.itemCount| truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/incompleteMovementsWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"movements.view\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Incomplete movements</h4><i class=\"fa fa-arrows fa-3x\"></i><h1 title=\"Total incomplete : {{vm.count}}\" class=\"pull-right text-white font-bold\">{{ vm.count| truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/incompletePicklistsWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"picklists.view\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Incomplete picklists</h4><i class=\"fa fa-cart-plus fa-3x\"></i><h1 title=\"Total incomplete : {{vm.itemCount}}\" class=\"pull-right text-white font-bold\">{{ vm.itemCount| truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/incompleteReceiptsWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"receipts.view\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Incomplete receipts</h4><i class=\"fa fa-file-text-o fa-3x\"></i><h1 title=\"Total incomplete : {{vm.itemCount}}\" class=\"pull-right text-white font-bold\">{{ vm.itemCount | truncateNumber }}</h1></div></a></div>");
$templateCache.put("app/main/incompleteReturnsWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"returns.view\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Incomplete returns</h4><i class=\"fa fa-mail-reply fa-3x\"></i><h1 title=\"Total incomplete : {{vm.returnCount}}\" class=\"pull-right text-white font-bold\">{{ vm.returnCount| truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/incompleteTransfersWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"transfer.view\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Incomplete transfers</h4><i class=\"fa fa-exchange fa-3x\"></i><h1 title=\"Total incomplete : {{vm.count}}\" class=\"pull-right text-white font-bold\">{{ vm.count| truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/inspectionDeliveriesWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"deliveries.view.inspection\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Needing inspected</h4><i class=\"fa fa-search fa-3x\"></i><h1 title=\"Total to be inspected : {{vm.deliveryCount}}\" class=\"pull-right text-white font-bold\">{{ vm.deliveryCount| truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/main.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div id=\"homePageWidgets\"><span class=\"widget-heading\"><p class=\"widget-title widget-title-border\"><span>Deliveries</span></p></span><div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showInspectionsWidget\"><wg-vendor-inspection-widget></wg-vendor-inspection-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showDeliveriesWidget\"><wg-incomplete-deliveries-widget></wg-incomplete-deliveries-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showDeliveriesWidget\"><wg-checking-deliveries-widget></wg-checking-deliveries-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showInspectionsWidget\"><wg-inspection-deliveries-widget></wg-inspection-deliveries-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showOSDWidget\"><wg-potential-overage-deliveries-widget></wg-potential-overage-deliveries-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showDeliveriesWidget\"><wg-storing-deliveries-widget></wg-storing-deliveries-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showReceiptsWidget\"><wg-incomplete-receipts-widget></wg-incomplete-receipts-widget></div></div><span class=\"widget-heading\"><p class=\"widget-title widget-title-border\"><span>Warehouse</span></p></span><div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showIssuesWidget\"><wg-incomplete-issues-widget></wg-incomplete-issues-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showReturnsWidget\"><wg-incomplete-returns-widget></wg-incomplete-returns-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showTransfersWidget\"><wg-incomplete-transfers-widget></wg-incomplete-transfers-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showMovementsWidget\"><wg-incomplete-movements-widget></wg-incomplete-movements-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showMinMaxWidget\"><wg-incomplete-min-max-widget></wg-incomplete-min-max-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showPicklistsWidget\"><wg-incomplete-picklists-widget></wg-incomplete-picklists-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showPicklistsWidget\"><wg-ready-for-picking-picklists-widget></wg-ready-for-picking-picklists-widget></div></div><span class=\"widget-heading\"><p class=\"widget-title widget-title-border\"><span>Shipping</span></p></span><div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showExpeditingWidget\"><wg-one-week-expediting-widget time-interval=\"\'yy:-1\'\" title=\"\'Items overdue expediting\'\"></wg-one-week-expediting-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showExpeditingWidget\"><wg-one-week-expediting-widget time-interval=\"\'ww:1\'\" title=\"\'Items due to be expedited < 7 days\'\"></wg-one-week-expediting-widget></div><div class=\"col-sm-6 col-lg-3\" ng-if=\"main.showManifestWidget\"><wg-incomplete-manifests-widget></wg-incomplete-manifests-widget></div></div></div></div></div>");
$templateCache.put("app/main/oneWeekExpeditingWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"expediting.view({timeInterval: \'{{vm.timeInterval}}\' })\" class=\"inheritColors\"><div class=\"ibox-content homePageWidget\"><h4>{{vm.title}}</h4><i class=\"fa fa-plane fa-3x\"></i><h1 title=\"Total overdue : {{vm.count}}\" class=\"pull-right text-white font-bold\">{{ vm.count | truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/potentialOverageDeliveriesWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"deliveries.view.osd\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Outstanding OS&D</h4><i class=\"fa fa-warning fa-3x\"></i><h1 title=\"Total outstanding : {{vm.deliveryCount}}\" class=\"pull-right text-white font-bold\">{{ vm.deliveryCount| truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/readyForPickingPicklistsWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"picklists.view.picking\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Ready for issuing picklists</h4><i class=\"fa fa-shopping-cart fa-3x\"></i><h1 title=\"Total ready : {{vm.itemCount}}\" class=\"pull-right text-white font-bold\">{{ vm.itemCount | truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/storingDeliveriesWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"deliveries.view.storing\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Needing stored</h4><i class=\"fa fa-archive fa-3x\"></i><h1 title=\"Total needing stored : {{vm.deliveryCount}}\" class=\"pull-right text-white font-bold\">{{ vm.deliveryCount | truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/main/vendorInspectionWidget.html","<div class=\"ibox float-e-margins\"><a ui-sref=\"inspections.view\" class=\"inheritColors\"><div class=\"ibox-content\"><h4>Vendor inspections < 7 days</h4><i class=\"fa fa-check-square fa-3x\"></i><h1 title=\"Total vendor inspections due in less than 7 days : {{vm.itemCount}}\" class=\"pull-right text-white font-bold\">{{ vm.itemCount | truncateNumber}}</h1></div></a></div>");
$templateCache.put("app/material-allocation/createConstructionWorkpack.html","<button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.openCreateConstructionWorkpack()\" data-style=\"expand-right\"><i class=\"fa fa-plus\"></i> Add Construction Workpack</button>");
$templateCache.put("app/material-allocation/createConstructionWorkpackModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-folder modal-icon\"></i><h4 class=\"modal-title\">Create a Construction Workpack</h4></div><div class=\"modal-body p-b-xxs transfer-bag-and-tag\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Number *</label><div class=\"col-lg-9\"><input type=\"text\" required=\"\" class=\"form-control col-lg-10\" ng-model=\"vm.item.number\"></div></div><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Description</label><div class=\"col-lg-9\"><textarea required=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.item.description\" name=\"itemDescription\" rows=\"3\" ng-class=\"{ \'has-error\' : save.itemDescription.$invalid && !save.itemDescription.$pristine }\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Job Number</label><div class=\"col-lg-5\"><input type=\"text\" maxlength=\"6\" class=\"form-control\" ng-model=\"vm.item.jobNumber\"></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Item successfully saved.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error saving the item.</div><span class=\"pr20\"><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.addAnother\"> Add another</span> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.item.number === undefined || vm.saved\">Save</button></div></div>");
$templateCache.put("app/material-allocation/updateConstructionWorkpack.html","<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openModal()\"><i class=\"fa fa-edit fa-lg\"></i></button>");
$templateCache.put("app/material-allocation/updateConstructionWorkpackModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-folder modal-icon\"></i><h4 class=\"modal-title\">Edit Construction Workpack</h4></div><div class=\"modal-body p-b-xxs transfer-bag-and-tag\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Number *</label><div class=\"col-lg-9\"><input type=\"text\" required=\"\" class=\"form-control col-lg-10\" ng-model=\"vm.item.number\"></div></div><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Description</label><div class=\"col-lg-9\"><textarea required=\"\" type=\"text\" class=\"form-control\" ng-model=\"vm.item.description\" name=\"itemDescription\" rows=\"3\" ng-class=\"{ \'has-error\' : save.itemDescription.$invalid && !save.itemDescription.$pristine }\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Job Number</label><div class=\"col-lg-5\"><input type=\"text\" maxlength=\"6\" class=\"form-control col-lg-10\" ng-model=\"vm.item.jobNumber\"></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Item successfully saved.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error saving the item.</div><button type=\"button\" class=\"btn btn-danger pull-left\" ng-click=\"vm.delete()\" ng-disabled=\"vm.saving\">Delete</button> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.item.number === undefined || vm.saved\">Save</button></div></div>");
$templateCache.put("app/material-allocation/uploadDemandModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-cubes modal-icon\"></i><h4 class=\"modal-title\">Add demand to CWP {{vm.constructionWorkpark.number}}</h4></div><div class=\"modal-body p-b-xxs transfer-bag-and-tag\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"dz-container dropzone border-dashed\" dropzone=\"\" parent-id=\"\" import-endpoint=\"vm.importEndpoint\" get-import-errors=\"vm.getImportErrors(documentKey)\" id=\"dropzone\"><div class=\"dz-message\"><h4><i class=\"fa fa-upload fa-lg\"></i> Drop files here or click to upload</h4></div><div id=\"previews\"><div id=\"template\" class=\"dz-file-preview dz-full-width\"><div class=\"dz-file-preview-top\"><div id=\"upload-image\" class=\"dz-image\"><span class=\"preview\"><img data-dz-thumbnail=\"\"></span></div><div id=\"upload-info\" class=\"dz-info-upload\"><p class=\"dz-name\" data-dz-name=\"\"></p><p class=\"size\" data-dz-size=\"\"></p><strong class=\"error text-danger\" data-dz-errormessage=\"\"></strong></div><div class=\"dz-remove\"><button data-dz-remove=\"\" class=\"btn btn-danger delete pull-right\"><i class=\"fa fa-times\"></i></button></div><div class=\"clearfix pb-20\"></div><div class=\"progress progress-striped active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" aria-valuenow=\"0\" id=\"progressBar\" style=\"width: 100%; height: 5px; position: absolute; bottom: 0px; margin-top: 10px;\"><div class=\"progress-bar progress-bar-success\" style=\"width:0%;\" data-dz-uploadprogress=\"\"></div></div></div><div class=\"dz-file-preview-bottom\"></div></div></div></div></form></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\">Close</button></div></div>");
$templateCache.put("app/material-allocation/viewMaterialAllocation.html","<div ng-controller=\"ViewMaterialAllocationCtrl as vm\"><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"m-b-md\"><h2><span class=\"text-nowrap\">Construction Workpack {{ vm.constructionWorkpack.number }}</span> <small><strong class=\"text-nowrap\">{{vm.constructionWorkpack.description }}</strong></small></h2><span class=\"text-nowrap\"><span><strong>Priority rank:</strong> {{vm.constructionWorkpack.rank}} |</span> <strong>Created date:</strong> {{vm.constructionWorkpack.createdDate | date: \'dd-MMM-yyyy\'}} | <strong>Job Number:</strong> {{vm.constructionWorkpack.jobNumber}}</span></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"btn-group\"><button ladda=\"vm.loading\" type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.exportDetail()\"><i class=\"fa fa-table\"></i> Export summary</button></div><table class=\"table\" ng-if=\"vm.constructionWorkpackDemand.length\"><thead><tr><th class=\"col-lg-4\">Material Code</th><th class=\"col-lg-1 text-center\">Demand</th><th class=\"col-lg-1 text-center\">Short</th><th class=\"col-lg-1 text-center\">Purchased</th><th class=\"col-lg-1 text-center\">Shipped</th><th class=\"col-lg-1 text-center\">Stock</th><th class=\"col-lg-1 text-center\">Reserved</th><th class=\"col-lg-1 text-center\">Issued</th><th class=\"col-lg-1 text-center\"></th></tr></thead><tbody><tr ng-repeat=\"item in vm.constructionWorkpackDemand | orderBy: \'materialCode\'\"><td>{{item.materialCode}}</td><td class=\"text-center\">{{item.demandQuantity}}</td><td class=\"text-center\">{{item.shortQuantity}}</td><td class=\"text-center\">{{item.purchasedQuantity}}</td><td class=\"text-center\">{{item.shippedQuantity}}</td><td class=\"text-center\">{{item.stockQuantity}}</td><td class=\"text-center\">{{item.reservedQuantity}}</td><td class=\"text-center\">{{item.issuedQuantity}}</td><td class=\"text-center\"><span ng-if=\"item.shortQuantity === item.demandQuantity\" style=\"color: red\"><i class=\"fa fa-times-circle fa-2x\"></i></span> <span ng-if=\"item.shortQuantity > 0 && item.shortQuantity < item.demandQuantity && item.issuedQuantity !== item.demandQuantity\" style=\"color: red\"><i class=\"fa fa-times-circle-o fa-2x\"></i></span> <span ng-if=\"item.shortQuantity === 0 && item.issuedQuantity < item.demandQuantity\" style=\"color: green\"><i class=\"fa fa-check-circle-o fa-2x\"></i></span> <span ng-if=\"item.issuedQuantity === item.demandQuantity\" style=\"color: green\"><i class=\"fa fa-check-circle fa-2x\"></i></span></td></tr></tbody></table><span class=\"row\" ng-if=\"!vm.constructionWorkpackDemand.length\"><strong>No demand has been added to this construction workpack.</strong></span></div></div></div></div></div></div></div></div>");
$templateCache.put("app/material-allocation/viewMaterialAllocations.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"tabs-container\" ng-controller=\"ViewMaterialAllocationsCtrl as vm\"><uib-tabset><uib-tab><uib-tab-heading><i class=\"fa fa-folder\"></i>Construction Workpacks <span class=\"badge label-success\">{{vm.constructionWorkpacks.length}}</span></uib-tab-heading><div class=\"panel-body\"><div class=\"row\"><div class=\"form-group col-lg-6\"><div class=\"btn-toolbar\"><div class=\"btn-group\"><wg-create-construction-workpack post-update-delegate=\"vm.loadConstructionWorkpacks()\"></wg-create-construction-workpack></div><div class=\"btn-group\"><button ladda=\"vm.loading\" type=\"submit\" class=\"btn btn-primary\" ng-click=\"vm.downloadTemplate()\"><i class=\"fa fa-download\"></i> Download import template</button></div><div class=\"btn-group\"><button ladda=\"vm.loading\" type=\"submit\" class=\"btn btn-default\" ng-click=\"vm.exportSummary()\"><i class=\"fa fa-table\"></i> Export summary</button></div></div></div><div class=\"form-group col-lg-6 text-right\" ng-if=\"vm.constructionWorkpacks.length\"><div class=\"btn-group\"><input type=\"text\" class=\"form-control filter-input\" ng-model=\"vm.textFilter\" placeholder=\"Filter list\" style=\"width: 250px\"></div><div class=\"btn-group\"><button class=\"btn btn-default\" ng-click=\"vm.clearFilter()\">Clear filter</button></div></div></div><div class=\"row\"><div class=\"form-group col-lg-12\"><span class=\"badge\" ng-class=\"vm.allocationActivityPercentage <= 10 ? \'label-primary\' : \'label-warning\'\" ng-if=\"vm.allocationActivityPercentage > 0\"><span ng-if=\"vm.allocationActivityPercentage <= 10\">Low activity</span> <span ng-if=\"vm.allocationActivityPercentage > 10\">Caution: High activity</span></span> <span ng-if=\"vm.allocationActivityPercentage > 10\">{{vm.allocationActivityPercentage}}% of material codes are being processed. Exports generated at this time may not be accurate.</span></div></div><strong ng-if=\"!vm.constructionWorkpacks.length\">No construction workpacks have been created.</strong><div ng-if=\"vm.constructionWorkpacks.length\"><div class=\"demand-priority row\"><div class=\"header\"><div class=\"col-4\" ng-if=\"vm.canUpdatePriority && vm.constructionWorkpacks.length > 1\"></div><div class=\"col-4 text-center\">Rank</div><div class=\"col-5 text-center\">Demand</div><div class=\"col-20\">Number</div><div class=\"col-20\">Description</div><div class=\"col-5 text-center\">Job Number</div><div class=\"col-5 text-center\">Short</div><div class=\"col-5 text-center\">Purchased</div><div class=\"col-5 text-center\">Shipped</div><div class=\"col-5 text-center\">Stock</div><div class=\"col-5 text-center\">Reserved</div><div class=\"col-5 text-center\">Issued</div><div class=\"col-4 text-center\"></div><div class=\"col-4 text-center\" ng-if=\"vm.canEdit\"></div></div></div><div class=\"demand-priority\"><ul dnd-list=\"vm.constructionWorkpacks\"><li ng-repeat=\"item in vm.constructionWorkpacks | filter: vm.textFilter\" dnd-effect-allowed=\"move\" dnd-selected=\"models.selected = item\" dnd-draggable=\"item\" dnd-moved=\"vm.constructionWorkpacks.splice($index, 1)\" dnd-disable-if=\"{{!vm.canUpdatePriority}}\" dnd-dragend=\"vm.priorityChanged($index, item)\"><dnd-nodrag><div class=\"row\"><div dnd-handle=\"\" class=\"handle col-4\" ng-if=\"vm.canUpdatePriority && vm.constructionWorkpacks.length > 1\"><button class=\"btn btn-default\"><i class=\"fa fa-arrows fa-lg\"></i></button></div><div class=\"col-4 text-center\">{{ $index + 1}}</div><div class=\"col-5 text-center\"><button class=\"btn\" ng-class=\"item.hasDemand ? \'btn-green\' : \'btn-red\'\" ng-click=\"vm.openModal(item)\"><i class=\"fa fa-upload fa-lg fa-inverse\"></i></button></div><div class=\"col-20\"><a ui-sref=\"materialAllocation.details({id:item.id})\">{{ item.number }}</a></div><div class=\"col-20\">{{ item.description }}</div><div class=\"col-5 text-center\">{{ item.jobNumber }}</div><div class=\"col-5 text-center\">{{ item.fulfillmentShortPercentage }}%</div><div class=\"col-5 text-center\">{{ item.fulfilledFromPurchasedPercentage }}%</div><div class=\"col-5 text-center\">{{ item.fulfilledFromShippedPercentage }}%</div><div class=\"col-5 text-center\">{{ item.fulfilledFromStockPercentage }}%</div><div class=\"col-5 text-center\">{{ item.fulfilledFromReservedPercentage }}%</div><div class=\"col-5 text-center\">{{ item.fulfilledFromIssuedPercentage }}%</div><div class=\"col-4 text-center\"><span ng-if=\"item.hasDemand\"><span ng-if=\"item.fulfillmentShortPercentage === 100\" style=\"color: red\"><i class=\"fa fa-times-circle fa-2x\"></i></span> <span ng-if=\"item.fulfillmentShortPercentage > 0 && item.fulfillmentShortPercentage < 100\" style=\"color: red\"><i class=\"fa fa-times-circle-o fa-2x\"></i></span> <span ng-if=\"item.fulfillmentShortPercentage === 0 && item.fulfilledFromIssuedPercentage < 100\" style=\"color: green\"><i class=\"fa fa-check-circle-o fa-2x\"></i></span> <span ng-if=\"item.fulfilledFromIssuedPercentage === 100\" style=\"color: green\"><i class=\"fa fa-check-circle fa-2x\"></i></span></span></div><div class=\"col-4 text-center\" ng-if=\"vm.canEdit\"><wg-update-construction-workpack item=\"item\" post-update-delegate=\"vm.loadConstructionWorkpacks()\"></wg-update-construction-workpack></div></div></dnd-nodrag></li></ul></div></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/issues/storedItemPicklist.html","<tr ng-class=\"vm.item.class\"><td colspan=\"12\" class=\"item-description\">{{vm.item.description | uppercase}}</td></tr><tr add-item-to-issue=\"vm.addItemToIssue(item)\" ng-class=\"vm.item.class\"><td class=\"text-nowrap\">{{vm.item.poNumber}} / {{vm.item.poLineNumber}}</td><td>{{vm.item.costCode}}</td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.materialCode }}</pre></td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.barcode }}</pre></td><td>{{vm.item.unitOfMeasureCode}}</td><td><strong>{{vm.item.selectedQuantity}}</strong></td><td><strong>{{vm.item.issuedQuantity}}</strong></td><td></td><td></td><td></td><td></td></tr><tr ng-repeat=\"stockItemLocation in vm.item.storedItems\"><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td>{{stockItemLocation.warehouseName}} / {{stockItemLocation.locationName}}</td><td>{{stockItemLocation.quantity}}<span ng-if=\"stockItemLocation.issueQuantity > vm.item.selectedQuantity || stockItemLocation.issueQuantity > stockItemLocation.quantity || (vm.item.issuedQuantity--stockItemLocation.issueQuantity) > vm.item.selectedQuantity\" class=\"pull-right\" title=\"The issue quantity is invalid.\"><i class=\"fa fa-warning text-danger\"></i></span></td><td><input type=\"text\" class=\"form-control\" style=\"width:50px\" numeric-only=\"\" ng-model=\"stockItemLocation.issueQuantity\"></td><td><button class=\"btn btn-primary btn-sm\" ng-click=\"vm.addItem({item: stockItemLocation})\" ng-disabled=\"!stockItemLocation.issueQuantity.length || stockItemLocation.issueQuantity == 0 || stockItemLocation.issueQuantity > vm.item.selectedQuantity || stockItemLocation.issueQuantity > stockItemLocation.quantity || (vm.item.issuedQuantity--stockItemLocation.issueQuantity) > vm.item.selectedQuantity\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button></td></tr>");
$templateCache.put("app/issues/updateIssueItemQuantity.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-ship modal-icon\"></i><h4 class=\"modal-title\">Edit issue item</h4></div><div class=\"modal-body p-b-xxs transfer-bag-and-tag\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Material code</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-disabled=\"vm.isReadOnly\" ng-model=\"vm.lineItem.materialCode\" name=\"materialCodes\" style=\"width:100%\"></div><label class=\"col-lg-2 control-label\">Barcode</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.barcode\" ng-disabled=\"vm.isReadOnly\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Description</label><div class=\"col-lg-4\"><textarea required=\"\" type=\"text\" class=\"form-control\" style=\"resize: none; width: 100%\" ng-model=\"vm.lineItem.description\" name=\"itemDescription\" rows=\"4\" ng-disabled=\"vm.isReadOnly\"></textarea></div><label class=\"col-lg-2 control-label\">Location</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.location\" ng-disabled=\"vm.isReadOnly\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Avail. Quantity</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.lineItem.availableQuantity\" ng-disabled=\"vm.isReadOnly\" name=\"availablequantity\"></div><label class=\"col-lg-2 control-label\">Issue Quantity</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control\" numeric-only=\"\" ng-model=\"vm.lineItem.selectedQuantity\" name=\"SelectedQuantity\"></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">{{vm.errorMessage}}</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"saveForm.$invalid\">Save</button></div></div>");
$templateCache.put("app/issues/viewIssue.html","<div ng-controller=\"ViewIssueCtrl as vm\"><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"m-b-md\"><h2><span class=\"text-nowrap\">Issue {{ vm.issue.number }}</span> <small><strong class=\"text-nowrap\">{{vm.issue.description }}</strong></small> <span ng-class=\"!vm.issue.isReadOnly ? \'badge label-warning\' : (vm.issue.issueStatus === \'Cancelled\') ? \'badge label-danger\' : \'badge label-primary\'\">{{vm.issue.issueStatus}}</span></h2><span class=\"text-nowrap\"><span ng-if=\"vm.issue.costCode.length\"><strong>Issue to Cost Code:</strong> {{vm.issue.costCode}} |</span> <span ng-if=\"vm.issue.picklistNumber.length\"><strong>Picklist:</strong> {{vm.issue.picklistNumber}} - {{vm.issue.picklistDescription}} |</span> <strong>Created by:</strong> {{vm.issue.createdBy}} | <strong>Created date:</strong> {{vm.issue.createdDate | date: \'dd-MMM-yyyy\'}} | <strong>Default Ref No.:</strong> <a href=\"#\" editable-text=\"vm.issue.defaultRefNo\" onaftersave=\"vm.updateIssue()\">{{vm.issue.defaultRefNo}}</a> <span ng-if=\"vm.issue.issueStatus === \'Complete\'\">| <strong>Completed by:</strong> {{vm.issue.completedBy}} | <strong>Completed date:</strong> {{vm.issue.completedDate | date: \'dd-MMM-yyyy\'}}</span></span></div><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-8\" ng-if=\"!vm.issue.isReadOnly && !vm.issue.isPicklist\"><wg-search-criteria results=\"vm.results\" bag-and-tag-results=\"vm.bagAndTagResults\" tabs=\"vm.tabs\"></wg-search-criteria><div class=\"tabs-container items-container\" ng-show=\"vm.results.length || vm.bagAndTagResults.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsResultsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.results.length ? vm.results.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results\"><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ng-show=\"vm.results.length\"><thead><tr><th ng-if=\"!vm.issue.isReadOnly\"><span><input type=\"checkbox\" ng-model=\"vm.selectedAll\" icheck-all-nested=\"vm.results.storedItems.isIncluded\"></span></th><th>PO / Item</th><th>Material code</th><th>Barcode</th><th>UOM</th><th>Cost code</th><th>Location</th><th>Avail. Qty</th><th>Issue Qty</th><th></th></tr></thead><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.addIssueItems((vm.results | greaterThanZero: 0))\" ng-disabled=\"!(vm.results | filter: {storedItems:{isIncluded: true}}).length\">Add selected to Issue</button><tbody ng-repeat=\"item in vm.results | orderBy: [\'poNumber\', natural(\'poLineNumber\')]\" item=\"item\" selected=\"vm.selectedAll\" wg-stored-item=\"\" add-item=\"vm.addItem(item)\" show-checkbox=\"true\"></tbody></table></div></div><div ng-show=\"!vm.results.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagResultsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.bagAndTagResults.length ? vm.bagAndTagResults.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.bagAndTagResults.length\"><table class=\"table materia-grouped-row\" ng-show=\"vm.bagAndTagResults\"><thead><th width=\"50\"></th><th>Number</th><th>Ref. number</th><th></th></thead><tbody ng-repeat=\"item in vm.bagAndTagResults\" item=\"item\" wg-bag-and-tag-item=\"\" add-item=\"vm.addBagAndTag(item)\" enable-add=\"true\"></tbody></table></div><div ng-show=\"!vm.bagAndTagResults.length\">No results found.</div></div></uib-tab></uib-tabset></div></div><div class=\"col-lg-8\" ng-if=\"!vm.issue.isReadOnly && vm.issue.isPicklist\"><div class=\"tabs-container items-container\" ng-show=\"vm.picklistItems.length || vm.picklistBagAndTagItems.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsResultsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.picklistItems.length ? vm.picklistItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.picklistItems\"><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ng-show=\"vm.picklistItems.length\"><thead><tr><th>PO / Item</th><th>Cost code</th><th>Material code</th><th>Barcode</th><th data-breakpoints=\"sm\">UOM</th><th>Picklist Qty</th><th>Picklist Issued Qty</th><th data-breakpoints=\"sm\">Location</th><th>Avail. Qty</th><th>Issue Qty</th><th data-sort-ignore=\"true\"></th></tr></thead><tbody ng-repeat=\"item in vm.picklistItems\" item=\"item\" wg-stored-item-picklist=\"\" add-item=\"vm.addPicklistItem(item)\"></tbody></table></div></div><div ng-show=\"!vm.picklistItems.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagResultsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.picklistBagAndTagItems.length ? vm.picklistBagAndTagItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.picklistBagAndTagItems.length\"><table class=\"table materia-grouped-row\" ng-show=\"vm.picklistBagAndTagItems\"><thead><th width=\"50\"></th><th>Number</th><th>Workpack number</th><th></th></thead><tbody ng-repeat=\"item in vm.picklistBagAndTagItems\" item=\"item\" wg-bag-and-tag-item=\"\" add-item=\"vm.addBagAndTag(item)\" enable-add=\"true\"></tbody></table></div><div ng-show=\"!vm.picklistBagAndTagItems.length\">No results found.</div></div></uib-tab></uib-tabset></div><div ng-show=\"!vm.picklistItems.length && !vm.picklistBagAndTagItems.length\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\">All picklist items have been picked.</div></div></div></div><div ng-class=\"!vm.issue.isReadOnly ? \'col-lg-4\' : \'col-lg-12\'\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Included items</h5></div><div class=\"ibox-footer\" ng-if=\"!vm.issue.isReadOnly\"><div ng-cloak=\"\"><div class=\"pull-left\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!vm.issueItems.length && !vm.issueBagAndTagItems.length\" data-style=\"expand-right\" ng-click=\"vm.completeIssue()\"><i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i> Complete</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"vm.cancelIssue()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Cancel</button></div><div class=\"clearfix\"></div></div></div><div class=\"ibox-content\" ng-show=\"!vm.issueItems.length && !vm.issueBagAndTagItems.length\"><p><strong>No items have been included in this issue.</strong></p><p ng-if=\"!vm.issue.isReadOnly\">Use the search function to find stock...</p></div><div class=\"tabs-container items-container\" ng-if=\"vm.issueItems.length || vm.issueBagAndTagItems.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.issueItems.length ? vm.issueItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.issueItems.length\">No stock items have been included in this issue.</strong><div ng-show=\"vm.issueItems.length\"><table class=\"table materia-grouped-row\"><thead><tr><th>Material code</th><th>Barcode</th><th>Issue Qty</th><th>Location</th><th data-sort-ignore=\"true\" ng-if=\"!vm.issue.isReadOnly\"></th></tr></thead><tbody wg-included-item=\"\" ng-repeat=\"item in vm.issueItems | orderBy: \'barcode\'\" item=\"item\" update-item=\"vm.updateItem(item)\" open-modal=\"vm.openModal(item)\" is-read-only=\"vm.issue.isReadOnly\" is-issue-with-picklist=\"vm.issue.isPicklist\" remove-item=\"vm.removeItem(item)\"></tbody></table></div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.issueBagAndTagItems.length ? vm.issueBagAndTagItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.issueBagAndTagItems.length\">No bag & tag items have been included in this issue.</strong><div ng-show=\"vm.issueBagAndTagItems.length\"><table class=\"table materia-grouped-row\"><thead><tr><th></th><th>Number</th><th>Workpack number</th><th></th></tr></thead><tbody wg-included-bag-and-tag-item=\"\" ng-repeat=\"item in vm.issueBagAndTagItems\" item=\"item\" is-read-only=\"vm.issue.isReadOnly\" remove-item=\"vm.removeBagAndTag(item)\" is-bag-and-tag-view=\"true\"></tbody></table></div></div></uib-tab></uib-tabset></div></div></div></div></div></div>");
$templateCache.put("app/issues/viewIssues.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><form role=\"form\" name=\"createForm\" ng-submit=\"vm.createIssue()\" ng-controller=\"CreateIssueCtrl as vm\"><div class=\"ibox-title\"><h5 for=\"product_name\">Create an issue</h5></div><div class=\"form-group\"><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-lg-5 col-md-5\"><label class=\"control-label\" for=\"description\">Description *</label> <input type=\"text\" class=\"form-control k-textbox\" name=\"description\" placeholder=\"Enter a description\" required=\"\" ng-model=\"vm.issue.description\" id=\"description\" ng-class=\"{ \'has-error\' : createForm.description.$invalid && !createForm.description.$pristine }\"></div><div class=\"col-lg-2 col-md-2\"><label class=\"control-label\" for=\"defaultRefNo\">Default Ref No.</label> <input type=\"text\" class=\"form-control k-textbox\" name=\"defaultRefNo\" placeholder=\"(Optional)\" ng-model=\"vm.issue.defaultRefNo\" id=\"defaultRefNo\" ng-class=\"{ \'has-error\' : createFrom.defaultRefNo.$invalid && !createForm.defaultRefNo.$pristine }\"></div><div class=\"col-lg-2 col-md-2\"><label class=\"control-label\" for=\"costCode\">Issue to Cost Code</label><select kendo-combo-box=\"\" ng-model=\"vm.issue.costCode\" k-ng-delay=\"vm.issue.costCode\" k-options=\"vm.costCodesOptions\" class=\"form-control\" name=\"costCode\" id=\"costCode\" ng-class=\"{ \'has-error\' : createForm.costCode.$invalid && !createForm.costCode.$pristine }\"></select></div><div class=\"col-lg-2 col-md-2\"><label class=\"control-label\" for=\"picklist\">Picklist</label><select kendo-combo-box=\"\" ng-model=\"vm.issue.picklistId\" k-ng-delay=\"vm.issue.picklistId\" k-options=\"vm.picklistsOptions\" class=\"form-control\" name=\"picklist\" id=\"picklist\" ng-class=\"{ \'has-error\' : createForm.picklist.$invalid && !createForm.picklist.$pristine }\"></select></div><div class=\"col-lg-1 col-md-1 label-pad\"><button type=\"submit\" ladda=\"vm.loading\" class=\"btn btn-primary\" ng-disabled=\"createForm.$invalid\">Create issue</button></div></div></div></div></div></form></div></div><div class=\"tabs-container\" ng-controller=\"ViewIssuesCtrl as vm\"><uib-tabset><uib-tab><uib-tab-heading><i class=\"fa fa-warning\"></i>Incomplete <span class=\"badge label-warning\">{{vm.incompleteIssues.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.incompleteIssues.length\">There are no incomplete issues.</strong><div ng-if=\"vm.incompleteIssues.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-2 text-nowrap\">Description</th><th class=\"col-xs-1 text-nowrap\">Cost code</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-2 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"issue in vm.incompleteIssues | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"incomplete\"><td><a ui-sref=\"issues.details({id:issue.id})\">{{ issue.number }}</a></td><td>{{ issue.description }}</td><td>{{ issue.costCode }}</td><td>{{ issue.createdBy }}</td><td>{{ issue.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls></div></div></uib-tab><uib-tab><uib-tab-heading><i class=\"fa fa-check-square-o\"></i>Completed <span class=\"badge label-primary\">{{ vm.completedIssues.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.completedIssues.length\">There are no completed issues.</strong><div ng-if=\"vm.completedIssues.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completed\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Cost code</th><th class=\"col-xs-2 text-nowrap\">Picklist</th><th class=\"col-xs-1 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th><th class=\"col-xs-1 text-nowrap\">Completed by</th><th class=\"col-xs-1 text-nowrap\">Completed date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"issue in vm.completedIssues | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"completed\"><td><a ui-sref=\"issues.details({id:issue.id})\">{{ issue.number }}</a></td><td>{{ issue.description }}</td><td>{{ issue.costCode }}</td><td>{{ issue.picklistNumber }} - {{issue.picklistDescription}}</td><td>{{ issue.createdBy }}</td><td>{{ issue.createdDate | date:\'dd-MMM-yyyy\' }}</td><td>{{ issue.completedBy }}</td><td>{{ issue.completedDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completed\"></dir-pagination-controls></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/min-max/addMinMaxMaterialCode.html","<button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.openAddMinMaxItem()\" data-style=\"expand-right\"><i class=\"fa fa-plus\"></i> Add material code</button>");
$templateCache.put("app/min-max/addMinMaxMaterialCodeModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-line-chart modal-icon\"></i><h4 class=\"modal-title\">Add min/max values for a material code</h4></div><div class=\"modal-body p-b-xxs transfer-bag-and-tag\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Material code *</label><div class=\"col-lg-4\"><select kendo-combo-box=\"\" k-options=\"vm.materialCodesOptions\" ng-model=\"vm.selectedMaterialCode\" name=\"materialCode\" style=\"width:100%\" ng-disabled=\"vm.saving\"></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Description *</label><div class=\"col-lg-10\"><textarea required=\"\" type=\"text\" class=\"form-control\" style=\"resize: none; width: 80%\" ng-model=\"vm.item.description\" name=\"itemDescription\" rows=\"3\" ng-disabled=\"vm.descriptionIsReadOnly\" ng-class=\"{ \'has-error\' : save.itemDescription.$invalid && !save.itemDescription.$pristine }\"></textarea></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Quantities *</label><div class=\"col-lg-10\"><table><tr><th class=\"\">Min</th><th class=\"\">Max</th><th class=\"\">Reorder</th><th></th></tr><tr><td><input type=\"text\" required=\"\" numeric-only=\"\" class=\"form-control col-lg-2\" ng-model=\"vm.item.minQuantity\" style=\"width: 95%\"></td><td><input type=\"text\" required=\"\" numeric-only=\"\" class=\"form-control col-lg-2\" ng-model=\"vm.item.maxQuantity\" style=\"width: 95%\"></td><td><input type=\"text\" required=\"\" numeric-only=\"\" class=\"form-control col-lg-2\" ng-model=\"vm.item.reorderQuantity\" style=\"width: 95%\"></td><td><span ng-if=\"!vm.isValidQuantity()\" class=\"pull-right\" title=\"The minimum quantity cannot be greater than the maximum quantity.\"><i class=\"fa fa-warning text-danger\"></i></span></td></tr></table></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Warehouse(s) *</label><div class=\"col-lg-8\"><div class=\"input-group\" style=\"width:100%;\"><select kendo-multi-select=\"\" k-options=\"vm.warehouseOptions\" k-ng-model=\"vm.selectedWarehouse\" name=\"warehouse\" style=\"width:100%\"></select></div></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Item successfully saved.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error saving the item.</div><span class=\"pr20\"><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.addAnother\"> Add another</span> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.selectedMaterialCode == undefined || vm.item.minQuantity == undefined || vm.item.maxQuantity == undefined || vm.item.reorderQuantity == undefined || vm.selectedWarehouse == undefined || !vm.isValidQuantity() || vm.saved\">Save</button></div></div>");
$templateCache.put("app/min-max/importMaterialMinMaxItems.html","<div ng-controller=\"ImportMaterialMinMaxItemsCtrl as vm\"><form role=\"form\" name=\"poImport\"><div class=\"row\"><div class=\"col-md-12\"><button ladda=\"vm.loading\" type=\"submit\" class=\"btn btn-primary m-t-n-xs\" ng-click=\"vm.downloadTemplate()\"><i class=\"fa fa-download\"></i> Download template</button></div></div><div class=\"ibox\"></div><div class=\"row\"><div class=\"dz-container dropzone border-dashed\" dropzone=\"\" parent-id=\"\" import-endpoint=\"vm.importEndpoint\" get-import-errors=\"vm.getImportErrors(parentId, documentKey)\" id=\"dropzone\"><div class=\"dz-message\"><h4><i class=\"fa fa-upload fa-lg\"></i> Drop files here or click to upload</h4></div><div id=\"previews\"><div id=\"template\" class=\"dz-file-preview\"><div class=\"dz-file-preview-top\"><div id=\"upload-image\" class=\"dz-image\"><span class=\"preview\"><img data-dz-thumbnail=\"\"></span></div><div id=\"upload-info\" class=\"dz-info-upload\"><p class=\"dz-name\" data-dz-name=\"\"></p><p class=\"size\" data-dz-size=\"\"></p><strong class=\"error text-danger\" data-dz-errormessage=\"\"></strong></div><div class=\"dz-remove\"><button data-dz-remove=\"\" class=\"btn btn-danger delete pull-right\"><i class=\"fa fa-times\"></i></button></div><div class=\"clearfix\"></div><div class=\"progress progress-striped active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" aria-valuenow=\"0\" id=\"progressBar\" style=\"width: 100%; height: 5px; position: absolute; bottom: 0px; margin-top: 10px;\"><div class=\"progress-bar progress-bar-success\" style=\"width:0%;\" data-dz-uploadprogress=\"\"></div></div></div><div class=\"dz-file-preview-bottom\"></div></div></div></div></div></form></div>");
$templateCache.put("app/min-max/minMaxAction.html","<button class=\"btn btn-primary\" ng-click=\"vm.openMinMax(true)\">Reorder</button> <button class=\"btn btn-warning\" ng-click=\"vm.openMinMax(false)\">Dismiss</button>");
$templateCache.put("app/min-max/minMaxActionModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Action min max items</h4></div><div class=\"modal-body p-b-xxs transfer-bag-and-tag\"><form name=\"saveForm\" class=\"form-horizontal\"><table class=\"table\" ng-if=\"vm.reorder\"><thead><tr><th class=\"width-150\">Material Code</th><th class=\"width-150\">Available Quantity</th><th class=\"width-150\">Min Quantity</th><th class=\"width-150\">Max Quantity</th><th class=\"width-150\">Reorder Quantity</th><th class=\"width-150\">Order Quantity</th></tr></thead><tbody ng-repeat=\"item in vm.items | orderBy: \'materialCode\'\"><tr class=\"new-border\"><td>{{item.materialCode}}</td><td><input type=\"text\" class=\"form-control\" ng-model=\"item.availableQuantity\" numeric-only=\"\" ng-disabled=\"true\"></td><td><input type=\"text\" class=\"form-control\" ng-model=\"item.materialMinMaxMinQuantity\" numeric-only=\"\" ng-disabled=\"true\"></td><td><input type=\"text\" class=\"form-control\" ng-model=\"item.materialMinMaxMaxQuantity\" numeric-only=\"\" ng-disabled=\"true\"></td><td><input type=\"text\" class=\"form-control\" ng-model=\"item.materialMinMaxReorderQuantity\" numeric-only=\"\" ng-disabled=\"true\"></td><td ng-class=\"{ \'has-error\' : saveForm.orderQuantity.$invalid && !saveForm.orderQuantity.$pristine }\"><input type=\"text\" class=\"form-control\" ng-model=\"item.orderQuantity\" numeric-only=\"\" name=\"orderQuantity\" required=\"\" ng-disabled=\"vm.saved\"></td></tr></tbody></table><div class=\"form-group\" ng-if=\"vm.reorder\"><label class=\"col-lg-2 control-label\">Buyer</label><div class=\"col-lg-10\"><select kendo-combo-box=\"\" k-options=\"vm.buyerOptions\" k-ng-model=\"vm.buyer\" name=\"buyer\" style=\"width:100%\"></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Comments</label><div class=\"col-lg-10\"><textarea type=\"text\" class=\"form-control\" ng-model=\"vm.comments\" style=\"resize: none;\" ng-disabled=\"vm.saved\" required=\"!vm.reorder\"></textarea></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Item(s) successfully actioned.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error actioning these item(s).</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"saveForm.$invalid || vm.saved\">Action</button></div></div>");
$templateCache.put("app/min-max/minMaxLineItem.html","<tr><td colspan=\"7\" class=\"item-description\">{{ vm.item.description | uppercase }}</td></tr><tr><td>{{ vm.item.materialCode }}</td><td>{{ vm.item.warehouseName }} <span ng-if=\"vm.item.minQuantity > vm.item.maxQuantity\" class=\"pull-right\" title=\"The minimum quantity cannot be greater than the maximum quantity.\"><i class=\"fa fa-warning text-danger\"></i></span></td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.minQuantity\" numeric-only=\"\" name=\"minQuantity\"></td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.maxQuantity\" numeric-only=\"\" name=\"maxQuantity\"></td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.reorderQuantity\" numeric-only=\"\"></td><td><input icheck=\"\" type=\"checkbox\" ng-model=\"vm.item.isActive\" ng-checked=\"vm.item.isActive\" ng-change=\"vm.setActive()\"></td><td style=\"text-align: right\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!vm.item.isDirty || vm.isInvalid()\" ladda=\"vm.saving\" ng-click=\"vm.ok()\">Save</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.delete()\"><i class=\"fa fa-times\"></i></button></td></tr>");
$templateCache.put("app/min-max/minMaxRegisterActionedLine.html","<tr><td colspan=\"{{ vm.isReorder ? 8 : 6 }}\" class=\"item-description\">{{ vm.item.description | uppercase }}</td></tr><tr><td>{{ vm.item.number }}</td><td ng-if=\"vm.isReorder\">{{ vm.item.requisitionNumber }}</td><td>{{ vm.item.materialCode }}</td><td>{{ vm.item.warehouseName }}</td><td ng-if=\"vm.isReorder\">{{ vm.item.reorderedQuantity }}</td><td>{{ vm.item.comments }}</td><td>{{ vm.item.actionedBy }}</td><td>{{ vm.item.actionDate | date:\'dd-MMM-yyyy\' }}</td></tr>");
$templateCache.put("app/min-max/viewMinMaxPlanning.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\" ng-controller=\"ViewMinMaxPlanningCtrl as vm\"><div class=\"col-lg-12\"><div class=\"row add-pd-b\"><div class=\"col-lg-12\"><form role=\"form\" name=\"materialMinMaxFilter\"><div class=\"ibox-title\"><h5>Min/Max planning filters</h5></div><div class=\"ibox-content\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3\"><label class=\"control-label\" for=\"materialCode\">Material code</label> <input type=\"text\" class=\"form-control k-textbox\" id=\"materialCode\" ng-model=\"materialCode.query\"></div><div class=\"col-md-3\"><label class=\"control-label\" for=\"warehouseName\">Warehouse</label><select kendo-combo-box=\"\" k-options=\"vm.warehouseOptions\" ng-model=\"vm.selectedWarehouse\" name=\"warehouseName\" id=\"warehouseName\" class=\"form-control\"></select></div><div class=\"col-md-6 label-pad\"><button type=\"button\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-click=\"vm.setWarehouse()\" ng-disabled=\"vm.activeTab === \'completed\'\">Go!</button></div></div></div></div></form></div></div><div class=\"tabs-container\"><uib-tabset><uib-tab><uib-tab-heading><i class=\"fa fa-line-chart\"></i>Min/Max values</uib-tab-heading><div class=\"panel-body\"><div class=\"btn-group pr4\"><wg-add-min-max-material-code post-update-delegate=\"vm.refreshGrid()\"></wg-add-min-max-material-code></div><div class=\"btn-group\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.exportMinMax()\"><i class=\"fa fa-download\"></i> Export</button></div><p class=\"label-pad\"><strong ng-if=\"!vm.minMaxItems.length\">There are no min/max items.</strong></p><div ng-if=\"vm.minMaxItems.length\"><table class=\"table materia-grouped-row\"><thead><tr><th class=\"col-xs-2 text-nowrap\">Material code</th><th class=\"col-xs-3 text-nowrap\">Warehouse</th><th class=\"col-xs-1 text-nowrap\">Min Qty</th><th class=\"col-xs-1 text-nowrap\">Max Qty</th><th class=\"col-xs-1 text-nowrap\">Reorder Qty</th><th class=\"col-xs-1 text-nowrap\">Active</th><th class=\"col-xs-1\"></th></tr></thead><tbody ng-repeat=\"item in vm.minMaxItems | orderBy: [\'warehouseName\',\'materialCode\'] | filter: materialCode.query | filter: vm.warehouseQuery\" wg-min-max-line-item=\"\" item=\"item\" post-update-delegate=\"vm.fakeDeleteItem(item)\"></tbody></table></div></div></uib-tab><uib-tab><uib-tab-heading><i class=\"fa fa-upload\"></i>Import</uib-tab-heading><div class=\"panel-body\"><div ng-include=\"\'app/min-max/importMaterialMinMaxItems.html\'\"></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/min-max/viewMinMaxRegister.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"tabs-container\" ng-controller=\"ViewMinMaxRegisterCtrl as vm\"><uib-tabset><uib-tab><uib-tab-heading><i class=\"fa fa-warning\"></i>Requiring action <span class=\"badge label-warning\">{{vm.incompleteMinMaxItems.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.incompleteMinMaxItems.length\">No items have reached their minimum quantity threshold.</strong><div ng-if=\"vm.incompleteMinMaxItems.length\"><div class=\"add-pd-b\"><button class=\"btn btn-primary\" ng-click=\"vm.openMinMax(true, (vm.incompleteMinMaxItems | filter:{isIncluded: true}))\" ng-disabled=\"!(vm.incompleteMinMaxItems | filter:{isIncluded: true}).length\">Reorder</button> <button class=\"btn btn-warning\" ng-click=\"vm.openMinMax(false, (vm.incompleteMinMaxItems | filter:{isIncluded: true}))\" ng-disabled=\"!(vm.incompleteMinMaxItems | filter:{isIncluded: true}).length\">Dismiss</button></div><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls><table class=\"table materia-grouped-row\"><thead><tr><th><input type=\"checkbox\" ng-model=\"vm.selectedAll\" icheck-all=\"vm.incompleteMinMaxItems.isIncluded\"></th><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-2 text-nowrap\">Material Code</th><th>Warehouse</th><th>Available Quantity</th><th>Min Quantity</th><th>Max Quantity</th><th>Reorder Quantity</th></tr></thead><tbody dir-paginate=\"item in vm.incompleteMinMaxItems | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"incomplete\"><tr><td colspan=\"7\" class=\"item-description\">{{ item.description | uppercase }}</td></tr><tr><td><input icheck=\"\" type=\"checkbox\" ng-model=\"item.isIncluded\"></td><td>{{ item.number }}</td><td>{{ item.materialCode }}</td><td>{{ item.warehouseName }}</td><td>{{ item.availableQuantity }}</td><td>{{ item.materialMinMaxMinQuantity }}</td><td>{{ item.materialMinMaxMaxQuantity }}</td><td>{{ item.materialMinMaxReorderQuantity }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls></div></div></uib-tab><uib-tab><uib-tab-heading><i class=\"fa fa-check-square-o\"></i>Reordered <span class=\"badge label-primary\">{{ vm.reorderedMinMaxItems.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.reorderedMinMaxItems.length\">No min/max items have been actioned.</strong><div ng-if=\"vm.reorderedMinMaxItems.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"reordered\"></dir-pagination-controls><table class=\"table materia-grouped-row\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-2 text-nowrap\">Requisition #</th><th class=\"col-xs-2 text-nowrap\">Material Code</th><th>Warehouse</th><th>Reordered Quantity</th><th>Comments</th><th>Actioned By</th><th>Action Date</th></tr></thead><tbody dir-paginate=\"item in vm.reorderedMinMaxItems | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"reordered\" wg-min-max-register-actioned-line=\"\" item=\"item\" is-reorder=\"true\"></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"reordered\"></dir-pagination-controls></div></div></uib-tab><uib-tab><uib-tab-heading><i class=\"fa fa-check-square-o\"></i>Dismissed <span class=\"badge label-primary\">{{ vm.notOrderedMinMaxItems.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.notOrderedMinMaxItems.length\">No min/max items have been dismissed.</strong><div ng-if=\"vm.notOrderedMinMaxItems.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"notOrdered\"></dir-pagination-controls><table class=\"table materia-grouped-row\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-2 text-nowrap\">Material Code</th><th>Warehouse</th><th>Comments</th><th>Actioned By</th><th>Action Date</th></tr></thead><tbody dir-paginate=\"item in vm.notOrderedMinMaxItems | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"notOrdered\" wg-min-max-register-actioned-line=\"\" item=\"item\"></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"notOrdered\"></dir-pagination-controls></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/picklists/searchCriteriaPicklist.html","<form role=\"form\" name=\"searchForm\" ng-submit=\"vm.doSearch()\"><div class=\"ibox-title\"><h5>Search for stock</h5></div><div class=\"ibox-content\"><div class=\"form-group remove-margin-b\"><div class=\"row\"><div class=\"col-md-3 pt4\"><label class=\"control-label\">PO number</label><div class=\"input-group\" style=\"width:100%;\"><select name=\"purchaseOrder\" kendo-multi-select=\"\" k-options=\"vm.purchaseOrdersOptions\" k-ng-model=\"vm.purchaseOrdersSelected\" style=\"width: 100%;\" ng-class=\"{ \'has-error\' : searchForm.purchaseOrder.$invalid && !searchForm.purchaseOrder.$pristine }\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Material code</label><div class=\"input-group\" style=\"width:100%;\"><select kendo-multi-select=\"\" k-options=\"vm.materialCodesOptions\" style=\"width: 100%;\" k-ng-model=\"vm.materialCodesSelected\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Cost code</label><div class=\"input-group\" style=\"width:100%;\"><select kendo-multi-select=\"\" k-options=\"vm.costCodesOptions\" k-ng-model=\"vm.costCodesSelected\" style=\"width:100%\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Barcode</label><div class=\"input-group\" style=\"width:100%;\"><select kendo-multi-select=\"\" k-options=\"vm.barcodesOptions\" k-ng-model=\"vm.barcodesSelected\" style=\"width:100%\"></select></div></div></div><div class=\"row\"><div class=\"col-md-3 pt4\"><label class=\"control-label\">Bag & Tag number</label><div class=\"input-group\" style=\"width: 100%\"><select kendo-multi-select=\"\" k-options=\"vm.bagAndTagNumbersOptions\" k-ng-model=\"vm.bagAndTagNumbersSelected\" style=\"width: 100%\"></select></div></div><div class=\"col-md-3 pt4\"><label class=\"control-label\">Workpack number</label><div class=\"input-group\" style=\"width: 100%\"><select kendo-multi-select=\"\" k-options=\"vm.workpackNumbersOptions\" k-ng-model=\"vm.workpackNumbersSelected\" style=\"width: 100%\"></select></div></div><div class=\"col-md-6 pt4\"><label class=\"control-label\">Description</label><div class=\"input-group\" style=\"width: 100%\"><input type=\"text\" class=\"form-control k-textbox\" name=\"description\" placeholder=\"Enter a description\" ng-model=\"vm.filter\"></div></div></div></div></div><div class=\"ibox-footer\"><button type=\"submit\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-disabled=\"!vm.purchaseOrdersSelected.length && !vm.materialCodesSelected.length && !vm.costCodesSelected.length && !vm.barcodesSelected.length && !vm.bagAndTagNumbersSelected.length && !vm.workpackNumbersSelected.length && !vm.filter.length\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> Search</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.resetForm()\"><i class=\"fa fa-eraser\" aria-hidden=\"true\"></i> Clear</button></div></form>");
$templateCache.put("app/picklists/viewPicklist.html","<div ng-controller=\"ViewPicklistCtrl as vm\"><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"m-b-md\"><h2><span class=\"text-nowrap\">Picklist {{ vm.picklist.number }}</span> <small><strong class=\"text-nowrap\">{{vm.picklist.description }}</strong></small> <span ng-class=\"!vm.picklist.isReadOnly ? \'badge label-warning\' : (vm.picklist.picklistStatus === \'Cancelled\') ? \'badge label-danger\' : \'badge label-primary\'\">{{vm.picklist.picklistStatus}}</span> <span ng-class=\"vm.picklist.pickingStatus === \'Pick\' ? \'badge\' : (vm.picklist.pickingStatus === \'Picking\') ? \'badge label-warning\' : \'badge label-primary\'\">{{vm.picklist.pickingStatus}}</span></h2><span class=\"text-nowrap\"><strong>Created by:</strong> {{vm.picklist.createdBy}} | <strong>Created date:</strong> {{vm.picklist.createdDate | date: \'dd-MMM-yyyy\'}} <span ng-if=\"vm.picklist.picklistStatus === \'Complete\'\">| <strong>Completed by:</strong> {{vm.picklist.completedBy}} | <strong>Completed date:</strong> {{vm.picklist.completedDate | date: \'dd-MMM-yyyy\'}}</span></span></div><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div></div></div></div></div></div></div><div style=\"margin-bottom: 20px;\"><button class=\"btn btn-warning\" ng-click=\"vm.reopenPicklist()\" ng-if=\"vm.picklist && vm.picklist.picklistStatus === \'Complete\' && vm.picklist.pickingStatus === \'Picking\'\">Reopen Picklist</button></div><div class=\"row\"><div class=\"col-lg-7\" ng-if=\"!vm.picklist.isReadOnly\"><wg-search-criteria-picklist results=\"vm.results\" bag-and-tag-results=\"vm.bagAndTagResults\" tabs=\"vm.tabs\"></wg-search-criteria-picklist><div class=\"tabs-container items-container add-pd-b\" ng-show=\"vm.results.length || vm.bagAndTagResults.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsResultsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.results.length ? vm.results.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results\"><table class=\"table materia-grouped-row\" ng-show=\"vm.results.length\"><thead><tr><th>PO / Item</th><th>Material code</th><th>Barcode</th><th>UOM</th><th>Cost code</th><th>Avail. Qty</th><th>Picklist Qty</th><th></th></tr></thead><tbody ng-repeat=\"item in vm.results | orderBy: natural(\'poLineNumber\')\" item=\"item\" wg-stored-item=\"\" is-picklist=\"true\" add-item=\"vm.addItem(item)\" hide-location=\"true\"></tbody></table></div><div ng-show=\"!vm.results.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagResultsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.bagAndTagResults.length ? vm.bagAndTagResults.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.bagAndTagResults.length\"><table class=\"table materia-grouped-row\" ng-show=\"vm.bagAndTagResults\"><thead><th width=\"50\"></th><th>Number</th><th>Workpack number</th><th></th></thead><tbody ng-repeat=\"item in vm.bagAndTagResults\" item=\"item\" wg-bag-and-tag-item=\"\" picklist-id=\"{{vm.picklistId}}\" add-item=\"vm.addBagAndTag(item)\" fake-bag-and-tag-items=\"vm.fakePicklistBagAndTagItems\" enable-add=\"true\"></tbody></table></div><div ng-show=\"!vm.bagAndTagResults.length\">No results found.</div></div></uib-tab></uib-tabset></div></div><div ng-class=\"!vm.picklist.isReadOnly ? \'col-lg-5\' : \'col-lg-12\'\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Included items</h5></div><div class=\"ibox-footer\" ng-if=\"!vm.picklist.isReadOnly\"><div ng-cloak=\"\"><div class=\"pull-left\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!vm.picklistItems.length && !vm.picklistBagAndTagItems.length\" data-style=\"expand-right\" ng-click=\"vm.completePicklist()\"><i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i> Complete</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"vm.cancelPicklist()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Cancel</button></div><div class=\"clearfix\"></div></div></div><div class=\"ibox-content\" ng-show=\"!vm.picklistItems.length && !vm.picklistBagAndTagItems.length\"><p><strong>No items have been included in this picklist.</strong></p><p ng-if=\"!vm.picklist.isReadOnly\">Use the search function to find stock...</p></div><div class=\"tabs-container items-container\" ng-if=\"vm.picklistItems.length || vm.picklistBagAndTagItems.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.picklistItems.length ? vm.picklistItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.picklistItems.length\">No stock items have been included in this picklist.</strong><div ng-show=\"vm.picklistItems.length\"><table class=\"table materia-grouped-row\"><thead><tr><th>Material code</th><th>Barcode</th><th>Picklist Qty</th><th data-sort-ignore=\"true\" ng-if=\"!vm.picklist.isReadOnly\"></th></tr></thead><tbody wg-included-item=\"\" ng-repeat=\"item in vm.picklistItems\" item=\"item\" is-read-only=\"vm.picklist.isReadOnly\" remove-item=\"vm.removeItem(item)\" no-locations=\"true\"></tbody></table></div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.picklistBagAndTagItems.length ? vm.picklistBagAndTagItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.picklistBagAndTagItems.length\">No bag & tag items have been included in this issue.</strong><div ng-show=\"vm.picklistBagAndTagItems.length\"><table class=\"table materia-grouped-row\"><thead><tr><th></th><th>Number</th><th>Workpack number</th><th></th></tr></thead><tbody wg-included-bag-and-tag-item=\"\" ng-repeat=\"item in vm.picklistBagAndTagItems\" item=\"item\" is-read-only=\"vm.picklist.isReadOnly\" remove-item=\"vm.removeBagAndTag(item)\" is-bag-and-tag-view=\"true\"></tbody></table></div></div></uib-tab></uib-tabset></div></div></div></div></div></div>");
$templateCache.put("app/picklists/viewPicklists.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><form role=\"form\" name=\"createForm\" ng-submit=\"vm.createPicklist()\" ng-controller=\"CreatePicklistCtrl as vm\"><div class=\"ibox-title\"><h5 for=\"product_name\">Create a picklist</h5></div><div class=\"form-group\"><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"description\" placeholder=\"Enter a description\" required=\"\" ng-model=\"vm.picklist.description\" ng-class=\"{ \'has-error\' : createForm.name.$invalid && !createForm.name.$pristine }\"> <span class=\"input-group-btn\"><button type=\"submit\" ladda=\"vm.loading\" class=\"btn btn-primary\" ng-disabled=\"createForm.$invalid\">Create picklist</button></span></div></div></div></form></div></div><div class=\"tabs-container\" ng-controller=\"ViewPicklistsCtrl as vm\"><uib-tabset><uib-tab ui-sref=\"picklists.view\" active=\"vm.tabs.incompleteActive\"><uib-tab-heading><i class=\"fa fa-cart-plus\"></i>Incomplete <span class=\"badge label-warning\">{{vm.incompletePicklists.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.incompletePicklists.length\">There are no incomplete picklists.</strong><div ng-if=\"vm.incompletePicklists.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-2 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"picklist in vm.incompletePicklists | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"incomplete\"><td><a ui-sref=\"picklists.details({id:picklist.id})\">{{ picklist.number }}</a></td><td>{{ picklist.description }}</td><td>{{ picklist.createdBy }}</td><td>{{ picklist.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls></div></div></uib-tab><uib-tab ui-sref=\"picklists.view.picking\" active=\"vm.tabs.pickingActive\"><uib-tab-heading><i class=\"fa fa-shopping-cart\"></i>Ready for issue <span class=\"badge label-warning\">{{vm.pickingPicklists.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.pickingPicklists.length\">There are no picklists ready for picking.</strong><div ng-if=\"vm.pickingPicklists.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"picking\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-2 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"picklist in vm.pickingPicklists | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"picking\"><td><a ui-sref=\"picklists.details({id:picklist.id})\">{{ picklist.number }}</a></td><td>{{ picklist.description }}</td><td>{{ picklist.createdBy }}</td><td>{{ picklist.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"picking\"></dir-pagination-controls></div></div></uib-tab><uib-tab ui-sref=\"picklists.view.complete\" active=\"vm.tabs.completeActive\"><uib-tab-heading><i class=\"fa fa-check-square-o\"></i>Issued <span class=\"badge label-primary\">{{ vm.completedPicklists.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.completedPicklists.length\">There are no completed picklists.</strong><div ng-if=\"vm.completedPicklists.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completed\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-1 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th><th class=\"col-xs-1 text-nowrap\">Completed by</th><th class=\"col-xs-1 text-nowrap\">Completed date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"picklist in vm.completedPicklists | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"completed\"><td><a ui-sref=\"picklists.details({id:picklist.id})\">{{ picklist.number }}</a></td><td>{{ picklist.description }}</td><td>{{ picklist.createdBy}}</td><td>{{ picklist.createdDate | date:\'dd-MMM-yyyy\' }}</td><td>{{ picklist.completedBy}}</td><td>{{ picklist.completedDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completed\"></dir-pagination-controls></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/osd-register/addFromStoredItem.html","<button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.openAddFromStoredItem()\" data-style=\"expand-right\"><i class=\"fa fa-plus\"></i> Add from stock</button>");
$templateCache.put("app/osd-register/addFromStoredItemModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Add OS&D from stock</h4></div><div class=\"modal-body p-b-xxs\"><form name=\"saveForm\" class=\"form-horizontal\"><div ng-if=\"vm.stockSearch\"><div class=\"ibox-title\"><h4>Search for stock item</h4></div><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">PO Number</label><div class=\"col-lg-4\"><select kendo-multi-select=\"\" k-options=\"vm.purchaseOrdersOptions\" k-ng-model=\"vm.purchaseOrdersSelected\" name=\"purchaseOrder\" style=\"width:100%\" ng-disabled=\"vm.searching\"></select></div><label class=\"col-lg-2 control-label\">Material code</label><div class=\"col-lg-4\"><select kendo-multi-select=\"\" k-options=\"vm.materialCodesOptions\" k-ng-model=\"vm.materialCodesSelected\" name=\"materialCode\" style=\"width:100%\" ng-disabled=\"vm.searching\"></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Costcode</label><div class=\"col-lg-4\"><select kendo-multi-select=\"\" k-options=\"vm.costCodesOptions\" k-ng-model=\"vm.costCodesSelected\" name=\"costCode\" style=\"width:100%\" ng-disabled=\"vm.searching\"></select></div><label class=\"col-lg-2 control-label\">Barcode</label><div class=\"col-lg-4\"><select kendo-multi-select=\"\" k-options=\"vm.barcodesOptions\" k-ng-model=\"vm.barcodesSelected\" name=\"barcode\" style=\"width:100%\" ng-disabled=\"vm.searching\"></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Location</label><div class=\"col-lg-4\"><select kendo-multi-select=\"\" k-options=\"vm.locationsOptions\" k-ng-model=\"vm.locationsSelected\" name=\"location\" style=\"width:100%\" ng-disabled=\"vm.searching\"></select></div><label class=\"col-lg-2 control-label\">Workpack</label><div class=\"col-lg-4\"><select kendo-multi-select=\"\" k-options=\"vm.workpackNumbersOptions\" k-ng-model=\"vm.workpackNumbersSelected\" name=\"workpack\" style=\"width:100%\" ng-disabled=\"vm.searching\"></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Description</label><div class=\"col-lg-10\"><input type=\"text\" class=\"form-control k-textbox\" name=\"description\" placeholder=\"Enter a description\" ng-model=\"vm.filter\" ng-disabled=\"vm.searching\"></div></div></div><div class=\"ibox-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.doSearch()\" ladda=\"vm.searching\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> Search</button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.resetForm()\"><i class=\"fa fa-eraser\" aria-hidden=\"true\"></i> Clear</button></div><div class=\"pt8\" ng-show=\"vm.results.length > 0\"><div class=\"ibox-title\"><h5>Search results</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ng-show=\"vm.results.length\"><thead><tr><th>PO / Item</th><th>Cost code</th><th>Material code</th><th>Barcode</th><th data-breakpoints=\"sm\">UOM</th><th data-breakpoints=\"sm\">Location</th><th>Avail. Qty</th><th data-sort-ignore=\"true\"></th></tr></thead><tbody ng-repeat=\"item in vm.results\" item=\"item\" wg-modal-stored-item=\"\" select-item=\"vm.selectItem(item)\"></tbody></table></div></div></div></div><div ng-if=\"!vm.stockSearch\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Description</label><div class=\"col-lg-10\"><textarea required=\"\" type=\"text\" class=\"form-control\" style=\"resize: none;\" ng-model=\"vm.item.description\" name=\"itemDescription\" rows=\"2\" ng-disabled=\"true\" ng-class=\"{ \'has-error\' : save.itemDescription.$invalid && !save.itemDescription.$pristine }\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Original location</label><div class=\"col-lg-5\"><label class=\"control-label\">{{ vm.item.warehouseName }} / {{ vm.item.locationName }}</label></div></div><div class=\"\"><label class=\"col-lg-2 control-label\"></label><div class=\"col-lg-10\"><table class=\"table\"><thead><tr><th class=\"width-150\">Available Quantity</th><th class=\"width-150\">Damaged Quantity</th><th class=\"width-150\">Other Quantity</th><th class=\"width-150\">Good Quantity</th></tr></thead><tr class=\"new-border\"><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.availableQuantity\" numeric-only=\"\" ng-disabled=\"true\"></td><td ng-class=\"{ \'has-error\' : (saveForm.damagedInterventionQuantity.$invalid && !saveForm.damagedInterventionQuantity.$pristine) || saveForm.damagedInterventionQuantity.$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.damagedInterventionQuantity\" ng-max=\"vm.availableQuantity\" ng-min=\"0\" name=\"damagedInterventionQuantity\" numeric-only=\"\" required=\"\" ng-disabled=\"vm.saved\"></td><td ng-class=\"{ \'has-error\' : (saveForm.otherInterventionQuantity.$invalid && !saveForm.otherInterventionQuantity.$pristine) || saveForm.otherInterventionQuantity.$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.otherInterventionQuantity\" ng-max=\"vm.availableQuantity\" ng-min=\"0\" name=\"otherInterventionQuantity\" numeric-only=\"\" required=\"\" ng-disabled=\"vm.saved\"></td><td><input type=\"text\" class=\"form-control\" ng-value=\"(vm.availableQuantity - vm.damagedInterventionQuantity - vm.otherInterventionQuantity)\" ng-disabled=\"true\"></td></tr><tr><td colspan=\"4\"><span class=\"text-danger\" ng-show=\"saveForm.damagedInterventionQuantity.$error.ngMin || saveForm.damagedInterventionQuantity.$error.ngMax\">Damaged quantity must be between 0 and {{vm.availableQuantity - vm.otherInterventionQuantity}}.</span> <span class=\"text-danger\" ng-show=\"saveForm.otherInterventionQuantity.$error.ngMin || saveForm.otherInterventionQuantity.$error.ngMax\">Other quantity must be between 0 and {{vm.availableQuantity - vm.damagedInterventionQuantity}}.</span> <span class=\"text-danger\" ng-show=\"(vm.availableQuantity - vm.damagedInterventionQuantity - vm.otherInterventionQuantity) < 0\">Good quantity must not be less than 0.</span></td></tr></table></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Discrepancy Description</label><div class=\"col-lg-10\"><textarea type=\"text\" class=\"form-control\" ng-model=\"vm.discrepancyDescription\" style=\"resize: none;\" ng-disabled=\"vm.saved\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Quarantine location</label><div class=\"col-lg-5\"><select kendo-combo-box=\"\" k-options=\"vm.quarantineLocationsOptions\" k-ng-model=\"vm.selectedQuarantineLocation\" name=\"location\" style=\"width:100%\" ng-disabled=\"vm.warehouseId === undefined\"></select></div></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Item successfully saved.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error saving the item.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.storedItemId == undefined || vm.damagedInterventionQuantity == undefined || vm.otherInterventionQuantity == undefined || vm.discrepancyDescription == undefined || vm.selectedQuarantineLocation == undefined || vm.saved || vm.stockSearch\">Save</button></div></div>");
$templateCache.put("app/osd-register/addStoredItem.html","<tr class=\"new-border\"><td></td><td class=\"visible-lg-block osd-cost-code\">{{ vm.item.costCode }}</td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.materialCode }}</pre></td><td class=\"text-nowrap\"><pre class=\"m-t-none inline btn btn-sm btn-default no-hover\">{{ vm.item.barcode }}</pre></td><td>{{ vm.item.unitOfMeasureCode }}</td><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.acceptedQuantity\" ng-readonly=\"true\"></td><td class=\"text-right\"><span ng-if=\"!vm.isReadonly\"><small>{{vm.item.acceptedQuantity - vm.item.totalStoredQuantity}} outstanding</small><uib-progressbar max=\"vm.item.acceptedQuantity\" value=\"vm.item.totalStoredQuantity\" type=\"{{vm.progressbarType}}\" title=\"Stored Quantity / Total\"><span style=\"color:black; white-space:nowrap;\">{{vm.item.totalStoredQuantity}} / {{vm.item.acceptedQuantity}}</span></uib-progressbar></span></td><td ng-if=\"!vm.isReadonly\"><a class=\"btn btn-primary btn-sm\" ng-click=\"vm.addStoredItemLocation()\" ladda=\"vm.loading\"><i class=\"fa fa-plus\"></i></a></td></tr><tr wg-add-stored-item-location=\"\" ng-repeat=\"storedItemLocation in vm.item.storedItemLocations track by $index\" stored-item-location=\"storedItemLocation\" item=\"vm.item\" index=\"{{$index}}\" locations=\"vm.locations\" is-readonly=\"vm.isReadonly\"></tr>");
$templateCache.put("app/osd-register/addStoredItemLocation.html","<td ng-class=\"{\'remove-border\': vm.index!=0}\"><span ng-if=\"vm.item.quarantineItemId !== null\"><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.returnToOriginalStockLocation\" ng-checked=\"vm.returnToOriginalStockLocation\"></span></td><td ng-class=\"{\'remove-border\': vm.index!=0}\"><span ng-if=\"vm.item.quarantineItemId !== null\">Store in original location?</span> <span ng-if=\"vm.item.quarantineItemId == null\" class=\"text-right\">Stored Location</span></td><td colspan=\"3\" class=\"hidden-lg\"><select required=\"\" kendo-drop-down-list=\"\" k-options=\"vm.locationsOptions\" k-ng-model=\"vm.locationSelected\" k-on-change=\"vm.locationChanged(kendoEvent)\" ng-disabled=\"vm.returnToOriginalStockLocation\" style=\"width:100%\"></select></td><td colspan=\"4\" class=\"visible-lg\"><select required=\"\" kendo-drop-down-list=\"\" k-options=\"vm.locationsOptions\" k-ng-model=\"vm.locationSelected\" k-on-change=\"vm.locationChanged(kendoEvent)\" ng-disabled=\"vm.returnToOriginalStockLocation\" style=\"width:100%\"></select></td><td><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.storedItemLocation.quantity\" ng-disabled=\"vm.isReadonly\" numeric-only=\"\"><div class=\"input-group-addon\" ng-if=\"!vm.isReadonly\"><span data-ng-if=\"!vm.loading && !vm.validationErrors\"><i class=\"fa fa-check text-navy\"></i></span> <span data-ng-if=\"vm.loading && !vm.validationErrors\"><i class=\"fa fa-cog fa-spin\"></i></span> <span data-ng-if=\"vm.validationErrors\"><i class=\"fa fa-times text-danger\"></i></span></div></div></td><td ng-if=\"!vm.isReadonly\"><a class=\"btn btn-danger btn-sm\" ng-click=\"vm.removeStoredItemLocation(vm.index)\" ladda=\"vm.loadingRemoveButton\" ng-disabled=\"vm.isReadonly\"><i class=\"fa fa-minus\"></i></a></td>");
$templateCache.put("app/osd-register/osdResolution.html","<button class=\"btn btn-primary\" ng-click=\"vm.openResolution()\">Resolve</button>");
$templateCache.put("app/osd-register/osdResolveOverageModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Resolve {{vm.item.title | lowercase}} - {{vm.item.number}}</h4><h4>Outstanding quantity: {{vm.item.quantity}}</h4><small class=\"font-bold\">{{vm.item.description | uppercase}}</small></div><div class=\"modal-body p-b-xxs transfer-bag-and-tag\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Discrepancy</label><div class=\"col-lg-9 osd-desc\">{{vm.item.osdComments}}</div></div><div class=\"form-group\" ng-if=\"vm.item.ircNumber\"><label class=\"col-lg-3 control-label\">IRC Number</label><div class=\"col-lg-9 osd-desc\">{{vm.item.ircNumber}}</div></div><div class=\"form-group\"><div ng-hide=\"vm.isVendorInspection\"><label class=\"col-lg-3 control-label\">Resolution</label><div class=\"col-lg-9\"><table class=\"table remove-margin-b\"><thead><tr><th class=\"width-150\">{{vm.item.title}} Quantity</th><th class=\"width-150\">Accepted Quantity</th><th class=\"width-150\">Returned Quantity</th></tr></thead><tr class=\"new-border\"><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.quantity\" numeric-only=\"\" ng-disabled=\"true\"></td><td ng-class=\"{ \'has-error\' : (saveForm.acceptedQuantity.$invalid && !saveForm.acceptedQuantity.$pristine) || saveForm.acceptedQuantity.$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.acceptedQuantity\" ng-max=\"vm.item.quantity\" ng-min=\"0\" name=\"acceptedQuantity\" numeric-only=\"\" required=\"\" ng-disabled=\"vm.saved\" ng-change=\"vm.updateAcceptedQuantity()\" ng-model-options=\"{debounce: 500}\"></td><td ng-class=\"{ \'has-error\' : (saveForm.returnedQuantity.$invalid && !saveForm.returnedQuantity.$pristine) || saveForm.returnedQuantity.$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.returnedQuantity\" ng-max=\"vm.item.quantity\" ng-min=\"0\" name=\"returnedQuantity\" numeric-only=\"\" required=\"\" ng-disabled=\"true\"></td></tr><tr><td colspan=\"3\"><span class=\"text-danger\" ng-show=\"saveForm.acceptedQuantity.$error.ngMin || saveForm.acceptedQuantity.$error.ngMax\">Accepted quantity must be between 0 and {{vm.item.quantity}}.</span> <span class=\"text-danger\" ng-show=\"saveForm.returnedQuantity.$error.ngMin || saveForm.returnedQuantity.$error.ngMax\">Returned quantity must be between 0 and {{vm.item.quantity - vm.item.acceptedQuantity}}.</span> <span class=\"text-danger\" ng-show=\"(vm.item.quantity - vm.item.acceptedQuantity - vm.item.returnedQuantity) < 0\">Returned quantity must not be less than 0.</span></td></tr></table></div></div></div><div ng-if=\"vm.item.acceptedQuantity > 0\"><div class=\"hr-line-dashed\"></div><div class=\"table-responsive\"><table class=\"table\"><thead><th></th><th class=\"visible-lg-block\" style=\"border:none\">Cost code</th><th>Material code</th><th>Barcode</th><th>UOM</th><th class=\"width-100\">Checked Qty</th><th>Stored Qty</th><th></th></thead><tbody wg-add-stored-item=\"\" item=\"vm.item\" locations=\"vm.locations\"></tbody></table></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Comments *</label><div class=\"col-lg-9\"><textarea type=\"text\" class=\"form-control\" ng-model=\"vm.item.comments\" style=\"resize: none;\" ng-disabled=\"vm.saved\" required=\"\"></textarea></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Item successfully resolved.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error resolving this item. <span ng-if=\"vm.errorMessage !== null\">{{vm.errorMessage}}</span></div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"!vm.hasValidQuantities() || vm.saved || saveForm.$invalid\">Resolve</button></div></div>");
$templateCache.put("app/osd-register/osdResolveShortageModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Resolve shortage - {{vm.item.number}}</h4><h4>Shortage quantity: {{vm.item.quantity}}</h4><small class=\"font-bold\">{{vm.item.description | uppercase}}</small></div><div class=\"modal-body p-b-xxs transfer-bag-and-tag\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Comments</label><div class=\"col-lg-9\"><textarea type=\"text\" class=\"form-control\" ng-model=\"vm.item.comments\" style=\"resize: none;\" ng-disabled=\"vm.saved\"></textarea></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Item successfully resolved.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error resolving this item.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.item.comments === null || vm.saved\">Resolve</button></div></div>");
$templateCache.put("app/osd-register/viewOsdRegister.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"tabs-container col-lg-12\" ng-controller=\"ViewOsdRegisterCtrl as vm\"><uib-tabset><uib-tab><uib-tab-heading><i class=\"fa fa-warning\"></i>Unresolved <span class=\"badge label-warning\">{{vm.osdRegisterIncomplete.length}}</span></uib-tab-heading><div class=\"panel-body\"><div class=\"add-pd-b\"><wg-add-osd-from-stored-item post-update-delegate=\"vm.refreshTabs()\"></wg-add-osd-from-stored-item></div><strong ng-if=\"!vm.osdRegisterIncomplete.length\">There are no unresolved Over, Short or Damaged items.</strong><div ng-if=\"vm.osdRegisterIncomplete.length\"><div class=\"table-responsive\"><table class=\"table\"><thead><tr><th>Type</th><th>#</th><th>Delivery No.</th><th>PO No. / Item</th><th>Qty</th><th>Description</th><th>Discrepancy</th><th>Supplier</th><th>Date raised</th><th></th></tr></thead><tbody><tr ng-repeat=\"osd in vm.osdRegisterIncomplete | orderBy: \'-number\'\"><td><span ng-class=\"{Damaged:\'badge label-danger\', Over:\'badge label-danger\', Inspection:\'badge label-danger\',\'Vendor Inspection\':\'badge label-danger\', Other:\'badge\', Short:\'badge\' }[osd.type]\">{{ osd.type }}</span></td><td>{{ osd.number }}</td><td>{{ osd.deliveryNumber }}</td><td class=\"text-nowrap\">{{ osd.purchaseOrderNumber }} / {{ osd.purchaseOrderLineNumber }}</td><td style=\"text-align: right\">{{ osd.quantity }}</td><td>{{ osd.description }}</td><td>{{ osd.osdComments }}</td><td>{{ osd.supplierName }}</td><td class=\"text-nowrap\">{{ osd.raisedDate | date:\'dd-MMM-yyyy\' }}</td><td><wg-osd-resolution id=\"osd.id\" type=\"osd.type\" post-update-delegate=\"vm.refreshTabs()\"></wg-osd-resolution></td></tr></tbody></table></div></div></div></uib-tab><uib-tab><uib-tab-heading><i class=\"fa fa-check-square-o\"></i>Resolved <span class=\"badge\">{{vm.osdRegisterComplete.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.osdRegisterComplete.length\">There are no resolved Over, Short or Damaged items.</strong><div ng-if=\"vm.osdRegisterComplete.length\"><table class=\"table\"><thead><tr><th>Type</th><th>#</th><th>Delivery No.</th><th>PO No. / Item</th><th>Qty</th><th>Description</th><th>Comments</th><th>Supplier</th><th>Date resolved</th></tr></thead><tbody class=\"rowlink\"><tr ng-repeat=\"osd in vm.osdRegisterComplete | orderBy: -number\"><td><span ng-class=\"{Damaged:\'badge label-danger\', Over:\'badge label-danger\', \'Vendor Inspection\':\'badge label-danger\', Inspection:\'badge label-danger\', Other:\'badge\', Short:\'badge\' }[osd.type]\">{{ osd.type }}</span></td><td>{{ osd.number }}</td><td>{{ osd.deliveryNumber }}</td><td class=\"text-nowrap\">{{ osd.purchaseOrderNumber }} / {{ osd.purchaseOrderLineNumber }}</td><td style=\"text-align: right\">{{ osd.quantity }}</td><td>{{ osd.description }}</td><td>{{ osd.comments }}</td><td>{{ osd.supplierName }}</td><td class=\"text-nowrap\">{{ osd.completedDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table></div></div></uib-tab></uib-tabset></div></div></div>");
$templateCache.put("app/projects/createProject.html","<div ng-controller=\"CreateProjectCtrl as vm\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox-title\"><h5>Create a Project</h5></div><div class=\"form-group\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div></div><form role=\"form\" name=\"createForm\" ng-submit=\"vm.createProject()\"><div class=\"row\"><div class=\"col-md-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : createForm.client.$invalid && !createForm.client.$pristine }\"><label class=\"control-label\" for=\"client\">Client</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.project.client\" id=\"client\" name=\"client\" required=\"\" ng-class=\"{ \'has-error\' : createForm.client.$invalid && !createForm.client.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : createForm.name.$invalid && !createForm.name.$pristine }\"><label class=\"control-label\" for=\"name\">Name</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.project.name\" name=\"name\" id=\"name\" minlength=\"1\" maxlength=\"20\" required=\"\" ng-class=\"{ \'has-error\' : createForm.name.$invalid && !createForm.name.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : createForm.code.$invalid && !createForm.code.$pristine }\"><label class=\"control-label\" for=\"code\">Code</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.project.code\" name=\"code\" id=\"code\" maxlength=\"3\" minlength=\"3\" required=\"\" ng-class=\"{ \'has-error\' : createForm.code.$invalid && !createForm.code.$pristine }\" capitalize=\"\" letters-only=\"\"> <span class=\"text-danger\" ng-show=\"createForm.code.$error.minlength || createForm.code.$error.maxlength\">Code must be 3 characters.</span></div></div><div class=\"col-md-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : (createForm.startDate.$invalid && !createForm.startDate.$pristine) || (createForm.startDateMobile.$invalid && !createForm.startDateMobile.$pristine) }\"><label class=\"control-label\" for=\"startDate\">Start Date</label><div class=\"input-group date hidden-xs\"><input type=\"text\" name=\"startDate\" class=\"form-control\" id=\"startDate\" ng-click=\"vm.calendar.open($event, \'startDate\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" uib-tooltip=\"Start date of the project.\" ng-model=\"vm.project.startDate\" is-open=\"vm.calendar.opened.startDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" max-date=\"vm.project.endDate\" date-to-iso=\"\" required=\"\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'startDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div><div class=\"input-group date visible-xs\"><datepicker name=\"startDateMobile\" ng-model=\"vm.project.startDate\" is-open=\"vm.calendar.opened.startDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" max-date=\"vm.project.endDate\" required=\"\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'startDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></datepicker></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : (createForm.endDate.$invalid && !createForm.endDate.$pristine) || (createForm.endDateMobile.$invalid && !createForm.endDateMobile.$pristine) }\"><label class=\"control-label\" for=\"endDate\">End Date</label><div class=\"input-group date hidden-xs\"><input type=\"text\" name=\"endDate\" class=\"form-control\" id=\"endDate\" ng-click=\"vm.calendar.open($event, \'endDate\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" uib-tooltip=\"End date of the project.\" ng-model=\"vm.project.endDate\" is-open=\"vm.calendar.opened.endDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" min-date=\"vm.project.startDate\" date-to-iso=\"\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div><div class=\"input-group date visible-xs\"><datepicker name=\"endDateMobile\" ng-model=\"vm.project.endDate\" is-open=\"vm.calendar.opened.endDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" min-date=\"vm.project.startDate\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></datepicker></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : createForm.currencyCode.$invalid && !createForm.currencyCode.$pristine }\"><label class=\"control-label\" for=\"currencyCode\">Currency code</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.project.currencyCode\" name=\"currencyCode\" id=\"currencyCode\" maxlength=\"3\" minlength=\"3\" required=\"\" ng-class=\"{ \'has-error\' : createForm.currencyCode.$invalid && !createForm.currencyCode.$pristine }\" capitalize=\"\" letters-only=\"\"> <span class=\"text-danger\" ng-show=\"createForm.currencyCode.$error.minlength || createForm.currencyCode.$error.maxlength\">Code must be 3 characters.</span></div></div><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : (createForm.expenditureOrgCode.$invalid && !createForm.expenditureOrgCode.$pristine) }\"><label class=\"control-label\" for=\"expOrgCode\">Oracle Carrying Out Organization</label> <input type=\"text\" name=\"expOrgCode\" class=\"form-control\" id=\"expOrgCode\" uib-tooltip=\"e.g. 101 Wood Group UK Limited\" ng-model=\"vm.project.expenditureOrgCode\" ng-class=\"{ \'has-error\' : createForm.expenditureOrgCode.$invalid && !createForm.expenditureOrgCode.$pristine }\" required=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : createForm.subProject.$invalid && !createForm.subProject.$pristine }\"><label class=\"control-label\" for=\"subProject\">Sub Project</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.project.subProject\" name=\"subProject\" id=\"subProject\" minlength=\"1\" maxlength=\"20\" ng-class=\"{ \'has-error\' : createForm.subProject.$invalid && !createForm.subProject.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : (createForm.operatingUnitCode.$invalid && !createForm.operatingUnitCode.$pristine) }\"><label class=\"control-label\" for=\"operatingUnitCode\">Operating Unit</label> <input type=\"text\" name=\"operatingUnitCode\" class=\"form-control\" id=\"operatingUnitCode\" uib-tooltip=\"e.g. OU UK\" ng-model=\"vm.project.operatingUnitCode\" ng-class=\"{ \'has-error\' : createForm.operatingUnitCode.$invalid && !createForm.operatingUnitCode.$pristine }\" required=\"\"></div><div class=\"form-group\"><label class=\"\" for=\"enablePOSync\"><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.project.enableSync\" name=\"enableSync\"> Enable PO synchronisation</label></div></div></div><div class=\"row\"><div class=\"col-md-8\"><button type=\"submit\" ladda=\"vm.loading\" class=\"btn btn-primary\" data-style=\"expand-right\" ng-disabled=\"createForm.$invalid\"><i class=\"fa fa-check\"></i> Save</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/projects/viewProject.html","<div ng-controller=\"ViewProjectCtrl as vm\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-10 m-t-md\"><ol class=\"breadcrumb\"><li><a ui-sref=\"index.main\">Home</a></li><li><a ui-sref=\"projects.view\">Projects</a></li><li class=\"active\"><strong>Project details</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"m-b-md\"><h2><span class=\"text-nowrap\">{{ vm.project.name }}</span> <small><strong class=\"text-nowrap\">{{vm.project.code }}</strong></small></h2></div></div></div><div class=\"form-group\"><div class=\"ibox-content\"><div class=\"row\"><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div></div><form role=\"form\" name=\"createForm\" ng-submit=\"vm.updateProject()\"><div class=\"row\"><div class=\"col-md-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : createForm.client.$invalid && !createForm.client.$pristine }\"><label class=\"control-label\" for=\"client\">Client</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.project.client\" id=\"client\" name=\"client\" required=\"\" ng-class=\"{ \'has-error\' : createForm.client.$invalid && !createForm.client.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : createForm.name.$invalid && !createForm.name.$pristine }\"><label class=\"control-label\" for=\"name\">Name</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.project.name\" name=\"name\" id=\"name\" required=\"\" ng-class=\"{ \'has-error\' : createForm.name.$invalid && !createForm.name.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : createForm.code.$invalid && !createForm.code.$pristine }\"><label class=\"control-label\" for=\"code\">Code</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.project.code\" name=\"code\" id=\"code\" maxlength=\"3\" minlength=\"3\" required=\"\" ng-class=\"{ \'has-error\' : createForm.code.$invalid && !createForm.code.$pristine }\" capitalize=\"\" letters-only=\"\"> <span class=\"text-danger\" ng-show=\"createForm.code.$error.minlength || createForm.code.$error.maxlength\">Code must be 3 characters.</span></div></div><div class=\"col-md-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : (createForm.startDate.$invalid && !createForm.startDate.$pristine) || (createForm.startDateMobile.$invalid && !createForm.startDateMobile.$pristine) }\"><label class=\"control-label\" for=\"startDate\">Start Date</label><div class=\"input-group date hidden-xs\"><input type=\"text\" name=\"startDate\" class=\"form-control\" id=\"startDate\" ng-click=\"vm.calendar.open($event, \'startDate\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" uib-tooltip=\"Start date of the project.\" ng-model=\"vm.project.startDate\" is-open=\"vm.calendar.opened.startDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" max-date=\"vm.project.endDate\" date-to-iso=\"\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'startDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : (createForm.endDate.$invalid && !createForm.endDate.$pristine) || (createForm.endDateMobile.$invalid && !createForm.endDateMobile.$pristine) }\"><label class=\"control-label\" for=\"endDate\">End Date</label><div class=\"input-group date hidden-xs\"><input type=\"text\" name=\"endDate\" class=\"form-control\" id=\"endDate\" ng-click=\"vm.calendar.open($event, \'endDate\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" uib-tooltip=\"End date of the project.\" ng-model=\"vm.project.endDate\" is-open=\"vm.calendar.opened.endDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" min-date=\"vm.project.startDate\" date-to-iso=\"\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'endDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : createForm.currencyCode.$invalid && !createForm.currencyCode.$pristine }\"><label class=\"control-label\" for=\"currencyCode\">Currency code</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.project.currencyCode\" name=\"currencyCode\" id=\"currencyCode\" maxlength=\"3\" minlength=\"3\" required=\"\" ng-class=\"{ \'has-error\' : createForm.currencyCode.$invalid && !createForm.currencyCode.$pristine }\" capitalize=\"\" letters-only=\"\"> <span class=\"text-danger\" ng-show=\"createForm.currencyCode.$error.minlength || createForm.currencyCode.$error.maxlength\">Code must be 3 characters.</span></div></div><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : (createForm.expenditureOrgCode.$invalid && !createForm.expenditureOrgCode.$pristine) }\"><label class=\"control-label\" for=\"expOrgCode\">Oracle Carrying Out Organization</label> <input type=\"text\" name=\"expOrgCode\" class=\"form-control\" id=\"expOrgCode\" uib-tooltip=\"e.g. 101 Wood Group UK Limited\" ng-model=\"vm.project.expenditureOrgCode\" ng-class=\"{ \'has-error\' : createForm.expenditureOrgCode.$invalid && !createForm.expenditureOrgCode.$pristine }\" required=\"\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : createForm.subProject.$invalid && !createForm.subProject.$pristine }\"><label class=\"control-label\" for=\"subProject\">Sub Project</label> <input type=\"text\" class=\"form-control\" ng-model=\"vm.project.subProject\" name=\"subProject\" id=\"subProject\" minlength=\"1\" maxlength=\"20\" ng-class=\"{ \'has-error\' : createForm.subProject.$invalid && !createForm.subProject.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : (createForm.operatingUnitCode.$invalid && !createForm.operatingUnitCode.$pristine) }\"><label class=\"control-label\" for=\"operatingUnitCode\">Operating Unit</label> <input type=\"text\" name=\"operatingUnitCode\" class=\"form-control\" id=\"operatingUnitCode\" uib-tooltip=\"e.g. OU UK\" ng-model=\"vm.project.operatingUnitCode\" ng-class=\"{ \'has-error\' : createForm.operatingUnitCode.$invalid && !createForm.operatingUnitCode.$pristine }\" required=\"\"></div><div class=\"form-group\"><label class=\"\" for=\"enablePOSync\"><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.project.enableSync\" name=\"enableSync\"> Enable PO synchronisation</label></div></div></div><div class=\"row\"><div class=\"col-md-8\"><button type=\"submit\" ladda=\"vm.loading\" class=\"btn btn-primary\" data-style=\"expand-right\" ng-disabled=\"createForm.$invalid\"><i class=\"fa fa-check\"></i> Save</button></div></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("app/projects/viewProjects.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div ng-include=\"\'app/projects/createProject.html\'\"></div><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Projects</h5></div><div class=\"ibox-content\" ng-controller=\"ViewProjectsCtrl as vm\"><table class=\"table\"><thead><tr><th class=\"col-xs-2 text-nowrap\">Client</th><th class=\"col-xs-2 text-nowrap\">Name</th><th class=\"col-xs-2 text-nowrap\">Code</th><th class=\"col-xs-1 text-nowrap\">Start Date</th><th class=\"col-xs-1 text-nowrap\">End Date</th><th class=\"col-xs-1 text-nowrap\">Currency</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr ng-repeat=\"project in vm.projectsCombined | orderBy: \'code\'\"><td><a ui-sref=\"projects.details({id:project.id})\">{{project.client}}</a></td><td>{{ project.name }}</td><td>{{ project.code }}</td><td>{{ project.startDate | date:\'dd-MMM-yyyy\' }}</td><td>{{ project.endDate | date:\'dd-MMM-yyyy\' }}</td><td>{{ project.currencyCode }}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/purchase-orders/addComment.html","<button class=\"btn btn-success\" ng-click=\"vm.openComments()\" ng-show=\"!vm.isEdit\" title=\"View / add comments\"><i class=\"fa fa-comments\"></i><span ng-if=\"!vm.isLine\">View / add comments</span></button>");
$templateCache.put("app/purchase-orders/addCommentModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-comments modal-icon\"></i><h4 class=\"modal-title\">Add comments - Purchase order {{vm.number}}</h4><small ng-if=\"vm.lineItem.materialDescription\" class=\"font-bold\">{{vm.lineItem.materialDescription | uppercase}}</small></div><div class=\"modal-body p-b-xxs\"><div class=\"sk-spinner sk-spinner-three-bounce\" ng-if=\"vm.loading\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Comments *</label><div class=\"col-lg-10\"><textarea required=\"\" type=\"text\" class=\"form-control\" style=\"resize: none; width: 100%\" ng-model=\"vm.item.comments\" name=\"comments\" rows=\"4\" ng-class=\"{ \'has-error\' : saveForm.comments.$invalid && !saveForm.comments.$pristine }\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">ETA Date</label><div class=\"col-lg-4\"><div class=\"input-group date\"><input type=\"text\" name=\"etaDate\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'etaDate\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.item.etaDate\" is-open=\"vm.calendar.opened.etaDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" placeholder=\"Enter ETA Date\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : saveForm.etaDate.$invalid && !saveForm.etaDate.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'etaDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><label class=\"col-lg-2 control-label\">Follow up Date</label><div class=\"col-lg-4\"><div class=\"input-group date\"><input type=\"text\" name=\"followUpDate\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'followUpDate\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.item.followUpDate\" is-open=\"vm.calendar.opened.followUpDate\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" placeholder=\"Enter Follow Up Date\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : saveForm.followUpDate.$invalid && !saveForm.followUpDate.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'followUpDate\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div></div></form><div class=\"modal-footer\"><span ng-if=\"!vm.isLine\"><small>Saving comments and dates at header level will update all lines.</small></span><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error saving the item.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"saveForm.$invalid || vm.saved\">Save</button></div><div class=\"ibox-title\"><h5>Comment history</h5></div><div class=\"ibox-content\" id=\"ibox-content\"><div ng-if=\"!vm.purchaseOrderComments.length\">There are no comments.</div><div id=\"vertical-timeline\" class=\"vertical-container dark-timeline\"><div class=\"vertical-timeline-block\" ng-repeat=\"item in vm.purchaseOrderComments | orderBy: \'createdDate\':true\"><div class=\"vertical-timeline-icon navy-bg\"><i class=\"fa fa-comment\"></i></div><div class=\"vertical-timeline-content\"><h2>{{ item.comments }}</h2><p><span ng-if=\"item.etaDate\"><strong>ETA Date:</strong> {{item.etaDate | date:\'dd-MMM-yyyy\'}}</span> <span ng-if=\"item.followUpDate\"><span ng-if=\"item.etaDate\">|</span><strong>Follow Up Date:</strong> {{item.followUpDate | date:\'dd-MMM-yyyy\'}}</span></p><span class=\"vertical-date\">{{ item.createdBy }}<br><small am-time-ago=\"item.createdDate\" title=\"{{item.createdDate | date:\'dd-MMM-yyyy HH:mm\'}}\"></small></span></div></div></div></div></div></div>");
$templateCache.put("app/purchase-orders/addLineItem.html","<button class=\"btn btn-success\" ng-click=\"vm.openAddLineItem()\" ng-show=\"!vm.isEdit\" title=\"Add a new line item\"><i class=\"fa fa-plus\"></i> Add line item</button> <button class=\"btn btn-primary\" ng-click=\"vm.openAddLineItem()\" ng-show=\"vm.isEdit\" title=\"Edit line item\"><i class=\"fa fa-edit\"></i></button>");
$templateCache.put("app/purchase-orders/addLineItemModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-credit-card modal-icon\"></i><h4 class=\"modal-title\">Add line item</h4></div><div class=\"modal-body p-b-xxs transfer-bag-and-tag\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Material code *</label><div class=\"col-lg-4\"><select kendo-combo-box=\"\" k-options=\"vm.materialCodesOptions\" ng-model=\"vm.lineItem.materialCode\" name=\"materialCodes\" style=\"width:100%\" ng-disabled=\"vm.saving\"></select></div><label class=\"col-lg-2 control-label\">Cost code *</label><div class=\"col-lg-4\"><select kendo-combo-box=\"\" k-options=\"vm.costCodesOptions\" ng-model=\"vm.lineItem.costCode\" name=\"costCodes\" style=\"width:100%\" ng-disabled=\"vm.saving\"></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Description *</label><div class=\"col-lg-10\"><textarea required=\"\" type=\"text\" class=\"form-control\" style=\"resize: none; width: 100%\" ng-model=\"vm.lineItem.description\" name=\"itemDescription\" rows=\"4\" ng-class=\"{ \'has-error\' : save.itemDescription.$invalid && !save.itemDescription.$pristine }\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Quantity *</label><div class=\"col-lg-4\"><input type=\"text\" required=\"\" numeric-only=\"\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.quantity\" style=\"width: 50%\"></div><label class=\"col-lg-2 control-label\">UOM *</label><div class=\"col-lg-4\"><select kendo-combo-box=\"\" k-options=\"vm.unitsOfMeasureOptions\" ng-model=\"vm.lineItem.unitOfMeasureCode\" name=\"unitsOfMeasure\" style=\"width:100%\" ng-disabled=\"vm.saving\"></select></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Item unit price *</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.lineItem.price\" placeholder=\"0.00\" style=\"width: 50%\" ng-pattern=\"/(^\\d{0,6}?)+(\\.\\d{1,2})?$/\" step=\"0.01\"></div><label class=\"col-lg-2 control-label\">Currency</label><div class=\"col-lg-4\"><input type=\"text\" class=\"form-control col-lg-2\" ng-model=\"vm.selectedCurrency\" readonly=\"\" style=\"width: 50%\"></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Item successfully saved.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error saving the item.</div><span class=\"pr20\"><input type=\"checkbox\" icheck=\"\" ng-model=\"vm.addAnother\"> Add another</span> <button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"!vm.lineItem.materialCode || !vm.lineItem.costCode || !vm.lineItem.description || !vm.lineItem.quantity || !vm.lineItem.unitOfMeasureCode || !vm.lineItem.price || !vm.selectedCurrency || vm.saved\">Save</button></div></div>");
$templateCache.put("app/purchase-orders/details.html","<div ng-controller=\"DetailsCtrl as vm\"><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"m-b-md\"><h2><span class=\"text-nowrap\">Purchase order {{ vm.purchaseOrder.number }}</span> <small><strong class=\"text-nowrap\">{{ vm.purchaseOrder.description }}</strong></small> <span ng-class=\"(vm.purchaseOrder.statusId === 1) ? \'badge label-warning\' : (vm.purchaseOrder.statusId === 2) ? \'badge label-danger\' : \'badge label-primary\'\">{{(vm.purchaseOrder.statusId === 1) ? \'Incomplete\' : (vm.purchaseOrder.statusId === 2) ? \'Cancelled\' : \'Complete\'}}</span></h2><span class=\"text-nowrap\"><strong>Supplier:</strong> {{vm.purchaseOrder.supplierName}}</span> | <span class=\"text-nowrap\"><strong>Created date:</strong> {{vm.purchaseOrder.date | date: \'dd-MMM-yyyy\'}}</span> <span ng-if=\"vm.purchaseOrder.isManual && vm.purchaseOrder.statusId === 3\">| <span class=\"text-nowrap\"><strong>Completed by:</strong> {{vm.purchaseOrder.completedBy}}</span> | <span class=\"text-nowrap\"><strong>Completed date:</strong> {{vm.purchaseOrder.completedDate | date: \'dd-MMM-yyyy\'}}</span></span></div></div></div></div><div class=\"ibox-footer\" ng-if=\"!vm.purchaseOrder.isManual\"><div ng-cloak=\"\"><div class=\"pull-left\"><wg-add-comment purchase-order-id=\"vm.purchaseOrderId\" number=\"vm.purchaseOrder.number\"></wg-add-comment></div><div class=\"pull-right\"><wg-small-progress-bar title=\"Overall delivery completion\" total=\"vm.completionTotal\"></wg-small-progress-bar></div><div class=\"clearfix\"></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox\"><div class=\"ibox-title\"><div class=\"btn-toolbar add-pd-b\" ng-if=\"vm.purchaseOrder.isManual && vm.purchaseOrder.statusId === 1\"><wg-add-line-item purchase-order-id=\"vm.purchaseOrder.id\" post-update-delegate=\"vm.fakeLineItems(item)\"></wg-add-line-item><button class=\"btn btn-primary\" ng-click=\"vm.completePurchaseOrder()\"><i class=\"fa fa-check-square-o\"></i> Complete</button> <button class=\"btn btn-warning\" ng-click=\"vm.cancelPurchaseOrder()\"><i class=\"fa fa-times\"></i> Cancel</button></div><div class=\"table-responsive\"><table class=\"table materia-grouped-row\"><thead><tr><th>Line No.</th><th>Material Code</th><th>Cost Code</th><th ng-if=\"vm.purchaseOrder.statusId != 1\">Workpack</th><th ng-if=\"vm.purchaseOrder.statusId != 1\">Buyer</th><th ng-if=\"vm.purchaseOrder.statusId != 1\">ETA Date</th><th ng-if=\"vm.purchaseOrder.statusId != 1\">Promised</th><th style=\"text-align: right\">Unit Price</th><th style=\"text-align: center\">UOM</th><th ng-if=\"vm.purchaseOrder.statusId != 1\">Dual Use?</th><th>Ordered</th><th ng-if=\"vm.purchaseOrder.statusId != 1\">Outstanding</th><th ng-if=\"vm.purchaseOrder.statusId != 1\">Delivery in progress</th><th ng-if=\"vm.purchaseOrder.statusId != 1\">OS&D</th><th ng-if=\"vm.purchaseOrder.statusId != 1\">Stored</th><th ng-if=\"vm.purchaseOrder.statusId != 1\">Issued</th><th ng-if=\"vm.purchaseOrder.statusId != 1\">Available</th><th ng-if=\"vm.purchaseOrder.isManual && vm.purchaseOrder.statusId === 1\"></th></tr></thead><tbody ng-repeat=\"line in vm.purchaseOrderLines | orderBy: natural(\'lineNumber\')\" wg-purchase-order-line=\"\" item=\"line\" is-manual=\"vm.purchaseOrder.isManual\" status-id=\"vm.purchaseOrder.statusId\" delete-purchase-order-line-item=\"vm.deletePurchaseOrderLineItem(id)\"></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/purchase-orders/getPurchaseOrder.html","<div ng-controller=\"GetPurchaseOrderCtrl as vm\"><form role=\"form\" name=\"getPurchaseOrderForm\" ng-submit=\"vm.getPurchaseOrder()\"><div class=\"row\"><div class=\"col-md-4\"><label class=\"control-label\" for=\"purchaseOrderNumber\">Purchase Order number</label> <input type=\"text\" class=\"form-control k-textbox\" name=\"purchaseOrderNumber\" placeholder=\"Enter a Purchase Order number\" required=\"\" ng-model=\"vm.purchaseOrderNumber\" ng-class=\"{ \'has-error\' : getPurchaseOrderForm.description.$invalid && !getPurchaseOrderForm.number.$pristine }\"></div><div class=\"col-lg-1 label-pad\"><button type=\"submit\" ladda=\"vm.loading\" class=\"btn btn-primary\" ng-disabled=\"getPurchaseOrderForm.$invalid\">Go</button></div></div><div class=\"row\"><div class=\"col-lg-12\"><p class=\"user-info {{vm.loadingClass}}\" ng-if=\"!vm.successful\">{{ vm.status }}</p><p class=\"user-info\" ng-if=\"vm.successful\">Purchase Order <strong>{{ vm.response.purchaseOrderNumber }}</strong> from <strong>{{ vm.response.supplier }}</strong> has been successfully imported ({{ vm.response.lineCount }} lines).</p></div></div></form></div>");
$templateCache.put("app/purchase-orders/importPOItems.html","<div ng-controller=\"ImportPOItemsCtrl as vm\"><form role=\"form\" name=\"poImport\"><div class=\"row\"><div class=\"col-md-12\"><button ladda=\"vm.loading\" type=\"submit\" class=\"btn btn-primary m-t-n-xs\" ng-click=\"vm.downloadTemplate()\"><i class=\"fa fa-download\"></i> Download template</button></div></div><div class=\"ibox\"></div><div class=\"row\"><div class=\"dz-container dropzone border-dashed\" dropzone=\"\" parent-id=\"\" import-endpoint=\"vm.importEndpoint\" get-import-errors=\"vm.getImportErrors(parentId, documentKey)\" id=\"dropzone\"><div class=\"dz-message\"><h4><i class=\"fa fa-upload fa-lg\"></i> Drop files here or click to upload</h4></div><div id=\"previews\"><div id=\"template\" class=\"dz-file-preview\"><div class=\"dz-file-preview-top\"><div id=\"upload-image\" class=\"dz-image\"><span class=\"preview\"><img data-dz-thumbnail=\"\"></span></div><div id=\"upload-info\" class=\"dz-info-upload\"><p class=\"dz-name\" data-dz-name=\"\"></p><p class=\"size\" data-dz-size=\"\"></p><strong class=\"error text-danger\" data-dz-errormessage=\"\"></strong></div><div class=\"dz-remove\"><button data-dz-remove=\"\" class=\"btn btn-danger delete pull-right\"><i class=\"fa fa-times\"></i></button></div><div class=\"clearfix\"></div><div class=\"progress progress-striped active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" aria-valuenow=\"0\" id=\"progressBar\" style=\"width: 100%; height: 5px; position: absolute; bottom: 0px; margin-top: 10px;\"><div class=\"progress-bar progress-bar-success\" style=\"width:0%;\" data-dz-uploadprogress=\"\"></div></div></div><div class=\"dz-file-preview-bottom\"></div></div></div></div></div></form></div>");
$templateCache.put("app/purchase-orders/purchaseOrderLineDeliveries.html","<button class=\"btn btn-primary\" ng-click=\"vm.openDeliveries()\">Deliveries</button>");
$templateCache.put("app/purchase-orders/purchaseOrderLineDeliveriesModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><small class=\"font-bold\">Deliveries for</small><h4 class=\"modal-title\">{{vm.purchaseOrderLine.purchaseOrderNumber}} - {{vm.purchaseOrderLine.lineNumber}}</h4><small class=\"font-bold\">{{vm.purchaseOrderLine.description | uppercase}}</small></div><div class=\"modal-body p-b-xxs\"><div class=\"sk-spinner sk-spinner-three-bounce\" ng-if=\"vm.loading\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div><div class=\"ibox-content\" ng-if=\"!vm.loading\"><table class=\"table\"><thead><tr><th class=\"col-xs-3 text-nowrap\">Number</th><th class=\"col-xs-3 text-nowrap\">Created by</th><th class=\"col-xs-3 text-center text-nowrap\">Stored date</th><th class=\"col-xs-3\"></th></tr></thead><tbody><tr ng-repeat=\"item in vm.deliveries | orderBy: \'lastUpdatedDate\' : true\"><td>{{ item.deliveryNumber }}</td><td>{{ item.createdBy }}</td><td class=\"text-center text-nowrap\">{{ item.lastUpdatedDate | date:\'dd-MMM-yyyy HH:mm\' }}</td><td><button class=\"btn btn-primary pull-right\" ng-click=\"vm.goToDelivery(item.deliveryId)\">Go to delivery</button></td></tr></tbody></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button></div></div>");
$templateCache.put("app/purchase-orders/viewHistory.html","<button class=\"btn btn-primary\" ng-click=\"vm.openHistory()\" title=\"View history\"><i class=\"fa fa-history\"></i></button>");
$templateCache.put("app/purchase-orders/viewHistoryModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-history modal-icon\"></i><h4 class=\"modal-title\">Material History</h4><small ng-if=\"vm.materialDescription\" class=\"font-bold\">{{ vm.materialDescription | uppercase }}</small></div><div class=\"modal-body p-b-xxs\"><div class=\"sk-spinner sk-spinner-three-bounce\" ng-if=\"vm.loading\"><div class=\"sk-bounce1\"></div><div class=\"sk-bounce2\"></div><div class=\"sk-bounce3\"></div></div><div class=\"ibox-content\" id=\"ibox-content\"><div ng-if=\"!vm.history.length\">There is no material history.</div><div id=\"vertical-timeline\" class=\"vertical-container dark-timeline\"><div class=\"vertical-timeline-block\" ng-repeat=\"item in vm.history | orderBy: \'createdDate\':true\"><div class=\"vertical-timeline-icon {{ item.colour }}-bg\"><i class=\"fa {{ item.icon }}\"></i></div><div class=\"vertical-timeline-content\"><h2>{{ item.type }}</h2><p>{{ item.description }}</p><span class=\"vertical-date\">{{ item.createdBy }}<br><small am-time-ago=\"item.createdDate\" title=\"{{item.createdDate | date:\'dd-MMM-yyyy HH:mm\'}}\"></small></span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button></div></div>");
$templateCache.put("app/purchase-orders/viewPurchaseOrders.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><form role=\"form\" name=\"createForm\" ng-submit=\"vm.createPurchaseOrder()\" ng-controller=\"CreatePurchaseOrderCtrl as vm\"><div class=\"ibox-title\"><h5 for=\"product_name\">Create a non-PO receipt</h5></div><div class=\"form-group\"><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-2\"><label class=\"control-label\" for=\"number\">Number</label> <input type=\"text\" class=\"form-control k-textbox\" name=\"number\" id=\"number\" placeholder=\"(Optional)\" ng-model=\"vm.purchaseOrder.number\" uib-tooltip=\"Where no system PO information is available client, vendor or third party PO reference should be used. Leave blank if neither option is available.\" tooltip-placement=\"bottom\" ng-class=\"{ \'has-error\' : createForm.number.$invalid && !createForm.number.$pristine }\"></div><div class=\"col-md-6\"><label class=\"control-label\" for=\"description\">Description *</label> <input type=\"text\" class=\"form-control k-textbox\" name=\"description\" placeholder=\"Enter a description\" required=\"\" ng-model=\"vm.purchaseOrder.description\" ng-class=\"{ \'has-error\' : createForm.description.$invalid && !createForm.number.$pristine }\"></div><div class=\"col-lg-3\"><label class=\"control-label\" for=\"supplierName\">Supplier *</label><select kendo-combo-box=\"\" ng-model=\"vm.selectedSupplier\" k-options=\"vm.suppliersOptions\" class=\"form-control\" name=\"supplierName\" required=\"\" ng-class=\"{ \'has-error\' : createForm.supplierName.$invalid && !createForm.supplierName.$pristine }\"></select></div><div class=\"col-lg-1 label-pad\"><button type=\"submit\" ladda=\"vm.loading\" class=\"btn btn-primary\" ng-disabled=\"createForm.$invalid\">Create</button></div></div></div></div></div></form></div></div><div class=\"tabs-container\" ng-controller=\"ViewPurchaseOrdersCtrl as vm\"><uib-tabset><uib-tab><uib-tab-heading><i class=\"fa fa-warning\"></i>Incomplete <span class=\"badge label-warning\">{{vm.incompletePurchaseOrders.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.incompletePurchaseOrders.length\">There are no incomplete non-purchase order receipts.</strong><div ng-if=\"vm.incompletePurchaseOrders.length\"><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-3 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Supplier</th><th class=\"col-xs-1 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr ng-repeat=\"po in vm.incompletePurchaseOrders | orderBy: number\"><td><a ui-sref=\"purchase-orders.details({id:po.id})\">{{ po.number }}</a></td><td>{{ po.description }}</td><td>{{ po.supplierName }}</td><td>{{ po.date | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table></div></div></uib-tab><uib-tab><uib-tab-heading><i class=\"fa fa-check-square-o\"></i>Completed <span class=\"badge label-primary\">{{ vm.completePurchaseOrders.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.completePurchaseOrders.length\">There are no completed non-purchase order receipts.</strong><div ng-if=\"vm.completePurchaseOrders.length\"><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-3 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Supplier</th><th class=\"col-xs-2 text-nowrap\">Completed by</th><th class=\"col-xs-1 text-nowrap\">Complete date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr ng-repeat=\"po in vm.completePurchaseOrders | orderBy: number\"><td><a ui-sref=\"purchase-orders.details({id:po.id})\">{{ po.number }}</a></td><td>{{ po.description }}</td><td>{{ po.supplierName }}</td><td>{{ po.completedBy }}</td><td>{{ po.completedDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table></div></div></uib-tab><uib-tab><uib-tab-heading><i class=\"fa fa-upload\"></i>Import</uib-tab-heading><div class=\"panel-body\"><div ng-include=\"\'app/purchase-orders/importPOItems.html\'\"></div></div></uib-tab><uib-tab ng-show=\"vm.canGetPurchaseOrder\"><uib-tab-heading><i class=\"fa fa-get-pocket\"></i>Get Purchase Order</uib-tab-heading><div class=\"panel-body\"><div ng-include=\"\'app/purchase-orders/getPurchaseOrder.html\'\"></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/purchase-orders/viewReceiptDetails.html","<div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ViewReceiptDetailsCtrl as vm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row add-pd-b\"><div class=\"col-lg-12\"><div class=\"ibox-title\"><a ng-click=\"vm.backBtn()\" href=\"\"><h5><span><i class=\"fa fa-chevron-circle-left\"></i></span> Back</h5></a></div></div></div><div class=\"float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"m-b-md\"><h2><span class=\"text-nowrap\">Purchase order {{ vm.purchaseOrder.number }}</span> <small><strong class=\"text-nowrap\">{{ vm.purchaseOrder.description }}</strong></small></h2><span class=\"text-nowrap\"><strong>Supplier:</strong> {{vm.purchaseOrder.supplierName}}</span> | <span class=\"text-nowrap\"><strong>Created date:</strong> {{vm.purchaseOrder.date | date: \'dd-MMM-yyyy\'}}</span><div class=\"row m-t-sm\"><div class=\"col-md-4\"><label class=\"control-label\">Receipt status</label><select class=\"form-control\" ng-model=\"vm.statusSelected\" ng-options=\"status as status.text for status in vm.receiptStatusOptions\"></select></div></div></div></div></div></div></div><div class=\"ibox-content\"><div class=\"panel-body\"><div ng-if=\"vm.purchaseOrderLines.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">Line No.</th><th class=\"col-xs-6 text-nowrap\">Description</th><th class=\"col-xs-1 text-nowrap\">Buyer</th><th class=\"col-xs-1 text-center text-nowrap\">Last receipted in Materia</th><th class=\"col-xs-1 text-center text-nowrap\">Last receipted in Oracle</th><th class=\"col-xs-1 text-center\">Status</th><th></th></tr></thead><tbody><tr dir-paginate=\"item in vm.purchaseOrderLines | filter: vm.statusFilter| orderBy: natural(\'lineNumber\') | itemsPerPage: 15\" pagination-id=\"incomplete\"><td>{{ item.lineNumber }}</td><td>{{ item.description }}</td><td class=\"text-nowrap\">{{ item.buyerName }}</td><td class=\"text-center\">{{ item.lastReceivedInMateria | date:\'dd-MMM-yyyy HH:mm\' }}</td><td class=\"text-center\"><span ng-if=\"item.lastUpdatedInOracle !== null\">{{ item.lastUpdatedInOracle | date:\'dd-MMM-yyyy HH:mm\' }}</span> <span ng-if=\"item.lastUpdatedInOracle == null\">-</span></td><td class=\"text-center\"><span ng-if=\"item.receivedStatusId === 1\" style=\"color: red\" uib-tooltip=\"Receipts for this purchase order line have been sent to Oracle and are waiting to be processed.\"><i class=\"fa fa-times-circle-o fa-2x\"></i></span> <span ng-if=\"item.receivedStatusId === 2\" style=\"color: red\" uib-tooltip=\"Receipts for this purchase order line have been sent to Oracle but have exceeded the processing threshold.\"><i class=\"fa fa-times-circle fa-2x\"></i></span> <span ng-if=\"item.receivedStatusId === 3\" style=\"color: green\" uib-tooltip=\"Receipts for this purchase order line have been receipted in Oracle.\"><i class=\"fa fa-check-circle fa-2x\"></i></span></td><td><wg-purchase-order-line-deliveries id=\"item.purchaseOrderLineId\" \"=\"\"></wg-purchase-order-line-deliveries></td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls></div></div></div></div></div></div>");
$templateCache.put("app/purchase-orders/viewReceipts.html","<div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ViewReceiptsCtrl as vm\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row add-pd-b\"><div class=\"col-lg-12\"><form role=\"form\" name=\"receiptsFilter\"><div class=\"ibox-title\"><h5>Receipt filters</h5></div><div class=\"ibox-content\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-4\"><label class=\"control-label\" for=\"receiptStatus\">Receipt status</label><select kendo-combo-box=\"\" k-options=\"vm.receiptStatusOptions\" k-ng-model=\"vm.statusSelected\" name=\"receiptStatus\" id=\"receiptStatus\" class=\"form-control\"></select></div><div class=\"col-md-2 label-pad\"><button type=\"button\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-click=\"vm.getReceiptedPurchaseOrders()\">Go!</button></div></div></div></div></form></div></div><div class=\"ibox-content\"><div class=\"panel-body\"><span ng-if=\"!vm.incompletePurchaseOrderReceipts.length\"><strong><span ng-if=\"vm.statusSelected.value === \'incomplete\'\">There are no items waiting to be receipted in Oracle.</span> <span ng-if=\"vm.statusSelected.value === \'overdue\'\">There are no overdue items (> 60 mins) waiting to be receipted in Oracle.</span> <span ng-if=\"vm.statusSelected.value === \'complete\'\">There are no items completely receipted in Oracle.</span></strong></span><div ng-if=\"vm.incompletePurchaseOrderReceipts.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">PO Number</th><th class=\"col-xs-2 text-nowrap\">Supplier</th><th class=\"col-xs-1 text-center\">No of lines</th><th class=\"col-xs-1 text-center\">Last receipted in Materia</th><th class=\"col-xs-1 text-center\">Last receipted in Oracle</th><th class=\"col-xs-1 text-center\">Status</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"item in vm.incompletePurchaseOrderReceipts | orderBy: \'lastReceivedInMateria\' : true | itemsPerPage: 15\" pagination-id=\"incomplete\"><td><a ui-sref=\"receipts.details({id:item.purchaseOrderId})\">{{ item.number }}</a></td><td>{{ item.supplierName }}</td><td class=\"text-center\">{{ item.lineCount }}</td><td class=\"text-center\"><span am-time-ago=\"item.lastReceivedInMateria\" title=\"{{item.lastReceivedInMateria | date:\'dd-MMM-yyyy HH:mm\'}}\"></span></td><td class=\"text-center\"><span ng-if=\"item.lastUpdatedInOracle !== null\" am-time-ago=\"item.lastUpdatedInOracle\" title=\"{{item.lastUpdatedInOracle | date:\'dd-MMM-yyyy HH:mm\'}}\"></span> <span ng-if=\"item.lastUpdatedInOracle === null\">-</span></td><td class=\"text-center\"><span ng-if=\"item.receivedStatusId === 1\" style=\"color: red\" uib-tooltip=\"Receipts for this purchase order have been sent to Oracle and are waiting to be processed.\"><i class=\"fa fa-times-circle-o fa-2x\"></i></span> <span ng-if=\"item.receivedStatusId === 2\" style=\"color: red\" uib-tooltip=\"Receipts for this purchase order have been sent to Oracle but have exceeded the processing threshold.\"><i class=\"fa fa-times-circle fa-2x\"></i></span> <span ng-if=\"item.receivedStatusId === 3\" style=\"color: green\" uib-tooltip=\"Receipts for this purchase order have been receipted in Oracle.\"><i class=\"fa fa-check-circle fa-2x\"></i></span></td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls></div></div></div></div></div></div>");
$templateCache.put("app/reporting/bagAndTagReport.html","<div class=\"ibox-title\"><h5>Bag & Tag Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"BagAndTagReportCtrl as vm\" class=\"form-horizontal\"><div class=\"row\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.bagAndTag.$invalid && !report.bagAndTag.$pristine }\"><label class=\"control-label col-sm-2\" for=\"bagAndTag\">Bag & Tag Number</label><div class=\"col-sm-4\"><select kendo-combo-box=\"\" k-options=\"vm.bagAndTagNumbersOptions\" k-ng-model=\"vm.bagAndTagSelected\" k-ng-delay=\"vm.bagAndTagSelected\" required=\"\" name=\"bagAndTag\" id=\"bagAndTag\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.bagAndTag.$invalid && !report.bagAndTag.$pristine }\"></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Report Format</label><div class=\"col-sm-4\"><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> <label class=\"control-label\" for=\"pdf\">PDF</label></div><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" ng-disabled=\"true\" class=\"form-control\"> <label class=\"control-label\" for=\"excel\">Excel</label></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/expeditingHistoryReport.html","<div class=\"ibox-title\"><h5>Expediting History Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"ExpeditingHistoryReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.supplier.$invalid && !report.supplier.$pristine }\"><label class=\"control-label\" for=\"supplier\">Supplier</label><select kendo-combo-box=\"\" k-options=\"vm.supplierOptions\" k-ng-model=\"vm.supplierSelected\" k-ng-delay=\"vm.supplierSelected\" name=\"supplier\" id=\"supplier\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.supplier.$invalid && !report.supplier.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><div class=\"input-group\" style=\"width:100%;\"><select name=\"purchaseOrder\" kendo-multi-select=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" style=\"width: 100%;\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.refNo.$invalid && !report.refNo.$pristine }\"><label class=\"control-label\" for=\"refNo\">Ref Number</label><select kendo-combo-box=\"\" k-options=\"vm.refNumberOptions\" k-ng-model=\"vm.refNumberSelected\" k-ng-delay=\"vm.refNumberSelected\" name=\"refNo\" id=\"refNo\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.refNo.$invalid && !report.refNo.$pristine }\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"timeInterval\">Arriving within</label><select kendo-combo-box=\"\" k-options=\"vm.timeIntervalOptions\" k-ng-model=\"vm.timeInterval\" name=\"timeInterval\" id=\"timeInterval\" class=\"form-control\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\" ng-disabled=\"true\" uib-tooltip=\"PDF is not available for this report\" tooltip-placement=\"bottom\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\" ng-disabled=\"true\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/expeditingReport.html","<div class=\"ibox-title\"><h5>Expediting Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"ExpeditingReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.supplier.$invalid && !report.supplier.$pristine }\"><label class=\"control-label\" for=\"supplier\">Supplier</label><select kendo-combo-box=\"\" k-options=\"vm.supplierOptions\" k-ng-model=\"vm.supplierSelected\" k-ng-delay=\"vm.supplierSelected\" name=\"supplier\" id=\"supplier\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.supplier.$invalid && !report.supplier.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.buyerName.$invalid && !report.buyerName.$pristine }\"><label class=\"control-label\" for=\"buyerName\">Buyer Name</label><select kendo-combo-box=\"\" k-options=\"vm.buyerNameOptions\" k-ng-model=\"vm.buyerNameSelected\" k-ng-delay=\"vm.buyerNameSelected\" name=\"buyerName\" id=\"buyerName\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.buyerName.$invalid && !report.buyerName.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><div class=\"input-group\" style=\"width:100%;\"><select name=\"purchaseOrder\" kendo-multi-select=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" style=\"width: 100%;\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.refNo.$invalid && !report.refNo.$pristine }\"><label class=\"control-label\" for=\"refNo\">Ref Number</label><select kendo-combo-box=\"\" k-options=\"vm.refNumberOptions\" k-ng-model=\"vm.refNumberSelected\" k-ng-delay=\"vm.refNumberSelected\" name=\"refNo\" id=\"refNo\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.refNo.$invalid && !report.refNo.$pristine }\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"timeInterval\">Arriving within</label><select kendo-combo-box=\"\" k-options=\"vm.timeIntervalOptions\" k-ng-model=\"vm.timeInterval\" name=\"timeInterval\" id=\"timeInterval\" class=\"form-control\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\"><label class=\"control-label\">Order by</label><select kendo-combo-box=\"\" k-options=\"vm.orderByOptions\" k-ng-model=\"vm.orderBy\" name=\"orderBy\" id=\"orderBy\" class=\"form-control\"></select></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/expeditingUpdateReport.html","<div class=\"ibox-title\"><h5>Expediting Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"ExpeditingUpdateReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.supplier.$invalid && !report.supplier.$pristine }\"><label class=\"control-label\" for=\"supplier\">Supplier</label><select kendo-combo-box=\"\" k-options=\"vm.supplierOptions\" k-ng-model=\"vm.supplierSelected\" k-ng-delay=\"vm.supplierSelected\" name=\"supplier\" id=\"supplier\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.supplier.$invalid && !report.supplier.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.buyerName.$invalid && !report.buyerName.$pristine }\"><label class=\"control-label\" for=\"buyerName\">Buyer Name</label><select kendo-combo-box=\"\" k-options=\"vm.buyerNameOptions\" k-ng-model=\"vm.buyerNameSelected\" k-ng-delay=\"vm.buyerNameSelected\" name=\"buyerName\" id=\"buyerName\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.buyerName.$invalid && !report.buyerName.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><div class=\"input-group\" style=\"width:100%;\"><select name=\"purchaseOrder\" kendo-multi-select=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" style=\"width: 100%;\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"timeInterval\">Arriving within</label><select kendo-combo-box=\"\" k-options=\"vm.timeIntervalOptions\" k-ng-model=\"vm.timeInterval\" name=\"timeInterval\" id=\"timeInterval\" class=\"form-control\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.refNo.$invalid && !report.refNo.$pristine }\"><label class=\"control-label\" for=\"refNo\">Ref Number</label><select kendo-combo-box=\"\" k-options=\"vm.refNumberOptions\" k-ng-model=\"vm.refNumberSelected\" k-ng-delay=\"vm.refNumberSelected\" name=\"refNo\" id=\"refNo\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.refNo.$invalid && !report.refNo.$pristine }\"></select></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/grnDetailsMonetaryValueReport.html","<div class=\"ibox-title\"><h5>GRN Details Monetary Value Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"GrnDetailsMonetaryValueReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.ircNumber.$invalid && !report.ircNumber.$pristine }\"><label class=\"control-label\" for=\"ircNumber\">IRC Number</label><select kendo-combo-box=\"\" k-options=\"vm.ircNumberOptions\" k-ng-model=\"vm.ircNumberSelected\" k-ng-delay=\"vm.ircNumberSelected\" name=\"ircNumber\" id=\"ircNumber\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.ircNumber.$invalid && !report.ircNumber.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.delivery.$invalid && !report.delivery.$pristine }\"><label class=\"control-label\" for=\"delivery\">Delivery</label><select kendo-combo-box=\"\" k-options=\"vm.deliveryOptions\" k-ng-model=\"vm.deliverySelected\" k-ng-delay=\"vm.deliverySelected\" name=\"delivery\" id=\"delivery\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.delivery.$invalid && !report.delivery.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" k-ng-delay=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div><div class=\"form-group\"><label class=\"control-label\">Monetary value?</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"noMonetaryValue\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.monetaryValue\" value=\"False\" name=\"noMonetaryValue\" id=\"noMonetaryValue\" class=\"form-control\"> No</label> <label class=\"radio-inline control-label\" for=\"yesMonetaryValue\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.monetaryValue\" value=\"True\" name=\"yesMonetaryValue\" id=\"yesMonetaryValue\" class=\"form-control\"> Yes</label></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">Delivery Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter delivery from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">Delivery Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter delivery to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.description.$invalid && !report.description.$pristine }\"><label class=\"control-label\" for=\"description\">Description</label> <input type=\"text\" name=\"description\" class=\"form-control k-textbox\" ng-model=\"vm.description\" id=\"description\" placeholder=\"(Optional)\" ng-class=\"{ \'has-error\' : report.description.$invalid && !report.description.$pristine }\"></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/inspectionReport.html","<div class=\"ibox-title\"><h5>Outstanding Inspection Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"InspectionReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.supplier.$invalid && !report.supplier.$pristine }\"><label class=\"control-label\" for=\"supplier\">Supplier</label><select kendo-combo-box=\"\" k-options=\"vm.supplierOptions\" k-ng-model=\"vm.supplierSelected\" k-ng-delay=\"vm.supplierSelected\" name=\"supplier\" id=\"supplier\" class=\"form-control\" style=\"width: 100%;\" ng-class=\"{ \'has-error\' : report.supplier.$invalid && !report.supplier.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><div class=\"input-group\" style=\"width:100%;\"><select name=\"purchaseOrder\" kendo-multi-select=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" style=\"width: 100%;\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"inspectionType\">Inspection Level</label><select kendo-combo-box=\"\" k-options=\"vm.inspectionTypeOptions\" k-ng-model=\"vm.inspectionType\" name=\"inspectionType\" id=\"inspectionType\" class=\"form-control\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.refNo.$invalid && !report.refNo.$pristine }\"><label class=\"control-label\" for=\"refNo\">Reference Document Number</label><select kendo-combo-box=\"\" k-options=\"vm.refNumberOptions\" k-ng-model=\"vm.refNumberSelected\" k-ng-delay=\"vm.refNumberSelected\" name=\"refNo\" id=\"refNo\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.refNo.$invalid && !report.refNo.$pristine }\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"><label class=\"control-label\" for=\"costCode\">Cost Code</label><select kendo-combo-box=\"\" k-options=\"vm.costCodeOptions\" k-ng-model=\"vm.costCodeSelected\" k-ng-delay=\"vm.costCodeSelected\" name=\"costCode\" id=\"costCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">Promised Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">Promised Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/issueReport.html","<div class=\"ibox-title\"><h5>Issue Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"IssueReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"><label class=\"control-label\" for=\"costCode\">Cost Code</label><select kendo-combo-box=\"\" k-options=\"vm.costCodeOptions\" k-ng-model=\"vm.costCodeSelected\" k-ng-delay=\"vm.costCodeSelected\" name=\"costCode\" id=\"costCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.issue.$invalid && !report.issue.$pristine }\"><label class=\"control-label\" for=\"issue\">Issue</label><select kendo-combo-box=\"\" k-options=\"vm.issueOptions\" k-ng-model=\"vm.issueSelected\" k-ng-delay=\"vm.issueSelected\" name=\"issue\" id=\"issue\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.issue.$invalid && !report.issue.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" k-ng-delay=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div><div class=\"form-group\"><label class=\"control-label\">Monetary value?</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"noMonetaryValue\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.monetaryValue\" value=\"False\" name=\"noMonetaryValue\" id=\"noMonetaryValue\" class=\"form-control\"> No</label> <label class=\"radio-inline control-label\" for=\"yesMonetaryValue\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.monetaryValue\" value=\"True\" name=\"yesMonetaryValue\" id=\"yesMonetaryValue\" class=\"form-control\"> Yes</label></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">Issue Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter issue from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">Issue Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter issue to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.workpack.$invalid && !report.workpack.$pristine }\"><label class=\"control-label\" for=\"workpack\">Issue To Ref No.</label><select kendo-combo-box=\"\" k-options=\"vm.workpackNumberOptions\" k-ng-model=\"vm.workpackNumberSelected\" k-ng-delay=\"vm.workpackNumberSelected\" required=\"\" name=\"workpackNumber\" id=\"workpackNumber\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.workpackNumber.$invalid && !report.workpackNumber.$pristine }\"></select></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"form-group\"><label class=\"control-label\" style=\"display: block;\">Status</label><div style=\"\"><div class=\"radio-inline\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.issueStatus\" value=\"0\" name=\"status\" id=\"all\" class=\"form-control\"> <label class=\"control-label\" for=\"incomplete\">All</label></div><div class=\"radio-inline\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.issueStatus\" value=\"1\" name=\"status\" id=\"incomplete\" class=\"form-control\"> <label class=\"control-label\" for=\"incomplete\">Incomplete</label></div><div class=\"radio-inline\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.issueStatus\" value=\"3\" name=\"status\" id=\"complete\" class=\"form-control\"> <label class=\"control-label\" for=\"complete\">Complete</label></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/manifestImportReport.html","<div class=\"ibox-title\"><h5>Manifest Import Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"ManifestImportReportCtrl as vm\" class=\"form-horizontal\"><div class=\"row\"><div class=\"form-group\"><label class=\"control-label col-sm-2\">Report Format</label><div class=\"col-sm-4\"><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> <label class=\"control-label\" for=\"excel\">Excel</label></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/manifestReport.html","<div class=\"ibox-title\"><h5>Manifest Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"ManifestReportCtrl as vm\" class=\"form-horizontal\"><div class=\"row\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.manifestNo.$invalid && !report.manifestNo.$pristine }\"><label class=\"control-label col-sm-2\" for=\"manifestNo\">Manifest Number</label><div class=\"col-sm-4\"><select kendo-combo-box=\"\" k-options=\"vm.manifestsOptions\" ng-model=\"vm.manifestSelected\" k-ng-delay=\"vm.manifestSelected\" required=\"\" name=\"manifestNo\" id=\"manifestNo\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.manifestNo.$invalid && !report.manifestNo.$pristine }\"></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Manifest Type</label><div class=\"col-sm-4\"><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.manifestType\" value=\"manifest\" name=\"manifest\" id=\"manifest\" class=\"form-control\"> <label class=\"control-label\" for=\"manifest\">Shipping Manifest</label></div><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.manifestType\" value=\"manifestMMT\" name=\"manifestMMT\" id=\"manifestMMT\" class=\"form-control\"> <label class=\"control-label\" for=\"manifestMMT\">Material Movement Ticket</label></div><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.manifestType\" value=\"manifestCI\" name=\"manifestCI\" id=\"manifestCI\" class=\"form-control\"> <label class=\"control-label\" for=\"manifestCI\">Commerical Invoice</label></div><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.manifestType\" value=\"manifestBL\" name=\"manifestBL\" id=\"manifestBL\" class=\"form-control\"> <label class=\"control-label\" for=\"manifestBL\">Backload</label></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Report Format</label><div class=\"col-sm-4\"><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> <label class=\"control-label\" for=\"pdf\">PDF</label></div><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> <label class=\"control-label\" for=\"excel\">Excel</label></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Order by</label><div class=\"col-sm-4\"><select kendo-combo-box=\"\" k-options=\"vm.orderByOptions\" k-ng-model=\"vm.orderBy\" name=\"orderBy\" id=\"orderBy\" class=\"form-control\"></select></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/materialHistoryReport.html","<div class=\"ibox-title\"><h5>Material History Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"MaterialHistoryReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" k-ng-delay=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"><label class=\"control-label\" for=\"costCode\">Cost code</label><select kendo-combo-box=\"\" k-options=\"vm.costCodeOptions\" k-ng-model=\"vm.costCodeSelected\" k-ng-delay=\"vm.costCodeSelected\" name=\"costCode\" id=\"costCode\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/materialMovementReport.html","<div class=\"ibox-title\"><h5>Material Movement Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"MaterialMovementReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.movementNumber.$invalid && !report.movementNumber.$pristine }\"><label class=\"control-label\" for=\"movementNumber\">Movement Number</label><select kendo-combo-box=\"\" k-options=\"vm.movementNumberOptions\" k-ng-model=\"vm.movementNumberSelected\" k-ng-delay=\"vm.movementNumberSelected\" name=\"movementNumber\" id=\"movementNumber\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.movementNumber.$invalid && !report.movementNumber.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.warehouse.$invalid && !report.warehouse.$pristine }\"><label class=\"control-label\" for=\"warehouse\">Warehouse</label><select kendo-combo-box=\"\" k-options=\"vm.warehouseOptions\" k-ng-model=\"vm.warehouseSelected\" k-ng-delay=\"vm.warehouseSelected\" name=\"warehouse\" id=\"warehouse\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.warehouse.$invalid && !report.warehouse.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/materialReceivingReport.html","<div class=\"ibox-title\"><h5>Material receiving Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"MaterialReceivingReportCtrl as vm\" class=\"form-horizontal\"><div class=\"row\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label col-sm-2\" for=\"purchaseOrder\">Purchase Order</label><div class=\"col-sm-4\"><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrdersOptions\" k-ng-model=\"vm.selectedPurchaseOrder\" k-ng-delay=\"vm.selectedPurchaseOrder\" required=\"\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine}\"></select></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.delivery.$invalid && !report.delivery.$pristine }\"><label class=\"control-label col-sm-2\" for=\"delivery\">Delivery</label><div class=\"col-sm-4\"><select kendo-combo-box=\"\" k-options=\"vm.deliveriesOptions\" k-ng-model=\"vm.selectedDelivery\" required=\"\" name=\"delivery\" id=\"delivery\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.delivery.$invalid && !report.delivery.$pristine}\" ng-disabled=\"!vm.selectedPurchaseOrder\"></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Report Format</label><div class=\"col-sm-4\"><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> <label class=\"control-label\" for=\"pdf\">PDF</label></div><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> <label class=\"control-label\" for=\"excel\">Excel</label></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid || !vm.selectedPurchaseOrder || !vm.selectedDelivery\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/materialTrackingReport.html","<div class=\"ibox-title\"><h5>Material Tracking Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"MaterialTrackingReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"><label class=\"control-label\" for=\"costCode\">Cost Code</label><select kendo-combo-box=\"\" k-options=\"vm.costCodeOptions\" k-ng-model=\"vm.costCodeSelected\" k-ng-delay=\"vm.costCodeSelected\" name=\"costCode\" id=\"costCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" k-ng-delay=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.description.$invalid && !report.description.$pristine }\"><label class=\"control-label\" for=\"description\">Description</label> <input type=\"text\" name=\"description\" class=\"form-control k-textbox\" ng-model=\"vm.description\" id=\"description\" placeholder=\"(Optional)\" ng-class=\"{ \'has-error\' : report.description.$invalid && !report.description.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.container.$invalid && !report.container.$pristine }\"><label class=\"control-label\" for=\"description\">Container</label> <input type=\"text\" name=\"container\" class=\"form-control k-textbox\" ng-model=\"vm.container\" id=\"container\" placeholder=\"(Optional)\" ng-class=\"{ \'has-error\' : report.container.$invalid && !report.container.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.refDoc.$invalid && !report.refDoc.$pristine }\"><label class=\"control-label\" for=\"description\">Ref Doc</label> <input type=\"text\" name=\"refDoc\" class=\"form-control k-textbox\" ng-model=\"vm.refDoc\" id=\"refDoc\" placeholder=\"(Optional)\" ng-class=\"{ \'has-error\' : report.refDoc.$invalid && !report.refDoc.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.customsStatus.$invalid && !report.customsStatus.$pristine }\"><label class=\"control-label\" for=\"description\">Customs Status</label> <input type=\"text\" name=\"customsStatus\" class=\"form-control k-textbox\" ng-model=\"vm.customsStatus\" id=\"customsStatus\" placeholder=\"(Optional)\" ng-class=\"{ \'has-error\' : report.customsStatus.$invalid && !report.customsStatus.$pristine }\"></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\" ng-disabled=\"true\" uib-tooltip=\"PDF is not available for this report\" tooltip-placement=\"bottom\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\" ng-disabled=\"true\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/materialTransferReport.html","<div class=\"ibox-title\"><h5>Material Transfer Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"MaterialTransferReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.transferNumber.$invalid && !report.transferNumber.$pristine }\"><label class=\"control-label\" for=\"transferNumber\">Transfer Number</label><select kendo-combo-box=\"\" k-options=\"vm.transferNumberOptions\" k-ng-model=\"vm.transferNumberSelected\" k-ng-delay=\"vm.transferNumberSelected\" name=\"transferNumber\" id=\"transferNumber\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.transferNumber.$invalid && !report.transferNumber.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/osdReport.html","<div class=\"ibox-title\"><h5>OS&D Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"OsdReportCtrl as vm\" class=\"form-horizontal\"><div class=\"row\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.supplier.$invalid && !report.supplier.$pristine }\"><label class=\"control-label col-sm-2\" for=\"supplier\">Supplier</label><div class=\"col-sm-4\"><select kendo-combo-box=\"\" k-options=\"vm.supplierOptions\" k-ng-model=\"vm.supplierSelected\" k-ng-delay=\"vm.supplierSelected\" required=\"\" name=\"supplier\" id=\"supplier\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.supplier.$invalid && !report.supplier.$pristine }\"></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Order by</label><div class=\"col-sm-4\"><select kendo-combo-box=\"\" k-options=\"vm.orderByOptions\" k-ng-model=\"vm.orderBy\" name=\"orderBy\" id=\"orderBy\" class=\"form-control\"></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Status</label><div class=\"col-sm-4\"><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.osdStatus\" value=\"1\" name=\"unresolved\" id=\"unresolved\" class=\"form-control\"> <label class=\"control-label\" for=\"unresolved\">Unresolved</label></div><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.osdStatus\" value=\"3\" name=\"resolved\" id=\"resolved\" class=\"form-control\"> <label class=\"control-label\" for=\"resolved\">Resolved</label></div><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.osdStatus\" value=\"0\" name=\"all\" id=\"all\" class=\"form-control\"> <label class=\"control-label\" for=\"all\">All</label></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Report Format</label><div class=\"col-sm-4\"><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> <label class=\"control-label\" for=\"pdf\">PDF</label></div><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> <label class=\"control-label\" for=\"excel\">Excel</label></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/picklistReport.html","<div class=\"ibox-title\"><h5>Picklist Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"PicklistReportCtrl as vm\" class=\"form-horizontal\"><div class=\"row\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.picklistNo.$invalid && !report.picklistNo.$pristine }\"><label class=\"control-label col-sm-2\" for=\"picklistNo\">Picklist Number</label><div class=\"col-sm-4\"><select kendo-combo-box=\"\" k-options=\"vm.picklistsOptions\" ng-model=\"vm.picklistSelected\" k-ng-delay=\"vm.picklistSelected\" required=\"\" name=\"picklistNo\" id=\"picklistNo\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.picklistNo.$invalid && !report.picklistNo.$pristine }\"></select></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Report Format</label><div class=\"col-sm-4\"><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> <label class=\"control-label\" for=\"pdf\">PDF</label></div><div class=\"radio\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> <label class=\"control-label\" for=\"excel\">Excel</label></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/psrReport.html","<div class=\"ibox-title\"><h5>PSR Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"PsrReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"><label class=\"control-label\" for=\"costCode\">Cost Code</label><select kendo-combo-box=\"\" k-options=\"vm.costCodeOptions\" k-ng-model=\"vm.costCodeSelected\" k-ng-delay=\"vm.costCodeSelected\" name=\"costCode\" id=\"costCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" k-ng-delay=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.buyerName.$invalid && !report.buyerName.$pristine }\"><label class=\"control-label\" for=\"buyerName\">Buyer Name</label><select kendo-combo-box=\"\" k-options=\"vm.buyerNameOptions\" k-ng-model=\"vm.buyerNameSelected\" k-ng-delay=\"vm.buyerNameSelected\" name=\"buyerName\" id=\"buyerName\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.buyerName.$invalid && !report.buyerName.$pristine }\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">PO Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter PO from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">PO Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter PO to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"description\">Description</label> <input type=\"text\" class=\"form-control k-textbox\" id=\"description\" name=\"description\" placeholder=\"Enter a description\" ng-model=\"vm.description\"></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\" ng-disabled=\"true\" uib-tooltip=\"PDF is not available for this report\" tooltip-placement=\"bottom\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\" ng-disabled=\"true\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/psrShippingReport.html","<div class=\"ibox-title\"><h5>PSR Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"PsrShippingReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"><label class=\"control-label\" for=\"costCode\">Cost Code</label><select kendo-combo-box=\"\" k-options=\"vm.costCodeOptions\" k-ng-model=\"vm.costCodeSelected\" k-ng-delay=\"vm.costCodeSelected\" name=\"costCode\" id=\"costCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" k-ng-delay=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.buyerName.$invalid && !report.buyerName.$pristine }\"><label class=\"control-label\" for=\"buyerName\">Buyer Name</label><select kendo-combo-box=\"\" k-options=\"vm.buyerNameOptions\" k-ng-model=\"vm.buyerNameSelected\" k-ng-delay=\"vm.buyerNameSelected\" name=\"buyerName\" id=\"buyerName\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.buyerName.$invalid && !report.buyerName.$pristine }\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">PO Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter PO from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">PO Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter PO to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\"><label class=\"control-label\" for=\"description\">Description</label> <input type=\"text\" class=\"form-control k-textbox\" id=\"description\" name=\"description\" placeholder=\"Enter a description\" ng-model=\"vm.description\"></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\" ng-disabled=\"true\" uib-tooltip=\"PDF is not available for this report\" tooltip-placement=\"bottom\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\" ng-disabled=\"true\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/returnReport.html","<div class=\"ibox-title\"><h5>Return Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"ReturnReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"><label class=\"control-label\" for=\"costCode\">Cost Code</label><select kendo-combo-box=\"\" k-options=\"vm.costCodeOptions\" k-ng-model=\"vm.costCodeSelected\" k-ng-delay=\"vm.costCodeSelected\" name=\"costCode\" id=\"costCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.delivery.$invalid && !report.delivery.$pristine }\"><label class=\"control-label\" for=\"delivery\">Return</label><select kendo-combo-box=\"\" k-options=\"vm.deliveryOptions\" k-ng-model=\"vm.deliverySelected\" k-ng-delay=\"vm.deliverySelected\" name=\"delivery\" id=\"delivery\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.delivery.$invalid && !report.delivery.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" k-ng-delay=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div><div class=\"form-group\"><label class=\"control-label\">Monetary value?</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"noMonetaryValue\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.monetaryValue\" value=\"False\" name=\"noMonetaryValue\" id=\"noMonetaryValue\" class=\"form-control\"> No</label> <label class=\"radio-inline control-label\" for=\"yesMonetaryValue\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.monetaryValue\" value=\"True\" name=\"yesMonetaryValue\" id=\"yesMonetaryValue\" class=\"form-control\"> Yes</label></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">Return Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter return from date\" max-date=\"vm.dateTo\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">Return Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter return to date\" min-date=\"vm.dateFrom\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.description.$invalid && !report.description.$pristine }\"><label class=\"control-label\" for=\"description\">Description</label> <input type=\"text\" name=\"description\" class=\"form-control k-textbox\" ng-model=\"vm.description\" id=\"description\" placeholder=\"(Optional)\" ng-class=\"{ \'has-error\' : report.description.$invalid && !report.description.$pristine }\"></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/shippedItemsReport.html","<div class=\"ibox-title\"><h5>Shipped Items Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"ShippedItemsReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"><label class=\"control-label\" for=\"costCode\">Cost Code</label><select kendo-combo-box=\"\" k-options=\"vm.costCodeOptions\" k-ng-model=\"vm.costCodeSelected\" k-ng-delay=\"vm.costCodeSelected\" name=\"costCode\" id=\"costCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" k-ng-delay=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label\" for=\"dateFrom\">Date From</label><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label\" for=\"dateTo\">Date To</label><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.description.$invalid && !report.description.$pristine }\"><label class=\"control-label\" for=\"description\">Description</label> <input type=\"text\" name=\"description\" class=\"form-control k-textbox\" ng-model=\"vm.description\" id=\"description\" placeholder=\"(Optional)\" ng-class=\"{ \'has-error\' : report.description.$invalid && !report.description.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.container.$invalid && !report.container.$pristine }\"><label class=\"control-label\" for=\"description\">Container</label> <input type=\"text\" name=\"container\" class=\"form-control k-textbox\" ng-model=\"vm.container\" id=\"container\" placeholder=\"(Optional)\" ng-class=\"{ \'has-error\' : report.container.$invalid && !report.container.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.refDoc.$invalid && !report.refDoc.$pristine }\"><label class=\"control-label\" for=\"description\">Ref Doc</label> <input type=\"text\" name=\"refDoc\" class=\"form-control k-textbox\" ng-model=\"vm.refDoc\" id=\"refDoc\" placeholder=\"(Optional)\" ng-class=\"{ \'has-error\' : report.refDoc.$invalid && !report.refDoc.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.customsStatus.$invalid && !report.customsStatus.$pristine }\"><label class=\"control-label\" for=\"description\">Customs Status</label> <input type=\"text\" name=\"customsStatus\" class=\"form-control k-textbox\" ng-model=\"vm.customsStatus\" id=\"customsStatus\" placeholder=\"(Optional)\" ng-class=\"{ \'has-error\' : report.customsStatus.$invalid && !report.customsStatus.$pristine }\"></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\" ng-disabled=\"true\" uib-tooltip=\"PDF is not available for this report\" tooltip-placement=\"bottom\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\" ng-disabled=\"true\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/stockAgingReport.html","<div class=\"ibox-title\"><h5>Stock Aging Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"StockAgingReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.months.$invalid && !report.months.$pristine }\"><label class=\"control-label\" for=\"months\">Number of months to show stock older than *</label> <input type=\"text\" name=\"months\" class=\"form-control k-textbox\" ng-model=\"vm.months\" id=\"months\" placeholder=\"Enter months\" numeric-only=\"\" required=\"\" ng-class=\"{ \'has-error\' : report.months.$invalid && !report.months.$pristine }\"></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"><label class=\"control-label\" for=\"costCode\">Cost Code</label><select kendo-combo-box=\"\" k-options=\"vm.costCodeOptions\" k-ng-model=\"vm.costCodeSelected\" k-ng-delay=\"vm.costCodeSelected\" name=\"costCode\" id=\"costCode\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" k-ng-delay=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\" ng-disabled=\"true\" uib-tooltip=\"PDF is not available for this report\" tooltip-placement=\"bottom\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\" ng-disabled=\"true\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/stockBalanceReport.html","<div class=\"ibox-title\"><h5>Stock Balance Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"StockBalanceReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.warehouse.$invalid && !report.warehouse.$pristine }\"><label class=\"control-label\" for=\"warehouse\">Warehouse</label><select kendo-combo-box=\"\" k-options=\"vm.warehousesOptions\" k-ng-model=\"vm.warehouseSelected\" k-ng-delay=\"vm.warehouseSelected\" name=\"warehouse\" id=\"warehouse\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.warehouse.$invalid && !report.warehouse.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.location.$invalid && !report.location.$pristine }\"><label class=\"control-label\" for=\"location\">Location</label><select kendo-combo-box=\"\" k-options=\"vm.locationsOptions\" k-ng-model=\"vm.locationSelected\" k-ng-delay=\"vm.locationSelected\" name=\"location\" id=\"location\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.location.$invalid && !report.location.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"><label class=\"control-label\" for=\"costCode\">Cost Code</label><select kendo-combo-box=\"\" k-options=\"vm.costCodeOptions\" ng-model=\"vm.costCodeSelected\" name=\"costCode\" id=\"costCode\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.description.$invalid && !report.description.$pristine }\"><label class=\"control-label\" for=\"description\">Description</label> <input type=\"text\" name=\"description\" class=\"form-control k-textbox\" ng-model=\"vm.description\" id=\"description\" placeholder=\"(Optional)\" ng-class=\"{ \'has-error\' : report.description.$invalid && !report.description.$pristine }\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" k-ng-delay=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.workpack.$invalid && !report.workpack.$pristine }\"><label class=\"control-label\" for=\"workpack\">PO Ref Doc No.</label><select kendo-combo-box=\"\" k-options=\"vm.workpackNumberOptions\" k-ng-model=\"vm.workpackNumberSelected\" k-ng-delay=\"vm.workpackNumberSelected\" required=\"\" name=\"workpackNumber\" id=\"workpackNumber\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.workpackNumber.$invalid && !report.workpackNumber.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.bagAndTag.$invalid && !report.bagAndTag.$pristine }\"><label class=\"control-label\" for=\"bagAndTag\">Bag & Tag</label><select kendo-combo-box=\"\" k-options=\"vm.bagAndTagNumbersOptions\" k-ng-model=\"vm.bagAndTagSelected\" k-ng-delay=\"vm.bagAndTagSelected\" name=\"bagAndTag\" id=\"bagAndTag\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.bagAndTag.$invalid && !report.bagAndTag.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.bagAndTagRefDocNumber.$invalid && !report.bagAndTagRefDocNumber.$pristine }\"><label class=\"control-label\" for=\"bagAndTagRefDocNumber\">Bag & Tag Ref Doc No.</label><select kendo-combo-box=\"\" k-options=\"vm.bagAndTagRefDocNumberOptions\" k-ng-model=\"vm.bagAndTagRefDocNumberSelected\" k-ng-delay=\"vm.bagAndTagRefDocNumberSelected\" required=\"\" name=\"bagAndTagRefDocNumber\" id=\"bagAndTagRefDocNumber\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.bagAndTagRefDocNumber.$invalid && !report.bagAndTagRefDocNumber.$pristine }\"></select></div><div class=\"form-group\"><label class=\"control-label\">Bag & Tag</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"includeBagAndTag\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.incBagAndTag\" value=\"1\" name=\"includeBagAndTag\" id=\"includeBagAndTag\" class=\"form-control\"> Include bag & tag</label> <label class=\"radio-inline control-label\" for=\"excludeBagAndTag\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.incBagAndTag\" value=\"2\" name=\"excludeBagAndTag\" id=\"excludeBagAndTag\" class=\"form-control\"> Exclude bag & tag</label> <label class=\"radio-inline control-label\" for=\"onlyBagAndTag\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.incBagAndTag\" value=\"3\" name=\"onlyBagAndTag\" id=\"onlyBagAndTag\" class=\"form-control\"> Only show bag & tag</label></div></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/stockCheckSheetReport.html","<div class=\"ibox-title\"><h5>Stock Check Sheet Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"StockCheckSheetReportCtrl as vm\"><div class=\"row\"><div class=\"col-sm-4 b-r\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"><label class=\"control-label\" for=\"costCode\">Cost Code</label><select kendo-combo-box=\"\" k-options=\"vm.costCodeOptions\" k-ng-model=\"vm.costCodeSelected\" k-ng-delay=\"vm.costCodeSelected\" name=\"costCode\" id=\"costCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.costCode.$invalid && !report.costCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"><label class=\"control-label\" for=\"materialCode\">Material Code</label><select kendo-combo-box=\"\" k-options=\"vm.materialCodeOptions\" k-ng-model=\"vm.materialCodeSelected\" k-ng-delay=\"vm.materialCodeSelected\" name=\"materialCode\" id=\"materialCode\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.materialCode.$invalid && !report.materialCode.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"><label class=\"control-label\" for=\"purchaseOrder\">Purchase Order</label><select kendo-combo-box=\"\" k-options=\"vm.purchaseOrderOptions\" k-ng-model=\"vm.purchaseOrderSelected\" k-ng-delay=\"vm.purchaseOrderSelected\" name=\"purchaseOrder\" id=\"purchaseOrder\" class=\"form-control\" required=\"\" ng-class=\"{ \'has-error\' : report.purchaseOrder.$invalid && !report.purchaseOrder.$pristine }\"></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.warehouse.$invalid && !report.warehouse.$pristine }\"><label class=\"control-label\" for=\"warehouse\">Warehouse</label><select kendo-combo-box=\"\" k-ng-model=\"vm.warehouseSelected\" k-options=\"vm.warehousesOptions\" class=\"form-control\" name=\"warehouse\" id=\"warehouse\" ng-class=\"{ \'has-error\' : report.warehouse.$invalid && !report.warehouse.$pristine }\"></select></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.location.$invalid && !report.location.$pristine }\"><label class=\"control-label\">Location</label><select kendo-combo-box=\"\" k-options=\"vm.locationsOptions\" k-ng-model=\"vm.locationSelected\" class=\"form-control\" name=\"location\" id=\"location\" ng-class=\"{ \'has-error\' : report.location.$invalid && !report.location.$pristine }\"></select></div><div class=\"form-group\"><label class=\"control-label\">Third Party?</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"yesQuantity\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.showQuantity\" value=\"False\" name=\"yesQuantity\" id=\"yesQuantity\" class=\"form-control\"> Yes</label> <label class=\"radio-inline control-label\" for=\"noQuantity\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.showQuantity\" value=\"True\" name=\"noQuantity\" id=\"noQuantity\" class=\"form-control\"> No</label></div></div><div class=\"form-group\"><label class=\"control-label\">Report Format</label><div class=\"input-group radio\"><label class=\"radio-inline control-label\" for=\"pdf\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div></div></div><div class=\"row\"><div class=\"form-group\"><div class=\"col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/reporting/viewReporting.html","<div class=\"wrapper wrapper-content animated fadeIn\" ng-controller=\"ViewReportingCtrl as vm\"><div class=\"row\"><div class=\"ibox-title\"><h5>Reporting</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"createForm\" class=\"form-horizontal\"><div class=\"row\"><div class=\"form-group\"><label class=\"control-label col-sm-2\" for=\"reportType\">Report Type</label><div class=\"col-sm-4\"><select kendo-combo-box=\"\" k-options=\"vm.reportTypeOptions\" k-ng-model=\"vm.reportType\" name=\"reportType\" id=\"reportType\" class=\"form-control\"></select></div></div></div></form></div></div><div class=\"ibox\"></div><div class=\"row\" ng-if=\"vm.reportType != \'\'\"><div ng-include=\"vm.reportType.value\"></div></div></div>");
$templateCache.put("app/reporting/warehouseTransactionReport.html","<div class=\"ibox-title\"><h5>Warehouse Transaction Report</h5></div><div class=\"ibox-content\"><form role=\"form\" name=\"report\" ng-controller=\"WarehouseTransactionReportCtrl as vm\" class=\"form-horizontal\"><div class=\"row\"><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.warehouse.$invalid && !report.warehouse.$pristine }\"><label class=\"control-label col-sm-2\" for=\"warehouse\">Warehouse</label><div class=\"col-sm-4\"><select kendo-combo-box=\"\" k-options=\"vm.warehouseOptions\" k-ng-model=\"vm.warehouseSelected\" k-ng-delay=\"vm.warehouseSelected\" name=\"warehouse\" id=\"warehouse\" class=\"form-control\" ng-class=\"{ \'has-error\' : report.warehouse.$invalid && !report.warehouse.$pristine }\"></select></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><label class=\"control-label col-sm-2\" for=\"dateFrom\">Date From</label><div class=\"col-sm-4\"><div class=\"input-group\"><input type=\"text\" name=\"dateFrom\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateFrom\" is-open=\"vm.calendar.opened.dateFrom\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateFrom\" placeholder=\"Enter from date\" max-date=\"vm.dateTo\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateFrom.$invalid && !report.dateFrom.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateFrom\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div></div><div class=\"form-group\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><label class=\"control-label col-sm-2\" for=\"dateTo\">Date To</label><div class=\"col-sm-4\"><div class=\"input-group\"><input type=\"text\" name=\"dateTo\" class=\"form-control k-textbox\" ng-click=\"vm.calendar.open($event, \'dateTo\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" ng-model=\"vm.dateTo\" is-open=\"vm.calendar.opened.dateTo\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" id=\"dateTo\" placeholder=\"Enter to date\" min-date=\"vm.dateFrom\" date-to-iso=\"\" ng-class=\"{ \'has-error\' : report.dateTo.$invalid && !report.dateTo.$pristine }\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'dateTo\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div></div></div><div class=\"form-group\"><label class=\"control-label col-sm-2\">Report Format</label><div class=\"input-group radio col-sm-4\"><label class=\"radio-inline control-label\" for=\"pdf\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Pdf\" name=\"pdf\" id=\"pdf\" class=\"form-control\"> PDF</label> <label class=\"radio-inline control-label\" for=\"excel\"><input icheck=\"\" type=\"radio\" ng-model=\"vm.reportFormat\" value=\"Excel\" name=\"excel\" id=\"excel\" class=\"form-control\"> Excel</label></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-4\"><button class=\"btn btn-primary\" ladda=\"vm.generating\" ng-click=\"vm.runReport()\" ng-disabled=\"report.$invalid\">Run Report</button></div></div></div></form></div>");
$templateCache.put("app/returns/returnGroupedItems.html","<button class=\"btn btn-primary btn-sm pull-right\" ng-click=\"vm.openGroupedItems()\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></button>");
$templateCache.put("app/returns/returnGroupedItemsModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-mail-reply modal-icon\"></i><h4 class=\"modal-title\">{{vm.title}}</h4></div><div class=\"modal-body p-b-xxs transfer-bag-and-tag\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Return to location</label><div class=\"col-lg-8\"><select required=\"\" kendo-drop-down-list=\"\" k-options=\"vm.locationsOptions\" k-ng-model=\"vm.locationSelected\" style=\"width:100%\" ng-disabled=\"vm.saved\"></select></div></div><div class=\"hr-line-dashed\"></div><kendo-treelist id=\"treelist\" options=\"vm.storedItemsOptions\" style=\"width: 835px\"></kendo-treelist></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Items successfully returned.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error returning items.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.locationSelected == undefined || vm.saved || !(vm.storedItemsOptions.dataSource.data() | filter:{isIncluded: true} | filter:vm.greaterThan(\'quantity\', 0)).length\">Return</button></div></div>");
$templateCache.put("app/returns/viewReturn.html","<div ng-controller=\"ViewReturnCtrl as vm\"><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"m-b-md\"><h2><span class=\"text-nowrap\">Return {{ vm.return.number }}</span> <small><strong class=\"text-nowrap\">{{vm.return.description }}</strong></small> <span ng-class=\"!vm.return.isReadOnly ? \'badge label-warning\' : (vm.return.returnStatus === \'Cancelled\') ? \'badge label-danger\' : \'badge label-primary\'\">{{vm.return.returnStatus}}</span></h2><span class=\"text-nowrap\"><strong>Created by:</strong> {{vm.return.createdBy}} | <strong>Created date:</strong> {{vm.return.createdDate | date: \'dd-MMM-yyyy\'}} <span ng-if=\"vm.return.returnStatus === \'Complete\'\">| <strong>Completed by:</strong> {{vm.return.completedBy}} | <strong>Completed date:</strong> {{vm.return.completedDate | date: \'dd-MMM-yyyy\'}}</span></span></div><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-7\" ng-if=\"!vm.return.isReadOnly\"><wg-search-criteria results=\"vm.results\" bag-and-tag-results=\"vm.bagAndTagResults\" tabs=\"vm.tabs\" returns-only=\"true\"></wg-search-criteria><div class=\"ibox\"></div><div class=\"ibox-title remove-pd-b\" ng-if=\"vm.results.length || vm.bagAndTagResults.length\"><div class=\"btn-toolbar add-pd-b\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.addItems((vm.results | greaterThanZero: 0))\" ng-disabled=\"!(vm.results | greaterThanZero: 0).length || (vm.results | invalidQuantity:0).length\">Return items</button></div><div class=\"tabs-container items-container add-pd-b\" ng-show=\"vm.results.length || vm.bagAndTagResults.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsResultsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.results.length ? vm.results.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results\"><table class=\"table materia-grouped-row\" ng-show=\"vm.results.length\"><thead><tr><th></th><th>PO / Item</th><th>Issue</th><th>Material code</th><th>Barcode</th><th>UOM</th><th>Cost code</th><th>Avail. Qty</th><th>Return Qty</th></tr></thead><tbody ng-repeat=\"item in vm.results | orderBy: [\'poNumber\', natural(\'poLineNumber\')]\" item=\"item\" wg-stored-item-checkboxes=\"\" add-item=\"vm.addItem(item)\" hide-location=\"true\" include-issue=\"true\"></tbody></table></div><div ng-show=\"!vm.results.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagResultsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.bagAndTagResults.length ? vm.bagAndTagResults.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.bagAndTagResults.length\"><table class=\"table materia-grouped-row\" ng-show=\"vm.bagAndTagResults\"><thead><th width=\"50\"></th><th>Issue</th><th>Number</th><th>Workpack number</th><th></th></thead><tbody ng-repeat=\"item in vm.bagAndTagResults\" item=\"item\" wg-bag-and-tag-item=\"\" returns-only=\"true\" return-id=\"{{vm.returnId}}\" add-item=\"vm.addBagAndTag(item)\" fake-bag-and-tag-items=\"vm.fakeReturnBagAndTagItems\"></tbody></table></div><div ng-show=\"!vm.bagAndTagResults.length\">No results found.</div></div></uib-tab></uib-tabset></div></div></div><div ng-class=\"!vm.return.isReadOnly ? \'col-lg-5\' : \'col-lg-12\'\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Included items</h5></div><div class=\"ibox-footer\" ng-if=\"!vm.return.isReadOnly\"><div ng-cloak=\"\"><div class=\"pull-left\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!vm.returnItems.length && !vm.returnBagAndTagItems.length\" data-style=\"expand-right\" ng-click=\"vm.completeReturn()\"><i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i> Complete</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"vm.cancelReturn()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Cancel</button></div><div class=\"clearfix\"></div></div></div><div class=\"ibox-content\" ng-show=\"!vm.returnItems.length && !vm.returnBagAndTagItems.length\"><p><strong>No items have been included in this return.</strong></p><p ng-if=\"!vm.return.isReadOnly\">Use the search function to find stock...</p></div><div class=\"tabs-container items-container\" ng-if=\"vm.returnItems.length || vm.returnBagAndTagItems.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.returnItems.length ? vm.returnItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.returnItems.length\">No stock items have been included in this return.</strong><div ng-show=\"vm.returnItems.length\"><table class=\"table materia-grouped-row\"><thead><tr><th>Issue</th><th>Material code</th><th>Barcode</th><th>Return Qty</th><th>Location</th><th data-sort-ignore=\"true\" ng-if=\"!vm.return.isReadOnly\"></th></tr></thead><tbody wg-included-item=\"\" ng-repeat=\"item in vm.returnItems\" item=\"item\" is-read-only=\"vm.return.isReadOnly\" remove-item=\"vm.removeItem(item)\" include-issue=\"true\" hide-old-locations=\"true\" include-new-locations=\"true\"></tbody></table></div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.returnBagAndTagItems.length ? vm.returnBagAndTagItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.returnBagAndTagItems.length\">No bag & tag items have been included in this return.</strong><kendo-treelist id=\"treelist\" options=\"vm.returnBagAndTagItemsOptions\"></kendo-treelist></div></uib-tab></uib-tabset></div></div></div></div></div></div>");
$templateCache.put("app/returns/viewReturns.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><form role=\"form\" name=\"createForm\" ng-submit=\"vm.createReturn()\" ng-controller=\"CreateReturnCtrl as vm\"><div class=\"ibox-title\"><h5 for=\"product_name\">Create a return</h5></div><div class=\"form-group\"><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"description\" placeholder=\"Enter a description\" required=\"\" ng-model=\"vm.return.description\" ng-class=\"{ \'has-error\' : createForm.name.$invalid && !createForm.name.$pristine }\"> <span class=\"input-group-btn\"><button type=\"submit\" ladda=\"vm.loading\" class=\"btn btn-primary\" ng-disabled=\"createForm.$invalid\">Create return</button></span></div></div></div></form></div></div><div class=\"tabs-container\" ng-controller=\"ViewReturnsCtrl as vm\"><uib-tabset><uib-tab><uib-tab-heading><i class=\"fa fa-warning\"></i>Incomplete <span class=\"badge label-warning\">{{vm.incompleteReturns.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.incompleteReturns.length\">There are no incomplete returns.</strong><div ng-if=\"vm.incompleteReturns.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-2 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"return in vm.incompleteReturns | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"incomplete\"><td><a ui-sref=\"returns.details({id:return.id})\">{{ return.number }}</a></td><td>{{ return.description }}</td><td>{{ return.createdBy }}</td><td>{{ return.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls></div></div></uib-tab><uib-tab><uib-tab-heading><i class=\"fa fa-check-square-o\"></i>Completed <span class=\"badge label-primary\">{{ vm.completedReturns.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.completedReturns.length\">There are no completed returns.</strong><div ng-if=\"vm.completedReturns.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completed\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-1 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th><th class=\"col-xs-1 text-nowrap\">Completed by</th><th class=\"col-xs-1 text-nowrap\">Completed date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"return in vm.completedReturns | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"completed\"><td><a ui-sref=\"returns.details({id:return.id})\">{{ return.number }}</a></td><td>{{ return.description }}</td><td>{{ return.createdBy}}</td><td>{{ return.createdDate | date:\'dd-MMM-yyyy\' }}</td><td>{{ return.completedBy}}</td><td>{{ return.completedDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completed\"></dir-pagination-controls></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/search/search.html","<div ng-controller=\"SearchCtrl as vm\" class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row add-pd-b\"><div class=\"col-lg-12\"><div class=\"ibox-title\"><h5>Purchase Order Search</h5></div><div class=\"ibox-content\"><div class=\"row m-t-sm\"><div class=\"col-lg-12\"><form role=\"form\" ng-submit=\"vm.resetCurrentPage(); vm.doSearch()\"><div class=\"form-group\"><div class=\"col-sm-7\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchParams.searchTerm\" placeholder=\"Enter material code, supplier name, po number etc...\"></div><div class=\"col-sm-2\" ng-class=\"{ \'has-error\' : (createForm.date.$invalid && !createForm.date.$pristine) || (createForm.dateMobile.$invalid && !createForm.dateMobile.$pristine) }\"><div class=\"input-group date hidden-xs\"><input type=\"text\" name=\"date\" id=\"date\" class=\"form-control\" ng-click=\"vm.calendar.open($event, \'from\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" uib-tooltip=\"Date that all PO\'s found should be created after\" tooltip-placement=\"bottom\" ng-model=\"vm.searchParams.searchFromDate\" is-open=\"vm.calendar.opened.from\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" placeholder=\"Enter date to search from....\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'from\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div><div class=\"input-group date visible-xs\"><datepicker name=\"dateMobile\" ng-model=\"vm.searchParams.searchFromDate\" is-open=\"vm.calendar.opened.from\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" required=\"\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'from\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></datepicker></div></div><div class=\"col-sm-2\" ng-class=\"{ \'has-error\' : (createForm.date.$invalid && !createForm.date.$pristine) || (createForm.dateMobile.$invalid && !createForm.dateMobile.$pristine) }\"><div class=\"input-group date hidden-xs\"><input type=\"text\" name=\"toDate\" id=\"toDate\" class=\"form-control\" ng-click=\"vm.calendar.open($event, \'to\')\" uib-datepicker-popup=\"{{vm.calendar.dateFormat}}\" uib-tooltip=\"Date that all PO\'s found should be created before\" tooltip-placement=\"bottom\" ng-model=\"vm.searchParams.searchToDate\" is-open=\"vm.calendar.opened.to\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" placeholder=\"Enter date to search to....\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'to\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></div><div class=\"input-group date visible-xs\"><datepicker name=\"dateMobile\" ng-model=\"vm.searchParams.searchToDate\" is-open=\"vm.calendar.opened.win\" datepicker-options=\"vm.calendar.dateOptions\" close-text=\"Close\" required=\"\"><div class=\"input-group-addon\" ng-click=\"vm.calendar.open($event, \'to\')\"><i class=\"glyphicon glyphicon-calendar\"></i></div></datepicker></div></div><div class=\"col-sm-1\"><button type=\"submit\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-click=\"vm.resetCurrentPage(); vm.doSearch(vm.searchTerm)\">Go!</button></div></div></form></div></div></div></div></div><div class=\"ibox float-e-margins\" ng-show=\"vm.results\"><div class=\"ibox-title\"><h3>{{vm.totalItems}} results {{ vm.searchResultString }} <small></small></h3></div><div class=\"ibox-content\"><div ng-show=\"vm.results.length\"><dir-pagination-controls boundary-links=\"true\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls><table class=\"table\"><thead><tr><th>Purchase Order</th><th>Line No.</th><th>Supplier</th><th>Workpack</th><th>Cost Code</th><th>Material Code</th><th>Description</th><th>Created Date</th><th>Quantity</th><th>Unit Price</th><th>Total Value</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"result in vm.results | orderBy: [natural(\'purchaseOrder.number\'), natural(\'lineNumber\')] | itemsPerPage: vm.itemsPerPage\" current-page=\"vm.currentPage\"><td ng-bind-html=\"::result.purchaseOrder.number | highlight:vm.lastSearchParams.searchTerm\"></td><td><a ui-sref=\"purchase-orders.details({id:result.purchaseOrder.id, highlight:vm.lastSearchParams.searchTerm})\">{{::result.lineNumber}}</a></td><td ng-bind-html=\"::result.purchaseOrder.supplierName | highlight:vm.lastSearchParams.searchTerm\"></td><td ng-bind-html=\"::result.workpack | highlight:vm.lastSearchParams.searchTerm\"></td><td ng-bind-html=\"::result.costCode | highlight:vm.lastSearchParams.searchTerm\" class=\"text-nowrap\"></td><td ng-bind-html=\"::result.materialCode | highlight:vm.lastSearchParams.searchTerm\" class=\"text-nowrap\"></td><td ng-bind-html=\"::result.materialDescription| highlight:vm.lastSearchParams.searchTerm\"></td><td class=\"text-nowrap\">{{::result.purchaseOrder.date | date:\'dd-MMM-yyyy\'}}</td><td class=\"text-nowrap\">{{::result.quantity}} {{::result.unitOfMeasureCode}}</td><td class=\"text-nowrap text-right\">{{::result.unitPricePrice | number: 2}}</td><td class=\"text-nowrap text-right\">{{::result.totalValue | number: 2}} {{::result.unitPriceCurrencyCode}}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls></div><div ng-show=\"!vm.results.length\">No results found.</div></div></div></div></div></div>");
$templateCache.put("app/search/searchDelivery.html","<div ng-controller=\"DeliverySearchCtrl as vm\" class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row add-pd-b\"><div class=\"col-lg-12\"><div class=\"ibox-title\"><h5>Delivery Search</h5></div><div class=\"ibox-content\"><div class=\"row m-t-sm\"><div class=\"col-lg-12\"><form role=\"form\" ng-submit=\"vm.resetCurrentPage(); vm.doSearch()\"><div class=\"col-sm-12\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchTerm\" placeholder=\"Enter description, material code, supplier name, po number etc...\"> <span class=\"input-group-btn\"><button type=\"button\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-click=\"vm.resetCurrentPage(); vm.doSearch(vm.searchTerm)\">Go!</button></span></div></div></form></div></div></div></div></div><div class=\"ibox float-e-margins\" ng-show=\"vm.results\"><div class=\"ibox-title\"><h3>{{vm.totalItems}} results for \"{{ vm.lastSearchTerm }}\" <small></small></h3></div><div class=\"ibox-content\"><div ng-show=\"vm.results.length\"><dir-pagination-controls boundary-links=\"true\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls><table class=\"table\"><thead><tr><th>Number</th><th>Purchase Order</th><th>Line No</th><th>Supplier</th><th>Supplier Reference</th><th>Cost Code</th><th>Material Code</th><th>Description</th><th>Quantity</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"result in vm.results | itemsPerPage: vm.itemsPerPage\" current-page=\"vm.currentPage\"><td ng-bind-html=\"::result.deliveryNumber | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.purchaseOrderNumber| highlight:vm.lastSearchTerm\"></td><td><a ui-sref=\"deliveries.details({id:result.deliveryId, highlight:vm.lastSearchTerm})\">{{::result.lineNumber}}</a></td><td ng-bind-html=\"::result.supplierName | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.supplierDeliveryNumber | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.costCode | highlight:vm.lastSearchTerm\" class=\"text-nowrap\"></td><td ng-bind-html=\"::result.materialCode | highlight:vm.lastSearchTerm\" class=\"text-nowrap\"></td><td ng-bind-html=\"::result.description| highlight:vm.lastSearchTerm\"></td><td class=\"text-nowrap\">{{::result.statedQuantity}} {{::result.unitOfMeasureCode}}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls></div><div ng-show=\"!vm.results.length\">No results found.</div></div></div></div></div></div>");
$templateCache.put("app/search/searchIssue.html","<div ng-controller=\"IssueSearchCtrl as vm\" class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row add-pd-b\"><div class=\"col-lg-12\"><div class=\"ibox-title\"><h5>Issue Search</h5></div><div class=\"ibox-content\"><div class=\"row m-t-sm\"><div class=\"col-lg-12\"><form role=\"form\" ng-submit=\"vm.resetCurrentPage(); vm.doSearch()\"><div class=\"col-sm-12\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchTerm\" placeholder=\"Enter description, material code, supplier name, po number etc...\"> <span class=\"input-group-btn\"><button type=\"button\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-click=\"vm.resetCurrentPage(); vm.doSearch(vm.searchTerm)\">Go!</button></span></div></div></form></div></div></div></div></div><div class=\"ibox float-e-margins\" ng-show=\"vm.results\"><div class=\"ibox-title\"><h3>{{vm.totalItems}} results for \"{{ vm.lastSearchTerm }}\" <small></small></h3></div><div class=\"tabs-container items-container\" ng-show=\"vm.results.length || vm.resultsBagAndTag.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsResultsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.results.length ? vm.results.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"stock-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls><table class=\"table materia-grouped-row\" ng-show=\"vm.results.length\"><thead><tr><th>Issue</th><th>Issue Desc</th><th>Purchase Order</th><th>Line No</th><th>Barcode</th><th>Cost Code</th><th>Material Code</th><th>Picklist</th><th>Picklist Desc</th><th>Quantity</th></tr></thead><tbody dir-paginate=\"result in vm.results | orderBy: [natural(\'issueNumber\')] | itemsPerPage: vm.itemsPerPage\" pagination-id=\"stock-items\" current-page=\"vm.currentPage\"><tr ng-class=\"item.class\" class=\"rowlink\"><td colspan=\"8\" class=\"item-description\" ng-bind-html=\"::result.description | uppercase| highlight:vm.lastSearchTerm\" ui-sref=\"issues.details({id:result.issueId, highlight:vm.lastSearchTerm})\"></td></tr><tr data-link=\"row\" class=\"rowlink\"><td ng-bind-html=\"::result.issueNumber | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.issueDescription | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.poNumber| highlight:vm.lastSearchTerm\"></td><td><a ui-sref=\"issues.details({id:result.issueId, highlight:vm.lastSearchTerm})\">{{::result.poLineNumber}}</a></td><td ng-bind-html=\"::result.barcode | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.costCode | highlight:vm.lastSearchTerm\" class=\"text-nowrap\"></td><td ng-bind-html=\"::result.materialCode | highlight:vm.lastSearchTerm\" class=\"text-nowrap\"></td><td ng-bind-html=\"::result.picklistNumber | highlight:vm.lastSearchTerm\" class=\"text-nowrap\"></td><td ng-bind-html=\"::result.picklistDescription | highlight:vm.lastSearchTerm\" class=\"text-nowrap\"></td><td class=\"text-nowrap\">{{::result.selectedQuantity}} {{::result.unitOfMeasureCode}}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"stock-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls></div><div ng-show=\"!vm.results.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagResultsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.resultsBagAndTag.length ? vm.resultsBagAndTag.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.resultsBagAndTag.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"bag-and-tag-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls><table class=\"table materia-grouped-row\" ng-show=\"vm.resultsBagAndTag\"><thead><th width=\"50\"></th><th>Issue</th><th>Issue Desc</th><th>Number</th><th>Workpack number</th></thead><tbody dir-paginate=\"item in vm.resultsBagAndTag | itemsPerPage: vm.itemsPerPage\" pagination-id=\"bag-and-tag-items\" current-page=\"vm.currentPage\"><tr ng-class=\"item.class\" class=\"rowlink\" data-link=\"row\"><td class=\"rowlink-skip\"><wg-edit-grouped-items is-read-only=\"true\" is-bag-and-tag-view=\"true\" bag-and-tag-id=\"{{item.id}}\" description=\"{{item.description}}\"></wg-edit-grouped-items><a ui-sref=\"issues.details({id:item.issueId, highlight:vm.lastSearchTerm})\"></a></td><td colspan=\"4\" class=\"item-description\" ng-bind-html=\"::item.description | uppercase| highlight:vm.lastSearchTerm\"></td></tr><tr ng-class=\"item.class\" class=\"rowlink\" data-link=\"row\"><td><a ui-sref=\"issues.details({id:item.issueId, highlight:vm.lastSearchTerm})\"></a></td><td ng-bind-html=\"::item.issueNumber| highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.issueDescription | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.number| highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.workpackNumber| highlight:vm.lastSearchTerm\"></td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"bag-and-tag-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls></div><div ng-show=\"!vm.resultsBagAndTag.length\">No results found.</div></div></uib-tab></uib-tabset></div></div></div></div></div>");
$templateCache.put("app/search/searchManifest.html","<div ng-controller=\"ManifestSearchCtrl as vm\" class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row add-pd-b\"><div class=\"col-lg-12\"><div class=\"ibox-title\"><h5>Manifest Search</h5></div><div class=\"ibox-content\"><div class=\"row m-t-sm\"><div class=\"col-lg-12\"><form role=\"form\" ng-submit=\"vm.resetCurrentPage(); vm.doSearch()\"><div class=\"col-sm-12\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchTerm\" placeholder=\"Enter description, material code, supplier name, po number etc...\"> <span class=\"input-group-btn\"><button type=\"button\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-click=\"vm.resetCurrentPage(); vm.doSearch(vm.searchTerm)\">Go!</button></span></div></div></form></div></div></div></div></div><div class=\"ibox float-e-margins\" ng-show=\"vm.results\"><div class=\"ibox-title\"><h3>{{vm.totalItems}} results for \"{{ vm.lastSearchTerm }}\" <small></small></h3></div><div class=\"tabs-container items-container\" ng-show=\"vm.results.length || vm.resultsBagAndTag.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsResultsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.results.length ? vm.results.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"stock-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls><table class=\"table materia-grouped-row\" ng-show=\"vm.results.length\"><thead><tr><th>Manifest</th><th>Manifest Desc</th><th>Document Number</th><th>Purchase Order</th><th>Line No</th><th>Barcode</th><th>Cost Code</th><th>Material Code</th><th>Quantity</th></tr></thead><tbody dir-paginate=\"result in vm.results | orderBy: [natural(\'manifestNumber\')] | itemsPerPage: vm.itemsPerPage\" pagination-id=\"stock-items\" current-page=\"vm.currentPage\"><tr ng-class=\"item.class\" class=\"rowlink\" ng-if=\"result.description\"><td colspan=\"10\" class=\"item-description\" ng-bind-html=\"::result.description | uppercase| highlight:vm.lastSearchTerm\" ui-sref=\"manifests.details({id:result.manifestId, highlight:vm.lastSearchTerm})\"></td></tr><tr ng-class=\"item.class\" class=\"rowlink\" ng-if=\"!result.description\"><td colspan=\"10\" class=\"item-description\"><a ui-sref=\"manifests.details({id:result.manifestId, highlight:vm.lastSearchTerm})\">No items have been added to manifest {{result.manifestNumber}}</a></td></tr><tr data-link=\"row\" class=\"rowlink\"><td ng-bind-html=\"::result.manifestNumber | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.manifestDescription | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.documentNumber | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.poNumber| highlight:vm.lastSearchTerm\"></td><td><a ui-sref=\"manifests.details({id:result.manifestId, highlight:vm.lastSearchTerm})\">{{::result.poLineNumber}}</a></td><td ng-bind-html=\"::result.barcode | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.costCode | highlight:vm.lastSearchTerm\" class=\"text-nowrap\"></td><td ng-bind-html=\"::result.materialCode | highlight:vm.lastSearchTerm\" class=\"text-nowrap\"></td><td class=\"text-nowrap\">{{::result.quantity}} {{::result.unitOfMeasureCode}}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"stock-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls></div><div ng-show=\"!vm.results.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagResultsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.resultsBagAndTag.length ? vm.resultsBagAndTag.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.resultsBagAndTag.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"bag-and-tag-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls><table class=\"table materia-grouped-row\" ng-show=\"vm.resultsBagAndTag\"><thead><th width=\"50\"></th><th>Manifest</th><th>Manifest Desc</th><th>Number</th><th>Workpack number</th></thead><tbody dir-paginate=\"item in vm.resultsBagAndTag | itemsPerPage: vm.itemsPerPage\" pagination-id=\"bag-and-tag-items\" current-page=\"vm.currentPage\"><tr ng-class=\"item.class\" class=\"rowlink\" data-link=\"row\"><td class=\"rowlink-skip\"><wg-edit-grouped-items is-read-only=\"true\" is-bag-and-tag-view=\"true\" bag-and-tag-id=\"{{item.bagAndTagId}}\" description=\"{{item.description}}\"></wg-edit-grouped-items><a ui-sref=\"manifests.details({id:item.manifestId, highlight:vm.lastSearchTerm})\"></a></td><td colspan=\"4\" class=\"item-description\" ng-bind-html=\"::item.description | uppercase| highlight:vm.lastSearchTerm\"></td></tr><tr ng-class=\"item.class\" class=\"rowlink\" data-link=\"row\"><td><a ui-sref=\"manifests.details({id:item.manifestId, highlight:vm.lastSearchTerm})\"></a></td><td ng-bind-html=\"::item.manifestNumber| highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.manifestDescription | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.number| highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.workpackNumber| highlight:vm.lastSearchTerm\"></td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"bag-and-tag-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls></div><div ng-show=\"!vm.resultsBagAndTag.length\">No results found.</div></div></uib-tab></uib-tabset></div></div></div></div></div>");
$templateCache.put("app/search/searchReturn.html","<div ng-controller=\"ReturnSearchCtrl as vm\" class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row add-pd-b\"><div class=\"col-lg-12\"><div class=\"ibox-title\"><h5>Return Search</h5></div><div class=\"ibox-content\"><div class=\"row m-t-sm\"><div class=\"col-lg-12\"><form role=\"form\" ng-submit=\"vm.resetCurrentPage(); vm.doSearch()\"><div class=\"col-sm-12\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchTerm\" placeholder=\"Enter description, material code, supplier name, po number etc...\"> <span class=\"input-group-btn\"><button type=\"button\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-click=\"vm.resetCurrentPage(); vm.doSearch(vm.searchTerm)\">Go!</button></span></div></div></form></div></div></div></div></div><div class=\"ibox float-e-margins\" ng-show=\"vm.results\"><div class=\"ibox-title\"><h3>{{vm.totalItems}} results for \"{{ vm.lastSearchTerm }}\" <small></small></h3></div><div class=\"tabs-container items-container\" ng-show=\"vm.results.length || vm.resultsBagAndTag.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsResultsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.results.length ? vm.results.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"stock-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls><table class=\"table materia-grouped-row\" ng-show=\"vm.results.length\"><thead><tr><th>Return</th><th>Return Desc</th><th>Issue</th><th>Issue Desc</th><th>Purchase Order</th><th>Line No</th><th>Barcode</th><th>Cost Code</th><th>Material Code</th><th>Quantity</th></tr></thead><tbody dir-paginate=\"result in vm.results | orderBy: [natural(\'returnNumber\')] | itemsPerPage: vm.itemsPerPage\" pagination-id=\"stock-items\" current-page=\"vm.currentPage\"><tr ng-class=\"item.class\" class=\"rowlink\"><td colspan=\"10\" class=\"item-description\" ng-bind-html=\"::result.description | uppercase| highlight:vm.lastSearchTerm\" ui-sref=\"returns.details({id:result.returnId, highlight:vm.lastSearchTerm})\"></td></tr><tr data-link=\"row\" class=\"rowlink\"><td ng-bind-html=\"::result.returnNumber | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.returnDescription | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.issueNumber | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.issueDescription | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.poNumber| highlight:vm.lastSearchTerm\"></td><td><a ui-sref=\"returns.details({id:result.returnId, highlight:vm.lastSearchTerm})\">{{::result.poLineNumber}}</a></td><td ng-bind-html=\"::result.barcode | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.costCode | highlight:vm.lastSearchTerm\" class=\"text-nowrap\"></td><td ng-bind-html=\"::result.materialCode | highlight:vm.lastSearchTerm\" class=\"text-nowrap\"></td><td class=\"text-nowrap\">{{::result.selectedQuantity}} {{::result.unitOfMeasureCode}}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"stock-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls></div><div ng-show=\"!vm.results.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagResultsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.resultsBagAndTag.length ? vm.resultsBagAndTag.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.resultsBagAndTag.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"bag-and-tag-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls><table class=\"table materia-grouped-row\" ng-show=\"vm.resultsBagAndTag\"><thead><th width=\"50\"></th><th>Return</th><th>Return Desc</th><th>Issue</th><th>Issue Desc</th><th>Number</th><th>Workpack number</th></thead><tbody dir-paginate=\"item in vm.resultsBagAndTag | itemsPerPage: vm.itemsPerPage\" pagination-id=\"bag-and-tag-items\" current-page=\"vm.currentPage\"><tr ng-class=\"item.class\" class=\"rowlink\" data-link=\"row\"><td class=\"rowlink-skip\"><wg-edit-grouped-items is-read-only=\"true\" is-bag-and-tag-view=\"true\" bag-and-tag-id=\"{{item.id}}\" description=\"{{item.description}}\"></wg-edit-grouped-items><a ui-sref=\"returns.details({id:item.returnId, highlight:vm.lastSearchTerm})\"></a></td><td colspan=\"6\" class=\"item-description\" ng-bind-html=\"::item.description | uppercase| highlight:vm.lastSearchTerm\"></td></tr><tr ng-class=\"item.class\" class=\"rowlink\" data-link=\"row\"><td><a ui-sref=\"returns.details({id:item.returnId, highlight:vm.lastSearchTerm})\"></a></td><td ng-bind-html=\"::item.returnNumber| highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.returnDescription | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.issueNumber| highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.issueDescription | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.number| highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.workpackNumber| highlight:vm.lastSearchTerm\"></td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"bag-and-tag-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls></div><div ng-show=\"!vm.resultsBagAndTag.length\">No results found.</div></div></uib-tab></uib-tabset></div></div></div></div></div>");
$templateCache.put("app/search/searchTransfer.html","<div ng-controller=\"TransferSearchCtrl as vm\" class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row add-pd-b\"><div class=\"col-lg-12\"><div class=\"ibox-title\"><h5>Transfer Search</h5></div><div class=\"ibox-content\"><div class=\"row m-t-sm\"><div class=\"col-lg-12\"><form role=\"form\" ng-submit=\"vm.resetCurrentPage(); vm.doSearch()\"><div class=\"col-sm-12\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.searchTerm\" placeholder=\"Enter description, material code, supplier name, po number etc...\"> <span class=\"input-group-btn\"><button type=\"button\" ladda=\"vm.searching\" class=\"btn btn-primary\" ng-click=\"vm.resetCurrentPage(); vm.doSearch(vm.searchTerm)\">Go!</button></span></div></div></form></div></div></div></div></div><div class=\"ibox float-e-margins\" ng-show=\"vm.results\"><div class=\"ibox-title\"><h3>{{vm.totalItems}} results for \"{{ vm.lastSearchTerm }}\" <small></small></h3></div><div class=\"tabs-container items-container\" ng-show=\"vm.results.length || vm.resultsBagAndTag.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsResultsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.results.length ? vm.results.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"stock-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls><table class=\"table materia-grouped-row\" ng-show=\"vm.results.length\"><thead><tr><th>Transfer</th><th>Transfer Desc</th><th>Purchase Order</th><th>Line No</th><th>Barcode</th><th>Cost Code</th><th>Material Code</th><th>Quantity</th></tr></thead><tbody dir-paginate=\"result in vm.results | orderBy: [natural(\'transferNumber\')] | itemsPerPage: vm.itemsPerPage\" pagination-id=\"stock-items\" current-page=\"vm.currentPage\"><tr ng-class=\"item.class\" class=\"rowlink\"><td colspan=\"8\" class=\"item-description\" ng-bind-html=\"result.description | uppercase| highlight:vm.lastSearchTerm\" ui-sref=\"transfer.details({id:result.transferId, highlight:vm.lastSearchTerm})\"></td></tr><tr data-link=\"row\" class=\"rowlink\"><td ng-bind-html=\"::result.transferNumber | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.transferDescription | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.poNumber| highlight:vm.lastSearchTerm\"></td><td><a ui-sref=\"transfer.details({id:result.transferId, highlight:vm.lastSearchTerm})\">{{::result.poLineNumber}}</a></td><td ng-bind-html=\"::result.barcode | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::result.costCode | highlight:vm.lastSearchTerm\" class=\"text-nowrap\"></td><td ng-bind-html=\"::result.materialCode | highlight:vm.lastSearchTerm\" class=\"text-nowrap\"></td><td class=\"text-nowrap\">{{::result.selectedQuantity}} {{::result.unitOfMeasureCode}}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"stock-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls></div><div ng-show=\"!vm.results.length\">No results found.</div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagResultsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.resultsBagAndTag.length ? vm.resultsBagAndTag.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.resultsBagAndTag.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"bag-and-tag-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls><table class=\"table materia-grouped-row\" ng-show=\"vm.resultsBagAndTag\"><thead><th width=\"50\"></th><th>Issue</th><th>Issue Desc</th><th>Number</th><th>Workpack number</th></thead><tbody dir-paginate=\"item in vm.resultsBagAndTag | itemsPerPage: vm.itemsPerPage\" pagination-id=\"bag-and-tag-items\" current-page=\"vm.currentPage\"><tr ng-class=\"item.class\" class=\"rowlink\" data-link=\"row\"><td class=\"rowlink-skip\"><wg-edit-grouped-items is-read-only=\"true\" is-bag-and-tag-view=\"true\" bag-and-tag-id=\"{{item.id}}\" description=\"{{item.description}}\"></wg-edit-grouped-items><a ui-sref=\"returns.details({id:item.returnId, highlight:vm.lastSearchTerm})\"></a></td><td colspan=\"4\" class=\"item-description\" ng-bind-html=\"::item.description | uppercase| highlight:vm.lastSearchTerm\"></td></tr><tr ng-class=\"item.class\" class=\"rowlink\" data-link=\"row\"><td><a ui-sref=\"returns.details({id:item.returnId, highlight:vm.lastSearchTerm})\"></a></td><td ng-bind-html=\"::item.issueNumber| highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.issueDescription | highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.number| highlight:vm.lastSearchTerm\"></td><td ng-bind-html=\"::item.workpackNumber| highlight:vm.lastSearchTerm\"></td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"bag-and-tag-items\" on-page-change=\"vm.pageChange(newPageNumber)\"></dir-pagination-controls></div><div ng-show=\"!vm.resultsBagAndTag.length\">No results found.</div></div></uib-tab></uib-tabset></div></div></div></div></div>");
$templateCache.put("app/transfers/addBagAndTagModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-exchange modal-icon\"></i><h4 class=\"modal-title\">Transfer bag & tag location</h4></div><div class=\"modal-body p-b-xss\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\">New location</label><div class=\"col-lg-8\"><select required=\"\" kendo-drop-down-list=\"\" k-options=\"vm.locationOptions\" k-ng-model=\"vm.locationSelected\" style=\"width: 100%\" ng-disabled=\"vm.saved\"></select></div></div><div class=\"hr-line-dashed\"></div><kendo-treelist id=\"treelist\" options=\"vm.storedItemsOptions\" style=\"width: 835px\"></kendo-treelist></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Successfully transferred items.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error transferring items.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.locationSelected == undefined || vm.saved || !(vm.storedItemsOptions.dataSource.data() | filter:{isIncluded: true} | filter:vm.greaterThan(\'quantity\', 0)).length\">Transfer</button></div></div>");
$templateCache.put("app/transfers/addCostCodeItemsModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-exchange modal-icon\"></i><h4 class=\"modal-title\">Transfer cost code</h4></div><div class=\"modal-body p-b-xxs\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\">New cost code</label><div class=\"col-lg-8\"><select required=\"\" kendo-combo-box=\"\" k-options=\"vm.costCodesOptions\" ng-model=\"vm.transferItem.costCode\" style=\"width:100%\" ng-disabled=\"vm.saved\"></select></div></div><div class=\"hr-line-dashed\"></div><table class=\"table materia-grouped-row\"><tbody ng-repeat=\"item in vm.items | orderBy: \'description\'\"><tr ng-class=\"item.class\"><td colspan=\"6\" class=\"item-description\">{{item.description | uppercase}}</td></tr><tr ng-class=\"item.class\"><td>{{item.costCode}}</td><td><pre class=\"inline btn btn-sm btn-default no-hover\">{{item.materialCode}}</pre></td><td><pre class=\"inline btn btn-sm btn-default no-hover\">{{item.barcode}}</pre></td><td>{{item.unitOfMeasureCode}}</td><td ng-hide=\"vm.isReturn\">{{item.warehouseName}} / {{item.locationName}}</td><td><input type=\"text\" class=\"form-control\" ng-model=\"item.selectedQuantity\" numeric-only=\"\" ng-disabled=\"true\"></td></tr></tbody></table></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Successfully transferred items.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error transferring items.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.transferItem.costCode == undefined || vm.saved\">Transfer</button></div></div>");
$templateCache.put("app/transfers/viewTransfer.html","<div ng-controller=\"ViewTransferCtrl as vm\"><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"m-b-md\"><h2><span class=\"text-nowrap\">Transfer {{ vm.transfer.number }}</span> <small><strong class=\"text-nowrap\">{{vm.transfer.description }}</strong></small> <span ng-class=\"!vm.transfer.isReadOnly ? \'badge label-warning\' : (vm.transfer.transferStatus === \'Cancelled\') ? \'badge label-danger\' : \'badge label-primary\'\">{{vm.transfer.transferStatus}}</span></h2><span class=\"text-nowrap\"><strong>Created by:</strong> {{vm.transfer.createdBy}} | <strong>Created date:</strong> {{vm.transfer.createdDate | date: \'dd-MMM-yyyy\'}} <span ng-if=\"vm.transfer.transferStatus === \'Complete\'\">| <strong>Closed by:</strong> {{vm.transfer.completedBy}} | <strong>Closed date:</strong> {{vm.transfer.completedDate | date: \'dd-MMM-yyyy\'}}</span></span></div><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-7\" ng-if=\"!vm.transfer.isReadOnly\"><wg-search-criteria results=\"vm.results\" bag-and-tag-results=\"vm.bagAndTagResults\" tabs=\"vm.tabs\"></wg-search-criteria><div class=\"tabs-container items-container\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsResultsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.results.length ? vm.results.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div class=\"add-pd-b\"><button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.addItems((vm.results | greaterThanZero: 0))\" ng-disabled=\"!(vm.results | greaterThanZero: 0).length || (vm.results | invalidQuantity:0).length\">Transfer location</button> <button type=\"submit\" class=\"btn btn-primary\" ladda=\"vm.loading\" data-style=\"expand-right\" ng-click=\"vm.addCostCodeItems((vm.results | greaterThanZero: 0))\" ng-disabled=\"!(vm.results | greaterThanZero: 0).length || (vm.results | invalidQuantity:0).length\">Transfer cost code</button></div><div class=\"row\"><div class=\"ibox-content\" ng-show=\"vm.results\"><div class=\"table-responsive\"><table class=\"table materia-grouped-row\" ng-show=\"vm.results.length\"><thead><tr><th><input type=\"checkbox\" ng-model=\"vm.selectedAll\" icheck-all-four=\"vm.results.storedItems.isIncluded\"></th><th>PO / Item</th><th>Material code</th><th>Barcode</th><th>UOM</th><th>Cost code</th><th>Location</th><th>Avail. Qty</th><th>Transfer Qty</th></tr></thead><tbody ng-repeat=\"item in vm.results | orderBy: [\'poNumber\', natural(\'poLineNumber\')]\" item=\"item\" wg-stored-item-checkboxes=\"\"></tbody></table></div><div ng-show=\"!vm.results.length\">No results found.</div></div></div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagResultsActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.bagAndTagResults.length ? vm.bagAndTagResults.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.bagAndTagResults.length\"><table class=\"table materia-grouped-row\" ng-show=\"vm.bagAndTagResults\"><thead><th width=\"50\"></th><th>Number</th><th>Workpack number</th><th></th></thead><tbody ng-repeat=\"item in vm.bagAndTagResults\" item=\"item\" wg-bag-and-tag-item=\"\" enable-transfer=\"true\" transfer-item=\"vm.transferBagAndTag(item)\"></tbody></table></div><div ng-show=\"!vm.bagAndTagResults.length\">No results found.</div></div></uib-tab></uib-tabset></div></div><div ng-class=\"!vm.transfer.isReadOnly ? \'col-lg-5\' : \'col-lg-12\'\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Transferred items</h5></div><div class=\"ibox-footer\"><div ng-cloak=\"\" ng-if=\"!vm.transfer.isReadOnly\"><div class=\"pull-left\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!vm.transferItems.length && !vm.transferBagAndTagItemsOptions.dataSource._total > 0 && !vm.transferCostCodeItems.length\" data-style=\"expand-right\" ng-click=\"vm.completeTransfer()\"><i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i> Close</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"vm.cancelTransfer()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Cancel</button></div><div class=\"clearfix\"></div></div></div><div class=\"ibox-content\" ng-show=\"!vm.transferItems.length && !vm.transferBagAndTagItemsOptions.dataSource._total > 0 && !vm.transferCostCodeItems.length\"><p><strong>No items have been included in this transfer.</strong></p><p ng-if=\"!vm.transfer.isReadOnly\">Use the search function to find stock...</p></div><div class=\"tabs-container items-container\" ng-if=\"vm.transferItems.length || vm.transferBagAndTagItemsOptions.dataSource._total > 0 || vm.transferCostCodeItems.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.transferItems.length ? vm.transferItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.transferItems.length\">No stock items have been included in this transfer.</strong><div ng-show=\"vm.transferItems.length\"><table class=\"table materia-grouped-row\"><thead><tr><th>Material code</th><th>Barcode</th><th>Transfer Qty</th><th>Previous Location</th><th>New Location</th><th ng-if=\"!vm.transfer.isReadOnly\"></th></tr></thead><tbody wg-included-item=\"\" ng-repeat=\"transferItem in vm.transferItems\" item=\"transferItem\" is-read-only=\"vm.transfer.isReadOnly\" remove-item=\"vm.removeItem(transferItem)\" include-new-locations=\"true\"></tbody></table></div></div></uib-tab><uib-tab active=\"vm.tabs.bagAndTagActive\"><uib-tab-heading>Bag & Tag <span class=\"badge label-info\">{{vm.transferBagAndTagItems.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.transferBagAndTagItemsOptions.dataSource._total > 0\">No bag & tag items have been included in this transfer.</strong><kendo-treelist id=\"treelist\" options=\"vm.transferBagAndTagItemsOptions\"></kendo-treelist></div></uib-tab><uib-tab active=\"vm.tabs.storedItemsCostCodeActive\"><uib-tab-heading>Cost code transfer <span class=\"badge label-info\">{{vm.transferCostCodeItems.length ? vm.transferCostCodeItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.transferCostCodeItems.length\">No cost codes have been included in this transfer.</strong><div ng-show=\"vm.transferCostCodeItems.length\"><table class=\"table materia-grouped-row\"><thead><tr><th>Material code</th><th>Barcode</th><th>Transfer Qty</th><th>Previous Cost Code</th><th>New Cost Code</th><th ng-if=\"!vm.transfer.isReadOnly\"></th></tr></thead><tbody wg-included-item=\"\" ng-repeat=\"transferItem in vm.transferCostCodeItems\" item=\"transferItem\" is-read-only=\"vm.transfer.isReadOnly\" remove-item=\"vm.removeCostCodeItem(transferItem)\" no-locations=\"true\" show-cost-code=\"true\"></tbody></table></div></div></uib-tab></uib-tabset></div></div></div></div></div></div>");
$templateCache.put("app/transfers/viewTransfers.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><form role=\"form\" name=\"createForm\" ng-submit=\"vm.createTransfer()\" ng-controller=\"CreateTransferCtrl as vm\"><div class=\"ibox-title\"><h5 for=\"product_name\">Create a transfer</h5></div><div class=\"form-group\"><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"description\" placeholder=\"Enter a description\" required=\"\" ng-model=\"vm.transfer.description\" ng-class=\"{ \'has-error\' : createForm.name.$invalid && !createForm.name.$pristine }\"> <span class=\"input-group-btn\"><button type=\"submit\" ladda=\"vm.loading\" class=\"btn btn-primary\" ng-disabled=\"createForm.$invalid\">Create transfer</button></span></div></div></div></form></div></div><div class=\"tabs-container\" ng-controller=\"ViewTransfersCtrl as vm\"><uib-tabset><uib-tab><uib-tab-heading><i class=\"fa fa-warning\"></i>Incomplete <span class=\"badge label-warning\">{{vm.transfers.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.transfers.length\">There are no incomplete transfers.</strong><div ng-if=\"vm.transfers.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"transfers\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-1 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"transfer in vm.transfers | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"transfers\"><td><a ui-sref=\"transfer.details({id:transfer.id})\">{{ transfer.number }}</a></td><td>{{ transfer.description }}</td><td>{{ transfer.createdBy }}</td><td>{{ transfer.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"transfers\"></dir-pagination-controls></div></div></uib-tab><uib-tab><uib-tab-heading><i class=\"fa fa-check-square-o\"></i>Closed <span class=\"badge label-primary\">{{ vm.completedTransfers.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.completedTransfers.length\">There are no closed transfers.</strong><div ng-if=\"vm.completedTransfers.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completedTransfers\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-1 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th><th class=\"col-xs-1 text-nowrap\">Closed by</th><th class=\"col-xs-1 text-nowrap\">Closed date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"transfer in vm.completedTransfers | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"completedTransfers\"><td><a ui-sref=\"transfer.details({id:transfer.id})\">{{ transfer.number }}</a></td><td>{{ transfer.description }}</td><td>{{ transfer.createdBy }}</td><td>{{ transfer.createdDate | date:\'dd-MMM-yyyy\' }}</td><td>{{ transfer.completedBy }}</td><td>{{ transfer.completedDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completedTransfers\"></dir-pagination-controls></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/movements/viewMovement.html","<div ng-controller=\"ViewMovementCtrl as vm\"><div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content remove-pd-b\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"m-b-md\"><h2><span class=\"text-nowrap\">Movement {{ vm.movement.number }}</span> <small><strong class=\"text-nowrap\">{{vm.movement.description }}</strong></small> <span ng-class=\"!vm.movement.isReadOnly ? \'badge label-warning\' : (vm.movement.movementStatus === \'Cancelled\') ? \'badge label-danger\' : \'badge label-primary\'\">{{vm.movement.movementStatus}}</span> <span ng-class=\"vm.movement.pickingStatus === \'Pick\' ? \'badge\' : (vm.movement.pickingStatus === \'Picking\') ? \'badge label-warning\' : \'badge label-primary\'\">{{vm.movement.pickingStatus}}</span></h2><span class=\"text-nowrap\"><strong>Warehouse:</strong> {{vm.movement.warehouseName}} | <strong>Created by:</strong> {{vm.movement.createdBy}} | <strong>Created date:</strong> {{vm.movement.createdDate | date: \'dd-MMM-yyyy\'}} <span ng-if=\"vm.movement.movementStatus === \'Complete\'\">| <strong>Completed by:</strong> {{vm.movement.completedBy}} | <strong>Completed date:</strong> {{vm.movement.completedDate | date: \'dd-MMM-yyyy\'}}</span> <span ng-if=\"vm.movement.hasDelivery\">| <strong>Delivery:</strong> {{vm.movement.deliveryNumber}}</span> <span ng-if=\"vm.movement.newProjectCode\">| <strong>To Project:</strong> {{vm.movement.newProjectCode}}</span></span></div><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controllerhasloaded\"><div class=\"col-lg-7\" ng-if=\"!vm.movement.isReadOnly\"><wg-search-criteria results=\"vm.results\" disable-bag-and-tag=\"true\" tabs=\"vm.tabs\" is-movement=\"true\" warehouse=\"vm.movement.warehouseId\"></wg-search-criteria><div class=\"tabs-container items-container add-pd-b\" ng-show=\"vm.results.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsResultsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.results.length ? vm.results.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><div ng-show=\"vm.results\"><table class=\"table materia-grouped-row\" ng-show=\"vm.results.length\"><thead><tr><th>PO / Item</th><th>Cost code</th><th>Material code</th><th>Barcode</th><th>UOM</th><th>Location</th><th>Avail. Qty</th><th>Movement Qty</th><th></th></tr></thead><tbody ng-repeat=\"item in vm.results | orderBy: [\'movementNumber\', \'poNumber\', natural(\'poLineNumber\')]\" item=\"item\" wg-stored-item=\"\" add-item=\"vm.addItem(item)\"></tbody></table></div><div ng-show=\"!vm.results.length\">No results found.</div></div></uib-tab></uib-tabset></div></div><div ng-class=\"!vm.movement.isReadOnly ? \'col-lg-5\' : \'col-lg-12\'\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\"><h5>Included items</h5></div><div class=\"ibox-footer\" ng-if=\"!vm.movement.isReadOnly\"><div ng-cloak=\"\"><div class=\"pull-left\"><button type=\"button\" class=\"btn btn-primary\" ng-disabled=\"!vm.movementItems.length && !vm.movementBagAndTagItems.length\" data-style=\"expand-right\" ng-click=\"vm.completeMovement()\"><i class=\"fa fa-check-square-o\" aria-hidden=\"true\"></i> Complete</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"vm.cancelMovement()\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Cancel</button></div><div class=\"clearfix\"></div></div></div><div class=\"ibox-content\" ng-show=\"!vm.movementItems.length && !vm.movementBagAndTagItems.length\"><p><strong>No items have been included in this movement.</strong></p><p ng-if=\"!vm.movement.isReadOnly\">Use the search function to find stock...</p></div><div class=\"tabs-container items-container\" ng-if=\"vm.movementItems.length\"><uib-tabset><uib-tab active=\"vm.tabs.storedItemsActive\"><uib-tab-heading>Stock items <span class=\"badge label-info\">{{vm.movementItems.length ? vm.movementItems.length : 0}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.movementItems.length\">No stock items have been included in this movement.</strong><div ng-show=\"vm.movementItems.length\"><table class=\"table materia-grouped-row\"><thead><tr><th>Material code</th><th>Barcode</th><th>Movement Qty</th><th data-sort-ignore=\"true\" ng-if=\"!vm.movement.isReadOnly\"></th></tr></thead><tbody wg-included-item=\"\" ng-repeat=\"item in vm.movementItems\" item=\"item\" is-read-only=\"vm.movement.isReadOnly\" remove-item=\"vm.removeItem(item)\" no-locations=\"true\"></tbody></table></div></div></uib-tab></uib-tabset></div></div></div></div></div></div>");
$templateCache.put("app/movements/viewMovements.html","<div class=\"wrapper wrapper-content animated fadeIn\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"col-lg-12\"><form role=\"form\" name=\"createForm\" ng-submit=\"vm.createMovement()\" ng-controller=\"CreateMovementCtrl as vm\"><div class=\"ibox-title\"><h5 for=\"product_name\">Create a movement</h5></div><div class=\"form-group\"><div class=\"ibox-content\"><div class=\"alert alert-danger\" ng-show=\"vm.hasErrors\"><ul><li ng-repeat=\"error in vm.validationErrors\">{{error}}</li></ul></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\"><label class=\"control-label\" for=\"description\">Description *</label> <input type=\"text\" class=\"form-control k-textbox\" name=\"description\" placeholder=\"Enter a description\" required=\"\" ng-model=\"vm.movement.description\" id=\"description\" ng-class=\"{ \'has-error\' : createForm.name.$invalid && !createForm.name.$pristine }\"></div><div class=\"col-lg-2\"><label class=\"control-label\" for=\"warehouse\">From Warehouse *</label><select kendo-combo-box=\"\" ng-model=\"vm.movement.warehouseId\" k-ng-delay=\"vm.movement.warehouseId\" k-options=\"vm.warehousesOptions\" class=\"form-control\" required=\"\" name=\"warehouse\" id=\"warehouse\" ng-class=\"{ \'has-error\' : createForm.warehouse.$invalid && !createForm.warehouse.$pristine }\"></select></div><div class=\"col-lg-2\"><label class=\"control-label\" for=\"newProjectId\">To Project</label><select kendo-combo-box=\"\" ng-model=\"vm.movement.newProjectId\" k-ng-delay=\"vm.movement.newProjectId\" k-options=\"vm.projectsOptions\" class=\"form-control\" name=\"newProjectId\" id=\"newProjectId\" ng-class=\"{ \'has-error\' : createForm.newProjectId.$invalid && !createForm.newProjectId.$pristine }\"></select></div><div class=\"col-lg-2 label-pad\"><button type=\"submit\" ladda=\"vm.loading\" class=\"btn btn-primary\" ng-disabled=\"createForm.$invalid\">Create movement</button></div></div></div></div></div></form></div></div><div class=\"tabs-container\" ng-controller=\"ViewMovementsCtrl as vm\"><uib-tabset><uib-tab ui-sref=\"movements.view\" active=\"vm.tabs.incompleteActive\"><uib-tab-heading><i class=\"fa fa-cart-plus\"></i>Incomplete <span class=\"badge label-warning\">{{vm.incompleteMovements.length}}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.incompleteMovements.length\">There are no incomplete movements.</strong><div ng-if=\"vm.incompleteMovements.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-5 text-nowrap\">Warehouse</th><th class=\"col-xs-5 text-nowrap\">To Project</th><th class=\"col-xs-2 text-nowrap\">Created by</th><th class=\"col-xs-2 text-nowrap\">Created date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"movement in vm.incompleteMovements | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"incomplete\"><td><a ui-sref=\"movements.details({id:movement.id})\">{{ movement.number }}</a></td><td>{{ movement.description }}</td><td>{{ movement.warehouseName }}</td><td>{{ movement.newProjectCode }}</td><td>{{ movement.createdBy }}</td><td>{{ movement.createdDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"incomplete\"></dir-pagination-controls></div></div></uib-tab><uib-tab active=\"vm.tabs.completeActive\"><uib-tab-heading><i class=\"fa fa-check-square-o\"></i>Awaiting delivery <span class=\"badge label-primary\">{{ vm.completedMovements.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.completedMovements.length\">There are no completed movements.</strong><div ng-if=\"vm.completedMovements.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completed\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-1 text-nowrap\">Warehouse</th><th class=\"col-xs-1 text-nowrap\">To Project</th><th class=\"col-xs-1 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th><th class=\"col-xs-1 text-nowrap\">Completed by</th><th class=\"col-xs-1 text-nowrap\">Completed date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"movement in vm.completedMovements | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"completed\"><td><a ui-sref=\"movements.details({id:movement.id})\">{{ movement.number }}</a></td><td>{{ movement.description }}</td><td>{{ movement.warehouseName }}</td><td>{{ movement.newProjectCode }}</td><td>{{ movement.createdBy}}</td><td>{{ movement.createdDate | date:\'dd-MMM-yyyy\' }}</td><td>{{ movement.completedBy}}</td><td>{{ movement.completedDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"completed\"></dir-pagination-controls></div></div></uib-tab><uib-tab active=\"vm.tabs.deliveryActive\"><uib-tab-heading><i class=\"fa fa-check-square-o\"></i>Delivery <span class=\"badge label-primary\">{{ vm.deliveryMovements.length }}</span></uib-tab-heading><div class=\"panel-body\"><strong ng-if=\"!vm.deliveryMovements.length\">There have been no movements delivered.</strong><div ng-if=\"vm.deliveryMovements.length\"><dir-pagination-controls boundary-links=\"true\" pagination-id=\"delivery\"></dir-pagination-controls><table class=\"table\"><thead><tr><th class=\"col-xs-1 text-nowrap\">#</th><th class=\"col-xs-5 text-nowrap\">Description</th><th class=\"col-xs-1 text-nowrap\">Warehouse</th><th class=\"col-xs-1 text-nowrap\">To Project</th><th class=\"col-xs-1 text-nowrap\">Delivery</th><th class=\"col-xs-1 text-nowrap\">Created by</th><th class=\"col-xs-1 text-nowrap\">Created date</th><th class=\"col-xs-1 text-nowrap\">Completed by</th><th class=\"col-xs-1 text-nowrap\">Completed date</th></tr></thead><tbody data-link=\"row\" class=\"rowlink\"><tr dir-paginate=\"movement in vm.deliveryMovements | orderBy: number : true | itemsPerPage: 15\" pagination-id=\"delivery\"><td><a ui-sref=\"movements.details({id:movement.id})\">{{ movement.number }}</a></td><td>{{ movement.description }}</td><td>{{ movement.warehouseName }}</td><td>{{ movement.newProjectCode }}</td><td>{{ movement.deliveryNumber }}</td><td>{{ movement.createdBy}}</td><td>{{ movement.createdDate | date:\'dd-MMM-yyyy\' }}</td><td>{{ movement.completedBy}}</td><td>{{ movement.completedDate | date:\'dd-MMM-yyyy\' }}</td></tr></tbody></table><dir-pagination-controls boundary-links=\"true\" pagination-id=\"delivery\"></dir-pagination-controls></div></div></uib-tab></uib-tabset></div></div></div></div>");
$templateCache.put("app/deliveries/inspection/addInspection.html","<button class=\"btn btn-primary\" ng-click=\"vm.openInspection()\">Inspect</button>");
$templateCache.put("app/deliveries/inspection/addInspectionModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Inspection {{vm.item.barcode}}</h4><h4 ng-if=\"!vm.isVendorInspection\">Checked quantity:{{vm.item.checkedQuantity}}</h4><small class=\"font-bold\">{{vm.item.description | uppercase}}</small></div><div class=\"modal-body p-b-xxs transfer-bag-and-tag\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Inspection</label><div class=\"col-lg-9\"><table class=\"table remove-margin-b\"><thead><tr><th class=\"width-150\">Inspected Quantity *</th><th class=\"width-150\">Passed Quantity</th><th class=\"width-150\">Failed Quantity *</th></tr></thead><tr class=\"new-border\"><td ng-class=\"{ \'has-error\' : (saveForm.checkedQuantity.$invalid && !saveForm.checkedQuantity.$pristine) || saveForm.checkedQuantity.$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.checkedQuantity\" name=\"checkedQuantity\" ng-disabled=\"!vm.isVendorInspection\" ng-max=\"vm.maxInspectionQuantity\"></td><td><input type=\"text\" class=\"form-control\" ng-value=\"vm.passedQuantity()\" ng-class=\"{ \'has-error\' : vm.passedQuantity() < 0 }\" name=\"passedQuantity\" ng-disabled=\"true\"></td><td ng-class=\"{ \'has-error\' : (saveForm.failedQuantity.$invalid && !saveForm.failedQuantity.$pristine) || saveForm.failedQuantity.$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.failedQuantity\" ng-max=\"vm.maxInspectionQuantity\" ng-min=\"0\" name=\"failedQuantity\" numeric-only=\"\" required=\"\" ng-disabled=\"vm.saved\"></td></tr><tr><td colspan=\"3\"><span class=\"text-danger\" ng-show=\"saveForm.failedQuantity.$error.ngMin || saveForm.failedQuantity.$error.ngMax\">Failed quantity must be between 0 and {{vm.maxInspectionQuantity}}.</span> <span class=\"text-danger\" ng-show=\"saveForm.checkedQuantity.$error.ngMax\">Inspected quantity must not be greater than {{vm.maxInspectionQuantity}}.</span> <span class=\"text-danger\" ng-show=\"vm.passedQuantity() < 0\">Passed quantity must be between 0 and {{vm.maxInspectionQuantity}}.</span></td></tr></table></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-lg-3 control-label\">IRC Number</label><div class=\"col-lg-9\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.item.ircNumber\" style=\"resize: none;\" ng-disabled=\"vm.saved\"></div></div><div class=\"form-group\"><label class=\"col-lg-3 control-label\">Comments <span ng-if=\"vm.item.failedQuantity > 0\">*</span></label><div class=\"col-lg-9\"><textarea type=\"text\" class=\"form-control\" ng-model=\"vm.item.comments\" style=\"resize: none;\" ng-disabled=\"vm.saved\" ng-required=\"vm.item.failedQuantity > 0\"></textarea></div></div><div class=\"form-group\" ng-if=\"vm.item.failedQuantity > 0 && !vm.isVendorInspection\"><label class=\"col-lg-3 control-label\">Quarantine location</label><div class=\"col-lg-9\"><select kendo-combo-box=\"\" k-options=\"vm.quarantineLocationsOptions\" ng-model=\"vm.selectedQuarantineLocationId\" name=\"location\" style=\"width:100%\" ng-disabled=\"vm.saved\" required=\"\" require-valid-option=\"\"></select></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Inspection completed.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error inspecting this item.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.saved || saveForm.$invalid\">Save</button></div></div>");
$templateCache.put("app/deliveries/inspection/addInspections.html","<button class=\"btn btn-primary\" ng-click=\"vm.inspectItems(vm.items)\" ng-disabled=\"!(vm.items | isIncluded).length\">Inspect selected</button>");
$templateCache.put("app/deliveries/inspection/addInspectionsModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Inspections</h4></div><div class=\"modal-body p-b-xxs\"><form name=\"saveForm\" class=\"form-horizontal\"><div class=\"form-group\"><div class=\"col-lg-12\"><div ng-repeat=\"item in vm.items | orderBy: \'checkLine.poLineNumber\'\"><div ng-if=\"item.inspections.length > 1\"><wg-split-inspection-item item=\"item\" warehouse-id=\"vm.warehouseId\" index=\"$index\"></wg-split-inspection-item></div><div ng-if=\"item.inspections.length < 2\"><wg-inspection-item item=\"item\" warehouse-id=\"vm.warehouseId\" index=\"$index\"></wg-inspection-item></div></div></div></div><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-lg-3 control-label\">IRC Number</label><div class=\"col-lg-9\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.ircNumber\" style=\"resize: none;\" ng-disabled=\"vm.saved\"></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Inspection completed.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error inspecting this item.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"vm.saved || saveForm.$invalid\">Save</button></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","<div class=\"footer\"><div class=\"pull-right\"></div><div><strong>Copyright</strong> John Wood Group plc &copy; 2015-2017</div></div>");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\" ng-controller=\"NavigationCtrl as vm\"><div class=\"sidebar-collapse\"><div id=\"logo-container\"><img src=\"../../assets/images/logo/wood_logo_White.png\" style=\"width: 100%;\"></div><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li ui-sref-active=\"active\"><a ui-sref=\"index.main\" title=\"Home\"><i class=\"fa fa-home fa-fw\"></i> <span class=\"nav-label\">Home</span></a></li><li ng-class=\"{active: $state.includes(\'search\')}\" ng-if=\"vm.allowSearch\"><a><i class=\"fa fa-search fa-fw\" title=\"Search\"></i> <span class=\"nav-label\">Search</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\"><li ui-sref-active=\"active\" ng-if=\"vm.allowPurchaseOrders\"><a ui-sref=\"search.purchase-orders\"><i class=\"fa fa-credit-card fa-fw\"></i>Purchase Orders</a></li><li ui-sref-active=\"active\" ng-if=\"vm.allowDeliveries\"><a ui-sref=\"search.deliveries\"><i class=\"fa fa-truck fa-fw\"></i>Deliveries</a></li><li ui-sref-active=\"active\" ng-if=\"vm.allowIssues\"><a ui-sref=\"search.issues\"><i class=\"fa fa-mail-forward fa-fw\"></i>Issues</a></li><li ui-sref-active=\"active\" ng-if=\"vm.allowReturns\"><a ui-sref=\"search.returns\"><i class=\"fa fa-mail-reply fa-fw\"></i>Returns</a></li><li ui-sref-active=\"active\" ng-if=\"vm.allowTransfers\"><a ui-sref=\"search.transfer\"><i class=\"fa fa-exchange fa-fw\"></i>Transfers</a></li><li ui-sref-active=\"active\" ng-if=\"vm.allowManifests\"><a ui-sref=\"search.manifests\"><i class=\"fa fa-ship fa-fw\"></i>Manifests</a></li></ul></li><li ng-class=\"{active: $state.includes(\'purchase-orders\')}\" ng-if=\"vm.allowPurchaseOrders\"><a ui-sref=\"purchase-orders.view\" title=\"Purchase Orders\"><i class=\"fa fa-credit-card fa-fw\"></i> <span class=\"nav-label\">Purchase Orders</span></a></li><li ng-class=\"{active: $state.includes(\'deliveries\')}\" ng-if=\"vm.allowDeliveries\"><a ui-sref=\"deliveries.view\" title=\"Deliveries\"><i class=\"fa fa-truck fa-fw\"></i> <span class=\"nav-label\">Deliveries</span></a></li><li ng-class=\"{active: $state.includes(\'issues\') || $state.includes(\'returns\') || $state.includes(\'bagAndTag\') || $state.includes(\'picklists\') || $state.includes(\'movements\') || $state.includes(\'transfer\') || $state.includes(\'minMax\')}\" ng-if=\"vm.allowWarehouseFunctions\"><a><i class=\"fa fa-archive fa-fw\" title=\"Warehouse\"></i> <span class=\"nav-label\">Warehouse</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\"><li ui-sref-active=\"active\" ng-if=\"vm.allowIssues\"><a ui-sref=\"issues.view\" title=\"Issues\"><i class=\"fa fa-mail-forward fa-fw\"></i>Issues</a></li><li ui-sref-active=\"active\" ng-if=\"vm.allowReturns\"><a ui-sref=\"returns.view\" title=\"Returns\"><i class=\"fa fa-mail-reply fa-fw\"></i>Returns</a></li><li ui-sref-active=\"active\" ng-if=\"vm.allowBagAndTag\"><a ui-sref=\"bagAndTag.view\" title=\"Bag & Tag\"><i class=\"fa fa-tags fa-fw\"></i>Bag & Tag</a></li><li ui-sref-active=\"active\" ng-if=\"vm.allowPicklists\"><a ui-sref=\"picklists.view\" title=\"Picklists\"><i class=\"fa fa-shopping-cart fa-fw\"></i>Picklists</a></li><li ui-sref-active=\"active\" ng-if=\"vm.allowMovements\"><a ui-sref=\"movements.view\" title=\"Movements\"><i class=\"fa fa-arrows fa-fw\"></i>Movements</a></li><li ui-sref-active=\"active\" ng-if=\"vm.allowTransfers\"><a ui-sref=\"transfer.view\" title=\"Transfers\"><i class=\"fa fa-exchange fa-fw\"></i>Transfers</a></li><li ng-class=\"{active : $state.includes(\'minMax\')}\" ng-if=\"vm.allowMinMax\"><a><i class=\"fa fa-line-chart fa-fw\" title=\"MinMax\"></i>Min/Max<span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level collapse\"><li ui-sref-active=\"active\" ng-if=\"vm.allowMinMaxRegister\"><a ui-sref=\"minMax.register\">Register</a></li><li ui-sref-active=\"active\" ng-if=\"vm.allowMinMaxPlanning\"><a ui-sref=\"minMax.planning\">Planning</a></li></ul></li></ul></li><li ng-class=\"{active : $state.includes(\'materialAllocation\')}\" ng-if=\"vm.allowMaterialAllocation\"><a ui-sref=\"materialAllocation.view\" title=\"Material Allocation\"><i class=\"fa fa-cubes\"></i> <span class=\"nav-label\">Material Allocation</span></a></li><li ng-class=\"{active: $state.includes(\'inspections\')}\" ng-if=\"vm.allowInspections\"><a ui-sref=\"inspections.view\" title=\"Inspections\"><i class=\"fa fa-check-square-o fa-fw\"></i> <span class=\"nav-label\">Vendor Inspections</span></a></li><li ng-class=\"{active: $state.includes(\'expediting\')}\" ng-if=\"vm.allowExpediting\"><a ui-sref=\"expediting.view\" title=\"Expediting\"><i class=\"fa fa-plane fa-fw\"></i> <span class=\"nav-label\">Expediting</span></a></li><li ng-class=\"{active: $state.includes(\'manifests\')}\" ng-if=\"vm.allowManifests\"><a ui-sref=\"manifests.view\" title=\"Manifests\"><i class=\"fa fa-ship fa-fw\"></i> <span class=\"nav-label\">Manifests</span></a></li><li ng-class=\"{active: $state.includes(\'osdRegister\')}\" ng-if=\"vm.allowOsdRegister\"><a ui-sref=\"osdRegister.view\" title=\"OS&D Register\"><i class=\"fa fa-list-alt fa-fw\"></i> <span class=\"nav-label\">OS&D Register</span></a></li><li ng-class=\"{active: $state.includes(\'reporting\')}\" ng-if=\"vm.allowReporting\"><a ui-sref=\"reporting.view\" title=\"Reporting\"><i class=\"fa fa-table fa-fw\"></i> <span class=\"nav-label\">Reporting</span></a></li><li ng-class=\"{active: $state.includes(\'admin\')}\" ng-if=\"vm.isAdmin || vm.isSuperUser\"><a ui-sref=\"admin.view\" title=\"Admin\"><i class=\"fa fa-cogs fa-fw\"></i> <span class=\"nav-label\">Admin</span></a></li><li><a href=\"http://confluence.woodgroup.com/display/MateriaDocumentation/Materia+Documentation\" target=\"_blank\" title=\"Click for Materia documentation\"><i class=\"fa fa-question-circle fa-fw\"></i> <span class=\"nav-label\">Help</span></a></li></ul></div><span expand-sidebar=\"\" style=\"position: fixed;bottom: 0;left:0;\" id=\"expand-sidebar-full\"></span></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0; padding-bottom: 4px\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span></div><ul class=\"nav navbar-top-links navbar-right\"><li><wg-select-project></wg-select-project></li><li><wg-log-out></wg-log-out></li></ul></nav></div>");
$templateCache.put("app/deliveries/osd/registerIntervention.html","<a class=\"btn btn-sm btn-primary\" ng-click=\"vm.openRegisterIntervention()\">Raise OS&D</a>");
$templateCache.put("app/deliveries/osd/registerInterventionModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-wrench modal-icon\"></i><h4 class=\"modal-title\">Register intervention - {{vm.barcode}}</h4><small class=\"font-bold\">{{vm.description}}</small></div><div class=\"modal-body p-b-xxs\"><form name=\"saveForm\" class=\"form-horizontal\"><table class=\"table\"><thead><tr><th class=\"width-150\">Checked Quantity</th><th class=\"width-150\">Damaged Quantity</th><th class=\"width-150\">Other Quantity</th><th class=\"width-150\">Good Quantity</th></tr></thead><tr class=\"new-border\"><td><input type=\"text\" class=\"form-control\" ng-model=\"vm.checkedQuantity\" numeric-only=\"\" ng-disabled=\"true\"></td><td ng-class=\"{ \'has-error\' : (saveForm.damagedInterventionQuantity.$invalid && !saveForm.damagedInterventionQuantity.$pristine) || saveForm.damagedInterventionQuantity.$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.damagedInterventionQuantity\" ng-max=\"vm.checkedQuantity\" ng-min=\"0\" name=\"damagedInterventionQuantity\" numeric-only=\"\" required=\"\" ng-disabled=\"vm.saved\"></td><td ng-class=\"{ \'has-error\' : (saveForm.otherInterventionQuantity.$invalid && !saveForm.otherInterventionQuantity.$pristine) || saveForm.otherInterventionQuantity.$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.otherInterventionQuantity\" ng-max=\"vm.checkedQuantity\" ng-min=\"0\" name=\"otherInterventionQuantity\" uib-tooltip=\"This could be due to goods being delivered without certification, delivered goods not matching supplied certification, goods not conforming to PO requirements, etc.\" numeric-only=\"\" required=\"\" ng-disabled=\"vm.saved\" tooltip-placement=\"bottom\"></td><td><input type=\"text\" class=\"form-control\" ng-value=\"(vm.checkedQuantity - vm.damagedInterventionQuantity - vm.otherInterventionQuantity)\" ng-disabled=\"true\"></td></tr><tr><td colspan=\"4\"><span class=\"text-danger\" ng-show=\"saveForm.damagedInterventionQuantity.$error.ngMin || saveForm.damagedInterventionQuantity.$error.ngMax\">Damaged quantity must be between 0 and {{vm.checkedQuantity - vm.otherInterventionQuantity}}.</span> <span class=\"text-danger\" ng-show=\"saveForm.otherInterventionQuantity.$error.ngMin || saveForm.otherInterventionQuantity.$error.ngMax\">Other quantity must be between 0 and {{vm.checkedQuantity - vm.damagedInterventionQuantity}}.</span> <span class=\"text-danger\" ng-show=\"(vm.checkedQuantity - vm.damagedInterventionQuantity - vm.otherInterventionQuantity) < 0\">Good quantity must not be less than 0.</span></td></tr></table><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Discrepancy Description</label><div class=\"col-lg-8\"><textarea type=\"text\" class=\"form-control\" ng-model=\"vm.discrepancyDescription\" style=\"resize: none;\" ng-disabled=\"vm.saved\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Quarantine location</label><div class=\"col-lg-8\"><select kendo-combo-box=\"\" k-options=\"vm.quarantineLocationsOptions\" ng-model=\"vm.selectedQuarantineLocationId\" name=\"location\" style=\"width:100%\" ng-disabled=\"vm.saved\" required=\"\" require-valid-option=\"\"></select></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Successfully registered intervention.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error registering intervention.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"saveForm.$invalid || vm.saved\">Save</button></div></div>");
$templateCache.put("app/deliveries/osd/registerOverage.html","<a class=\"btn btn-sm btn-primary\" ng-click=\"vm.openRegisterOverage()\">Raise OS&D</a>");
$templateCache.put("app/deliveries/osd/registerOverageModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-arrow-circle-up modal-icon\"></i><h4 class=\"modal-title\">Register overage - {{vm.barcode}}</h4><h4>Outstanding quantity - {{vm.quantityOutstanding}}</h4><small class=\"font-bold\">{{vm.description}}</small></div><div class=\"modal-body p-b-xxs\"><form name=\"saveForm\" class=\"form-horizontal\"><table class=\"table\"><thead><tr><th class=\"width-150\">Barcode</th><th class=\"width-150\">Checked Quantity</th><th class=\"width-150\">Overage Quantity</th><th class=\"width-150\"></th></tr></thead><tbody ng-repeat=\"potentialOverage in vm.potentialOverages | orderBy: \'barcode\'\"><tr class=\"new-border\"><td><pre class=\"inline btn btn-sm btn-default no-hover\">{{potentialOverage.barcode}}</pre></td><td><input type=\"text\" class=\"form-control\" ng-model=\"potentialOverage.unresolvedQuantity\" numeric-only=\"\" ng-disabled=\"true\"></td><td ng-class=\"{ \'has-error\' : (saveForm[\'overageQuantity_\' + $index].$invalid && !saveForm[\'overageQuantity_\' + $index].$pristine) || saveForm[\'overageQuantity_\' + $index].$error.ngMax }\"><input type=\"text\" class=\"form-control\" ng-model=\"potentialOverage.overageQuantity\" ng-max=\"potentialOverage.unresolvedQuantity\" name=\"overageQuantity_{{$index}}\" numeric-only=\"\" required=\"\" ng-disabled=\"vm.saved\"></td><td><span class=\"text-danger\" ng-show=\"saveForm[\'overageQuantity_\' + $index].$error.ngMax\">Overage must be between 0 and {{potentialOverage.unresolvedQuantity}}.</span></td></tr></tbody><tr class=\"new-border\" ng-if=\"vm.potentialOverages.length > 1\"><td></td><td class=\"text-right\"><strong>Total Overage</strong></td><td><strong><input type=\"text\" ng-class=\"((vm.potentialOverages | sumOfValue:\'overageQuantity\')!=vm.requiredOverage) ? \'form-control text-danger\' : \'form-control text-primary\'\" ng-value=\"vm.potentialOverages | sumOfValue:\'overageQuantity\'\" ng-disabled=\"true\"></strong></td><td></td></tr><tr class=\"new-border\"><td></td><td class=\"text-right\"><strong>Overage Required</strong></td><td><strong><input type=\"text\" class=\"form-control\" ng-value=\"vm.requiredOverage\" ng-disabled=\"true\"></strong></td><td></td></tr></table><div class=\"hr-line-dashed\"></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Discrepancy Description</label><div class=\"col-lg-8\"><textarea type=\"text\" class=\"form-control\" ng-model=\"vm.discrepancyDescription\" style=\"resize: none;\" ng-disabled=\"vm.saved\"></textarea></div></div><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Quarantine location</label><div class=\"col-lg-8\"><select kendo-combo-box=\"\" k-options=\"vm.quarantineLocationsOptions\" ng-model=\"vm.selectedQuarantineLocationId\" name=\"location\" style=\"width:100%\" ng-disabled=\"vm.saved\" required=\"\" require-valid-option=\"\"></select></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Successfully registered overage.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error registering overage.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\" ng-disabled=\"(vm.potentialOverages | sumOfValue:\'overageQuantity\')!=vm.requiredOverage || vm.saved || saveForm.$invalid\">Save</button></div></div>");
$templateCache.put("app/deliveries/osd/registerShort.html","<a class=\"btn btn-sm btn-primary\" ng-click=\"vm.openRegisterShort()\">Raise OS&D</a>");
$templateCache.put("app/deliveries/osd/registerShortModal.html","<div class=\"inmodal\"><div class=\"modal-header\"><i class=\"fa fa-arrow-circle-down modal-icon\"></i><h4 class=\"modal-title\">Register short - {{vm.barcode}}</h4><small class=\"font-bold\">{{vm.description}}</small></div><div class=\"modal-body p-b-xxs\"><form class=\"form-horizontal\" name=\"save\"><div class=\"form-group\"><label class=\"col-lg-4 control-label\">Discrepancy Description</label><div class=\"col-lg-8\"><textarea type=\"text\" class=\"form-control\" ng-model=\"vm.comments\" style=\"resize: none;\" ng-disabled=\"vm.saved\"></textarea></div></div></form></div><div class=\"modal-footer\"><div class=\"alert alert-success text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.saved\" ng-cloak=\"\">Successfully registered short for <strong>{{vm.barcode}}</strong>.</div><div class=\"alert alert-danger text-center animated fadeIn ng-cloak ng-hide\" ng-show=\"vm.error\" ng-cloak=\"\">There was an error registering short for <strong>{{vm.barcode}}</strong>.</div><button type=\"button\" class=\"btn btn-white\" ng-click=\"vm.cancel()\" ng-disabled=\"vm.saving\">Close</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.ok()\" ladda=\"vm.saving\">Save</button></div></div>");}]);